import './assets/main.9662b04f.css';
import ue from "vue";
const rk = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48
}, ok = ue.extend({
  name: "SvgIcon",
  props: {
    height: {
      type: Number,
      default: null
    },
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    viewBox: {
      type: String,
      default: "0 0 24 24"
    }
  },
  computed: {
    svgSize() {
      return rk[this.size];
    }
  }
});
var sk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("svg", {
    attrs: {
      height: a.height ? a.height : a.svgSize,
      width: a.width ? a.width : a.svgSize,
      viewBox: a.viewBox,
      "aria-hidden": a.titleAccess ? void 0 : !0
    }
  }, [a.titleAccess ? c("title", [a._v(" " + a._s(a.titleAccess) + " ")]) : a._e(), a._t("default")], 2);
}, ak = [];
function Yt(a, r, c, u, p, h, v, w) {
  var x = typeof a == "function" ? a.options : a;
  r && (x.render = r, x.staticRenderFns = c, x._compiled = !0), u && (x.functional = !0), h && (x._scopeId = "data-v-" + h);
  var k;
  if (v ? (k = function($) {
    $ = $ || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !$ && typeof __VUE_SSR_CONTEXT__ < "u" && ($ = __VUE_SSR_CONTEXT__), p && p.call(this, $), $ && $._registeredComponents && $._registeredComponents.add(v);
  }, x._ssrRegister = k) : p && (k = w ? function() {
    p.call(
      this,
      (x.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : p), k)
    if (x.functional) {
      x._injectStyles = k;
      var P = x.render;
      x.render = function($, J) {
        return k.call(J), P($, J);
      };
    } else {
      var R = x.beforeCreate;
      x.beforeCreate = R ? [].concat(R, k) : [k];
    }
  return {
    exports: a,
    options: x
  };
}
const kf = {};
var lk = /* @__PURE__ */ Yt(
  ok,
  sk,
  ak,
  !1,
  ck,
  null,
  null,
  null
);
function ck(a) {
  for (let r in kf)
    this[r] = kf[r];
}
const de = /* @__PURE__ */ function() {
  return lk.exports;
}();
ue.extend({
  name: "BrandAmazon",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 22
    },
    titleAccess: {
      type: String,
      default: "Amazon Music"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandApple",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Apple Podcasts"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandAudacy",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Audacy"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandAudioGo",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Audio Go"
    },
    width: {
      type: Number,
      default: 90
    }
  }
});
ue.extend({
  name: "BrandDeezer",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Deezer"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandGaana",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Gaana"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandGoogle",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Google"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandIHeart",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "iHeart"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandJiosaavn",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Jiosaavn"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandListenOnApple",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Listen On Apple Podcasts"
    },
    width: {
      type: Number,
      default: 145
    }
  }
});
ue.extend({
  name: "BrandListenOnGoogle",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Listen On Google Podcasts"
    },
    width: {
      type: Number,
      default: 145
    }
  }
});
ue.extend({
  name: "BrandListenOnSpotify",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Listen On Spotify"
    },
    width: {
      type: Number,
      default: 145
    }
  }
});
ue.extend({
  name: "BrandOvercast",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Overcast"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandPandora",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 20
    },
    titleAccess: {
      type: String,
      default: "Pandora"
    },
    width: {
      type: Number,
      default: 82
    }
  }
});
ue.extend({
  name: "BrandPlayerFM",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "PlayerFM"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandPocketcast",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Pocketcast"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandRadioPublic",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Radio Public"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandSimplecast",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "xl"
    },
    titleAccess: {
      type: String,
      default: "Simplecast"
    }
  }
});
ue.extend({
  name: "BrandSimplecastCreatorConnect",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 50
    },
    titleAccess: {
      type: String,
      default: "Simplecast Creator Connect"
    },
    width: {
      type: Number,
      default: 537
    }
  }
});
ue.extend({
  name: "BrandSimplecastWordmark",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 50
    },
    titleAccess: {
      type: String,
      default: "Simplecast"
    },
    width: {
      type: Number,
      default: 260
    }
  }
});
ue.extend({
  name: "BrandSpotify",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Spotify"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandStitcher",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 24
    },
    titleAccess: {
      type: String,
      default: "Stitcher"
    },
    width: {
      type: Number,
      default: 60
    }
  }
});
ue.extend({
  name: "BrandSxm",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 24
    },
    titleAccess: {
      type: String,
      default: "SiriusXM"
    },
    width: {
      type: Number,
      default: 110
    }
  }
});
ue.extend({
  name: "BrandTunein",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 36
    },
    titleAccess: {
      type: String,
      default: "Tunein"
    },
    width: {
      type: Number,
      default: 36
    }
  }
});
ue.extend({
  name: "BrandYoutube",
  components: {
    SvgIcon: de
  },
  props: {
    height: {
      type: Number,
      default: 24
    },
    titleAccess: {
      type: String,
      default: "Youtube"
    },
    width: {
      type: Number,
      default: 60
    }
  }
});
const uk = ue.extend({
  name: "IconAdd",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Add"
    }
  }
});
var dk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-add",
    attrs: {
      viewBox: a.size === "sm" ? "0 0 16 16" : "0 0 24 24"
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 3v4h4v2H9v4H7V8.999L3 9V7l4-.001V3h2Z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 6v5h5v2h-5v5h-2v-5.001L6 13v-2l5-.001V6h2Z"
    }
  })]);
}, hk = [];
const xf = {};
var fk = /* @__PURE__ */ Yt(
  uk,
  dk,
  hk,
  !1,
  pk,
  null,
  null,
  null
);
function pk(a) {
  for (let r in xf)
    this[r] = xf[r];
}
const mk = /* @__PURE__ */ function() {
  return fk.exports;
}();
ue.extend({
  name: "IconAlert",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Alert"
    }
  }
});
ue.extend({
  name: "IconArchive",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Archive"
    }
  }
});
const gk = ue.extend({
  name: "IconArrow",
  components: {
    SvgIcon: de
  },
  props: {
    direction: {
      type: String,
      default: "up"
    },
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: null
    }
  }
});
var vk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", {
    class: ["icon-arrow", `icon-arrow_${a.direction}`],
    attrs: {
      size: a.size,
      titleAccess: a.titleAccess ? a.titleAccess : a.direction,
      viewBox: a.size === "sm" ? "0 0 16 16" : "0 0 24 24"
    }
  }, [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.485 10.864 7.95 7.328l-3.536 3.536L3 9.45 7.95 4.5l4.95 4.95-1.415 1.414Z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.41 16 12 11.42 16.59 16 18 14.59l-6-6-6 6z"
    }
  })]);
}, bk = [];
const Sf = {};
var _k = /* @__PURE__ */ Yt(
  gk,
  vk,
  bk,
  !1,
  wk,
  "2945f567",
  null,
  null
);
function wk(a) {
  for (let r in Sf)
    this[r] = Sf[r];
}
const vi = /* @__PURE__ */ function() {
  return _k.exports;
}(), yk = ue.extend({
  name: "IconAudio",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Audio"
    }
  }
});
var kk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-audio"
  }, "SvgIcon", a.$props, !1), [c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 12v8H4v-8h4Zm6-8v16h-4V4h4Zm6 4v12h-4V8h4Z"
    }
  })]);
}, xk = [];
const Cf = {};
var Sk = /* @__PURE__ */ Yt(
  yk,
  kk,
  xk,
  !1,
  Ck,
  null,
  null,
  null
);
function Ck(a) {
  for (let r in Cf)
    this[r] = Cf[r];
}
const rp = /* @__PURE__ */ function() {
  return Sk.exports;
}();
ue.extend({
  name: "IconBack",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Back"
    }
  }
});
ue.extend({
  name: "IconBlocked",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Blocked"
    }
  }
});
ue.extend({
  name: "IconCalendar",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Calendar"
    }
  }
});
ue.extend({
  name: "IconChangelog",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Changelog"
    }
  }
});
const Ak = ue.extend({
  name: "IconCheck",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Check"
    }
  }
});
var Tk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-check",
    attrs: {
      viewBox: a.size === "sm" ? "0 0 16 16" : "0 0 24 24"
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 9.086 4.707 6.793 3.293 8.207 7 11.914l6.707-6.707-1.414-1.414z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.414 11 3 12.414l5.707 5.707L20.414 6.414 19 5 8.707 15.293z"
    }
  })]);
}, Ik = [];
const Af = {};
var Ek = /* @__PURE__ */ Yt(
  Ak,
  Tk,
  Ik,
  !1,
  Pk,
  null,
  null,
  null
);
function Pk(a) {
  for (let r in Af)
    this[r] = Af[r];
}
const Fr = /* @__PURE__ */ function() {
  return Ek.exports;
}(), Mk = ue.extend({
  name: "IconCloseCircle",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Close"
    }
  }
});
var Ok = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-close-circle"
  }, "SvgIcon", a.$props, !1), [c("g", {
    attrs: {
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [c("path", {
    attrs: {
      fill: "currentColor",
      d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2Zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59Z"
    }
  })])]);
}, Dk = [];
const Tf = {};
var Nk = /* @__PURE__ */ Yt(
  Mk,
  Ok,
  Dk,
  !1,
  Rk,
  null,
  null,
  null
);
function Rk(a) {
  for (let r in Tf)
    this[r] = Tf[r];
}
const Lk = /* @__PURE__ */ function() {
  return Nk.exports;
}(), Fk = ue.extend({
  name: "IconClose",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Close"
    }
  }
});
var zk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-close",
    attrs: {
      viewBox: a.size === "sm" ? "0 0 16 16" : "0 0 24 24"
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m5.172 3.757 2.827 2.828 2.829-2.828 1.415 1.415L9.413 8l2.83 2.828-1.415 1.415-2.829-2.829-2.827 2.829-1.415-1.415 2.828-2.829-2.828-2.827z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  })]);
}, $k = [];
const If = {};
var jk = /* @__PURE__ */ Yt(
  Fk,
  zk,
  $k,
  !1,
  Bk,
  null,
  null,
  null
);
function Bk(a) {
  for (let r in If)
    this[r] = If[r];
}
const Vk = /* @__PURE__ */ function() {
  return jk.exports;
}();
ue.extend({
  name: "IconCode",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Code"
    }
  }
});
const Uk = ue.extend({
  name: "IconDownload",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Download"
    }
  }
});
var Hk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-download"
  }, "SvgIcon", a.$props, !1), [c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20 18v2H4v-2h16ZM13 4v9.172l3.59-3.582L18 11l-6 6-6-6 1.41-1.41L11 13.172V4h2Z"
    }
  })]);
}, Wk = [];
const Ef = {};
var Yk = /* @__PURE__ */ Yt(
  Uk,
  Hk,
  Wk,
  !1,
  qk,
  null,
  null,
  null
);
function qk(a) {
  for (let r in Ef)
    this[r] = Ef[r];
}
const Gk = /* @__PURE__ */ function() {
  return Yk.exports;
}();
ue.extend({
  name: "IconDraggable",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Draggable"
    }
  }
});
ue.extend({
  name: "IconDuplicate",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Duplicate"
    }
  }
});
ue.extend({
  name: "IconEdit",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Edit"
    }
  }
});
ue.extend({
  name: "IconEmail",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Email"
    }
  }
});
ue.extend({
  name: "IconExplicit",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Explicit"
    }
  }
});
ue.extend({
  name: "IconGraph",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Graph"
    }
  }
});
const Zk = ue.extend({
  name: "IconInfo",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Info"
    }
  }
});
var Kk = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-info",
    attrs: {
      viewBox: a.size === "sm" ? "0 0 16 16" : "0 0 24 24"
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm1 5v5H7V7h2Zm0-3v2H7V4h2Z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm1 6v5h-2v-5h2Zm0-3v2h-2V8h2Z"
    }
  })]);
}, Xk = [];
const Pf = {};
var Qk = /* @__PURE__ */ Yt(
  Zk,
  Kk,
  Xk,
  !1,
  Jk,
  null,
  null,
  null
);
function Jk(a) {
  for (let r in Pf)
    this[r] = Pf[r];
}
const op = /* @__PURE__ */ function() {
  return Qk.exports;
}();
ue.extend({
  name: "IconLink",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Link"
    }
  }
});
const e0 = ue.extend({
  name: "IconLock",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Lock"
    }
  }
});
var t0 = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-lock",
    attrs: {
      viewBox: a.size === "sm" ? "0 0 16 16" : "0 0 24 24"
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.5 6V4.5a1.5 1.5 0 0 0-3 0V6h3ZM12 8H4v5h8V8ZM9 9v3H7V9h2ZM4.5 4.5a3.5 3.5 0 0 1 7 0V6H14v9H2V6h2.5Z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2a5 5 0 0 1 5 5v1h3v14H4V8h3V7a5 5 0 0 1 4.783-4.995Zm6 8H6v10h12V10Zm-5 2v6h-2v-6h2Zm-1-8a3 3 0 0 0-3 3v1h6V7a3 3 0 0 0-2.824-2.995Z"
    }
  })]);
}, n0 = [];
const Mf = {};
var i0 = /* @__PURE__ */ Yt(
  e0,
  t0,
  n0,
  !1,
  r0,
  null,
  null,
  null
);
function r0(a) {
  for (let r in Mf)
    this[r] = Mf[r];
}
const wl = /* @__PURE__ */ function() {
  return i0.exports;
}();
ue.extend({
  name: "IconLogout",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Logout"
    }
  }
});
ue.extend({
  name: "IconMenu",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "lg"
    },
    titleAccess: {
      type: String,
      default: "Menu"
    }
  }
});
ue.extend({
  name: "IconNoEdit",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Cannot Edit"
    }
  }
});
const o0 = ue.extend({
  name: "IconOptions",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Options"
    }
  }
});
var s0 = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-options"
  }, "SvgIcon", a.$props, !1), [c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.5 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
    }
  })]);
}, a0 = [];
const Of = {};
var l0 = /* @__PURE__ */ Yt(
  o0,
  s0,
  a0,
  !1,
  c0,
  null,
  null,
  null
);
function c0(a) {
  for (let r in Of)
    this[r] = Of[r];
}
const u0 = /* @__PURE__ */ function() {
  return l0.exports;
}(), Df = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48
}, d0 = ue.extend({
  name: "IconPause",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Pause"
    }
  },
  computed: {
    viewBox() {
      let a = Df.md;
      return this.size !== "lg" && (a = Df[this.size]), `0 0 ${a} ${a}`;
    }
  }
});
var h0 = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-pause",
    attrs: {
      viewBox: a.viewBox
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.429 2v12H3V2h3.429Zm6.857 0v12H9.857V2h3.429Z"
    }
  }) : a.size === "xl" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0Zm0 2C10.059 2 2 10.059 2 20s8.059 18 18 18 18-8.059 18-18S29.941 2 20 2Zm-2 10.5v15h-4v-15h4Zm8 0v15h-4v-15h4Z"
    }
  }) : a.size === "xxl" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0Zm0 2C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2Zm-2.667 13v18H16V15h5.333ZM32 15v18h-5.333V15H32Z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-1 4v8H9V8h2Zm4 0v8h-2V8h2Z"
    }
  })]);
}, f0 = [];
const Nf = {};
var p0 = /* @__PURE__ */ Yt(
  d0,
  h0,
  f0,
  !1,
  m0,
  null,
  null,
  null
);
function m0(a) {
  for (let r in Nf)
    this[r] = Nf[r];
}
const sp = /* @__PURE__ */ function() {
  return p0.exports;
}(), Rf = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48
}, g0 = ue.extend({
  name: "IconPlay",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Play"
    }
  },
  computed: {
    viewBox() {
      let a = Rf.md;
      return this.size !== "lg" && (a = Rf[this.size]), `0 0 ${a} ${a}`;
    }
  }
});
var v0 = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-play",
    attrs: {
      viewBox: a.viewBox
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 2v12.303l9.667-6.151z"
    }
  }) : a.size === "xl" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0Zm-4.848 11.515v16.97L28.485 20l-13.333-8.485Z"
    }
  }) : a.size === "xxl" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0Zm-5.818 13.818v20.364l16-10.182-16-10.182Z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM9 7v10l8-5-8-5Z"
    }
  })]);
}, b0 = [];
const Lf = {};
var _0 = /* @__PURE__ */ Yt(
  g0,
  v0,
  b0,
  !1,
  w0,
  null,
  null,
  null
);
function w0(a) {
  for (let r in Lf)
    this[r] = Lf[r];
}
const y0 = /* @__PURE__ */ function() {
  return _0.exports;
}();
ue.extend({
  name: "IconPrivate",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Private"
    }
  }
});
ue.extend({
  name: "IconRandomize",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Randomize"
    }
  }
});
ue.extend({
  name: "IconRecast",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Recast"
    }
  }
});
const k0 = ue.extend({
  name: "IconSearch",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Search"
    }
  }
});
var x0 = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-search"
  }, "SvgIcon", a.$props, !1), [c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
    }
  })]);
}, S0 = [];
const Ff = {};
var C0 = /* @__PURE__ */ Yt(
  k0,
  x0,
  S0,
  !1,
  A0,
  null,
  null,
  null
);
function A0(a) {
  for (let r in Ff)
    this[r] = Ff[r];
}
const ap = /* @__PURE__ */ function() {
  return C0.exports;
}();
ue.extend({
  name: "IconSettings",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Settings"
    }
  }
});
ue.extend({
  name: "IconShare",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Share"
    }
  }
});
ue.extend({
  name: "IconStar",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Star"
    }
  }
});
ue.extend({
  name: "IconStop",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Stop"
    }
  }
});
ue.extend({
  name: "IconSubtract",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Subtract"
    }
  }
});
ue.extend({
  name: "IconTime",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Time"
    }
  }
});
const T0 = ue.extend({
  name: "IconTrash",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Delete"
    }
  }
});
var I0 = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-trash",
    attrs: {
      viewBox: a.size === "sm" ? "0 0 16 16" : "0 0 24 24"
    }
  }, "SvgIcon", a.$props, !1), [a.size === "sm" ? c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 3H6v1H4V2a1 1 0 0 1 .883-.993L5 1h6a1 1 0 0 1 .993.883L12 2v2h3v2h-2v8a1 1 0 0 1-.883.993L12 15H4a1 1 0 0 1-1-1V6H1V4h9V3Zm1 3H5v7h6V6Z"
    }
  }) : c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15 3a1 1 0 0 1 .993.883L16 4l-.001 2H21v2h-2v12a1 1 0 0 1-.883.993L18 21H6a1 1 0 0 1-.993-.883L5 20V8H3V6h5.003L8 4.002a1 1 0 0 1 .883-.995L9 3h6Zm2 5H7v11h10V8Zm-6 2v7H9v-7h2Zm4 0v7h-2v-7h2Zm-1-5h-3.999l.002 1h3.996L14 5Z"
    }
  })]);
}, E0 = [];
const zf = {};
var P0 = /* @__PURE__ */ Yt(
  T0,
  I0,
  E0,
  !1,
  M0,
  null,
  null,
  null
);
function M0(a) {
  for (let r in zf)
    this[r] = zf[r];
}
const O0 = /* @__PURE__ */ function() {
  return P0.exports;
}();
ue.extend({
  name: "IconUnarchive",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Unarchive"
    }
  }
});
const D0 = ue.extend({
  name: "IconUpload",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Upload"
    }
  }
});
var N0 = function() {
  var a = this, r = a.$createElement, c = a._self._c || r;
  return c("SvgIcon", a._b({
    staticClass: "icon-upload"
  }, "SvgIcon", a.$props, !1), [c("path", {
    attrs: {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 20h-.5c-1.51667 0-2.81233-.525-3.887-1.575C1.53767 17.375 1 16.0917 1 14.575c0-1.3.39167-2.4583 1.175-3.475.78333-1.0167 1.80833-1.66667 3.075-1.95.41667-1.53333 1.25-2.775 2.5-3.725C9 4.475 10.4167 4 12 4c1.95 0 3.604.679 4.962 2.037C18.3207 7.39567 19 9.05 19 11c1.15.1333 2.1043.629 2.863 1.487C22.621 13.3457 23 14.35 23 15.5c0 1.25-.4373 2.3127-1.312 3.188C20.8127 19.5627 19.75 20 18.5 20H13v-6h3l-4-4-4 4h3v6H7Z",
      "clip-rule": "evenodd"
    }
  })]);
}, R0 = [];
const $f = {};
var L0 = /* @__PURE__ */ Yt(
  D0,
  N0,
  R0,
  !1,
  F0,
  null,
  null,
  null
);
function F0(a) {
  for (let r in $f)
    this[r] = $f[r];
}
const os = /* @__PURE__ */ function() {
  return L0.exports;
}();
ue.extend({
  name: "IconUploadImage",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    titleAccess: {
      type: String,
      default: "Upload Image"
    }
  }
});
ue.extend({
  name: "IconWarning",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Warning"
    }
  }
});
ue.extend({
  name: "IconWaveform",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Waveform"
    }
  }
});
ue.extend({
  name: "SocialApple",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Apple"
    }
  }
});
ue.extend({
  name: "SocialBandcamp",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Bandcamp"
    }
  }
});
ue.extend({
  name: "SocialBehance",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Behance"
    }
  }
});
ue.extend({
  name: "SocialBitbucket",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Bitbucket"
    }
  }
});
ue.extend({
  name: "SocialCodepen",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Codepen"
    }
  }
});
ue.extend({
  name: "SocialDelicious",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Delicious"
    }
  }
});
ue.extend({
  name: "SocialDevaintart",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "DeviantArt"
    }
  }
});
ue.extend({
  name: "SocialDribbble",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Dribbble"
    }
  }
});
ue.extend({
  name: "SocialEtsy",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Etsy"
    }
  }
});
ue.extend({
  name: "SocialFacebook",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Facebook"
    }
  }
});
ue.extend({
  name: "SocialGithub",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Github"
    }
  }
});
ue.extend({
  name: "SocialGitlab",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Gitlab"
    }
  }
});
ue.extend({
  name: "SocialImdb",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "IMDb"
    }
  }
});
ue.extend({
  name: "SocialInstagram",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Instagram"
    }
  }
});
ue.extend({
  name: "SocialLinkedin",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Linkedin"
    }
  }
});
ue.extend({
  name: "SocialPatreon",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Patreon"
    }
  }
});
ue.extend({
  name: "SocialPaypal",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Paypal"
    }
  }
});
ue.extend({
  name: "SocialRss",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "RSS"
    }
  }
});
ue.extend({
  name: "SocialSoundcloud",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "SoundCloud"
    }
  }
});
ue.extend({
  name: "SocialSpotify",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Spotify"
    }
  }
});
ue.extend({
  name: "SocialTwitch",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Twitch"
    }
  }
});
ue.extend({
  name: "SocialTwitter",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Twitter"
    }
  }
});
ue.extend({
  name: "SocialYoutube",
  components: {
    SvgIcon: de
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    titleAccess: {
      type: String,
      default: "Youtube"
    }
  }
});
function he(a, r, c, u, p, h, v, w) {
  var x = typeof a == "function" ? a.options : a;
  r && (x.render = r, x.staticRenderFns = c, x._compiled = !0), u && (x.functional = !0), h && (x._scopeId = "data-v-" + h);
  var k;
  if (v ? (k = function($) {
    $ = $ || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !$ && typeof __VUE_SSR_CONTEXT__ < "u" && ($ = __VUE_SSR_CONTEXT__), p && p.call(this, $), $ && $._registeredComponents && $._registeredComponents.add(v);
  }, x._ssrRegister = k) : p && (k = w ? function() {
    p.call(
      this,
      (x.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : p), k)
    if (x.functional) {
      x._injectStyles = k;
      var P = x.render;
      x.render = function(J, X) {
        return k.call(X), P(J, X);
      };
    } else {
      var R = x.beforeCreate;
      x.beforeCreate = R ? [].concat(R, k) : [k];
    }
  return {
    exports: a,
    options: x
  };
}
const z0 = {
  name: "Collapse",
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  data() {
    return {
      renderContent: this.open,
      openCollapse: this.open,
      contentHeight: 0,
      resizeObserver: null
    };
  },
  watch: {
    open(a) {
      this.toggleCollapse(a);
    }
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.collaspibleHeight), this.resizeObserver.observe(this.$refs.collaspibleContent);
  },
  beforeDestroy() {
    this.resizeObserver.disconnect();
  },
  methods: {
    collaspibleHeight() {
      this.$refs.collaspibleContent || (this.contentHeight = "0");
      const a = this.$refs.collaspibleContent;
      this.contentHeight = `${a.clientHeight}px`;
    },
    toggleCollapse(a) {
      a ? (this.renderContent = !0, this.$nextTick(() => {
        this.openCollapse = !0;
      })) : (this.openCollapse = !1, setTimeout(() => {
        this.renderContent = !1;
      }, 500));
    }
  }
};
var $0 = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "collapse", style: { height: r.openCollapse ? r.contentHeight : 0 } }, [c(r.tag, { ref: "collaspibleContent", tag: "component", staticClass: "collaspe-inner" }, [r.renderContent ? r._t("default") : r._e()], 2)], 1);
}, j0 = [], B0 = /* @__PURE__ */ he(
  z0,
  $0,
  j0,
  !1,
  null,
  "a0644a0b",
  null,
  null
);
const lp = B0.exports;
const V0 = {
  name: "SType",
  props: {
    breakpoints: {
      type: Object,
      validator: (a) => a === void 0 || "md" in a || "lg" in a || "xl" in a
    },
    gutterBottom: {
      type: Boolean,
      default: !0
    },
    prominence: {
      type: String,
      default: "default",
      validator: (a) => ["lg", "default", "sm"].includes(a)
    },
    tag: {
      type: String,
      required: !1,
      validator: (a) => [
        "p",
        "span",
        "div",
        "label",
        "legend",
        "th",
        "td",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "dt",
        "dl",
        "li",
        "ol"
      ].includes(a)
    },
    variant: {
      type: String,
      default: "body",
      validator: (a) => ["heading", "title", "subtitle", "body", "helper"].includes(a)
    }
  },
  computed: {
    component() {
      return this.tag ? this.tag : {
        heading: "h1",
        title: "h2",
        subtitle: "h3",
        body: "p",
        helper: "p"
      }[this.variant];
    },
    classList() {
      let a = ["type"];
      if (a.push(`type--${this.variant}`), a.push(`type--${this.prominence}`), this.breakpoints) {
        if (this.breakpoints.md !== void 0) {
          const r = this.breakpoints.md;
          r.variant && r.prominence && (a.push(`type--md-${r.variant}`), a.push(`type--md-${r.prominence}`));
        }
        if (this.breakpoints.lg !== void 0) {
          const r = this.breakpoints.lg;
          r.variant && r.prominence && (a.push(`type--lg-${r.variant}`), a.push(`type--lg-${r.prominence}`));
        }
        if (this.breakpoints.xl !== void 0) {
          const r = this.breakpoints.xl;
          r.variant && r.prominence && (a.push(`type--xl-${r.variant}`), a.push(`type--xl-${r.prominence}`));
        }
      }
      return this.gutterBottom === !1 && a.push("type--no-margin"), a;
    }
  }
};
var U0 = function() {
  var r = this, c = r._self._c;
  return c(r.component, r._b({ tag: "component", class: r.classList }, "component", r.$props, !1), [r._t("default")], 2);
}, H0 = [], W0 = /* @__PURE__ */ he(
  V0,
  U0,
  H0,
  !1,
  null,
  "0b9304f0",
  null,
  null
);
const Rt = W0.exports;
const Y0 = {
  name: "s-button",
  components: {
    SType: Rt
  },
  props: {
    to: {
      type: Object,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    disabledStyle: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "button",
      validator: (a) => ["button", "submit", "reset"].includes(a)
    },
    variant: {
      type: String,
      default: "primary",
      validator: (a) => [
        "primary",
        "secondary",
        "secondary-inverse",
        "tertiary",
        "destructive",
        "flat",
        "flat-inverse",
        "flat-secondary"
      ].includes(a)
    },
    block: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    isRouterLink() {
      return this.to !== null;
    },
    component() {
      return this.isRouterLink && !this.disabled ? "router-link" : this.href && !this.disabled ? "a" : (this.isRouterLink || this.href) && this.disabled ? "span" : "button";
    }
  }
};
var q0 = function() {
  var r = this, c = r._self._c;
  return c(r.component, r._g(r._b({ tag: "component", class: [
    "button",
    `button-${r.variant}`,
    {
      "button-block": r.block,
      "button-icon": r.icon,
      "button-disabled": r.disabledStyle
    }
  ], attrs: { type: r.type, disabled: r.disabled, title: r.title, "aria-label": r.title } }, "component", r.$props, !1), r.$listeners), [r.$slots.pre ? c("span", { staticClass: "button__pre" }, [r._t("pre")], 2) : r._e(), c("SType", { staticClass: "button__content", attrs: { variant: "subtitle", "gutter-bottom": !1, tag: "span" } }, [r._t("default")], 2)], 1);
}, G0 = [], Z0 = /* @__PURE__ */ he(
  Y0,
  q0,
  G0,
  !1,
  null,
  "64337db8",
  null,
  null
);
const bi = Z0.exports;
const K0 = ue.extend({
  name: "Accordion",
  components: {
    Collapse: lp,
    IconArrow: vi,
    SType: Rt,
    SButton: bi
  },
  props: {
    a11yOpen: {
      type: String,
      default: "Open accordion"
    },
    a11yClose: {
      type: String,
      default: "Close accordion"
    },
    header: {
      type: String,
      default: null
    },
    hideCaron: {
      type: Boolean,
      default: !1
    },
    subheader: {
      type: String,
      default: null
    },
    openDefault: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      open: !1
    };
  },
  computed: {
    contentHeight() {
      return this.open === !1 || !this.$refs.accordionContent ? "0" : `${this.$refs.accordionContent.clientHeight}px`;
    },
    stackedMobile() {
      return this.$scopedSlots.right !== void 0 && this.hideCaron === !1;
    },
    buttonTitle() {
      return this.open ? this.a11yClose : this.a11yOpen;
    },
    buttonDirection() {
      return this.open ? "up" : "down";
    }
  },
  mounted() {
    this.open = this.openDefault;
  },
  methods: {
    toggleStatus() {
      this.open = !this.open;
    },
    triggerAccordion(a) {
      this.open = a.value;
    }
  }
});
var X0 = function() {
  var r = this, c = r._self._c;
  return r._self._setupProxy, c("div", { staticClass: "accordion" }, [c("div", { class: {
    accordion__header: !0,
    "accordion__header-stacked": r.stackedMobile
  } }, [c("div", { staticClass: "accordion__header__left" }, [c("SType", { staticClass: "accordion__header__title", attrs: { variant: "title", prominence: "sm" } }, [r._v(" " + r._s(r.header) + " ")]), r.subheader ? c("SType", { staticClass: "accordion__header__subtitle", attrs: { gutterBottom: !1, variant: "body" }, domProps: { innerHTML: r._s(r.subheader) } }) : r._e()], 1), c("div", { staticClass: "accordion__header__right" }, [r._t("right", null, { toggleAccordion: r.triggerAccordion }), r.hideCaron ? r._e() : c("SButton", { staticClass: "accordion__header__toggle", attrs: { title: r.buttonTitle, icon: !0, variant: "flat" }, on: { click: function(u) {
    return u.preventDefault(), r.toggleStatus.apply(null, arguments);
  } } }, [c("IconArrow", { attrs: { "title-access": r.buttonTitle, direction: r.buttonDirection } })], 1)], 2)]), c("Collapse", { staticClass: "accordion__content", attrs: { open: r.open } }, [c("div", { staticClass: "accordion__content__inner" }, [r._t("default")], 2)])], 1);
}, Q0 = [], J0 = /* @__PURE__ */ he(
  K0,
  X0,
  Q0,
  !1,
  null,
  "61770bcb",
  null,
  null
);
const NP = J0.exports;
const e1 = {
  name: "Alert",
  components: {
    IconCheck: Fr,
    IconClose: Vk,
    IconInfo: op,
    SButton: bi,
    SType: Rt
  },
  props: {
    dismissable: {
      type: Boolean,
      default: !0
    },
    sticky: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "default",
      validator: function(a) {
        return ["default", "success", "warning", "error"].includes(a);
      }
    }
  },
  computed: {
    colorVariant() {
      return {
        default: "info-strong",
        success: "success-strong",
        warning: "warning-strong",
        error: "destructive-strong"
      }[this.type];
    }
  },
  methods: {
    dismiss() {
      this.$emit("dismiss");
    }
  }
};
var t1 = function() {
  var r = this, c = r._self._c;
  return c("div", { class: ["alert-container", { sticky: r.sticky }] }, [c("div", { class: ["alert", `alert-${r.type}`, { dismissable: r.dismissable, sticky: r.sticky }] }, [r.type !== "success" ? c("IconInfo", { staticClass: "alert--icon", attrs: { size: "sm" } }) : c("IconCheck", { staticClass: "alert--icon", attrs: { size: "sm" } }), c("SType", { class: "alert__content", attrs: { "gutter-bottom": !1, variant: "body" } }, [r._t("default")], 2), r.dismissable ? c("SButton", { staticClass: "button-x", attrs: { icon: !0, variant: "flat-secondary" }, on: { click: function(u) {
    return u.preventDefault(), r.dismiss.apply(null, arguments);
  } } }, [c("IconClose", { attrs: { size: "md" } })], 1) : r._e()], 1)]);
}, n1 = [], i1 = /* @__PURE__ */ he(
  e1,
  t1,
  n1,
  !1,
  null,
  "fa976d80",
  null,
  null
);
const cp = i1.exports;
var An = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yl(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
function up(a) {
  var r = a.default;
  if (typeof r == "function") {
    var c = function() {
      return r.apply(this, arguments);
    };
    c.prototype = r.prototype;
  } else
    c = {};
  return Object.defineProperty(c, "__esModule", { value: !0 }), Object.keys(a).forEach(function(u) {
    var p = Object.getOwnPropertyDescriptor(a, u);
    Object.defineProperty(c, u, p.get ? p : {
      enumerable: !0,
      get: function() {
        return a[u];
      }
    });
  }), c;
}
var Zi = typeof self == "object" && self.self === self && self || typeof An == "object" && An.global === An && An || An;
const Ga = [
  { height: 40, width: 40, retina: !0 },
  { height: 80, width: 80, retina: !0 },
  { height: 150, width: 150, retina: !0 },
  { height: 200, width: 200, retina: !0 },
  { height: 300, width: 300, retina: !0 },
  { height: 480, width: 480, retina: !0 },
  { height: 640, width: 640, retina: !0 },
  { height: 1400, width: 1400 },
  {
    height: 3e3,
    width: 3e3,
    minHeight: 1400,
    minWidth: 1400
  }
];
const r1 = {
  name: "artwork",
  props: {
    imageUrl: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      artworkStyle: {},
      currentImage: null
    };
  },
  watch: {
    imageUrl() {
      this.setArtworkStyle();
    },
    loading(a) {
      a || this.setArtworkStyle();
    }
  },
  mounted() {
    this.setArtworkStyle(), Zi.addEventListener("resize", this.setArtworkStyle);
  },
  beforeDestroy() {
    Zi.removeEventListener("resize", this.setArtworkStyle);
  },
  methods: {
    setArtworkStyle() {
      if (!this.imageUrl || this.loading) {
        this.artworkStyle = {
          backgroundImage: "none"
        };
        return;
      }
      const a = this.$refs.ratio.offsetHeight, r = this.$refs.ratio.offsetWidth, c = this.getImageSize(this.imageUrl, a, r);
      if (c === this.currentImage)
        return;
      this.currentImage = c;
      const u = new Zi.Image();
      u.onload = () => {
        this.artworkStyle = {
          backgroundImage: `url(${c})`
        };
      }, u.onerror = () => {
        this.artworkStyle = {
          backgroundImage: `url(${this.imageUrl})`
        };
      }, u.src = String(c);
    },
    getImageSize(a, r, c) {
      const u = this.normalizeSize(r, c), p = a.split("/"), v = p.pop().split(".");
      return p.push(`${u.height}x${u.width}`), Zi.devicePixelRatio >= 1.5 && u.retina && (v[0] += "@2x"), p.push(v.join(".")), p.join("/");
    },
    normalizeSize(a, r) {
      let c = Ga[0];
      for (let u = 0; u < Ga.length; u += 1) {
        const p = Ga[u];
        if (Zi.devicePixelRatio >= 1.5 && p.height <= a && p.width <= r)
          c = p;
        else if (Zi.devicePixelRatio < 1.5 && p.height >= a && p.width >= r) {
          c = p;
          break;
        }
      }
      return c;
    }
  }
};
var o1 = function() {
  var r = this, c = r._self._c;
  return r.loading ? c("div", { ref: "ratio", staticClass: "ratio ratio-1-1 artwork" }) : c("div", { ref: "ratio", staticClass: "ratio ratio-1-1 artwork", style: r.artworkStyle }, [r._t("default")], 2);
}, s1 = [], a1 = /* @__PURE__ */ he(
  r1,
  o1,
  s1,
  !1,
  null,
  "7f71dda8",
  null,
  null
);
const kl = a1.exports;
const l1 = {
  name: "Badge",
  components: {
    SType: Rt
  },
  props: {
    interactive: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "default",
      validator: (a) => ["default", "small", "large"].includes(a)
    },
    tag: {
      type: String,
      default: "span"
    },
    variant: {
      type: String,
      default: "neutral-weak",
      validator: (a) => [
        "neutral",
        "neutral-weak",
        "neutral-strong",
        "info",
        "success-weak",
        "success-strong",
        "warning",
        "destructive",
        "accent1",
        "accent2",
        "accent3",
        "accent4",
        "accent5"
      ].includes(a)
    }
  },
  computed: {
    variantType() {
      return this.size === "small" || this.variant === "neutral" ? "subtitle" : "body";
    },
    prominenceType() {
      return this.variant === "neutral" ? "default" : "sm";
    }
  }
};
var c1 = function() {
  var r = this, c = r._self._c;
  return c("span", { class: [
    "badge",
    `badge--${r.variant}`,
    { "badge--interactive": r.interactive, "badge--large": r.size === "large" }
  ] }, [r.$slots.pre ? c("span", { staticClass: "badge__pre" }, [r._t("pre")], 2) : r._e(), c("SType", { staticClass: "badge__content", attrs: { variant: r.variantType, prominence: r.prominenceType, "gutter-bottom": !1, tag: r.tag } }, [r._t("default")], 2), r.$slots.post ? c("span", { staticClass: "badge__post" }, [r._t("post")], 2) : r._e()], 1);
}, u1 = [], d1 = /* @__PURE__ */ he(
  l1,
  c1,
  u1,
  !1,
  null,
  null,
  null,
  null
);
const Di = d1.exports;
const h1 = {
  name: "BadgeCampaign",
  components: {
    Badge: Di,
    IconPause: sp
  },
  props: {
    status: {
      type: String,
      required: !0,
      validator: function(a) {
        return [
          "draft",
          "scheduled",
          "live",
          "paused",
          "complete",
          "canceled"
        ].includes(a);
      }
    }
  },
  computed: {
    badgeVarient() {
      return {
        draft: "warning",
        scheduled: "success-weak",
        live: "success-strong",
        paused: "neutral-weak",
        complete: "info",
        canceled: "destructive"
      }[this.status];
    },
    badgeCopy() {
      return {
        draft: "Draft",
        scheduled: "Scheduled",
        live: "Live",
        paused: "Paused",
        complete: "Complete",
        canceled: "Canceled"
      }[this.status];
    }
  }
};
var f1 = function() {
  var r = this, c = r._self._c;
  return c("Badge", { staticClass: "badge--campaign", attrs: { variant: r.badgeVarient }, scopedSlots: r._u([r.status === "live" || r.status === "paused" ? { key: "pre", fn: function() {
    return [r.status === "paused" ? c("IconPause", { attrs: { size: "sm", height: "8", width: "8" } }) : c("svg", { staticClass: "badge__live", attrs: { width: "6", height: "6", alt: "", viewbox: "0 0 6 6" } }, [c("circle", { attrs: { cx: "3", cy: "3", r: "3", fill: "currentColor" } })])];
  }, proxy: !0 } : null], null, !0) }, [r._v(" " + r._s(r.badgeCopy) + " ")]);
}, p1 = [], m1 = /* @__PURE__ */ he(
  h1,
  f1,
  p1,
  !1,
  null,
  null,
  null,
  null
);
const RP = m1.exports, g1 = {
  name: "BadgeEpisode",
  components: {
    Badge: Di
  },
  props: {
    status: {
      type: String,
      required: !0,
      validator: function(a) {
        return ["draft", "processing", "scheduled", "published"].includes(a);
      }
    }
  },
  computed: {
    badgeVarient() {
      return {
        draft: "warning",
        processing: "neutral-weak",
        scheduled: "success-weak",
        published: "success-strong"
      }[this.status];
    },
    badgeCopy() {
      return {
        draft: "Draft",
        processing: "Processing",
        scheduled: "Scheduled",
        published: "Published"
      }[this.status];
    }
  }
};
var v1 = function() {
  var r = this, c = r._self._c;
  return c("Badge", { staticClass: "badge--episode", attrs: { variant: r.badgeVarient } }, [r._v(" " + r._s(r.badgeCopy) + " ")]);
}, b1 = [], _1 = /* @__PURE__ */ he(
  g1,
  v1,
  b1,
  !1,
  null,
  null,
  null,
  null
);
const LP = _1.exports, w1 = {
  name: "BadgeHostRead",
  components: {
    Badge: Di
  },
  props: {
    status: {
      type: String,
      required: !0,
      validator: function(a) {
        return [
          "pending",
          "uploaded",
          "reviewed",
          "accepted",
          "canceled",
          "rejected"
        ].includes(a);
      }
    }
  },
  computed: {
    badgeVarient() {
      return {
        pending: "warning",
        uploaded: "neutral-strong",
        reviewed: "warning",
        accepted: "info",
        canceled: "destructive",
        rejected: "destructive"
      }[this.status];
    },
    badgeCopy() {
      return {
        pending: "Open",
        uploaded: "Submitted",
        reviewed: "Revision Requested",
        accepted: "Accepted",
        canceled: "Canceled",
        rejected: "Rejected"
      }[this.status];
    }
  }
};
var y1 = function() {
  var r = this, c = r._self._c;
  return c("Badge", { staticClass: "badge--host", attrs: { variant: r.badgeVarient } }, [r._v(" " + r._s(r.badgeCopy) + " ")]);
}, k1 = [], x1 = /* @__PURE__ */ he(
  w1,
  y1,
  k1,
  !1,
  null,
  null,
  null,
  null
);
const FP = x1.exports;
const S1 = {
  name: "BadgeMarker",
  components: {
    Badge: Di,
    SType: Rt
  },
  props: {
    markers: {
      type: Array
    },
    size: {
      type: String,
      default: "default",
      validator: function(a) {
        return ["default", "small"].includes(a);
      }
    },
    type: {
      type: String,
      required: !0,
      validator: function(a) {
        return ["intro", "pre", "mid", "post", "outro"].includes(a);
      }
    }
  },
  computed: {
    badgeCopy() {
      return {
        intro: "Intro",
        pre: "Pre",
        mid: "Mid",
        post: "Post",
        outro: "Outro"
      }[this.type];
    },
    svgSize() {
      return this.size === "small" ? 6 : 8;
    }
  }
};
var C1 = function() {
  var r = this, c = r._self._c;
  return c("Badge", { staticClass: "badge--marker", attrs: { size: r.size, variant: "neutral" }, scopedSlots: r._u([{ key: "pre", fn: function() {
    return [c("svg", { class: `badge__icon-${r.type}`, attrs: { width: r.svgSize, height: r.svgSize, alt: "", viewbox: `0 0 ${r.svgSize} ${r.svgSize}` } }, [c("circle", { attrs: { cx: r.svgSize / 2, cy: r.svgSize / 2, r: r.svgSize / 2, fill: "currentColor" } })])];
  }, proxy: !0 }, r.markers && r.markers.length > 0 ? { key: "post", fn: function() {
    return [c("SType", { staticClass: "badge__markers", attrs: { "gutter-bottom": !1, prominence: r.size === "small" ? "sm" : "default", variant: "body", tag: "span" } }, [r._v(" " + r._s(r.markers.join(", ")) + " ")])];
  }, proxy: !0 } : null], null, !0) }, [r._v(" " + r._s(r.badgeCopy) + " ")]);
}, A1 = [], T1 = /* @__PURE__ */ he(
  S1,
  C1,
  A1,
  !1,
  null,
  null,
  null,
  null
);
const zP = T1.exports, I1 = {
  name: "BadgeUser",
  components: {
    Badge: Di,
    SType: Rt
  },
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
};
var E1 = function() {
  var r = this, c = r._self._c;
  return c("Badge", { staticClass: "badge--user", attrs: { variant: "neutral-weak" }, scopedSlots: r._u([{ key: "post", fn: function() {
    return [c("SType", { attrs: { variant: "subtitle", prominence: "sm", "gutter-bottom": !1 } }, [r._v(" " + r._s(r.count) + " ")])];
  }, proxy: !0 }]) }, [r._v(" Roles ")]);
}, P1 = [], M1 = /* @__PURE__ */ he(
  I1,
  E1,
  P1,
  !1,
  null,
  null,
  null,
  null
);
const $P = M1.exports;
const O1 = {
  name: "Banner",
  props: {
    bannerType: {
      type: String,
      default: "default"
    },
    dismissable: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      showNotification: !0
    };
  },
  methods: {
    onClick() {
      this.showNotification = !1, this.$emit("dismiss-banner");
    }
  }
};
var D1 = function() {
  var r = this, c = r._self._c;
  return r.showNotification ? c("div", { class: "banner banner-" + r.bannerType }, [c("p", { staticClass: "no-margin" }, [r._t("default")], 2), r.dismissable ? c("button", { staticClass: "button-x", on: { click: function(u) {
    return u.preventDefault(), r.onClick();
  } } }) : r._e()]) : r._e();
}, N1 = [], R1 = /* @__PURE__ */ he(
  O1,
  D1,
  N1,
  !1,
  null,
  null,
  null,
  null
);
const jP = R1.exports;
const L1 = {
  name: "s-card",
  props: {
    radius: {
      type: String,
      validator: (a) => ["strong", "marketing"].includes(a),
      default: "strong"
    },
    variant: {
      type: String,
      validator: (a) => [
        "neutral-weak",
        "neutral",
        "neutral-strong",
        "accent1",
        "accent2",
        "accent3",
        "accent4",
        "accent5"
      ].includes(a),
      default: "neutral"
    }
  }
};
var F1 = function() {
  var r = this, c = r._self._c;
  return c("div", { class: `s-card s-card-${r.variant} s-card-${r.radius}` }, [r._t("default")], 2);
}, z1 = [], $1 = /* @__PURE__ */ he(
  L1,
  F1,
  z1,
  !1,
  null,
  "d586ee3a",
  null,
  null
);
const j1 = $1.exports;
const B1 = {
  name: "Card"
};
var V1 = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "card" }, [r._t("default")], 2);
}, U1 = [], H1 = /* @__PURE__ */ he(
  B1,
  V1,
  U1,
  !1,
  null,
  null,
  null,
  null
);
const BP = H1.exports, Wo = {
  doubleDigits(a) {
    return a.toString().length < 2 ? `0${a}` : a;
  },
  format(a, r, c) {
    const u = c ? `${this.removeOffset(a)}-00:00` : a, p = new Date(u), h = r;
    return this.replace(p, h);
  },
  getDateTime(a) {
    let r, c;
    try {
      return [r, c] = a.split("T");
    } catch {
    }
    return [a, null];
  },
  getHour(a, r) {
    const c = r ? `${this.removeOffset(a)}-00:00` : a;
    let u = this.format(c, "HH", r);
    return u > 12 ? u = this.doubleDigits(u - 12) : u === "00" && (u = "12"), u.toString();
  },
  get24Hour(a, r) {
    let c = r === "pm" ? parseInt(a) + 12 : parseInt(a) === 12 ? "00" : a;
    return c === 24 && (c = 12), c;
  },
  getMonthName(a) {
    return [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ][a];
  },
  getMonthShortName(a) {
    return [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ][a];
  },
  iso(a) {
    if (typeof a != "number")
      return a;
    const r = new Date(a * 1e3).toISOString();
    let c = 11, u = 8;
    return r.substr(c, 2) === "00" && (c = 14, u = 5), r.substr(c, u);
  },
  removeOffset(a) {
    let r = a, c, u;
    try {
      [c, u] = a.split("T");
    } catch {
    }
    if (u) {
      const [p] = u.split(/[-+Z]/gi);
      r = `${c}T${p}`;
    }
    return r;
  },
  replace(a, r) {
    return r.replace(/\bm(?!m)/, a.getUTCMinutes()).replace(
      /\bM(?!M)/,
      a.getUTCMinutes() > 9 ? a.getUTCMinutes() : `0${a.getUTCMinutes()}`
    ).replace(
      "h",
      a.getUTCHours() > 12 ? a.getUTCHours() - 12 : a.getUTCHours() === 0 ? 12 : a.getUTCHours()
    ).replace("HH", a.getUTCHours()).replace("DD", a.getUTCDate()).replace("YYYY", a.getUTCFullYear()).replace(/\ba(?!a)\b/, a.getUTCHours() >= 12 ? "pm" : "am").replace(/\bA(?!A)\b/, a.getUTCHours() >= 12 ? "PM" : "AM").replace("MMMM", this.getMonthName(a.getUTCMonth())).replace("MMM", this.getMonthShortName(a.getUTCMonth()));
  },
  url(a) {
    let r = typeof a == "number" ? this.iso(a).split(":") : a.split(":");
    return r = r.map((c) => parseInt(c)).filter((c) => c >= 0), r.length === 3 ? `${r[0]}h${r[1]}m${r[2]}s` : r.length === 2 ? `${r[0]}m${r[1]}s` : r[0] >= 60 ? this.url(r[0]) : `${r[0]}s`;
  }
}, W1 = {
  name: "SimplecastIcon"
};
var Y1 = function() {
  var r = this, c = r._self._c;
  return c("svg", { attrs: { viewBox: "0 0 25 25", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [c("polygon", { attrs: { points: "24.845 24.845 0 24.845 0 0 12.422 12.423" } }), c("polygon", { attrs: { points: "21.3821 17.5179 7.3271 3.4629 9.3481 1.4429 23.4031 15.4969" } }), c("polygon", { attrs: { points: "21.3821 9.6116 15.2341 3.4636 17.2531 1.4426 23.4031 7.5916" } })]);
}, q1 = [], G1 = /* @__PURE__ */ he(
  W1,
  Y1,
  q1,
  !1,
  null,
  null,
  null,
  null
);
const dp = G1.exports;
const Z1 = {
  components: {
    Artwork: kl,
    LogoImage: dp
  },
  props: {
    episode: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: !1
    },
    podcast: {
      type: Object,
      default: null
    },
    transparent: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    imageUrl() {
      let a = null;
      return this.podcast && this.podcast.image_url && (a = this.podcast.image_url), this.episode && this.episode.image_url && (a = this.episode.image_url), a;
    }
  }
};
var K1 = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "episode-artwork" }, [c("artwork", { class: { "transparent-image": r.transparent }, attrs: { "image-url": r.imageUrl, loading: r.loading } }, [r.imageUrl ? r._e() : c("logo-image", { staticClass: "episode-artwork-default" })], 1)], 1);
}, X1 = [], Q1 = /* @__PURE__ */ he(
  Z1,
  K1,
  X1,
  !1,
  null,
  null,
  null,
  null
);
const J1 = Q1.exports;
const ex = {
  name: "CardEpisode",
  components: {
    EpisodeArtwork: J1
  },
  props: {
    episode: {
      type: Object,
      default: null
    },
    seasons: {
      type: Number,
      default: -1
    },
    podcast: {
      type: Object,
      default: null
    },
    downloads: {
      type: Number,
      default: -1
    }
  },
  computed: {
    cardClass() {
      return {
        "card-episode": this.episode,
        [`episode-status-${this.status}`]: !this.isPrivate(),
        "episode-status-private": this.isPrivate()
      };
    },
    imageIsTransparent() {
      return !(["dirty", "live", "published"].indexOf(this.episode.status) > -1) || this.isPrivate();
    },
    showSeason() {
      return this.podcast.type !== "episodic";
    },
    meta() {
      const r = typeof this.episode.number == "number" && this.episode.number > -1 ? `EP${this.episode.number}` : null, c = this.showSeason && this.episode.season && this.episode.season.number > 0 ? `S${this.episode.season.number}` : null, u = this.episode.type === "trailer" || this.episode.type === "bonus" ? this.episode.type.charAt(0).toUpperCase() + this.episode.type.slice(1) : null;
      let p = "";
      return c && (p += c), c && r && !u && (p += ":"), r && !u && (p += r), c && u && (p += " - "), u && (p += u), p;
    },
    metaSecondary() {
      if (this.episode.is_published)
        return this.formatDate(this.episode.published_at);
      switch (this.episode.status) {
        case "dirty":
          return this.formatDate(this.episode.published_at);
        case "draft":
          return this.episode.updated_at ? this.formatDate(this.episode.updated_at) : "";
        case "live":
          return this.formatDate(this.episode.published_at);
        case "published":
          return this.formatDate(this.episode.published_at);
        case "scheduled":
          return this.formatDate(this.episode.scheduled_for);
      }
      return "";
    },
    status() {
      return this.episode.audio_status === "transcoded" ? this.isPrivate() ? "private" : this.episode.status : (this.episode.audio_status === "no_audio" || this.episode.audio_status === null) && this.episode.status === "draft" ? this.episode.status : this.episode.audio_status;
    },
    statusText() {
      return this.episode.audio_status === "transcoded" ? this.episode.published_at && !this.episode.is_hidden && ["dirty", "live", "published"].indexOf(this.episode.status) > -1 ? "" : this.isPrivate() ? "Private" : this.episode.status.replace("_", " ") : (this.episode.audio_status === "no_audio" || this.episode.audio_status === null) && this.episode.status === "draft" ? this.episode.status : this.episode.audio_status.replace("_", " ");
    }
  },
  methods: {
    isPrivate() {
      return this.episode.is_hidden === !0 && ["dirty", "live", "published"].indexOf(this.episode.status) > -1;
    },
    getPercentComplete() {
      let r = 0;
      return this.episode.title && this.episode.title !== "" && (r += 1), this.episode.description && this.episode.description !== "" && (r += 1), this.episode.long_description && this.episode.long_description !== "" && (r += 1), this.episode.number && this.episode.number > 0 && (r += 1), this.episode.audio_file_path && this.episode.audio_file_path !== "" && (r += 1), this.episode.image_url && this.episode.image_url !== "" && (r += 1), this.episode.season_id && this.episode.season_id > 0 && (r += 1), this.episode.recast_image && this.episode.recast_image !== "" && (r += 1), this.episode.recast_color && this.episode.recast_color !== "" && (r += 1), this.episode.authors && this.episode.authors.collection && this.episode.authors.collection.length > 0 && (r += 1), this.episode.keywords && this.episode.keywords.collection && this.episode.keywords.collection.length > 0 && (r += 1), `${Math.round(r / 11 * 100)}% complete`;
    },
    truncate(a) {
      if (!a)
        return "";
      const r = a.substring(0, 70);
      return r.length < a.length ? r + "..." : a;
    },
    formatDate(a) {
      return `${Wo.format(a, "MMMM DD, YYYY @ h:M a", !0)} ${this.podcast.time_zone_abbreviation}`;
    }
  }
};
var tx = function() {
  var r = this, c = r._self._c;
  return c("div", { class: r.cardClass }, [c("div", { staticClass: "card-image" }, [c("EpisodeArtwork", { attrs: { episode: r.episode, podcast: r.podcast, transparent: r.imageIsTransparent } })], 1), c("div", { staticClass: "card-content" }, [c("div", { staticClass: "card-meta type-s" }, [c("div", { staticClass: "card-meta-data" }, [r._v(" " + r._s(r.meta) + " ")]), c("div", { staticClass: "card-meta-status" }, [r._v(" " + r._s(r.statusText === "transcoding" ? "processing" : r.statusText) + " ")])]), c("div", { staticClass: "card-title" }, [r._v(" " + r._s(r.truncate(r.episode.title)) + " ")]), c("div", { staticClass: "card-meta-secondary type-s" }, [c("span", [r._v(r._s(r.metaSecondary))]), r._t("default")], 2)])]);
}, nx = [], ix = /* @__PURE__ */ he(
  ex,
  tx,
  nx,
  !1,
  null,
  null,
  null,
  null
);
const VP = ix.exports;
const rx = {
  name: "CollapsibleList",
  components: {
    IconArrow: vi,
    SButton: bi,
    SType: Rt
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      a11yOpen: "Open all",
      a11yClose: "Close all",
      allOpen: !1
    };
  },
  computed: {
    buttonTitle() {
      return this.allOpen ? this.a11yClose : this.a11yOpen;
    },
    buttonDirection() {
      return this.allOpen ? "up" : "down";
    }
  },
  methods: {
    toggleAll() {
      this.allOpen = !this.allOpen, this.$emit("toggle", this.allOpen);
    }
  }
};
var ox = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "collapsible-list" }, [r.title || r.$slots.header ? c("SType", { staticClass: "collapsible-list--title", attrs: { "gutter-bottom": !1, variant: "subtitle" } }, [r._t("header", function() {
    return [r._v(r._s(r.title))];
  }), c("SButton", { attrs: { title: r.buttonTitle, icon: !0, variant: "flat" }, on: { click: function(u) {
    return u.preventDefault(), r.toggleAll.apply(null, arguments);
  } } }, [c("IconArrow", { attrs: { "title-access": r.buttonTitle, direction: r.buttonDirection } })], 1)], 2) : r._e(), c("ul", { staticClass: "collapsible-list--items" }, [r._t("default")], 2)], 1);
}, sx = [], ax = /* @__PURE__ */ he(
  rx,
  ox,
  sx,
  !1,
  null,
  "ae73caec",
  null,
  null
);
const UP = ax.exports;
const lx = {
  name: "CollapsibleListItem",
  components: {
    Collapse: lp,
    IconArrow: vi,
    SButton: bi
  },
  data() {
    return {
      a11yOpen: "Open accordion",
      a11yClose: "Close accordion",
      open: !1
    };
  },
  props: {
    overrideOpen: {
      type: Boolean,
      default: !1
    },
    child: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    overrideOpen(a) {
      this.open = a;
    }
  },
  computed: {
    buttonTitle() {
      return this.open ? this.a11yClose : this.a11yOpen;
    },
    buttonDirection() {
      return this.open ? "up" : "down";
    }
  },
  methods: {
    toggleStatus() {
      this.open = !this.open;
    }
  }
};
var cx = function() {
  var r = this, c = r._self._c;
  return c("li", { class: ["collapsible-list-item", { child: r.child, open: r.open }] }, [c("div", { staticClass: "collapsible-list-item--parent" }, [c("div", [r._t("default")], 2), r.$slots.children ? c("SButton", { attrs: { title: r.buttonTitle, icon: !0, variant: "flat" }, on: { click: function(u) {
    return u.preventDefault(), r.toggleStatus.apply(null, arguments);
  } } }, [c("IconArrow", { attrs: { "title-access": r.buttonTitle, direction: r.buttonDirection } })], 1) : r._e()], 1), r.$slots.children ? c("Collapse", { staticClass: "collapsible-list-item--children", attrs: { open: r.open, tag: "ul" } }, [r._t("children")], 2) : r._e()], 1);
}, ux = [], dx = /* @__PURE__ */ he(
  lx,
  cx,
  ux,
  !1,
  null,
  "5ff698e3",
  null,
  null
);
const HP = dx.exports;
const hx = {
  components: { SType: Rt, IconArrow: vi },
  props: {
    crumbs: {
      SType: Array,
      default: () => []
    }
  }
};
var fx = function() {
  var r = this, c = r._self._c;
  return r.crumbs && r.crumbs.length > 0 ? c("ul", { staticClass: "list-crumbs" }, r._l(r.crumbs, function(u, p) {
    return c("li", { key: u.title }, [u.to ? c("router-link", { attrs: { to: { name: u.to, params: u.params || {} } } }, [c("SType", { staticClass: "list-crumbs__text", attrs: { gutterBottom: !1, tag: "span", variant: "body" } }, [r._v(" " + r._s(u.title) + " ")])], 1) : c("SType", { staticClass: "list-crumbs__text", attrs: { gutterBottom: !1, variant: "body", tag: "span" } }, [r._v(" " + r._s(u.title) + " ")]), p < r.crumbs.length - 1 ? c("IconArrow", { staticClass: "list-crumbs__icons", attrs: { direction: "right", size: "sm", titleAccess: "" } }) : r._e()], 1);
  }), 0) : r._e();
}, px = [], mx = /* @__PURE__ */ he(
  hx,
  fx,
  px,
  !1,
  null,
  "8a1866e2",
  null,
  null
);
const WP = mx.exports;
const gx = {
  components: {
    IconCheck: Fr,
    IconAdd: mk
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    toggle: {
      type: Boolean,
      default: !1
    },
    pill: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      focused: !1,
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  created() {
    window.addEventListener("keydown", this.preventScroll);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.preventScroll);
  },
  methods: {
    blur() {
      this.focused = !1;
    },
    change(a) {
      this.input = a.target.checked, this.$emit("input", { target: { value: this.input } });
    },
    focus(a) {
      this.focused = !0, this.$emit("focus", a);
    },
    preventScroll(a) {
      if (a.keyCode === 32 && this.focused)
        return a.preventDefault(), !1;
    },
    toggleCheckbox() {
      this.$refs.checkbox.checked = !this.$refs.checkbox.checked;
      const a = {};
      a.target = { checked: this.$refs.checkbox.checked }, this.change(a);
    }
  }
};
var vx = function() {
  var r = this, c = r._self._c;
  return c("label", { class: [
    "form-input-checkbox form-input-checkbox-label",
    {
      "form-input-pill": r.pill,
      "form-input-checked": r.input,
      disabled: r.disabled
    }
  ], attrs: { for: "form-input-" + r.name, tabindex: "0" }, on: { blur: r.blur, focus: r.focus, keyup: function(u) {
    return !u.type.indexOf("key") && u.keyCode !== 32 ? null : r.toggleCheckbox.apply(null, arguments);
  } } }, [c("div", { class: { "form-input-toggle": r.toggle } }, [c("input", { ref: "checkbox", attrs: { id: "form-input-" + r.name, disabled: r.disabled, tabindex: "-1", type: "checkbox" }, domProps: { checked: r.input, value: r.name }, on: { change: r.change } }), r.toggle ? c("span", { class: { "input-checkbox-slider": !0, disabled: r.disabled } }) : r.pill ? [r.input ? c("IconCheck", { staticClass: "icon", attrs: { size: "sm" } }) : c("IconAdd", { staticClass: "icon", attrs: { size: "sm" } })] : c("span", { staticClass: "input-checkbox-indicator" })], 2), r._t("default")], 2);
}, bx = [], _x = /* @__PURE__ */ he(
  gx,
  vx,
  bx,
  !1,
  null,
  "36876331",
  null,
  null
);
const wx = _x.exports;
const yx = {};
var kx = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "data-group" }, [r._t("default")], 2);
}, xx = [], Sx = /* @__PURE__ */ he(
  yx,
  kx,
  xx,
  !1,
  null,
  null,
  null,
  null
);
const YP = Sx.exports;
function Za(a, r) {
  return !!(a && a.toLowerCase() === r.toLowerCase());
}
function hp(a) {
  return Za(a.tagName, "div") && (a.classList.value === "dropdown" || a.classList.value === "dropdown-mobile-content") ? !1 : Za(a.tagName, "a") || Za(a.tagName, "button") ? !0 : a.parentElement ? hp(a.parentElement) : !1;
}
function fp(a) {
  return hp(a);
}
const Cx = {
  name: "DropdownCaron",
  components: { IconArrow: vi },
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    hasMargin: {
      type: Boolean,
      default: !0
    },
    mode: {
      type: String,
      default: "light"
    }
  },
  computed: {
    buttonTitle() {
      return this.isOpen ? "Close Dropdown" : "Open Dropdown";
    },
    buttonDirection() {
      return this.isOpen ? "up" : "down";
    }
  }
};
var Ax = function() {
  var r = this, c = r._self._c;
  return c("IconArrow", { class: [
    "dropdown-caron",
    `dropdown-caron-${r.mode}`,
    { "dropdown-caron-hasMargin": r.hasMargin }
  ], attrs: { "title-access": r.buttonTitle, direction: r.buttonDirection, size: "sm" } });
}, Tx = [], Ix = /* @__PURE__ */ he(
  Cx,
  Ax,
  Tx,
  !1,
  null,
  null,
  null,
  null
);
const pp = Ix.exports;
const Ex = {
  components: {
    DropdownCaron: pp,
    SButton: bi
  },
  props: {
    hasCarot: {
      type: Boolean,
      default: !0
    },
    hasMargin: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      default: "flat"
    },
    dropdownWidth: {
      type: String,
      default: null
    },
    dropdownPadding: {
      type: Boolean,
      default: !0
    },
    openOnHover: {
      type: Boolean,
      default: !0
    },
    position: {
      type: String,
      default: "left"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showDropdown: !1
    };
  },
  computed: {
    mode() {
      return this.variant === "secondary-inverse" || this.variant === "flat-inverse" ? "light" : "dark";
    }
  },
  created() {
    document.addEventListener("click", this.handleGlobalClick), document.addEventListener("touchstart", this.handleGlobalClick), document.addEventListener("focusin", this.handleGlobalClick);
  },
  destroyed() {
    document.removeEventListener("click", this.handleGlobalClick), document.removeEventListener("touchstart", this.handleGlobalClick), document.removeEventListener("focusin", this.handleGlobalClick);
  },
  methods: {
    handleClick(a) {
      fp(a.target) && (this.showDropdown = !1);
    },
    handleGlobalClick(a) {
      const r = this.$refs.dropdown, { target: c } = a;
      r !== c && !r.contains(c) && (this.showDropdown = !1);
    },
    mouseEnter() {
      this.openOnHover && (this.showDropdown = !0);
    },
    mouseLeave() {
      this.openOnHover && (this.showDropdown = !1);
    }
  }
};
var Px = function() {
  var r = this, c = r._self._c;
  return c("div", { ref: "dropdown", class: ["dropdown-container", { "dropdown-open": r.showDropdown }], on: { mouseenter: r.mouseEnter, mouseleave: r.mouseLeave, keyup: function(u) {
    if (!u.type.indexOf("key") && r._k(u.keyCode, "esc", 27, u.key, ["Esc", "Escape"]))
      return null;
    r.showDropdown = !1;
  } } }, [c("SButton", { staticClass: "dropdown-trigger", attrs: { icon: !0, variant: r.variant, disabled: r.disabled }, on: { touchstart: function(u) {
    u.stopPropagation(), u.preventDefault(), r.showDropdown = !r.showDropdown;
  }, click: function(u) {
    u.stopPropagation(), u.preventDefault(), r.showDropdown = !r.showDropdown;
  } } }, [r._t("button"), r.hasCarot ? c("dropdown-caron", { attrs: { "has-margin": r.hasMargin, "is-open": r.showDropdown, mode: r.mode } }) : r._e()], 2), c("transition", { attrs: { name: "fade" } }, [c("div", { directives: [{ name: "show", rawName: "v-show", value: r.showDropdown, expression: "showDropdown" }], class: [
    "dropdown",
    `dropdown-${r.position}`,
    { "dropdown-padding": r.dropdownPadding }
  ], style: `width: ${r.dropdownWidth ? r.dropdownWidth : "auto"}`, on: { touchstart: r.handleClick, click: r.handleClick } }, [r._t("content")], 2)])], 1);
}, Mx = [], Ox = /* @__PURE__ */ he(
  Ex,
  Px,
  Mx,
  !1,
  null,
  null,
  null,
  null
);
const mp = Ox.exports;
var cn = { exports: {} };
function Tt() {
  return Tt = Object.assign ? Object.assign.bind() : function(a) {
    for (var r = 1; r < arguments.length; r++) {
      var c = arguments[r];
      for (var u in c)
        Object.prototype.hasOwnProperty.call(c, u) && (a[u] = c[u]);
    }
    return a;
  }, Tt.apply(this, arguments);
}
function Dx(a, r) {
  if (a == null)
    return {};
  var c = {}, u = Object.keys(a), p, h;
  for (h = 0; h < u.length; h++)
    p = u[h], !(r.indexOf(p) >= 0) && (c[p] = a[p]);
  return c;
}
var Nx = ".".charCodeAt(0), Rx = /\\(\\)?/g, Lx = RegExp(
  `[^.[\\]]+|\\[(?:([^"'][^[]*)|(["'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))`,
  "g"
), Fx = function(r) {
  var c = [];
  return r.charCodeAt(0) === Nx && c.push(""), r.replace(Lx, function(u, p, h, v) {
    var w = u;
    h ? w = v.replace(Rx, "$1") : p && (w = p.trim()), c.push(w);
  }), c;
}, Ka = {}, gp = function(r) {
  if (r == null || !r.length)
    return [];
  if (typeof r != "string")
    throw new Error("toPath() expects a string");
  return Ka[r] == null && (Ka[r] = Fx(r)), Ka[r];
}, ht = function(r, c) {
  for (var u = gp(c), p = r, h = 0; h < u.length; h++) {
    var v = u[h];
    if (p == null || typeof p != "object" || Array.isArray(p) && isNaN(v))
      return;
    p = p[v];
  }
  return p;
};
function zx(a) {
  var r = $x(a, "string");
  return typeof r == "symbol" ? r : String(r);
}
function $x(a, r) {
  if (typeof a != "object" || a === null)
    return a;
  var c = a[Symbol.toPrimitive];
  if (c !== void 0) {
    var u = c.call(a, r || "default");
    if (typeof u != "object")
      return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(a);
}
var jx = function a(r, c, u, p, h) {
  if (c >= u.length)
    return p;
  var v = u[c];
  if (isNaN(v)) {
    var w;
    if (r == null) {
      var x, k = a(void 0, c + 1, u, p, h);
      return k === void 0 ? void 0 : (x = {}, x[v] = k, x);
    }
    if (Array.isArray(r))
      throw new Error("Cannot set a non-numeric property on an array");
    var P = a(r[v], c + 1, u, p, h);
    if (P === void 0) {
      var R = Object.keys(r).length;
      if (r[v] === void 0 && R === 0)
        return;
      if (r[v] !== void 0 && R <= 1)
        return !isNaN(u[c - 1]) && !h ? {} : void 0;
      r[v];
      var $ = Dx(r, [v].map(zx));
      return $;
    }
    return Tt({}, r, (w = {}, w[v] = P, w));
  }
  var J = Number(v);
  if (r == null) {
    var X = a(void 0, c + 1, u, p, h);
    if (X === void 0)
      return;
    var H = [];
    return H[J] = X, H;
  }
  if (!Array.isArray(r))
    throw new Error("Cannot set a numeric property on an object");
  var W = r[J], Z = a(W, c + 1, u, p, h), ee = [].concat(r);
  if (h && Z === void 0) {
    if (ee.splice(J, 1), ee.length === 0)
      return;
  } else
    ee[J] = Z;
  return ee;
}, sn = function(r, c, u, p) {
  if (p === void 0 && (p = !1), r == null)
    throw new Error("Cannot call setIn() with " + String(r) + " state");
  if (c == null)
    throw new Error("Cannot call setIn() with " + String(c) + " key");
  return jx(r, 0, gp(c), u, p);
}, hl = "FINAL_FORM/form-error", tr = "FINAL_FORM/array-error";
function jf(a, r) {
  var c = a.errors, u = a.initialValues, p = a.lastSubmittedValues, h = a.submitErrors, v = a.submitFailed, w = a.submitSucceeded, x = a.submitting, k = a.values, P = r.active, R = r.blur, $ = r.change, J = r.data, X = r.focus, H = r.modified, W = r.modifiedSinceLastSubmit, Z = r.name, ee = r.touched, ne = r.validating, se = r.visited, pe = ht(k, Z), ge = ht(c, Z);
  ge && ge[tr] && (ge = ge[tr]);
  var Oe = h && ht(h, Z), ke = u && ht(u, Z), we = r.isEqual(ke, pe), F = !!(p && !r.isEqual(ht(p, Z), pe)), _ = !ge && !Oe;
  return {
    active: P,
    blur: R,
    change: $,
    data: J,
    dirty: !we,
    dirtySinceLastSubmit: F,
    error: ge,
    focus: X,
    initial: ke,
    invalid: !_,
    length: Array.isArray(pe) ? pe.length : void 0,
    modified: H,
    modifiedSinceLastSubmit: W,
    name: Z,
    pristine: we,
    submitError: Oe,
    submitFailed: v,
    submitSucceeded: w,
    submitting: x,
    touched: ee,
    valid: _,
    value: pe,
    visited: se,
    validating: ne
  };
}
var vp = ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "value", "visited", "validating"], Fn = function(r, c) {
  if (r === c)
    return !0;
  if (typeof r != "object" || !r || typeof c != "object" || !c)
    return !1;
  var u = Object.keys(r), p = Object.keys(c);
  if (u.length !== p.length)
    return !1;
  for (var h = Object.prototype.hasOwnProperty.bind(c), v = 0; v < u.length; v++) {
    var w = u[v];
    if (!h(w) || r[w] !== c[w])
      return !1;
  }
  return !0;
};
function bp(a, r, c, u, p, h) {
  var v = !1;
  return p.forEach(function(w) {
    u[w] && (a[w] = r[w], (!c || (~h.indexOf(w) ? !Fn(r[w], c[w]) : r[w] !== c[w])) && (v = !0));
  }), v;
}
var Bx = ["data"], Vx = function(r, c, u, p) {
  var h = {
    blur: r.blur,
    change: r.change,
    focus: r.focus,
    name: r.name
  }, v = bp(h, r, c, u, vp, Bx) || !c;
  return v || p ? h : void 0;
}, _p = ["active", "dirty", "dirtyFields", "dirtyFieldsSinceLastSubmit", "dirtySinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitting", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "touched", "valid", "validating", "values", "visited"], Ux = ["touched", "visited"];
function Bf(a, r, c, u) {
  var p = {}, h = bp(p, a, r, c, _p, Ux) || !r;
  return h || u ? p : void 0;
}
var Vf = function(r) {
  var c, u;
  return function() {
    for (var p = arguments.length, h = new Array(p), v = 0; v < p; v++)
      h[v] = arguments[v];
    return (!c || h.length !== c.length || h.some(function(w, x) {
      return !Fn(c[x], w);
    })) && (c = h, u = r.apply(void 0, h)), u;
  };
}, Xa = function(a) {
  return !!a && (typeof a == "object" || typeof a == "function") && typeof a.then == "function";
}, Hx = "4.20.7", Wx = ["debug", "initialValues", "keepDirtyOnReinitialize", "mutators", "onSubmit", "validate", "validateOnBlur"], Yx = function(r, c) {
  return r === c;
}, Ji = function a(r) {
  return Object.keys(r).some(function(c) {
    var u = r[c];
    return u && typeof u == "object" && !(u instanceof Error) ? a(u) : typeof u < "u";
  });
};
function qx(a) {
  var r = a.active, c = a.dirtySinceLastSubmit, u = a.modifiedSinceLastSubmit, p = a.error, h = a.errors, v = a.initialValues, w = a.pristine, x = a.submitting, k = a.submitFailed, P = a.submitSucceeded, R = a.submitError, $ = a.submitErrors, J = a.valid, X = a.validating, H = a.values;
  return {
    active: r,
    dirty: !w,
    dirtySinceLastSubmit: c,
    modifiedSinceLastSubmit: u,
    error: p,
    errors: h,
    hasSubmitErrors: !!(R || $ && Ji($)),
    hasValidationErrors: !!(p || Ji(h)),
    invalid: !J,
    initialValues: v,
    pristine: w,
    submitting: x,
    submitFailed: k,
    submitSucceeded: P,
    submitError: R,
    submitErrors: $,
    valid: J,
    validating: X > 0,
    values: H
  };
}
function wp(a, r, c, u, p, h) {
  var v = p(c, u, r, h);
  return v ? (a(v), !0) : !1;
}
function Uf(a, r, c, u, p) {
  var h = a.entries;
  Object.keys(h).forEach(function(v) {
    var w = h[Number(v)];
    if (w) {
      var x = w.subscription, k = w.subscriber, P = w.notified;
      wp(k, x, r, c, u, p || !P) && (w.notified = !0);
    }
  });
}
function Gx(a) {
  if (!a)
    throw new Error("No config specified");
  var r = a.debug, c = a.destroyOnUnregister, u = a.keepDirtyOnReinitialize, p = a.initialValues, h = a.mutators, v = a.onSubmit, w = a.validate, x = a.validateOnBlur;
  if (!v)
    throw new Error("No onSubmit function specified");
  var k = {
    subscribers: {
      index: 0,
      entries: {}
    },
    fieldSubscribers: {},
    fields: {},
    formState: {
      asyncErrors: {},
      dirtySinceLastSubmit: !1,
      modifiedSinceLastSubmit: !1,
      errors: {},
      initialValues: p && Tt({}, p),
      invalid: !1,
      pristine: !0,
      submitting: !1,
      submitFailed: !1,
      submitSucceeded: !1,
      resetWhileSubmitting: !1,
      valid: !0,
      validating: 0,
      values: p ? Tt({}, p) : {}
    },
    lastFormState: void 0
  }, P = 0, R = !1, $ = !1, J = !1, X = 0, H = {}, W = function(A) {
    return function(M) {
      return delete H[A], M;
    };
  }, Z = function(A, M, Q) {
    var z = ht(A.formState.values, M), te = Q(z);
    A.formState.values = sn(A.formState.values, M, te) || {};
  }, ee = function(A, M, Q) {
    if (A.fields[M]) {
      var z, te;
      A.fields = Tt({}, A.fields, (z = {}, z[Q] = Tt({}, A.fields[M], {
        name: Q,
        blur: function() {
          return Ce.blur(Q);
        },
        change: function(ve) {
          return Ce.change(Q, ve);
        },
        focus: function() {
          return Ce.focus(Q);
        },
        lastFieldState: void 0
      }), z)), delete A.fields[M], A.fieldSubscribers = Tt({}, A.fieldSubscribers, (te = {}, te[Q] = A.fieldSubscribers[M], te)), delete A.fieldSubscribers[M];
      var me = ht(A.formState.values, M);
      A.formState.values = sn(A.formState.values, M, void 0) || {}, A.formState.values = sn(A.formState.values, Q, me), delete A.lastFormState;
    }
  }, ne = function(A) {
    return function() {
      if (h) {
        for (var M = {
          formState: k.formState,
          fields: k.fields,
          fieldSubscribers: k.fieldSubscribers,
          lastFormState: k.lastFormState
        }, Q = arguments.length, z = new Array(Q), te = 0; te < Q; te++)
          z[te] = arguments[te];
        var me = h[A](z, M, {
          changeValue: Z,
          getIn: ht,
          renameField: ee,
          resetFieldState: Ce.resetFieldState,
          setIn: sn,
          shallowEqual: Fn
        });
        return k.formState = M.formState, k.fields = M.fields, k.fieldSubscribers = M.fieldSubscribers, k.lastFormState = M.lastFormState, ke(void 0, function() {
          we(), re();
        }), me;
      }
    };
  }, se = h ? Object.keys(h).reduce(function(q, A) {
    return q[A] = ne(A), q;
  }, {}) : {}, pe = function(A) {
    var M = [];
    if (w) {
      var Q = w(Tt({}, k.formState.values));
      Xa(Q) ? M.push(Q.then(function(z) {
        return A(z, !0);
      })) : A(Q, !1);
    }
    return M;
  }, ge = function(A) {
    return Object.keys(A.validators).reduce(function(M, Q) {
      var z = A.validators[Number(Q)]();
      return z && M.push(z), M;
    }, []);
  }, Oe = function(A, M) {
    var Q = [], z = ge(A);
    if (z.length) {
      var te;
      z.forEach(function(me) {
        var Ie = me(ht(k.formState.values, A.name), k.formState.values, me.length === 0 || me.length === 3 ? jf(k.formState, k.fields[A.name]) : void 0);
        if (Ie && Xa(Ie)) {
          A.validating = !0;
          var ve = Ie.then(function(Ne) {
            k.fields[A.name] && (k.fields[A.name].validating = !1, M(Ne));
          });
          Q.push(ve);
        } else
          te || (te = Ie);
      }), M(te);
    }
    return Q;
  }, ke = function(A, M) {
    if (R) {
      $ = !0, M();
      return;
    }
    var Q = k.fields, z = k.formState, te = Tt({}, Q), me = Object.keys(te);
    if (!w && !me.some(function(Et) {
      return ge(te[Et]).length;
    })) {
      M();
      return;
    }
    var Ie = !1;
    if (A) {
      var ve = te[A];
      if (ve) {
        var Ne = ve.validateFields;
        Ne && (Ie = !0, me = Ne.length ? Ne.concat(A) : [A]);
      }
    }
    var fe = {}, ae = {}, ct = {}, Gt = [].concat(pe(function(Et, Ft) {
      Ft ? ae = Et || {} : fe = Et || {};
    }), me.reduce(function(Et, Ft) {
      return Et.concat(Oe(Q[Ft], function(Mt) {
        ct[Ft] = Mt;
      }));
    }, [])), Qe = Gt.length > 0, Ve = ++X, Zt = Promise.all(Gt).then(W(Ve));
    Qe && (H[Ve] = Zt);
    var Tn = function(Ft) {
      var Mt = Tt({}, Ie ? z.errors : {}, fe, Ft ? ae : z.asyncErrors), Jt = function(et) {
        me.forEach(function(bt) {
          if (Q[bt]) {
            var en = ht(fe, bt), ir = ht(Mt, bt), jn = ge(te[bt]).length, Jn = ct[bt];
            et(bt, jn && Jn || w && en || (!en && !Ie ? ir : void 0));
          }
        });
      };
      Jt(function(Je, et) {
        Mt = sn(Mt, Je, et) || {};
      }), Jt(function(Je, et) {
        if (et && et[tr]) {
          var bt = ht(Mt, Je), en = [].concat(bt);
          en[tr] = et[tr], Mt = sn(Mt, Je, en);
        }
      }), Fn(z.errors, Mt) || (z.errors = Mt), Ft && (z.asyncErrors = ae), z.error = fe[hl];
    };
    if (Qe && (k.formState.validating++, M()), Tn(!1), M(), Qe) {
      var $n = function() {
        k.formState.validating--, M();
      };
      Zt.then(function() {
        X > Ve || Tn(!0);
      }).then($n, $n);
    }
  }, we = function(A) {
    if (!P) {
      var M = k.fields, Q = k.fieldSubscribers, z = k.formState, te = Tt({}, M), me = function(ve) {
        var Ne = te[ve], fe = jf(z, Ne), ae = Ne.lastFieldState;
        Ne.lastFieldState = fe;
        var ct = Q[ve];
        ct && Uf(ct, fe, ae, Vx, ae === void 0);
      };
      A ? me(A) : Object.keys(te).forEach(me);
    }
  }, F = function() {
    Object.keys(k.fields).forEach(function(A) {
      k.fields[A].touched = !0;
    });
  }, _ = function() {
    return !!(k.formState.error || Ji(k.formState.errors));
  }, E = function() {
    var A = k.fields, M = k.formState, Q = k.lastFormState, z = Tt({}, A), te = Object.keys(z), me = !1, Ie = te.reduce(function(Qe, Ve) {
      var Zt = !z[Ve].isEqual(ht(M.values, Ve), ht(M.initialValues || {}, Ve));
      return Zt && (me = !0, Qe[Ve] = !0), Qe;
    }, {}), ve = te.reduce(function(Qe, Ve) {
      var Zt = M.lastSubmittedValues || {};
      return z[Ve].isEqual(ht(M.values, Ve), ht(Zt, Ve)) || (Qe[Ve] = !0), Qe;
    }, {});
    M.pristine = !me, M.dirtySinceLastSubmit = !!(M.lastSubmittedValues && Object.values(ve).some(function(Qe) {
      return Qe;
    })), M.modifiedSinceLastSubmit = !!(M.lastSubmittedValues && Object.keys(z).some(function(Qe) {
      return z[Qe].modifiedSinceLastSubmit;
    })), M.valid = !M.error && !M.submitError && !Ji(M.errors) && !(M.submitErrors && Ji(M.submitErrors));
    var Ne = qx(M), fe = te.reduce(function(Qe, Ve) {
      return Qe.modified[Ve] = z[Ve].modified, Qe.touched[Ve] = z[Ve].touched, Qe.visited[Ve] = z[Ve].visited, Qe;
    }, {
      modified: {},
      touched: {},
      visited: {}
    }), ae = fe.modified, ct = fe.touched, Gt = fe.visited;
    return Ne.dirtyFields = Q && Fn(Q.dirtyFields, Ie) ? Q.dirtyFields : Ie, Ne.dirtyFieldsSinceLastSubmit = Q && Fn(Q.dirtyFieldsSinceLastSubmit, ve) ? Q.dirtyFieldsSinceLastSubmit : ve, Ne.modified = Q && Fn(Q.modified, ae) ? Q.modified : ae, Ne.touched = Q && Fn(Q.touched, ct) ? Q.touched : ct, Ne.visited = Q && Fn(Q.visited, Gt) ? Q.visited : Gt, Q && Fn(Q, Ne) ? Q : Ne;
  }, B = function() {
    return r && !0 && r(E(), Object.keys(k.fields).reduce(function(A, M) {
      return A[M] = k.fields[M], A;
    }, {}));
  }, Y = !1, N = !1, re = function q() {
    if (Y)
      N = !0;
    else {
      if (Y = !0, B(), !P && !(R && J)) {
        var A = k.lastFormState, M = E();
        M !== A && (k.lastFormState = M, Uf(k.subscribers, M, A, Bf));
      }
      Y = !1, N && (N = !1, q());
    }
  }, Te = function() {
    return Object.keys(k.fields).some(function(A) {
      return k.fields[A].beforeSubmit && k.fields[A].beforeSubmit() === !1;
    });
  }, Me = function() {
    return Object.keys(k.fields).forEach(function(A) {
      return k.fields[A].afterSubmit && k.fields[A].afterSubmit();
    });
  }, Ee = function() {
    return Object.keys(k.fields).forEach(function(A) {
      return k.fields[A].modifiedSinceLastSubmit = !1;
    });
  };
  ke(void 0, function() {
    re();
  });
  var Ce = {
    batch: function(A) {
      P++, A(), P--, we(), re();
    },
    blur: function(A) {
      var M = k.fields, Q = k.formState, z = M[A];
      z && (delete Q.active, M[A] = Tt({}, z, {
        active: !1,
        touched: !0
      }), x ? ke(A, function() {
        we(), re();
      }) : (we(), re()));
    },
    change: function(A, M) {
      var Q = k.fields, z = k.formState;
      if (ht(z.values, A) !== M) {
        Z(k, A, function() {
          return M;
        });
        var te = Q[A];
        te && (Q[A] = Tt({}, te, {
          modified: !0,
          modifiedSinceLastSubmit: !!z.lastSubmittedValues
        })), x ? (we(), re()) : ke(A, function() {
          we(), re();
        });
      }
    },
    get destroyOnUnregister() {
      return !!c;
    },
    set destroyOnUnregister(q) {
      c = q;
    },
    focus: function(A) {
      var M = k.fields[A];
      M && !M.active && (k.formState.active = A, M.active = !0, M.visited = !0, we(), re());
    },
    mutators: se,
    getFieldState: function(A) {
      var M = k.fields[A];
      return M && M.lastFieldState;
    },
    getRegisteredFields: function() {
      return Object.keys(k.fields);
    },
    getState: function() {
      return E();
    },
    initialize: function(A) {
      var M = k.fields, Q = k.formState, z = Tt({}, M), te = typeof A == "function" ? A(Q.values) : A;
      u || (Q.values = te);
      var me = u ? Object.keys(z).reduce(function(Ie, ve) {
        var Ne = z[ve], fe = Ne.isEqual(ht(Q.values, ve), ht(Q.initialValues || {}, ve));
        return fe || (Ie[ve] = ht(Q.values, ve)), Ie;
      }, {}) : {};
      Q.initialValues = te, Q.values = te, Object.keys(me).forEach(function(Ie) {
        Q.values = sn(Q.values, Ie, me[Ie]) || {};
      }), ke(void 0, function() {
        we(), re();
      });
    },
    isValidationPaused: function() {
      return R;
    },
    pauseValidation: function(A) {
      A === void 0 && (A = !0), R = !0, J = A;
    },
    registerField: function(A, M, Q, z) {
      Q === void 0 && (Q = {}), k.fieldSubscribers[A] || (k.fieldSubscribers[A] = {
        index: 0,
        entries: {}
      });
      var te = k.fieldSubscribers[A].index++;
      k.fieldSubscribers[A].entries[te] = {
        subscriber: Vf(M),
        subscription: Q,
        notified: !1
      }, k.fields[A] || (k.fields[A] = {
        active: !1,
        afterSubmit: z && z.afterSubmit,
        beforeSubmit: z && z.beforeSubmit,
        blur: function() {
          return Ce.blur(A);
        },
        change: function(ae) {
          return Ce.change(A, ae);
        },
        data: z && z.data || {},
        focus: function() {
          return Ce.focus(A);
        },
        isEqual: z && z.isEqual || Yx,
        lastFieldState: void 0,
        modified: !1,
        modifiedSinceLastSubmit: !1,
        name: A,
        touched: !1,
        valid: !0,
        validateFields: z && z.validateFields,
        validators: {},
        validating: !1,
        visited: !1
      });
      var me = !1, Ie = z && z.silent, ve = function() {
        Ie ? we(A) : (re(), we());
      };
      if (z) {
        me = !!(z.getValidator && z.getValidator()), z.getValidator && (k.fields[A].validators[te] = z.getValidator);
        var Ne = ht(k.formState.values, A) === void 0;
        z.initialValue !== void 0 && (Ne || ht(k.formState.values, A) === ht(k.formState.initialValues, A)) && (k.formState.initialValues = sn(k.formState.initialValues || {}, A, z.initialValue), k.formState.values = sn(k.formState.values, A, z.initialValue), ke(void 0, ve)), z.defaultValue !== void 0 && z.initialValue === void 0 && ht(k.formState.initialValues, A) === void 0 && Ne && (k.formState.values = sn(k.formState.values, A, z.defaultValue));
      }
      return me ? ke(void 0, ve) : ve(), function() {
        var fe = !1;
        k.fields[A] && (fe = !!(k.fields[A].validators[te] && k.fields[A].validators[te]()), delete k.fields[A].validators[te]);
        var ae = !!k.fieldSubscribers[A];
        ae && delete k.fieldSubscribers[A].entries[te];
        var ct = ae && !Object.keys(k.fieldSubscribers[A].entries).length;
        ct && (delete k.fieldSubscribers[A], delete k.fields[A], fe && (k.formState.errors = sn(k.formState.errors, A, void 0) || {}), c && (k.formState.values = sn(k.formState.values, A, void 0, !0) || {})), Ie || (fe ? ke(void 0, function() {
          re(), we();
        }) : ct && re());
      };
    },
    reset: function(A) {
      A === void 0 && (A = k.formState.initialValues), k.formState.submitting && (k.formState.resetWhileSubmitting = !0), k.formState.submitFailed = !1, k.formState.submitSucceeded = !1, delete k.formState.submitError, delete k.formState.submitErrors, delete k.formState.lastSubmittedValues, Ce.initialize(A || {});
    },
    resetFieldState: function(A) {
      k.fields[A] = Tt({}, k.fields[A], {
        active: !1,
        lastFieldState: void 0,
        modified: !1,
        touched: !1,
        valid: !0,
        validating: !1,
        visited: !1
      }), ke(void 0, function() {
        we(), re();
      });
    },
    restart: function(A) {
      A === void 0 && (A = k.formState.initialValues), Ce.batch(function() {
        for (var M in k.fields)
          Ce.resetFieldState(M), k.fields[M] = Tt({}, k.fields[M], {
            active: !1,
            lastFieldState: void 0,
            modified: !1,
            modifiedSinceLastSubmit: !1,
            touched: !1,
            valid: !0,
            validating: !1,
            visited: !1
          });
        Ce.reset(A);
      });
    },
    resumeValidation: function() {
      R = !1, J = !1, $ && ke(void 0, function() {
        we(), re();
      }), $ = !1;
    },
    setConfig: function(A, M) {
      switch (A) {
        case "debug":
          r = M;
          break;
        case "destroyOnUnregister":
          c = M;
          break;
        case "initialValues":
          Ce.initialize(M);
          break;
        case "keepDirtyOnReinitialize":
          u = M;
          break;
        case "mutators":
          h = M, M ? (Object.keys(se).forEach(function(Q) {
            Q in M || delete se[Q];
          }), Object.keys(M).forEach(function(Q) {
            se[Q] = ne(Q);
          })) : Object.keys(se).forEach(function(Q) {
            delete se[Q];
          });
          break;
        case "onSubmit":
          v = M;
          break;
        case "validate":
          w = M, ke(void 0, function() {
            we(), re();
          });
          break;
        case "validateOnBlur":
          x = M;
          break;
        default:
          throw new Error("Unrecognised option " + A);
      }
    },
    submit: function() {
      var A = k.formState;
      if (!A.submitting) {
        if (delete A.submitErrors, delete A.submitError, A.lastSubmittedValues = Tt({}, A.values), _()) {
          F(), Ee(), k.formState.submitFailed = !0, re(), we();
          return;
        }
        var M = Object.keys(H);
        if (M.length) {
          Promise.all(M.map(function(ve) {
            return H[Number(ve)];
          })).then(Ce.submit, console.error);
          return;
        }
        var Q = Te();
        if (!Q) {
          var z, te = !1, me = function(Ne) {
            A.submitting = !1;
            var fe = A.resetWhileSubmitting;
            return fe && (A.resetWhileSubmitting = !1), Ne && Ji(Ne) ? (A.submitFailed = !0, A.submitSucceeded = !1, A.submitErrors = Ne, A.submitError = Ne[hl], F()) : (fe || (A.submitFailed = !1, A.submitSucceeded = !0), Me()), re(), we(), te = !0, z && z(Ne), Ne;
          };
          A.submitting = !0, A.submitFailed = !1, A.submitSucceeded = !1, A.lastSubmittedValues = Tt({}, A.values), Ee();
          var Ie = v(A.values, Ce, me);
          if (!te) {
            if (Ie && Xa(Ie))
              return re(), we(), Ie.then(me, function(ve) {
                throw me(), ve;
              });
            if (v.length >= 3)
              return re(), we(), new Promise(function(ve) {
                z = ve;
              });
            me(Ie);
          }
        }
      }
    },
    subscribe: function(A, M) {
      if (!A)
        throw new Error("No callback given.");
      if (!M)
        throw new Error("No subscription provided. What values do you want to listen to?");
      var Q = Vf(A), z = k.subscribers, te = z.index++;
      z.entries[te] = {
        subscriber: Q,
        subscription: M,
        notified: !1
      };
      var me = E();
      return wp(Q, M, me, me, Bf, !0), function() {
        delete z.entries[te];
      };
    }
  };
  return Ce;
}
const Zx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARRAY_ERROR: tr,
  FORM_ERROR: hl,
  configOptions: Wx,
  createForm: Gx,
  fieldSubscriptionItems: vp,
  formSubscriptionItems: _p,
  getIn: ht,
  setIn: sn,
  version: Hx
}, Symbol.toStringTag, { value: "Module" })), Kx = /* @__PURE__ */ up(Zx);
(function(a, r) {
  (function(c, u) {
    u(r, Kx);
  })(An, function(c, u) {
    /*!
     * nano-assign v1.0.0
     * (c) 2017-present egoist <0x142857@gmail.com>
     * Released under the MIT License.
     */
    var p = function(H) {
      for (var W = arguments, Z = 1; Z < arguments.length; Z++)
        for (var ee in arguments[Z])
          H[ee] = W[Z][ee];
      return H;
    }, h = p, v = function(W) {
      return Array.isArray(W) ? W : [W];
    }, w = function(W) {
      for (var Z = arguments.length, ee = new Array(Z > 1 ? Z - 1 : 0), ne = 1; ne < Z; ne++)
        ee[ne - 1] = arguments[ne];
      return W.reduce(function(se, pe) {
        return se || pe.apply(void 0, ee);
      }, void 0);
    }, x = function(W) {
      return function() {
        for (var Z = arguments.length, ee = new Array(Z), ne = 0; ne < Z; ne++)
          ee[ne] = arguments[ne];
        return w.apply(void 0, [W].concat(ee));
      };
    }, k = function(W) {
      return function() {
        return function() {
          for (var Z = arguments.length, ee = new Array(Z), ne = 0; ne < Z; ne++)
            ee[ne] = arguments[ne];
          return w.apply(void 0, [W].concat(ee));
        };
      };
    }, P = u.formSubscriptionItems.reduce(function(H, W) {
      return H[W] = !0, H;
    }, {}), R = {
      name: "final-form",
      props: {
        initialValues: Object,
        submit: {
          type: Function,
          default: function() {
          }
        },
        subscription: Object,
        validate: [Function, Array]
      },
      provide: function() {
        return {
          finalForm: this.finalForm
        };
      },
      data: function() {
        return {
          finalForm: u.createForm({
            onSubmit: this.submit,
            initialValues: this.initialValues,
            validate: Array.isArray(this.validate) ? x(this.validate) : this.validate
          }),
          formState: null
        };
      },
      methods: {
        handleSubmit: function(W) {
          W && W.preventDefault(), this.finalForm.submit();
        }
      },
      created: function() {
        var W = this;
        this.unsubscribe = this.finalForm.subscribe(function(Z) {
          W.formState = Z, W.$emit("change", Z);
        }, this.subscription || P);
      },
      beforeDestroy: function() {
        this.unsubscribe();
      },
      render: function(W) {
        var Z = this.$scopedSlots.default ? this.$scopedSlots.default(h({}, this.formState, {
          handleSubmit: this.handleSubmit,
          mutators: this.finalForm.mutators,
          batch: this.finalForm.batch,
          blur: this.finalForm.blur,
          change: this.finalForm.change,
          focus: this.finalForm.focus,
          initialize: this.finalForm.initialize,
          reset: this.finalForm.reset
        })) : this.$slots.default;
        return W("div", null, v(Z));
      }
    };
    function $(H, W) {
      if (H == null)
        return {};
      var Z = {}, ee = Object.keys(H), ne, se;
      for (se = 0; se < ee.length; se++)
        ne = ee[se], !(W.indexOf(ne) >= 0) && (Z[ne] = H[ne]);
      return Z;
    }
    function J(H, W) {
      if (H == null)
        return {};
      var Z = $(H, W), ee, ne;
      if (Object.getOwnPropertySymbols) {
        var se = Object.getOwnPropertySymbols(H);
        for (ne = 0; ne < se.length; ne++)
          ee = se[ne], !(W.indexOf(ee) >= 0) && (!Object.prototype.propertyIsEnumerable.call(H, ee) || (Z[ee] = H[ee]));
      }
      return Z;
    }
    var X = {
      name: "final-field",
      inject: ["finalForm"],
      props: {
        name: {
          required: !0,
          type: String
        },
        validate: [Function, Array],
        subscription: Object
      },
      data: function() {
        return {
          fieldState: {}
        };
      },
      created: function() {
        var W = this, Z = this.subscription || u.fieldSubscriptionItems.reduce(function(ee, ne) {
          return ee[ne] = !0, ee;
        }, {});
        this.unsubscribe = this.finalForm.registerField(this.name, function(ee) {
          W.fieldState = ee, W.$emit("change", ee);
        }, Z, {
          getValidator: Array.isArray(this.validate) ? k(this.validate) : function() {
            return W.validate;
          }
        });
      },
      beforeDestroy: function() {
        this.unsubscribe();
      },
      computed: {
        fieldEvents: function() {
          var W = this;
          return {
            input: function(ee) {
              return W.fieldState.change(ee.target.value);
            },
            blur: function() {
              return W.fieldState.blur();
            },
            focus: function() {
              return W.fieldState.focus();
            }
          };
        }
      },
      render: function() {
        var W = this.fieldState;
        W.blur;
        var Z = W.change;
        W.focus;
        var ee = W.value, ne = W.name, se = J(W, ["blur", "change", "focus", "value", "name"]), pe = this.$scopedSlots.default({
          events: this.fieldEvents,
          change: Z,
          value: ee,
          name: ne,
          meta: se
        });
        return v(pe)[0];
      }
    };
    typeof window < "u" && window.Vue && (window.Vue.component(R.name, R), window.Vue.component(X.name, X)), c.FinalForm = R, c.FinalField = X, Object.defineProperty(c, "__esModule", { value: !0 });
  });
})(cn, cn.exports);
const Xx = {
  components: {
    SType: Rt
  },
  props: {
    error: {
      type: Boolean,
      default: !1
    }
  }
};
var Qx = function() {
  var r = this, c = r._self._c;
  return c("SType", { class: ["helper", { "helper-error": r.error === !0 }], attrs: { variant: "helper", prominence: "sm" } }, [r._t("default")], 2);
}, Jx = [], eS = /* @__PURE__ */ he(
  Xx,
  Qx,
  Jx,
  !1,
  null,
  "c420bbfd",
  null,
  null
);
const nr = eS.exports;
const tS = {
  name: "LoadingSpinner",
  props: {
    color: {
      type: String,
      default: "#333"
    },
    size: {
      type: String,
      default: "lg"
    }
  }
};
var nS = function() {
  var r = this, c = r._self._c;
  return c("div", { class: `loading loading-${r.size}`, style: { color: r.color }, attrs: { "aria-label": "Content is Loading" } }, [c("span"), c("span"), c("span")]);
}, iS = [], rS = /* @__PURE__ */ he(
  tS,
  nS,
  iS,
  !1,
  null,
  "0277b5f8",
  null,
  null
);
const oS = rS.exports;
const sS = {
  name: "LoadingCircular",
  props: {
    percent: {
      type: Number,
      default: null
    },
    size: {
      type: Number,
      default: 36
    }
  },
  data() {
    return {
      progressRadius: 18
    };
  },
  computed: {
    circumference() {
      return this.progressRadius * 2 * Math.PI;
    },
    percentDash() {
      return `${this.circumference} ${this.circumference}`;
    },
    percentDashOffset() {
      if (!this.percent)
        return "";
      const a = this.circumference - this.percent / 100 * this.circumference;
      return this.percent > 0 ? a : this.circumference;
    },
    percentDashOffsetSpin() {
      return this.circumference - 33 / 100 * this.circumference;
    }
  }
};
var aS = function() {
  var r = this, c = r._self._c;
  return c("svg", { class: { "circular-loader": !0, spinning: !r.percent && r.percent !== 0 }, attrs: { viewBox: "0 0 40 40", height: r.size, width: r.size } }, [c("circle", { staticClass: "circular-loader_bg", attrs: { cx: "20", cy: "20", r: r.progressRadius, fill: "none", "stroke-width": "4" } }), r.percent > 0 ? c("circle", { staticClass: "circular-loader_fg", attrs: { "stroke-dasharray": r.percentDash, "stroke-dashoffset": r.percentDashOffset, r: r.progressRadius, cx: "20", cy: "20", fill: "transparent", "stroke-width": "4" } }) : r.percent !== 0 ? c("circle", { staticClass: "circular-loader_fg", attrs: { "stroke-dasharray": r.percentDash, "stroke-dashoffset": r.percentDashOffsetSpin, r: r.progressRadius, cx: "20", cy: "20", fill: "transparent", "stroke-width": "4" } }) : r._e()]);
}, lS = [], cS = /* @__PURE__ */ he(
  sS,
  aS,
  lS,
  !1,
  null,
  "110c938f",
  null,
  null
);
const uS = cS.exports;
const dS = {
  components: {
    Artwork: kl,
    LogoImage: dp
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    podcast: {
      type: Object,
      default: null
    },
    transparent: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    imageUrl() {
      return !this.podcast || !this.podcast.image_url ? null : this.podcast.image_url;
    }
  }
};
var hS = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "podcast-artwork" }, [c("artwork", { class: { "transparent-image": r.transparent }, attrs: { "image-url": r.imageUrl, loading: r.loading } }, [r.imageUrl ? r._e() : c("logo-image", { staticClass: "podcast-artwork-default" })], 1)], 1);
}, fS = [], pS = /* @__PURE__ */ he(
  dS,
  hS,
  fS,
  !1,
  null,
  null,
  null,
  null
);
const yp = pS.exports;
const mS = {
  name: "ListGroupItem",
  components: {
    PodcastArtwork: yp,
    IconCheck: Fr,
    IconLock: wl,
    SType: Rt
  },
  props: {
    to: {
      type: Object,
      required: !1
    },
    href: {
      type: String,
      required: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    selected: {
      type: Boolean,
      default: !1
    },
    locked: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: "",
      required: !0
    },
    image: {
      type: Object,
      required: !1
    },
    icon: {
      type: Function,
      required: !1
    },
    events: {
      type: Function | Object,
      required: !1
    }
  },
  computed: {
    isRouterLink() {
      return !!this.to;
    },
    component() {
      return this.isRouterLink && !this.disabled ? "router-link" : this.href && !this.disabled ? "a" : (this.isRouterLink || this.href) && this.disabled ? "span" : "button";
    },
    hasArwork() {
      return !!(this.locked || this.icon || this.image);
    }
  }
};
var gS = function() {
  var r = this, c = r._self._c;
  return c("li", { staticClass: "list-group-item__wrapper" }, [c(r.component, r._g({ tag: "component", class: [
    "list-group-item",
    {
      "list-group-item__disabled": r.disabled,
      "list-group-item__selected": r.selected
    }
  ], attrs: { disabled: r.disabled, href: r.disabled ? void 0 : r.href, to: r.disabled ? void 0 : r.to, target: r.href ? "_blank" : void 0 } }, r.events ? r.events : r.$listeners), [r.locked ? c("IconLock", { attrs: { size: "sm" } }) : r._e(), r.icon ? c(r.icon, { tag: "component" }) : r._e(), r.image ? c("PodcastArtwork", { staticClass: "list-group-item__artwork", attrs: { podcast: r.image } }) : r._e(), r.label ? c("SType", { class: [
    "list-group-item__label",
    { "list-group-item__label-has-artwork": r.hasArwork }
  ], attrs: { gutterBottom: !1, variant: "body", tag: "span" } }, [r._v(" " + r._s(r.label) + " ")]) : r._e(), r.selected ? c("IconCheck", { attrs: { titleAccess: "Selected" } }) : r._e()], 1)], 1);
}, vS = [], bS = /* @__PURE__ */ he(
  mS,
  gS,
  vS,
  !1,
  null,
  "61b2ed71",
  null,
  null
);
const kp = bS.exports;
const _S = {
  name: "ListGroup",
  components: {
    ListGroupItem: kp
  },
  props: {
    listItems: {
      type: Array,
      default: null
    }
  }
};
var wS = function() {
  var r = this, c = r._self._c;
  return c("ul", { staticClass: "list-group" }, [r.listItems ? r._l(r.listItems, function(u) {
    return c("ListGroupItem", r._b({ key: `list-item-${u.label}` }, "ListGroupItem", u, !1));
  }) : r._t("default")], 2);
}, yS = [], kS = /* @__PURE__ */ he(
  _S,
  wS,
  yS,
  !1,
  null,
  "f0f1cdb9",
  null,
  null
);
const xp = kS.exports;
const xS = {
  name: "QuickMenu",
  components: {
    Dropdown: mp,
    IconOptions: u0,
    ListGroup: xp
  },
  props: {
    width: {
      type: String,
      default: "148px"
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    position: {
      type: String,
      default: "left",
      validator: (a) => ["left", "right"].includes(a)
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
};
var SS = function() {
  var r = this, c = r._self._c;
  return c("Dropdown", { class: ["quick-menu", { "quick-menu_disabled": r.disabled }], attrs: { "has-carot": !1, "open-on-hover": !1, "dropdown-width": r.width, position: r.position, "dropdown-padding": !1, disabled: r.disabled } }, [c("template", { slot: "button" }, [c("IconOptions", { attrs: { titleAccess: "Menu" } })], 1), r.menuItems ? c("template", { slot: "content" }, [c("ListGroup", { attrs: { listItems: r.menuItems } })], 1) : r._e()], 2);
}, CS = [], AS = /* @__PURE__ */ he(
  xS,
  SS,
  CS,
  !1,
  null,
  "a9fc6a80",
  null,
  null
);
const TS = AS.exports;
const IS = {
  name: "CustomAudio",
  components: {
    Badge: Di,
    IconAudio: rp,
    IconPause: sp,
    IconPlay: y0,
    IconUpload: os,
    LoadingSpinner: oS,
    LoadingCircular: uS,
    QuickMenu: TS
  },
  props: {
    accept: {
      type: String,
      default: ".mp3,.wav,.m4a,audio/*"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    download: {
      type: Boolean,
      default: !1
    },
    draft: {
      type: Boolean,
      default: !1
    },
    file: {
      type: Object,
      default: () => {
      }
    },
    fileStatus: {
      type: Object,
      default: () => ({
        message: !1,
        percent: 0,
        status: !1
      })
    },
    name: {
      type: String,
      default: ""
    },
    preview: {
      type: Object,
      default: null
    },
    showPreview: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Object | File,
      default: () => ({ value: "" })
    },
    phrases: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      audio: {
        currentTime: 0,
        isPlaying: !1,
        loaded: 0
      },
      fileData: this.value,
      left: 0,
      size: 0,
      width: 0,
      progressRadius: 18
    };
  },
  computed: {
    isoCurrent() {
      return !this.audio || !this.audio.currentTime ? "00:00" : Wo.iso(this.audio.currentTime);
    },
    isoTotal() {
      return !this.preview || !this.preview.duration ? "00:00" : Wo.iso(this.preview.duration);
    },
    isProcessing() {
      return this.fileStatus && this.fileStatus.status === "processing";
    },
    isProcessingPercent() {
      return this.isProcessing && this.uploadPercent !== null && this.uploadPercent > -1;
    },
    isUploading() {
      return this.fileStatus && this.fileStatus.status === "uploading";
    },
    isPlayable() {
      return this.showPreview && this.preview && this.preview.enclosure_url;
    },
    actionsMenu() {
      let a = [];
      return this.download && a.push({
        label: "Download",
        icon: Gk,
        href: this.preview.enclosure_url
      }), a.push({
        label: "Delete",
        icon: O0,
        events: { click: this.removeFile },
        disabled: this.disabled
      }), a;
    },
    showTimestamps() {
      return this.showPreview && this.fileData && this.fileData.name && this.preview && this.preview.enclosure_url;
    },
    uploadPercent() {
      return (this.isUploading || this.isProcessing) && this.fileStatus.percent > -1 ? this.fileStatus.percent : null;
    },
    uploadStyle() {
      return this.isUploading ? { width: `${this.fileStatus.percent > 0 ? this.fileStatus.percent : 0}%` } : !1;
    },
    widthTime() {
      return !this.audio || !this.preview ? 0 : Math.floor(
        this.audio.currentTime / this.preview.duration * this.width
      );
    }
  },
  watch: {
    "preview.waveform_pack"(a) {
      a || (this.audio.currentTime = 0, this.$refs.audio && (this.$refs.audio.currentTime = 0));
    },
    value(a) {
      a ? a.name && (this.fileData = a) : this.fileData = !1;
    }
  },
  mounted() {
    window.addEventListener("resize", this.resize), this.size = this.$el.clientWidth || 1e3, this.setWidth();
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    attachListeners() {
      document.addEventListener("mousemove", this.move), document.addEventListener("touchmove", this.move), document.addEventListener("mouseup", this.stop), document.addEventListener("touchend", this.stop);
    },
    audioLoadedData() {
      this.$refs.audio_player.currentTime = this.audio.currentTime;
    },
    audioPause() {
      this.audio.isPlaying && this.audioToggle();
    },
    audioPlay() {
      this.audio.isPlaying || this.audioToggle();
    },
    audioTimeUpdate() {
      this.audio.currentTime = this.$refs.audio_player.currentTime;
    },
    audioToggle() {
      this.audio.isPlaying = !this.audio.isPlaying, this.audio.isPlaying ? (this.$refs.audio_player.currentTime = this.audio.currentTime, this.$refs.audio_player.play()) : this.$refs.audio_player.pause();
    },
    detachListeners() {
      document.removeEventListener("mousemove", this.move), document.removeEventListener("touchmove", this.move), document.removeEventListener("mouseup", this.stop), document.removeEventListener("touchend", this.stop);
    },
    fileClick() {
      if (this.isProcessing || this.isUploading || this.audio.isPlaying)
        return !1;
      this.$refs.audio.click();
    },
    formatFileSizeForDisplay(a) {
      return a ? a >= 1e6 ? `${(a * 1e-6).toFixed(2)}MB` : `${(a * 1e-3).toFixed(2)}KB` : "";
    },
    getOffset(a) {
      return Math.min(1, Math.max((a - this.left) / this.width, 0));
    },
    getTouchPageX(a) {
      return a.touches[0] && a.touches[0].pageX ? a.touches[0].pageX : null;
    },
    move(a) {
      this.setOffset(a.pageX || this.getTouchPageX(a));
    },
    setFileInfo(a) {
      if (this.isProcessing || this.isUploading || this.disabled)
        return !1;
      const r = a.target.files ? a.target.files[0] : a.dataTransfer.files[0];
      if (!!r) {
        if (!r.type || !r.type.startsWith("audio/")) {
          alert("Audio files only");
          return;
        }
        this.fileData = r, this.$emit("input", { target: { value: this.fileData } });
      }
    },
    removeFile() {
      if (this.isProcessing || this.isUploading || this.disabled)
        return !1;
      this.$refs.audio.value = null, this.audio.currentTime = 0, this.$refs.audio_player && (this.$refs.audio_player.pause(), this.$refs.audio_player.currentTime = 0), this.fileData = null, this.$emit("input", { target: { value: this.fileData } });
    },
    resize() {
      this.size = this.$el.clientWidth, this.setWidth();
    },
    setBounds() {
      if (!this.$refs.scrubber)
        return;
      const a = this.$refs.scrubber.getBoundingClientRect(), r = window.pageXOffset;
      this.left = a.left + r;
    },
    setWidth() {
      !this.$refs.scrubber || (this.width = this.$refs.scrubber.getBoundingClientRect().width);
    },
    setOffset(a) {
      const r = this.getOffset(a);
      this.audio.currentTime = r * this.preview.duration, this.$refs.audio_player.currentTime = this.audio.currentTime;
    },
    start(a) {
      !this.isPlayable || (this.attachListeners(), this.setBounds(a), this.setOffset(a.pageX || this.getTouchPageX(a)));
    },
    stop() {
      !this.isPlayable || this.detachListeners();
    },
    getAudioInfo() {
      let a = "";
      if (this.fileData.size && (a += this.formatFileSizeForDisplay(this.fileData.size)), this.preview && this.preview.duration) {
        const r = this.preview.duration < 60 ? `${this.preview.duration} seconds` : Wo.iso(this.preview.duration);
        a += a ? ` - ${r}` : r;
      }
      return a;
    },
    phrase(a) {
      return this.phrases[a] || a;
    }
  }
};
var ES = function() {
  var r = this, c = r._self._c;
  return c("div", { class: ["form-input-audio"] }, [c("input", { ref: "audio", attrs: { id: `form-input-${r.name}`, accept: r.accept, disabled: r.disabled, type: "file" }, on: { change: r.setFileInfo } }), !r.fileData || !r.fileData.name ? c("div", { class: {
    disabled: r.disabled,
    dropzone: !0,
    isProcessing: r.isProcessing,
    isUploading: r.isUploading,
    hasFile: r.fileData && r.fileData.name
  }, on: { dragover: function(u) {
    u.preventDefault();
  }, drop: function(u) {
    return u.preventDefault(), r.setFileInfo.apply(null, arguments);
  }, click: r.fileClick } }, [c("IconUpload", { staticClass: "audio-svg-cloud" }), c("div", { staticClass: "drag-n-drop" }, [r._v(" " + r._s(r.phrase("Drag and drop an audio file")) + " " + r._s(r.phrase("or")) + " "), c("span", { staticClass: "browse" }, [r._v(r._s(r.phrase("Browse")))])])], 1) : c("div", { class: {
    disabled: r.disabled,
    dropzone: !0,
    showPreview: r.showPreview,
    isProcessing: r.isProcessing,
    isUploading: r.isUploading,
    hasFile: r.fileData && r.fileData.name
  } }, [r.showPreview && !r.isUploading ? c("button", { staticClass: "play-pause", attrs: { disabled: !r.preview || !r.preview.enclosure_url }, on: { click: function(u) {
    return u.preventDefault(), u.stopPropagation(), r.audioToggle.apply(null, arguments);
  } } }, [r.audio.isPlaying ? c("IconPause", { attrs: { size: "xl" } }) : c("IconPlay", { attrs: { size: "xl" } })], 1) : r.isUploading ? c("loading-circular", { attrs: { percent: r.uploadPercent, size: 32 } }) : c("IconAudio", { staticClass: "audio-svg-bars" }), c("div", { staticClass: "filename" }, [c("div", [r._v(r._s(r.fileData.name))]), r.getAudioInfo() ? c("div", { staticClass: "filename-info" }, [r._v(" " + r._s(r.getAudioInfo()) + " ")]) : r._e()]), r.isUploading || r.isProcessing ? c("div", { class: r.fileStatus.status }, [c("div", { staticClass: "status-message-wrap" }, [r.isProcessing && r.uploadPercent === 0 ? c("div", { staticClass: "status-message" }, [r._v(" " + r._s(r.phrase("Preparing audio file")) + " ")]) : c("div", { staticClass: "status-message" }, [r.isProcessing && !r.isProcessingPercent ? c("loading-spinner", { attrs: { size: "sm" } }) : r._e(), r._v(" " + r._s(r.fileStatus.message) + " ")], 1), r.uploadPercent ? c("div", { staticClass: "status-percent" }, [r._v(" " + r._s(r.uploadPercent) + "% ")]) : r._e()])]) : r._e(), c("div", { staticClass: "content-right" }, [r.draft ? c("Badge", { attrs: { variant: "warning" } }, [r._v(" Draft ")]) : r._e(), r._t("custom")], 2), c("div", { staticClass: "remove" }, [r.actionsMenu.length > 0 ? c("QuickMenu", { attrs: { disabled: r.isUploading || r.isProcessing, menuItems: r.actionsMenu, position: "right" } }) : r._e()], 1)], 1), r.showTimestamps ? c("div", { staticClass: "timestamps" }, [c("div", [r._v(r._s(r.isoCurrent))]), c("div", [r._v(r._s(r.isoTotal))])]) : r._e(), c("div", { ref: "scrubber", class: [
    "progress-wrap",
    {
      hasFile: r.fileData && r.fileData.name && !r.isUploading,
      isFinished: r.preview && r.preview.enclosure_url,
      isPlayable: r.isPlayable,
      isProcessing: r.isProcessing
    }
  ], on: { mousedown: function(u) {
    return u.preventDefault(), r.start.apply(null, arguments);
  }, mouseup: function(u) {
    return u.preventDefault(), r.stop.apply(null, arguments);
  }, touchstart: function(u) {
    return u.preventDefault(), r.start.apply(null, arguments);
  }, touchend: function(u) {
    return u.preventDefault(), r.stop.apply(null, arguments);
  } } }, [c("div", { staticClass: "progress-time", style: {
    width: r.isProcessing ? `${r.uploadPercent}%` : `${r.widthTime}px`
  } })]), r.showPreview && r.preview && r.preview.enclosure_url ? c("audio", { ref: "audio_player", staticClass: "audio", attrs: { preload: "none", src: r.preview.enclosure_url }, on: { loadeddata: r.audioLoadedData, pause: r.audioPause, play: r.audioPlay, timeupdate: r.audioTimeUpdate } }) : r._e()]);
}, PS = [], MS = /* @__PURE__ */ he(
  IS,
  ES,
  PS,
  !1,
  null,
  "6d362661",
  null,
  null
);
const OS = MS.exports, DS = {
  components: { CustomAudio: OS, FinalField: cn.exports.FinalField, HelperText: nr },
  props: {
    fileStatus: {
      type: Object,
      default: () => ({
        message: !1,
        percent: 0,
        status: !1
      })
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    download: {
      type: Boolean,
      default: !1
    },
    draft: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    preview: {
      type: Object,
      default: null
    },
    showPreview: {
      type: Boolean,
      default: !1
    },
    validate: {
      type: Function,
      default: null
    },
    phrases: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var NS = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { "file-status": r.fileStatus, name: r.name, validate: r.validate }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("CustomAudio", r._g({ class: { error: u.meta.touched && u.meta.error }, attrs: { disabled: r.disabled, draft: r.draft, download: r.download, preview: r.preview, name: u.name, value: u.value, "file-status": r.fileStatus, "show-preview": r.showPreview, phrases: r.phrases }, on: { blur: r.blur, focus: r.focus, input: r.input } }, u.events), [c("template", { slot: "custom" }, [r._t("custom")], 2)], 2), u.meta.touched && u.meta.error ? c("HelperText", { attrs: { error: !0 } }, [r._v(" " + r._s(u.meta.error) + " ")]) : r._e()], 1);
  } }], null, !0) });
}, RS = [], LS = /* @__PURE__ */ he(
  DS,
  NS,
  RS,
  !1,
  null,
  null,
  null,
  null
);
const qP = LS.exports;
const FS = {
  name: "Tooltip",
  components: { IconInfo: op, SType: Rt },
  props: {
    id: {
      type: String,
      required: !0,
      default: ""
    },
    position: {
      type: String,
      default: "bottom-start",
      validator: (a) => [
        "bottom-start",
        "bottom",
        "bottom-end",
        "top-start",
        "top",
        "top-end"
      ].includes(a)
    }
  },
  data() {
    return {
      tooltipOpen: !1,
      a11yId: `tooltip-desc-${this.id}`
    };
  },
  mounted() {
    this.a11yId = `tooltip-desc-${this.id}`;
  },
  methods: {
    openTooltip() {
      this.tooltipOpen = !0;
    },
    closeTooltip() {
      this.tooltipOpen = !1;
    },
    focus() {
      this.$refs.tooltip && this.$refs.tooltip.focus();
    }
  }
};
var zS = function() {
  var r = this, c = r._self._c;
  return c("span", { class: { tooltip: !0, "tooltip-icon": !r.$scopedSlots.element } }, [r.$scopedSlots.element ? c("span", { ref: "customTooltip" }, [r._t("element", null, { open: r.openTooltip, close: r.closeTooltip, id: r.a11yId })], 2) : c("button", { ref: "tooltip", staticClass: "tooltip-button", attrs: { "aria-describedby": r.a11yId, role: "button" }, on: { click: function(u) {
    return u.preventDefault(), u.stopPropagation(), r.focus.apply(null, arguments);
  }, focus: r.openTooltip, blur: r.closeTooltip } }, [c("IconInfo", { staticClass: "icon-info", attrs: { size: "sm", titleAccess: "" } }), c("span", { staticClass: "screenreader" }, [r._v("More Information")])], 1), c("transition", { attrs: { name: "fade" } }, [r.tooltipOpen ? c("SType", { class: r.position + " tooltip-text", attrs: { id: r.a11yId, "gutter-bottom": !1, variant: "helper", role: "tooltip" } }, [r._t("default")], 2) : r._e()], 1)], 1);
}, $S = [], jS = /* @__PURE__ */ he(
  FS,
  zS,
  $S,
  !1,
  null,
  null,
  null,
  null
);
const zr = jS.exports;
const BS = {
  components: { Tooltip: zr, SButton: bi, SType: Rt },
  props: {
    alt: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({})
    },
    isFinalForm: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      inputData: this.value
    };
  },
  watch: {
    value(a) {
      this.inputData = a;
    },
    "value.value"(a) {
      this.isFinalForm && this.$emit("input", { target: { value: a } });
    }
  },
  mounted() {
    !this.inputData.value && this.inputData.options && this.$set(this.inputData, "value", this.inputData.options[0].value);
  }
};
var VS = function() {
  var r = this, c = r._self._c;
  return c("div", { class: ["buttons-switch", { "buttons-switch-alt": r.alt }] }, [r._l(r.inputData.options, function(u, p) {
    return [u.tooltip ? [u.tooltip ? c("tooltip", { key: "v" + u.value, staticClass: "button-switch", attrs: { id: "v" + u.value, position: "bottom" }, scopedSlots: r._u([{ key: "element", fn: function(h) {
      return [u.disabled ? [c("SButton", { key: "l" + u.value, class: {
        "button-switch__button": !0,
        disabled: !0,
        first: p === 0,
        last: p === r.inputData.options.length - 1
      }, attrs: { block: !0, "aria-describedby": h.id, "disabled-style": !0, variant: "secondary" }, on: { focus: h.open, blur: h.close } }, [r._v(" " + r._s(u.label) + " ")])] : [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.inputData.value, expression: "inputData.value" }], key: "l" + u.value, staticClass: "button-switch__input", attrs: { id: r.name + u.value, name: r.name, type: "radio", tabindex: "0", "aria-describedby": h.id }, domProps: { value: u.value, checked: r._q(r.inputData.value, u.value) }, on: { focus: h.open, blur: h.close, change: function(v) {
        return r.$set(r.inputData, "value", u.value);
      } } }), c("SType", { key: "v" + u.value, class: {
        "button-switch__label": r.alt !== !0,
        first: p === 0,
        last: p === r.inputData.options.length - 1
      }, attrs: { for: r.name + u.value, "gutter-bottom": !1, tag: "label", variant: "subtitle" } }, [r._v(" " + r._s(u.label) + " ")])]];
    } }], null, !0) }, [c("span", { domProps: { innerHTML: r._s(u.tooltip) } })]) : r._e()] : c("span", { key: "l" + u.value, staticClass: "button-switch" }, [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.inputData.value, expression: "inputData.value" }], staticClass: "button-switch__input", attrs: { id: r.name + u.value, name: r.name, disabled: u.disabled, tabindex: "0", type: "radio" }, domProps: { value: u.value, checked: r._q(r.inputData.value, u.value) }, on: { change: function(h) {
      return r.$set(r.inputData, "value", u.value);
    } } }), c("SType", { key: "v" + u.value, class: {
      "button-switch__label": r.alt !== !0,
      first: p === 0,
      last: p === r.inputData.options.length - 1
    }, attrs: { for: r.name + u.value, "gutter-bottom": !1, variant: "subtitle", tag: "label" } }, [r._v(" " + r._s(u.label) + " ")])], 1)];
  })], 2);
}, US = [], HS = /* @__PURE__ */ he(
  BS,
  VS,
  US,
  !1,
  null,
  "c6ef9947",
  null,
  null
);
const WS = HS.exports, YS = {
  components: { FormButtonsSwitch: WS, FinalField: cn.exports.FinalField },
  props: {
    alt: {
      type: Boolean,
      default: !1
    },
    colors: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var qS = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("form-buttons-switch", r._g({ attrs: { value: { value: u.value, options: r.options }, name: u.name, colors: r.colors, alt: r.alt, isFinalForm: !0 }, on: { blur: r.blur, focus: r.focus, input: r.input } }, u.events))], 1);
  } }]) });
}, GS = [], ZS = /* @__PURE__ */ he(
  YS,
  qS,
  GS,
  !1,
  null,
  null,
  null,
  null
);
const GP = ZS.exports, KS = {
  components: { CustomCheckbox: wx, FinalField: cn.exports.FinalField, Tooltip: zr },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    pill: {
      type: Boolean,
      default: !1
    },
    toggle: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: null
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var XS = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("custom-checkbox", r._g({ attrs: { value: u.value, name: u.name, disabled: r.disabled, pill: r.pill, toggle: r.toggle }, on: { blur: r.blur, focus: r.focus, input: r.input } }, u.events), [c("span", { domProps: { innerHTML: r._s(r.label) } }), r.tooltip ? c("tooltip", { attrs: { id: `tooltip-${u.name}` } }, [r._v(r._s(r.tooltip))]) : r._e()], 1)], 1);
  } }]) });
}, QS = [], JS = /* @__PURE__ */ he(
  KS,
  XS,
  QS,
  !1,
  null,
  null,
  null,
  null
);
const ZP = JS.exports;
var Sp = { exports: {} };
(function(a, r) {
  (function(c, u) {
    a.exports = u();
  })(An, function() {
    var c = typeof window < "u" ? window : typeof An < "u" ? An : typeof self < "u" ? self : {};
    function u(F, _) {
      return _ = { exports: {} }, F(_, _.exports), _.exports;
    }
    var p = u(function(F, _) {
      (function(E, B) {
        F.exports = B();
      })(c, function() {
        function E(B, Y, N, re, Te, Me) {
          if (!/^[1-8]$/.test(Y))
            throw new Error("orientation should be [1-8]");
          N == null && (N = 0), re == null && (re = 0), Te == null && (Te = B.width), Me == null && (Me = B.height);
          var Ee = document.createElement("canvas"), Ce = Ee.getContext("2d");
          switch (Ee.width = Te, Ee.height = Me, Ce.save(), +Y) {
            case 1:
              break;
            case 2:
              Ce.translate(Te, 0), Ce.scale(-1, 1);
              break;
            case 3:
              Ce.translate(Te, Me), Ce.rotate(180 / 180 * Math.PI);
              break;
            case 4:
              Ce.translate(0, Me), Ce.scale(1, -1);
              break;
            case 5:
              Ee.width = Me, Ee.height = Te, Ce.rotate(90 / 180 * Math.PI), Ce.scale(1, -1);
              break;
            case 6:
              Ee.width = Me, Ee.height = Te, Ce.rotate(90 / 180 * Math.PI), Ce.translate(0, -Me);
              break;
            case 7:
              Ee.width = Me, Ee.height = Te, Ce.rotate(270 / 180 * Math.PI), Ce.translate(-Te, Me), Ce.scale(1, -1);
              break;
            case 8:
              Ee.width = Me, Ee.height = Te, Ce.translate(0, Te), Ce.rotate(270 / 180 * Math.PI);
              break;
          }
          return Ce.drawImage(B, N, re, Te, Me), Ce.restore(), Ee;
        }
        return {
          drawImage: E
        };
      });
    }), h = {
      onePointCoord: function(_, E) {
        var B = E.canvas, Y = E.quality, N = B.getBoundingClientRect(), re = _.clientX, Te = _.clientY;
        return {
          x: (re - N.left) * Y,
          y: (Te - N.top) * Y
        };
      },
      getPointerCoords: function(_, E) {
        var B = void 0;
        return _.touches && _.touches[0] ? B = _.touches[0] : _.changedTouches && _.changedTouches[0] ? B = _.changedTouches[0] : B = _, this.onePointCoord(B, E);
      },
      getPinchDistance: function(_, E) {
        var B = _.touches[0], Y = _.touches[1], N = this.onePointCoord(B, E), re = this.onePointCoord(Y, E);
        return Math.sqrt(Math.pow(N.x - re.x, 2) + Math.pow(N.y - re.y, 2));
      },
      getPinchCenterCoord: function(_, E) {
        var B = _.touches[0], Y = _.touches[1], N = this.onePointCoord(B, E), re = this.onePointCoord(Y, E);
        return {
          x: (N.x + re.x) / 2,
          y: (N.y + re.y) / 2
        };
      },
      imageLoaded: function(_) {
        return _.complete && _.naturalWidth !== 0;
      },
      rAFPolyfill: function() {
        if (!(typeof document > "u" || typeof window > "u")) {
          for (var _ = 0, E = ["webkit", "moz"], B = 0; B < E.length && !window.requestAnimationFrame; ++B)
            window.requestAnimationFrame = window[E[B] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[E[B] + "CancelAnimationFrame"] || window[E[B] + "CancelRequestAnimationFrame"];
          window.requestAnimationFrame || (window.requestAnimationFrame = function(Y) {
            var N = new Date().getTime(), re = Math.max(0, 16.7 - (N - _)), Te = window.setTimeout(function() {
              var Me = N + re;
              Y(Me);
            }, re);
            return _ = N + re, Te;
          }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(Y) {
            clearTimeout(Y);
          }), Array.isArray = function(Y) {
            return Object.prototype.toString.call(Y) === "[object Array]";
          };
        }
      },
      toBlobPolyfill: function() {
        if (!(typeof document > "u" || typeof window > "u" || !HTMLCanvasElement)) {
          var _, E, B;
          HTMLCanvasElement.prototype.toBlob || Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
            value: function(N, re, Te) {
              _ = atob(this.toDataURL(re, Te).split(",")[1]), E = _.length, B = new Uint8Array(E);
              for (var Me = 0; Me < E; Me++)
                B[Me] = _.charCodeAt(Me);
              N(new Blob([B], { type: re || "image/png" }));
            }
          });
        }
      },
      eventHasFile: function(_) {
        var E = _.dataTransfer || _.originalEvent.dataTransfer;
        if (E.types) {
          for (var B = 0, Y = E.types.length; B < Y; B++)
            if (E.types[B] == "Files")
              return !0;
        }
        return !1;
      },
      getFileOrientation: function(_) {
        var E = new DataView(_);
        if (E.getUint16(0, !1) != 65496)
          return -2;
        for (var B = E.byteLength, Y = 2; Y < B; ) {
          var N = E.getUint16(Y, !1);
          if (Y += 2, N == 65505) {
            if (E.getUint32(Y += 2, !1) != 1165519206)
              return -1;
            var re = E.getUint16(Y += 6, !1) == 18761;
            Y += E.getUint32(Y + 4, re);
            var Te = E.getUint16(Y, re);
            Y += 2;
            for (var Me = 0; Me < Te; Me++)
              if (E.getUint16(Y + Me * 12, re) == 274)
                return E.getUint16(Y + Me * 12 + 8, re);
          } else {
            if ((N & 65280) != 65280)
              break;
            Y += E.getUint16(Y, !1);
          }
        }
        return -1;
      },
      parseDataUrl: function(_) {
        var E = /^data:([^;]+)?(;base64)?,(.*)/gmi;
        return E.exec(_)[3];
      },
      base64ToArrayBuffer: function(_) {
        for (var E = atob(_), B = E.length, Y = new Uint8Array(B), N = 0; N < B; N++)
          Y[N] = E.charCodeAt(N);
        return Y.buffer;
      },
      getRotatedImage: function(_, E) {
        var B = p.drawImage(_, E), Y = new Image();
        return Y.src = B.toDataURL(), Y;
      },
      flipX: function(_) {
        return _ % 2 == 0 ? _ - 1 : _ + 1;
      },
      flipY: function(_) {
        var E = {
          1: 4,
          4: 1,
          2: 3,
          3: 2,
          5: 8,
          8: 5,
          6: 7,
          7: 6
        };
        return E[_];
      },
      rotate90: function(_) {
        var E = {
          1: 6,
          2: 7,
          3: 8,
          4: 5,
          5: 2,
          6: 3,
          7: 4,
          8: 1
        };
        return E[_];
      },
      numberValid: function(_) {
        return typeof _ == "number" && !isNaN(_);
      }
    };
    Number.isInteger = Number.isInteger || function(F) {
      return typeof F == "number" && isFinite(F) && Math.floor(F) === F;
    };
    var v = String;
    typeof window < "u" && window.Image && (v = [String, Image]);
    var w = {
      value: Object,
      width: {
        type: Number,
        default: 200,
        validator: function(_) {
          return _ > 0;
        }
      },
      height: {
        type: Number,
        default: 200,
        validator: function(_) {
          return _ > 0;
        }
      },
      placeholder: {
        type: String,
        default: "Choose an image"
      },
      placeholderColor: {
        default: "#606060"
      },
      placeholderFontSize: {
        type: Number,
        default: 0,
        validator: function(_) {
          return _ >= 0;
        }
      },
      canvasColor: {
        default: "transparent"
      },
      quality: {
        type: Number,
        default: 2,
        validator: function(_) {
          return _ > 0;
        }
      },
      zoomSpeed: {
        default: 3,
        type: Number,
        validator: function(_) {
          return _ > 0;
        }
      },
      accept: String,
      fileSizeLimit: {
        type: Number,
        default: 0,
        validator: function(_) {
          return _ >= 0;
        }
      },
      disabled: Boolean,
      disableDragAndDrop: Boolean,
      disableClickToChoose: Boolean,
      disableDragToMove: Boolean,
      disableScrollToZoom: Boolean,
      disablePinchToZoom: Boolean,
      disableRotation: Boolean,
      reverseScrollToZoom: Boolean,
      preventWhiteSpace: Boolean,
      showRemoveButton: {
        type: Boolean,
        default: !0
      },
      removeButtonColor: {
        type: String,
        default: "red"
      },
      removeButtonSize: {
        type: Number
      },
      initialImage: v,
      initialSize: {
        type: String,
        default: "cover",
        validator: function(_) {
          return _ === "cover" || _ === "contain" || _ === "natural";
        }
      },
      initialPosition: {
        type: String,
        default: "center",
        validator: function(_) {
          var E = ["center", "top", "bottom", "left", "right"];
          return _.split(" ").every(function(B) {
            return E.indexOf(B) >= 0;
          }) || /^-?\d+% -?\d+%$/.test(_);
        }
      },
      inputAttrs: Object,
      showLoading: Boolean,
      loadingSize: {
        type: Number,
        default: 20
      },
      loadingColor: {
        type: String,
        default: "#606060"
      },
      replaceDrop: Boolean,
      passive: Boolean,
      imageBorderRadius: {
        type: [Number, String],
        default: 0
      },
      autoSizing: Boolean,
      videoEnabled: Boolean
    }, x = {
      INIT_EVENT: "init",
      FILE_CHOOSE_EVENT: "file-choose",
      FILE_SIZE_EXCEED_EVENT: "file-size-exceed",
      FILE_TYPE_MISMATCH_EVENT: "file-type-mismatch",
      NEW_IMAGE_EVENT: "new-image",
      NEW_IMAGE_DRAWN_EVENT: "new-image-drawn",
      IMAGE_REMOVE_EVENT: "image-remove",
      MOVE_EVENT: "move",
      ZOOM_EVENT: "zoom",
      DRAW_EVENT: "draw",
      INITIAL_IMAGE_LOADED_EVENT: "initial-image-loaded",
      LOADING_START_EVENT: "loading-start",
      LOADING_END_EVENT: "loading-end"
    }, k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(F) {
      return typeof F;
    } : function(F) {
      return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
    }, P = 1 / 1e5, R = 500, $ = 100, J = 10, X = 2 / 3, H = 1, W = ["imgData", "img", "imgSet", "originalImage", "naturalHeight", "naturalWidth", "orientation", "scaleRatio"], Z = {
      render: function() {
        var _ = this, E = _.$createElement, B = _._self._c || E;
        return B("div", { ref: "wrapper", class: "croppa-container " + (_.img ? "croppa--has-target" : "") + " " + (_.passive ? "croppa--passive" : "") + " " + (_.disabled ? "croppa--disabled" : "") + " " + (_.disableClickToChoose ? "croppa--disabled-cc" : "") + " " + (_.disableDragToMove && _.disableScrollToZoom ? "croppa--disabled-mz" : "") + " " + (_.fileDraggedOver ? "croppa--dropzone" : ""), on: { dragenter: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handleDragEnter(N);
        }, dragleave: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handleDragLeave(N);
        }, dragover: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handleDragOver(N);
        }, drop: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handleDrop(N);
        } } }, [B("input", _._b({ ref: "fileInput", staticStyle: { height: "1px", width: "1px", overflow: "hidden", "margin-left": "-99999px", position: "absolute" }, attrs: { type: "file", accept: _.accept, disabled: _.disabled }, on: { change: _._handleInputChange } }, "input", _.inputAttrs, !1)), _._v(" "), B("div", { staticClass: "slots", staticStyle: { width: "0", height: "0", visibility: "hidden" } }, [_._t("initial"), _._v(" "), _._t("placeholder")], 2), _._v(" "), B("canvas", { ref: "canvas", on: { click: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handleClick(N);
        }, dblclick: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handleDblClick(N);
        }, touchstart: function(N) {
          return N.stopPropagation(), _._handlePointerStart(N);
        }, mousedown: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerStart(N);
        }, pointerstart: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerStart(N);
        }, touchend: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerEnd(N);
        }, touchcancel: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerEnd(N);
        }, mouseup: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerEnd(N);
        }, pointerend: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerEnd(N);
        }, pointercancel: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerEnd(N);
        }, touchmove: function(N) {
          return N.stopPropagation(), _._handlePointerMove(N);
        }, mousemove: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerMove(N);
        }, pointermove: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerMove(N);
        }, pointerleave: function(N) {
          return N.stopPropagation(), N.preventDefault(), _._handlePointerLeave(N);
        }, DOMMouseScroll: function(N) {
          return N.stopPropagation(), _._handleWheel(N);
        }, wheel: function(N) {
          return N.stopPropagation(), _._handleWheel(N);
        }, mousewheel: function(N) {
          return N.stopPropagation(), _._handleWheel(N);
        } } }), _._v(" "), _.showRemoveButton && _.img && !_.passive ? B("svg", { staticClass: "icon icon-remove", style: "top: -" + _.height / 40 + "px; right: -" + _.width / 40 + "px", attrs: { viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", width: _.removeButtonSize || _.width / 10, height: _.removeButtonSize || _.width / 10 }, on: { click: _.remove } }, [B("path", { attrs: { d: "M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z", fill: _.removeButtonColor } })]) : _._e(), _._v(" "), _.showLoading && _.loading ? B("div", { staticClass: "sk-fading-circle", style: _.loadingStyle }, _._l(12, function(Y) {
          return B("div", { key: Y, class: "sk-circle" + Y + " sk-circle" }, [B("div", { staticClass: "sk-circle-indicator", style: { backgroundColor: _.loadingColor } })]);
        })) : _._e(), _._v(" "), _._t("default")], 2);
      },
      staticRenderFns: [],
      model: {
        prop: "value",
        event: x.INIT_EVENT
      },
      props: w,
      data: function() {
        return {
          canvas: null,
          ctx: null,
          originalImage: null,
          img: null,
          video: null,
          dragging: !1,
          lastMovingCoord: null,
          imgData: {
            width: 0,
            height: 0,
            startX: 0,
            startY: 0
          },
          fileDraggedOver: !1,
          tabStart: 0,
          scrolling: !1,
          pinching: !1,
          rotating: !1,
          pinchDistance: 0,
          supportTouch: !1,
          pointerMoved: !1,
          pointerStartCoord: null,
          naturalWidth: 0,
          naturalHeight: 0,
          scaleRatio: null,
          orientation: 1,
          userMetadata: null,
          imageSet: !1,
          currentPointerCoord: null,
          currentIsInitial: !1,
          loading: !1,
          realWidth: 0,
          realHeight: 0,
          chosenFile: null,
          useAutoSizing: !1
        };
      },
      computed: {
        outputWidth: function() {
          var _ = this.useAutoSizing ? this.realWidth : this.width;
          return this.naturalWidth >= _ ? (this._setRealSize(), this.naturalWidth) : _ * this.quality;
        },
        outputHeight: function() {
          var _ = this.useAutoSizing ? this.realHeight : this.height, E = this.useAutoSizing ? this.realWidth : this.width;
          return this.naturalWidth >= E ? (this._setRealSize(), this.naturalWidth / this.width * this.height) : _ * this.quality;
        },
        computedPlaceholderFontSize: function() {
          return this.placeholderFontSize * this.quality;
        },
        aspectRatio: function() {
          return this.naturalWidth / this.naturalHeight;
        },
        loadingStyle: function() {
          return {
            width: this.loadingSize + "px",
            height: this.loadingSize + "px",
            right: "15px",
            bottom: "10px"
          };
        }
      },
      mounted: function() {
        var _ = this;
        this._initialize(), h.rAFPolyfill(), h.toBlobPolyfill();
        var E = this.supportDetection();
        E.basic || console.warn("Your browser does not support vue-croppa functionality."), this.passive && this.$watch("value._data", function(B) {
          var Y = !1;
          if (!!B) {
            for (var N in B)
              if (W.indexOf(N) >= 0) {
                var re = B[N];
                re !== _[N] && (_.$set(_, N, re), Y = !0);
              }
            Y && (_.img ? _.$nextTick(function() {
              _._draw();
            }) : _.remove());
          }
        }, {
          deep: !0
        }), this.useAutoSizing = !!(this.autoSizing && this.$refs.wrapper && getComputedStyle), this.useAutoSizing && this._autoSizingInit();
      },
      beforeDestroy: function() {
        this.useAutoSizing && this._autoSizingRemove();
      },
      watch: {
        outputWidth: function() {
          this.onDimensionChange();
        },
        outputHeight: function() {
          this.onDimensionChange();
        },
        canvasColor: function() {
          this.img ? this._draw() : this._setPlaceholders();
        },
        imageBorderRadius: function() {
          this.img && this._draw();
        },
        placeholder: function() {
          this.img || this._setPlaceholders();
        },
        placeholderColor: function() {
          this.img || this._setPlaceholders();
        },
        computedPlaceholderFontSize: function() {
          this.img || this._setPlaceholders();
        },
        preventWhiteSpace: function(_) {
          _ && (this.imageSet = !1), this._placeImage();
        },
        scaleRatio: function(_, E) {
          if (!this.passive && !!this.img && !!h.numberValid(_)) {
            var B = 1;
            h.numberValid(E) && E !== 0 && (B = _ / E);
            var Y = this.currentPointerCoord || {
              x: this.imgData.startX + this.imgData.width / 2,
              y: this.imgData.startY + this.imgData.height / 2
            };
            if (this.imgData.width = this.naturalWidth * _, this.imgData.height = this.naturalHeight * _, !this.userMetadata && this.imageSet && !this.rotating) {
              var N = (B - 1) * (Y.x - this.imgData.startX), re = (B - 1) * (Y.y - this.imgData.startY);
              this.imgData.startX = this.imgData.startX - N, this.imgData.startY = this.imgData.startY - re;
            }
            this.preventWhiteSpace && (this._preventZoomingToWhiteSpace(), this._preventMovingToWhiteSpace());
          }
        },
        "imgData.width": function(_, E) {
          !h.numberValid(_) || (this.scaleRatio = _ / this.naturalWidth, this.hasImage() && Math.abs(_ - E) > _ * (1 / 1e5) && (this.emitEvent(x.ZOOM_EVENT), this._draw()));
        },
        "imgData.height": function(_) {
          !h.numberValid(_) || (this.scaleRatio = _ / this.naturalHeight);
        },
        "imgData.startX": function(_) {
          this.hasImage() && this.$nextTick(this._draw);
        },
        "imgData.startY": function(_) {
          this.hasImage() && this.$nextTick(this._draw);
        },
        loading: function(_) {
          this.passive || (_ ? this.emitEvent(x.LOADING_START_EVENT) : this.emitEvent(x.LOADING_END_EVENT));
        },
        autoSizing: function(_) {
          this.useAutoSizing = !!(this.autoSizing && this.$refs.wrapper && getComputedStyle), _ ? this._autoSizingInit() : this._autoSizingRemove();
        }
      },
      methods: {
        emitEvent: function() {
          this.$emit.apply(this, arguments);
        },
        getCanvas: function() {
          return this.canvas;
        },
        getContext: function() {
          return this.ctx;
        },
        getChosenFile: function() {
          return this.chosenFile || this.$refs.fileInput.files[0];
        },
        move: function(_) {
          if (!(!_ || this.passive)) {
            var E = this.imgData.startX, B = this.imgData.startY;
            this.imgData.startX += _.x, this.imgData.startY += _.y, this.preventWhiteSpace && this._preventMovingToWhiteSpace(), (this.imgData.startX !== E || this.imgData.startY !== B) && (this.emitEvent(x.MOVE_EVENT), this._draw());
          }
        },
        moveUpwards: function() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
          this.move({ x: 0, y: -_ });
        },
        moveDownwards: function() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
          this.move({ x: 0, y: _ });
        },
        moveLeftwards: function() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
          this.move({ x: -_, y: 0 });
        },
        moveRightwards: function() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
          this.move({ x: _, y: 0 });
        },
        zoom: function() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
          if (!this.passive) {
            var B = this.zoomSpeed * E, Y = this.outputWidth * P * B, N = 1;
            _ ? N = 1 + Y : this.imgData.width > J && (N = 1 - Y), this.scaleRatio *= N;
          }
        },
        zoomIn: function() {
          this.zoom(!0);
        },
        zoomOut: function() {
          this.zoom(!1);
        },
        rotate: function() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
          this.disableRotation || this.disabled || this.passive || (_ = parseInt(_), (isNaN(_) || _ > 3 || _ < -3) && (console.warn("Invalid argument for rotate() method. It should one of the integers from -3 to 3."), _ = 1), this._rotateByStep(_));
        },
        flipX: function() {
          this.disableRotation || this.disabled || this.passive || this._setOrientation(2);
        },
        flipY: function() {
          this.disableRotation || this.disabled || this.passive || this._setOrientation(4);
        },
        refresh: function() {
          this.$nextTick(this._initialize);
        },
        hasImage: function() {
          return !!this.imageSet;
        },
        applyMetadata: function(_) {
          if (!(!_ || this.passive)) {
            this.userMetadata = _;
            var E = _.orientation || this.orientation || 1;
            this._setOrientation(E, !0);
          }
        },
        generateDataUrl: function(_, E) {
          return this.hasImage() ? this.canvas.toDataURL(_, E) : "";
        },
        generateBlob: function(_, E, B) {
          if (!this.hasImage()) {
            _(null);
            return;
          }
          this.canvas.toBlob(_, E, B);
        },
        promisedBlob: function() {
          for (var _ = this, E = arguments.length, B = Array(E), Y = 0; Y < E; Y++)
            B[Y] = arguments[Y];
          if (typeof Promise > "u") {
            console.warn("No Promise support. Please add Promise polyfill if you want to use this method.");
            return;
          }
          return new Promise(function(N, re) {
            try {
              _.generateBlob.apply(_, [function(Te) {
                N(Te);
              }].concat(B));
            } catch (Te) {
              re(Te);
            }
          });
        },
        getMetadata: function() {
          if (!this.hasImage())
            return {};
          var _ = this.imgData, E = _.startX, B = _.startY;
          return {
            startX: E,
            startY: B,
            scale: this.scaleRatio,
            orientation: this.orientation
          };
        },
        supportDetection: function() {
          if (!(typeof window > "u")) {
            var _ = document.createElement("div");
            return {
              basic: window.requestAnimationFrame && window.File && window.FileReader && window.FileList && window.Blob,
              dnd: "ondragstart" in _ && "ondrop" in _
            };
          }
        },
        chooseFile: function() {
          this.passive || this.$refs.fileInput.click();
        },
        remove: function() {
          if (!!this.imageSet) {
            this._setPlaceholders();
            var _ = this.img != null;
            this.originalImage = null, this.img = null, this.$refs.fileInput.value = "", this.imgData = {
              width: 0,
              height: 0,
              startX: 0,
              startY: 0
            }, this.orientation = 1, this.scaleRatio = null, this.userMetadata = null, this.imageSet = !1, this.chosenFile = null, this.video && (this.video.pause(), this.video = null), _ && this.emitEvent(x.IMAGE_REMOVE_EVENT);
          }
        },
        addClipPlugin: function(_) {
          if (this.clipPlugins || (this.clipPlugins = []), typeof _ == "function" && this.clipPlugins.indexOf(_) < 0)
            this.clipPlugins.push(_);
          else
            throw Error("Clip plugins should be functions");
        },
        emitNativeEvent: function(_) {
          this.emitEvent(_.type, _);
        },
        setFile: function(_) {
          this._onNewFileIn(_);
        },
        _setContainerSize: function() {
          this.useAutoSizing && (this.realWidth = +getComputedStyle(this.$refs.wrapper).width.slice(0, -2), this.realHeight = +getComputedStyle(this.$refs.wrapper).height.slice(0, -2));
        },
        _autoSizingInit: function() {
          this._setContainerSize(), window.addEventListener("resize", this._setContainerSize);
        },
        _autoSizingRemove: function() {
          this._setContainerSize(), window.removeEventListener("resize", this._setContainerSize);
        },
        _initialize: function() {
          this.canvas = this.$refs.canvas, this._setSize(), this._setRealSize(), this.canvas.style.backgroundColor = !this.canvasColor || this.canvasColor == "default" ? "transparent" : typeof this.canvasColor == "string" ? this.canvasColor : "", this.ctx = this.canvas.getContext("2d"), this.ctx.imageSmoothingEnabled = !0, this.ctx.imageSmoothingQuality = "high", this.ctx.webkitImageSmoothingEnabled = !0, this.ctx.msImageSmoothingEnabled = !0, this.ctx.imageSmoothingEnabled = !0, this.originalImage = null, this.img = null, this.$refs.fileInput.value = "", this.imageSet = !1, this.chosenFile = null, this._setInitial(), this.passive || this.emitEvent(x.INIT_EVENT, this);
        },
        _setSize: function() {
          this.canvas.width = this.outputWidth, this.canvas.height = this.outputHeight;
        },
        _setRealSize: function() {
          this.canvas.style.width = (this.useAutoSizing ? this.realWidth : this.width) + "px", this.canvas.style.height = (this.useAutoSizing ? this.realHeight : this.height) + "px";
        },
        _rotateByStep: function(_) {
          var E = 1;
          switch (_) {
            case 1:
              E = 6;
              break;
            case 2:
              E = 3;
              break;
            case 3:
              E = 8;
              break;
            case -1:
              E = 8;
              break;
            case -2:
              E = 3;
              break;
            case -3:
              E = 6;
              break;
          }
          this._setOrientation(E);
        },
        _setImagePlaceholder: function() {
          var _ = this, E = void 0;
          if (this.$slots.placeholder && this.$slots.placeholder[0]) {
            var B = this.$slots.placeholder[0], Y = B.tag, N = B.elm;
            Y == "img" && N && (E = N);
          }
          if (!!E) {
            var re = function() {
              _.ctx.drawImage(E, 0, 0, _.outputWidth, _.outputHeight);
            };
            h.imageLoaded(E) ? re() : E.onload = re;
          }
        },
        _setTextPlaceholder: function() {
          var _ = this.ctx;
          _.textBaseline = "middle", _.textAlign = "center";
          var E = this.outputWidth * X / this.placeholder.length, B = !this.computedPlaceholderFontSize || this.computedPlaceholderFontSize == 0 ? E : this.computedPlaceholderFontSize;
          _.font = B + "px sans-serif", _.fillStyle = !this.placeholderColor || this.placeholderColor == "default" ? "#606060" : this.placeholderColor, _.fillText(this.placeholder, this.outputWidth / 2, this.outputHeight / 2);
        },
        _setPlaceholders: function() {
          this._paintBackground(), this._setImagePlaceholder(), this._setTextPlaceholder();
        },
        _setInitial: function() {
          var _ = this, E = void 0, B = void 0;
          if (this.$slots.initial && this.$slots.initial[0]) {
            var Y = this.$slots.initial[0], N = Y.tag, re = Y.elm;
            N == "img" && re && (B = re);
          }
          if (this.initialImage && typeof this.initialImage == "string" ? (E = this.initialImage, B = new Image(), !/^data:/.test(E) && !/^blob:/.test(E) && B.setAttribute("crossOrigin", "anonymous"), B.src = E) : k(this.initialImage) === "object" && this.initialImage instanceof Image && (B = this.initialImage), !E && !B) {
            this._setPlaceholders();
            return;
          }
          this.currentIsInitial = !0, h.imageLoaded(B) ? this._onload(B, +B.dataset.exifOrientation, !0) : (this.loading = !0, B.onload = function() {
            _._onload(B, +B.dataset.exifOrientation, !0);
          }, B.onerror = function() {
            _._setPlaceholders();
          });
        },
        _onload: function(_) {
          var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, B = arguments[2];
          this.imageSet && this.remove(), this.originalImage = _, this.img = _, isNaN(E) && (E = 1), this._setOrientation(E), B && this.emitEvent(x.INITIAL_IMAGE_LOADED_EVENT);
        },
        _onVideoLoad: function(_, E) {
          var B = this;
          this.video = _;
          var Y = document.createElement("canvas"), N = _.videoWidth, re = _.videoHeight;
          Y.width = N, Y.height = re;
          var Te = Y.getContext("2d");
          this.loading = !1;
          var Me = function(q) {
            if (!!B.video) {
              Te.drawImage(B.video, 0, 0, N, re);
              var A = new Image();
              A.src = Y.toDataURL(), A.onload = function() {
                B.img = A, q ? B._placeImage() : B._draw();
              };
            }
          };
          Me(!0);
          var Ee = function Ce() {
            B.$nextTick(function() {
              Me(), !(!B.video || B.video.ended || B.video.paused) && requestAnimationFrame(Ce);
            });
          };
          this.video.addEventListener("play", function() {
            requestAnimationFrame(Ee);
          });
        },
        _handleClick: function(_) {
          this.emitNativeEvent(_), !this.hasImage() && !this.disableClickToChoose && !this.disabled && !this.supportTouch && !this.passive && this.chooseFile();
        },
        _handleDblClick: function(_) {
          if (this.emitNativeEvent(_), this.videoEnabled && this.video) {
            this.video.paused || this.video.ended ? this.video.play() : this.video.pause();
            return;
          }
        },
        _handleInputChange: function() {
          var _ = this.$refs.fileInput;
          if (!(!_.files.length || this.passive)) {
            var E = _.files[0];
            this._onNewFileIn(E);
          }
        },
        _onNewFileIn: function(_) {
          var E = this;
          if (this.currentIsInitial = !1, this.loading = !0, this.emitEvent(x.FILE_CHOOSE_EVENT, _), this.chosenFile = _, !this._fileSizeIsValid(_))
            return this.loading = !1, this.emitEvent(x.FILE_SIZE_EXCEED_EVENT, _), !1;
          if (!this._fileTypeIsValid(_))
            return this.loading = !1, this.emitEvent(x.FILE_TYPE_MISMATCH_EVENT, _), _.type || _.name.toLowerCase().split(".").pop(), !1;
          if (typeof window < "u" && typeof window.FileReader < "u") {
            var B = new FileReader();
            B.onload = function(Y) {
              var N = Y.target.result, re = h.parseDataUrl(N), Te = /^video/.test(_.type);
              if (Te) {
                var Me = document.createElement("video");
                Me.src = N, N = null, Me.readyState >= Me.HAVE_FUTURE_DATA ? E._onVideoLoad(Me) : Me.addEventListener("canplay", function() {
                  console.log("can play event"), E._onVideoLoad(Me);
                }, !1);
              } else {
                var Ee = 1;
                try {
                  Ee = h.getFileOrientation(h.base64ToArrayBuffer(re));
                } catch {
                }
                Ee < 1 && (Ee = 1);
                var Ce = new Image();
                Ce.src = N, N = null, Ce.onload = function() {
                  E._onload(Ce, Ee), E.emitEvent(x.NEW_IMAGE_EVENT);
                };
              }
            }, B.readAsDataURL(_);
          }
        },
        _fileSizeIsValid: function(_) {
          return _ ? !this.fileSizeLimit || this.fileSizeLimit == 0 ? !0 : _.size < this.fileSizeLimit : !1;
        },
        _fileTypeIsValid: function(_) {
          var E = this.videoEnabled && /^video/.test(_.type) && document.createElement("video").canPlayType(_.type) || /^image/.test(_.type);
          if (!E)
            return !1;
          if (!this.accept)
            return !0;
          for (var B = this.accept, Y = B.replace(/\/.*$/, ""), N = B.split(","), re = 0, Te = N.length; re < Te; re++) {
            var Me = N[re], Ee = Me.trim();
            if (Ee.charAt(0) == ".") {
              if (_.name.toLowerCase().split(".").pop() === Ee.toLowerCase().slice(1))
                return !0;
            } else if (/\/\*$/.test(Ee)) {
              var Ce = _.type.replace(/\/.*$/, "");
              if (Ce === Y)
                return !0;
            } else if (_.type === Me)
              return !0;
          }
          return !1;
        },
        _placeImage: function(_) {
          if (!!this.img) {
            var E = this.imgData;
            if (this.naturalWidth = this.img.naturalWidth, this.naturalHeight = this.img.naturalHeight, E.startX = h.numberValid(E.startX) ? E.startX : 0, E.startY = h.numberValid(E.startY) ? E.startY : 0, this.preventWhiteSpace ? this._aspectFill() : this.imageSet ? (this.imgData.width = this.naturalWidth * this.scaleRatio, this.imgData.height = this.naturalHeight * this.scaleRatio) : this.initialSize == "contain" ? this._aspectFit() : this.initialSize == "natural" ? this._naturalSize() : this._aspectFill(), !this.imageSet && (/top/.test(this.initialPosition) ? E.startY = 0 : /bottom/.test(this.initialPosition) && (E.startY = this.outputHeight - E.height), /left/.test(this.initialPosition) ? E.startX = 0 : /right/.test(this.initialPosition) && (E.startX = this.outputWidth - E.width), /^-?\d+% -?\d+%$/.test(this.initialPosition))) {
              var B = /^(-?\d+)% (-?\d+)%$/.exec(this.initialPosition), Y = +B[1] / 100, N = +B[2] / 100;
              E.startX = Y * (this.outputWidth - E.width), E.startY = N * (this.outputHeight - E.height);
            }
            _ && this._applyMetadata(), _ && this.preventWhiteSpace ? this.zoom(!1, 0) : (this.move({ x: 0, y: 0 }), this._draw());
          }
        },
        _aspectFill: function() {
          var _ = this.naturalWidth, E = this.naturalHeight, B = this.outputWidth / this.outputHeight, Y = void 0;
          this.aspectRatio > B ? (Y = E / this.outputHeight, this.imgData.width = _ / Y, this.imgData.height = this.outputHeight, this.imgData.startX = -(this.imgData.width - this.outputWidth) / 2, this.imgData.startY = 0) : (Y = _ / this.outputWidth, this.imgData.height = E / Y, this.imgData.width = this.outputWidth, this.imgData.startY = -(this.imgData.height - this.outputHeight) / 2, this.imgData.startX = 0);
        },
        _aspectFit: function() {
          var _ = this.naturalWidth, E = this.naturalHeight, B = this.outputWidth / this.outputHeight, Y = void 0;
          this.aspectRatio > B ? (Y = _ / this.outputWidth, this.imgData.height = E / Y, this.imgData.width = this.outputWidth, this.imgData.startY = -(this.imgData.height - this.outputHeight) / 2, this.imgData.startX = 0) : (Y = E / this.outputHeight, this.imgData.width = _ / Y, this.imgData.height = this.outputHeight, this.imgData.startX = -(this.imgData.width - this.outputWidth) / 2, this.imgData.startY = 0);
        },
        _naturalSize: function() {
          var _ = this.naturalWidth, E = this.naturalHeight;
          this.imgData.width = _, this.imgData.height = E, this.imgData.startX = -(this.imgData.width - this.outputWidth) / 2, this.imgData.startY = -(this.imgData.height - this.outputHeight) / 2;
        },
        _handlePointerStart: function(_) {
          if (this.emitNativeEvent(_), !this.passive) {
            this.supportTouch = !0, this.pointerMoved = !1;
            var E = h.getPointerCoords(_, this);
            if (this.pointerStartCoord = E, !this.disabled) {
              if (!this.hasImage() && !this.disableClickToChoose) {
                this.tabStart = new Date().valueOf();
                return;
              }
              if (!(_.which && _.which > 1)) {
                if (!_.touches || _.touches.length === 1) {
                  this.dragging = !0, this.pinching = !1;
                  var B = h.getPointerCoords(_, this);
                  this.lastMovingCoord = B;
                }
                _.touches && _.touches.length === 2 && !this.disablePinchToZoom && (this.dragging = !1, this.pinching = !0, this.pinchDistance = h.getPinchDistance(_, this));
                for (var Y = ["mouseup", "touchend", "touchcancel", "pointerend", "pointercancel"], N = 0, re = Y.length; N < re; N++) {
                  var Te = Y[N];
                  document.addEventListener(Te, this._handlePointerEnd);
                }
              }
            }
          }
        },
        _handlePointerEnd: function(_) {
          if (this.emitNativeEvent(_), !this.passive) {
            var E = 0;
            if (this.pointerStartCoord) {
              var B = h.getPointerCoords(_, this);
              E = Math.sqrt(Math.pow(B.x - this.pointerStartCoord.x, 2) + Math.pow(B.y - this.pointerStartCoord.y, 2)) || 0;
            }
            if (!this.disabled) {
              if (!this.hasImage() && !this.disableClickToChoose) {
                var Y = new Date().valueOf();
                E < $ && Y - this.tabStart < R && this.supportTouch && this.chooseFile(), this.tabStart = 0;
                return;
              }
              this.dragging = !1, this.pinching = !1, this.pinchDistance = 0, this.lastMovingCoord = null, this.pointerMoved = !1, this.pointerStartCoord = null;
            }
          }
        },
        _handlePointerMove: function(_) {
          if (this.emitNativeEvent(_), !this.passive && (this.pointerMoved = !0, !!this.hasImage())) {
            var E = h.getPointerCoords(_, this);
            if (this.currentPointerCoord = E, !(this.disabled || this.disableDragToMove)) {
              if (_.preventDefault(), !_.touches || _.touches.length === 1) {
                if (!this.dragging)
                  return;
                this.lastMovingCoord && this.move({
                  x: E.x - this.lastMovingCoord.x,
                  y: E.y - this.lastMovingCoord.y
                }), this.lastMovingCoord = E;
              }
              if (_.touches && _.touches.length === 2 && !this.disablePinchToZoom) {
                if (!this.pinching)
                  return;
                var B = h.getPinchDistance(_, this), Y = B - this.pinchDistance;
                this.zoom(Y > 0, H), this.pinchDistance = B;
              }
            }
          }
        },
        _handlePointerLeave: function(_) {
          this.emitNativeEvent(_), !this.passive && (this.currentPointerCoord = null);
        },
        _handleWheel: function(_) {
          var E = this;
          this.emitNativeEvent(_), !this.passive && (this.disabled || this.disableScrollToZoom || !this.hasImage() || (_.preventDefault(), this.scrolling = !0, _.wheelDelta < 0 || _.deltaY > 0 || _.detail > 0 ? this.zoom(this.reverseScrollToZoom) : (_.wheelDelta > 0 || _.deltaY < 0 || _.detail < 0) && this.zoom(!this.reverseScrollToZoom), this.$nextTick(function() {
            E.scrolling = !1;
          })));
        },
        _handleDragEnter: function(_) {
          this.emitNativeEvent(_), !this.passive && (this.disabled || this.disableDragAndDrop || !h.eventHasFile(_) || this.hasImage() && !this.replaceDrop || (this.fileDraggedOver = !0));
        },
        _handleDragLeave: function(_) {
          this.emitNativeEvent(_), !this.passive && (!this.fileDraggedOver || !h.eventHasFile(_) || (this.fileDraggedOver = !1));
        },
        _handleDragOver: function(_) {
          this.emitNativeEvent(_);
        },
        _handleDrop: function(_) {
          if (this.emitNativeEvent(_), !this.passive && !(!this.fileDraggedOver || !h.eventHasFile(_)) && !(this.hasImage() && !this.replaceDrop)) {
            this.fileDraggedOver = !1;
            var E = void 0, B = _.dataTransfer;
            if (!!B) {
              if (B.items)
                for (var Y = 0, N = B.items.length; Y < N; Y++) {
                  var re = B.items[Y];
                  if (re.kind == "file") {
                    E = re.getAsFile();
                    break;
                  }
                }
              else
                E = B.files[0];
              E && this._onNewFileIn(E);
            }
          }
        },
        _preventMovingToWhiteSpace: function() {
          this.imgData.startX > 0 && (this.imgData.startX = 0), this.imgData.startY > 0 && (this.imgData.startY = 0), this.outputWidth - this.imgData.startX > this.imgData.width && (this.imgData.startX = -(this.imgData.width - this.outputWidth)), this.outputHeight - this.imgData.startY > this.imgData.height && (this.imgData.startY = -(this.imgData.height - this.outputHeight));
        },
        _preventZoomingToWhiteSpace: function() {
          this.imgData.width < this.outputWidth && (this.scaleRatio = this.outputWidth / this.naturalWidth), this.imgData.height < this.outputHeight && (this.scaleRatio = this.outputHeight / this.naturalHeight);
        },
        _setOrientation: function() {
          var _ = this, E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 6, B = arguments[1], Y = B;
          if (E > 1 || Y) {
            if (!this.img)
              return;
            this.rotating = !0;
            var N = h.getRotatedImage(Y ? this.originalImage : this.img, E);
            N.onload = function() {
              _.img = N, _._placeImage(B);
            };
          } else
            this._placeImage(B);
          E == 2 ? this.orientation = h.flipX(this.orientation) : E == 4 ? this.orientation = h.flipY(this.orientation) : E == 6 ? this.orientation = h.rotate90(this.orientation) : E == 3 ? this.orientation = h.rotate90(h.rotate90(this.orientation)) : E == 8 ? this.orientation = h.rotate90(h.rotate90(h.rotate90(this.orientation))) : this.orientation = E, Y && (this.orientation = E);
        },
        _paintBackground: function() {
          var _ = !this.canvasColor || this.canvasColor == "default" ? "transparent" : this.canvasColor;
          this.ctx.fillStyle = _, this.ctx.clearRect(0, 0, this.outputWidth, this.outputHeight), this.ctx.fillRect(0, 0, this.outputWidth, this.outputHeight);
        },
        _draw: function() {
          var _ = this;
          this.$nextTick(function() {
            typeof window < "u" && window.requestAnimationFrame ? requestAnimationFrame(_._drawFrame) : _._drawFrame();
          });
        },
        _drawFrame: function() {
          if (!!this.img) {
            this.loading = !1;
            var _ = this.ctx, E = this.imgData, B = E.startX, Y = E.startY, N = E.width, re = E.height;
            this._paintBackground(), _.drawImage(this.img, B, Y, N, re), this.preventWhiteSpace && this._clip(this._createContainerClipPath), this.emitEvent(x.DRAW_EVENT, _), this.imageSet || (this.imageSet = !0, this.emitEvent(x.NEW_IMAGE_DRAWN_EVENT)), this.rotating = !1;
          }
        },
        _clipPathFactory: function(_, E, B, Y) {
          var N = this.ctx, re = typeof this.imageBorderRadius == "number" ? this.imageBorderRadius : isNaN(Number(this.imageBorderRadius)) ? 0 : Number(this.imageBorderRadius);
          N.beginPath(), N.moveTo(_ + re, E), N.lineTo(_ + B - re, E), N.quadraticCurveTo(_ + B, E, _ + B, E + re), N.lineTo(_ + B, E + Y - re), N.quadraticCurveTo(_ + B, E + Y, _ + B - re, E + Y), N.lineTo(_ + re, E + Y), N.quadraticCurveTo(_, E + Y, _, E + Y - re), N.lineTo(_, E + re), N.quadraticCurveTo(_, E, _ + re, E), N.closePath();
        },
        _createContainerClipPath: function() {
          var _ = this;
          this._clipPathFactory(0, 0, this.outputWidth, this.outputHeight), this.clipPlugins && this.clipPlugins.length && this.clipPlugins.forEach(function(E) {
            E(_.ctx, 0, 0, _.outputWidth, _.outputHeight);
          });
        },
        _clip: function(_) {
          var E = this.ctx;
          E.save(), E.fillStyle = "#fff", E.globalCompositeOperation = "destination-in", _(), E.fill(), E.restore();
        },
        _applyMetadata: function() {
          var _ = this;
          if (!!this.userMetadata) {
            var E = this.userMetadata, B = E.startX, Y = E.startY, N = E.scale;
            h.numberValid(B) && (this.imgData.startX = B), h.numberValid(Y) && (this.imgData.startY = Y), h.numberValid(N) && (this.scaleRatio = N), this.$nextTick(function() {
              _.userMetadata = null;
            });
          }
        },
        onDimensionChange: function() {
          this.img ? (this.preventWhiteSpace && (this.imageSet = !1), this._setSize(), this._setRealSize(), this._placeImage()) : this._initialize();
        }
      }
    };
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    var ee = Object.getOwnPropertySymbols, ne = Object.prototype.hasOwnProperty, se = Object.prototype.propertyIsEnumerable;
    function pe(F) {
      if (F == null)
        throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(F);
    }
    function ge() {
      try {
        if (!Object.assign)
          return !1;
        var F = new String("abc");
        if (F[5] = "de", Object.getOwnPropertyNames(F)[0] === "5")
          return !1;
        for (var _ = {}, E = 0; E < 10; E++)
          _["_" + String.fromCharCode(E)] = E;
        var B = Object.getOwnPropertyNames(_).map(function(N) {
          return _[N];
        });
        if (B.join("") !== "0123456789")
          return !1;
        var Y = {};
        return "abcdefghijklmnopqrst".split("").forEach(function(N) {
          Y[N] = N;
        }), Object.keys(Object.assign({}, Y)).join("") === "abcdefghijklmnopqrst";
      } catch {
        return !1;
      }
    }
    var Oe = ge() ? Object.assign : function(F, _) {
      for (var E, B = pe(F), Y, N = 1; N < arguments.length; N++) {
        E = Object(arguments[N]);
        for (var re in E)
          ne.call(E, re) && (B[re] = E[re]);
        if (ee) {
          Y = ee(E);
          for (var Te = 0; Te < Y.length; Te++)
            se.call(E, Y[Te]) && (B[Y[Te]] = E[Y[Te]]);
        }
      }
      return B;
    }, ke = {
      componentName: "croppa"
    }, we = {
      install: function(_, E) {
        E = Oe({}, ke, E);
        var B = Number(_.version.split(".")[0]);
        if (B < 2)
          throw new Error("vue-croppa supports vue version 2.0 and above. You are using Vue@" + B + ". Please upgrade to the latest version of Vue.");
        var Y = E.componentName || "croppa";
        _.component(Y, Z);
      },
      component: Z
    };
    return we;
  });
})(Sp);
const Cp = Sp.exports;
const eC = {
  name: "FormLabel",
  components: {
    SType: Rt
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    prominence: {
      type: String,
      default: "default",
      validator: function(a) {
        return ["default", "weak"].includes(a);
      }
    },
    required: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "label",
      validator: function(a) {
        return ["label", "legend"].includes(a);
      }
    }
  },
  computed: {
    variant() {
      return this.prominence === "default" ? "subtitle" : "body";
    },
    classes() {
      let a = ["form-input-label"];
      return this.error && a.push("form-input-label--error"), this.disabled && a.push("form-input-label--disabled"), this.prominence === "weak" && a.push("form-input-label--weak"), a;
    }
  }
};
var tC = function() {
  var r = this, c = r._self._c;
  return c("SType", { class: r.classes, attrs: { for: `form-input-${r.name}`, variant: r.variant, tag: r.tag, gutterBottom: r.prominence !== "weak", prominence: "default" } }, [r.required ? c("span", [r._v(" * ")]) : r._e(), r.error ? c("span", { staticClass: "screen-reader-only" }, [r._v(" Error on Input: ")]) : r._e(), r._t("default"), r.required ? c("span", { staticClass: "screen-reader-only" }, [r._v(" Required ")]) : r._e()], 2);
}, nC = [], iC = /* @__PURE__ */ he(
  eC,
  tC,
  nC,
  !1,
  null,
  "c2d4041d",
  null,
  null
);
const rC = iC.exports;
const oC = {
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.1
    },
    value: {
      type: Number,
      default: 0.5
    }
  },
  data() {
    return {
      range: this.value
    };
  },
  methods: {
    change() {
      this.$emit("input", this.range * 1), this.$emit("change", this.range * 1);
    },
    mouseup() {
      this.$emit("mouseup", this.range);
    }
  }
};
var sC = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "input-range-group" }, [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.range, expression: "range" }], attrs: { min: r.min, max: r.max, step: r.step, type: "range" }, domProps: { value: r.range }, on: { input: r.change, mouseup: function(u) {
    return u.stopPropagation(), r.mouseup.apply(null, arguments);
  }, __r: function(u) {
    r.range = u.target.value;
  } } })]);
}, aC = [], lC = /* @__PURE__ */ he(
  oC,
  sC,
  aC,
  !1,
  null,
  null,
  null,
  null
);
const Ap = lC.exports;
const cC = {
  components: {
    croppa: Cp.component,
    FormLabel: rC,
    FormRange: Ap,
    IconUpload: os,
    SButton: bi,
    SType: Rt,
    Tooltip: zr
  },
  props: {
    cropperH: {
      type: Number,
      default: 130
    },
    cropperW: {
      type: Number,
      default: 130
    },
    error: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isRound: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      default: ""
    },
    quality: {
      type: Number,
      default: 2
    },
    value: {
      type: Object,
      default: () => ({
        blob: null,
        name: null,
        value: ""
      })
    }
  },
  data() {
    return {
      croppa: {},
      generating: !1,
      imageZoom: 0,
      initialImage: "",
      loaded: !1,
      newImage: !1,
      removingImage: !1,
      zoomMax: 0,
      zoomMin: 0
    };
  },
  computed: {
    radius() {
      return this.isRound ? "50%" : 0;
    },
    containerStyle() {
      return `width: ${this.cropperW ? this.cropperW + "px" : "auto"};`;
    },
    showPlaceholder() {
      return !(this.initialImage || this.croppa.img);
    }
  },
  watch: {
    value(a) {
      !a.value || a.value === "" ? (this.initialImage = "", this.croppa.remove()) : !a.blob && a.value && this.cors();
    }
  },
  created() {
    this.cors();
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    chooseImage() {
      this.$refs.croppa.$el.getElementsByTagName("input")[0].click();
    },
    cors() {
      const a = new Image();
      a.setAttribute("crossorigin", "anonymous"), a.onload = () => {
        this.initialImage = a, this.croppa.refresh();
      };
      let r = `${this.value.value}`;
      (!this.value.blob || this.value.blob === "") && (r += "?crossorigin=anonymous"), a.src = r;
    },
    focus(a) {
      this.$emit("focus", a);
    },
    onFileChoose() {
      this.newImage = !0;
    },
    onFileSizeExceed() {
    },
    onFileTypeMismatch() {
    },
    onInit() {
    },
    onNewImageDrawn() {
      this.imageZoom = this.croppa.scaleRatio, this.zoomMin = this.croppa.scaleRatio, this.zoomMax = this.croppa.scaleRatio * 4, this.newImage && (this.sendImageData(), this.newImage = !1);
    },
    onImageRemove() {
      this.removingImage = !0, this.initialImage = "", this.croppa.remove(), this.sendImageData();
    },
    onSliderChange(a) {
      this.croppa.scaleRatio = +a, this.sendImageData();
    },
    onMove() {
      this.sendImageData();
    },
    onZoom() {
      this.sendImageData();
    },
    async sendImageData() {
      if (this.generating)
        return;
      this.generating = !0;
      const a = this.croppa.getChosenFile() || { name: null };
      let r = null;
      if (!a.name && this.value.name && !this.removingImage)
        a.name = this.value.name;
      else if (!a.name && this.value.value && !this.removingImage) {
        const u = this.value.value.split("/");
        a.name = u[u.length - 1];
      }
      if (this.removingImage = !1, a.name) {
        const u = a.name.split(".");
        u.pop(), r = u.join(".") + ".jpg";
      }
      const c = {
        blob: await this.croppa.promisedBlob("image/jpeg"),
        name: r,
        value: this.croppa.generateDataUrl("image/jpeg")
      };
      JSON.stringify(
        this.$parent.finalForm.getState().initialValues[`${this.name}`]
      ) === JSON.stringify(c) ? this.$emit("input", {
        target: {
          value: this.$parent.finalForm.getState().initialValues[`${this.name}`]
        }
      }) : this.$emit("input", { target: { value: c } }), this.$emit("change", c), this.generating = !1;
    }
  }
};
var uC = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "image-field" }, [c("div", { staticClass: "input-image-group" }, [c("div", { class: [
    "input-image-group-cropper",
    { dashed: !0, rounded: r.isRound, error: r.error, disabled: r.disabled }
  ], style: r.containerStyle }, [c("div", { staticClass: "croppa-wrappa", attrs: { tabindex: "0" }, on: { focus: r.focus, keyup: function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.chooseImage.apply(null, arguments);
  } } }, [c("croppa", { ref: "croppa", style: "border-radius:" + r.radius, attrs: { accept: "image/*", "canvas-color": "default", "disable-click-to-choose": r.disabled, "disable-drag-and-drop": r.disabled, "disable-drag-to-move": r.disabled, "disable-rotation": r.disabled, "disable-scroll-to-zoom": r.disabled, disabled: r.disabled, "file-size-limit": 0, height: r.cropperH, "initial-image": r.initialImage, "placeholder-color": "default", "placeholder-font-size": 0, placeholder: "", "prevent-white-space": !0, "show-remove-button": !1, width: r.cropperW }, on: { "file-choose": r.onFileChoose, "file-size-exceed": r.onFileSizeExceed, "file-type-mismatch": r.onFileTypeMismatch, "image-remove": r.onImageRemove, init: r.onInit, mouseup: function(u) {
    return u.stopPropagation(), r.sendImageData.apply(null, arguments);
  }, move: r.onMove, "new-image-drawn": r.onNewImageDrawn, zoom: r.onZoom }, model: { value: r.croppa, callback: function(u) {
    r.croppa = u;
  }, expression: "croppa" } }, [[r.showPlaceholder ? c("div", { staticClass: "content" }, [c("IconUpload", { attrs: { size: "lg" } }), c("SType", { staticClass: "helper-text", attrs: { "gutter-bottom": !1 } }, [r._v(" Drag file to upload ")])], 1) : r._e()]], 2)], 1)]), c("div", { directives: [{ name: "show", rawName: "v-show", value: r.croppa.hasImage && r.croppa.hasImage() && !r.disabled, expression: "croppa.hasImage && croppa.hasImage() && !disabled" }], staticClass: "image-zoomer" }, [c("form-range", { attrs: { max: r.zoomMax, min: r.zoomMin, step: 1e-3, disabled: r.disabled }, on: { change: r.onSliderChange, mouseup: r.sendImageData }, model: { value: r.imageZoom, callback: function(u) {
    r.imageZoom = u;
  }, expression: "imageZoom" } })], 1)]), c("div", { staticClass: "image-field__description" }, [c("FormLabel", { attrs: { for: r.name } }, [r._v(" " + r._s(r.label) + " "), r.$slots.tooltip ? c("Tooltip", { attrs: { id: `${r.name}-tooltip` } }, [r._t("tooltip")], 2) : r._e()], 1), c("SType", [r._t("default")], 2), c("SButton", { directives: [{ name: "show", rawName: "v-show", value: r.croppa.imageSet, expression: "croppa.imageSet" }], attrs: { disabled: r.disabled, variant: "secondary" }, on: { keyup: function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.onImageRemove.apply(null, arguments);
  }, click: r.onImageRemove } }, [r._v(" Remove ")]), c("SButton", { directives: [{ name: "show", rawName: "v-show", value: !r.croppa.imageSet, expression: "!croppa.imageSet" }], attrs: { disabled: r.disabled, variant: "secondary" }, on: { keyup: function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.chooseImage.apply(null, arguments);
  }, click: r.chooseImage } }, [r._v(" Choose file ")])], 1)]);
}, dC = [], hC = /* @__PURE__ */ he(
  cC,
  uC,
  dC,
  !1,
  null,
  null,
  null,
  null
);
const fC = hC.exports, pC = {
  name: "final-form-image",
  components: {
    CustomImage: fC,
    FinalField: cn.exports.FinalField
  },
  props: {
    cropperH: {
      type: Number,
      default: 130
    },
    cropperW: {
      type: Number,
      default: 130
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !0
    },
    isRound: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    quality: {
      type: Number,
      default: 2
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var mC = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    var p;
    return c("div", {}, [c("custom-image", r._g({ attrs: { value: u.value, name: u.name, "cropper-h": r.cropperH, "cropper-w": r.cropperW, "is-round": r.isRound, quality: r.quality, disabled: r.disabled, label: r.label }, on: { blur: r.blur, focus: r.focus, input: r.input }, scopedSlots: r._u([(p = r.$slots.tooltip) != null && p[0] ? { key: "tooltip", fn: function() {
      return [r._t("tooltip")];
    }, proxy: !0 } : null], null, !0) }, u.events), [r._t("default")], 2)], 1);
  } }], null, !0) });
}, gC = [], vC = /* @__PURE__ */ he(
  pC,
  mC,
  gC,
  !1,
  null,
  null,
  null,
  null
);
const KP = vC.exports, bC = {
  name: "DollarIcon"
};
var _C = function() {
  var r = this, c = r._self._c;
  return c("svg", { attrs: { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" } }, [c("path", { attrs: { d: "M21 6v12H3V6h18zm-4 2H7a2 2 0 01-1.85 1.995L5 10v4a2 2 0 011.995 1.85L7 16h10a2 2 0 011.85-1.995L19 14v-4a2 2 0 01-2-2zm-5 1a3 3 0 110 6 3 3 0 010-6z", fill: "#0F0F09", "fill-rule": "evenodd" } })]);
}, wC = [], yC = /* @__PURE__ */ he(
  bC,
  _C,
  wC,
  !1,
  null,
  null,
  null,
  null
);
const kC = yC.exports, xC = {
  name: "MonetizeIcon"
};
var SC = function() {
  var r = this, c = r._self._c;
  return c("svg", { attrs: { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" } }, [c("path", { attrs: { d: "M22 5a1 1 0 011 1v12a1 1 0 01-1 1H2a1 1 0 01-1-1V6a1 1 0 011-1h20zM9 8v8l7-4-7-4z", fill: "#0F0F09", "fill-rule": "evenodd" } })]);
}, CC = [], AC = /* @__PURE__ */ he(
  xC,
  SC,
  CC,
  !1,
  null,
  null,
  null,
  null
);
const TC = AC.exports, IC = () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), Tp = (a, r = IC) => {
  const c = r();
  return a.includes(c) ? Tp(a) : c;
}, EC = (a) => a.map((r) => r.uploadId || r.id), Hf = (a) => Tp(EC(a));
var Ip = { exports: {} };
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Yo(a) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Yo = function(r) {
    return typeof r;
  } : Yo = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Yo(a);
}
function PC(a, r, c) {
  return r in a ? Object.defineProperty(a, r, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[r] = c, a;
}
function gn() {
  return gn = Object.assign || function(a) {
    for (var r = 1; r < arguments.length; r++) {
      var c = arguments[r];
      for (var u in c)
        Object.prototype.hasOwnProperty.call(c, u) && (a[u] = c[u]);
    }
    return a;
  }, gn.apply(this, arguments);
}
function gi(a) {
  for (var r = 1; r < arguments.length; r++) {
    var c = arguments[r] != null ? arguments[r] : {}, u = Object.keys(c);
    typeof Object.getOwnPropertySymbols == "function" && (u = u.concat(Object.getOwnPropertySymbols(c).filter(function(p) {
      return Object.getOwnPropertyDescriptor(c, p).enumerable;
    }))), u.forEach(function(p) {
      PC(a, p, c[p]);
    });
  }
  return a;
}
function MC(a, r) {
  if (a == null)
    return {};
  var c = {}, u = Object.keys(a), p, h;
  for (h = 0; h < u.length; h++)
    p = u[h], !(r.indexOf(p) >= 0) && (c[p] = a[p]);
  return c;
}
function OC(a, r) {
  if (a == null)
    return {};
  var c = MC(a, r), u, p;
  if (Object.getOwnPropertySymbols) {
    var h = Object.getOwnPropertySymbols(a);
    for (p = 0; p < h.length; p++)
      u = h[p], !(r.indexOf(u) >= 0) && (!Object.prototype.propertyIsEnumerable.call(a, u) || (c[u] = a[u]));
  }
  return c;
}
function DC(a) {
  return NC(a) || RC(a) || LC();
}
function NC(a) {
  if (Array.isArray(a)) {
    for (var r = 0, c = new Array(a.length); r < a.length; r++)
      c[r] = a[r];
    return c;
  }
}
function RC(a) {
  if (Symbol.iterator in Object(a) || Object.prototype.toString.call(a) === "[object Arguments]")
    return Array.from(a);
}
function LC() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
var FC = "1.10.2";
function Xn(a) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(a);
}
var Qn = Xn(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), $r = Xn(/Edge/i), Wf = Xn(/firefox/i), fl = Xn(/safari/i) && !Xn(/chrome/i) && !Xn(/android/i), Ep = Xn(/iP(ad|od|hone)/i), zC = Xn(/chrome/i) && Xn(/android/i), Pp = {
  capture: !1,
  passive: !1
};
function Ye(a, r, c) {
  a.addEventListener(r, c, !Qn && Pp);
}
function He(a, r, c) {
  a.removeEventListener(r, c, !Qn && Pp);
}
function Xo(a, r) {
  if (!!r) {
    if (r[0] === ">" && (r = r.substring(1)), a)
      try {
        if (a.matches)
          return a.matches(r);
        if (a.msMatchesSelector)
          return a.msMatchesSelector(r);
        if (a.webkitMatchesSelector)
          return a.webkitMatchesSelector(r);
      } catch {
        return !1;
      }
    return !1;
  }
}
function $C(a) {
  return a.host && a !== document && a.host.nodeType ? a.host : a.parentNode;
}
function Cn(a, r, c, u) {
  if (a) {
    c = c || document;
    do {
      if (r != null && (r[0] === ">" ? a.parentNode === c && Xo(a, r) : Xo(a, r)) || u && a === c)
        return a;
      if (a === c)
        break;
    } while (a = $C(a));
  }
  return null;
}
var Yf = /\s+/g;
function vt(a, r, c) {
  if (a && r)
    if (a.classList)
      a.classList[c ? "add" : "remove"](r);
    else {
      var u = (" " + a.className + " ").replace(Yf, " ").replace(" " + r + " ", " ");
      a.className = (u + (c ? " " + r : "")).replace(Yf, " ");
    }
}
function Pe(a, r, c) {
  var u = a && a.style;
  if (u) {
    if (c === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? c = document.defaultView.getComputedStyle(a, "") : a.currentStyle && (c = a.currentStyle), r === void 0 ? c : c[r];
    !(r in u) && r.indexOf("webkit") === -1 && (r = "-webkit-" + r), u[r] = c + (typeof c == "string" ? "" : "px");
  }
}
function Oi(a, r) {
  var c = "";
  if (typeof a == "string")
    c = a;
  else
    do {
      var u = Pe(a, "transform");
      u && u !== "none" && (c = u + " " + c);
    } while (!r && (a = a.parentNode));
  var p = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return p && new p(c);
}
function Mp(a, r, c) {
  if (a) {
    var u = a.getElementsByTagName(r), p = 0, h = u.length;
    if (c)
      for (; p < h; p++)
        c(u[p], p);
    return u;
  }
  return [];
}
function zn() {
  var a = document.scrollingElement;
  return a || document.documentElement;
}
function yt(a, r, c, u, p) {
  if (!(!a.getBoundingClientRect && a !== window)) {
    var h, v, w, x, k, P, R;
    if (a !== window && a !== zn() ? (h = a.getBoundingClientRect(), v = h.top, w = h.left, x = h.bottom, k = h.right, P = h.height, R = h.width) : (v = 0, w = 0, x = window.innerHeight, k = window.innerWidth, P = window.innerHeight, R = window.innerWidth), (r || c) && a !== window && (p = p || a.parentNode, !Qn))
      do
        if (p && p.getBoundingClientRect && (Pe(p, "transform") !== "none" || c && Pe(p, "position") !== "static")) {
          var $ = p.getBoundingClientRect();
          v -= $.top + parseInt(Pe(p, "border-top-width")), w -= $.left + parseInt(Pe(p, "border-left-width")), x = v + h.height, k = w + h.width;
          break;
        }
      while (p = p.parentNode);
    if (u && a !== window) {
      var J = Oi(p || a), X = J && J.a, H = J && J.d;
      J && (v /= H, w /= X, R /= X, P /= H, x = v + P, k = w + R);
    }
    return {
      top: v,
      left: w,
      bottom: x,
      right: k,
      width: R,
      height: P
    };
  }
}
function qf(a, r, c) {
  for (var u = mi(a, !0), p = yt(a)[r]; u; ) {
    var h = yt(u)[c], v = void 0;
    if (c === "top" || c === "left" ? v = p >= h : v = p <= h, !v)
      return u;
    if (u === zn())
      break;
    u = mi(u, !1);
  }
  return !1;
}
function Qo(a, r, c) {
  for (var u = 0, p = 0, h = a.children; p < h.length; ) {
    if (h[p].style.display !== "none" && h[p] !== Le.ghost && h[p] !== Le.dragged && Cn(h[p], c.draggable, a, !1)) {
      if (u === r)
        return h[p];
      u++;
    }
    p++;
  }
  return null;
}
function xl(a, r) {
  for (var c = a.lastElementChild; c && (c === Le.ghost || Pe(c, "display") === "none" || r && !Xo(c, r)); )
    c = c.previousElementSibling;
  return c || null;
}
function wt(a, r) {
  var c = 0;
  if (!a || !a.parentNode)
    return -1;
  for (; a = a.previousElementSibling; )
    a.nodeName.toUpperCase() !== "TEMPLATE" && a !== Le.clone && (!r || Xo(a, r)) && c++;
  return c;
}
function Gf(a) {
  var r = 0, c = 0, u = zn();
  if (a)
    do {
      var p = Oi(a), h = p.a, v = p.d;
      r += a.scrollLeft * h, c += a.scrollTop * v;
    } while (a !== u && (a = a.parentNode));
  return [r, c];
}
function jC(a, r) {
  for (var c in a)
    if (!!a.hasOwnProperty(c)) {
      for (var u in r)
        if (r.hasOwnProperty(u) && r[u] === a[c][u])
          return Number(c);
    }
  return -1;
}
function mi(a, r) {
  if (!a || !a.getBoundingClientRect)
    return zn();
  var c = a, u = !1;
  do
    if (c.clientWidth < c.scrollWidth || c.clientHeight < c.scrollHeight) {
      var p = Pe(c);
      if (c.clientWidth < c.scrollWidth && (p.overflowX == "auto" || p.overflowX == "scroll") || c.clientHeight < c.scrollHeight && (p.overflowY == "auto" || p.overflowY == "scroll")) {
        if (!c.getBoundingClientRect || c === document.body)
          return zn();
        if (u || r)
          return c;
        u = !0;
      }
    }
  while (c = c.parentNode);
  return zn();
}
function BC(a, r) {
  if (a && r)
    for (var c in r)
      r.hasOwnProperty(c) && (a[c] = r[c]);
  return a;
}
function Qa(a, r) {
  return Math.round(a.top) === Math.round(r.top) && Math.round(a.left) === Math.round(r.left) && Math.round(a.height) === Math.round(r.height) && Math.round(a.width) === Math.round(r.width);
}
var Dr;
function Op(a, r) {
  return function() {
    if (!Dr) {
      var c = arguments, u = this;
      c.length === 1 ? a.call(u, c[0]) : a.apply(u, c), Dr = setTimeout(function() {
        Dr = void 0;
      }, r);
    }
  };
}
function VC() {
  clearTimeout(Dr), Dr = void 0;
}
function Dp(a, r, c) {
  a.scrollLeft += r, a.scrollTop += c;
}
function Sl(a) {
  var r = window.Polymer, c = window.jQuery || window.Zepto;
  return r && r.dom ? r.dom(a).cloneNode(!0) : c ? c(a).clone(!0)[0] : a.cloneNode(!0);
}
function Zf(a, r) {
  Pe(a, "position", "absolute"), Pe(a, "top", r.top), Pe(a, "left", r.left), Pe(a, "width", r.width), Pe(a, "height", r.height);
}
function Ja(a) {
  Pe(a, "position", ""), Pe(a, "top", ""), Pe(a, "left", ""), Pe(a, "width", ""), Pe(a, "height", "");
}
var Wt = "Sortable" + new Date().getTime();
function UC() {
  var a = [], r;
  return {
    captureAnimationState: function() {
      if (a = [], !!this.options.animation) {
        var u = [].slice.call(this.el.children);
        u.forEach(function(p) {
          if (!(Pe(p, "display") === "none" || p === Le.ghost)) {
            a.push({
              target: p,
              rect: yt(p)
            });
            var h = gi({}, a[a.length - 1].rect);
            if (p.thisAnimationDuration) {
              var v = Oi(p, !0);
              v && (h.top -= v.f, h.left -= v.e);
            }
            p.fromRect = h;
          }
        });
      }
    },
    addAnimationState: function(u) {
      a.push(u);
    },
    removeAnimationState: function(u) {
      a.splice(jC(a, {
        target: u
      }), 1);
    },
    animateAll: function(u) {
      var p = this;
      if (!this.options.animation) {
        clearTimeout(r), typeof u == "function" && u();
        return;
      }
      var h = !1, v = 0;
      a.forEach(function(w) {
        var x = 0, k = w.target, P = k.fromRect, R = yt(k), $ = k.prevFromRect, J = k.prevToRect, X = w.rect, H = Oi(k, !0);
        H && (R.top -= H.f, R.left -= H.e), k.toRect = R, k.thisAnimationDuration && Qa($, R) && !Qa(P, R) && (X.top - R.top) / (X.left - R.left) === (P.top - R.top) / (P.left - R.left) && (x = WC(X, $, J, p.options)), Qa(R, P) || (k.prevFromRect = P, k.prevToRect = R, x || (x = p.options.animation), p.animate(k, X, R, x)), x && (h = !0, v = Math.max(v, x), clearTimeout(k.animationResetTimer), k.animationResetTimer = setTimeout(function() {
          k.animationTime = 0, k.prevFromRect = null, k.fromRect = null, k.prevToRect = null, k.thisAnimationDuration = null;
        }, x), k.thisAnimationDuration = x);
      }), clearTimeout(r), h ? r = setTimeout(function() {
        typeof u == "function" && u();
      }, v) : typeof u == "function" && u(), a = [];
    },
    animate: function(u, p, h, v) {
      if (v) {
        Pe(u, "transition", ""), Pe(u, "transform", "");
        var w = Oi(this.el), x = w && w.a, k = w && w.d, P = (p.left - h.left) / (x || 1), R = (p.top - h.top) / (k || 1);
        u.animatingX = !!P, u.animatingY = !!R, Pe(u, "transform", "translate3d(" + P + "px," + R + "px,0)"), HC(u), Pe(u, "transition", "transform " + v + "ms" + (this.options.easing ? " " + this.options.easing : "")), Pe(u, "transform", "translate3d(0,0,0)"), typeof u.animated == "number" && clearTimeout(u.animated), u.animated = setTimeout(function() {
          Pe(u, "transition", ""), Pe(u, "transform", ""), u.animated = !1, u.animatingX = !1, u.animatingY = !1;
        }, v);
      }
    }
  };
}
function HC(a) {
  return a.offsetWidth;
}
function WC(a, r, c, u) {
  return Math.sqrt(Math.pow(r.top - a.top, 2) + Math.pow(r.left - a.left, 2)) / Math.sqrt(Math.pow(r.top - c.top, 2) + Math.pow(r.left - c.left, 2)) * u.animation;
}
var Sr = [], el = {
  initializeByDefault: !0
}, jr = {
  mount: function(r) {
    for (var c in el)
      el.hasOwnProperty(c) && !(c in r) && (r[c] = el[c]);
    Sr.push(r);
  },
  pluginEvent: function(r, c, u) {
    var p = this;
    this.eventCanceled = !1, u.cancel = function() {
      p.eventCanceled = !0;
    };
    var h = r + "Global";
    Sr.forEach(function(v) {
      !c[v.pluginName] || (c[v.pluginName][h] && c[v.pluginName][h](gi({
        sortable: c
      }, u)), c.options[v.pluginName] && c[v.pluginName][r] && c[v.pluginName][r](gi({
        sortable: c
      }, u)));
    });
  },
  initializePlugins: function(r, c, u, p) {
    Sr.forEach(function(w) {
      var x = w.pluginName;
      if (!(!r.options[x] && !w.initializeByDefault)) {
        var k = new w(r, c, r.options);
        k.sortable = r, k.options = r.options, r[x] = k, gn(u, k.defaults);
      }
    });
    for (var h in r.options)
      if (!!r.options.hasOwnProperty(h)) {
        var v = this.modifyOption(r, h, r.options[h]);
        typeof v < "u" && (r.options[h] = v);
      }
  },
  getEventProperties: function(r, c) {
    var u = {};
    return Sr.forEach(function(p) {
      typeof p.eventProperties == "function" && gn(u, p.eventProperties.call(c[p.pluginName], r));
    }), u;
  },
  modifyOption: function(r, c, u) {
    var p;
    return Sr.forEach(function(h) {
      !r[h.pluginName] || h.optionListeners && typeof h.optionListeners[c] == "function" && (p = h.optionListeners[c].call(r[h.pluginName], u));
    }), p;
  }
};
function Er(a) {
  var r = a.sortable, c = a.rootEl, u = a.name, p = a.targetEl, h = a.cloneEl, v = a.toEl, w = a.fromEl, x = a.oldIndex, k = a.newIndex, P = a.oldDraggableIndex, R = a.newDraggableIndex, $ = a.originalEvent, J = a.putSortable, X = a.extraEventProperties;
  if (r = r || c && c[Wt], !!r) {
    var H, W = r.options, Z = "on" + u.charAt(0).toUpperCase() + u.substr(1);
    window.CustomEvent && !Qn && !$r ? H = new CustomEvent(u, {
      bubbles: !0,
      cancelable: !0
    }) : (H = document.createEvent("Event"), H.initEvent(u, !0, !0)), H.to = v || c, H.from = w || c, H.item = p || c, H.clone = h, H.oldIndex = x, H.newIndex = k, H.oldDraggableIndex = P, H.newDraggableIndex = R, H.originalEvent = $, H.pullMode = J ? J.lastPutMode : void 0;
    var ee = gi({}, X, jr.getEventProperties(u, r));
    for (var ne in ee)
      H[ne] = ee[ne];
    c && c.dispatchEvent(H), W[Z] && W[Z].call(r, H);
  }
}
var Qt = function(r, c) {
  var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, p = u.evt, h = OC(u, ["evt"]);
  jr.pluginEvent.bind(Le)(r, c, gi({
    dragEl: ye,
    parentEl: At,
    ghostEl: Be,
    rootEl: gt,
    nextEl: Mi,
    lastDownEl: qo,
    cloneEl: _t,
    cloneHidden: pi,
    dragStarted: Pr,
    putSortable: Lt,
    activeSortable: Le.active,
    originalEvent: p,
    oldIndex: er,
    oldDraggableIndex: Nr,
    newIndex: ln,
    newDraggableIndex: fi,
    hideGhostForTarget: Fp,
    unhideGhostForTarget: zp,
    cloneNowHidden: function() {
      pi = !0;
    },
    cloneNowShown: function() {
      pi = !1;
    },
    dispatchSortableEvent: function(w) {
      Xt({
        sortable: c,
        name: w,
        originalEvent: p
      });
    }
  }, h));
};
function Xt(a) {
  Er(gi({
    putSortable: Lt,
    cloneEl: _t,
    targetEl: ye,
    rootEl: gt,
    oldIndex: er,
    oldDraggableIndex: Nr,
    newIndex: ln,
    newDraggableIndex: fi
  }, a));
}
var ye, At, Be, gt, Mi, qo, _t, pi, er, ln, Nr, fi, jo, Lt, Qi = !1, Jo = !1, es = [], Ei, kn, tl, nl, Kf, Xf, Pr, Ki, Rr, Lr = !1, Bo = !1, Go, Ht, il = [], pl = !1, ts = [], ss = typeof document < "u", Vo = Ep, Qf = $r || Qn ? "cssFloat" : "float", YC = ss && !zC && !Ep && "draggable" in document.createElement("div"), Np = function() {
  if (!!ss) {
    if (Qn)
      return !1;
    var a = document.createElement("x");
    return a.style.cssText = "pointer-events:auto", a.style.pointerEvents === "auto";
  }
}(), Rp = function(r, c) {
  var u = Pe(r), p = parseInt(u.width) - parseInt(u.paddingLeft) - parseInt(u.paddingRight) - parseInt(u.borderLeftWidth) - parseInt(u.borderRightWidth), h = Qo(r, 0, c), v = Qo(r, 1, c), w = h && Pe(h), x = v && Pe(v), k = w && parseInt(w.marginLeft) + parseInt(w.marginRight) + yt(h).width, P = x && parseInt(x.marginLeft) + parseInt(x.marginRight) + yt(v).width;
  if (u.display === "flex")
    return u.flexDirection === "column" || u.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (u.display === "grid")
    return u.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (h && w.float && w.float !== "none") {
    var R = w.float === "left" ? "left" : "right";
    return v && (x.clear === "both" || x.clear === R) ? "vertical" : "horizontal";
  }
  return h && (w.display === "block" || w.display === "flex" || w.display === "table" || w.display === "grid" || k >= p && u[Qf] === "none" || v && u[Qf] === "none" && k + P > p) ? "vertical" : "horizontal";
}, qC = function(r, c, u) {
  var p = u ? r.left : r.top, h = u ? r.right : r.bottom, v = u ? r.width : r.height, w = u ? c.left : c.top, x = u ? c.right : c.bottom, k = u ? c.width : c.height;
  return p === w || h === x || p + v / 2 === w + k / 2;
}, GC = function(r, c) {
  var u;
  return es.some(function(p) {
    if (!xl(p)) {
      var h = yt(p), v = p[Wt].options.emptyInsertThreshold, w = r >= h.left - v && r <= h.right + v, x = c >= h.top - v && c <= h.bottom + v;
      if (v && w && x)
        return u = p;
    }
  }), u;
}, Lp = function(r) {
  function c(h, v) {
    return function(w, x, k, P) {
      var R = w.options.group.name && x.options.group.name && w.options.group.name === x.options.group.name;
      if (h == null && (v || R))
        return !0;
      if (h == null || h === !1)
        return !1;
      if (v && h === "clone")
        return h;
      if (typeof h == "function")
        return c(h(w, x, k, P), v)(w, x, k, P);
      var $ = (v ? w : x).options.group.name;
      return h === !0 || typeof h == "string" && h === $ || h.join && h.indexOf($) > -1;
    };
  }
  var u = {}, p = r.group;
  (!p || Yo(p) != "object") && (p = {
    name: p
  }), u.name = p.name, u.checkPull = c(p.pull, !0), u.checkPut = c(p.put), u.revertClone = p.revertClone, r.group = u;
}, Fp = function() {
  !Np && Be && Pe(Be, "display", "none");
}, zp = function() {
  !Np && Be && Pe(Be, "display", "");
};
ss && document.addEventListener("click", function(a) {
  if (Jo)
    return a.preventDefault(), a.stopPropagation && a.stopPropagation(), a.stopImmediatePropagation && a.stopImmediatePropagation(), Jo = !1, !1;
}, !0);
var Pi = function(r) {
  if (ye) {
    r = r.touches ? r.touches[0] : r;
    var c = GC(r.clientX, r.clientY);
    if (c) {
      var u = {};
      for (var p in r)
        r.hasOwnProperty(p) && (u[p] = r[p]);
      u.target = u.rootEl = c, u.preventDefault = void 0, u.stopPropagation = void 0, c[Wt]._onDragOver(u);
    }
  }
}, ZC = function(r) {
  ye && ye.parentNode[Wt]._isOutsideThisEl(r.target);
};
function Le(a, r) {
  if (!(a && a.nodeType && a.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(a));
  this.el = a, this.options = r = gn({}, r), a[Wt] = this;
  var c = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(a.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: !1,
    invertedSwapThreshold: null,
    removeCloneOnHide: !0,
    direction: function() {
      return Rp(a, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(v, w) {
      v.setData("Text", w.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Le.supportPointer !== !1 && "PointerEvent" in window,
    emptyInsertThreshold: 5
  };
  jr.initializePlugins(this, a, c);
  for (var u in c)
    !(u in r) && (r[u] = c[u]);
  Lp(r);
  for (var p in this)
    p.charAt(0) === "_" && typeof this[p] == "function" && (this[p] = this[p].bind(this));
  this.nativeDraggable = r.forceFallback ? !1 : YC, this.nativeDraggable && (this.options.touchStartThreshold = 1), r.supportPointer ? Ye(a, "pointerdown", this._onTapStart) : (Ye(a, "mousedown", this._onTapStart), Ye(a, "touchstart", this._onTapStart)), this.nativeDraggable && (Ye(a, "dragover", this), Ye(a, "dragenter", this)), es.push(this.el), r.store && r.store.get && this.sort(r.store.get(this) || []), gn(this, UC());
}
Le.prototype = {
  constructor: Le,
  _isOutsideThisEl: function(r) {
    !this.el.contains(r) && r !== this.el && (Ki = null);
  },
  _getDirection: function(r, c) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, r, c, ye) : this.options.direction;
  },
  _onTapStart: function(r) {
    if (!!r.cancelable) {
      var c = this, u = this.el, p = this.options, h = p.preventOnFilter, v = r.type, w = r.touches && r.touches[0] || r.pointerType && r.pointerType === "touch" && r, x = (w || r).target, k = r.target.shadowRoot && (r.path && r.path[0] || r.composedPath && r.composedPath()[0]) || x, P = p.filter;
      if (nA(u), !ye && !(/mousedown|pointerdown/.test(v) && r.button !== 0 || p.disabled) && !k.isContentEditable && (x = Cn(x, p.draggable, u, !1), !(x && x.animated) && qo !== x)) {
        if (er = wt(x), Nr = wt(x, p.draggable), typeof P == "function") {
          if (P.call(this, r, x, this)) {
            Xt({
              sortable: c,
              rootEl: k,
              name: "filter",
              targetEl: x,
              toEl: u,
              fromEl: u
            }), Qt("filter", c, {
              evt: r
            }), h && r.cancelable && r.preventDefault();
            return;
          }
        } else if (P && (P = P.split(",").some(function(R) {
          if (R = Cn(k, R.trim(), u, !1), R)
            return Xt({
              sortable: c,
              rootEl: R,
              name: "filter",
              targetEl: x,
              fromEl: u,
              toEl: u
            }), Qt("filter", c, {
              evt: r
            }), !0;
        }), P)) {
          h && r.cancelable && r.preventDefault();
          return;
        }
        p.handle && !Cn(k, p.handle, u, !1) || this._prepareDragStart(r, w, x);
      }
    }
  },
  _prepareDragStart: function(r, c, u) {
    var p = this, h = p.el, v = p.options, w = h.ownerDocument, x;
    if (u && !ye && u.parentNode === h) {
      var k = yt(u);
      if (gt = h, ye = u, At = ye.parentNode, Mi = ye.nextSibling, qo = u, jo = v.group, Le.dragged = ye, Ei = {
        target: ye,
        clientX: (c || r).clientX,
        clientY: (c || r).clientY
      }, Kf = Ei.clientX - k.left, Xf = Ei.clientY - k.top, this._lastX = (c || r).clientX, this._lastY = (c || r).clientY, ye.style["will-change"] = "all", x = function() {
        if (Qt("delayEnded", p, {
          evt: r
        }), Le.eventCanceled) {
          p._onDrop();
          return;
        }
        p._disableDelayedDragEvents(), !Wf && p.nativeDraggable && (ye.draggable = !0), p._triggerDragStart(r, c), Xt({
          sortable: p,
          name: "choose",
          originalEvent: r
        }), vt(ye, v.chosenClass, !0);
      }, v.ignore.split(",").forEach(function(P) {
        Mp(ye, P.trim(), ol);
      }), Ye(w, "dragover", Pi), Ye(w, "mousemove", Pi), Ye(w, "touchmove", Pi), Ye(w, "mouseup", p._onDrop), Ye(w, "touchend", p._onDrop), Ye(w, "touchcancel", p._onDrop), Wf && this.nativeDraggable && (this.options.touchStartThreshold = 4, ye.draggable = !0), Qt("delayStart", this, {
        evt: r
      }), v.delay && (!v.delayOnTouchOnly || c) && (!this.nativeDraggable || !($r || Qn))) {
        if (Le.eventCanceled) {
          this._onDrop();
          return;
        }
        Ye(w, "mouseup", p._disableDelayedDrag), Ye(w, "touchend", p._disableDelayedDrag), Ye(w, "touchcancel", p._disableDelayedDrag), Ye(w, "mousemove", p._delayedDragTouchMoveHandler), Ye(w, "touchmove", p._delayedDragTouchMoveHandler), v.supportPointer && Ye(w, "pointermove", p._delayedDragTouchMoveHandler), p._dragStartTimer = setTimeout(x, v.delay);
      } else
        x();
    }
  },
  _delayedDragTouchMoveHandler: function(r) {
    var c = r.touches ? r.touches[0] : r;
    Math.max(Math.abs(c.clientX - this._lastX), Math.abs(c.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    ye && ol(ye), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var r = this.el.ownerDocument;
    He(r, "mouseup", this._disableDelayedDrag), He(r, "touchend", this._disableDelayedDrag), He(r, "touchcancel", this._disableDelayedDrag), He(r, "mousemove", this._delayedDragTouchMoveHandler), He(r, "touchmove", this._delayedDragTouchMoveHandler), He(r, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(r, c) {
    c = c || r.pointerType == "touch" && r, !this.nativeDraggable || c ? this.options.supportPointer ? Ye(document, "pointermove", this._onTouchMove) : c ? Ye(document, "touchmove", this._onTouchMove) : Ye(document, "mousemove", this._onTouchMove) : (Ye(ye, "dragend", this), Ye(gt, "dragstart", this._onDragStart));
    try {
      document.selection ? Zo(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(r, c) {
    if (Qi = !1, gt && ye) {
      Qt("dragStarted", this, {
        evt: c
      }), this.nativeDraggable && Ye(document, "dragover", ZC);
      var u = this.options;
      !r && vt(ye, u.dragClass, !1), vt(ye, u.ghostClass, !0), Le.active = this, r && this._appendGhost(), Xt({
        sortable: this,
        name: "start",
        originalEvent: c
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (kn) {
      this._lastX = kn.clientX, this._lastY = kn.clientY, Fp();
      for (var r = document.elementFromPoint(kn.clientX, kn.clientY), c = r; r && r.shadowRoot && (r = r.shadowRoot.elementFromPoint(kn.clientX, kn.clientY), r !== c); )
        c = r;
      if (ye.parentNode[Wt]._isOutsideThisEl(r), c)
        do {
          if (c[Wt]) {
            var u = void 0;
            if (u = c[Wt]._onDragOver({
              clientX: kn.clientX,
              clientY: kn.clientY,
              target: r,
              rootEl: c
            }), u && !this.options.dragoverBubble)
              break;
          }
          r = c;
        } while (c = c.parentNode);
      zp();
    }
  },
  _onTouchMove: function(r) {
    if (Ei) {
      var c = this.options, u = c.fallbackTolerance, p = c.fallbackOffset, h = r.touches ? r.touches[0] : r, v = Be && Oi(Be, !0), w = Be && v && v.a, x = Be && v && v.d, k = Vo && Ht && Gf(Ht), P = (h.clientX - Ei.clientX + p.x) / (w || 1) + (k ? k[0] - il[0] : 0) / (w || 1), R = (h.clientY - Ei.clientY + p.y) / (x || 1) + (k ? k[1] - il[1] : 0) / (x || 1);
      if (!Le.active && !Qi) {
        if (u && Math.max(Math.abs(h.clientX - this._lastX), Math.abs(h.clientY - this._lastY)) < u)
          return;
        this._onDragStart(r, !0);
      }
      if (Be) {
        v ? (v.e += P - (tl || 0), v.f += R - (nl || 0)) : v = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: P,
          f: R
        };
        var $ = "matrix(".concat(v.a, ",").concat(v.b, ",").concat(v.c, ",").concat(v.d, ",").concat(v.e, ",").concat(v.f, ")");
        Pe(Be, "webkitTransform", $), Pe(Be, "mozTransform", $), Pe(Be, "msTransform", $), Pe(Be, "transform", $), tl = P, nl = R, kn = h;
      }
      r.cancelable && r.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!Be) {
      var r = this.options.fallbackOnBody ? document.body : gt, c = yt(ye, !0, Vo, !0, r), u = this.options;
      if (Vo) {
        for (Ht = r; Pe(Ht, "position") === "static" && Pe(Ht, "transform") === "none" && Ht !== document; )
          Ht = Ht.parentNode;
        Ht !== document.body && Ht !== document.documentElement ? (Ht === document && (Ht = zn()), c.top += Ht.scrollTop, c.left += Ht.scrollLeft) : Ht = zn(), il = Gf(Ht);
      }
      Be = ye.cloneNode(!0), vt(Be, u.ghostClass, !1), vt(Be, u.fallbackClass, !0), vt(Be, u.dragClass, !0), Pe(Be, "transition", ""), Pe(Be, "transform", ""), Pe(Be, "box-sizing", "border-box"), Pe(Be, "margin", 0), Pe(Be, "top", c.top), Pe(Be, "left", c.left), Pe(Be, "width", c.width), Pe(Be, "height", c.height), Pe(Be, "opacity", "0.8"), Pe(Be, "position", Vo ? "absolute" : "fixed"), Pe(Be, "zIndex", "100000"), Pe(Be, "pointerEvents", "none"), Le.ghost = Be, r.appendChild(Be), Pe(Be, "transform-origin", Kf / parseInt(Be.style.width) * 100 + "% " + Xf / parseInt(Be.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(r, c) {
    var u = this, p = r.dataTransfer, h = u.options;
    if (Qt("dragStart", this, {
      evt: r
    }), Le.eventCanceled) {
      this._onDrop();
      return;
    }
    Qt("setupClone", this), Le.eventCanceled || (_t = Sl(ye), _t.draggable = !1, _t.style["will-change"] = "", this._hideClone(), vt(_t, this.options.chosenClass, !1), Le.clone = _t), u.cloneId = Zo(function() {
      Qt("clone", u), !Le.eventCanceled && (u.options.removeCloneOnHide || gt.insertBefore(_t, ye), u._hideClone(), Xt({
        sortable: u,
        name: "clone"
      }));
    }), !c && vt(ye, h.dragClass, !0), c ? (Jo = !0, u._loopId = setInterval(u._emulateDragOver, 50)) : (He(document, "mouseup", u._onDrop), He(document, "touchend", u._onDrop), He(document, "touchcancel", u._onDrop), p && (p.effectAllowed = "move", h.setData && h.setData.call(u, p, ye)), Ye(document, "drop", u), Pe(ye, "transform", "translateZ(0)")), Qi = !0, u._dragStartId = Zo(u._dragStarted.bind(u, c, r)), Ye(document, "selectstart", u), Pr = !0, fl && Pe(document.body, "user-select", "none");
  },
  _onDragOver: function(r) {
    var c = this.el, u = r.target, p, h, v, w = this.options, x = w.group, k = Le.active, P = jo === x, R = w.sort, $ = Lt || k, J, X = this, H = !1;
    if (pl)
      return;
    function W(Te, Me) {
      Qt(Te, X, gi({
        evt: r,
        isOwner: P,
        axis: J ? "vertical" : "horizontal",
        revert: v,
        dragRect: p,
        targetRect: h,
        canSort: R,
        fromSortable: $,
        target: u,
        completed: ee,
        onMove: function(Ce, q) {
          return rl(gt, c, ye, p, Ce, yt(Ce), r, q);
        },
        changed: ne
      }, Me));
    }
    function Z() {
      W("dragOverAnimationCapture"), X.captureAnimationState(), X !== $ && $.captureAnimationState();
    }
    function ee(Te) {
      return W("dragOverCompleted", {
        insertion: Te
      }), Te && (P ? k._hideClone() : k._showClone(X), X !== $ && (vt(ye, Lt ? Lt.options.ghostClass : k.options.ghostClass, !1), vt(ye, w.ghostClass, !0)), Lt !== X && X !== Le.active ? Lt = X : X === Le.active && Lt && (Lt = null), $ === X && (X._ignoreWhileAnimating = u), X.animateAll(function() {
        W("dragOverAnimationComplete"), X._ignoreWhileAnimating = null;
      }), X !== $ && ($.animateAll(), $._ignoreWhileAnimating = null)), (u === ye && !ye.animated || u === c && !u.animated) && (Ki = null), !w.dragoverBubble && !r.rootEl && u !== document && (ye.parentNode[Wt]._isOutsideThisEl(r.target), !Te && Pi(r)), !w.dragoverBubble && r.stopPropagation && r.stopPropagation(), H = !0;
    }
    function ne() {
      ln = wt(ye), fi = wt(ye, w.draggable), Xt({
        sortable: X,
        name: "change",
        toEl: c,
        newIndex: ln,
        newDraggableIndex: fi,
        originalEvent: r
      });
    }
    if (r.preventDefault !== void 0 && r.cancelable && r.preventDefault(), u = Cn(u, w.draggable, c, !0), W("dragOver"), Le.eventCanceled)
      return H;
    if (ye.contains(r.target) || u.animated && u.animatingX && u.animatingY || X._ignoreWhileAnimating === u)
      return ee(!1);
    if (Jo = !1, k && !w.disabled && (P ? R || (v = !gt.contains(ye)) : Lt === this || (this.lastPutMode = jo.checkPull(this, k, ye, r)) && x.checkPut(this, k, ye, r))) {
      if (J = this._getDirection(r, u) === "vertical", p = yt(ye), W("dragOverValid"), Le.eventCanceled)
        return H;
      if (v)
        return At = gt, Z(), this._hideClone(), W("revert"), Le.eventCanceled || (Mi ? gt.insertBefore(ye, Mi) : gt.appendChild(ye)), ee(!0);
      var se = xl(c, w.draggable);
      if (!se || QC(r, J, this) && !se.animated) {
        if (se === ye)
          return ee(!1);
        if (se && c === r.target && (u = se), u && (h = yt(u)), rl(gt, c, ye, p, u, h, r, !!u) !== !1)
          return Z(), c.appendChild(ye), At = c, ne(), ee(!0);
      } else if (u.parentNode === c) {
        h = yt(u);
        var pe = 0, ge, Oe = ye.parentNode !== c, ke = !qC(ye.animated && ye.toRect || p, u.animated && u.toRect || h, J), we = J ? "top" : "left", F = qf(u, "top", "top") || qf(ye, "top", "top"), _ = F ? F.scrollTop : void 0;
        Ki !== u && (ge = h[we], Lr = !1, Bo = !ke && w.invertSwap || Oe), pe = JC(r, u, h, J, ke ? 1 : w.swapThreshold, w.invertedSwapThreshold == null ? w.swapThreshold : w.invertedSwapThreshold, Bo, Ki === u);
        var E;
        if (pe !== 0) {
          var B = wt(ye);
          do
            B -= pe, E = At.children[B];
          while (E && (Pe(E, "display") === "none" || E === Be));
        }
        if (pe === 0 || E === u)
          return ee(!1);
        Ki = u, Rr = pe;
        var Y = u.nextElementSibling, N = !1;
        N = pe === 1;
        var re = rl(gt, c, ye, p, u, h, r, N);
        if (re !== !1)
          return (re === 1 || re === -1) && (N = re === 1), pl = !0, setTimeout(XC, 30), Z(), N && !Y ? c.appendChild(ye) : u.parentNode.insertBefore(ye, N ? Y : u), F && Dp(F, 0, _ - F.scrollTop), At = ye.parentNode, ge !== void 0 && !Bo && (Go = Math.abs(ge - yt(u)[we])), ne(), ee(!0);
      }
      if (c.contains(ye))
        return ee(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    He(document, "mousemove", this._onTouchMove), He(document, "touchmove", this._onTouchMove), He(document, "pointermove", this._onTouchMove), He(document, "dragover", Pi), He(document, "mousemove", Pi), He(document, "touchmove", Pi);
  },
  _offUpEvents: function() {
    var r = this.el.ownerDocument;
    He(r, "mouseup", this._onDrop), He(r, "touchend", this._onDrop), He(r, "pointerup", this._onDrop), He(r, "touchcancel", this._onDrop), He(document, "selectstart", this);
  },
  _onDrop: function(r) {
    var c = this.el, u = this.options;
    if (ln = wt(ye), fi = wt(ye, u.draggable), Qt("drop", this, {
      evt: r
    }), At = ye && ye.parentNode, ln = wt(ye), fi = wt(ye, u.draggable), Le.eventCanceled) {
      this._nulling();
      return;
    }
    Qi = !1, Bo = !1, Lr = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), ml(this.cloneId), ml(this._dragStartId), this.nativeDraggable && (He(document, "drop", this), He(c, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), fl && Pe(document.body, "user-select", ""), Pe(ye, "transform", ""), r && (Pr && (r.cancelable && r.preventDefault(), !u.dropBubble && r.stopPropagation()), Be && Be.parentNode && Be.parentNode.removeChild(Be), (gt === At || Lt && Lt.lastPutMode !== "clone") && _t && _t.parentNode && _t.parentNode.removeChild(_t), ye && (this.nativeDraggable && He(ye, "dragend", this), ol(ye), ye.style["will-change"] = "", Pr && !Qi && vt(ye, Lt ? Lt.options.ghostClass : this.options.ghostClass, !1), vt(ye, this.options.chosenClass, !1), Xt({
      sortable: this,
      name: "unchoose",
      toEl: At,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: r
    }), gt !== At ? (ln >= 0 && (Xt({
      rootEl: At,
      name: "add",
      toEl: At,
      fromEl: gt,
      originalEvent: r
    }), Xt({
      sortable: this,
      name: "remove",
      toEl: At,
      originalEvent: r
    }), Xt({
      rootEl: At,
      name: "sort",
      toEl: At,
      fromEl: gt,
      originalEvent: r
    }), Xt({
      sortable: this,
      name: "sort",
      toEl: At,
      originalEvent: r
    })), Lt && Lt.save()) : ln !== er && ln >= 0 && (Xt({
      sortable: this,
      name: "update",
      toEl: At,
      originalEvent: r
    }), Xt({
      sortable: this,
      name: "sort",
      toEl: At,
      originalEvent: r
    })), Le.active && ((ln == null || ln === -1) && (ln = er, fi = Nr), Xt({
      sortable: this,
      name: "end",
      toEl: At,
      originalEvent: r
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Qt("nulling", this), gt = ye = At = Be = Mi = _t = qo = pi = Ei = kn = Pr = ln = fi = er = Nr = Ki = Rr = Lt = jo = Le.dragged = Le.ghost = Le.clone = Le.active = null, ts.forEach(function(r) {
      r.checked = !0;
    }), ts.length = tl = nl = 0;
  },
  handleEvent: function(r) {
    switch (r.type) {
      case "drop":
      case "dragend":
        this._onDrop(r);
        break;
      case "dragenter":
      case "dragover":
        ye && (this._onDragOver(r), KC(r));
        break;
      case "selectstart":
        r.preventDefault();
        break;
    }
  },
  toArray: function() {
    for (var r = [], c, u = this.el.children, p = 0, h = u.length, v = this.options; p < h; p++)
      c = u[p], Cn(c, v.draggable, this.el, !1) && r.push(c.getAttribute(v.dataIdAttr) || tA(c));
    return r;
  },
  sort: function(r) {
    var c = {}, u = this.el;
    this.toArray().forEach(function(p, h) {
      var v = u.children[h];
      Cn(v, this.options.draggable, u, !1) && (c[p] = v);
    }, this), r.forEach(function(p) {
      c[p] && (u.removeChild(c[p]), u.appendChild(c[p]));
    });
  },
  save: function() {
    var r = this.options.store;
    r && r.set && r.set(this);
  },
  closest: function(r, c) {
    return Cn(r, c || this.options.draggable, this.el, !1);
  },
  option: function(r, c) {
    var u = this.options;
    if (c === void 0)
      return u[r];
    var p = jr.modifyOption(this, r, c);
    typeof p < "u" ? u[r] = p : u[r] = c, r === "group" && Lp(u);
  },
  destroy: function() {
    Qt("destroy", this);
    var r = this.el;
    r[Wt] = null, He(r, "mousedown", this._onTapStart), He(r, "touchstart", this._onTapStart), He(r, "pointerdown", this._onTapStart), this.nativeDraggable && (He(r, "dragover", this), He(r, "dragenter", this)), Array.prototype.forEach.call(r.querySelectorAll("[draggable]"), function(c) {
      c.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), es.splice(es.indexOf(this.el), 1), this.el = r = null;
  },
  _hideClone: function() {
    if (!pi) {
      if (Qt("hideClone", this), Le.eventCanceled)
        return;
      Pe(_t, "display", "none"), this.options.removeCloneOnHide && _t.parentNode && _t.parentNode.removeChild(_t), pi = !0;
    }
  },
  _showClone: function(r) {
    if (r.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (pi) {
      if (Qt("showClone", this), Le.eventCanceled)
        return;
      gt.contains(ye) && !this.options.group.revertClone ? gt.insertBefore(_t, ye) : Mi ? gt.insertBefore(_t, Mi) : gt.appendChild(_t), this.options.group.revertClone && this.animate(ye, _t), Pe(_t, "display", ""), pi = !1;
    }
  }
};
function KC(a) {
  a.dataTransfer && (a.dataTransfer.dropEffect = "move"), a.cancelable && a.preventDefault();
}
function rl(a, r, c, u, p, h, v, w) {
  var x, k = a[Wt], P = k.options.onMove, R;
  return window.CustomEvent && !Qn && !$r ? x = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (x = document.createEvent("Event"), x.initEvent("move", !0, !0)), x.to = r, x.from = a, x.dragged = c, x.draggedRect = u, x.related = p || r, x.relatedRect = h || yt(r), x.willInsertAfter = w, x.originalEvent = v, a.dispatchEvent(x), P && (R = P.call(k, x, v)), R;
}
function ol(a) {
  a.draggable = !1;
}
function XC() {
  pl = !1;
}
function QC(a, r, c) {
  var u = yt(xl(c.el, c.options.draggable)), p = 10;
  return r ? a.clientX > u.right + p || a.clientX <= u.right && a.clientY > u.bottom && a.clientX >= u.left : a.clientX > u.right && a.clientY > u.top || a.clientX <= u.right && a.clientY > u.bottom + p;
}
function JC(a, r, c, u, p, h, v, w) {
  var x = u ? a.clientY : a.clientX, k = u ? c.height : c.width, P = u ? c.top : c.left, R = u ? c.bottom : c.right, $ = !1;
  if (!v) {
    if (w && Go < k * p) {
      if (!Lr && (Rr === 1 ? x > P + k * h / 2 : x < R - k * h / 2) && (Lr = !0), Lr)
        $ = !0;
      else if (Rr === 1 ? x < P + Go : x > R - Go)
        return -Rr;
    } else if (x > P + k * (1 - p) / 2 && x < R - k * (1 - p) / 2)
      return eA(r);
  }
  return $ = $ || v, $ && (x < P + k * h / 2 || x > R - k * h / 2) ? x > P + k / 2 ? 1 : -1 : 0;
}
function eA(a) {
  return wt(ye) < wt(a) ? 1 : -1;
}
function tA(a) {
  for (var r = a.tagName + a.className + a.src + a.href + a.textContent, c = r.length, u = 0; c--; )
    u += r.charCodeAt(c);
  return u.toString(36);
}
function nA(a) {
  ts.length = 0;
  for (var r = a.getElementsByTagName("input"), c = r.length; c--; ) {
    var u = r[c];
    u.checked && ts.push(u);
  }
}
function Zo(a) {
  return setTimeout(a, 0);
}
function ml(a) {
  return clearTimeout(a);
}
ss && Ye(document, "touchmove", function(a) {
  (Le.active || Qi) && a.cancelable && a.preventDefault();
});
Le.utils = {
  on: Ye,
  off: He,
  css: Pe,
  find: Mp,
  is: function(r, c) {
    return !!Cn(r, c, r, !1);
  },
  extend: BC,
  throttle: Op,
  closest: Cn,
  toggleClass: vt,
  clone: Sl,
  index: wt,
  nextTick: Zo,
  cancelNextTick: ml,
  detectDirection: Rp,
  getChild: Qo
};
Le.get = function(a) {
  return a[Wt];
};
Le.mount = function() {
  for (var a = arguments.length, r = new Array(a), c = 0; c < a; c++)
    r[c] = arguments[c];
  r[0].constructor === Array && (r = r[0]), r.forEach(function(u) {
    if (!u.prototype || !u.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(u));
    u.utils && (Le.utils = gi({}, Le.utils, u.utils)), jr.mount(u);
  });
};
Le.create = function(a, r) {
  return new Le(a, r);
};
Le.version = FC;
var It = [], Mr, gl, vl = !1, sl, al, ns, Or;
function iA() {
  function a() {
    this.defaults = {
      scroll: !0,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var r in this)
      r.charAt(0) === "_" && typeof this[r] == "function" && (this[r] = this[r].bind(this));
  }
  return a.prototype = {
    dragStarted: function(c) {
      var u = c.originalEvent;
      this.sortable.nativeDraggable ? Ye(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? Ye(document, "pointermove", this._handleFallbackAutoScroll) : u.touches ? Ye(document, "touchmove", this._handleFallbackAutoScroll) : Ye(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(c) {
      var u = c.originalEvent;
      !this.options.dragOverBubble && !u.rootEl && this._handleAutoScroll(u);
    },
    drop: function() {
      this.sortable.nativeDraggable ? He(document, "dragover", this._handleAutoScroll) : (He(document, "pointermove", this._handleFallbackAutoScroll), He(document, "touchmove", this._handleFallbackAutoScroll), He(document, "mousemove", this._handleFallbackAutoScroll)), Jf(), Ko(), VC();
    },
    nulling: function() {
      ns = gl = Mr = vl = Or = sl = al = null, It.length = 0;
    },
    _handleFallbackAutoScroll: function(c) {
      this._handleAutoScroll(c, !0);
    },
    _handleAutoScroll: function(c, u) {
      var p = this, h = (c.touches ? c.touches[0] : c).clientX, v = (c.touches ? c.touches[0] : c).clientY, w = document.elementFromPoint(h, v);
      if (ns = c, u || $r || Qn || fl) {
        ll(c, this.options, w, u);
        var x = mi(w, !0);
        vl && (!Or || h !== sl || v !== al) && (Or && Jf(), Or = setInterval(function() {
          var k = mi(document.elementFromPoint(h, v), !0);
          k !== x && (x = k, Ko()), ll(c, p.options, k, u);
        }, 10), sl = h, al = v);
      } else {
        if (!this.options.bubbleScroll || mi(w, !0) === zn()) {
          Ko();
          return;
        }
        ll(c, this.options, mi(w, !1), !1);
      }
    }
  }, gn(a, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function Ko() {
  It.forEach(function(a) {
    clearInterval(a.pid);
  }), It = [];
}
function Jf() {
  clearInterval(Or);
}
var ll = Op(function(a, r, c, u) {
  if (!!r.scroll) {
    var p = (a.touches ? a.touches[0] : a).clientX, h = (a.touches ? a.touches[0] : a).clientY, v = r.scrollSensitivity, w = r.scrollSpeed, x = zn(), k = !1, P;
    gl !== c && (gl = c, Ko(), Mr = r.scroll, P = r.scrollFn, Mr === !0 && (Mr = mi(c, !0)));
    var R = 0, $ = Mr;
    do {
      var J = $, X = yt(J), H = X.top, W = X.bottom, Z = X.left, ee = X.right, ne = X.width, se = X.height, pe = void 0, ge = void 0, Oe = J.scrollWidth, ke = J.scrollHeight, we = Pe(J), F = J.scrollLeft, _ = J.scrollTop;
      J === x ? (pe = ne < Oe && (we.overflowX === "auto" || we.overflowX === "scroll" || we.overflowX === "visible"), ge = se < ke && (we.overflowY === "auto" || we.overflowY === "scroll" || we.overflowY === "visible")) : (pe = ne < Oe && (we.overflowX === "auto" || we.overflowX === "scroll"), ge = se < ke && (we.overflowY === "auto" || we.overflowY === "scroll"));
      var E = pe && (Math.abs(ee - p) <= v && F + ne < Oe) - (Math.abs(Z - p) <= v && !!F), B = ge && (Math.abs(W - h) <= v && _ + se < ke) - (Math.abs(H - h) <= v && !!_);
      if (!It[R])
        for (var Y = 0; Y <= R; Y++)
          It[Y] || (It[Y] = {});
      (It[R].vx != E || It[R].vy != B || It[R].el !== J) && (It[R].el = J, It[R].vx = E, It[R].vy = B, clearInterval(It[R].pid), (E != 0 || B != 0) && (k = !0, It[R].pid = setInterval(function() {
        u && this.layer === 0 && Le.active._onTouchMove(ns);
        var N = It[this.layer].vy ? It[this.layer].vy * w : 0, re = It[this.layer].vx ? It[this.layer].vx * w : 0;
        typeof P == "function" && P.call(Le.dragged.parentNode[Wt], re, N, a, ns, It[this.layer].el) !== "continue" || Dp(It[this.layer].el, re, N);
      }.bind({
        layer: R
      }), 24))), R++;
    } while (r.bubbleScroll && $ !== x && ($ = mi($, !1)));
    vl = k;
  }
}, 30), $p = function(r) {
  var c = r.originalEvent, u = r.putSortable, p = r.dragEl, h = r.activeSortable, v = r.dispatchSortableEvent, w = r.hideGhostForTarget, x = r.unhideGhostForTarget;
  if (!!c) {
    var k = u || h;
    w();
    var P = c.changedTouches && c.changedTouches.length ? c.changedTouches[0] : c, R = document.elementFromPoint(P.clientX, P.clientY);
    x(), k && !k.el.contains(R) && (v("spill"), this.onSpill({
      dragEl: p,
      putSortable: u
    }));
  }
};
function Cl() {
}
Cl.prototype = {
  startIndex: null,
  dragStart: function(r) {
    var c = r.oldDraggableIndex;
    this.startIndex = c;
  },
  onSpill: function(r) {
    var c = r.dragEl, u = r.putSortable;
    this.sortable.captureAnimationState(), u && u.captureAnimationState();
    var p = Qo(this.sortable.el, this.startIndex, this.options);
    p ? this.sortable.el.insertBefore(c, p) : this.sortable.el.appendChild(c), this.sortable.animateAll(), u && u.animateAll();
  },
  drop: $p
};
gn(Cl, {
  pluginName: "revertOnSpill"
});
function Al() {
}
Al.prototype = {
  onSpill: function(r) {
    var c = r.dragEl, u = r.putSortable, p = u || this.sortable;
    p.captureAnimationState(), c.parentNode && c.parentNode.removeChild(c), p.animateAll();
  },
  drop: $p
};
gn(Al, {
  pluginName: "removeOnSpill"
});
var mn;
function rA() {
  function a() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return a.prototype = {
    dragStart: function(c) {
      var u = c.dragEl;
      mn = u;
    },
    dragOverValid: function(c) {
      var u = c.completed, p = c.target, h = c.onMove, v = c.activeSortable, w = c.changed, x = c.cancel;
      if (!!v.options.swap) {
        var k = this.sortable.el, P = this.options;
        if (p && p !== k) {
          var R = mn;
          h(p) !== !1 ? (vt(p, P.swapClass, !0), mn = p) : mn = null, R && R !== mn && vt(R, P.swapClass, !1);
        }
        w(), u(!0), x();
      }
    },
    drop: function(c) {
      var u = c.activeSortable, p = c.putSortable, h = c.dragEl, v = p || this.sortable, w = this.options;
      mn && vt(mn, w.swapClass, !1), mn && (w.swap || p && p.options.swap) && h !== mn && (v.captureAnimationState(), v !== u && u.captureAnimationState(), oA(h, mn), v.animateAll(), v !== u && u.animateAll());
    },
    nulling: function() {
      mn = null;
    }
  }, gn(a, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: mn
      };
    }
  });
}
function oA(a, r) {
  var c = a.parentNode, u = r.parentNode, p, h;
  !c || !u || c.isEqualNode(r) || u.isEqualNode(a) || (p = wt(a), h = wt(r), c.isEqualNode(u) && p < h && h++, c.insertBefore(r, c.children[p]), u.insertBefore(a, u.children[h]));
}
var je = [], an = [], Cr, xn, Ar = !1, on = !1, Xi = !1, lt, Tr, Uo;
function sA() {
  function a(r) {
    for (var c in this)
      c.charAt(0) === "_" && typeof this[c] == "function" && (this[c] = this[c].bind(this));
    r.options.supportPointer ? Ye(document, "pointerup", this._deselectMultiDrag) : (Ye(document, "mouseup", this._deselectMultiDrag), Ye(document, "touchend", this._deselectMultiDrag)), Ye(document, "keydown", this._checkKeyDown), Ye(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      setData: function(p, h) {
        var v = "";
        je.length && xn === r ? je.forEach(function(w, x) {
          v += (x ? ", " : "") + w.textContent;
        }) : v = h.textContent, p.setData("Text", v);
      }
    };
  }
  return a.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(c) {
      var u = c.dragEl;
      lt = u;
    },
    delayEnded: function() {
      this.isMultiDrag = ~je.indexOf(lt);
    },
    setupClone: function(c) {
      var u = c.sortable, p = c.cancel;
      if (!!this.isMultiDrag) {
        for (var h = 0; h < je.length; h++)
          an.push(Sl(je[h])), an[h].sortableIndex = je[h].sortableIndex, an[h].draggable = !1, an[h].style["will-change"] = "", vt(an[h], this.options.selectedClass, !1), je[h] === lt && vt(an[h], this.options.chosenClass, !1);
        u._hideClone(), p();
      }
    },
    clone: function(c) {
      var u = c.sortable, p = c.rootEl, h = c.dispatchSortableEvent, v = c.cancel;
      !this.isMultiDrag || this.options.removeCloneOnHide || je.length && xn === u && (ep(!0, p), h("clone"), v());
    },
    showClone: function(c) {
      var u = c.cloneNowShown, p = c.rootEl, h = c.cancel;
      !this.isMultiDrag || (ep(!1, p), an.forEach(function(v) {
        Pe(v, "display", "");
      }), u(), Uo = !1, h());
    },
    hideClone: function(c) {
      var u = this;
      c.sortable;
      var p = c.cloneNowHidden, h = c.cancel;
      !this.isMultiDrag || (an.forEach(function(v) {
        Pe(v, "display", "none"), u.options.removeCloneOnHide && v.parentNode && v.parentNode.removeChild(v);
      }), p(), Uo = !0, h());
    },
    dragStartGlobal: function(c) {
      c.sortable, !this.isMultiDrag && xn && xn.multiDrag._deselectMultiDrag(), je.forEach(function(u) {
        u.sortableIndex = wt(u);
      }), je = je.sort(function(u, p) {
        return u.sortableIndex - p.sortableIndex;
      }), Xi = !0;
    },
    dragStarted: function(c) {
      var u = this, p = c.sortable;
      if (!!this.isMultiDrag) {
        if (this.options.sort && (p.captureAnimationState(), this.options.animation)) {
          je.forEach(function(v) {
            v !== lt && Pe(v, "position", "absolute");
          });
          var h = yt(lt, !1, !0, !0);
          je.forEach(function(v) {
            v !== lt && Zf(v, h);
          }), on = !0, Ar = !0;
        }
        p.animateAll(function() {
          on = !1, Ar = !1, u.options.animation && je.forEach(function(v) {
            Ja(v);
          }), u.options.sort && Ho();
        });
      }
    },
    dragOver: function(c) {
      var u = c.target, p = c.completed, h = c.cancel;
      on && ~je.indexOf(u) && (p(!1), h());
    },
    revert: function(c) {
      var u = c.fromSortable, p = c.rootEl, h = c.sortable, v = c.dragRect;
      je.length > 1 && (je.forEach(function(w) {
        h.addAnimationState({
          target: w,
          rect: on ? yt(w) : v
        }), Ja(w), w.fromRect = v, u.removeAnimationState(w);
      }), on = !1, aA(!this.options.removeCloneOnHide, p));
    },
    dragOverCompleted: function(c) {
      var u = c.sortable, p = c.isOwner, h = c.insertion, v = c.activeSortable, w = c.parentEl, x = c.putSortable, k = this.options;
      if (h) {
        if (p && v._hideClone(), Ar = !1, k.animation && je.length > 1 && (on || !p && !v.options.sort && !x)) {
          var P = yt(lt, !1, !0, !0);
          je.forEach(function($) {
            $ !== lt && (Zf($, P), w.appendChild($));
          }), on = !0;
        }
        if (!p)
          if (on || Ho(), je.length > 1) {
            var R = Uo;
            v._showClone(u), v.options.animation && !Uo && R && an.forEach(function($) {
              v.addAnimationState({
                target: $,
                rect: Tr
              }), $.fromRect = Tr, $.thisAnimationDuration = null;
            });
          } else
            v._showClone(u);
      }
    },
    dragOverAnimationCapture: function(c) {
      var u = c.dragRect, p = c.isOwner, h = c.activeSortable;
      if (je.forEach(function(w) {
        w.thisAnimationDuration = null;
      }), h.options.animation && !p && h.multiDrag.isMultiDrag) {
        Tr = gn({}, u);
        var v = Oi(lt, !0);
        Tr.top -= v.f, Tr.left -= v.e;
      }
    },
    dragOverAnimationComplete: function() {
      on && (on = !1, Ho());
    },
    drop: function(c) {
      var u = c.originalEvent, p = c.rootEl, h = c.parentEl, v = c.sortable, w = c.dispatchSortableEvent, x = c.oldIndex, k = c.putSortable, P = k || this.sortable;
      if (!!u) {
        var R = this.options, $ = h.children;
        if (!Xi)
          if (R.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), vt(lt, R.selectedClass, !~je.indexOf(lt)), ~je.indexOf(lt))
            je.splice(je.indexOf(lt), 1), Cr = null, Er({
              sortable: v,
              rootEl: p,
              name: "deselect",
              targetEl: lt,
              originalEvt: u
            });
          else {
            if (je.push(lt), Er({
              sortable: v,
              rootEl: p,
              name: "select",
              targetEl: lt,
              originalEvt: u
            }), u.shiftKey && Cr && v.el.contains(Cr)) {
              var J = wt(Cr), X = wt(lt);
              if (~J && ~X && J !== X) {
                var H, W;
                for (X > J ? (W = J, H = X) : (W = X, H = J + 1); W < H; W++)
                  ~je.indexOf($[W]) || (vt($[W], R.selectedClass, !0), je.push($[W]), Er({
                    sortable: v,
                    rootEl: p,
                    name: "select",
                    targetEl: $[W],
                    originalEvt: u
                  }));
              }
            } else
              Cr = lt;
            xn = P;
          }
        if (Xi && this.isMultiDrag) {
          if ((h[Wt].options.sort || h !== p) && je.length > 1) {
            var Z = yt(lt), ee = wt(lt, ":not(." + this.options.selectedClass + ")");
            if (!Ar && R.animation && (lt.thisAnimationDuration = null), P.captureAnimationState(), !Ar && (R.animation && (lt.fromRect = Z, je.forEach(function(se) {
              if (se.thisAnimationDuration = null, se !== lt) {
                var pe = on ? yt(se) : Z;
                se.fromRect = pe, P.addAnimationState({
                  target: se,
                  rect: pe
                });
              }
            })), Ho(), je.forEach(function(se) {
              $[ee] ? h.insertBefore(se, $[ee]) : h.appendChild(se), ee++;
            }), x === wt(lt))) {
              var ne = !1;
              je.forEach(function(se) {
                if (se.sortableIndex !== wt(se)) {
                  ne = !0;
                  return;
                }
              }), ne && w("update");
            }
            je.forEach(function(se) {
              Ja(se);
            }), P.animateAll();
          }
          xn = P;
        }
        (p === h || k && k.lastPutMode !== "clone") && an.forEach(function(se) {
          se.parentNode && se.parentNode.removeChild(se);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = Xi = !1, an.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), He(document, "pointerup", this._deselectMultiDrag), He(document, "mouseup", this._deselectMultiDrag), He(document, "touchend", this._deselectMultiDrag), He(document, "keydown", this._checkKeyDown), He(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(c) {
      if (!(typeof Xi < "u" && Xi) && xn === this.sortable && !(c && Cn(c.target, this.options.draggable, this.sortable.el, !1)) && !(c && c.button !== 0))
        for (; je.length; ) {
          var u = je[0];
          vt(u, this.options.selectedClass, !1), je.shift(), Er({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: u,
            originalEvt: c
          });
        }
    },
    _checkKeyDown: function(c) {
      c.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(c) {
      c.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, gn(a, {
    pluginName: "multiDrag",
    utils: {
      select: function(c) {
        var u = c.parentNode[Wt];
        !u || !u.options.multiDrag || ~je.indexOf(c) || (xn && xn !== u && (xn.multiDrag._deselectMultiDrag(), xn = u), vt(c, u.options.selectedClass, !0), je.push(c));
      },
      deselect: function(c) {
        var u = c.parentNode[Wt], p = je.indexOf(c);
        !u || !u.options.multiDrag || !~p || (vt(c, u.options.selectedClass, !1), je.splice(p, 1));
      }
    },
    eventProperties: function() {
      var c = this, u = [], p = [];
      return je.forEach(function(h) {
        u.push({
          multiDragElement: h,
          index: h.sortableIndex
        });
        var v;
        on && h !== lt ? v = -1 : on ? v = wt(h, ":not(." + c.options.selectedClass + ")") : v = wt(h), p.push({
          multiDragElement: h,
          index: v
        });
      }), {
        items: DC(je),
        clones: [].concat(an),
        oldIndicies: u,
        newIndicies: p
      };
    },
    optionListeners: {
      multiDragKey: function(c) {
        return c = c.toLowerCase(), c === "ctrl" ? c = "Control" : c.length > 1 && (c = c.charAt(0).toUpperCase() + c.substr(1)), c;
      }
    }
  });
}
function aA(a, r) {
  je.forEach(function(c, u) {
    var p = r.children[c.sortableIndex + (a ? Number(u) : 0)];
    p ? r.insertBefore(c, p) : r.appendChild(c);
  });
}
function ep(a, r) {
  an.forEach(function(c, u) {
    var p = r.children[c.sortableIndex + (a ? Number(u) : 0)];
    p ? r.insertBefore(c, p) : r.appendChild(c);
  });
}
function Ho() {
  je.forEach(function(a) {
    a !== lt && a.parentNode && a.parentNode.removeChild(a);
  });
}
Le.mount(new iA());
Le.mount(Al, Cl);
const lA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Le,
  MultiDrag: sA,
  Sortable: Le,
  Swap: rA
}, Symbol.toStringTag, { value: "Module" })), cA = /* @__PURE__ */ up(lA);
(function(a, r) {
  (function(u, p) {
    a.exports = p(cA);
  })(typeof self < "u" ? self : An, function(c) {
    return function(u) {
      var p = {};
      function h(v) {
        if (p[v])
          return p[v].exports;
        var w = p[v] = {
          i: v,
          l: !1,
          exports: {}
        };
        return u[v].call(w.exports, w, w.exports, h), w.l = !0, w.exports;
      }
      return h.m = u, h.c = p, h.d = function(v, w, x) {
        h.o(v, w) || Object.defineProperty(v, w, { enumerable: !0, get: x });
      }, h.r = function(v) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(v, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(v, "__esModule", { value: !0 });
      }, h.t = function(v, w) {
        if (w & 1 && (v = h(v)), w & 8 || w & 4 && typeof v == "object" && v && v.__esModule)
          return v;
        var x = /* @__PURE__ */ Object.create(null);
        if (h.r(x), Object.defineProperty(x, "default", { enumerable: !0, value: v }), w & 2 && typeof v != "string")
          for (var k in v)
            h.d(x, k, function(P) {
              return v[P];
            }.bind(null, k));
        return x;
      }, h.n = function(v) {
        var w = v && v.__esModule ? function() {
          return v.default;
        } : function() {
          return v;
        };
        return h.d(w, "a", w), w;
      }, h.o = function(v, w) {
        return Object.prototype.hasOwnProperty.call(v, w);
      }, h.p = "", h(h.s = "fb15");
    }({
      "01f9": function(u, p, h) {
        var v = h("2d00"), w = h("5ca1"), x = h("2aba"), k = h("32e9"), P = h("84f2"), R = h("41a0"), $ = h("7f20"), J = h("38fd"), X = h("2b4c")("iterator"), H = !([].keys && "next" in [].keys()), W = "@@iterator", Z = "keys", ee = "values", ne = function() {
          return this;
        };
        u.exports = function(se, pe, ge, Oe, ke, we, F) {
          R(ge, pe, Oe);
          var _ = function(M) {
            if (!H && M in N)
              return N[M];
            switch (M) {
              case Z:
                return function() {
                  return new ge(this, M);
                };
              case ee:
                return function() {
                  return new ge(this, M);
                };
            }
            return function() {
              return new ge(this, M);
            };
          }, E = pe + " Iterator", B = ke == ee, Y = !1, N = se.prototype, re = N[X] || N[W] || ke && N[ke], Te = re || _(ke), Me = ke ? B ? _("entries") : Te : void 0, Ee = pe == "Array" && N.entries || re, Ce, q, A;
          if (Ee && (A = J(Ee.call(new se())), A !== Object.prototype && A.next && ($(A, E, !0), !v && typeof A[X] != "function" && k(A, X, ne))), B && re && re.name !== ee && (Y = !0, Te = function() {
            return re.call(this);
          }), (!v || F) && (H || Y || !N[X]) && k(N, X, Te), P[pe] = Te, P[E] = ne, ke)
            if (Ce = {
              values: B ? Te : _(ee),
              keys: we ? Te : _(Z),
              entries: Me
            }, F)
              for (q in Ce)
                q in N || x(N, q, Ce[q]);
            else
              w(w.P + w.F * (H || Y), pe, Ce);
          return Ce;
        };
      },
      "02f4": function(u, p, h) {
        var v = h("4588"), w = h("be13");
        u.exports = function(x) {
          return function(k, P) {
            var R = String(w(k)), $ = v(P), J = R.length, X, H;
            return $ < 0 || $ >= J ? x ? "" : void 0 : (X = R.charCodeAt($), X < 55296 || X > 56319 || $ + 1 === J || (H = R.charCodeAt($ + 1)) < 56320 || H > 57343 ? x ? R.charAt($) : X : x ? R.slice($, $ + 2) : (X - 55296 << 10) + (H - 56320) + 65536);
          };
        };
      },
      "0390": function(u, p, h) {
        var v = h("02f4")(!0);
        u.exports = function(w, x, k) {
          return x + (k ? v(w, x).length : 1);
        };
      },
      "0bfb": function(u, p, h) {
        var v = h("cb7c");
        u.exports = function() {
          var w = v(this), x = "";
          return w.global && (x += "g"), w.ignoreCase && (x += "i"), w.multiline && (x += "m"), w.unicode && (x += "u"), w.sticky && (x += "y"), x;
        };
      },
      "0d58": function(u, p, h) {
        var v = h("ce10"), w = h("e11e");
        u.exports = Object.keys || function(k) {
          return v(k, w);
        };
      },
      1495: function(u, p, h) {
        var v = h("86cc"), w = h("cb7c"), x = h("0d58");
        u.exports = h("9e1e") ? Object.defineProperties : function(P, R) {
          w(P);
          for (var $ = x(R), J = $.length, X = 0, H; J > X; )
            v.f(P, H = $[X++], R[H]);
          return P;
        };
      },
      "214f": function(u, p, h) {
        h("b0c5");
        var v = h("2aba"), w = h("32e9"), x = h("79e5"), k = h("be13"), P = h("2b4c"), R = h("520a"), $ = P("species"), J = !x(function() {
          var H = /./;
          return H.exec = function() {
            var W = [];
            return W.groups = { a: "7" }, W;
          }, "".replace(H, "$<a>") !== "7";
        }), X = function() {
          var H = /(?:)/, W = H.exec;
          H.exec = function() {
            return W.apply(this, arguments);
          };
          var Z = "ab".split(H);
          return Z.length === 2 && Z[0] === "a" && Z[1] === "b";
        }();
        u.exports = function(H, W, Z) {
          var ee = P(H), ne = !x(function() {
            var we = {};
            return we[ee] = function() {
              return 7;
            }, ""[H](we) != 7;
          }), se = ne ? !x(function() {
            var we = !1, F = /a/;
            return F.exec = function() {
              return we = !0, null;
            }, H === "split" && (F.constructor = {}, F.constructor[$] = function() {
              return F;
            }), F[ee](""), !we;
          }) : void 0;
          if (!ne || !se || H === "replace" && !J || H === "split" && !X) {
            var pe = /./[ee], ge = Z(
              k,
              ee,
              ""[H],
              function(F, _, E, B, Y) {
                return _.exec === R ? ne && !Y ? { done: !0, value: pe.call(_, E, B) } : { done: !0, value: F.call(E, _, B) } : { done: !1 };
              }
            ), Oe = ge[0], ke = ge[1];
            v(String.prototype, H, Oe), w(
              RegExp.prototype,
              ee,
              W == 2 ? function(we, F) {
                return ke.call(we, this, F);
              } : function(we) {
                return ke.call(we, this);
              }
            );
          }
        };
      },
      "230e": function(u, p, h) {
        var v = h("d3f4"), w = h("7726").document, x = v(w) && v(w.createElement);
        u.exports = function(k) {
          return x ? w.createElement(k) : {};
        };
      },
      "23c6": function(u, p, h) {
        var v = h("2d95"), w = h("2b4c")("toStringTag"), x = v(function() {
          return arguments;
        }()) == "Arguments", k = function(P, R) {
          try {
            return P[R];
          } catch {
          }
        };
        u.exports = function(P) {
          var R, $, J;
          return P === void 0 ? "Undefined" : P === null ? "Null" : typeof ($ = k(R = Object(P), w)) == "string" ? $ : x ? v(R) : (J = v(R)) == "Object" && typeof R.callee == "function" ? "Arguments" : J;
        };
      },
      2621: function(u, p) {
        p.f = Object.getOwnPropertySymbols;
      },
      "2aba": function(u, p, h) {
        var v = h("7726"), w = h("32e9"), x = h("69a8"), k = h("ca5a")("src"), P = h("fa5b"), R = "toString", $ = ("" + P).split(R);
        h("8378").inspectSource = function(J) {
          return P.call(J);
        }, (u.exports = function(J, X, H, W) {
          var Z = typeof H == "function";
          Z && (x(H, "name") || w(H, "name", X)), J[X] !== H && (Z && (x(H, k) || w(H, k, J[X] ? "" + J[X] : $.join(String(X)))), J === v ? J[X] = H : W ? J[X] ? J[X] = H : w(J, X, H) : (delete J[X], w(J, X, H)));
        })(Function.prototype, R, function() {
          return typeof this == "function" && this[k] || P.call(this);
        });
      },
      "2aeb": function(u, p, h) {
        var v = h("cb7c"), w = h("1495"), x = h("e11e"), k = h("613b")("IE_PROTO"), P = function() {
        }, R = "prototype", $ = function() {
          var J = h("230e")("iframe"), X = x.length, H = "<", W = ">", Z;
          for (J.style.display = "none", h("fab2").appendChild(J), J.src = "javascript:", Z = J.contentWindow.document, Z.open(), Z.write(H + "script" + W + "document.F=Object" + H + "/script" + W), Z.close(), $ = Z.F; X--; )
            delete $[R][x[X]];
          return $();
        };
        u.exports = Object.create || function(X, H) {
          var W;
          return X !== null ? (P[R] = v(X), W = new P(), P[R] = null, W[k] = X) : W = $(), H === void 0 ? W : w(W, H);
        };
      },
      "2b4c": function(u, p, h) {
        var v = h("5537")("wks"), w = h("ca5a"), x = h("7726").Symbol, k = typeof x == "function", P = u.exports = function(R) {
          return v[R] || (v[R] = k && x[R] || (k ? x : w)("Symbol." + R));
        };
        P.store = v;
      },
      "2d00": function(u, p) {
        u.exports = !1;
      },
      "2d95": function(u, p) {
        var h = {}.toString;
        u.exports = function(v) {
          return h.call(v).slice(8, -1);
        };
      },
      "2fdb": function(u, p, h) {
        var v = h("5ca1"), w = h("d2c8"), x = "includes";
        v(v.P + v.F * h("5147")(x), "String", {
          includes: function(P) {
            return !!~w(this, P, x).indexOf(P, arguments.length > 1 ? arguments[1] : void 0);
          }
        });
      },
      "32e9": function(u, p, h) {
        var v = h("86cc"), w = h("4630");
        u.exports = h("9e1e") ? function(x, k, P) {
          return v.f(x, k, w(1, P));
        } : function(x, k, P) {
          return x[k] = P, x;
        };
      },
      "38fd": function(u, p, h) {
        var v = h("69a8"), w = h("4bf8"), x = h("613b")("IE_PROTO"), k = Object.prototype;
        u.exports = Object.getPrototypeOf || function(P) {
          return P = w(P), v(P, x) ? P[x] : typeof P.constructor == "function" && P instanceof P.constructor ? P.constructor.prototype : P instanceof Object ? k : null;
        };
      },
      "41a0": function(u, p, h) {
        var v = h("2aeb"), w = h("4630"), x = h("7f20"), k = {};
        h("32e9")(k, h("2b4c")("iterator"), function() {
          return this;
        }), u.exports = function(P, R, $) {
          P.prototype = v(k, { next: w(1, $) }), x(P, R + " Iterator");
        };
      },
      "456d": function(u, p, h) {
        var v = h("4bf8"), w = h("0d58");
        h("5eda")("keys", function() {
          return function(k) {
            return w(v(k));
          };
        });
      },
      4588: function(u, p) {
        var h = Math.ceil, v = Math.floor;
        u.exports = function(w) {
          return isNaN(w = +w) ? 0 : (w > 0 ? v : h)(w);
        };
      },
      4630: function(u, p) {
        u.exports = function(h, v) {
          return {
            enumerable: !(h & 1),
            configurable: !(h & 2),
            writable: !(h & 4),
            value: v
          };
        };
      },
      "4bf8": function(u, p, h) {
        var v = h("be13");
        u.exports = function(w) {
          return Object(v(w));
        };
      },
      5147: function(u, p, h) {
        var v = h("2b4c")("match");
        u.exports = function(w) {
          var x = /./;
          try {
            "/./"[w](x);
          } catch {
            try {
              return x[v] = !1, !"/./"[w](x);
            } catch {
            }
          }
          return !0;
        };
      },
      "520a": function(u, p, h) {
        var v = h("0bfb"), w = RegExp.prototype.exec, x = String.prototype.replace, k = w, P = "lastIndex", R = function() {
          var X = /a/, H = /b*/g;
          return w.call(X, "a"), w.call(H, "a"), X[P] !== 0 || H[P] !== 0;
        }(), $ = /()??/.exec("")[1] !== void 0, J = R || $;
        J && (k = function(H) {
          var W = this, Z, ee, ne, se;
          return $ && (ee = new RegExp("^" + W.source + "$(?!\\s)", v.call(W))), R && (Z = W[P]), ne = w.call(W, H), R && ne && (W[P] = W.global ? ne.index + ne[0].length : Z), $ && ne && ne.length > 1 && x.call(ne[0], ee, function() {
            for (se = 1; se < arguments.length - 2; se++)
              arguments[se] === void 0 && (ne[se] = void 0);
          }), ne;
        }), u.exports = k;
      },
      "52a7": function(u, p) {
        p.f = {}.propertyIsEnumerable;
      },
      5537: function(u, p, h) {
        var v = h("8378"), w = h("7726"), x = "__core-js_shared__", k = w[x] || (w[x] = {});
        (u.exports = function(P, R) {
          return k[P] || (k[P] = R !== void 0 ? R : {});
        })("versions", []).push({
          version: v.version,
          mode: h("2d00") ? "pure" : "global",
          copyright: "\xA9 2019 Denis Pushkarev (zloirock.ru)"
        });
      },
      "5ca1": function(u, p, h) {
        var v = h("7726"), w = h("8378"), x = h("32e9"), k = h("2aba"), P = h("9b43"), R = "prototype", $ = function(J, X, H) {
          var W = J & $.F, Z = J & $.G, ee = J & $.S, ne = J & $.P, se = J & $.B, pe = Z ? v : ee ? v[X] || (v[X] = {}) : (v[X] || {})[R], ge = Z ? w : w[X] || (w[X] = {}), Oe = ge[R] || (ge[R] = {}), ke, we, F, _;
          Z && (H = X);
          for (ke in H)
            we = !W && pe && pe[ke] !== void 0, F = (we ? pe : H)[ke], _ = se && we ? P(F, v) : ne && typeof F == "function" ? P(Function.call, F) : F, pe && k(pe, ke, F, J & $.U), ge[ke] != F && x(ge, ke, _), ne && Oe[ke] != F && (Oe[ke] = F);
        };
        v.core = w, $.F = 1, $.G = 2, $.S = 4, $.P = 8, $.B = 16, $.W = 32, $.U = 64, $.R = 128, u.exports = $;
      },
      "5eda": function(u, p, h) {
        var v = h("5ca1"), w = h("8378"), x = h("79e5");
        u.exports = function(k, P) {
          var R = (w.Object || {})[k] || Object[k], $ = {};
          $[k] = P(R), v(v.S + v.F * x(function() {
            R(1);
          }), "Object", $);
        };
      },
      "5f1b": function(u, p, h) {
        var v = h("23c6"), w = RegExp.prototype.exec;
        u.exports = function(x, k) {
          var P = x.exec;
          if (typeof P == "function") {
            var R = P.call(x, k);
            if (typeof R != "object")
              throw new TypeError("RegExp exec method returned something other than an Object or null");
            return R;
          }
          if (v(x) !== "RegExp")
            throw new TypeError("RegExp#exec called on incompatible receiver");
          return w.call(x, k);
        };
      },
      "613b": function(u, p, h) {
        var v = h("5537")("keys"), w = h("ca5a");
        u.exports = function(x) {
          return v[x] || (v[x] = w(x));
        };
      },
      "626a": function(u, p, h) {
        var v = h("2d95");
        u.exports = Object("z").propertyIsEnumerable(0) ? Object : function(w) {
          return v(w) == "String" ? w.split("") : Object(w);
        };
      },
      6762: function(u, p, h) {
        var v = h("5ca1"), w = h("c366")(!0);
        v(v.P, "Array", {
          includes: function(k) {
            return w(this, k, arguments.length > 1 ? arguments[1] : void 0);
          }
        }), h("9c6c")("includes");
      },
      6821: function(u, p, h) {
        var v = h("626a"), w = h("be13");
        u.exports = function(x) {
          return v(w(x));
        };
      },
      "69a8": function(u, p) {
        var h = {}.hasOwnProperty;
        u.exports = function(v, w) {
          return h.call(v, w);
        };
      },
      "6a99": function(u, p, h) {
        var v = h("d3f4");
        u.exports = function(w, x) {
          if (!v(w))
            return w;
          var k, P;
          if (x && typeof (k = w.toString) == "function" && !v(P = k.call(w)) || typeof (k = w.valueOf) == "function" && !v(P = k.call(w)) || !x && typeof (k = w.toString) == "function" && !v(P = k.call(w)))
            return P;
          throw TypeError("Can't convert object to primitive value");
        };
      },
      7333: function(u, p, h) {
        var v = h("0d58"), w = h("2621"), x = h("52a7"), k = h("4bf8"), P = h("626a"), R = Object.assign;
        u.exports = !R || h("79e5")(function() {
          var $ = {}, J = {}, X = Symbol(), H = "abcdefghijklmnopqrst";
          return $[X] = 7, H.split("").forEach(function(W) {
            J[W] = W;
          }), R({}, $)[X] != 7 || Object.keys(R({}, J)).join("") != H;
        }) ? function(J, X) {
          for (var H = k(J), W = arguments.length, Z = 1, ee = w.f, ne = x.f; W > Z; )
            for (var se = P(arguments[Z++]), pe = ee ? v(se).concat(ee(se)) : v(se), ge = pe.length, Oe = 0, ke; ge > Oe; )
              ne.call(se, ke = pe[Oe++]) && (H[ke] = se[ke]);
          return H;
        } : R;
      },
      7726: function(u, p) {
        var h = u.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
        typeof __g == "number" && (__g = h);
      },
      "77f1": function(u, p, h) {
        var v = h("4588"), w = Math.max, x = Math.min;
        u.exports = function(k, P) {
          return k = v(k), k < 0 ? w(k + P, 0) : x(k, P);
        };
      },
      "79e5": function(u, p) {
        u.exports = function(h) {
          try {
            return !!h();
          } catch {
            return !0;
          }
        };
      },
      "7f20": function(u, p, h) {
        var v = h("86cc").f, w = h("69a8"), x = h("2b4c")("toStringTag");
        u.exports = function(k, P, R) {
          k && !w(k = R ? k : k.prototype, x) && v(k, x, { configurable: !0, value: P });
        };
      },
      8378: function(u, p) {
        var h = u.exports = { version: "2.6.5" };
        typeof __e == "number" && (__e = h);
      },
      "84f2": function(u, p) {
        u.exports = {};
      },
      "86cc": function(u, p, h) {
        var v = h("cb7c"), w = h("c69a"), x = h("6a99"), k = Object.defineProperty;
        p.f = h("9e1e") ? Object.defineProperty : function(R, $, J) {
          if (v(R), $ = x($, !0), v(J), w)
            try {
              return k(R, $, J);
            } catch {
            }
          if ("get" in J || "set" in J)
            throw TypeError("Accessors not supported!");
          return "value" in J && (R[$] = J.value), R;
        };
      },
      "9b43": function(u, p, h) {
        var v = h("d8e8");
        u.exports = function(w, x, k) {
          if (v(w), x === void 0)
            return w;
          switch (k) {
            case 1:
              return function(P) {
                return w.call(x, P);
              };
            case 2:
              return function(P, R) {
                return w.call(x, P, R);
              };
            case 3:
              return function(P, R, $) {
                return w.call(x, P, R, $);
              };
          }
          return function() {
            return w.apply(x, arguments);
          };
        };
      },
      "9c6c": function(u, p, h) {
        var v = h("2b4c")("unscopables"), w = Array.prototype;
        w[v] == null && h("32e9")(w, v, {}), u.exports = function(x) {
          w[v][x] = !0;
        };
      },
      "9def": function(u, p, h) {
        var v = h("4588"), w = Math.min;
        u.exports = function(x) {
          return x > 0 ? w(v(x), 9007199254740991) : 0;
        };
      },
      "9e1e": function(u, p, h) {
        u.exports = !h("79e5")(function() {
          return Object.defineProperty({}, "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      },
      a352: function(u, p) {
        u.exports = c;
      },
      a481: function(u, p, h) {
        var v = h("cb7c"), w = h("4bf8"), x = h("9def"), k = h("4588"), P = h("0390"), R = h("5f1b"), $ = Math.max, J = Math.min, X = Math.floor, H = /\$([$&`']|\d\d?|<[^>]*>)/g, W = /\$([$&`']|\d\d?)/g, Z = function(ee) {
          return ee === void 0 ? ee : String(ee);
        };
        h("214f")("replace", 2, function(ee, ne, se, pe) {
          return [
            function(ke, we) {
              var F = ee(this), _ = ke == null ? void 0 : ke[ne];
              return _ !== void 0 ? _.call(ke, F, we) : se.call(String(F), ke, we);
            },
            function(Oe, ke) {
              var we = pe(se, Oe, this, ke);
              if (we.done)
                return we.value;
              var F = v(Oe), _ = String(this), E = typeof ke == "function";
              E || (ke = String(ke));
              var B = F.global;
              if (B) {
                var Y = F.unicode;
                F.lastIndex = 0;
              }
              for (var N = []; ; ) {
                var re = R(F, _);
                if (re === null || (N.push(re), !B))
                  break;
                var Te = String(re[0]);
                Te === "" && (F.lastIndex = P(_, x(F.lastIndex), Y));
              }
              for (var Me = "", Ee = 0, Ce = 0; Ce < N.length; Ce++) {
                re = N[Ce];
                for (var q = String(re[0]), A = $(J(k(re.index), _.length), 0), M = [], Q = 1; Q < re.length; Q++)
                  M.push(Z(re[Q]));
                var z = re.groups;
                if (E) {
                  var te = [q].concat(M, A, _);
                  z !== void 0 && te.push(z);
                  var me = String(ke.apply(void 0, te));
                } else
                  me = ge(q, _, A, M, z, ke);
                A >= Ee && (Me += _.slice(Ee, A) + me, Ee = A + q.length);
              }
              return Me + _.slice(Ee);
            }
          ];
          function ge(Oe, ke, we, F, _, E) {
            var B = we + Oe.length, Y = F.length, N = W;
            return _ !== void 0 && (_ = w(_), N = H), se.call(E, N, function(re, Te) {
              var Me;
              switch (Te.charAt(0)) {
                case "$":
                  return "$";
                case "&":
                  return Oe;
                case "`":
                  return ke.slice(0, we);
                case "'":
                  return ke.slice(B);
                case "<":
                  Me = _[Te.slice(1, -1)];
                  break;
                default:
                  var Ee = +Te;
                  if (Ee === 0)
                    return re;
                  if (Ee > Y) {
                    var Ce = X(Ee / 10);
                    return Ce === 0 ? re : Ce <= Y ? F[Ce - 1] === void 0 ? Te.charAt(1) : F[Ce - 1] + Te.charAt(1) : re;
                  }
                  Me = F[Ee - 1];
              }
              return Me === void 0 ? "" : Me;
            });
          }
        });
      },
      aae3: function(u, p, h) {
        var v = h("d3f4"), w = h("2d95"), x = h("2b4c")("match");
        u.exports = function(k) {
          var P;
          return v(k) && ((P = k[x]) !== void 0 ? !!P : w(k) == "RegExp");
        };
      },
      ac6a: function(u, p, h) {
        for (var v = h("cadf"), w = h("0d58"), x = h("2aba"), k = h("7726"), P = h("32e9"), R = h("84f2"), $ = h("2b4c"), J = $("iterator"), X = $("toStringTag"), H = R.Array, W = {
          CSSRuleList: !0,
          CSSStyleDeclaration: !1,
          CSSValueList: !1,
          ClientRectList: !1,
          DOMRectList: !1,
          DOMStringList: !1,
          DOMTokenList: !0,
          DataTransferItemList: !1,
          FileList: !1,
          HTMLAllCollection: !1,
          HTMLCollection: !1,
          HTMLFormElement: !1,
          HTMLSelectElement: !1,
          MediaList: !0,
          MimeTypeArray: !1,
          NamedNodeMap: !1,
          NodeList: !0,
          PaintRequestList: !1,
          Plugin: !1,
          PluginArray: !1,
          SVGLengthList: !1,
          SVGNumberList: !1,
          SVGPathSegList: !1,
          SVGPointList: !1,
          SVGStringList: !1,
          SVGTransformList: !1,
          SourceBufferList: !1,
          StyleSheetList: !0,
          TextTrackCueList: !1,
          TextTrackList: !1,
          TouchList: !1
        }, Z = w(W), ee = 0; ee < Z.length; ee++) {
          var ne = Z[ee], se = W[ne], pe = k[ne], ge = pe && pe.prototype, Oe;
          if (ge && (ge[J] || P(ge, J, H), ge[X] || P(ge, X, ne), R[ne] = H, se))
            for (Oe in v)
              ge[Oe] || x(ge, Oe, v[Oe], !0);
        }
      },
      b0c5: function(u, p, h) {
        var v = h("520a");
        h("5ca1")({
          target: "RegExp",
          proto: !0,
          forced: v !== /./.exec
        }, {
          exec: v
        });
      },
      be13: function(u, p) {
        u.exports = function(h) {
          if (h == null)
            throw TypeError("Can't call method on  " + h);
          return h;
        };
      },
      c366: function(u, p, h) {
        var v = h("6821"), w = h("9def"), x = h("77f1");
        u.exports = function(k) {
          return function(P, R, $) {
            var J = v(P), X = w(J.length), H = x($, X), W;
            if (k && R != R) {
              for (; X > H; )
                if (W = J[H++], W != W)
                  return !0;
            } else
              for (; X > H; H++)
                if ((k || H in J) && J[H] === R)
                  return k || H || 0;
            return !k && -1;
          };
        };
      },
      c649: function(u, p, h) {
        (function(v) {
          h.d(p, "c", function() {
            return J;
          }), h.d(p, "a", function() {
            return R;
          }), h.d(p, "b", function() {
            return x;
          }), h.d(p, "d", function() {
            return $;
          }), h("a481");
          function w() {
            return typeof window < "u" ? window.console : v.console;
          }
          var x = w();
          function k(X) {
            var H = /* @__PURE__ */ Object.create(null);
            return function(Z) {
              var ee = H[Z];
              return ee || (H[Z] = X(Z));
            };
          }
          var P = /-(\w)/g, R = k(function(X) {
            return X.replace(P, function(H, W) {
              return W ? W.toUpperCase() : "";
            });
          });
          function $(X) {
            X.parentElement !== null && X.parentElement.removeChild(X);
          }
          function J(X, H, W) {
            var Z = W === 0 ? X.children[0] : X.children[W - 1].nextSibling;
            X.insertBefore(H, Z);
          }
        }).call(this, h("c8ba"));
      },
      c69a: function(u, p, h) {
        u.exports = !h("9e1e") && !h("79e5")(function() {
          return Object.defineProperty(h("230e")("div"), "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      },
      c8ba: function(u, p) {
        var h;
        h = function() {
          return this;
        }();
        try {
          h = h || new Function("return this")();
        } catch {
          typeof window == "object" && (h = window);
        }
        u.exports = h;
      },
      ca5a: function(u, p) {
        var h = 0, v = Math.random();
        u.exports = function(w) {
          return "Symbol(".concat(w === void 0 ? "" : w, ")_", (++h + v).toString(36));
        };
      },
      cadf: function(u, p, h) {
        var v = h("9c6c"), w = h("d53b"), x = h("84f2"), k = h("6821");
        u.exports = h("01f9")(Array, "Array", function(P, R) {
          this._t = k(P), this._i = 0, this._k = R;
        }, function() {
          var P = this._t, R = this._k, $ = this._i++;
          return !P || $ >= P.length ? (this._t = void 0, w(1)) : R == "keys" ? w(0, $) : R == "values" ? w(0, P[$]) : w(0, [$, P[$]]);
        }, "values"), x.Arguments = x.Array, v("keys"), v("values"), v("entries");
      },
      cb7c: function(u, p, h) {
        var v = h("d3f4");
        u.exports = function(w) {
          if (!v(w))
            throw TypeError(w + " is not an object!");
          return w;
        };
      },
      ce10: function(u, p, h) {
        var v = h("69a8"), w = h("6821"), x = h("c366")(!1), k = h("613b")("IE_PROTO");
        u.exports = function(P, R) {
          var $ = w(P), J = 0, X = [], H;
          for (H in $)
            H != k && v($, H) && X.push(H);
          for (; R.length > J; )
            v($, H = R[J++]) && (~x(X, H) || X.push(H));
          return X;
        };
      },
      d2c8: function(u, p, h) {
        var v = h("aae3"), w = h("be13");
        u.exports = function(x, k, P) {
          if (v(k))
            throw TypeError("String#" + P + " doesn't accept regex!");
          return String(w(x));
        };
      },
      d3f4: function(u, p) {
        u.exports = function(h) {
          return typeof h == "object" ? h !== null : typeof h == "function";
        };
      },
      d53b: function(u, p) {
        u.exports = function(h, v) {
          return { value: v, done: !!h };
        };
      },
      d8e8: function(u, p) {
        u.exports = function(h) {
          if (typeof h != "function")
            throw TypeError(h + " is not a function!");
          return h;
        };
      },
      e11e: function(u, p) {
        u.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
      },
      f559: function(u, p, h) {
        var v = h("5ca1"), w = h("9def"), x = h("d2c8"), k = "startsWith", P = ""[k];
        v(v.P + v.F * h("5147")(k), "String", {
          startsWith: function($) {
            var J = x(this, $, k), X = w(Math.min(arguments.length > 1 ? arguments[1] : void 0, J.length)), H = String($);
            return P ? P.call(J, H, X) : J.slice(X, X + H.length) === H;
          }
        });
      },
      f6fd: function(u, p) {
        (function(h) {
          var v = "currentScript", w = h.getElementsByTagName("script");
          v in h || Object.defineProperty(h, v, {
            get: function() {
              try {
                throw new Error();
              } catch (P) {
                var x, k = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(P.stack) || [!1])[1];
                for (x in w)
                  if (w[x].src == k || w[x].readyState == "interactive")
                    return w[x];
                return null;
              }
            }
          });
        })(document);
      },
      f751: function(u, p, h) {
        var v = h("5ca1");
        v(v.S + v.F, "Object", { assign: h("7333") });
      },
      fa5b: function(u, p, h) {
        u.exports = h("5537")("native-function-to-string", Function.toString);
      },
      fab2: function(u, p, h) {
        var v = h("7726").document;
        u.exports = v && v.documentElement;
      },
      fb15: function(u, p, h) {
        if (h.r(p), typeof window < "u") {
          h("f6fd");
          var v;
          (v = window.document.currentScript) && (v = v.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) && (h.p = v[1]);
        }
        h("f751"), h("f559"), h("ac6a"), h("cadf"), h("456d");
        function w(q) {
          if (Array.isArray(q))
            return q;
        }
        function x(q, A) {
          if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(q)))) {
            var M = [], Q = !0, z = !1, te = void 0;
            try {
              for (var me = q[Symbol.iterator](), Ie; !(Q = (Ie = me.next()).done) && (M.push(Ie.value), !(A && M.length === A)); Q = !0)
                ;
            } catch (ve) {
              z = !0, te = ve;
            } finally {
              try {
                !Q && me.return != null && me.return();
              } finally {
                if (z)
                  throw te;
              }
            }
            return M;
          }
        }
        function k(q, A) {
          (A == null || A > q.length) && (A = q.length);
          for (var M = 0, Q = new Array(A); M < A; M++)
            Q[M] = q[M];
          return Q;
        }
        function P(q, A) {
          if (!!q) {
            if (typeof q == "string")
              return k(q, A);
            var M = Object.prototype.toString.call(q).slice(8, -1);
            if (M === "Object" && q.constructor && (M = q.constructor.name), M === "Map" || M === "Set")
              return Array.from(q);
            if (M === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(M))
              return k(q, A);
          }
        }
        function R() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        function $(q, A) {
          return w(q) || x(q, A) || P(q, A) || R();
        }
        h("6762"), h("2fdb");
        function J(q) {
          if (Array.isArray(q))
            return k(q);
        }
        function X(q) {
          if (typeof Symbol < "u" && Symbol.iterator in Object(q))
            return Array.from(q);
        }
        function H() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        function W(q) {
          return J(q) || X(q) || P(q) || H();
        }
        var Z = h("a352"), ee = /* @__PURE__ */ h.n(Z), ne = h("c649");
        function se(q, A, M) {
          return M === void 0 || (q = q || {}, q[A] = M), q;
        }
        function pe(q, A) {
          return q.map(function(M) {
            return M.elm;
          }).indexOf(A);
        }
        function ge(q, A, M, Q) {
          if (!q)
            return [];
          var z = q.map(function(Ie) {
            return Ie.elm;
          }), te = A.length - Q, me = W(A).map(function(Ie, ve) {
            return ve >= te ? z.length : z.indexOf(Ie);
          });
          return M ? me.filter(function(Ie) {
            return Ie !== -1;
          }) : me;
        }
        function Oe(q, A) {
          var M = this;
          this.$nextTick(function() {
            return M.$emit(q.toLowerCase(), A);
          });
        }
        function ke(q) {
          var A = this;
          return function(M) {
            A.realList !== null && A["onDrag" + q](M), Oe.call(A, q, M);
          };
        }
        function we(q) {
          return ["transition-group", "TransitionGroup"].includes(q);
        }
        function F(q) {
          if (!q || q.length !== 1)
            return !1;
          var A = $(q, 1), M = A[0].componentOptions;
          return M ? we(M.tag) : !1;
        }
        function _(q, A, M) {
          return q[M] || (A[M] ? A[M]() : void 0);
        }
        function E(q, A, M) {
          var Q = 0, z = 0, te = _(A, M, "header");
          te && (Q = te.length, q = q ? [].concat(W(te), W(q)) : W(te));
          var me = _(A, M, "footer");
          return me && (z = me.length, q = q ? [].concat(W(q), W(me)) : W(me)), {
            children: q,
            headerOffset: Q,
            footerOffset: z
          };
        }
        function B(q, A) {
          var M = null, Q = function(Ne, fe) {
            M = se(M, Ne, fe);
          }, z = Object.keys(q).filter(function(ve) {
            return ve === "id" || ve.startsWith("data-");
          }).reduce(function(ve, Ne) {
            return ve[Ne] = q[Ne], ve;
          }, {});
          if (Q("attrs", z), !A)
            return M;
          var te = A.on, me = A.props, Ie = A.attrs;
          return Q("on", te), Q("props", me), Object.assign(M.attrs, Ie), M;
        }
        var Y = ["Start", "Add", "Remove", "Update", "End"], N = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], re = ["Move"].concat(Y, N).map(function(q) {
          return "on" + q;
        }), Te = null, Me = {
          options: Object,
          list: {
            type: Array,
            required: !1,
            default: null
          },
          value: {
            type: Array,
            required: !1,
            default: null
          },
          noTransitionOnDrag: {
            type: Boolean,
            default: !1
          },
          clone: {
            type: Function,
            default: function(A) {
              return A;
            }
          },
          element: {
            type: String,
            default: "div"
          },
          tag: {
            type: String,
            default: null
          },
          move: {
            type: Function,
            default: null
          },
          componentData: {
            type: Object,
            required: !1,
            default: null
          }
        }, Ee = {
          name: "draggable",
          inheritAttrs: !1,
          props: Me,
          data: function() {
            return {
              transitionMode: !1,
              noneFunctionalComponentMode: !1
            };
          },
          render: function(A) {
            var M = this.$slots.default;
            this.transitionMode = F(M);
            var Q = E(M, this.$slots, this.$scopedSlots), z = Q.children, te = Q.headerOffset, me = Q.footerOffset;
            this.headerOffset = te, this.footerOffset = me;
            var Ie = B(this.$attrs, this.componentData);
            return A(this.getTag(), Ie, z);
          },
          created: function() {
            this.list !== null && this.value !== null && ne.b.error("Value and list props are mutually exclusive! Please set one or another."), this.element !== "div" && ne.b.warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props"), this.options !== void 0 && ne.b.warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
          },
          mounted: function() {
            var A = this;
            if (this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional(), this.noneFunctionalComponentMode && this.transitionMode)
              throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
            var M = {};
            Y.forEach(function(te) {
              M["on" + te] = ke.call(A, te);
            }), N.forEach(function(te) {
              M["on" + te] = Oe.bind(A, te);
            });
            var Q = Object.keys(this.$attrs).reduce(function(te, me) {
              return te[Object(ne.a)(me)] = A.$attrs[me], te;
            }, {}), z = Object.assign({}, this.options, Q, M, {
              onMove: function(me, Ie) {
                return A.onDragMove(me, Ie);
              }
            });
            !("draggable" in z) && (z.draggable = ">*"), this._sortable = new ee.a(this.rootContainer, z), this.computeIndexes();
          },
          beforeDestroy: function() {
            this._sortable !== void 0 && this._sortable.destroy();
          },
          computed: {
            rootContainer: function() {
              return this.transitionMode ? this.$el.children[0] : this.$el;
            },
            realList: function() {
              return this.list ? this.list : this.value;
            }
          },
          watch: {
            options: {
              handler: function(A) {
                this.updateOptions(A);
              },
              deep: !0
            },
            $attrs: {
              handler: function(A) {
                this.updateOptions(A);
              },
              deep: !0
            },
            realList: function() {
              this.computeIndexes();
            }
          },
          methods: {
            getIsFunctional: function() {
              var A = this._vnode.fnOptions;
              return A && A.functional;
            },
            getTag: function() {
              return this.tag || this.element;
            },
            updateOptions: function(A) {
              for (var M in A) {
                var Q = Object(ne.a)(M);
                re.indexOf(Q) === -1 && this._sortable.option(Q, A[M]);
              }
            },
            getChildrenNodes: function() {
              if (this.noneFunctionalComponentMode)
                return this.$children[0].$slots.default;
              var A = this.$slots.default;
              return this.transitionMode ? A[0].child.$slots.default : A;
            },
            computeIndexes: function() {
              var A = this;
              this.$nextTick(function() {
                A.visibleIndexes = ge(A.getChildrenNodes(), A.rootContainer.children, A.transitionMode, A.footerOffset);
              });
            },
            getUnderlyingVm: function(A) {
              var M = pe(this.getChildrenNodes() || [], A);
              if (M === -1)
                return null;
              var Q = this.realList[M];
              return {
                index: M,
                element: Q
              };
            },
            getUnderlyingPotencialDraggableComponent: function(A) {
              var M = A.__vue__;
              return !M || !M.$options || !we(M.$options._componentTag) ? !("realList" in M) && M.$children.length === 1 && "realList" in M.$children[0] ? M.$children[0] : M : M.$parent;
            },
            emitChanges: function(A) {
              var M = this;
              this.$nextTick(function() {
                M.$emit("change", A);
              });
            },
            alterList: function(A) {
              if (this.list) {
                A(this.list);
                return;
              }
              var M = W(this.value);
              A(M), this.$emit("input", M);
            },
            spliceList: function() {
              var A = arguments, M = function(z) {
                return z.splice.apply(z, W(A));
              };
              this.alterList(M);
            },
            updatePosition: function(A, M) {
              var Q = function(te) {
                return te.splice(M, 0, te.splice(A, 1)[0]);
              };
              this.alterList(Q);
            },
            getRelatedContextFromMoveEvent: function(A) {
              var M = A.to, Q = A.related, z = this.getUnderlyingPotencialDraggableComponent(M);
              if (!z)
                return {
                  component: z
                };
              var te = z.realList, me = {
                list: te,
                component: z
              };
              if (M !== Q && te && z.getUnderlyingVm) {
                var Ie = z.getUnderlyingVm(Q);
                if (Ie)
                  return Object.assign(Ie, me);
              }
              return me;
            },
            getVmIndex: function(A) {
              var M = this.visibleIndexes, Q = M.length;
              return A > Q - 1 ? Q : M[A];
            },
            getComponent: function() {
              return this.$slots.default[0].componentInstance;
            },
            resetTransitionData: function(A) {
              if (!(!this.noTransitionOnDrag || !this.transitionMode)) {
                var M = this.getChildrenNodes();
                M[A].data = null;
                var Q = this.getComponent();
                Q.children = [], Q.kept = void 0;
              }
            },
            onDragStart: function(A) {
              this.context = this.getUnderlyingVm(A.item), A.item._underlying_vm_ = this.clone(this.context.element), Te = A.item;
            },
            onDragAdd: function(A) {
              var M = A.item._underlying_vm_;
              if (M !== void 0) {
                Object(ne.d)(A.item);
                var Q = this.getVmIndex(A.newIndex);
                this.spliceList(Q, 0, M), this.computeIndexes();
                var z = {
                  element: M,
                  newIndex: Q
                };
                this.emitChanges({
                  added: z
                });
              }
            },
            onDragRemove: function(A) {
              if (Object(ne.c)(this.rootContainer, A.item, A.oldIndex), A.pullMode === "clone") {
                Object(ne.d)(A.clone);
                return;
              }
              var M = this.context.index;
              this.spliceList(M, 1);
              var Q = {
                element: this.context.element,
                oldIndex: M
              };
              this.resetTransitionData(M), this.emitChanges({
                removed: Q
              });
            },
            onDragUpdate: function(A) {
              Object(ne.d)(A.item), Object(ne.c)(A.from, A.item, A.oldIndex);
              var M = this.context.index, Q = this.getVmIndex(A.newIndex);
              this.updatePosition(M, Q);
              var z = {
                element: this.context.element,
                oldIndex: M,
                newIndex: Q
              };
              this.emitChanges({
                moved: z
              });
            },
            updateProperty: function(A, M) {
              A.hasOwnProperty(M) && (A[M] += this.headerOffset);
            },
            computeFutureIndex: function(A, M) {
              if (!A.element)
                return 0;
              var Q = W(M.to.children).filter(function(Ie) {
                return Ie.style.display !== "none";
              }), z = Q.indexOf(M.related), te = A.component.getVmIndex(z), me = Q.indexOf(Te) !== -1;
              return me || !M.willInsertAfter ? te : te + 1;
            },
            onDragMove: function(A, M) {
              var Q = this.move;
              if (!Q || !this.realList)
                return !0;
              var z = this.getRelatedContextFromMoveEvent(A), te = this.context, me = this.computeFutureIndex(z, A);
              Object.assign(te, {
                futureIndex: me
              });
              var Ie = Object.assign({}, A, {
                relatedContext: z,
                draggedContext: te
              });
              return Q(Ie, M);
            },
            onDragEnd: function() {
              this.computeIndexes(), Te = null;
            }
          }
        };
        typeof window < "u" && "Vue" in window && window.Vue.component("draggable", Ee);
        var Ce = Ee;
        p.default = Ce;
      }
    }).default;
  });
})(Ip);
const jp = /* @__PURE__ */ yl(Ip.exports);
const uA = {
  components: {
    Draggable: jp,
    IconAudio: rp,
    IconUpload: os,
    IconDollar: kC,
    IconMonetize: TC
  },
  props: {
    accept: {
      type: String,
      default: "audio/*"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    adswizz: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fileData: [...this.value].splice(),
      size: 0
    };
  },
  watch: {
    value(a) {
      !a || a.length < 1 ? this.fileData = [] : this.fileData = a;
    }
  },
  methods: {
    adswizzClick() {
      if (this.disabled)
        return;
      const r = { id: Hf(this.fileData), isVast: !0 };
      this.$emit("input", {
        target: {
          value: [...this.fileData, r]
        }
      });
    },
    dragEnd(a) {
      a.oldIndex !== a.newIndex && this.$emit("input", { target: { value: this.fileData } });
    },
    fileClick() {
      this.disabled || this.$refs.audio.click();
    },
    formatFileSizeForDisplay(a) {
      return a ? a >= 1e6 ? `(${(a * 1e-6).toFixed(2)}mb)` : `(${(a * 1e-3).toFixed(2)}kb)` : "";
    },
    setFileInfo(a) {
      if (this.disabled)
        return;
      const r = a.target.files ? a.target.files[0] : a.dataTransfer.files[0];
      if (!r.type || !r.type.startsWith("audio/")) {
        alert("Audio files only");
        return;
      }
      const c = Hf(this.fileData), u = { audio: r, uploadId: c };
      this.$emit("upload", u), this.$emit("input", {
        target: {
          value: [...this.fileData, u]
        }
      }), this.$refs.audio.value = "";
    },
    removeFile(a) {
      if (this.disabled)
        return;
      const r = this.fileData.filter((c, u) => u !== a);
      this.$emit("input", { target: { value: r } });
    }
  }
};
var dA = function() {
  var r = this, c = r._self._c;
  return c("div", { class: ["form-input-audio"] }, [c("input", { ref: "audio", attrs: { id: `form-input-${r.name}`, accept: r.accept, disabled: r.disabled, type: "file" }, on: { change: r.setFileInfo } }), c("div", { class: ["audio", { disabled: r.disabled }] }, [c("Draggable", { attrs: { disabled: r.disabled, group: "fileData", "ghost-class": "ghost" }, on: { end: r.dragEnd }, model: { value: r.fileData, callback: function(u) {
    r.fileData = u;
  }, expression: "fileData" } }, [c("transition-group", r._l(r.fileData, function(u, p) {
    return c("div", { key: u.id ? u.id : u.uploadId, staticClass: "audio-item" }, [c("div", { staticClass: "audio-name" }, [c("div", { staticClass: "drag-icon", attrs: { "aria-hidden": "true" } }, [c("span")]), u.isVast ? c("icon-dollar", { staticClass: "audio-svg-dollar" }) : c("IconAudio", { staticClass: "audio-svg-bars" }), c("div", { staticClass: "audio-title" }, [r._v(" " + r._s(u.isVast ? "Marketplace" : u.audio.name) + " ")])], 1), c("div", { staticClass: "audio-data" }, [u.audio && u.audio.size ? c("span", [r._v(r._s(r.formatFileSizeForDisplay(u.audio.size)))]) : r._e(), c("a", { class: ["remove", { disabled: r.disabled }], on: { click: function(h) {
      return h.stopPropagation(), h.preventDefault(), r.removeFile(p);
    } } }, [r._v("\xD7")])])]);
  }), 0)], 1)], 1), c("div", { class: ["dropzone", { disabled: r.disabled }], on: { dragover: function(u) {
    u.preventDefault();
  }, drop: function(u) {
    return u.preventDefault(), r.setFileInfo.apply(null, arguments);
  }, click: r.fileClick } }, [c("IconUpload", { staticClass: "audio-svg" }), r._m(0)], 1), r.adswizz ? c("div", { class: ["dropzone", { disabled: r.disabled }], on: { click: r.adswizzClick } }, [c("icon-monetize", { staticClass: "audio-svg" }), c("div", { staticClass: "drag-n-drop" }, [r._v("Monetize with Adswizz")])], 1) : r._e()]);
}, hA = [function() {
  var a = this, r = a._self._c;
  return r("div", { staticClass: "drag-n-drop" }, [a._v(" Drag and drop an audio file or\xA0"), r("span", { staticClass: "browse" }, [a._v("Browse")])]);
}], fA = /* @__PURE__ */ he(
  uA,
  dA,
  hA,
  !1,
  null,
  "523c0c2b",
  null,
  null
);
const pA = fA.exports, mA = {
  components: { CustomMultiAudio: pA, FinalField: cn.exports.FinalField },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    adswizz: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    },
    upload(a) {
      this.$emit("upload", a);
    }
  }
};
var gA = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("CustomMultiAudio", r._g({ class: {
      error: u.meta && u.meta.touched && u.meta.error
    }, attrs: { disabled: r.disabled, adswizz: r.adswizz, name: u.name, value: u.value }, on: { blur: r.blur, focus: r.focus, input: r.input, upload: r.upload } }, u.events))], 1);
  } }]) });
}, vA = [], bA = /* @__PURE__ */ he(
  mA,
  gA,
  vA,
  !1,
  null,
  null,
  null,
  null
);
const XP = bA.exports;
const _A = {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  computed: {
    isDetail() {
      return this.options[0].detail !== void 0;
    }
  },
  mounted() {
    this.setSelected();
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    change() {
      this.$emit("input", { target: { value: this.input } });
    },
    focus(a) {
      this.$emit("focus", a);
    },
    select(a) {
      const r = this.options.findIndex((u) => u.value === this.input);
      let c = a + r;
      c = Math.min(c, this.options.length - 1), c = Math.max(0, c), this.input = this.options[c].value;
    },
    setSelected() {
      (!this.input || this.input === "") && (this.input = this.options[0].value), this.change();
    }
  }
};
var wA = function() {
  var r = this, c = r._self._c;
  return c("div", { class: {
    "input-radio-group": !0,
    "input-radio-group__details": r.isDetail
  }, attrs: { tabindex: 0 }, on: { keyup: [function(u) {
    return !u.type.indexOf("key") && u.keyCode !== 37 ? null : r.select(-1);
  }, function(u) {
    return !u.type.indexOf("key") && u.keyCode !== 39 ? null : r.select(1);
  }], focus: r.focus, blur: r.blur } }, r._l(r.options, function(u, p) {
    return c("div", { key: p, class: r.isDetail ? "" : "input-radio__condensed" }, [c("label", { class: ["input-radio input-radio-label", { disabled: r.disabled }], attrs: { for: `form-input-${r.name}${u.value}` } }, [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.input, expression: "input" }], ref: `radio${r.name}${u.value}`, refInFor: !0, attrs: { id: `form-input-${r.name}${u.value}`, name: r.name, tabindex: -1, disabled: r.disabled, type: "radio" }, domProps: { value: u.value, checked: r._q(r.input, u.value) }, on: { change: [function(h) {
      r.input = u.value;
    }, r.change] } }), c("span", { staticClass: "input-radio-indicator" }), r._v(" " + r._s(u.label) + " ")]), u.detail ? c("div", { staticClass: "input-radio-detail", domProps: { innerHTML: r._s(u.detail) } }) : r._e()]);
  }), 0);
}, yA = [], kA = /* @__PURE__ */ he(
  _A,
  wA,
  yA,
  !1,
  null,
  null,
  null,
  null
);
const xA = kA.exports, SA = {
  components: { CustomRadio: xA, FinalField: cn.exports.FinalField },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var CA = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("custom-radio", r._g({ attrs: { value: u.value, name: u.name, options: r.options, disabled: r.disabled }, on: { blur: r.blur, focus: r.focus, input: r.input } }, u.events))], 1);
  } }]) });
}, AA = [], TA = /* @__PURE__ */ he(
  SA,
  CA,
  AA,
  !1,
  null,
  null,
  null,
  null
);
const QP = TA.exports;
const IA = {
  name: "Search",
  components: { IconSearch: ap },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      search: this.value
    };
  },
  watch: {
    value(a) {
      this.search = a;
    }
  },
  methods: {
    keydown(a) {
      this.$emit("keydown", a);
    },
    keyup(a) {
      this.$emit("keyup", a), this.$emit("change", this.search), this.$emit("input", this.search);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    }
  }
};
var EA = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "search" }, [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.search, expression: "search" }], ref: "input", attrs: { placeholder: r.placeholder || "Search", tabindex: "0", type: "search" }, domProps: { value: r.search }, on: { keydown: r.keydown, keyup: r.keyup, focus: r.focus, input: function(u) {
    u.target.composing || (r.search = u.target.value);
  } } }), c("button", { staticClass: "search-button", attrs: { type: "submit" } }, [c("IconSearch")], 1)]);
}, PA = [], MA = /* @__PURE__ */ he(
  IA,
  EA,
  PA,
  !1,
  null,
  "feb141c1",
  null,
  null
);
const Bp = MA.exports;
const OA = {
  components: {
    FormSearch: Bp,
    IconArrow: vi,
    IconCheck: Fr,
    IconLock: wl,
    PodcastArtwork: yp,
    SType: Rt
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Select One"
    },
    prefix: {
      type: String,
      default: null
    },
    search: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Object,
      default: () => ({
        options: [
          {
            disabled: !0,
            label: "Select One",
            selected: !0,
            value: null
          }
        ],
        value: null
      })
    },
    prepend: {
      type: Array,
      default: () => []
    },
    append: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      filter: "",
      focused: !1,
      input: this.value,
      opened: !1,
      navSelected: "",
      scrollFilter: "",
      scrollTimeout: !1,
      optionList: []
    };
  },
  computed: {
    buttonTitle() {
      return this.opened ? "Close Select" : "Open Select";
    },
    buttonDirection() {
      return this.opened ? "up" : "down";
    },
    hasOptions() {
      return this.options.filter((r) => r.disabled !== !0).length > 0;
    },
    isDisabled() {
      if (this.disabled)
        return !0;
      const a = this.options.find((r) => r.disabled);
      return a && a.label ? a.label === this.selected.label : !1;
    },
    options() {
      const a = this.input.options.filter((r) => this.filter === "" ? !0 : r.label.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1);
      return [
        ...this.clearableOption,
        ...this.prepend,
        ...a,
        ...this.append
      ];
    },
    selected() {
      if (!this.input.value && this.input.value !== 0)
        return { disabled: !0, label: this.placeholder, value: null };
      const a = this.input.options.filter((r) => this.input.value === r.value).pop();
      return a !== void 0 ? a : { disabled: !1, label: this.input.value, value: this.input.value };
    },
    clearableOption() {
      const a = [];
      return this.clearable && a.push({
        label: this.placeholder,
        value: null,
        disabled: !1,
        selected: !1
      }), a;
    },
    selectedIndex() {
      return this.options.findIndex((a) => a.value === this.navSelected);
    },
    selectedOption() {
      return this.$refs.option[this.selectedIndex];
    }
  },
  watch: {
    opened(a) {
      a === !0 ? (this.setScroll(), this.$refs.search && this.$refs.search.focusInput(), document.addEventListener("click", this.handleGlobalClick), document.addEventListener("touchstart", this.handleGlobalClick)) : (document.removeEventListener("click", this.handleGlobalClick), document.removeEventListener("touchstart", this.handleGlobalClick));
    },
    value(a) {
      a.value && (a.options.find((c) => c.value === a.value) || (a.value = null, this.$emit("input", { target: { value: a.value } }))), this.input = a, this.$emit("blur", this.input);
    },
    "value.options"(a) {
      this.input.options = a;
    }
  },
  created() {
    this.navSelected = this.input.value;
  },
  methods: {
    addEvents() {
      window.addEventListener("keydown", this.keydownTab);
    },
    blur() {
      this.focused = !1, this.validate(), this.removeEvents(), this.$emit("blur", this.input), this.$emit("input", { target: { value: this.input.value } });
    },
    close() {
      this.opened = !1, this.navSelected = this.selected.value, this.filter = "", this.$nextTick(() => {
        this.$refs.select && this.$refs.select.focus();
      });
    },
    change() {
      this.validate(), this.$emit("change", this.input), this.$emit("input", { target: { value: this.input.value } });
    },
    chooseOption(a) {
      a.disabled || (this.setSelected(a.value), this.close());
    },
    focus() {
      !this.hasOptions || this.disabled || (this.focused = !0, this.addEvents());
    },
    keydown(a) {
      switch (a.keyCode) {
        case 9:
          this.close();
          break;
        case 13:
          this.select();
          break;
        case 27:
          this.close();
          break;
        case 32:
          this.opened || this.open();
          break;
        case 38:
          this.opened && this.selectPrev(), this.open();
          break;
        case 40:
          this.opened && this.selectNext(), this.open();
          break;
      }
    },
    keydownSearch(a) {
      a.keyCode === 9 && (a.stopPropagation(), a.preventDefault()), this.keydown(a);
    },
    keydownTab(a) {
      a.keyCode !== 9 && (a.stopPropagation(), a.preventDefault()), this.keydown(a);
    },
    keyupScroll(a) {
      if (a.key.length > 1 || this.opened && this.search)
        return;
      this.scrollFilter = this.scrollFilter + a.key;
      const r = this.options.findIndex((c) => c.label.toLowerCase().indexOf(this.scrollFilter.toLowerCase()) === 0);
      r >= 0 && (this.navSelected = this.options[r].value, this.setScroll(), this.opened || (this.input.value = this.options[r].value)), clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
        this.scrollFilter = "";
      }, 3e3);
    },
    handleGlobalClick(a) {
      const r = this.$refs.select;
      r !== a.target && !r.contains(a.target) && this.close();
    },
    isSelected(a) {
      return a === this.navSelected;
    },
    open() {
      !this.hasOptions || this.disabled || (this.opened = !0);
    },
    toggleOpen() {
      !this.hasOptions || this.disabled || (this.opened = !this.opened);
    },
    removeEvents() {
      window.removeEventListener("keydown", this.keydown), window.removeEventListener("keydown", this.keydownTab);
    },
    select() {
      this.$refs.select && this.$refs.select.focus(), this.setSelected(this.navSelected), this.close(), this.filter = "";
    },
    selectNext() {
      const r = this.options.findIndex((c) => c.value === this.navSelected) + 1;
      this.options[r] && (this.navSelected = this.options[r].value), this.setScroll();
    },
    selectPrev() {
      const a = this.options.findIndex((c) => c.value === this.navSelected), r = Math.max(0, a - 1);
      this.options[r] && (this.navSelected = this.options[r].value), this.setScroll();
    },
    setScroll() {
      this.$nextTick(() => {
        const a = this.selectedOption ? this.selectedOption.offsetTop : 0;
        this.$refs.options.scrollTop = a - this.$refs.options.offsetTop;
      });
    },
    setSelected(a) {
      this.navSelected = a, this.$set(this.input, "value", a), this.change();
    },
    validate() {
      this.$set(this.input, "error", !1), this.input.required && (!this.input.value || this.input.value === "") && (this.input.error = !0);
    }
  }
};
var DA = function() {
  var r = this, c = r._self._c;
  return c("div", { ref: "select", class: [
    "wrap",
    { focused: r.focused, opened: r.opened },
    { disabled: !r.hasOptions || r.disabled }
  ], attrs: { disabled: !r.hasOptions || r.disabled, tabindex: r.hasOptions ? 0 : -1 }, on: { blur: r.blur, focus: r.focus, keyup: r.keyupScroll } }, [c("div", { class: ["form-input-select", { error: r.error }], on: { click: r.toggleOpen } }, [c("div", { class: ["text", { disabled: !r.selected || r.selected.disabled }] }, [r.selected && r.selected.lock ? c("span", { staticClass: "option" }, [c("IconLock", { attrs: { "aria-hidden": "true", size: "sm" } }), c("span", { staticClass: "label" }, [r._v(r._s(r.selected ? r.selected.label : ""))])], 1) : [r.prefix && r.selected && r.selected.label && r.selected.label !== r.placeholder ? c("SType", { attrs: { variant: "subtitle", tag: "span" } }, [r._v(r._s(r.prefix) + " ")]) : r._e(), r._v(" " + r._s(r.selected ? r.selected.label : "") + " ")]], 2), c("IconArrow", { attrs: { "title-access": r.buttonTitle, direction: r.buttonDirection } })], 1), c("div", { staticClass: "options" }, [c("form-search", { directives: [{ name: "show", rawName: "v-show", value: r.search, expression: "search" }], ref: "search", on: { keydown: function(u) {
    return u.stopPropagation(), r.keydownSearch.apply(null, arguments);
  } }, model: { value: r.filter, callback: function(u) {
    r.filter = u;
  }, expression: "filter" } }), c("div", { ref: "options", staticClass: "options-wrap" }, [c("ul", { ref: "optionsList" }, r._l(r.options, function(u, p) {
    return c("li", { key: p, ref: "option", refInFor: !0, class: {
      selected: r.isSelected(u.value),
      disabled: u.disabled,
      placeholder: u.value === ""
    }, attrs: { disabled: u.disabled, value: u.value }, on: { click: function(h) {
      return h.stopPropagation(), r.chooseOption(u);
    } } }, [c("span", { staticClass: "option-wrap" }, [c("span", { staticClass: "option" }, [u.lock ? c("IconLock", { attrs: { size: "sm", "aria-hidden": "true" } }) : r._e(), u.image_url ? c("podcast-artwork", { staticClass: "image", attrs: { podcast: u, "aria-hidden": "true" } }) : r._e(), c("span", { staticClass: "label" }, [r._v(r._s(u.label))])], 1), u.description ? c("span", { staticClass: "option-description" }, [r._v(" " + r._s(u.description) + " ")]) : r._e()]), r.isSelected(u.value) ? c("IconCheck") : r._e()], 1);
  }), 0)])], 1)]);
}, NA = [], RA = /* @__PURE__ */ he(
  OA,
  DA,
  NA,
  !1,
  null,
  "763ab90b",
  null,
  null
);
const LA = RA.exports, FA = {
  components: { CustomSelect: LA, FinalField: cn.exports.FinalField, HelperText: nr },
  props: {
    append: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    prefix: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: "Select One"
    },
    search: {
      type: Boolean,
      default: !1
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var zA = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("custom-select", r._g({ attrs: { append: r.append, disabled: r.disabled, value: { value: u.value, options: r.options }, name: u.name, search: r.search, clearable: r.clearable, placeholder: r.placeholder, prefix: r.prefix, error: !!(u.meta.touched && u.meta.error) }, on: { blur: r.blur, focus: r.focus, input: r.input } }, u.events)), u.meta.touched && u.meta.error ? c("HelperText", { attrs: { error: !0 } }, [r._v(" " + r._s(u.meta.error) + " ")]) : r._e()], 1);
  } }]) });
}, $A = [], jA = /* @__PURE__ */ he(
  FA,
  zA,
  $A,
  !1,
  null,
  null,
  null,
  null
);
const JP = jA.exports, BA = {
  name: "DragIcon"
};
var VA = function() {
  var r = this, c = r._self._c;
  return c("svg", { attrs: { width: "6px", height: "10px", viewBox: "0 0 6 10", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [c("path", { attrs: { d: "M1,8 C1.55228475,8 2,8.44771525 2,9 C2,9.55228475 1.55228475,10 1,10 C0.44771525,10 0,9.55228475 0,9 C0,8.44771525 0.44771525,8 1,8 Z M5,8 C5.55228475,8 6,8.44771525 6,9 C6,9.55228475 5.55228475,10 5,10 C4.44771525,10 4,9.55228475 4,9 C4,8.44771525 4.44771525,8 5,8 Z M1,4 C1.55228475,4 2,4.44771525 2,5 C2,5.55228475 1.55228475,6 1,6 C0.44771525,6 0,5.55228475 0,5 C0,4.44771525 0.44771525,4 1,4 Z M5,4 C5.55228475,4 6,4.44771525 6,5 C6,5.55228475 5.55228475,6 5,6 C4.44771525,6 4,5.55228475 4,5 C4,4.44771525 4.44771525,4 5,4 Z M1,0 C1.55228475,0 2,0.44771525 2,1 C2,1.55228475 1.55228475,2 1,2 C0.44771525,2 0,1.55228475 0,1 C0,0.44771525 0.44771525,0 1,0 Z M5,0 C5.55228475,0 6,0.44771525 6,1 C6,1.55228475 5.55228475,2 5,2 C4.44771525,2 4,1.55228475 4,1 C4,0.44771525 4.44771525,0 5,0 Z" } })]);
}, UA = [], HA = /* @__PURE__ */ he(
  BA,
  VA,
  UA,
  !1,
  null,
  null,
  null,
  null
);
const WA = HA.exports;
const YA = {
  components: {
    IconDrag: WA
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    sortable: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    remove() {
      this.$emit("remove", this.name);
    }
  }
};
var qA = function() {
  var r = this, c = r._self._c;
  return c("span", { class: ["form-input-tag", { sortable: r.sortable }] }, [r.sortable ? c("IconDrag", { staticClass: "drag-icon" }) : r._e(), r._v(" " + r._s(r.name) + " "), c("a", { attrs: { href: "#", "aria-label": "Remove" }, on: { click: function(u) {
    return u.preventDefault(), r.remove.apply(null, arguments);
  } } }, [r._v("\xD7")])], 1);
}, GA = [], ZA = /* @__PURE__ */ he(
  YA,
  qA,
  GA,
  !1,
  null,
  null,
  null,
  null
);
const Vp = ZA.exports;
const KA = {
  components: { Draggable: jp, FormTag: Vp },
  props: {
    name: {
      type: String,
      default: "tags"
    },
    sortable: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  methods: {
    dragEnd(a) {
      a.oldIndex !== a.newIndex && this.$emit("update", this.input);
    },
    remove(a) {
      this.input.splice(a, 1), this.$emit("update", this.input);
    }
  }
};
var XA = function() {
  var r = this, c = r._self._c;
  return c(r.sortable ? "Draggable" : "div", { tag: "component", staticClass: "form-input-tag-list", attrs: { group: r.name, "ghost-class": "ghost" }, on: { end: r.dragEnd }, model: { value: r.input, callback: function(u) {
    r.input = u;
  }, expression: "input" } }, r._l(r.input, function(u, p) {
    return c("form-tag", { key: p, attrs: { name: u, sortable: r.sortable }, on: { remove: function(h) {
      return r.remove(p);
    } } });
  }), 1);
}, QA = [], JA = /* @__PURE__ */ he(
  KA,
  XA,
  QA,
  !1,
  null,
  null,
  null,
  null
);
const eT = JA.exports;
const tT = {
  name: "FinalFormTaggerSearchList",
  components: {
    ListGroupItem: kp,
    ListGroup: xp
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    emptySearchMessage: {
      type: String,
      default: "No search results"
    },
    helperText: {
      type: String,
      default: "Select from the list, or hit enter to create a new keyword"
    },
    searchTerm: {
      type: String,
      default: ""
    },
    searchResults: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    associateItem(a) {
      this.$emit("select", a);
    },
    deleteItem(a) {
      this.$emit("delete", a);
    }
  }
};
var nT = function() {
  var r = this, c = r._self._c;
  return r.isOpen && r.searchTerm && r.searchTerm.length >= 3 ? c("div", { staticClass: "final-form-tagger-search-list" }, [r.searchResults.length > 0 ? c("ListGroup", { staticClass: "final-form-tagger-search-list__results" }, [c("ListGroupItem", { attrs: { disabled: !0, label: r.helperText } }), r._l(r.searchResults, function(u) {
    return c("ListGroupItem", { key: u.id, attrs: { label: u.value }, on: { click: function(p) {
      return r.associateItem(u);
    }, delete: function(p) {
      return r.deleteItem(u);
    } } });
  })], 2) : c("ListGroup", { staticClass: "final-form-tagger-search-list__results" }, [c("ListGroupItem", { attrs: { disabled: !0, label: r.emptySearchMessage } })], 1)], 1) : r._e();
}, iT = [], rT = /* @__PURE__ */ he(
  tT,
  nT,
  iT,
  !1,
  null,
  "444b9638",
  null,
  null
);
const oT = rT.exports;
const sT = {
  components: {
    FormHelperText: nr,
    Taglist: eT,
    SButton: bi,
    SearchList: oT
  },
  props: {
    isAlphabetical: {
      type: Boolean,
      default: !0
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    hasSearchResults: {
      type: Boolean,
      default: !1
    },
    helpertext: {
      type: String,
      default: "Hit enter or separate tags with commas"
    },
    allowCaps: {
      type: Boolean,
      default: !1
    },
    clearInputText: {
      type: Number,
      default: 0
    },
    searchResults: {
      type: Array
    },
    sortable: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      input: [...this.value],
      inputText: "",
      isSearchListOpen: !1
    };
  },
  watch: {
    value(a) {
      this.input = [...a];
    },
    clearInputText(a, r) {
      a !== r && (this.inputText = "");
    }
  },
  mounted() {
    this.$refs.focusableContents.addEventListener("focusout", (a) => {
      a.currentTarget.contains(a.relatedTarget) ? this.focus(a) : this.blur(a);
    });
  },
  methods: {
    enter(a) {
      const r = a.target.value;
      if (r !== "") {
        let c = [];
        this.allowCaps ? c = r.split(",") : c = r.toLowerCase().split(","), c = c.map((u) => u.trim()), this.input.length || (this.input = []), c = c.filter((u) => !this.input.includes(u) && u !== ""), this.input = this.input.concat(c), this.inputText = "", this.sendInput(this.input);
      }
    },
    blur(a) {
      this.isSearchListOpen = !1, this.$emit("blur", a);
    },
    focus(a) {
      this.isSearchListOpen = this.hasSearchResults, this.$emit("focus", a);
    },
    sendInput(a) {
      const r = this.$parent.finalForm.getState().initialValues[`${this.name}`].concat(), c = a.concat();
      JSON.stringify(r) === JSON.stringify(c) ? this.$emit("input", {
        target: {
          value: this.$parent.finalForm.getState().initialValues[`${this.name}`]
        }
      }) : this.$emit("input", {
        target: { value: this.isAlphabetical ? a.sort() : a }
      });
    },
    update(a) {
      this.sendInput(a);
    },
    change(a) {
      a.target.value.indexOf(",") > -1 ? this.enter(a) : this.$emit("changeInputText", a.target.value);
    }
  }
};
var aT = function() {
  var r = this, c = r._self._c;
  return c("form", { staticClass: "form-input-tagger", on: { submit: function(u) {
    u.preventDefault();
  } } }, [c("div", { ref: "focusableContents" }, [c("div", { staticClass: "tagger-input-container" }, [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.inputText, expression: "inputText" }], staticClass: "tagger-input", attrs: { id: `form-input-${r.name}`, name: r.name, placeholder: r.placeholder, type: "text" }, domProps: { value: r.inputText }, on: { focus: r.focus, keyup: function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : (u.preventDefault(), r.enter.apply(null, arguments));
  }, input: [function(u) {
    u.target.composing || (r.inputText = u.target.value);
  }, r.change] } }), c("SButton", { staticClass: "add-tag", attrs: { variant: "secondary" }, on: { click: function(u) {
    return u.preventDefault(), r.enter({ target: { value: r.inputText } });
  } } }, [r._v(" Add ")])], 1), c("SearchList", { attrs: { "is-open": r.isSearchListOpen, "search-term": r.inputText, "search-results": r.searchResults }, on: { select: (u) => r.enter({ target: { value: u.value } }) } })], 1), c("form-helper-text", [r._v(" " + r._s(r.helpertext) + " ")]), c("taglist", { attrs: { name: r.name, sortable: r.sortable }, on: { update: r.update }, model: { value: r.input, callback: function(u) {
    r.input = u;
  }, expression: "input" } })], 1);
}, lT = [], cT = /* @__PURE__ */ he(
  sT,
  aT,
  lT,
  !1,
  null,
  "17f6bf74",
  null,
  null
);
const uT = cT.exports, dT = {
  components: { CustomTagger: uT, FinalField: cn.exports.FinalField },
  props: {
    isAlphabetical: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: String,
      default: ""
    },
    hasSearchResults: {
      type: Boolean,
      default: !1
    },
    helpertext: {
      type: String,
      default: "Hit enter or separate tags with commas"
    },
    name: {
      type: String,
      default: ""
    },
    allowCaps: {
      type: Boolean,
      default: !1
    },
    clearInputText: {
      type: Number,
      default: 0
    },
    searchResults: {
      type: Array
    },
    sortable: {
      type: Boolean,
      default: !1
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    },
    changeInputText(a) {
      this.$emit("changeInputText", a);
    }
  }
};
var hT = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("custom-tagger", r._g({ attrs: { value: u.value, name: u.name, "allow-caps": r.allowCaps, placeholder: r.placeholder, "clear-input-text": r.clearInputText, helpertext: r.helpertext, "is-alphabetical": r.isAlphabetical && !r.sortable, sortable: r.sortable, "search-results": r.searchResults, "has-search-results": r.hasSearchResults }, on: { blur: r.blur, focus: r.focus, input: r.input, changeInputText: r.changeInputText } }, u.events))], 1);
  } }]) });
}, fT = [], pT = /* @__PURE__ */ he(
  dT,
  hT,
  fT,
  !1,
  null,
  null,
  null,
  null
);
const e2 = pT.exports;
const mT = {
  components: { FinalField: cn.exports.FinalField, HelperText: nr, IconSearch: ap },
  props: {
    autocomplete: {
      type: String,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    maxlength: {
      type: Number,
      default: 524288
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    },
    keyup(a) {
      this.$emit("keyup", a);
    },
    showErrorStyles(a) {
      return this.error || a.meta.touched && a.meta.error;
    },
    submit() {
      this.$emit("search");
    }
  }
};
var gT = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("div", { staticClass: "text" }, [r.prefix !== "" ? c("span", { staticClass: "prefix" }, [r._v(r._s(r.prefix))]) : r._e(), c("input", r._g({ class: {
      error: r.showErrorStyles(u),
      prefixed: r.prefix !== "",
      suffixed: r.suffix !== ""
    }, attrs: { id: `form-input-${r.name}`, name: u.name, maxlength: r.maxlength, placeholder: r.placeholder || "", disabled: r.disabled, type: r.type, autocomplete: r.autocomplete, tabindex: "0" }, domProps: { value: u.value }, on: { blur: r.blur, focus: r.focus, input: r.input, keyup: r.keyup } }, u.events)), r.suffix !== "" ? c("span", { staticClass: "suffix" }, [r._v(r._s(r.suffix))]) : r._e(), r.type === "search" ? c("button", { staticClass: "search-button", attrs: { type: "submit" }, on: { click: function(p) {
      return p.preventDefault(), r.submit.apply(null, arguments);
    } } }, [c("IconSearch", { attrs: { size: "md" } })], 1) : r._e()]), u.meta.touched && u.meta.error ? c("HelperText", { attrs: { error: !0 } }, [r._v(" " + r._s(u.meta.error) + " ")]) : r._e()], 1);
  } }]) });
}, vT = [], bT = /* @__PURE__ */ he(
  mT,
  gT,
  vT,
  !1,
  null,
  "dc098291",
  null,
  null
);
const t2 = bT.exports;
const _T = {
  components: { FinalField: cn.exports.FinalField, HelperText: nr },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    validate: {
      type: Function,
      default: null
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var wT = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("textarea", r._g({ class: { error: u.meta.touched && u.meta.error }, attrs: { id: `form-input-${r.name}`, name: u.name, placeholder: r.placeholder, tabindex: "0" }, domProps: { value: u.value }, on: { blur: r.blur, focus: r.focus, input: r.input } }, u.events)), r._v(" "), u.meta.touched && u.meta.error ? c("HelperText", { attrs: { error: !0 } }, [r._v(" " + r._s(u.meta.error) + " ")]) : r._e()], 1);
  } }]) });
}, yT = [], kT = /* @__PURE__ */ he(
  _T,
  wT,
  yT,
  !1,
  null,
  "b7e210a1",
  null,
  null
);
const n2 = kT.exports, xT = {
  name: "AttachFileIcon"
};
var ST = function() {
  var r = this, c = r._self._c;
  return c("svg", { staticClass: "icon-attach-file", attrs: { viewBox: "0 0 19 37", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [c("path", { staticClass: "icon-fill", attrs: { d: "M15.8333333,27.5 C15.8333333,31.1833333 12.85,34.1666667 9.16666667,34.1666667 C5.48333333,34.1666667 2.5,31.1833333 2.5,27.5 L2.5,6.66666667 C2.5,4.36666667 4.36666667,2.5 6.66666667,2.5 C8.96666667,2.5 10.8333333,4.36666667 10.8333333,6.66666667 L10.8333333,24.1666667 C10.8333333,25.0833333 10.0833333,25.8333333 9.16666667,25.8333333 C8.25,25.8333333 7.5,25.0833333 7.5,24.1666667 L7.5,8.33333333 L5,8.33333333 L5,24.1666667 C5,26.4666667 6.86666667,28.3333333 9.16666667,28.3333333 C11.4666667,28.3333333 13.3333333,26.4666667 13.3333333,24.1666667 L13.3333333,6.66666667 C13.3333333,2.98333333 10.35,0 6.66666667,0 C2.98333333,0 0,2.98333333 0,6.66666667 L0,27.5 C0,32.5666667 4.1,36.6666667 9.16666667,36.6666667 C14.2333333,36.6666667 18.3333333,32.5666667 18.3333333,27.5 L18.3333333,8.33333333 L15.8333333,8.33333333 L15.8333333,27.5 Z" } })]);
}, CT = [], AT = /* @__PURE__ */ he(
  xT,
  ST,
  CT,
  !1,
  null,
  null,
  null,
  null
);
const TT = AT.exports;
const IT = {
  components: {
    IconAttachFile: TT,
    IconUpload: os
  },
  props: {
    accept: {
      type: String,
      default: ".mp3,.wav,.m4a,audio/*"
    },
    file: {
      type: Object,
      default: () => {
      }
    },
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({ value: "" })
    }
  },
  data() {
    return {
      fileData: this.file
    };
  },
  watch: {
    file(a) {
      a.file ? a.name && (this.fileData = a) : this.fileData = !1;
    }
  },
  methods: {
    fileClick() {
      this.$refs.audio.click();
    },
    setFileInfo(a) {
      const r = a.target.files ? a.target.files[0] : a.dataTransfer.files[0];
      if (!r.type.startsWith("audio/")) {
        alert("Audio files only");
        return;
      }
      this.fileData = r, this.$emit("change", this.fileData);
    },
    removeFile() {
      this.fileData = "remove", this.$emit("change", this.fileData);
    }
  }
};
var ET = function() {
  var r = this, c = r._self._c;
  return c("div", [c("input", { ref: "audio", attrs: { accept: r.accept, type: "file" }, on: { change: r.setFileInfo } }), c("div", { staticClass: "dropzone", on: { dragover: function(u) {
    u.preventDefault();
  }, drop: function(u) {
    return u.preventDefault(), r.setFileInfo.apply(null, arguments);
  }, click: r.fileClick } }, [!r.fileData || !r.fileData.name ? [c("IconUpload"), r._t("default", function() {
    return [r._v("DRAG OR SELECT FROM COMPUTER (MP3, M4A, WAV)")];
  })] : [c("icon-attach-file"), c("div", [c("span", { staticClass: "filename" }, [r._v(r._s(r.fileData.name))]), r._v(" - "), c("a", { staticClass: "remove", on: { click: function(u) {
    return u.stopPropagation(), u.preventDefault(), r.removeFile.apply(null, arguments);
  } } }, [r._v(" REMOVE ")]), c("div", [r._t("default", function() {
    return [r._v("DRAG OR SELECT FROM COMPUTER (MP3, M4A, WAV)")];
  })], 2)])]], 2)]);
}, PT = [], MT = /* @__PURE__ */ he(
  IT,
  ET,
  PT,
  !1,
  null,
  "aceab38b",
  null,
  null
);
const i2 = MT.exports;
const OT = {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: ""
    },
    toggle: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      focused: !1,
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  created() {
    window.addEventListener("keydown", this.preventScroll);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.preventScroll);
  },
  methods: {
    blur() {
      this.focused = !1;
    },
    change(a) {
      this.$set(this.input, "value", a.target.checked), this.$emit("change", this.input), this.$emit("input", this.input);
    },
    focus(a) {
      this.focused = !0, this.$emit("focus", a);
    },
    preventScroll(a) {
      if (a.keyCode === 32 && this.focused)
        return a.preventDefault(), !1;
    },
    toggleCheckbox() {
      this.$refs.checkbox.checked = !this.$refs.checkbox.checked;
      const a = {};
      a.target = { checked: this.$refs.checkbox.checked }, this.change(a);
    }
  }
};
var DT = function() {
  var r = this, c = r._self._c;
  return c("label", { staticClass: "form-input-checkbox form-input-checkbox-label", attrs: { for: "form-input-" + r.name, tabindex: "0" }, on: { blur: r.blur, focus: r.focus, keyup: function(u) {
    return !u.type.indexOf("key") && u.keyCode !== 32 ? null : r.toggleCheckbox.apply(null, arguments);
  } } }, [c("div", { class: { "form-input-toggle": r.toggle } }, [c("input", { ref: "checkbox", attrs: { id: "form-input-" + r.name, disabled: r.disabled, tabindex: "-1", type: "checkbox" }, domProps: { checked: r.input.value, value: r.name }, on: { change: r.change } }), r.toggle ? c("span", { staticClass: "input-checkbox-slider" }) : c("span", { staticClass: "input-checkbox-indicator" })]), r._t("default")], 2);
}, NT = [], RT = /* @__PURE__ */ he(
  OT,
  DT,
  NT,
  !1,
  null,
  "3b3f6c65",
  null,
  null
);
const r2 = RT.exports, Sn = {
  domain(a, r) {
    return a ? /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/i.test(a) ? null : r : !1;
  },
  email(a, r) {
    return a ? /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(a) ? null : r : !1;
  },
  emailsCommaDelimited(a) {
    if (!a || !a.length)
      return !1;
    const r = a.split(","), c = [], u = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    for (let p = 0; p < r.length; p++)
      u.test(r[p]) || c.push(r[p]);
    return c;
  },
  positiveNum(a, r) {
    return parseInt(a) > 0 ? null : r;
  },
  required(a, r) {
    return a ? null : r;
  },
  url(a, r) {
    return a ? /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/gi.test(a) ? null : r : !1;
  },
  urlChartable(a, r) {
    return a ? a.startsWith("https://ads.chtbl.com/imp_track") ? null : r : !1;
  },
  urlPodsights(a, r) {
    return a ? a.startsWith("https://sink.pdst.fm/") ? null : r : !1;
  },
  color(a, r) {
    return a ? /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/gim.test(a) ? null : r : !1;
  },
  timestamp(a, r) {
    const c = /^([0-9]?[0-9]):[0-5][0-9](:[0-5][0-9])(.([0-9]){1,3})?$/gi, u = /^[0-5]?[0-9](:[0-5][0-9])(.([0-9]){1,3})?$/gi;
    return c.test(a) || u.test(a) ? null : r;
  },
  pixelTrackingUrlsCommaDelimited(a) {
    if (!a || !a.length)
      return !1;
    const r = a.split(","), c = [];
    for (let u = 0; u < r.length; u++)
      Sn.urlPodsights(r[u], !0) && Sn.urlChartable(r[u], !0) && c.push(r[u]);
    return c;
  },
  passwordRequirementsMet(a) {
    return {
      uppercase: a.search(/[A-Z]/) >= 0,
      lowercase: a.search(/[a-z]/) >= 0,
      number: a.search(/[0-9]/) >= 0,
      symbol: a.search(/[^A-Za-z0-9\s]/) >= 0,
      passwordLength: a.length >= 12 && a.length <= 128
    };
  },
  isDomain(a) {
    return a ? /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/i.test(a) : !1;
  },
  isEmail(a) {
    return a ? /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(a) : !1;
  },
  isUrl(a) {
    return a ? /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/gi.test(a) : !1;
  },
  isApplePodcasts(a) {
    return a ? /^(?:podcast:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/gi.test(a) : !1;
  },
  isOvercast(a) {
    return a ? /^(?:overcast:\/\/)(.*)$/gi.test(a) : !1;
  },
  isPocketCasts(a) {
    return a ? /^(?:pktc:\/\/)(.*)$/gi.test(a) : !1;
  }
};
const LT = {
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({
        value: ""
      })
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  methods: {
    blur() {
      this.validate(), this.$emit("blur", this.input), this.$emit("input", this.input);
    },
    change() {
      this.validate(), this.$emit("change", this.input), this.$emit("input", this.input);
    },
    enter() {
      this.$emit("enter", this.input);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    validate() {
      this.$set(this.input, "error", !1), this.input.error = !Sn.isEmail(this.input.value), this.input.required && (!this.input.value || this.input.value === "") && (this.input.error = !0);
    }
  }
};
var FT = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "email" }, [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.input.value, expression: "input.value" }], class: { error: r.input.error === !0 }, attrs: { id: `form-input-${r.name}`, placeholder: r.placeholder || "", tabindex: "0", type: "email" }, domProps: { value: r.input.value }, on: { blur: r.blur, focus: r.focus, keyup: [r.change, function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.enter.apply(null, arguments);
  }], input: function(u) {
    u.target.composing || r.$set(r.input, "value", u.target.value);
  } } })]);
}, zT = [], $T = /* @__PURE__ */ he(
  LT,
  FT,
  zT,
  !1,
  null,
  "1d8e3a22",
  null,
  null
);
const o2 = $T.exports;
const jT = {
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    props() {
      return this.$props;
    }
  }
};
var BT = function() {
  var r = this, c = r._self._c;
  return c("fieldset", [r._t("default", null, null, r.props)], 2);
}, VT = [], UT = /* @__PURE__ */ he(
  jT,
  BT,
  VT,
  !1,
  null,
  "9be6be91",
  null,
  null
);
const s2 = UT.exports;
const HT = {
  components: {
    IconArrow: vi,
    Tooltip: zr
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    tooltipText: {
      type: String,
      default: null
    },
    canCollapse: {
      type: Boolean,
      default: !1
    },
    defaultOpen: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      collapsed: !0
    };
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    svgTitle() {
      return this.collapsed ? "Close Form Group" : "Open Form Group";
    },
    svgDirection() {
      return this.collapsed ? "down" : "up";
    }
  },
  created() {
    this.defaultOpen && (this.collapsed = !1);
  },
  methods: {
    toggleOpen(a) {
      a.preventDefault(), this.collapsed = !this.collapsed;
    }
  }
};
var WT = function() {
  var r = this, c = r._self._c;
  return c("div", { class: [
    "form-group",
    { "has-footer-slot": r.hasFooterSlot && (!r.collapsed || !r.canCollapse) }
  ], style: r.maxWidth ? { maxWidth: r.maxWidth } : "" }, [r.canCollapse ? c("a", { staticClass: "form-group-header", attrs: { title: "Open Section" }, on: { click: r.toggleOpen } }, [c("span", { staticClass: "form-group-title" }, [r._v(r._s(r.title))]), r.canCollapse ? c("IconArrow", { attrs: { titleAccess: r.svgTitle, direction: r.svgDirection } }) : r._e()], 1) : c("div", { staticClass: "form-group-header" }, [c("span", { staticClass: "form-group-title" }, [r._v(" " + r._s(r.title) + " "), r.tooltipText && r.tooltipText.length > 0 ? c("tooltip", { attrs: { id: `tooltip-${r.title.replace(/\s/g, "")}` } }, [r._v(" " + r._s(r.tooltipText) + " ")]) : r._e()], 1)]), !r.collapsed || !r.canCollapse ? c("div", { staticClass: "form-group-content" }, [r._t("default")], 2) : r._e(), r.hasFooterSlot && (!r.collapsed || !r.canCollapse) ? c("div", { staticClass: "form-group-footer" }, [r._t("footer")], 2) : r._e()]);
}, YT = [], qT = /* @__PURE__ */ he(
  HT,
  WT,
  YT,
  !1,
  null,
  "f2e18a5b",
  null,
  null
);
const a2 = qT.exports, GT = {
  name: "AddImageIcon"
};
var ZT = function() {
  var r = this, c = r._self._c;
  return c("svg", { staticClass: "icon-add-image", attrs: { viewBox: "0 0 48 44", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [c("path", { attrs: { d: "M6.25,6.33333333 L6.25,0.0833333333 L10.4166667,0.0833333333 L10.4166667,6.33333333 L16.6666667,6.33333333 L16.6666667,10.5 L10.4166667,10.5 L10.4166667,16.75 L6.25,16.75 L6.25,10.5 L0,10.5 L0,6.33333333 L6.25,6.33333333 L6.25,6.33333333 Z M12.5,18.8333333 L12.5,12.5833333 L18.75,12.5833333 L18.75,6.33333333 L33.3333333,6.33333333 L37.1458333,10.5 L43.75,10.5 C46.0416667,10.5 47.9166667,12.375 47.9166667,14.6666667 L47.9166667,39.6666667 C47.9166667,41.9583333 46.0416667,43.8333333 43.75,43.8333333 L10.4166667,43.8333333 C8.125,43.8333333 6.25,41.9583333 6.25,39.6666667 L6.25,18.8333333 L12.5,18.8333333 L12.5,18.8333333 Z M27.0833333,37.5833333 C32.8333333,37.5833333 37.5,32.9166667 37.5,27.1666667 C37.5,21.4166667 32.8333333,16.75 27.0833333,16.75 C21.3333333,16.75 16.6666667,21.4166667 16.6666667,27.1666667 C16.6666667,32.9166667 21.3333333,37.5833333 27.0833333,37.5833333 L27.0833333,37.5833333 Z M20.4166667,27.1666667 C20.4166667,30.8541667 23.3958333,33.8333333 27.0833333,33.8333333 C30.7708333,33.8333333 33.75,30.8541667 33.75,27.1666667 C33.75,23.4791667 30.7708333,20.5 27.0833333,20.5 C23.3958333,20.5 20.4166667,23.4791667 20.4166667,27.1666667 L20.4166667,27.1666667 Z" } })]);
}, KT = [], XT = /* @__PURE__ */ he(
  GT,
  ZT,
  KT,
  !1,
  null,
  null,
  null,
  null
);
const QT = XT.exports;
const JT = {
  components: {
    croppa: Cp.component,
    FormRange: Ap,
    IconAddImage: QT,
    IconCloseCircle: Lk
  },
  props: {
    cropperH: {
      type: Number,
      default: 130
    },
    cropperW: {
      type: Number,
      default: 130
    },
    isRound: {
      type: Boolean,
      default: !1
    },
    quality: {
      type: Number,
      default: 2
    },
    value: {
      type: Object,
      default: () => ({
        blob: "",
        name: "",
        value: ""
      })
    }
  },
  data() {
    return {
      croppa: {},
      generating: !1,
      imageZoom: 0,
      initialImage: "",
      loaded: !1,
      newImage: !1,
      zoomMax: 0,
      zoomMin: 0
    };
  },
  computed: {
    radius() {
      return this.isRound ? "50%" : 0;
    },
    containerStyle() {
      return `width: ${this.cropperW ? this.cropperW + "px" : "auto"};`;
    }
  },
  watch: {
    value(a) {
      (!a.value || a.value === "") && (this.initialImage = "", this.croppa.remove()), this.cors();
    }
  },
  created() {
    this.cors();
  },
  methods: {
    chooseImage() {
      this.$refs.croppa.$el.getElementsByTagName("input")[0].click();
    },
    cors() {
      const a = new Image();
      a.setAttribute("crossorigin", "anonymous"), a.onload = () => {
        this.initialImage = a, this.croppa.refresh();
      };
      let r = `${this.value.value}`;
      (!this.value.blob || this.value.blob === "") && (r += "?crossorigin=anonymous"), a.src = r;
    },
    focus(a) {
      this.$emit("focus", a);
    },
    onFileChoose() {
      this.newImage = !0;
    },
    onFileSizeExceed() {
    },
    onFileTypeMismatch() {
    },
    onInit() {
    },
    onNewImageDrawn() {
      this.imageZoom = this.croppa.scaleRatio, this.zoomMin = this.croppa.scaleRatio, this.zoomMax = this.croppa.scaleRatio * 4, this.newImage && (this.sendImageData(), this.newImage = !1);
    },
    onImageRemove() {
      this.initialImage = "", this.croppa.remove(), this.sendImageData();
    },
    onSliderChange(a) {
      this.croppa.scaleRatio = +a, this.sendImageData();
    },
    onMove() {
      this.sendImageData();
    },
    onZoom() {
      this.sendImageData();
    },
    async sendImageData() {
      if (this.generating)
        return;
      this.generating = !0;
      const a = this.croppa.getChosenFile() || { name: null };
      let r = null;
      if (!a.name && this.value.value) {
        const u = this.value.value.split("/");
        a.name = u[u.length - 1];
      }
      if (a.name) {
        const u = a.name.split(".");
        u.pop(), r = u.join(".") + ".jpg";
      }
      const c = {
        blob: await this.croppa.promisedBlob("image/jpeg"),
        name: r,
        value: this.croppa.generateDataUrl("image/jpeg")
      };
      this.$emit("input", c), this.$emit("change", c), this.generating = !1;
    }
  }
};
var eI = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "input-image-group" }, [c("div", { staticClass: "input-image-group-cropper", style: r.containerStyle }, [c("div", { directives: [{ name: "show", rawName: "v-show", value: r.croppa.imageSet, expression: "croppa.imageSet" }], staticClass: "closer", attrs: { tabindex: "0" }, on: { focus: r.focus, keyup: function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.onImageRemove.apply(null, arguments);
  }, click: r.onImageRemove } }, [c("IconCloseCircle", { attrs: { titleAccess: "Remove Image" } })], 1), c("div", { staticClass: "croppa-wrappa", attrs: { tabindex: "0" }, on: { focus: r.focus, keyup: function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.chooseImage.apply(null, arguments);
  } } }, [c("croppa", { ref: "croppa", style: "border-radius:" + r.radius, attrs: { accept: "image/*", "canvas-color": "default", "disable-click-to-choose": !1, "disable-drag-and-drop": !1, "disable-drag-to-move": !1, "disable-rotation": !1, "disable-scroll-to-zoom": !0, disabled: !1, "file-size-limit": 0, height: r.cropperH, "initial-image": r.initialImage, "placeholder-color": "default", "placeholder-font-size": 0, placeholder: "", "prevent-white-space": !0, quality: r.quality, "show-remove-button": !1, width: r.cropperW }, on: { "file-choose": r.onFileChoose, "file-size-exceed": r.onFileSizeExceed, "file-type-mismatch": r.onFileTypeMismatch, "image-remove": r.onImageRemove, init: r.onInit, mouseup: function(u) {
    return u.stopPropagation(), r.sendImageData.apply(null, arguments);
  }, move: r.onMove, "new-image-drawn": r.onNewImageDrawn, zoom: r.onZoom }, model: { value: r.croppa, callback: function(u) {
    r.croppa = u;
  }, expression: "croppa" } }, [r._t("default", function() {
    return [r.initialImage ? r._e() : c("icon-add-image")];
  })], 2)], 1)]), c("div", { directives: [{ name: "show", rawName: "v-show", value: r.croppa.hasImage && r.croppa.hasImage(), expression: "croppa.hasImage && croppa.hasImage()" }], staticClass: "image-zoomer" }, [c("form-range", { attrs: { max: r.zoomMax, min: r.zoomMin, step: 1e-3 }, on: { change: r.onSliderChange, mouseup: r.sendImageData }, model: { value: r.imageZoom, callback: function(u) {
    r.imageZoom = u;
  }, expression: "imageZoom" } })], 1)]);
}, tI = [], nI = /* @__PURE__ */ he(
  JT,
  eI,
  tI,
  !1,
  null,
  "1100443e",
  null,
  null
);
const iI = nI.exports, rI = {
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({ value: 1 })
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  methods: {
    blur() {
      this.validate(), this.$emit("blur", this.input), this.$emit("input", this.input);
    },
    change() {
      this.validate(), this.$emit("input", this.input), this.$emit("change", this.input);
    },
    enter() {
      this.$emit("enter", this.input);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    validate() {
      this.$set(this.input, "error", !1), this.input.required && (!this.input.value || this.input.value === "") && (this.input.error = !0);
    }
  }
};
var oI = function() {
  var r = this, c = r._self._c;
  return c("input", { directives: [{ name: "model", rawName: "v-model", value: r.input.value, expression: "input.value" }], class: { error: r.input.error }, attrs: { id: `form-input-${r.name}`, placeholder: r.placeholder || "", tabindex: "0", type: "number" }, domProps: { value: r.input.value }, on: { blur: r.blur, focus: r.focus, keyup: [r.change, function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.enter.apply(null, arguments);
  }], input: function(u) {
    u.target.composing || r.$set(r.input, "value", u.target.value);
  } } });
}, sI = [], aI = /* @__PURE__ */ he(
  rI,
  oI,
  sI,
  !1,
  null,
  null,
  null,
  null
);
const l2 = aI.exports;
const lI = {
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({
        options: [],
        value: ""
      })
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  mounted() {
    this.setSelected();
  },
  methods: {
    change() {
      this.$emit("change", this.input), this.$emit("input", this.input);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    select(a) {
      const r = this.input.options.findIndex((u) => u.value === this.input.value);
      let c = a + r;
      c = Math.min(c, this.input.options.length - 1), c = Math.max(0, c), this.input.value = this.input.options[c].value;
    },
    setSelected() {
      (!this.input.value || this.input.value === "") && this.$set(this.input, "value", this.input.options[0].value), this.change();
    }
  }
};
var cI = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "input-radio-group", attrs: { tabindex: 0 }, on: { keyup: [function(u) {
    return !u.type.indexOf("key") && u.keyCode !== 37 ? null : r.select(-1);
  }, function(u) {
    return !u.type.indexOf("key") && u.keyCode !== 39 ? null : r.select(1);
  }], focus: r.focus } }, r._l(r.input.options, function(u, p) {
    return c("label", { key: p, staticClass: "input-radio input-radio-label", attrs: { for: `form-input-${r.name}${u.value}` } }, [c("input", { directives: [{ name: "model", rawName: "v-model", value: r.input.value, expression: "input.value" }], ref: `radio${r.name}${u.value}`, refInFor: !0, attrs: { id: `form-input-${r.name}${u.value}`, name: r.name, tabindex: -1, type: "radio" }, domProps: { value: u.value, checked: r._q(r.input.value, u.value) }, on: { change: [function(h) {
      return r.$set(r.input, "value", u.value);
    }, r.change] } }), c("span", { staticClass: "input-radio-indicator" }), r._v(" " + r._s(u.label) + " ")]);
  }), 0);
}, uI = [], dI = /* @__PURE__ */ he(
  lI,
  cI,
  uI,
  !1,
  null,
  null,
  null,
  null
);
const c2 = dI.exports;
const hI = {
  components: {
    IconArrow: vi,
    IconCheck: Fr,
    FormSearch: Bp
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Select One"
    },
    search: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    value: {
      type: Object,
      default: () => ({
        options: [
          {
            disabled: !0,
            label: "Select One",
            selected: !0,
            value: ""
          }
        ],
        value: ""
      })
    },
    prefix: {
      type: String,
      default: null
    },
    prepend: {
      type: Array,
      default: () => []
    },
    append: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      filter: "",
      focused: !1,
      input: this.value,
      opened: !1,
      navSelected: "",
      scrollFilter: "",
      scrollTimeout: !1,
      optionList: []
    };
  },
  computed: {
    buttonTitle() {
      return this.opened ? "Close Select" : "Open Select";
    },
    buttonDirection() {
      return this.opened ? "up" : "down";
    },
    hasOptions() {
      return this.options.filter((r) => r.disabled !== !0).length > 0;
    },
    isDisabled() {
      if (this.disabled)
        return !0;
      const a = this.options.find((r) => r.disabled);
      return a && a.label ? a.label === this.selected.label : !1;
    },
    options() {
      const a = this.input.options.filter((r) => this.filter === "" ? !0 : r.label.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1);
      return [
        ...this.clearableOption,
        ...this.prepend,
        ...a,
        ...this.append
      ];
    },
    selected() {
      if (!this.input.value)
        return { disabled: !0, label: this.placeholder, value: "" };
      const a = this.input.options.filter((r) => this.input.value === r.value).pop();
      return a !== void 0 ? a : { disabled: !1, label: this.input.value, value: this.input.value };
    },
    clearableOption() {
      const a = [];
      return this.clearable && a.push({
        label: this.placeholder,
        value: "",
        disabled: !1,
        selected: !1
      }), a;
    },
    selectedIndex() {
      return this.options.findIndex((a) => a.value === this.navSelected);
    },
    selectedOption() {
      return this.$refs.option[this.selectedIndex];
    },
    selectedText() {
      return this.selected ? this.selected.label : "";
    }
  },
  watch: {
    opened(a) {
      a === !0 ? (this.setScroll(), this.$refs.search && this.$refs.search.focusInput(), document.addEventListener("click", this.handleGlobalClick), document.addEventListener("touchstart", this.handleGlobalClick)) : (document.removeEventListener("click", this.handleGlobalClick), document.removeEventListener("touchstart", this.handleGlobalClick));
    },
    value(a) {
      this.input = a;
    },
    "value.options"(a) {
      this.input.options = a;
    },
    "input.value"(a) {
      this.navSelected = a;
    }
  },
  created() {
    this.navSelected = this.input.value;
  },
  methods: {
    addEvents() {
      window.addEventListener("keydown", this.keydownTab);
    },
    blur() {
      this.focused = !1, this.validate(), this.removeEvents(), this.$emit("blur", this.input), this.$emit("input", this.input);
    },
    close() {
      this.opened = !1, this.navSelected = this.selected.value, this.filter = "", this.$nextTick(() => {
        this.$refs.select && this.$refs.select.focus();
      });
    },
    change() {
      this.validate(), this.$emit("change", this.input), this.$emit("input", this.input);
    },
    focus(a) {
      !this.hasOptions || this.disabled || (this.focused = !0, this.addEvents(), this.$emit("focus", a));
    },
    keydown(a) {
      switch (a.keyCode) {
        case 9:
          this.close();
          break;
        case 13:
          this.select();
          break;
        case 27:
          this.close();
          break;
        case 32:
          this.opened || this.open();
          break;
        case 38:
          this.opened && this.selectPrev(), this.open();
          break;
        case 40:
          this.opened && this.selectNext(), this.open();
          break;
      }
    },
    keydownSearch(a) {
      a.keyCode === 9 && (a.stopPropagation(), a.preventDefault()), this.keydown(a);
    },
    keydownTab(a) {
      a.keyCode !== 9 && (a.stopPropagation(), a.preventDefault()), this.keydown(a);
    },
    keyupScroll(a) {
      if (a.key.length > 1 || this.opened && this.search)
        return;
      this.scrollFilter = this.scrollFilter + a.key;
      const r = this.options.findIndex((c) => c.label.toLowerCase().indexOf(this.scrollFilter.toLowerCase()) === 0);
      r >= 0 && (this.navSelected = this.options[r].value, this.setScroll(), this.opened || (this.input.value = this.options[r].value)), clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
        this.scrollFilter = "";
      }, 3e3);
    },
    handleGlobalClick(a) {
      const r = this.$refs.select;
      r !== a.target && !r.contains(a.target) && this.close();
    },
    isSelected(a) {
      return a === this.navSelected;
    },
    open() {
      !this.hasOptions || this.disabled || (this.opened = !0);
    },
    toggleOpen() {
      !this.hasOptions || this.disabled || (this.opened = !this.opened);
    },
    removeEvents() {
      window.removeEventListener("keydown", this.keydown), window.removeEventListener("keydown", this.keydownTab);
    },
    select() {
      this.$refs.select.focus(), this.setSelected(this.navSelected), this.close(), this.filter = "";
    },
    selectNext() {
      const r = this.options.findIndex((c) => c.value === this.navSelected) + 1;
      this.options[r] && (this.navSelected = this.options[r].value), this.setScroll();
    },
    selectPrev() {
      const a = this.options.findIndex((c) => c.value === this.navSelected), r = Math.max(0, a - 1);
      this.options[r] && (this.navSelected = this.options[r].value), this.setScroll();
    },
    setScroll() {
      this.$nextTick(() => {
        const a = this.selectedOption ? this.selectedOption.offsetTop : 0;
        this.$refs.options.scrollTop = a - this.$refs.options.offsetTop;
      });
    },
    setSelected(a) {
      this.navSelected = a, this.$set(this.input, "value", a), this.change();
    },
    validate() {
      this.$set(this.input, "error", !1), this.input.required && (!this.input.value || this.input.value === "") && (this.input.error = !0);
    }
  }
};
var fI = function() {
  var r = this, c = r._self._c;
  return c("div", { ref: "select", class: [
    "wrap",
    { focused: r.focused, opened: r.opened },
    { disabled: !r.hasOptions || r.disabled }
  ], attrs: { disabled: !r.hasOptions || r.disabled, tabindex: r.hasOptions ? 0 : -1 }, on: { blur: r.blur, focus: r.focus, keyup: r.keyupScroll } }, [c("div", { class: ["form-input-select", { error: r.input.error === !0 }], on: { click: r.toggleOpen } }, [c("div", { class: ["text", { disabled: !r.selected || r.selected.disabled }] }, [r.prefix && r.selectedText && r.selectedText !== r.placeholder ? c("span", { staticClass: "prefix" }, [r._v(r._s(r.prefix))]) : r._e(), r._v(" " + r._s(r.selectedText) + " ")]), c("IconArrow", { attrs: { "title-access": r.buttonTitle, direction: r.buttonDirection } })], 1), c("div", { staticClass: "options" }, [c("form-search", { directives: [{ name: "show", rawName: "v-show", value: r.search, expression: "search" }], ref: "search", on: { keydown: function(u) {
    return u.stopPropagation(), r.keydownSearch.apply(null, arguments);
  } }, model: { value: r.filter, callback: function(u) {
    r.filter = u;
  }, expression: "filter" } }), c("div", { ref: "options", staticClass: "options-wrap" }, [c("ul", { ref: "optionsList" }, r._l(r.options, function(u, p) {
    return c("li", { key: p, ref: "option", refInFor: !0, class: {
      selected: r.isSelected(u.value),
      disabled: u.disabled,
      placeholder: u.value === ""
    }, attrs: { disabled: u.disabled, value: u.value }, on: { click: function(h) {
      return h.stopPropagation(), (() => {
        u.disabled || (r.setSelected(u.value), r.close());
      }).apply(null, arguments);
    } } }, [c("span", { staticClass: "option-wrap" }, [r._v(" " + r._s(u.label) + " ")]), r.isSelected(u.value) ? c("IconCheck") : r._e()], 1);
  }), 0)])], 1)]);
}, pI = [], mI = /* @__PURE__ */ he(
  hI,
  fI,
  pI,
  !1,
  null,
  "5be7b3bd",
  null,
  null
);
const gI = mI.exports;
const vI = {
  components: { FormTag: Vp },
  props: {
    value: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  methods: {
    remove(a) {
      this.input.value.splice(a, 1), this.$emit("input", this.input), this.$emit("remove", this.input);
    }
  }
};
var bI = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "form-input-tag-list" }, r._l(r.input.value, function(u, p) {
    return c("form-tag", { key: p, attrs: { name: u }, on: { remove: function(h) {
      return r.remove(p);
    } } });
  }), 1);
}, _I = [], wI = /* @__PURE__ */ he(
  vI,
  bI,
  _I,
  !1,
  null,
  null,
  null,
  null
);
const yI = wI.exports;
function kI(a) {
  return a ? a.replace(/(\r\n|\n|\r)/gm, "").replace(/<em>/g, "<i>").replace(/<\/em>/g, "</i>").replace(/<\/ em>/g, "</i>").replace(/<b>/g, "<strong>").replace(/<\/b>/g, "</strong>").replace(/<\/ b>/g, "</strong>").replace(/<br \/>/g, "<br>").replace(/<br\/>/g, "<br>").replace(/&#39;/g, "'").replace(/&quot;/g, '"') : "";
}
function xI(a) {
  a = a.replace(/^\s+|\s+$/g, "-"), a = a.toLowerCase();
  const r = "\xE5\xE0\xE1\xE3\xE4\xE2\xE8\xE9\xEB\xEA\xEC\xED\xEF\xEE\xF2\xF3\xF6\xF4\xF9\xFA\xFC\xFB\xF1\xE7\xB7/_,:;", c = "aaaaaaeeeeiiiioooouuuunc------";
  return r.split("").map((u, p) => {
    a = a.replace(new RegExp(u, "g"), c.charAt(p));
  }), a = a.replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-+/, ""), a;
}
function SI(a) {
  return a ? a.replace(/(^\w+:|^)\/\//, "") : "";
}
const CI = {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    filters: {
      type: Object,
      default: () => {
      }
    },
    maxlength: {
      type: Number,
      default: 524288
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    validations: {
      type: Object,
      default: () => {
      }
    },
    value: {
      type: Object,
      default: () => ({ value: "" })
    }
  },
  data() {
    return {
      input: this.value,
      keyupTimeout: !1
    };
  },
  watch: {
    value(a) {
      this.input = a;
    },
    "value.value"(a, r) {
      a !== r && a && (clearTimeout(this.keyupTimeout), this.keyupTimeout = setTimeout(this.validate, 300));
    }
  },
  created() {
    this.validate();
  },
  methods: {
    blur() {
      this.validate(), this.$emit("blur", this.input), this.$emit("input", this.input);
    },
    change() {
      this.input.value = this.filter(this.input.value), this.$emit("change", this.input), this.$emit("input", this.input);
    },
    enter() {
      this.$emit("enter", this.input);
    },
    filter(a) {
      return this.filters && (this.filters.trimProtocol && (a = SI(a)), this.filters.slugify && (a = xI(a))), a;
    },
    focus(a) {
      this.$emit("focus", a);
    },
    validate() {
      this.$set(this.input, "error", !1), this.validations && (this.validations.domain && this.input.value && this.input.value !== "" && (this.input.error = !Sn.isDomain(this.input.value)), this.validations.url && this.input.value && this.input.value !== "" && (this.input.error = !Sn.isUrl(this.input.value)), this.validations.apple && this.input.value && this.input.value !== "" && (this.input.error = !Sn.isApplePodcasts(this.input.value) && !Sn.isUrl(this.input.value)), this.validations.overcast && this.input.value && this.input.value !== "" && (this.input.error = !Sn.isOvercast(this.input.value) && !Sn.isUrl(this.input.value)), this.validations.pocketcasts && this.input.value && this.input.value !== "" && (this.input.error = !Sn.isPocketCasts(this.input.value) && !Sn.isUrl(this.input.value))), this.input.required && (!this.input.value || this.input.value === "") && (this.input.error = !0);
    }
  }
};
var AI = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "text" }, [r.prefix !== "" ? c("span", { staticClass: "prefix" }, [r._v(r._s(r.prefix))]) : r._e(), r.type === "checkbox" ? c("input", { directives: [{ name: "model", rawName: "v-model", value: r.input.value, expression: "input.value" }], class: {
    error: r.input.error === !0,
    prefixed: r.prefix !== "",
    suffixed: r.suffix !== ""
  }, attrs: { id: `form-input-${r.name}`, maxlength: r.maxlength, placeholder: r.placeholder || "", disabled: r.disabled, tabindex: "0", type: "checkbox" }, domProps: { checked: Array.isArray(r.input.value) ? r._i(r.input.value, null) > -1 : r.input.value }, on: { blur: r.blur, focus: r.focus, keyup: [r.change, function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.enter.apply(null, arguments);
  }], change: function(u) {
    var p = r.input.value, h = u.target, v = !!h.checked;
    if (Array.isArray(p)) {
      var w = null, x = r._i(p, w);
      h.checked ? x < 0 && r.$set(r.input, "value", p.concat([w])) : x > -1 && r.$set(r.input, "value", p.slice(0, x).concat(p.slice(x + 1)));
    } else
      r.$set(r.input, "value", v);
  } } }) : r.type === "radio" ? c("input", { directives: [{ name: "model", rawName: "v-model", value: r.input.value, expression: "input.value" }], class: {
    error: r.input.error === !0,
    prefixed: r.prefix !== "",
    suffixed: r.suffix !== ""
  }, attrs: { id: `form-input-${r.name}`, maxlength: r.maxlength, placeholder: r.placeholder || "", disabled: r.disabled, tabindex: "0", type: "radio" }, domProps: { checked: r._q(r.input.value, null) }, on: { blur: r.blur, focus: r.focus, keyup: [r.change, function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.enter.apply(null, arguments);
  }], change: function(u) {
    return r.$set(r.input, "value", null);
  } } }) : c("input", { directives: [{ name: "model", rawName: "v-model", value: r.input.value, expression: "input.value" }], class: {
    error: r.input.error === !0,
    prefixed: r.prefix !== "",
    suffixed: r.suffix !== ""
  }, attrs: { id: `form-input-${r.name}`, maxlength: r.maxlength, placeholder: r.placeholder || "", disabled: r.disabled, tabindex: "0", type: r.type }, domProps: { value: r.input.value }, on: { blur: r.blur, focus: r.focus, keyup: [r.change, function(u) {
    return !u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter") ? null : r.enter.apply(null, arguments);
  }], input: function(u) {
    u.target.composing || r.$set(r.input, "value", u.target.value);
  } } }), r.suffix !== "" ? c("span", { staticClass: "suffix" }, [r._v(r._s(r.suffix))]) : r._e()]);
}, TI = [], II = /* @__PURE__ */ he(
  CI,
  AI,
  TI,
  !1,
  null,
  "fbc3e38d",
  null,
  null
);
const EI = II.exports, PI = {
  components: {
    FormHelperText: nr,
    FormTagList: yI,
    FormText: EI
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    helpertext: {
      type: String,
      default: "Hit enter or separate tags with commas"
    },
    allowCaps: {
      type: Boolean,
      default: !1
    },
    clearInputText: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: () => ({
        value: []
      })
    }
  },
  data() {
    return {
      input: this.value,
      inputText: {
        value: ""
      }
    };
  },
  watch: {
    value(a) {
      this.input = a;
    },
    clearInputText(a, r) {
      a !== r && (this.inputText.value = "");
    }
  },
  methods: {
    enter(a) {
      if (a.value !== "") {
        let r = [];
        this.allowCaps ? r = a.value.split(",") : r = a.value.toLowerCase().split(","), r = r.map((c) => c.trim()), this.input.value || this.$set(this.input, "value", []), r = r.filter((c) => !this.input.value.includes(c) && c !== ""), this.input.value = this.input.value.concat(r), a.value = "", this.$emit("input", this.input), this.$emit("change", this.input);
      }
    },
    focus(a) {
      this.$emit("focus", a);
    },
    remove() {
      this.$emit("input", this.input), this.$emit("change", this.input);
    },
    change(a) {
      a.value.indexOf(",") > -1 ? this.enter(a) : this.$emit("changeInputText", a);
    }
  }
};
var MI = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "form-input-tagger" }, [c("form-text", { attrs: { name: r.name, placeholder: r.placeholder }, on: { enter: r.enter, focus: r.focus, change: r.change }, model: { value: r.inputText, callback: function(u) {
    r.inputText = u;
  }, expression: "inputText" } }), c("form-helper-text", [r._v(" " + r._s(r.helpertext) + " ")]), c("form-tag-list", { on: { remove: r.remove }, model: { value: r.input, callback: function(u) {
    r.input = u;
  }, expression: "input" } })], 1);
}, OI = [], DI = /* @__PURE__ */ he(
  PI,
  MI,
  OI,
  !1,
  null,
  null,
  null,
  null
);
const u2 = DI.exports;
const NI = {
  props: {
    name: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({ value: "" })
    }
  },
  data() {
    return {
      input: this.value
    };
  },
  watch: {
    value(a) {
      this.input = a;
    }
  },
  methods: {
    blur() {
      this.validate(), this.$emit("blur", this.input), this.$emit("input", this.input);
    },
    change() {
      this.validate(), this.$emit("change", this.input), this.$emit("input", this.input);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    select(a) {
      this.$emit("select", a);
    },
    validate() {
      this.$set(this.input, "error", !1), this.input.required && (!this.input.value || this.input.value === "") && (this.input.error = !0);
    }
  }
};
var RI = function() {
  var r = this, c = r._self._c;
  return c("textarea", { directives: [{ name: "model", rawName: "v-model", value: r.input.value, expression: "input.value" }], class: { error: r.input.error === !0 }, attrs: { id: `form-input-${r.name}`, tabindex: "0" }, domProps: { value: r.input.value }, on: { blur: r.blur, keyup: r.change, focus: r.focus, select: r.select, input: function(u) {
    u.target.composing || r.$set(r.input, "value", u.target.value);
  } } });
}, LI = [], FI = /* @__PURE__ */ he(
  NI,
  RI,
  LI,
  !1,
  null,
  "0e1a4a41",
  null,
  null
);
const d2 = FI.exports;
const zI = {
  components: {
    FormImage: iI
  },
  props: {
    cropperH: {
      type: Number,
      default: 130
    },
    cropperW: {
      type: Number,
      default: 130
    },
    isRound: {
      type: Boolean,
      default: !1
    },
    showZoomer: {
      type: Boolean,
      default: !0
    },
    quality: {
      type: Number,
      default: 2
    },
    value: {
      type: Object,
      default: () => ({
        blob: "",
        name: "",
        value: ""
      })
    }
  },
  data() {
    return {
      imageData: this.value
    };
  },
  watch: {
    value(a) {
      this.imageData = a;
    }
  },
  methods: {
    change(a) {
      this.$emit("input", a), this.$emit("change", a);
    },
    focus(a) {
      this.$emit("focus", a);
    }
  }
};
var $I = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "input-uploader-cropper-group" }, [c("form-image", { attrs: { value: r.imageData, "cropper-h": r.cropperH, "cropper-w": r.cropperW, "is-round": r.isRound, quality: r.quality, "show-zoomer": r.showZoomer }, on: { change: r.change, focus: r.focus } }), c("div", { staticClass: "input-uploader-cropper-group-instructions" }, [r._t("default", function() {
    return [c("label", [r._v("Upload Image")]), r._m(0), c("p", [r._v(" Image should be at least 3000px wide and will be cropped to a square.You can skip this for now if you want but it will be required to publish. ")])];
  })], 2)], 1);
}, jI = [function() {
  var a = this, r = a._self._c;
  return r("ul", [r("li", [a._v("Drag image onto square or click to select from hard drive")]), r("li", [a._v("Image should be at least 600px wide")]), r("li", [a._v("Will be cropped to a square")])]);
}], BI = /* @__PURE__ */ he(
  zI,
  $I,
  jI,
  !1,
  null,
  null,
  null,
  null
);
const h2 = BI.exports;
const VI = {
  name: "Hamburger",
  props: {
    change: {
      type: Function,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    toggle() {
      this.change && this.change(!this.isOpen);
    }
  }
};
var UI = function() {
  var r = this, c = r._self._c;
  return c("a", { staticClass: "bun", attrs: { href: "#" }, on: { click: function(u) {
    return u.preventDefault(), r.toggle.apply(null, arguments);
  } } }, [c("span", { staticClass: "hamburger-title" }, [r._v("Open Menu")]), c("span", { class: { hamburger: !0, "hamburger-open": r.isOpen } }, [c("span", { staticClass: "line top" }), c("span", { staticClass: "line mid" }), c("span", { staticClass: "line bottom" })])]);
}, HI = [], WI = /* @__PURE__ */ he(
  VI,
  UI,
  HI,
  !1,
  null,
  "d36bf82e",
  null,
  null
);
const f2 = WI.exports;
const YI = {
  name: "LoadingText",
  props: {
    size: {
      type: String,
      default: "lg"
    },
    width: {
      type: String,
      default: "100%"
    }
  }
};
var qI = function() {
  var r = this, c = r._self._c;
  return c("div", { class: `loading-text loading-text-${r.size}`, style: { width: r.width }, attrs: { "aria-label": "Content is Loading" } });
}, GI = [], ZI = /* @__PURE__ */ he(
  YI,
  qI,
  GI,
  !1,
  null,
  "a50a4f91",
  null,
  null
);
const p2 = ZI.exports;
const KI = {
  components: {
    Dropdown: mp,
    DropdownCaron: pp
  },
  props: {
    inverse: {
      type: Boolean,
      default: !0
    },
    mobileEnd: {
      type: Number,
      default: 600
    }
  },
  data() {
    return {
      open: !1,
      showDropdown: !1,
      size: document.documentElement.clientWidth
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleClick(a) {
      fp(a.target) && (this.showDropdown = !1, this.$emit("close-menu"));
    },
    handleResize() {
      this.size = document.documentElement.clientWidth;
    }
  }
};
var XI = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "menu-dropdown" }, [r.size < r.mobileEnd ? c("div", { staticClass: "dropdown-mobile" }, [c("div", { staticClass: "dropdown-mobile-button", class: { "dropdown-mobile-button-open": r.showDropdown }, attrs: { tabindex: "0" }, on: { click: function(u) {
    u.preventDefault(), r.showDropdown = !r.showDropdown;
  }, keyup: [function(u) {
    if (!u.type.indexOf("key") && r._k(u.keyCode, "enter", 13, u.key, "Enter"))
      return null;
    r.showDropdown = !0;
  }, function(u) {
    if (!u.type.indexOf("key") && r._k(u.keyCode, "space", 32, u.key, [" ", "Spacebar"]))
      return null;
    r.showDropdown = !0;
  }, function(u) {
    if (!u.type.indexOf("key") && r._k(u.keyCode, "esc", 27, u.key, ["Esc", "Escape"]))
      return null;
    r.showDropdown = !1;
  }] } }, [c("div", { staticClass: "dropdown-mobile-title", class: { "dropdown-mobile-title-open": r.showDropdown } }, [r._t("title")], 2), c("div", { staticClass: "dropdown-mobile-icon" }, [r._t("button"), c("dropdown-caron", { attrs: { "is-open": r.showDropdown } })], 2)]), r.showDropdown ? c("div", { staticClass: "dropdown-mobile-content", on: { click: r.handleClick } }, [r._t("content")], 2) : r._e()]) : c("dropdown", { attrs: { "open-on-hover": !1, variant: r.inverse ? "flat-inverse" : "flat", "dropdown-width": "300px" } }, [c("template", { slot: "button" }, [r._t("button")], 2), c("template", { slot: "content" }, [r._t("content")], 2)], 2)], 1);
}, QI = [], JI = /* @__PURE__ */ he(
  KI,
  XI,
  QI,
  !1,
  null,
  "d1555e86",
  null,
  null
);
const m2 = JI.exports;
const eE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', tE = {
  name: "Modal",
  components: {
    SType: Rt
  },
  props: {
    iframe: {
      type: Boolean,
      default: !1
    },
    isLarge: {
      type: Boolean,
      default: !1
    },
    isXLarge: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "confirmation"
    }
  },
  data() {
    return {
      maxHeight: "auto",
      observer: null,
      firstFocusable: null,
      lastFocusable: null
    };
  },
  mounted() {
    window.addEventListener("keydown", this.handeClick), document.getElementsByTagName("HTML")[0].classList.add("modal-is-open"), window.addEventListener("touchmove", this.preventEvent, !1), document.addEventListener("click", this.handleGlobalClick), document.addEventListener("touchstart", this.handleGlobalClick), this.type === "content" && typeof this.$refs.body == "object" && (this.handleResize(), window.addEventListener("resize", this.handleResize), this.observer = new MutationObserver(
      function() {
        this.handleResize();
      }.bind(this)
    ), this.observer.observe(this.$refs.body, {
      attributes: !0,
      childList: !0
    }));
    const a = this.$refs.modal.querySelectorAll(eE);
    this.firstFocusable = a[0], this.lastFocusable = a[a.length - 1], this.firstFocusable.focus();
  },
  beforeDestroy() {
    document.getElementsByTagName("HTML")[0].classList.remove("modal-is-open"), window.removeEventListener("keydown", this.handeClick), window.removeEventListener("touchmove", this.preventEvent, !1), document.removeEventListener("click", this.handleGlobalClick), document.removeEventListener("touchstart", this.handleGlobalClick), this.type === "content" && (window.removeEventListener("resize", this.handleResize), this.observer.disconnect());
  },
  methods: {
    handleResize() {
      if (this.$refs.body) {
        const a = this.$refs.header ? this.$refs.header.clientHeight : 0, r = this.$refs.footer ? this.$refs.footer.clientHeight : 0, c = window.innerWidth > 550 ? 0.8 : 1, u = 32;
        this.$refs.body.style.maxHeight = `${window.innerHeight * c - u - (a + r)}px`;
      }
    },
    handleGlobalClick(a) {
      this.$refs.wrapper === a.target && this.$emit("close");
    },
    handeClick(a) {
      a.keyCode === 27 && this.$emit("close"), (a.key === "Tab" || a.keyCode === 9) && (a.shiftKey ? document.activeElement === this.firstFocusable && (this.lastFocusable.focus(), a.preventDefault()) : document.activeElement === this.lastFocusable && (this.firstFocusable.focus(), a.preventDefault()));
    },
    preventEvent(a) {
      a.preventDefault(), a.stopPropagation();
    }
  }
};
var nE = function() {
  var r = this, c = r._self._c;
  return c("transition", { attrs: { name: "modal" } }, [c("div", { staticClass: "modal-mask", attrs: { role: "dialog", "aria-labelledby": "modalTitle", "aria-describedby": "modalDescription" } }, [c("div", { ref: "wrapper", staticClass: "modal-wrapper" }, [c("div", { ref: "modal", class: {
    "modal-container": !0,
    "modal-container-large": r.isLarge,
    "modal-container-xlarge": r.isXLarge,
    "modal-container-iframe": r.iframe,
    "modal-container-content": r.type === "content"
  } }, [c("div", { staticClass: "focus-lock" }, [c("div", { staticClass: "modal-main" }, [r.$slots.header ? c("div", { ref: "header", class: `modal-header modal-header__${r.type}`, attrs: { id: "modalTitle" } }, [c("SType", { attrs: { variant: "title", gutterBottom: !1 } }, [r._t("header")], 2)], 1) : r._e(), r.$slots.body ? c("div", { ref: "body", staticClass: "modal-body", style: { maxHeight: r.maxHeight }, attrs: { id: "modalDescription" } }, [r._t("body")], 2) : r._e(), r.$slots.footer ? c("div", { ref: "footer", staticClass: "modal-footer" }, [r._t("footer")], 2) : r._e()]), r.$slots.sidebar ? c("div", { staticClass: "modal-sidebar", attrs: { id: "modalSidebar" } }, [r._t("sidebar")], 2) : r._e()])])])])]);
}, iE = [], rE = /* @__PURE__ */ he(
  tE,
  nE,
  iE,
  !1,
  null,
  null,
  null,
  null
);
const g2 = rE.exports;
const oE = {
  name: "Sidebar",
  components: {
    Alert: cp,
    IconLock: wl,
    Tooltip: zr,
    SType: Rt
  },
  props: {
    active: {
      type: String,
      default: null
    },
    ariaActiveLabel: {
      type: String,
      default: "Current Page"
    },
    dismissText: {
      type: String,
      default: "Dismiss"
    },
    disabledLabel: {
      type: String,
      default: "Disabled Page"
    },
    ariaLabel: {
      type: String,
      default: "Sidebar Nav"
    },
    links: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const a = {};
    return this.links.forEach((r) => {
      a[r.key] = this.dismissed(r.key);
    }), {
      dismissedState: a
    };
  },
  methods: {
    toggleFeature(a) {
      const r = this.dismissed(a);
      localStorage.setItem(`dismissed-${a}`, !r), this.dismissedState[a] = !r;
    },
    dismissed(a) {
      return localStorage.getItem(`dismissed-${a}`) === "true";
    }
  }
};
var sE = function() {
  var r = this, c = r._self._c;
  return c("nav", { staticClass: "sidebar", attrs: { "aria-labelledby": "sidebar-label" } }, [c("h2", { staticClass: "sidebar__screenreader", attrs: { id: "sidebar-label" } }, [r._v(" " + r._s(r.ariaLabel) + " ")]), c("ul", { staticClass: "sidebar__links" }, r._l(r.links, function(u) {
    return c("li", { key: u.key, staticClass: "sidebar__section" }, [c("SType", { staticClass: "sidebar__label", attrs: { variant: "helper" } }, [u.isFeatureGate ? c("button", { class: {
      sidebar__lock: !0,
      "sidebar__lock--min": r.dismissedState[u.key] === !0
    }, attrs: { describedby: `${u.key}-info` }, on: { click: function(p) {
      return r.toggleFeature(u.key);
    } } }, [c("div", { staticClass: "sidebar__screenreader" }, [r._v("Feature Gated:")]), c("IconLock", { attrs: { "aria-hidden": "true", size: "sm" } })], 1) : r._e(), r._v(" " + r._s(u.label) + " ")]), u.featureGateText && r.dismissedState[u.key] !== !0 ? c("Alert", { staticClass: "sidebar__feature-gated", attrs: { id: `${u.key}-info`, dismissable: !1, type: "default" } }, [c("span", { domProps: { innerHTML: r._s(u.featureGateText) } }), u.featureGateRoute && u.featureGateRouteText ? c("router-link", { staticClass: "a", attrs: { to: { name: u.featureGateRoute } } }, [r._v(" " + r._s(u.featureGateRouteText) + " ")]) : c("button", { staticClass: "a", on: { click: function(p) {
      return r.toggleFeature(u.key);
    } } }, [r._v(" " + r._s(r.dismissText) + " ")])], 1) : r._e(), c("ul", { staticClass: "sidebar__links" }, r._l(u.links, function(p) {
      return c("li", { key: p.name, staticClass: "sidebar__item" }, [r.active !== p.name && !u.isFeatureGate && !p.disabled ? c("router-link", { staticClass: "sidebar__link", attrs: { to: { name: p.name, params: p.params } } }, [r._v(" " + r._s(p.label) + " ")]) : p.disabled && p.disabled_hover ? c("tooltip", { attrs: { id: `tooltip-${p.name}` }, scopedSlots: r._u([{ key: "element", fn: function(h) {
        return [c("button", { class: {
          sidebar__link: !0,
          "sidebar__link-active": r.active === p.name,
          "sidebar__link-disabled": u.isFeatureGate || p.disabled
        }, attrs: { "aria-describedby": h.id, role: "button", "aria-disabled": "true" }, on: { focus: h.open, blur: h.close } }, [c("span", { staticClass: "sidebar__screenreader" }, [r._v(" " + r._s(u.isFeatureGate || p.disabled ? r.disabledLabel : r.ariaActiveLabel) + ": ")]), r._v(" " + r._s(p.label) + " ")])];
      } }], null, !0) }, [r._v(" " + r._s(p.disabled_hover) + " ")]) : c("span", { class: {
        "sidebar__link-active": r.active === p.name,
        "sidebar__link-disabled": u.isFeatureGate || p.disabled
      } }, [c("span", { staticClass: "sidebar__screenreader" }, [r._v(" " + r._s(u.isFeatureGate || p.disabled ? r.disabledLabel : r.ariaActiveLabel) + ": ")]), r._v(" " + r._s(p.label) + " ")])], 1);
    }), 0)], 1);
  }), 0)]);
}, aE = [], lE = /* @__PURE__ */ he(
  oE,
  sE,
  aE,
  !1,
  null,
  null,
  null,
  null
);
const v2 = lE.exports;
const cE = {
  name: "SCell",
  components: {
    SType: Rt
  },
  props: {
    gridArea: {
      type: Object,
      default: null
    },
    header: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: "sm"
    }
  },
  computed: {
    styles() {
      if (!this.gridArea)
        return null;
      const a = {
        "grid-area": this.gridArea.name,
        order: this.gridArea.order || 0
      };
      return this.gridArea.span && (a["grid-row"] = `span ${this.gridArea.span}`), a;
    }
  }
};
var uE = function() {
  var r = this, c = r._self._c;
  return c(r.header ? "SType" : "td", { tag: "component", class: ["simplecast-tablecell", r.size], style: r.styles, attrs: { variant: "subtitle", tag: "th" } }, [r.label && !r.header ? c("SType", { class: ["tablecell-label", r.size], attrs: { variant: "subtitle", tag: "span" } }, [r._v(" " + r._s(r.label) + ": ")]) : r._e(), r._t("default")], 2);
}, dE = [], hE = /* @__PURE__ */ he(
  cE,
  uE,
  dE,
  !1,
  null,
  "d9e26e3d",
  null,
  null
);
const fE = hE.exports;
const pE = {
  name: "SRow",
  props: {
    events: {
      type: Function | Object,
      default: null
    },
    disableA11y: {
      type: Boolean,
      default: !1
    },
    gridTemplate: {
      type: Object,
      default: null
    },
    header: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "sm",
      validator: (a) => ["none", "xs", "sm", "md", "lg"].includes(a)
    },
    short: {
      type: Boolean,
      default: !0
    },
    to: {
      type: Object,
      default: null
    },
    clickTitle: {
      type: String
    }
  },
  computed: {
    styles() {
      return this.gridTemplate ? {
        "grid-template-areas": this.gridTemplate.areas,
        "grid-template-columns": this.gridTemplate.columns
      } : null;
    }
  }
};
var mE = function() {
  var r = this, c = r._self._c;
  return c(r.to ? "router-link" : "tr", r._g({ tag: "component", class: [
    "simplecast-tablerow",
    r.size,
    { header: r.header },
    { short: r.short },
    { clickable: !!r.to || !!r.events },
    { focusable: (!!r.to || !!r.events) && !r.disableA11y }
  ], style: r.styles, attrs: { to: r.to, tag: "tr" } }, r.events || {}), [r._t("default"), r.events && r.events.click && !r.disableA11y ? c("td", { staticClass: "sr-accessibile-td" }, [c("button", { on: { click: function(u) {
    return u.stopPropagation(), u.preventDefault(), r.events.click.apply(null, arguments);
  } } }, [r._v(" " + r._s(r.clickTitle) + " ")])]) : r._e()], 2);
}, gE = [], vE = /* @__PURE__ */ he(
  pE,
  mE,
  gE,
  !1,
  null,
  "6d6be532",
  null,
  null
);
const bE = vE.exports;
const _E = ue.extend({
  name: "STable",
  components: {
    SCell: fE,
    SRow: bE
  },
  props: {
    fields: {
      type: Array,
      required: !1
    },
    items: {
      type: Array,
      required: !1
    },
    size: {
      type: String,
      default: "sm",
      validator: (a) => ["none", "xs", "sm", "md", "lg"].includes(a)
    }
  }
});
var wE = function() {
  var r = this, c = r._self._c;
  return r._self._setupProxy, c("table", { class: ["simplecast-table", r.size] }, [c("thead", [r._t("head"), r.fields && r.fields.length > 0 ? c("SRow", { attrs: { header: !0 } }, r._l(r.fields, function(u) {
    return c("SCell", { key: u.key, attrs: { size: r.size, header: !0 } }, [r._v(" " + r._s(u.label) + " ")]);
  }), 1) : r._e()], 2), r.items && r.items.length > 0 ? c("tbody", r._l(r.items, function(u, p) {
    return c("SRow", { key: p, attrs: { to: u.to, "click-title": u.clickTitle, events: u.events } }, r._l(r.fields, function(h) {
      return c("SCell", { key: `${p}-${h.key}`, attrs: { label: h.mobile ? h.mobile : h.label, size: r.size } }, [r._v(" " + r._s(u[h.key]) + " ")]);
    }), 1);
  }), 1) : c("tbody", [r._t("default")], 2)]);
}, yE = [], kE = /* @__PURE__ */ he(
  _E,
  wE,
  yE,
  !1,
  null,
  "48e09da5",
  null,
  null
);
const b2 = kE.exports;
const xE = {
  components: {
    FormSelect: gI
  },
  props: {
    label: {
      type: String,
      default: "tabs"
    },
    tabs: {
      type: Array,
      default: () => []
    },
    responsiveBreak: {
      type: Number,
      default: 500
    },
    startingTab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedTab: this.startingTab,
      showSelect: !1,
      selectOptions: {
        value: "tab-0",
        options: this.tabs.map((a, r) => ({
          value: "tab-" + r,
          label: a.title
        }))
      },
      underlineStyles: [
        {
          marginLeft: "0",
          width: "0"
        }
      ]
    };
  },
  mounted() {
    this.handleResize(), this.updateUnderlineStyles();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  watch: {
    tabs() {
      this.updateUnderlineStyles();
    }
  },
  methods: {
    component(a) {
      return a.to ? "router-link" : "a";
    },
    handleResize() {
      const a = this.$el.clientWidth || 1e3;
      this.svgWidth = a, a <= this.responsiveBreak ? this.showSelect = !0 : this.showSelect = !1;
    },
    getUnderlineStyle(a) {
      return this.underlineStyles[a];
    },
    selectChanged(a) {
      const r = a.value.replace("tab-", "");
      this.selectTab(parseInt(r));
    },
    selectTab(a) {
      this.$set(this.selectOptions, "value", "tab-" + a), this.selectedTab = a, this.$emit("change", this.selectedTab);
    },
    updateUnderlineStyles() {
      if (this.$refs["tab-0"] && !this.showSelect) {
        const a = this.$refs["tab-0"][0].offsetLeft;
        this.underlineStyles = this.tabs.map((r, c) => {
          const { offsetLeft: u, offsetWidth: p } = this.$refs[`tab-${c}`][0];
          return {
            marginLeft: `${u - a}px`,
            width: `${p}px`
          };
        });
      }
    }
  }
};
var SE = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "tabs-container" }, [r.showSelect ? c("div", [c("FormSelect", { on: { change: r.selectChanged }, model: { value: r.selectOptions, callback: function(u) {
    r.selectOptions = u;
  }, expression: "selectOptions" } })], 1) : c("div", { staticClass: "tabs", attrs: { "aria-label": r.label } }, r._l(r.tabs, function(u, p) {
    return c(r.component(u), { key: `tab-${p}`, ref: `tab-${p}`, refInFor: !0, tag: "component", class: {
      tab: !0,
      selected: r.selectedTab === p
    }, attrs: { role: "tab", "aria-label": u.title, "aria-controls": `${r.label}-tabs-content`, "aria-selected": r.selectedTab === p, to: u.to }, on: { click: function(h) {
      return h.preventDefault(), r.selectTab(p);
    } } }, [r._v(" " + r._s(u.title) + " ")]);
  }), 1), c("div", { staticClass: "tabs-underline" }, [c("div", { staticClass: "tab-underline slide", style: r.getUnderlineStyle(r.selectedTab) })]), c("div", { staticClass: "tabs-content", attrs: { id: `${r.label}-tabs-content` } }, [c("transition", { attrs: { name: "fade", mode: "out-in" } }, [r.tabs.length && r.tabs[r.selectedTab] ? c(r.tabs[r.selectedTab].component, r._g(r._b({ tag: "component", attrs: { "aria-label": r.tabs[r.selectedTab].title } }, "component", r.tabs[r.selectedTab].props || {}, !1), r.tabs[r.selectedTab].events || {})) : r._e()], 1)], 1)]);
}, CE = [], AE = /* @__PURE__ */ he(
  xE,
  SE,
  CE,
  !1,
  null,
  "0c539782",
  null,
  null
);
const _2 = AE.exports;
const TE = {
  name: "SToast",
  components: {
    Alert: cp
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !0
    },
    timer: {
      type: Number,
      default: 4e3
    },
    type: {
      type: String,
      default: "default",
      validator: function(a) {
        return ["default", "success", "warning", "error"].includes(a);
      }
    }
  },
  watch: {
    isOpen(a) {
      a && this.countdown();
    }
  },
  created() {
    this.isOpen && this.countdown();
  },
  methods: {
    countdown() {
      setTimeout(() => {
        this.$emit("dismiss");
      }, this.timer);
    }
  }
};
var IE = function() {
  var r = this, c = r._self._c;
  return c("Transition", { attrs: { name: "toast" } }, [r.isOpen ? c("Alert", { attrs: { sticky: !0, dismissable: !1, type: r.type } }, [r._t("default")], 2) : r._e()], 1);
}, EE = [], PE = /* @__PURE__ */ he(
  TE,
  IE,
  EE,
  !1,
  null,
  "471fe925",
  null,
  null
);
const w2 = PE.exports;
const ME = {
  name: "s-card",
  components: {
    Card: j1,
    Badge: Di
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      validator: (a) => [
        "neutral",
        "accent1",
        "accent2",
        "accent3",
        "accent4",
        "accent5"
      ].includes(a),
      default: "neutral"
    }
  }
};
var OE = function() {
  var r = this, c = r._self._c;
  return c("aside", { staticClass: "tip" }, [c("Badge", { class: "tip__title", attrs: { variant: r.variant === "neutral" ? "neutral-weak" : r.variant, tag: "h4" } }, [r._v(" " + r._s(r.title) + " ")]), c("Card", { staticClass: "tip__content", attrs: { variant: r.variant === "neutral" ? "neutral-strong" : r.variant, radius: "marketing" } }, [r._t("default")], 2)], 1);
}, DE = [], NE = /* @__PURE__ */ he(
  ME,
  OE,
  DE,
  !1,
  null,
  null,
  null,
  null
);
const y2 = NE.exports, RE = {
  body: "p",
  "lg-body": "p",
  "sm-body": "p",
  subtitle: "h5",
  "lg-subtitle": "h5",
  "sm-subtitle": "h5",
  helper: "p",
  "lg-helper": "p",
  title: "h3",
  "sm-title": "h4",
  "marketing-heading": "h1",
  "lg-heading": "h1",
  "sm-heading": "h2"
}, Ir = {
  body: "sans",
  "lg-body": "sans",
  "sm-body": "sans",
  subtitle: "sans",
  "lg-subtitle": "sans",
  "sm-subtitle": "sans",
  helper: "mono",
  "lg-helper": "mono",
  title: "wide",
  "sm-title": "wide",
  "marketing-heading": "wide",
  "lg-heading": "wide",
  "sm-heading": "wide"
}, LE = ue.extend({
  name: "Type",
  props: {
    align: {
      type: String,
      default: "left"
    },
    color: {
      type: String
    },
    gutterBottom: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      default: "body"
    },
    variantSm: {
      type: String,
      default: null
    },
    variantMd: {
      type: String,
      default: null
    },
    variantLg: {
      type: String,
      default: null
    },
    variantXl: {
      type: String,
      default: null
    },
    prominence: {
      type: String,
      default: null
    },
    prominenceSm: {
      type: String,
      default: null
    },
    prominenceMd: {
      type: String,
      default: null
    },
    prominenceLg: {
      type: String,
      default: null
    },
    prominenceXl: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: null
    }
  },
  computed: {
    classList() {
      return [
        "type",
        `type--${this.variant}`,
        this.variantSm ? `type--${this.variantSm}__sm` : "",
        this.variantMd ? `type--${this.variantMd}__md` : "",
        this.variantLg ? `type--${this.variantLg}__lg` : "",
        this.variantXl ? `type--${this.variantXl}__xl` : "",
        this.prominence ? `type--${this.family}-${this.prominence}` : "",
        this.prominenceSm ? `type--${this.familySm}-${this.prominenceSm}__sm` : "",
        this.prominenceMd ? `type--${this.familyMd}-${this.prominenceMd}__md` : "",
        this.prominenceLg ? `type--${this.familyLg}-${this.prominenceLg}__lg` : "",
        this.prominenceXl ? `type--${this.familyXl}-${this.prominenceXl}__xl` : "",
        `type--align-${this.align}`,
        this.color ? `type--color-${this.color}` : "",
        this.gutterBottom ? "" : "type--no-margin"
      ];
    },
    component() {
      return this.tag ? this.tag : RE[this.variant];
    },
    family() {
      return Ir[this.variant];
    },
    familySm() {
      return this.variantSm ? Ir[this.variantSm] : this.family;
    },
    familyMd() {
      return this.variantMd ? Ir[this.variantMd] : this.familySm;
    },
    familyLg() {
      return this.variantLg ? Ir[this.variantLg] : this.familyMd;
    },
    familyXl() {
      return this.variantXl ? Ir[this.variantXl] : this.familyLg;
    }
  }
});
var FE = function() {
  var r = this, c = r._self._c;
  return r._self._setupProxy, c(r.component, r._b({ tag: "component", class: r.classList }, "component", r.$props, !1), [r._t("default")], 2);
}, zE = [], $E = /* @__PURE__ */ he(
  LE,
  FE,
  zE,
  !1,
  null,
  "d7dbb6f6",
  null,
  null
);
const k2 = $E.exports, jE = {
  name: "UserIcon"
};
var BE = function() {
  var r = this, c = r._self._c;
  return c("svg", { attrs: { viewBox: "0 0 67 67", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [c("path", { attrs: { d: "M33.1944444,0 C14.8711111,0 0,14.8711111 0,33.1944444 C0,51.5177778 14.8711111,66.3888889 33.1944444,66.3888889 C51.5177778,66.3888889 66.3888889,51.5177778 66.3888889,33.1944444 C66.3888889,14.8711111 51.5177778,0 33.1944444,0 L33.1944444,0 Z M33.1944444,9.95833333 C38.7047222,9.95833333 43.1527778,14.4063889 43.1527778,19.9166667 C43.1527778,25.4269444 38.7047222,29.875 33.1944444,29.875 C27.6841667,29.875 23.2361111,25.4269444 23.2361111,19.9166667 C23.2361111,14.4063889 27.6841667,9.95833333 33.1944444,9.95833333 L33.1944444,9.95833333 Z M33.1944444,57.0944444 C24.8958333,57.0944444 17.5598611,52.8455556 13.2777778,46.4058333 C13.3773611,39.8001389 26.5555556,36.1819444 33.1944444,36.1819444 C39.8001389,36.1819444 53.0115278,39.8001389 53.1111111,46.4058333 C48.8290278,52.8455556 41.4930556,57.0944444 33.1944444,57.0944444 L33.1944444,57.0944444 Z" } })]);
}, VE = [], UE = /* @__PURE__ */ he(
  jE,
  BE,
  VE,
  !1,
  null,
  null,
  null,
  null
);
const HE = UE.exports;
const WE = {
  components: {
    Artwork: kl,
    IconUser: HE
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    user: {
      type: Object,
      default: null
    },
    account: {
      type: Object,
      default: null
    }
  },
  computed: {
    accountImageUrl() {
      return !this.account || !this.account.owner || !this.account.owner.image_url ? null : this.account.owner.image_url;
    },
    imageUrl() {
      return !this.user || !this.user.image_url ? null : this.user.image_url;
    }
  }
};
var YE = function() {
  var r = this, c = r._self._c;
  return c("div", { staticClass: "user-artwork" }, [c("artwork", { staticClass: "ratio-circle", attrs: { "image-url": r.imageUrl, loading: r.loading } }, [r.imageUrl ? r._e() : c("icon-user", { staticClass: "user-artwork-default" })], 1), r.account ? c("artwork", { staticClass: "account-artwork ratio-circle", attrs: { "image-url": r.accountImageUrl, loading: r.loading } }, [r.accountImageUrl ? r._e() : c("icon-user", { staticClass: "account-artwork-default" })], 1) : r._e()], 1);
}, qE = [], GE = /* @__PURE__ */ he(
  WE,
  YE,
  qE,
  !1,
  null,
  "3411a190",
  null,
  null
);
const x2 = GE.exports;
function ZE(a) {
  for (var r = 1; r < arguments.length; r++) {
    var c = arguments[r];
    for (var u in c)
      c.hasOwnProperty(u) && (a[u] = c[u]);
  }
  return a;
}
function bl(a, r) {
  return Array(r + 1).join(a);
}
function KE(a) {
  return a.replace(/^\n*/, "");
}
function XE(a) {
  for (var r = a.length; r > 0 && a[r - 1] === `
`; )
    r--;
  return a.substring(0, r);
}
var QE = [
  "ADDRESS",
  "ARTICLE",
  "ASIDE",
  "AUDIO",
  "BLOCKQUOTE",
  "BODY",
  "CANVAS",
  "CENTER",
  "DD",
  "DIR",
  "DIV",
  "DL",
  "DT",
  "FIELDSET",
  "FIGCAPTION",
  "FIGURE",
  "FOOTER",
  "FORM",
  "FRAMESET",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HEADER",
  "HGROUP",
  "HR",
  "HTML",
  "ISINDEX",
  "LI",
  "MAIN",
  "MENU",
  "NAV",
  "NOFRAMES",
  "NOSCRIPT",
  "OL",
  "OUTPUT",
  "P",
  "PRE",
  "SECTION",
  "TABLE",
  "TBODY",
  "TD",
  "TFOOT",
  "TH",
  "THEAD",
  "TR",
  "UL"
];
function Tl(a) {
  return Il(a, QE);
}
var Up = [
  "AREA",
  "BASE",
  "BR",
  "COL",
  "COMMAND",
  "EMBED",
  "HR",
  "IMG",
  "INPUT",
  "KEYGEN",
  "LINK",
  "META",
  "PARAM",
  "SOURCE",
  "TRACK",
  "WBR"
];
function Hp(a) {
  return Il(a, Up);
}
function JE(a) {
  return Yp(a, Up);
}
var Wp = [
  "A",
  "TABLE",
  "THEAD",
  "TBODY",
  "TFOOT",
  "TH",
  "TD",
  "IFRAME",
  "SCRIPT",
  "AUDIO",
  "VIDEO"
];
function eP(a) {
  return Il(a, Wp);
}
function tP(a) {
  return Yp(a, Wp);
}
function Il(a, r) {
  return r.indexOf(a.nodeName) >= 0;
}
function Yp(a, r) {
  return a.getElementsByTagName && r.some(function(c) {
    return a.getElementsByTagName(c).length;
  });
}
var qt = {};
qt.paragraph = {
  filter: "p",
  replacement: function(a) {
    return `

` + a + `

`;
  }
};
qt.lineBreak = {
  filter: "br",
  replacement: function(a, r, c) {
    return c.br + `
`;
  }
};
qt.heading = {
  filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
  replacement: function(a, r, c) {
    var u = Number(r.nodeName.charAt(1));
    if (c.headingStyle === "setext" && u < 3) {
      var p = bl(u === 1 ? "=" : "-", a.length);
      return `

` + a + `
` + p + `

`;
    } else
      return `

` + bl("#", u) + " " + a + `

`;
  }
};
qt.blockquote = {
  filter: "blockquote",
  replacement: function(a) {
    return a = a.replace(/^\n+|\n+$/g, ""), a = a.replace(/^/gm, "> "), `

` + a + `

`;
  }
};
qt.list = {
  filter: ["ul", "ol"],
  replacement: function(a, r) {
    var c = r.parentNode;
    return c.nodeName === "LI" && c.lastElementChild === r ? `
` + a : `

` + a + `

`;
  }
};
qt.listItem = {
  filter: "li",
  replacement: function(a, r, c) {
    a = a.replace(/^\n+/, "").replace(/\n+$/, `
`).replace(/\n/gm, `
    `);
    var u = c.bulletListMarker + "   ", p = r.parentNode;
    if (p.nodeName === "OL") {
      var h = p.getAttribute("start"), v = Array.prototype.indexOf.call(p.children, r);
      u = (h ? Number(h) + v : v + 1) + ".  ";
    }
    return u + a + (r.nextSibling && !/\n$/.test(a) ? `
` : "");
  }
};
qt.indentedCodeBlock = {
  filter: function(a, r) {
    return r.codeBlockStyle === "indented" && a.nodeName === "PRE" && a.firstChild && a.firstChild.nodeName === "CODE";
  },
  replacement: function(a, r, c) {
    return `

    ` + r.firstChild.textContent.replace(/\n/g, `
    `) + `

`;
  }
};
qt.fencedCodeBlock = {
  filter: function(a, r) {
    return r.codeBlockStyle === "fenced" && a.nodeName === "PRE" && a.firstChild && a.firstChild.nodeName === "CODE";
  },
  replacement: function(a, r, c) {
    for (var u = r.firstChild.getAttribute("class") || "", p = (u.match(/language-(\S+)/) || [null, ""])[1], h = r.firstChild.textContent, v = c.fence.charAt(0), w = 3, x = new RegExp("^" + v + "{3,}", "gm"), k; k = x.exec(h); )
      k[0].length >= w && (w = k[0].length + 1);
    var P = bl(v, w);
    return `

` + P + p + `
` + h.replace(/\n$/, "") + `
` + P + `

`;
  }
};
qt.horizontalRule = {
  filter: "hr",
  replacement: function(a, r, c) {
    return `

` + c.hr + `

`;
  }
};
qt.inlineLink = {
  filter: function(a, r) {
    return r.linkStyle === "inlined" && a.nodeName === "A" && a.getAttribute("href");
  },
  replacement: function(a, r) {
    var c = r.getAttribute("href"), u = is(r.getAttribute("title"));
    return u && (u = ' "' + u + '"'), "[" + a + "](" + c + u + ")";
  }
};
qt.referenceLink = {
  filter: function(a, r) {
    return r.linkStyle === "referenced" && a.nodeName === "A" && a.getAttribute("href");
  },
  replacement: function(a, r, c) {
    var u = r.getAttribute("href"), p = is(r.getAttribute("title"));
    p && (p = ' "' + p + '"');
    var h, v;
    switch (c.linkReferenceStyle) {
      case "collapsed":
        h = "[" + a + "][]", v = "[" + a + "]: " + u + p;
        break;
      case "shortcut":
        h = "[" + a + "]", v = "[" + a + "]: " + u + p;
        break;
      default:
        var w = this.references.length + 1;
        h = "[" + a + "][" + w + "]", v = "[" + w + "]: " + u + p;
    }
    return this.references.push(v), h;
  },
  references: [],
  append: function(a) {
    var r = "";
    return this.references.length && (r = `

` + this.references.join(`
`) + `

`, this.references = []), r;
  }
};
qt.emphasis = {
  filter: ["em", "i"],
  replacement: function(a, r, c) {
    return a.trim() ? c.emDelimiter + a + c.emDelimiter : "";
  }
};
qt.strong = {
  filter: ["strong", "b"],
  replacement: function(a, r, c) {
    return a.trim() ? c.strongDelimiter + a + c.strongDelimiter : "";
  }
};
qt.code = {
  filter: function(a) {
    var r = a.previousSibling || a.nextSibling, c = a.parentNode.nodeName === "PRE" && !r;
    return a.nodeName === "CODE" && !c;
  },
  replacement: function(a) {
    if (!a)
      return "";
    a = a.replace(/\r?\n|\r/g, " ");
    for (var r = /^`|^ .*?[^ ].* $|`$/.test(a) ? " " : "", c = "`", u = a.match(/`+/gm) || []; u.indexOf(c) !== -1; )
      c = c + "`";
    return c + r + a + r + c;
  }
};
qt.image = {
  filter: "img",
  replacement: function(a, r) {
    var c = is(r.getAttribute("alt")), u = r.getAttribute("src") || "", p = is(r.getAttribute("title")), h = p ? ' "' + p + '"' : "";
    return u ? "![" + c + "](" + u + h + ")" : "";
  }
};
function is(a) {
  return a ? a.replace(/(\n+\s*)+/g, `
`) : "";
}
function qp(a) {
  this.options = a, this._keep = [], this._remove = [], this.blankRule = {
    replacement: a.blankReplacement
  }, this.keepReplacement = a.keepReplacement, this.defaultRule = {
    replacement: a.defaultReplacement
  }, this.array = [];
  for (var r in a.rules)
    this.array.push(a.rules[r]);
}
qp.prototype = {
  add: function(a, r) {
    this.array.unshift(r);
  },
  keep: function(a) {
    this._keep.unshift({
      filter: a,
      replacement: this.keepReplacement
    });
  },
  remove: function(a) {
    this._remove.unshift({
      filter: a,
      replacement: function() {
        return "";
      }
    });
  },
  forNode: function(a) {
    if (a.isBlank)
      return this.blankRule;
    var r;
    return (r = cl(this.array, a, this.options)) || (r = cl(this._keep, a, this.options)) || (r = cl(this._remove, a, this.options)) ? r : this.defaultRule;
  },
  forEach: function(a) {
    for (var r = 0; r < this.array.length; r++)
      a(this.array[r], r);
  }
};
function cl(a, r, c) {
  for (var u = 0; u < a.length; u++) {
    var p = a[u];
    if (nP(p, r, c))
      return p;
  }
}
function nP(a, r, c) {
  var u = a.filter;
  if (typeof u == "string") {
    if (u === r.nodeName.toLowerCase())
      return !0;
  } else if (Array.isArray(u)) {
    if (u.indexOf(r.nodeName.toLowerCase()) > -1)
      return !0;
  } else if (typeof u == "function") {
    if (u.call(a, r, c))
      return !0;
  } else
    throw new TypeError("`filter` needs to be a string, array, or function");
}
function iP(a) {
  var r = a.element, c = a.isBlock, u = a.isVoid, p = a.isPre || function(R) {
    return R.nodeName === "PRE";
  };
  if (!(!r.firstChild || p(r))) {
    for (var h = null, v = !1, w = null, x = tp(w, r, p); x !== r; ) {
      if (x.nodeType === 3 || x.nodeType === 4) {
        var k = x.data.replace(/[ \r\n\t]+/g, " ");
        if ((!h || / $/.test(h.data)) && !v && k[0] === " " && (k = k.substr(1)), !k) {
          x = ul(x);
          continue;
        }
        x.data = k, h = x;
      } else if (x.nodeType === 1)
        c(x) || x.nodeName === "BR" ? (h && (h.data = h.data.replace(/ $/, "")), h = null, v = !1) : u(x) || p(x) ? (h = null, v = !0) : h && (v = !1);
      else {
        x = ul(x);
        continue;
      }
      var P = tp(w, x, p);
      w = x, x = P;
    }
    h && (h.data = h.data.replace(/ $/, ""), h.data || ul(h));
  }
}
function ul(a) {
  var r = a.nextSibling || a.parentNode;
  return a.parentNode.removeChild(a), r;
}
function tp(a, r, c) {
  return a && a.parentNode === r || c(r) ? r.nextSibling || r.parentNode : r.firstChild || r.nextSibling || r.parentNode;
}
var Gp = typeof window < "u" ? window : {};
function rP() {
  var a = Gp.DOMParser, r = !1;
  try {
    new a().parseFromString("", "text/html") && (r = !0);
  } catch {
  }
  return r;
}
function oP() {
  var a = function() {
  };
  return sP() ? a.prototype.parseFromString = function(r) {
    var c = new window.ActiveXObject("htmlfile");
    return c.designMode = "on", c.open(), c.write(r), c.close(), c;
  } : a.prototype.parseFromString = function(r) {
    var c = document.implementation.createHTMLDocument("");
    return c.open(), c.write(r), c.close(), c;
  }, a;
}
function sP() {
  var a = !1;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch {
    window.ActiveXObject && (a = !0);
  }
  return a;
}
var aP = rP() ? Gp.DOMParser : oP();
function lP(a, r) {
  var c;
  if (typeof a == "string") {
    var u = cP().parseFromString(
      '<x-turndown id="turndown-root">' + a + "</x-turndown>",
      "text/html"
    );
    c = u.getElementById("turndown-root");
  } else
    c = a.cloneNode(!0);
  return iP({
    element: c,
    isBlock: Tl,
    isVoid: Hp,
    isPre: r.preformattedCode ? uP : null
  }), c;
}
var dl;
function cP() {
  return dl = dl || new aP(), dl;
}
function uP(a) {
  return a.nodeName === "PRE" || a.nodeName === "CODE";
}
function dP(a, r) {
  return a.isBlock = Tl(a), a.isCode = a.nodeName === "CODE" || a.parentNode.isCode, a.isBlank = hP(a), a.flankingWhitespace = fP(a, r), a;
}
function hP(a) {
  return !Hp(a) && !eP(a) && /^\s*$/i.test(a.textContent) && !JE(a) && !tP(a);
}
function fP(a, r) {
  if (a.isBlock || r.preformattedCode && a.isCode)
    return { leading: "", trailing: "" };
  var c = pP(a.textContent);
  return c.leadingAscii && np("left", a, r) && (c.leading = c.leadingNonAscii), c.trailingAscii && np("right", a, r) && (c.trailing = c.trailingNonAscii), { leading: c.leading, trailing: c.trailing };
}
function pP(a) {
  var r = a.match(/^(([ \t\r\n]*)(\s*))[\s\S]*?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: r[1],
    leadingAscii: r[2],
    leadingNonAscii: r[3],
    trailing: r[4],
    trailingNonAscii: r[5],
    trailingAscii: r[6]
  };
}
function np(a, r, c) {
  var u, p, h;
  return a === "left" ? (u = r.previousSibling, p = / $/) : (u = r.nextSibling, p = /^ /), u && (u.nodeType === 3 ? h = p.test(u.nodeValue) : c.preformattedCode && u.nodeName === "CODE" ? h = !1 : u.nodeType === 1 && !Tl(u) && (h = p.test(u.textContent))), h;
}
var mP = Array.prototype.reduce, gP = [
  [/\\/g, "\\\\"],
  [/\*/g, "\\*"],
  [/^-/g, "\\-"],
  [/^\+ /g, "\\+ "],
  [/^(=+)/g, "\\$1"],
  [/^(#{1,6}) /g, "\\$1 "],
  [/`/g, "\\`"],
  [/^~~~/g, "\\~~~"],
  [/\[/g, "\\["],
  [/\]/g, "\\]"],
  [/^>/g, "\\>"],
  [/_/g, "\\_"],
  [/^(\d+)\. /g, "$1\\. "]
];
function rs(a) {
  if (!(this instanceof rs))
    return new rs(a);
  var r = {
    rules: qt,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: !1,
    blankReplacement: function(c, u) {
      return u.isBlock ? `

` : "";
    },
    keepReplacement: function(c, u) {
      return u.isBlock ? `

` + u.outerHTML + `

` : u.outerHTML;
    },
    defaultReplacement: function(c, u) {
      return u.isBlock ? `

` + c + `

` : c;
    }
  };
  this.options = ZE({}, r, a), this.rules = new qp(this.options);
}
rs.prototype = {
  turndown: function(a) {
    if (!_P(a))
      throw new TypeError(
        a + " is not a string, or an element/document/fragment node."
      );
    if (a === "")
      return "";
    var r = Zp.call(this, new lP(a, this.options));
    return vP.call(this, r);
  },
  use: function(a) {
    if (Array.isArray(a))
      for (var r = 0; r < a.length; r++)
        this.use(a[r]);
    else if (typeof a == "function")
      a(this);
    else
      throw new TypeError("plugin must be a Function or an Array of Functions");
    return this;
  },
  addRule: function(a, r) {
    return this.rules.add(a, r), this;
  },
  keep: function(a) {
    return this.rules.keep(a), this;
  },
  remove: function(a) {
    return this.rules.remove(a), this;
  },
  escape: function(a) {
    return gP.reduce(function(r, c) {
      return r.replace(c[0], c[1]);
    }, a);
  }
};
function Zp(a) {
  var r = this;
  return mP.call(a.childNodes, function(c, u) {
    u = new dP(u, r.options);
    var p = "";
    return u.nodeType === 3 ? p = u.isCode ? u.nodeValue : r.escape(u.nodeValue) : u.nodeType === 1 && (p = bP.call(r, u)), Kp(c, p);
  }, "");
}
function vP(a) {
  var r = this;
  return this.rules.forEach(function(c) {
    typeof c.append == "function" && (a = Kp(a, c.append(r.options)));
  }), a.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function bP(a) {
  var r = this.rules.forNode(a), c = Zp.call(this, a), u = a.flankingWhitespace;
  return (u.leading || u.trailing) && (c = c.trim()), u.leading + r.replacement(c, a, this.options) + u.trailing;
}
function Kp(a, r) {
  var c = XE(a), u = KE(r), p = Math.max(a.length - c.length, r.length - u.length), h = `

`.substring(0, p);
  return c + h + u;
}
function _P(a) {
  return a != null && (typeof a == "string" || a.nodeType && (a.nodeType === 1 || a.nodeType === 9 || a.nodeType === 11));
}
var Xp = { exports: {} };
(function(a, r) {
  (function(c, u) {
    a.exports = u();
  })(An, function() {
    function c(K, U) {
      for (var G = 0; G < U.length; G++) {
        var S = U[G];
        S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(K, S.key, S);
      }
    }
    function u(K, U, G) {
      return U && c(K.prototype, U), G && c(K, G), K;
    }
    function p(K, U) {
      if (!!K) {
        if (typeof K == "string")
          return h(K, U);
        var G = Object.prototype.toString.call(K).slice(8, -1);
        if (G === "Object" && K.constructor && (G = K.constructor.name), G === "Map" || G === "Set")
          return Array.from(K);
        if (G === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(G))
          return h(K, U);
      }
    }
    function h(K, U) {
      (U == null || U > K.length) && (U = K.length);
      for (var G = 0, S = new Array(U); G < U; G++)
        S[G] = K[G];
      return S;
    }
    function v(K, U) {
      var G;
      if (typeof Symbol > "u" || K[Symbol.iterator] == null) {
        if (Array.isArray(K) || (G = p(K)) || U && K && typeof K.length == "number") {
          G && (K = G);
          var S = 0;
          return function() {
            return S >= K.length ? {
              done: !0
            } : {
              done: !1,
              value: K[S++]
            };
          };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      return G = K[Symbol.iterator](), G.next.bind(G);
    }
    function w(K) {
      var U = { exports: {} };
      return K(U, U.exports), U.exports;
    }
    var x = w(function(K) {
      function U() {
        return {
          baseUrl: null,
          breaks: !1,
          gfm: !0,
          headerIds: !0,
          headerPrefix: "",
          highlight: null,
          langPrefix: "language-",
          mangle: !0,
          pedantic: !1,
          renderer: null,
          sanitize: !1,
          sanitizer: null,
          silent: !1,
          smartLists: !1,
          smartypants: !1,
          tokenizer: null,
          walkTokens: null,
          xhtml: !1
        };
      }
      function G(S) {
        K.exports.defaults = S;
      }
      K.exports = {
        defaults: U(),
        getDefaults: U,
        changeDefaults: G
      };
    }), k = /[&<>"']/, P = /[&<>"']/g, R = /[<>"']|&(?!#?\w+;)/, $ = /[<>"']|&(?!#?\w+;)/g, J = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, X = function(U) {
      return J[U];
    };
    function H(K, U) {
      if (U) {
        if (k.test(K))
          return K.replace(P, X);
      } else if (R.test(K))
        return K.replace($, X);
      return K;
    }
    var W = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function Z(K) {
      return K.replace(W, function(U, G) {
        return G = G.toLowerCase(), G === "colon" ? ":" : G.charAt(0) === "#" ? G.charAt(1) === "x" ? String.fromCharCode(parseInt(G.substring(2), 16)) : String.fromCharCode(+G.substring(1)) : "";
      });
    }
    var ee = /(^|[^\[])\^/g;
    function ne(K, U) {
      K = K.source || K, U = U || "";
      var G = {
        replace: function(T, I) {
          return I = I.source || I, I = I.replace(ee, "$1"), K = K.replace(T, I), G;
        },
        getRegex: function() {
          return new RegExp(K, U);
        }
      };
      return G;
    }
    var se = /[^\w:]/g, pe = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    function ge(K, U, G) {
      if (K) {
        var S;
        try {
          S = decodeURIComponent(Z(G)).replace(se, "").toLowerCase();
        } catch {
          return null;
        }
        if (S.indexOf("javascript:") === 0 || S.indexOf("vbscript:") === 0 || S.indexOf("data:") === 0)
          return null;
      }
      U && !pe.test(G) && (G = _(U, G));
      try {
        G = encodeURI(G).replace(/%25/g, "%");
      } catch {
        return null;
      }
      return G;
    }
    var Oe = {}, ke = /^[^:]+:\/*[^/]*$/, we = /^([^:]+:)[\s\S]*$/, F = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    function _(K, U) {
      Oe[" " + K] || (ke.test(K) ? Oe[" " + K] = K + "/" : Oe[" " + K] = N(K, "/", !0)), K = Oe[" " + K];
      var G = K.indexOf(":") === -1;
      return U.substring(0, 2) === "//" ? G ? U : K.replace(we, "$1") + U : U.charAt(0) === "/" ? G ? U : K.replace(F, "$1") + U : K + U;
    }
    var E = {
      exec: function() {
      }
    };
    function B(K) {
      for (var U = 1, G, S; U < arguments.length; U++) {
        G = arguments[U];
        for (S in G)
          Object.prototype.hasOwnProperty.call(G, S) && (K[S] = G[S]);
      }
      return K;
    }
    function Y(K, U) {
      var G = K.replace(/\|/g, function(I, L, j) {
        for (var xe = !1, Se = L; --Se >= 0 && j[Se] === "\\"; )
          xe = !xe;
        return xe ? "|" : " |";
      }), S = G.split(/ \|/), T = 0;
      if (S.length > U)
        S.splice(U);
      else
        for (; S.length < U; )
          S.push("");
      for (; T < S.length; T++)
        S[T] = S[T].trim().replace(/\\\|/g, "|");
      return S;
    }
    function N(K, U, G) {
      var S = K.length;
      if (S === 0)
        return "";
      for (var T = 0; T < S; ) {
        var I = K.charAt(S - T - 1);
        if (I === U && !G)
          T++;
        else if (I !== U && G)
          T++;
        else
          break;
      }
      return K.substr(0, S - T);
    }
    function re(K, U) {
      if (K.indexOf(U[1]) === -1)
        return -1;
      for (var G = K.length, S = 0, T = 0; T < G; T++)
        if (K[T] === "\\")
          T++;
        else if (K[T] === U[0])
          S++;
        else if (K[T] === U[1] && (S--, S < 0))
          return T;
      return -1;
    }
    function Te(K) {
      K && K.sanitize && !K.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    function Me(K, U) {
      if (U < 1)
        return "";
      for (var G = ""; U > 1; )
        U & 1 && (G += K), U >>= 1, K += K;
      return G + K;
    }
    var Ee = {
      escape: H,
      unescape: Z,
      edit: ne,
      cleanUrl: ge,
      resolveUrl: _,
      noopTest: E,
      merge: B,
      splitCells: Y,
      rtrim: N,
      findClosingBracket: re,
      checkSanitizeDeprecation: Te,
      repeatString: Me
    }, Ce = x.defaults, q = Ee.rtrim, A = Ee.splitCells, M = Ee.escape, Q = Ee.findClosingBracket;
    function z(K, U, G) {
      var S = U.href, T = U.title ? M(U.title) : null, I = K[1].replace(/\\([\[\]])/g, "$1");
      return K[0].charAt(0) !== "!" ? {
        type: "link",
        raw: G,
        href: S,
        title: T,
        text: I
      } : {
        type: "image",
        raw: G,
        href: S,
        title: T,
        text: M(I)
      };
    }
    function te(K, U) {
      var G = K.match(/^(\s+)(?:```)/);
      if (G === null)
        return U;
      var S = G[1];
      return U.split(`
`).map(function(T) {
        var I = T.match(/^\s+/);
        if (I === null)
          return T;
        var L = I[0];
        return L.length >= S.length ? T.slice(S.length) : T;
      }).join(`
`);
    }
    var me = /* @__PURE__ */ function() {
      function K(G) {
        this.options = G || Ce;
      }
      var U = K.prototype;
      return U.space = function(S) {
        var T = this.rules.block.newline.exec(S);
        if (T)
          return T[0].length > 1 ? {
            type: "space",
            raw: T[0]
          } : {
            raw: `
`
          };
      }, U.code = function(S, T) {
        var I = this.rules.block.code.exec(S);
        if (I) {
          var L = T[T.length - 1];
          if (L && L.type === "paragraph")
            return {
              raw: I[0],
              text: I[0].trimRight()
            };
          var j = I[0].replace(/^ {1,4}/gm, "");
          return {
            type: "code",
            raw: I[0],
            codeBlockStyle: "indented",
            text: this.options.pedantic ? j : q(j, `
`)
          };
        }
      }, U.fences = function(S) {
        var T = this.rules.block.fences.exec(S);
        if (T) {
          var I = T[0], L = te(I, T[3] || "");
          return {
            type: "code",
            raw: I,
            lang: T[2] ? T[2].trim() : T[2],
            text: L
          };
        }
      }, U.heading = function(S) {
        var T = this.rules.block.heading.exec(S);
        if (T) {
          var I = T[2].trim();
          if (/#$/.test(I)) {
            var L = q(I, "#");
            (this.options.pedantic || !L || / $/.test(L)) && (I = L.trim());
          }
          return {
            type: "heading",
            raw: T[0],
            depth: T[1].length,
            text: I
          };
        }
      }, U.nptable = function(S) {
        var T = this.rules.block.nptable.exec(S);
        if (T) {
          var I = {
            type: "table",
            header: A(T[1].replace(/^ *| *\| *$/g, "")),
            align: T[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
            cells: T[3] ? T[3].replace(/\n$/, "").split(`
`) : [],
            raw: T[0]
          };
          if (I.header.length === I.align.length) {
            var L = I.align.length, j;
            for (j = 0; j < L; j++)
              /^ *-+: *$/.test(I.align[j]) ? I.align[j] = "right" : /^ *:-+: *$/.test(I.align[j]) ? I.align[j] = "center" : /^ *:-+ *$/.test(I.align[j]) ? I.align[j] = "left" : I.align[j] = null;
            for (L = I.cells.length, j = 0; j < L; j++)
              I.cells[j] = A(I.cells[j], I.header.length);
            return I;
          }
        }
      }, U.hr = function(S) {
        var T = this.rules.block.hr.exec(S);
        if (T)
          return {
            type: "hr",
            raw: T[0]
          };
      }, U.blockquote = function(S) {
        var T = this.rules.block.blockquote.exec(S);
        if (T) {
          var I = T[0].replace(/^ *> ?/gm, "");
          return {
            type: "blockquote",
            raw: T[0],
            text: I
          };
        }
      }, U.list = function(S) {
        var T = this.rules.block.list.exec(S);
        if (T) {
          var I = T[0], L = T[2], j = L.length > 1, xe = {
            type: "list",
            raw: I,
            ordered: j,
            start: j ? +L.slice(0, -1) : "",
            loose: !1,
            items: []
          }, Se = T[0].match(this.rules.block.item), Fe = !1, Re, qe, Ot, pt, Ue, vn, ti, In, zt = Se.length;
          Ot = this.rules.block.listItemStart.exec(Se[0]);
          for (var Ke = 0; Ke < zt; Ke++) {
            if (Re = Se[Ke], I = Re, Ke !== zt - 1) {
              if (pt = this.rules.block.listItemStart.exec(Se[Ke + 1]), this.options.pedantic ? pt[1].length > Ot[1].length : pt[1].length > Ot[0].length || pt[1].length > 3) {
                Se.splice(Ke, 2, Se[Ke] + `
` + Se[Ke + 1]), Ke--, zt--;
                continue;
              } else
                (!this.options.pedantic || this.options.smartLists ? pt[2][pt[2].length - 1] !== L[L.length - 1] : j === (pt[2].length === 1)) && (Ue = Se.slice(Ke + 1).join(`
`), xe.raw = xe.raw.substring(0, xe.raw.length - Ue.length), Ke = zt - 1);
              Ot = pt;
            }
            qe = Re.length, Re = Re.replace(/^ *([*+-]|\d+[.)]) ?/, ""), ~Re.indexOf(`
 `) && (qe -= Re.length, Re = this.options.pedantic ? Re.replace(/^ {1,4}/gm, "") : Re.replace(new RegExp("^ {1," + qe + "}", "gm"), "")), vn = Fe || /\n\n(?!\s*$)/.test(Re), Ke !== zt - 1 && (Fe = Re.charAt(Re.length - 1) === `
`, vn || (vn = Fe)), vn && (xe.loose = !0), this.options.gfm && (ti = /^\[[ xX]\] /.test(Re), In = void 0, ti && (In = Re[1] !== " ", Re = Re.replace(/^\[[ xX]\] +/, ""))), xe.items.push({
              type: "list_item",
              raw: I,
              task: ti,
              checked: In,
              loose: vn,
              text: Re
            });
          }
          return xe;
        }
      }, U.html = function(S) {
        var T = this.rules.block.html.exec(S);
        if (T)
          return {
            type: this.options.sanitize ? "paragraph" : "html",
            raw: T[0],
            pre: !this.options.sanitizer && (T[1] === "pre" || T[1] === "script" || T[1] === "style"),
            text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(T[0]) : M(T[0]) : T[0]
          };
      }, U.def = function(S) {
        var T = this.rules.block.def.exec(S);
        if (T) {
          T[3] && (T[3] = T[3].substring(1, T[3].length - 1));
          var I = T[1].toLowerCase().replace(/\s+/g, " ");
          return {
            tag: I,
            raw: T[0],
            href: T[2],
            title: T[3]
          };
        }
      }, U.table = function(S) {
        var T = this.rules.block.table.exec(S);
        if (T) {
          var I = {
            type: "table",
            header: A(T[1].replace(/^ *| *\| *$/g, "")),
            align: T[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
            cells: T[3] ? T[3].replace(/\n$/, "").split(`
`) : []
          };
          if (I.header.length === I.align.length) {
            I.raw = T[0];
            var L = I.align.length, j;
            for (j = 0; j < L; j++)
              /^ *-+: *$/.test(I.align[j]) ? I.align[j] = "right" : /^ *:-+: *$/.test(I.align[j]) ? I.align[j] = "center" : /^ *:-+ *$/.test(I.align[j]) ? I.align[j] = "left" : I.align[j] = null;
            for (L = I.cells.length, j = 0; j < L; j++)
              I.cells[j] = A(I.cells[j].replace(/^ *\| *| *\| *$/g, ""), I.header.length);
            return I;
          }
        }
      }, U.lheading = function(S) {
        var T = this.rules.block.lheading.exec(S);
        if (T)
          return {
            type: "heading",
            raw: T[0],
            depth: T[2].charAt(0) === "=" ? 1 : 2,
            text: T[1]
          };
      }, U.paragraph = function(S) {
        var T = this.rules.block.paragraph.exec(S);
        if (T)
          return {
            type: "paragraph",
            raw: T[0],
            text: T[1].charAt(T[1].length - 1) === `
` ? T[1].slice(0, -1) : T[1]
          };
      }, U.text = function(S, T) {
        var I = this.rules.block.text.exec(S);
        if (I) {
          var L = T[T.length - 1];
          return L && L.type === "text" ? {
            raw: I[0],
            text: I[0]
          } : {
            type: "text",
            raw: I[0],
            text: I[0]
          };
        }
      }, U.escape = function(S) {
        var T = this.rules.inline.escape.exec(S);
        if (T)
          return {
            type: "escape",
            raw: T[0],
            text: M(T[1])
          };
      }, U.tag = function(S, T, I) {
        var L = this.rules.inline.tag.exec(S);
        if (L)
          return !T && /^<a /i.test(L[0]) ? T = !0 : T && /^<\/a>/i.test(L[0]) && (T = !1), !I && /^<(pre|code|kbd|script)(\s|>)/i.test(L[0]) ? I = !0 : I && /^<\/(pre|code|kbd|script)(\s|>)/i.test(L[0]) && (I = !1), {
            type: this.options.sanitize ? "text" : "html",
            raw: L[0],
            inLink: T,
            inRawBlock: I,
            text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(L[0]) : M(L[0]) : L[0]
          };
      }, U.link = function(S) {
        var T = this.rules.inline.link.exec(S);
        if (T) {
          var I = T[2].trim();
          if (!this.options.pedantic && /^</.test(I)) {
            if (!/>$/.test(I))
              return;
            var L = q(I.slice(0, -1), "\\");
            if ((I.length - L.length) % 2 === 0)
              return;
          } else {
            var j = Q(T[2], "()");
            if (j > -1) {
              var xe = T[0].indexOf("!") === 0 ? 5 : 4, Se = xe + T[1].length + j;
              T[2] = T[2].substring(0, j), T[0] = T[0].substring(0, Se).trim(), T[3] = "";
            }
          }
          var Fe = T[2], Re = "";
          if (this.options.pedantic) {
            var qe = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(Fe);
            qe && (Fe = qe[1], Re = qe[3]);
          } else
            Re = T[3] ? T[3].slice(1, -1) : "";
          return Fe = Fe.trim(), /^</.test(Fe) && (this.options.pedantic && !/>$/.test(I) ? Fe = Fe.slice(1) : Fe = Fe.slice(1, -1)), z(T, {
            href: Fe && Fe.replace(this.rules.inline._escapes, "$1"),
            title: Re && Re.replace(this.rules.inline._escapes, "$1")
          }, T[0]);
        }
      }, U.reflink = function(S, T) {
        var I;
        if ((I = this.rules.inline.reflink.exec(S)) || (I = this.rules.inline.nolink.exec(S))) {
          var L = (I[2] || I[1]).replace(/\s+/g, " ");
          if (L = T[L.toLowerCase()], !L || !L.href) {
            var j = I[0].charAt(0);
            return {
              type: "text",
              raw: j,
              text: j
            };
          }
          return z(I, L, I[0]);
        }
      }, U.strong = function(S, T, I) {
        I === void 0 && (I = "");
        var L = this.rules.inline.strong.start.exec(S);
        if (L && (!L[1] || L[1] && (I === "" || this.rules.inline.punctuation.exec(I)))) {
          T = T.slice(-1 * S.length);
          var j = L[0] === "**" ? this.rules.inline.strong.endAst : this.rules.inline.strong.endUnd;
          j.lastIndex = 0;
          for (var xe; (L = j.exec(T)) != null; )
            if (xe = this.rules.inline.strong.middle.exec(T.slice(0, L.index + 3)), xe)
              return {
                type: "strong",
                raw: S.slice(0, xe[0].length),
                text: S.slice(2, xe[0].length - 2)
              };
        }
      }, U.em = function(S, T, I) {
        I === void 0 && (I = "");
        var L = this.rules.inline.em.start.exec(S);
        if (L && (!L[1] || L[1] && (I === "" || this.rules.inline.punctuation.exec(I)))) {
          T = T.slice(-1 * S.length);
          var j = L[0] === "*" ? this.rules.inline.em.endAst : this.rules.inline.em.endUnd;
          j.lastIndex = 0;
          for (var xe; (L = j.exec(T)) != null; )
            if (xe = this.rules.inline.em.middle.exec(T.slice(0, L.index + 2)), xe)
              return {
                type: "em",
                raw: S.slice(0, xe[0].length),
                text: S.slice(1, xe[0].length - 1)
              };
        }
      }, U.codespan = function(S) {
        var T = this.rules.inline.code.exec(S);
        if (T) {
          var I = T[2].replace(/\n/g, " "), L = /[^ ]/.test(I), j = /^ /.test(I) && / $/.test(I);
          return L && j && (I = I.substring(1, I.length - 1)), I = M(I, !0), {
            type: "codespan",
            raw: T[0],
            text: I
          };
        }
      }, U.br = function(S) {
        var T = this.rules.inline.br.exec(S);
        if (T)
          return {
            type: "br",
            raw: T[0]
          };
      }, U.del = function(S) {
        var T = this.rules.inline.del.exec(S);
        if (T)
          return {
            type: "del",
            raw: T[0],
            text: T[2]
          };
      }, U.autolink = function(S, T) {
        var I = this.rules.inline.autolink.exec(S);
        if (I) {
          var L, j;
          return I[2] === "@" ? (L = M(this.options.mangle ? T(I[1]) : I[1]), j = "mailto:" + L) : (L = M(I[1]), j = L), {
            type: "link",
            raw: I[0],
            text: L,
            href: j,
            tokens: [{
              type: "text",
              raw: L,
              text: L
            }]
          };
        }
      }, U.url = function(S, T) {
        var I;
        if (I = this.rules.inline.url.exec(S)) {
          var L, j;
          if (I[2] === "@")
            L = M(this.options.mangle ? T(I[0]) : I[0]), j = "mailto:" + L;
          else {
            var xe;
            do
              xe = I[0], I[0] = this.rules.inline._backpedal.exec(I[0])[0];
            while (xe !== I[0]);
            L = M(I[0]), I[1] === "www." ? j = "http://" + L : j = L;
          }
          return {
            type: "link",
            raw: I[0],
            text: L,
            href: j,
            tokens: [{
              type: "text",
              raw: L,
              text: L
            }]
          };
        }
      }, U.inlineText = function(S, T, I) {
        var L = this.rules.inline.text.exec(S);
        if (L) {
          var j;
          return T ? j = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(L[0]) : M(L[0]) : L[0] : j = M(this.options.smartypants ? I(L[0]) : L[0]), {
            type: "text",
            raw: L[0],
            text: j
          };
        }
      }, K;
    }(), Ie = Ee.noopTest, ve = Ee.edit, Ne = Ee.merge, fe = {
      newline: /^(?: *(?:\n|$))+/,
      code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
      fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
      hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
      heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
      blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
      list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?! {0,3}bull )\n*|\s*$)/,
      html: "^ {0,3}(?:<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$))",
      def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
      nptable: Ie,
      table: Ie,
      lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
      _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html| +\n)[^\n]+)*)/,
      text: /^[^\n]+/
    };
    fe._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/, fe._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/, fe.def = ve(fe.def).replace("label", fe._label).replace("title", fe._title).getRegex(), fe.bullet = /(?:[*+-]|\d{1,9}[.)])/, fe.item = /^( *)(bull) ?[^\n]*(?:\n(?! *bull ?)[^\n]*)*/, fe.item = ve(fe.item, "gm").replace(/bull/g, fe.bullet).getRegex(), fe.listItemStart = ve(/^( *)(bull)/).replace("bull", fe.bullet).getRegex(), fe.list = ve(fe.list).replace(/bull/g, fe.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + fe.def.source + ")").getRegex(), fe._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", fe._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, fe.html = ve(fe.html, "i").replace("comment", fe._comment).replace("tag", fe._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), fe.paragraph = ve(fe._paragraph).replace("hr", fe.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)").replace("tag", fe._tag).getRegex(), fe.blockquote = ve(fe.blockquote).replace("paragraph", fe.paragraph).getRegex(), fe.normal = Ne({}, fe), fe.gfm = Ne({}, fe.normal, {
      nptable: "^ *([^|\\n ].*\\|.*)\\n {0,3}([-:]+ *\\|[-| :]*)(?:\\n((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)",
      table: "^ *\\|(.+)\\n {0,3}\\|?( *[-:]+[-| :]*)(?:\\n *((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
    }), fe.gfm.nptable = ve(fe.gfm.nptable).replace("hr", fe.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)").replace("tag", fe._tag).getRegex(), fe.gfm.table = ve(fe.gfm.table).replace("hr", fe.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)").replace("tag", fe._tag).getRegex(), fe.pedantic = Ne({}, fe.normal, {
      html: ve(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", fe._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
      def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
      heading: /^(#{1,6})(.*)(?:\n+|$)/,
      fences: Ie,
      paragraph: ve(fe.normal._paragraph).replace("hr", fe.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", fe.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    var ae = {
      escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
      autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
      url: Ie,
      tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
      link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
      reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
      nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
      reflinkSearch: "reflink|nolink(?!\\()",
      strong: {
        start: /^(?:(\*\*(?=[*punctuation]))|\*\*)(?![\s])|__/,
        middle: /^\*\*(?:(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)|\*(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)*?\*)+?\*\*$|^__(?![\s])((?:(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)|_(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)*?_)+?)__$/,
        endAst: /[^punctuation\s]\*\*(?!\*)|[punctuation]\*\*(?!\*)(?:(?=[punctuation_\s]|$))/,
        endUnd: /[^\s]__(?!_)(?:(?=[punctuation*\s])|$)/
      },
      em: {
        start: /^(?:(\*(?=[punctuation]))|\*)(?![*\s])|_/,
        middle: /^\*(?:(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)|\*(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)*?\*)+?\*$|^_(?![_\s])(?:(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)|_(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)*?_)+?_$/,
        endAst: /[^punctuation\s]\*(?!\*)|[punctuation]\*(?!\*)(?:(?=[punctuation_\s]|$))/,
        endUnd: /[^\s]_(?!_)(?:(?=[punctuation*\s])|$)/
      },
      code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
      br: /^( {2,}|\\)\n(?!\s*$)/,
      del: Ie,
      text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*]|\b_|$)|[^ ](?= {2,}\n)))/,
      punctuation: /^([\s*punctuation])/
    };
    ae._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", ae.punctuation = ve(ae.punctuation).replace(/punctuation/g, ae._punctuation).getRegex(), ae._blockSkip = "\\[[^\\]]*?\\]\\([^\\)]*?\\)|`[^`]*?`|<[^>]*?>", ae._overlapSkip = "__[^_]*?__|\\*\\*\\[^\\*\\]*?\\*\\*", ae._comment = ve(fe._comment).replace("(?:-->|$)", "-->").getRegex(), ae.em.start = ve(ae.em.start).replace(/punctuation/g, ae._punctuation).getRegex(), ae.em.middle = ve(ae.em.middle).replace(/punctuation/g, ae._punctuation).replace(/overlapSkip/g, ae._overlapSkip).getRegex(), ae.em.endAst = ve(ae.em.endAst, "g").replace(/punctuation/g, ae._punctuation).getRegex(), ae.em.endUnd = ve(ae.em.endUnd, "g").replace(/punctuation/g, ae._punctuation).getRegex(), ae.strong.start = ve(ae.strong.start).replace(/punctuation/g, ae._punctuation).getRegex(), ae.strong.middle = ve(ae.strong.middle).replace(/punctuation/g, ae._punctuation).replace(/overlapSkip/g, ae._overlapSkip).getRegex(), ae.strong.endAst = ve(ae.strong.endAst, "g").replace(/punctuation/g, ae._punctuation).getRegex(), ae.strong.endUnd = ve(ae.strong.endUnd, "g").replace(/punctuation/g, ae._punctuation).getRegex(), ae.blockSkip = ve(ae._blockSkip, "g").getRegex(), ae.overlapSkip = ve(ae._overlapSkip, "g").getRegex(), ae._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, ae._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, ae._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, ae.autolink = ve(ae.autolink).replace("scheme", ae._scheme).replace("email", ae._email).getRegex(), ae._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, ae.tag = ve(ae.tag).replace("comment", ae._comment).replace("attribute", ae._attribute).getRegex(), ae._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, ae._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, ae._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, ae.link = ve(ae.link).replace("label", ae._label).replace("href", ae._href).replace("title", ae._title).getRegex(), ae.reflink = ve(ae.reflink).replace("label", ae._label).getRegex(), ae.reflinkSearch = ve(ae.reflinkSearch, "g").replace("reflink", ae.reflink).replace("nolink", ae.nolink).getRegex(), ae.normal = Ne({}, ae), ae.pedantic = Ne({}, ae.normal, {
      strong: {
        start: /^__|\*\*/,
        middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        endAst: /\*\*(?!\*)/g,
        endUnd: /__(?!_)/g
      },
      em: {
        start: /^_|\*/,
        middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
        endAst: /\*(?!\*)/g,
        endUnd: /_(?!_)/g
      },
      link: ve(/^!?\[(label)\]\((.*?)\)/).replace("label", ae._label).getRegex(),
      reflink: ve(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", ae._label).getRegex()
    }), ae.gfm = Ne({}, ae.normal, {
      escape: ve(ae.escape).replace("])", "~|])").getRegex(),
      _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
      url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
      _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
      del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
      text: /^([`~]+|[^`~])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*~]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))/
    }), ae.gfm.url = ve(ae.gfm.url, "i").replace("email", ae.gfm._extended_email).getRegex(), ae.breaks = Ne({}, ae.gfm, {
      br: ve(ae.br).replace("{2,}", "*").getRegex(),
      text: ve(ae.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    var ct = {
      block: fe,
      inline: ae
    }, Gt = x.defaults, Qe = ct.block, Ve = ct.inline, Zt = Ee.repeatString;
    function Tn(K) {
      return K.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026");
    }
    function $n(K) {
      var U = "", G, S, T = K.length;
      for (G = 0; G < T; G++)
        S = K.charCodeAt(G), Math.random() > 0.5 && (S = "x" + S.toString(16)), U += "&#" + S + ";";
      return U;
    }
    var Et = /* @__PURE__ */ function() {
      function K(G) {
        this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = G || Gt, this.options.tokenizer = this.options.tokenizer || new me(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options;
        var S = {
          block: Qe.normal,
          inline: Ve.normal
        };
        this.options.pedantic ? (S.block = Qe.pedantic, S.inline = Ve.pedantic) : this.options.gfm && (S.block = Qe.gfm, this.options.breaks ? S.inline = Ve.breaks : S.inline = Ve.gfm), this.tokenizer.rules = S;
      }
      K.lex = function(S, T) {
        var I = new K(T);
        return I.lex(S);
      }, K.lexInline = function(S, T) {
        var I = new K(T);
        return I.inlineTokens(S);
      };
      var U = K.prototype;
      return U.lex = function(S) {
        return S = S.replace(/\r\n|\r/g, `
`).replace(/\t/g, "    "), this.blockTokens(S, this.tokens, !0), this.inline(this.tokens), this.tokens;
      }, U.blockTokens = function(S, T, I) {
        T === void 0 && (T = []), I === void 0 && (I = !0), this.options.pedantic && (S = S.replace(/^ +$/gm, ""));
        for (var L, j, xe, Se; S; ) {
          if (L = this.tokenizer.space(S)) {
            S = S.substring(L.raw.length), L.type && T.push(L);
            continue;
          }
          if (L = this.tokenizer.code(S, T)) {
            S = S.substring(L.raw.length), L.type ? T.push(L) : (Se = T[T.length - 1], Se.raw += `
` + L.raw, Se.text += `
` + L.text);
            continue;
          }
          if (L = this.tokenizer.fences(S)) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (L = this.tokenizer.heading(S)) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (L = this.tokenizer.nptable(S)) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (L = this.tokenizer.hr(S)) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (L = this.tokenizer.blockquote(S)) {
            S = S.substring(L.raw.length), L.tokens = this.blockTokens(L.text, [], I), T.push(L);
            continue;
          }
          if (L = this.tokenizer.list(S)) {
            for (S = S.substring(L.raw.length), xe = L.items.length, j = 0; j < xe; j++)
              L.items[j].tokens = this.blockTokens(L.items[j].text, [], !1);
            T.push(L);
            continue;
          }
          if (L = this.tokenizer.html(S)) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (I && (L = this.tokenizer.def(S))) {
            S = S.substring(L.raw.length), this.tokens.links[L.tag] || (this.tokens.links[L.tag] = {
              href: L.href,
              title: L.title
            });
            continue;
          }
          if (L = this.tokenizer.table(S)) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (L = this.tokenizer.lheading(S)) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (I && (L = this.tokenizer.paragraph(S))) {
            S = S.substring(L.raw.length), T.push(L);
            continue;
          }
          if (L = this.tokenizer.text(S, T)) {
            S = S.substring(L.raw.length), L.type ? T.push(L) : (Se = T[T.length - 1], Se.raw += `
` + L.raw, Se.text += `
` + L.text);
            continue;
          }
          if (S) {
            var Fe = "Infinite loop on byte: " + S.charCodeAt(0);
            if (this.options.silent) {
              console.error(Fe);
              break;
            } else
              throw new Error(Fe);
          }
        }
        return T;
      }, U.inline = function(S) {
        var T, I, L, j, xe, Se, Fe = S.length;
        for (T = 0; T < Fe; T++)
          switch (Se = S[T], Se.type) {
            case "paragraph":
            case "text":
            case "heading": {
              Se.tokens = [], this.inlineTokens(Se.text, Se.tokens);
              break;
            }
            case "table": {
              for (Se.tokens = {
                header: [],
                cells: []
              }, j = Se.header.length, I = 0; I < j; I++)
                Se.tokens.header[I] = [], this.inlineTokens(Se.header[I], Se.tokens.header[I]);
              for (j = Se.cells.length, I = 0; I < j; I++)
                for (xe = Se.cells[I], Se.tokens.cells[I] = [], L = 0; L < xe.length; L++)
                  Se.tokens.cells[I][L] = [], this.inlineTokens(xe[L], Se.tokens.cells[I][L]);
              break;
            }
            case "blockquote": {
              this.inline(Se.tokens);
              break;
            }
            case "list": {
              for (j = Se.items.length, I = 0; I < j; I++)
                this.inline(Se.items[I].tokens);
              break;
            }
          }
        return S;
      }, U.inlineTokens = function(S, T, I, L) {
        T === void 0 && (T = []), I === void 0 && (I = !1), L === void 0 && (L = !1);
        var j, xe = S, Se, Fe, Re;
        if (this.tokens.links) {
          var qe = Object.keys(this.tokens.links);
          if (qe.length > 0)
            for (; (Se = this.tokenizer.rules.inline.reflinkSearch.exec(xe)) != null; )
              qe.includes(Se[0].slice(Se[0].lastIndexOf("[") + 1, -1)) && (xe = xe.slice(0, Se.index) + "[" + Zt("a", Se[0].length - 2) + "]" + xe.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
        }
        for (; (Se = this.tokenizer.rules.inline.blockSkip.exec(xe)) != null; )
          xe = xe.slice(0, Se.index) + "[" + Zt("a", Se[0].length - 2) + "]" + xe.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        for (; S; ) {
          if (Fe || (Re = ""), Fe = !1, j = this.tokenizer.escape(S)) {
            S = S.substring(j.raw.length), T.push(j);
            continue;
          }
          if (j = this.tokenizer.tag(S, I, L)) {
            S = S.substring(j.raw.length), I = j.inLink, L = j.inRawBlock, T.push(j);
            continue;
          }
          if (j = this.tokenizer.link(S)) {
            S = S.substring(j.raw.length), j.type === "link" && (j.tokens = this.inlineTokens(j.text, [], !0, L)), T.push(j);
            continue;
          }
          if (j = this.tokenizer.reflink(S, this.tokens.links)) {
            S = S.substring(j.raw.length), j.type === "link" && (j.tokens = this.inlineTokens(j.text, [], !0, L)), T.push(j);
            continue;
          }
          if (j = this.tokenizer.strong(S, xe, Re)) {
            S = S.substring(j.raw.length), j.tokens = this.inlineTokens(j.text, [], I, L), T.push(j);
            continue;
          }
          if (j = this.tokenizer.em(S, xe, Re)) {
            S = S.substring(j.raw.length), j.tokens = this.inlineTokens(j.text, [], I, L), T.push(j);
            continue;
          }
          if (j = this.tokenizer.codespan(S)) {
            S = S.substring(j.raw.length), T.push(j);
            continue;
          }
          if (j = this.tokenizer.br(S)) {
            S = S.substring(j.raw.length), T.push(j);
            continue;
          }
          if (j = this.tokenizer.del(S)) {
            S = S.substring(j.raw.length), j.tokens = this.inlineTokens(j.text, [], I, L), T.push(j);
            continue;
          }
          if (j = this.tokenizer.autolink(S, $n)) {
            S = S.substring(j.raw.length), T.push(j);
            continue;
          }
          if (!I && (j = this.tokenizer.url(S, $n))) {
            S = S.substring(j.raw.length), T.push(j);
            continue;
          }
          if (j = this.tokenizer.inlineText(S, L, Tn)) {
            S = S.substring(j.raw.length), Re = j.raw.slice(-1), Fe = !0, T.push(j);
            continue;
          }
          if (S) {
            var Ot = "Infinite loop on byte: " + S.charCodeAt(0);
            if (this.options.silent) {
              console.error(Ot);
              break;
            } else
              throw new Error(Ot);
          }
        }
        return T;
      }, u(K, null, [{
        key: "rules",
        get: function() {
          return {
            block: Qe,
            inline: Ve
          };
        }
      }]), K;
    }(), Ft = x.defaults, Mt = Ee.cleanUrl, Jt = Ee.escape, Je = /* @__PURE__ */ function() {
      function K(G) {
        this.options = G || Ft;
      }
      var U = K.prototype;
      return U.code = function(S, T, I) {
        var L = (T || "").match(/\S*/)[0];
        if (this.options.highlight) {
          var j = this.options.highlight(S, L);
          j != null && j !== S && (I = !0, S = j);
        }
        return S = S.replace(/\n$/, "") + `
`, L ? '<pre><code class="' + this.options.langPrefix + Jt(L, !0) + '">' + (I ? S : Jt(S, !0)) + `</code></pre>
` : "<pre><code>" + (I ? S : Jt(S, !0)) + `</code></pre>
`;
      }, U.blockquote = function(S) {
        return `<blockquote>
` + S + `</blockquote>
`;
      }, U.html = function(S) {
        return S;
      }, U.heading = function(S, T, I, L) {
        return this.options.headerIds ? "<h" + T + ' id="' + this.options.headerPrefix + L.slug(I) + '">' + S + "</h" + T + `>
` : "<h" + T + ">" + S + "</h" + T + `>
`;
      }, U.hr = function() {
        return this.options.xhtml ? `<hr/>
` : `<hr>
`;
      }, U.list = function(S, T, I) {
        var L = T ? "ol" : "ul", j = T && I !== 1 ? ' start="' + I + '"' : "";
        return "<" + L + j + `>
` + S + "</" + L + `>
`;
      }, U.listitem = function(S) {
        return "<li>" + S + `</li>
`;
      }, U.checkbox = function(S) {
        return "<input " + (S ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
      }, U.paragraph = function(S) {
        return "<p>" + S + `</p>
`;
      }, U.table = function(S, T) {
        return T && (T = "<tbody>" + T + "</tbody>"), `<table>
<thead>
` + S + `</thead>
` + T + `</table>
`;
      }, U.tablerow = function(S) {
        return `<tr>
` + S + `</tr>
`;
      }, U.tablecell = function(S, T) {
        var I = T.header ? "th" : "td", L = T.align ? "<" + I + ' align="' + T.align + '">' : "<" + I + ">";
        return L + S + "</" + I + `>
`;
      }, U.strong = function(S) {
        return "<strong>" + S + "</strong>";
      }, U.em = function(S) {
        return "<em>" + S + "</em>";
      }, U.codespan = function(S) {
        return "<code>" + S + "</code>";
      }, U.br = function() {
        return this.options.xhtml ? "<br/>" : "<br>";
      }, U.del = function(S) {
        return "<del>" + S + "</del>";
      }, U.link = function(S, T, I) {
        if (S = Mt(this.options.sanitize, this.options.baseUrl, S), S === null)
          return I;
        var L = '<a href="' + Jt(S) + '"';
        return T && (L += ' title="' + T + '"'), L += ">" + I + "</a>", L;
      }, U.image = function(S, T, I) {
        if (S = Mt(this.options.sanitize, this.options.baseUrl, S), S === null)
          return I;
        var L = '<img src="' + S + '" alt="' + I + '"';
        return T && (L += ' title="' + T + '"'), L += this.options.xhtml ? "/>" : ">", L;
      }, U.text = function(S) {
        return S;
      }, K;
    }(), et = /* @__PURE__ */ function() {
      function K() {
      }
      var U = K.prototype;
      return U.strong = function(S) {
        return S;
      }, U.em = function(S) {
        return S;
      }, U.codespan = function(S) {
        return S;
      }, U.del = function(S) {
        return S;
      }, U.html = function(S) {
        return S;
      }, U.text = function(S) {
        return S;
      }, U.link = function(S, T, I) {
        return "" + I;
      }, U.image = function(S, T, I) {
        return "" + I;
      }, U.br = function() {
        return "";
      }, K;
    }(), bt = /* @__PURE__ */ function() {
      function K() {
        this.seen = {};
      }
      var U = K.prototype;
      return U.serialize = function(S) {
        return S.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
      }, U.getNextSafeSlug = function(S, T) {
        var I = S, L = 0;
        if (this.seen.hasOwnProperty(I)) {
          L = this.seen[S];
          do
            L++, I = S + "-" + L;
          while (this.seen.hasOwnProperty(I));
        }
        return T || (this.seen[S] = L, this.seen[I] = 0), I;
      }, U.slug = function(S, T) {
        T === void 0 && (T = {});
        var I = this.serialize(S);
        return this.getNextSafeSlug(I, T.dryrun);
      }, K;
    }(), en = x.defaults, ir = Ee.unescape, jn = /* @__PURE__ */ function() {
      function K(G) {
        this.options = G || en, this.options.renderer = this.options.renderer || new Je(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new et(), this.slugger = new bt();
      }
      K.parse = function(S, T) {
        var I = new K(T);
        return I.parse(S);
      }, K.parseInline = function(S, T) {
        var I = new K(T);
        return I.parseInline(S);
      };
      var U = K.prototype;
      return U.parse = function(S, T) {
        T === void 0 && (T = !0);
        var I = "", L, j, xe, Se, Fe, Re, qe, Ot, pt, Ue, vn, ti, In, zt, Ke, rr, or, ni, Ur = S.length;
        for (L = 0; L < Ur; L++)
          switch (Ue = S[L], Ue.type) {
            case "space":
              continue;
            case "hr": {
              I += this.renderer.hr();
              continue;
            }
            case "heading": {
              I += this.renderer.heading(this.parseInline(Ue.tokens), Ue.depth, ir(this.parseInline(Ue.tokens, this.textRenderer)), this.slugger);
              continue;
            }
            case "code": {
              I += this.renderer.code(Ue.text, Ue.lang, Ue.escaped);
              continue;
            }
            case "table": {
              for (Ot = "", qe = "", Se = Ue.header.length, j = 0; j < Se; j++)
                qe += this.renderer.tablecell(this.parseInline(Ue.tokens.header[j]), {
                  header: !0,
                  align: Ue.align[j]
                });
              for (Ot += this.renderer.tablerow(qe), pt = "", Se = Ue.cells.length, j = 0; j < Se; j++) {
                for (Re = Ue.tokens.cells[j], qe = "", Fe = Re.length, xe = 0; xe < Fe; xe++)
                  qe += this.renderer.tablecell(this.parseInline(Re[xe]), {
                    header: !1,
                    align: Ue.align[xe]
                  });
                pt += this.renderer.tablerow(qe);
              }
              I += this.renderer.table(Ot, pt);
              continue;
            }
            case "blockquote": {
              pt = this.parse(Ue.tokens), I += this.renderer.blockquote(pt);
              continue;
            }
            case "list": {
              for (vn = Ue.ordered, ti = Ue.start, In = Ue.loose, Se = Ue.items.length, pt = "", j = 0; j < Se; j++)
                Ke = Ue.items[j], rr = Ke.checked, or = Ke.task, zt = "", Ke.task && (ni = this.renderer.checkbox(rr), In ? Ke.tokens.length > 0 && Ke.tokens[0].type === "text" ? (Ke.tokens[0].text = ni + " " + Ke.tokens[0].text, Ke.tokens[0].tokens && Ke.tokens[0].tokens.length > 0 && Ke.tokens[0].tokens[0].type === "text" && (Ke.tokens[0].tokens[0].text = ni + " " + Ke.tokens[0].tokens[0].text)) : Ke.tokens.unshift({
                  type: "text",
                  text: ni
                }) : zt += ni), zt += this.parse(Ke.tokens, In), pt += this.renderer.listitem(zt, or, rr);
              I += this.renderer.list(pt, vn, ti);
              continue;
            }
            case "html": {
              I += this.renderer.html(Ue.text);
              continue;
            }
            case "paragraph": {
              I += this.renderer.paragraph(this.parseInline(Ue.tokens));
              continue;
            }
            case "text": {
              for (pt = Ue.tokens ? this.parseInline(Ue.tokens) : Ue.text; L + 1 < Ur && S[L + 1].type === "text"; )
                Ue = S[++L], pt += `
` + (Ue.tokens ? this.parseInline(Ue.tokens) : Ue.text);
              I += T ? this.renderer.paragraph(pt) : pt;
              continue;
            }
            default: {
              var Hr = 'Token with "' + Ue.type + '" type was not found.';
              if (this.options.silent) {
                console.error(Hr);
                return;
              } else
                throw new Error(Hr);
            }
          }
        return I;
      }, U.parseInline = function(S, T) {
        T = T || this.renderer;
        var I = "", L, j, xe = S.length;
        for (L = 0; L < xe; L++)
          switch (j = S[L], j.type) {
            case "escape": {
              I += T.text(j.text);
              break;
            }
            case "html": {
              I += T.html(j.text);
              break;
            }
            case "link": {
              I += T.link(j.href, j.title, this.parseInline(j.tokens, T));
              break;
            }
            case "image": {
              I += T.image(j.href, j.title, j.text);
              break;
            }
            case "strong": {
              I += T.strong(this.parseInline(j.tokens, T));
              break;
            }
            case "em": {
              I += T.em(this.parseInline(j.tokens, T));
              break;
            }
            case "codespan": {
              I += T.codespan(j.text);
              break;
            }
            case "br": {
              I += T.br();
              break;
            }
            case "del": {
              I += T.del(this.parseInline(j.tokens, T));
              break;
            }
            case "text": {
              I += T.text(j.text);
              break;
            }
            default: {
              var Se = 'Token with "' + j.type + '" type was not found.';
              if (this.options.silent) {
                console.error(Se);
                return;
              } else
                throw new Error(Se);
            }
          }
        return I;
      }, K;
    }(), Jn = Ee.merge, Br = Ee.checkSanitizeDeprecation, Vr = Ee.escape, as = x.getDefaults, ls = x.changeDefaults, cs = x.defaults;
    function We(K, U, G) {
      if (typeof K > "u" || K === null)
        throw new Error("marked(): input parameter is undefined or null");
      if (typeof K != "string")
        throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(K) + ", string expected");
      if (typeof U == "function" && (G = U, U = null), U = Jn({}, We.defaults, U || {}), Br(U), G) {
        var S = U.highlight, T;
        try {
          T = Et.lex(K, U);
        } catch (xe) {
          return G(xe);
        }
        var I = function(Se) {
          var Fe;
          if (!Se)
            try {
              Fe = jn.parse(T, U);
            } catch (Re) {
              Se = Re;
            }
          return U.highlight = S, Se ? G(Se) : G(null, Fe);
        };
        if (!S || S.length < 3 || (delete U.highlight, !T.length))
          return I();
        var L = 0;
        We.walkTokens(T, function(xe) {
          xe.type === "code" && (L++, setTimeout(function() {
            S(xe.text, xe.lang, function(Se, Fe) {
              if (Se)
                return I(Se);
              Fe != null && Fe !== xe.text && (xe.text = Fe, xe.escaped = !0), L--, L === 0 && I();
            });
          }, 0));
        }), L === 0 && I();
        return;
      }
      try {
        var j = Et.lex(K, U);
        return U.walkTokens && We.walkTokens(j, U.walkTokens), jn.parse(j, U);
      } catch (xe) {
        if (xe.message += `
Please report this to https://github.com/markedjs/marked.`, U.silent)
          return "<p>An error occurred:</p><pre>" + Vr(xe.message + "", !0) + "</pre>";
        throw xe;
      }
    }
    We.options = We.setOptions = function(K) {
      return Jn(We.defaults, K), ls(We.defaults), We;
    }, We.getDefaults = as, We.defaults = cs, We.use = function(K) {
      var U = Jn({}, K);
      if (K.renderer && function() {
        var S = We.defaults.renderer || new Je(), T = function(j) {
          var xe = S[j];
          S[j] = function() {
            for (var Se = arguments.length, Fe = new Array(Se), Re = 0; Re < Se; Re++)
              Fe[Re] = arguments[Re];
            var qe = K.renderer[j].apply(S, Fe);
            return qe === !1 && (qe = xe.apply(S, Fe)), qe;
          };
        };
        for (var I in K.renderer)
          T(I);
        U.renderer = S;
      }(), K.tokenizer && function() {
        var S = We.defaults.tokenizer || new me(), T = function(j) {
          var xe = S[j];
          S[j] = function() {
            for (var Se = arguments.length, Fe = new Array(Se), Re = 0; Re < Se; Re++)
              Fe[Re] = arguments[Re];
            var qe = K.tokenizer[j].apply(S, Fe);
            return qe === !1 && (qe = xe.apply(S, Fe)), qe;
          };
        };
        for (var I in K.tokenizer)
          T(I);
        U.tokenizer = S;
      }(), K.walkTokens) {
        var G = We.defaults.walkTokens;
        U.walkTokens = function(S) {
          K.walkTokens(S), G && G(S);
        };
      }
      We.setOptions(U);
    }, We.walkTokens = function(K, U) {
      for (var G = v(K), S; !(S = G()).done; ) {
        var T = S.value;
        switch (U(T), T.type) {
          case "table": {
            for (var I = v(T.tokens.header), L; !(L = I()).done; ) {
              var j = L.value;
              We.walkTokens(j, U);
            }
            for (var xe = v(T.tokens.cells), Se; !(Se = xe()).done; )
              for (var Fe = Se.value, Re = v(Fe), qe; !(qe = Re()).done; ) {
                var Ot = qe.value;
                We.walkTokens(Ot, U);
              }
            break;
          }
          case "list": {
            We.walkTokens(T.items, U);
            break;
          }
          default:
            T.tokens && We.walkTokens(T.tokens, U);
        }
      }
    }, We.parseInline = function(K, U) {
      if (typeof K > "u" || K === null)
        throw new Error("marked.parseInline(): input parameter is undefined or null");
      if (typeof K != "string")
        throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(K) + ", string expected");
      U = Jn({}, We.defaults, U || {}), Br(U);
      try {
        var G = Et.lexInline(K, U);
        return U.walkTokens && We.walkTokens(G, U.walkTokens), jn.parseInline(G, U);
      } catch (S) {
        if (S.message += `
Please report this to https://github.com/markedjs/marked.`, U.silent)
          return "<p>An error occurred:</p><pre>" + Vr(S.message + "", !0) + "</pre>";
        throw S;
      }
    }, We.Parser = jn, We.parser = jn.parse, We.Renderer = Je, We.TextRenderer = et, We.Lexer = Et, We.lexer = Et.lex, We.Tokenizer = me, We.Slugger = bt, We.parse = We;
    var ei = We;
    return ei;
  });
})(Xp);
const ip = Xp.exports;
var _l = { exports: {} };
/*!
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function(a, r) {
  (function(c) {
    c.en = Object.assign(c.en || {}, { a: "Cannot upload file:", b: "Image toolbar", c: "Table toolbar", d: "Align left", e: "Align right", f: "Align center", g: "Justify", h: "Text alignment", i: "Text alignment toolbar", j: "Italic", k: "Bold", l: "Block quote", m: "Insert image or file", n: "Choose heading", o: "Heading", p: "image widget", q: "Full size image", r: "Side image", s: "Left aligned image", t: "Centered image", u: "Right aligned image", v: "Insert image", w: "Numbered List", x: "Bulleted List", y: "Insert table", z: "Header column", aa: "Insert column left", ab: "Insert column right", ac: "Delete column", ad: "Column", ae: "Header row", af: "Insert row below", ag: "Insert row above", ah: "Delete row", ai: "Row", aj: "Merge cell up", ak: "Merge cell right", al: "Merge cell down", am: "Merge cell left", an: "Split cell vertically", ao: "Split cell horizontally", ap: "Merge cells", aq: "Enter image caption", ar: "Upload failed", as: "media widget", at: "Insert media", au: "The URL must not be empty.", av: "This media URL is not supported.", aw: "Link", ax: "Widget toolbar", ay: "Upload in progress", az: "Could not obtain resized image URL.", ba: "Selecting resized image failed", bb: "Could not insert image at the current position.", bc: "Inserting image failed", bd: "Paragraph", be: "Heading 1", bf: "Heading 2", bg: "Heading 3", bh: "Heading 4", bi: "Heading 5", bj: "Heading 6", bk: "Change image text alternative", bl: "Editor toolbar", bm: "Rich Text Editor", bn: "Rich Text Editor, %0", bo: "Dropdown toolbar", bp: "Unlink", bq: "Edit link", br: "Open link in new tab", bs: "This link has no URL", bt: "Undo", bu: "Redo", bv: "%0 of %1", bw: "Previous", bx: "Next", by: "Open in a new tab", bz: "Downloadable", ca: "Save", cb: "Cancel", cc: "Text alternative", cd: "Link URL", ce: "Paste the media URL in the input.", cf: "Tip: Paste the URL into the content to embed faster.", cg: "Media URL" });
  })(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function(c, u) {
    a.exports = u();
  }(window, function() {
    return function(c) {
      var u = {};
      function p(h) {
        if (u[h])
          return u[h].exports;
        var v = u[h] = { i: h, l: !1, exports: {} };
        return c[h].call(v.exports, v, v.exports, p), v.l = !0, v.exports;
      }
      return p.m = c, p.c = u, p.d = function(h, v, w) {
        p.o(h, v) || Object.defineProperty(h, v, { enumerable: !0, get: w });
      }, p.r = function(h) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(h, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(h, "__esModule", { value: !0 });
      }, p.t = function(h, v) {
        if (1 & v && (h = p(h)), 8 & v || 4 & v && typeof h == "object" && h && h.__esModule)
          return h;
        var w = /* @__PURE__ */ Object.create(null);
        if (p.r(w), Object.defineProperty(w, "default", { enumerable: !0, value: h }), 2 & v && typeof h != "string")
          for (var x in h)
            p.d(w, x, function(k) {
              return h[k];
            }.bind(null, x));
        return w;
      }, p.n = function(h) {
        var v = h && h.__esModule ? function() {
          return h.default;
        } : function() {
          return h;
        };
        return p.d(v, "a", v), v;
      }, p.o = function(h, v) {
        return Object.prototype.hasOwnProperty.call(h, v);
      }, p.p = "", p(p.s = 91);
    }([function(c, u, p) {
      p.d(u, "b", function() {
        return v;
      }), p.d(u, "a", function() {
        return w;
      });
      const h = "https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html";
      class v extends Error {
        constructor(k, P, R) {
          k = w(k), R && (k += " " + JSON.stringify(R)), super(k), this.name = "CKEditorError", this.context = P, this.data = R;
        }
        is(k) {
          return k === "CKEditorError";
        }
      }
      function w(x) {
        const k = x.match(/^([^:]+):/);
        return k ? x + ` Read more: ${h}#error-${k[1]}
` : x;
      }
    }, function(c, u, p) {
      var h = {}, v = function() {
        var W;
        return function() {
          return W === void 0 && (W = Boolean(window && document && document.all && !window.atob)), W;
        };
      }(), w = function() {
        var W = {};
        return function(Z) {
          if (W[Z] === void 0) {
            var ee = document.querySelector(Z);
            if (window.HTMLIFrameElement && ee instanceof window.HTMLIFrameElement)
              try {
                ee = ee.contentDocument.head;
              } catch {
                ee = null;
              }
            W[Z] = ee;
          }
          return W[Z];
        };
      }();
      function x(W, Z) {
        for (var ee = [], ne = {}, se = 0; se < W.length; se++) {
          var pe = W[se], ge = Z.base ? pe[0] + Z.base : pe[0], Oe = { css: pe[1], media: pe[2], sourceMap: pe[3] };
          ne[ge] ? ne[ge].parts.push(Oe) : ee.push(ne[ge] = { id: ge, parts: [Oe] });
        }
        return ee;
      }
      function k(W, Z) {
        for (var ee = 0; ee < W.length; ee++) {
          var ne = W[ee], se = h[ne.id], pe = 0;
          if (se) {
            for (se.refs++; pe < se.parts.length; pe++)
              se.parts[pe](ne.parts[pe]);
            for (; pe < ne.parts.length; pe++)
              se.parts.push(H(ne.parts[pe], Z));
          } else {
            for (var ge = []; pe < ne.parts.length; pe++)
              ge.push(H(ne.parts[pe], Z));
            h[ne.id] = { id: ne.id, refs: 1, parts: ge };
          }
        }
      }
      function P(W) {
        var Z = document.createElement("style");
        if (W.attributes.nonce === void 0) {
          var ee = p.nc;
          ee && (W.attributes.nonce = ee);
        }
        if (Object.keys(W.attributes).forEach(function(se) {
          Z.setAttribute(se, W.attributes[se]);
        }), typeof W.insert == "function")
          W.insert(Z);
        else {
          var ne = w(W.insert || "head");
          if (!ne)
            throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          ne.appendChild(Z);
        }
        return Z;
      }
      var R = function() {
        var W = [];
        return function(Z, ee) {
          return W[Z] = ee, W.filter(Boolean).join(`
`);
        };
      }();
      function $(W, Z, ee, ne) {
        var se = ee ? "" : ne.css;
        if (W.styleSheet)
          W.styleSheet.cssText = R(Z, se);
        else {
          var pe = document.createTextNode(se), ge = W.childNodes;
          ge[Z] && W.removeChild(ge[Z]), ge.length ? W.insertBefore(pe, ge[Z]) : W.appendChild(pe);
        }
      }
      var J = null, X = 0;
      function H(W, Z) {
        var ee, ne, se;
        if (Z.singleton) {
          var pe = X++;
          ee = J || (J = P(Z)), ne = $.bind(null, ee, pe, !1), se = $.bind(null, ee, pe, !0);
        } else
          ee = P(Z), ne = function(ge, Oe, ke) {
            var we = ke.css, F = ke.media, _ = ke.sourceMap;
            if (F && ge.setAttribute("media", F), _ && btoa && (we += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(_)))), " */")), ge.styleSheet)
              ge.styleSheet.cssText = we;
            else {
              for (; ge.firstChild; )
                ge.removeChild(ge.firstChild);
              ge.appendChild(document.createTextNode(we));
            }
          }.bind(null, ee, Z), se = function() {
            (function(ge) {
              if (ge.parentNode === null)
                return !1;
              ge.parentNode.removeChild(ge);
            })(ee);
          };
        return ne(W), function(ge) {
          if (ge) {
            if (ge.css === W.css && ge.media === W.media && ge.sourceMap === W.sourceMap)
              return;
            ne(W = ge);
          } else
            se();
        };
      }
      c.exports = function(W, Z) {
        (Z = Z || {}).attributes = typeof Z.attributes == "object" ? Z.attributes : {}, Z.singleton || typeof Z.singleton == "boolean" || (Z.singleton = v());
        var ee = x(W, Z);
        return k(ee, Z), function(ne) {
          for (var se = [], pe = 0; pe < ee.length; pe++) {
            var ge = ee[pe], Oe = h[ge.id];
            Oe && (Oe.refs--, se.push(Oe));
          }
          ne && k(x(ne, Z), Z);
          for (var ke = 0; ke < se.length; ke++) {
            var we = se[ke];
            if (we.refs === 0) {
              for (var F = 0; F < we.parts.length; F++)
                we.parts[F]();
              delete h[we.id];
            }
          }
        };
      };
    }, , function(c, u, p) {
      var h = p(7), v = typeof self == "object" && self && self.Object === Object && self, w = h.a || v || Function("return this")();
      u.a = w;
    }, function(c, u, p) {
      (function(h) {
        var v = p(7), w = r && !r.nodeType && r, x = w && typeof h == "object" && h && !h.nodeType && h, k = x && x.exports === w && v.a.process, P = function() {
          try {
            var R = x && x.require && x.require("util").types;
            return R || k && k.binding && k.binding("util");
          } catch {
          }
        }();
        u.a = P;
      }).call(this, p(8)(c));
    }, function(c, u, p) {
      (function(h) {
        var v = p(3), w = p(11), x = r && !r.nodeType && r, k = x && typeof h == "object" && h && !h.nodeType && h, P = k && k.exports === x ? v.a.Buffer : void 0, R = (P ? P.isBuffer : void 0) || w.a;
        u.a = R;
      }).call(this, p(8)(c));
    }, function(c, u, p) {
      (function(h) {
        var v = p(13), w = p(0);
        const x = typeof window == "object" ? window : h;
        if (x.CKEDITOR_VERSION)
          throw new w.b("ckeditor-duplicated-modules: Some CKEditor 5 modules are duplicated.", null);
        x.CKEDITOR_VERSION = v.a;
      }).call(this, p(9));
    }, function(c, u, p) {
      (function(h) {
        var v = typeof h == "object" && h && h.Object === Object && h;
        u.a = v;
      }).call(this, p(9));
    }, function(c, u) {
      c.exports = function(p) {
        if (!p.webpackPolyfill) {
          var h = Object.create(p);
          h.children || (h.children = []), Object.defineProperty(h, "loaded", { enumerable: !0, get: function() {
            return h.l;
          } }), Object.defineProperty(h, "id", { enumerable: !0, get: function() {
            return h.i;
          } }), Object.defineProperty(h, "exports", { enumerable: !0 }), h.webpackPolyfill = 1;
        }
        return h;
      };
    }, function(c, u) {
      var p;
      p = function() {
        return this;
      }();
      try {
        p = p || new Function("return this")();
      } catch {
        typeof window == "object" && (p = window);
      }
      c.exports = p;
    }, function(c, u, p) {
      var h = p(68);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u, p) {
      u.a = function() {
        return !1;
      };
    }, function(c, u, p) {
      (function(h) {
        var v = p(3), w = r && !r.nodeType && r, x = w && typeof h == "object" && h && !h.nodeType && h, k = x && x.exports === w ? v.a.Buffer : void 0, P = k ? k.allocUnsafe : void 0;
        u.a = function(R, $) {
          if ($)
            return R.slice();
          var J = R.length, X = P ? P(J) : new R.constructor(J);
          return R.copy(X), X;
        };
      }).call(this, p(8)(c));
    }, function(c) {
      c.exports = JSON.parse('{"a":"12.4.0"}');
    }, function(c, u, p) {
      var h = p(15);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none;cursor:text;color:var(--ck-color-engine-placeholder-text)}";
    }, function(c, u, p) {
      var h = p(17);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999);--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border:#47a4f5;--ck-color-focus-shadow:rgba(119,186,248,0.5);--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#5c5c5c;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}";
    }, function(c, u, p) {
      var h = p(19);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}";
    }, function(c, u, p) {
      var h = p(21);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}";
    }, function(c, u, p) {
      var h = p(23);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}";
    }, function(c, u, p) {
      var h = p(25);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row wrap;align-items:center}.ck.ck-toolbar.ck-toolbar_vertical{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating{flex-wrap:nowrap}.ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar__newline{display:block;width:100%}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar>*{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-toolbar>*{margin-left:var(--ck-spacing-small);margin-right:0}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck{width:100%;margin:0;border-radius:0;border:0}[dir=ltr] .ck.ck-toolbar>:last-child{margin-right:0}[dir=rtl] .ck.ck-toolbar>:last-child{margin-left:0}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar__separator{align-self:stretch;width:1px;margin-top:0;margin-bottom:0;background:var(--ck-color-toolbar-border)}.ck.ck-toolbar__newline{margin:0}";
    }, function(c, u, p) {
      var h = p(27);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}";
    }, function(c, u, p) {
      var h = p(29);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}";
    }, function(c, u, p) {
      var h = p(31);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck-tooltip .ck-tooltip__text{display:inline-block}.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0}.ck.ck-tooltip.ck-tooltip_s{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_n{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{border-style:solid;left:50%}.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s}';
    }, function(c, u, p) {
      var h = p(33);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button .ck-button__label,.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button .ck-button__label,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;border-color:transparent}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(-1*var(--ck-spacing-small));margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(-1*var(--ck-spacing-small));margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}";
    }, function(c, u, p) {
      var h = p(35);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block;will-change:transform}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{transform:translate3d(0,100%,0)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}:root{--ck-dropdown-arrow-size:calc(0.5*var(--ck-icon-size))}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}";
    }, function(c, u, p) {
      var h = p(37);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;border:0;padding:calc(0.2*var(--ck-line-height-base)*var(--ck-font-size-base)) calc(0.4*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(1.2*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:hover:not(ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}";
    }, function(c, u, p) {
      var h = p(39);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:1.3846153847em}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(2*var(--ck-spacing-large))}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(2*var(--ck-spacing-large))}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(0.5*var(--ck-border-radius))}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(-1*var(--ck-switch-button-translation)))}";
    }, function(c, u, p) {
      var h = p(41);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-toolbar-dropdown .ck-toolbar{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}";
    }, function(c, u, p) {
      var h = p(43);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}";
    }, function(c, u, p) {
      var h = p(45);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}";
    }, function(c, u, p) {
      var h = p(47);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-resizer-size:10px;--ck-resizer-border-width:1px;--ck-resizer-border-radius:2px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-tooltip-offset:10px;--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2}.ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0;outline:1px solid var(--ck-color-resizer)}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all;width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nesw-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nesw-resize}.ck .ck-widget.ck-widget_with-selection-handler{position:relative}.ck .ck-widget.ck-widget_with-selection-handler:hover .ck-widget__selection-handler{visibility:visible}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{position:absolute}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck-editor__editable>.ck-widget.ck-widget_with-selection-handler:first-child,.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handler:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler,.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected:hover .ck-widget__selection-handler{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected:hover .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handler:hover .ck-widget__selection-handler{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected .ck-widget__selection-handler,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected .ck-widget__selection-handler:hover,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover .ck-widget__selection-handler,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover .ck-widget__selection-handler:hover{background:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-read-only .ck-widget{--ck-widget-outline-thickness:0}";
    }, function(c, u, p) {
      var h = p(49);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-labeled-input .ck-labeled-input__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-input .ck-labeled-input__status_error{color:var(--ck-color-base-error)}";
    }, function(c, u, p) {
      var h = p(51);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{box-shadow:var(--ck-inner-shadow),0 0;background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition-property:box-shadow,border;transition:.2s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),var(--ck-inner-shadow)}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}";
    }, function(c, u, p) {
      var h = p(53);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-input{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-input{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}.ck.ck-text-alternative-form{padding:var(--ck-spacing-standard)}.ck.ck-text-alternative-form:focus{outline:none}[dir=ltr] .ck.ck-text-alternative-form>:not(:first-child),[dir=rtl] .ck.ck-text-alternative-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-text-alternative-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-text-alternative-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-text-alternative-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-text-alternative-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-text-alternative-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-text-alternative-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
    }, function(c, u, p) {
      var h = p(55);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}';
    }, function(c, u, p) {
      var h = p(57);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}";
    }, function(c, u, p) {
      var h = p(59);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}";
    }, function(c, u, p) {
      var h = p(61);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image>img{display:block;margin:0 auto;max-width:100%;min-width:50px}";
    }, function(c, u, p) {
      var h = p(63);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
    }, function(c, u, p) {
      var h = p(65);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}';
    }, function(c, u, p) {
      var h = p(67);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}';
    }, function(c, u) {
      c.exports = ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}";
    }, function(c, u, p) {
      var h = p(70);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}";
    }, function(c, u, p) {
      var h = p(72);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-align-center:not(.image_resized),.ck-content .image-style-align-left:not(.image_resized),.ck-content .image-style-align-right:not(.image_resized),.ck-content .image-style-side:not(.image_resized){max-width:50%}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}";
    }, function(c, u, p) {
      var h = p(74);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}";
    }, function(c, u, p) {
      var h = p(76);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-input{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}[dir=ltr] .ck.ck-link-form>:not(:first-child),[dir=rtl] .ck.ck-link-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin-left:0}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}";
    }, function(c, u, p) {
      var h = p(78);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions{padding:var(--ck-spacing-standard)}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions:focus{outline:none}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
    }, function(c, u, p) {
      var h = p(80);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(3*var(--ck-spacing-standard));background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c8,#b900b4,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}';
    }, function(c, u, p) {
      var h = p(82);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-input{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-input{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}.ck.ck-media-form{padding:var(--ck-spacing-standard)}.ck.ck-media-form:focus{outline:none}[dir=ltr] .ck.ck-media-form>:not(:first-child),[dir=rtl] .ck.ck-media-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-media-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-media-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-media-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-media-form .ck-labeled-input .ck-labeled-input__error{white-space:normal}.ck.ck-media-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-media-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-media-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-media-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-media-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
    }, function(c, u, p) {
      var h = p(84);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}";
    }, function(c, u, p) {
      var h = p(86);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ":root{--ck-color-table-focused-cell-background:#f5fafe}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}";
    }, function(c, u, p) {
      var h = p(88);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ":root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px;--ck-insert-table-dropdown-box-border-color:#bfbfbf;--ck-insert-table-dropdown-box-border-active-color:#53a0e4;--ck-insert-table-dropdown-box-active-background:#c7e5ff}.ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-insert-table-dropdown-box-border-color);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-insert-table-dropdown-box-border-active-color);background:var(--ck-insert-table-dropdown-box-active-background)}";
    }, function(c, u, p) {
      var h = p(90);
      typeof h == "string" && (h = [[c.i, h, ""]]);
      var v = { injectType: "singletonStyleTag", insert: "head", singleton: !0 };
      p(1)(h, v), h.locals && (c.exports = h.locals);
    }, function(c, u) {
      c.exports = ".ck-content .table{margin:1em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border-color:#d9d9d9}.ck-content .table table th{font-weight:700;background:#fafafa}";
    }, function(c, u, p) {
      p.r(u);
      var h = p(3), v = h.a.Symbol, w = Object.prototype, x = w.hasOwnProperty, k = w.toString, P = v ? v.toStringTag : void 0, R = function(o) {
        var e = x.call(o, P), t = o[P];
        try {
          o[P] = void 0;
          var n = !0;
        } catch {
        }
        var i = k.call(o);
        return n && (e ? o[P] = t : delete o[P]), i;
      }, $ = Object.prototype.toString, J = function(o) {
        return $.call(o);
      }, X = "[object Null]", H = "[object Undefined]", W = v ? v.toStringTag : void 0, Z = function(o) {
        return o == null ? o === void 0 ? H : X : W && W in Object(o) ? R(o) : J(o);
      }, ee = function(o, e) {
        return function(t) {
          return o(e(t));
        };
      }, ne = ee(Object.getPrototypeOf, Object), se = function(o) {
        return o != null && typeof o == "object";
      }, pe = "[object Object]", ge = Function.prototype, Oe = Object.prototype, ke = ge.toString, we = Oe.hasOwnProperty, F = ke.call(Object), _ = function(o) {
        if (!se(o) || Z(o) != pe)
          return !1;
        var e = ne(o);
        if (e === null)
          return !0;
        var t = we.call(e, "constructor") && e.constructor;
        return typeof t == "function" && t instanceof t && ke.call(t) == F;
      }, E = function() {
        this.__data__ = [], this.size = 0;
      }, B = function(o, e) {
        return o === e || o != o && e != e;
      }, Y = function(o, e) {
        for (var t = o.length; t--; )
          if (B(o[t][0], e))
            return t;
        return -1;
      }, N = Array.prototype.splice, re = function(o) {
        var e = this.__data__, t = Y(e, o);
        return !(t < 0 || (t == e.length - 1 ? e.pop() : N.call(e, t, 1), --this.size, 0));
      }, Te = function(o) {
        var e = this.__data__, t = Y(e, o);
        return t < 0 ? void 0 : e[t][1];
      }, Me = function(o) {
        return Y(this.__data__, o) > -1;
      }, Ee = function(o, e) {
        var t = this.__data__, n = Y(t, o);
        return n < 0 ? (++this.size, t.push([o, e])) : t[n][1] = e, this;
      };
      function Ce(o) {
        var e = -1, t = o == null ? 0 : o.length;
        for (this.clear(); ++e < t; ) {
          var n = o[e];
          this.set(n[0], n[1]);
        }
      }
      Ce.prototype.clear = E, Ce.prototype.delete = re, Ce.prototype.get = Te, Ce.prototype.has = Me, Ce.prototype.set = Ee;
      var q = Ce, A = function() {
        this.__data__ = new q(), this.size = 0;
      }, M = function(o) {
        var e = this.__data__, t = e.delete(o);
        return this.size = e.size, t;
      }, Q = function(o) {
        return this.__data__.get(o);
      }, z = function(o) {
        return this.__data__.has(o);
      }, te = function(o) {
        var e = typeof o;
        return o != null && (e == "object" || e == "function");
      }, me = "[object AsyncFunction]", Ie = "[object Function]", ve = "[object GeneratorFunction]", Ne = "[object Proxy]", fe = function(o) {
        if (!te(o))
          return !1;
        var e = Z(o);
        return e == Ie || e == ve || e == me || e == Ne;
      }, ae = h.a["__core-js_shared__"], ct = function() {
        var o = /[^.]+$/.exec(ae && ae.keys && ae.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), Gt = function(o) {
        return !!ct && ct in o;
      }, Qe = Function.prototype.toString, Ve = function(o) {
        if (o != null) {
          try {
            return Qe.call(o);
          } catch {
          }
          try {
            return o + "";
          } catch {
          }
        }
        return "";
      }, Zt = /^\[object .+?Constructor\]$/, Tn = Function.prototype, $n = Object.prototype, Et = Tn.toString, Ft = $n.hasOwnProperty, Mt = RegExp("^" + Et.call(Ft).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Jt = function(o) {
        return !(!te(o) || Gt(o)) && (fe(o) ? Mt : Zt).test(Ve(o));
      }, Je = function(o, e) {
        return o == null ? void 0 : o[e];
      }, et = function(o, e) {
        var t = Je(o, e);
        return Jt(t) ? t : void 0;
      }, bt = et(h.a, "Map"), en = et(Object, "create"), ir = function() {
        this.__data__ = en ? en(null) : {}, this.size = 0;
      }, jn = function(o) {
        var e = this.has(o) && delete this.__data__[o];
        return this.size -= e ? 1 : 0, e;
      }, Jn = "__lodash_hash_undefined__", Br = Object.prototype.hasOwnProperty, Vr = function(o) {
        var e = this.__data__;
        if (en) {
          var t = e[o];
          return t === Jn ? void 0 : t;
        }
        return Br.call(e, o) ? e[o] : void 0;
      }, as = Object.prototype.hasOwnProperty, ls = function(o) {
        var e = this.__data__;
        return en ? e[o] !== void 0 : as.call(e, o);
      }, cs = "__lodash_hash_undefined__", We = function(o, e) {
        var t = this.__data__;
        return this.size += this.has(o) ? 0 : 1, t[o] = en && e === void 0 ? cs : e, this;
      };
      function ei(o) {
        var e = -1, t = o == null ? 0 : o.length;
        for (this.clear(); ++e < t; ) {
          var n = o[e];
          this.set(n[0], n[1]);
        }
      }
      ei.prototype.clear = ir, ei.prototype.delete = jn, ei.prototype.get = Vr, ei.prototype.has = ls, ei.prototype.set = We;
      var K = ei, U = function() {
        this.size = 0, this.__data__ = { hash: new K(), map: new (bt || q)(), string: new K() };
      }, G = function(o) {
        var e = typeof o;
        return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? o !== "__proto__" : o === null;
      }, S = function(o, e) {
        var t = o.__data__;
        return G(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
      }, T = function(o) {
        var e = S(this, o).delete(o);
        return this.size -= e ? 1 : 0, e;
      }, I = function(o) {
        return S(this, o).get(o);
      }, L = function(o) {
        return S(this, o).has(o);
      }, j = function(o, e) {
        var t = S(this, o), n = t.size;
        return t.set(o, e), this.size += t.size == n ? 0 : 1, this;
      };
      function xe(o) {
        var e = -1, t = o == null ? 0 : o.length;
        for (this.clear(); ++e < t; ) {
          var n = o[e];
          this.set(n[0], n[1]);
        }
      }
      xe.prototype.clear = U, xe.prototype.delete = T, xe.prototype.get = I, xe.prototype.has = L, xe.prototype.set = j;
      var Se = xe, Fe = 200, Re = function(o, e) {
        var t = this.__data__;
        if (t instanceof q) {
          var n = t.__data__;
          if (!bt || n.length < Fe - 1)
            return n.push([o, e]), this.size = ++t.size, this;
          t = this.__data__ = new Se(n);
        }
        return t.set(o, e), this.size = t.size, this;
      };
      function qe(o) {
        var e = this.__data__ = new q(o);
        this.size = e.size;
      }
      qe.prototype.clear = A, qe.prototype.delete = M, qe.prototype.get = Q, qe.prototype.has = z, qe.prototype.set = Re;
      var Ot = qe, pt = function(o, e) {
        for (var t = -1, n = o == null ? 0 : o.length; ++t < n && e(o[t], t, o) !== !1; )
          ;
        return o;
      }, Ue = function() {
        try {
          var o = et(Object, "defineProperty");
          return o({}, "", {}), o;
        } catch {
        }
      }(), vn = function(o, e, t) {
        e == "__proto__" && Ue ? Ue(o, e, { configurable: !0, enumerable: !0, value: t, writable: !0 }) : o[e] = t;
      }, ti = Object.prototype.hasOwnProperty, In = function(o, e, t) {
        var n = o[e];
        ti.call(o, e) && B(n, t) && (t !== void 0 || e in o) || vn(o, e, t);
      }, zt = function(o, e, t, n) {
        var i = !t;
        t || (t = {});
        for (var s = -1, l = e.length; ++s < l; ) {
          var d = e[s], f = n ? n(t[d], o[d], d, t, o) : void 0;
          f === void 0 && (f = o[d]), i ? vn(t, d, f) : In(t, d, f);
        }
        return t;
      }, Ke = function(o, e) {
        for (var t = -1, n = Array(o); ++t < o; )
          n[t] = e(t);
        return n;
      }, rr = "[object Arguments]", or = function(o) {
        return se(o) && Z(o) == rr;
      }, ni = Object.prototype, Ur = ni.hasOwnProperty, Hr = ni.propertyIsEnumerable, Jp = or(function() {
        return arguments;
      }()) ? or : function(o) {
        return se(o) && Ur.call(o, "callee") && !Hr.call(o, "callee");
      }, En = Array.isArray, Wr = p(5), em = 9007199254740991, tm = /^(?:0|[1-9]\d*)$/, El = function(o, e) {
        var t = typeof o;
        return !!(e = e == null ? em : e) && (t == "number" || t != "symbol" && tm.test(o)) && o > -1 && o % 1 == 0 && o < e;
      }, nm = 9007199254740991, Pl = function(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= nm;
      }, ut = {};
      ut["[object Float32Array]"] = ut["[object Float64Array]"] = ut["[object Int8Array]"] = ut["[object Int16Array]"] = ut["[object Int32Array]"] = ut["[object Uint8Array]"] = ut["[object Uint8ClampedArray]"] = ut["[object Uint16Array]"] = ut["[object Uint32Array]"] = !0, ut["[object Arguments]"] = ut["[object Array]"] = ut["[object ArrayBuffer]"] = ut["[object Boolean]"] = ut["[object DataView]"] = ut["[object Date]"] = ut["[object Error]"] = ut["[object Function]"] = ut["[object Map]"] = ut["[object Number]"] = ut["[object Object]"] = ut["[object RegExp]"] = ut["[object Set]"] = ut["[object String]"] = ut["[object WeakMap]"] = !1;
      var im = function(o) {
        return se(o) && Pl(o.length) && !!ut[Z(o)];
      }, us = function(o) {
        return function(e) {
          return o(e);
        };
      }, Ni = p(4), Ml = Ni.a && Ni.a.isTypedArray, Ol = Ml ? us(Ml) : im, rm = Object.prototype.hasOwnProperty, Dl = function(o, e) {
        var t = En(o), n = !t && Jp(o), i = !t && !n && Object(Wr.a)(o), s = !t && !n && !i && Ol(o), l = t || n || i || s, d = l ? Ke(o.length, String) : [], f = d.length;
        for (var m in o)
          !e && !rm.call(o, m) || l && (m == "length" || i && (m == "offset" || m == "parent") || s && (m == "buffer" || m == "byteLength" || m == "byteOffset") || El(m, f)) || d.push(m);
        return d;
      }, om = Object.prototype, ds = function(o) {
        var e = o && o.constructor;
        return o === (typeof e == "function" && e.prototype || om);
      }, sm = ee(Object.keys, Object), am = Object.prototype.hasOwnProperty, lm = function(o) {
        if (!ds(o))
          return sm(o);
        var e = [];
        for (var t in Object(o))
          am.call(o, t) && t != "constructor" && e.push(t);
        return e;
      }, hs = function(o) {
        return o != null && Pl(o.length) && !fe(o);
      }, fs = function(o) {
        return hs(o) ? Dl(o) : lm(o);
      }, cm = function(o, e) {
        return o && zt(e, fs(e), o);
      }, um = function(o) {
        var e = [];
        if (o != null)
          for (var t in Object(o))
            e.push(t);
        return e;
      }, dm = Object.prototype.hasOwnProperty, hm = function(o) {
        if (!te(o))
          return um(o);
        var e = ds(o), t = [];
        for (var n in o)
          (n != "constructor" || !e && dm.call(o, n)) && t.push(n);
        return t;
      }, ps = function(o) {
        return hs(o) ? Dl(o, !0) : hm(o);
      }, fm = function(o, e) {
        return o && zt(e, ps(e), o);
      }, pm = p(12), mm = function(o, e) {
        var t = -1, n = o.length;
        for (e || (e = Array(n)); ++t < n; )
          e[t] = o[t];
        return e;
      }, gm = function(o, e) {
        for (var t = -1, n = o == null ? 0 : o.length, i = 0, s = []; ++t < n; ) {
          var l = o[t];
          e(l, t, o) && (s[i++] = l);
        }
        return s;
      }, Nl = function() {
        return [];
      }, vm = Object.prototype.propertyIsEnumerable, Rl = Object.getOwnPropertySymbols, ms = Rl ? function(o) {
        return o == null ? [] : (o = Object(o), gm(Rl(o), function(e) {
          return vm.call(o, e);
        }));
      } : Nl, bm = function(o, e) {
        return zt(o, ms(o), e);
      }, Ll = function(o, e) {
        for (var t = -1, n = e.length, i = o.length; ++t < n; )
          o[i + t] = e[t];
        return o;
      }, Fl = Object.getOwnPropertySymbols ? function(o) {
        for (var e = []; o; )
          Ll(e, ms(o)), o = ne(o);
        return e;
      } : Nl, _m = function(o, e) {
        return zt(o, Fl(o), e);
      }, zl = function(o, e, t) {
        var n = e(o);
        return En(o) ? n : Ll(n, t(o));
      }, gs = function(o) {
        return zl(o, fs, ms);
      }, wm = function(o) {
        return zl(o, ps, Fl);
      }, vs = et(h.a, "DataView"), bs = et(h.a, "Promise"), _s = et(h.a, "Set"), ws = et(h.a, "WeakMap"), ym = Ve(vs), km = Ve(bt), xm = Ve(bs), Sm = Ve(_s), Cm = Ve(ws), _i = Z;
      (vs && _i(new vs(new ArrayBuffer(1))) != "[object DataView]" || bt && _i(new bt()) != "[object Map]" || bs && _i(bs.resolve()) != "[object Promise]" || _s && _i(new _s()) != "[object Set]" || ws && _i(new ws()) != "[object WeakMap]") && (_i = function(o) {
        var e = Z(o), t = e == "[object Object]" ? o.constructor : void 0, n = t ? Ve(t) : "";
        if (n)
          switch (n) {
            case ym:
              return "[object DataView]";
            case km:
              return "[object Map]";
            case xm:
              return "[object Promise]";
            case Sm:
              return "[object Set]";
            case Cm:
              return "[object WeakMap]";
          }
        return e;
      });
      var sr = _i, Am = Object.prototype.hasOwnProperty, Tm = function(o) {
        var e = o.length, t = new o.constructor(e);
        return e && typeof o[0] == "string" && Am.call(o, "index") && (t.index = o.index, t.input = o.input), t;
      }, Yr = h.a.Uint8Array, ys = function(o) {
        var e = new o.constructor(o.byteLength);
        return new Yr(e).set(new Yr(o)), e;
      }, Im = function(o, e) {
        var t = e ? ys(o.buffer) : o.buffer;
        return new o.constructor(t, o.byteOffset, o.byteLength);
      }, Em = /\w*$/, Pm = function(o) {
        var e = new o.constructor(o.source, Em.exec(o));
        return e.lastIndex = o.lastIndex, e;
      }, $l = v ? v.prototype : void 0, jl = $l ? $l.valueOf : void 0, Mm = function(o) {
        return jl ? Object(jl.call(o)) : {};
      }, Om = function(o, e) {
        var t = e ? ys(o.buffer) : o.buffer;
        return new o.constructor(t, o.byteOffset, o.length);
      }, Dm = "[object Boolean]", Nm = "[object Date]", Rm = "[object Map]", Lm = "[object Number]", Fm = "[object RegExp]", zm = "[object Set]", $m = "[object String]", jm = "[object Symbol]", Bm = "[object ArrayBuffer]", Vm = "[object DataView]", Um = "[object Float32Array]", Hm = "[object Float64Array]", Wm = "[object Int8Array]", Ym = "[object Int16Array]", qm = "[object Int32Array]", Gm = "[object Uint8Array]", Zm = "[object Uint8ClampedArray]", Km = "[object Uint16Array]", Xm = "[object Uint32Array]", Qm = function(o, e, t) {
        var n = o.constructor;
        switch (e) {
          case Bm:
            return ys(o);
          case Dm:
          case Nm:
            return new n(+o);
          case Vm:
            return Im(o, t);
          case Um:
          case Hm:
          case Wm:
          case Ym:
          case qm:
          case Gm:
          case Zm:
          case Km:
          case Xm:
            return Om(o, t);
          case Rm:
            return new n();
          case Lm:
          case $m:
            return new n(o);
          case Fm:
            return Pm(o);
          case zm:
            return new n();
          case jm:
            return Mm(o);
        }
      }, Bl = Object.create, Jm = function() {
        function o() {
        }
        return function(e) {
          if (!te(e))
            return {};
          if (Bl)
            return Bl(e);
          o.prototype = e;
          var t = new o();
          return o.prototype = void 0, t;
        };
      }(), eg = function(o) {
        return typeof o.constructor != "function" || ds(o) ? {} : Jm(ne(o));
      }, tg = "[object Map]", ng = function(o) {
        return se(o) && sr(o) == tg;
      }, Vl = Ni.a && Ni.a.isMap, ig = Vl ? us(Vl) : ng, rg = "[object Set]", og = function(o) {
        return se(o) && sr(o) == rg;
      }, Ul = Ni.a && Ni.a.isSet, sg = Ul ? us(Ul) : og, ag = 1, lg = 2, cg = 4, Hl = "[object Arguments]", Wl = "[object Function]", ug = "[object GeneratorFunction]", Yl = "[object Object]", st = {};
      st[Hl] = st["[object Array]"] = st["[object ArrayBuffer]"] = st["[object DataView]"] = st["[object Boolean]"] = st["[object Date]"] = st["[object Float32Array]"] = st["[object Float64Array]"] = st["[object Int8Array]"] = st["[object Int16Array]"] = st["[object Int32Array]"] = st["[object Map]"] = st["[object Number]"] = st[Yl] = st["[object RegExp]"] = st["[object Set]"] = st["[object String]"] = st["[object Symbol]"] = st["[object Uint8Array]"] = st["[object Uint8ClampedArray]"] = st["[object Uint16Array]"] = st["[object Uint32Array]"] = !0, st["[object Error]"] = st[Wl] = st["[object WeakMap]"] = !1;
      var ks = function o(e, t, n, i, s, l) {
        var d, f = t & ag, m = t & lg, g = t & cg;
        if (n && (d = s ? n(e, i, s, l) : n(e)), d !== void 0)
          return d;
        if (!te(e))
          return e;
        var b = En(e);
        if (b) {
          if (d = Tm(e), !f)
            return mm(e, d);
        } else {
          var y = sr(e), C = y == Wl || y == ug;
          if (Object(Wr.a)(e))
            return Object(pm.a)(e, f);
          if (y == Yl || y == Hl || C && !s) {
            if (d = m || C ? {} : eg(e), !f)
              return m ? _m(e, fm(d, e)) : bm(e, cm(d, e));
          } else {
            if (!st[y])
              return s ? e : {};
            d = Qm(e, y, f);
          }
        }
        l || (l = new Ot());
        var O = l.get(e);
        if (O)
          return O;
        l.set(e, d), sg(e) ? e.forEach(function(ce) {
          d.add(o(ce, t, n, ce, e, l));
        }) : ig(e) && e.forEach(function(ce, _e) {
          d.set(_e, o(ce, t, n, _e, e, l));
        });
        var D = g ? m ? wm : gs : m ? keysIn : fs, oe = b ? void 0 : D(e);
        return pt(oe || e, function(ce, _e) {
          oe && (ce = e[_e = ce]), In(d, _e, o(ce, t, n, _e, e, l));
        }), d;
      }, dg = 1, hg = 4, ql = function(o, e) {
        return ks(o, dg | hg, e = typeof e == "function" ? e : void 0);
      }, Bn = function(o) {
        return se(o) && o.nodeType === 1 && !_(o);
      };
      class fg {
        constructor(e, t) {
          this._config = {}, t && this.define(t), e && this._setObjectToTarget(this._config, e);
        }
        set(e, t) {
          this._setToTarget(this._config, e, t);
        }
        define(e, t) {
          this._setToTarget(this._config, e, t, !0);
        }
        get(e) {
          return this._getFromSource(this._config, e);
        }
        _setToTarget(e, t, n, i = !1) {
          if (_(t))
            return void this._setObjectToTarget(e, t, i);
          const s = t.split(".");
          t = s.pop();
          for (const l of s)
            _(e[l]) || (e[l] = {}), e = e[l];
          if (_(n))
            return _(e[t]) || (e[t] = {}), e = e[t], void this._setObjectToTarget(e, n, i);
          i && e[t] !== void 0 || (e[t] = n);
        }
        _getFromSource(e, t) {
          const n = t.split(".");
          t = n.pop();
          for (const i of n) {
            if (!_(e[i])) {
              e = null;
              break;
            }
            e = e[i];
          }
          return e ? function(i) {
            return ql(i, pg);
          }(e[t]) : void 0;
        }
        _setObjectToTarget(e, t, n) {
          Object.keys(t).forEach((i) => {
            this._setToTarget(e, i, t[i], n);
          });
        }
      }
      function pg(o) {
        return Bn(o) ? o : void 0;
      }
      var V = p(0), Gl = function() {
        return function o() {
          o.called = !0;
        };
      };
      class qr {
        constructor(e, t) {
          this.source = e, this.name = t, this.path = [], this.stop = Gl(), this.off = Gl();
        }
      }
      function Vn() {
        let o = "e";
        for (let e = 0; e < 8; e++)
          o += Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
        return o;
      }
      var xs = { get(o) {
        return typeof o != "number" ? this[o] || this.normal : o;
      }, highest: 1e5, high: 1e3, normal: 0, low: -1e3, lowest: -1e5 };
      p(6);
      const ii = Symbol("listeningTo"), Ss = Symbol("emitterId");
      var dt = { on(o, e, t = {}) {
        this.listenTo(this, o, e, t);
      }, once(o, e, t) {
        let n = !1;
        this.listenTo(this, o, function(i, ...s) {
          n || (n = !0, i.off(), e.call(this, i, ...s));
        }, t);
      }, off(o, e) {
        this.stopListening(this, o, e);
      }, listenTo(o, e, t, n = {}) {
        let i, s;
        this[ii] || (this[ii] = {});
        const l = this[ii];
        Cs(o) || Zl(o);
        const d = Cs(o);
        (i = l[d]) || (i = l[d] = { emitter: o, callbacks: {} }), (s = i.callbacks[e]) || (s = i.callbacks[e] = []), s.push(t), function(b, y) {
          const C = Kl(b);
          if (C[y])
            return;
          let O = y, D = null;
          const oe = [];
          for (; O !== "" && !C[O]; )
            C[O] = { callbacks: [], childEvents: [] }, oe.push(C[O]), D && C[O].childEvents.push(D), D = O, O = O.substr(0, O.lastIndexOf(":"));
          if (O !== "") {
            for (const ce of oe)
              ce.callbacks = C[O].callbacks.slice();
            C[O].childEvents.push(D);
          }
        }(o, e);
        const f = As(o, e), m = xs.get(n.priority), g = { callback: t, priority: m };
        for (const b of f) {
          let y = !1;
          for (let C = 0; C < b.length; C++)
            if (b[C].priority < m) {
              b.splice(C, 0, g), y = !0;
              break;
            }
          y || b.push(g);
        }
      }, stopListening(o, e, t) {
        const n = this[ii];
        let i = o && Cs(o);
        const s = n && i && n[i], l = s && e && s.callbacks[e];
        if (!(!n || o && !s || e && !l))
          if (t)
            Ts(o, e, t);
          else if (l) {
            for (; t = l.pop(); )
              Ts(o, e, t);
            delete s.callbacks[e];
          } else if (s) {
            for (e in s.callbacks)
              this.stopListening(o, e);
            delete n[i];
          } else {
            for (i in n)
              this.stopListening(n[i].emitter);
            delete this[ii];
          }
      }, fire(o, ...e) {
        const t = o instanceof qr ? o : new qr(this, o), n = t.name;
        let i = function s(l, d) {
          let f;
          return !l._events || !(f = l._events[d]) || !f.callbacks.length ? d.indexOf(":") > -1 ? s(l, d.substr(0, d.lastIndexOf(":"))) : null : f.callbacks;
        }(this, n);
        if (t.path.push(this), i) {
          const s = [t, ...e];
          i = Array.from(i);
          for (let l = 0; l < i.length && (i[l].callback.apply(this, s), t.off.called && (delete t.off.called, Ts(this, n, i[l].callback)), !t.stop.called); l++)
            ;
        }
        if (this._delegations) {
          const s = this._delegations.get(n), l = this._delegations.get("*");
          s && Xl(s, t, e), l && Xl(l, t, e);
        }
        return t.return;
      }, delegate(...o) {
        return { to: (e, t) => {
          this._delegations || (this._delegations = /* @__PURE__ */ new Map()), o.forEach((n) => {
            const i = this._delegations.get(n);
            i ? i.set(e, t) : this._delegations.set(n, /* @__PURE__ */ new Map([[e, t]]));
          });
        } };
      }, stopDelegating(o, e) {
        if (this._delegations)
          if (o)
            if (e) {
              const t = this._delegations.get(o);
              t && t.delete(e);
            } else
              this._delegations.delete(o);
          else
            this._delegations.clear();
      } };
      function Zl(o, e) {
        o[Ss] || (o[Ss] = e || Vn());
      }
      function Cs(o) {
        return o[Ss];
      }
      function Kl(o) {
        return o._events || Object.defineProperty(o, "_events", { value: {} }), o._events;
      }
      function As(o, e) {
        const t = Kl(o)[e];
        if (!t)
          return [];
        let n = [t.callbacks];
        for (let i = 0; i < t.childEvents.length; i++) {
          const s = As(o, t.childEvents[i]);
          n = n.concat(s);
        }
        return n;
      }
      function Xl(o, e, t) {
        for (let [n, i] of o) {
          i ? typeof i == "function" && (i = i(e.name)) : i = e.name;
          const s = new qr(e.source, i);
          s.path = [...e.path], n.fire(s, ...t);
        }
      }
      function Ts(o, e, t) {
        const n = As(o, e);
        for (const i of n)
          for (let s = 0; s < i.length; s++)
            i[s].callback == t && (i.splice(s, 1), s--);
      }
      function $e(o, ...e) {
        e.forEach((t) => {
          Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t)).forEach((n) => {
            if (n in o.prototype)
              return;
            const i = Object.getOwnPropertyDescriptor(t, n);
            i.enumerable = !1, Object.defineProperty(o.prototype, n, i);
          });
        });
      }
      function Kt(o, e) {
        const t = Math.min(o.length, e.length);
        for (let n = 0; n < t; n++)
          if (o[n] != e[n])
            return n;
        return o.length == e.length ? "same" : o.length < e.length ? "prefix" : "extension";
      }
      var mg = 4, Ql = function(o) {
        return ks(o, mg);
      };
      class ri {
        constructor() {
          this.parent = null;
        }
        get index() {
          let e;
          if (!this.parent)
            return null;
          if ((e = this.parent.getChildIndex(this)) == -1)
            throw new V.b("view-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return e;
        }
        get nextSibling() {
          const e = this.index;
          return e !== null && this.parent.getChild(e + 1) || null;
        }
        get previousSibling() {
          const e = this.index;
          return e !== null && this.parent.getChild(e - 1) || null;
        }
        get root() {
          let e = this;
          for (; e.parent; )
            e = e.parent;
          return e;
        }
        get document() {
          return this.parent instanceof ri ? this.parent.document : null;
        }
        getPath() {
          const e = [];
          let t = this;
          for (; t.parent; )
            e.unshift(t.index), t = t.parent;
          return e;
        }
        getAncestors(e = { includeSelf: !1, parentFirst: !1 }) {
          const t = [];
          let n = e.includeSelf ? this : this.parent;
          for (; n; )
            t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return t;
        }
        getCommonAncestor(e, t = {}) {
          const n = this.getAncestors(t), i = e.getAncestors(t);
          let s = 0;
          for (; n[s] == i[s] && n[s]; )
            s++;
          return s === 0 ? null : n[s - 1];
        }
        isBefore(e) {
          if (this == e || this.root !== e.root)
            return !1;
          const t = this.getPath(), n = e.getPath(), i = Kt(t, n);
          switch (i) {
            case "prefix":
              return !0;
            case "extension":
              return !1;
            default:
              return t[i] < n[i];
          }
        }
        isAfter(e) {
          return this != e && this.root === e.root && !this.isBefore(e);
        }
        _remove() {
          this.parent._removeChildren(this.index);
        }
        _fireChange(e, t) {
          this.fire("change:" + e, t), this.parent && this.parent._fireChange(e, t);
        }
        toJSON() {
          const e = Ql(this);
          return delete e.parent, e;
        }
        is(e) {
          return e == "node" || e == "view:node";
        }
      }
      $e(ri, dt);
      class rt extends ri {
        constructor(e) {
          super(), this._textData = e;
        }
        is(e) {
          return e == "text" || e == "view:text" || super.is(e);
        }
        get data() {
          return this._textData;
        }
        get _data() {
          return this.data;
        }
        set _data(e) {
          this._fireChange("text", this), this._textData = e;
        }
        isSimilar(e) {
          return e instanceof rt && (this === e || this.data === e.data);
        }
        _clone() {
          return new rt(this.data);
        }
      }
      class Un {
        constructor(e, t, n) {
          if (this.textNode = e, t < 0 || t > e.data.length)
            throw new V.b("view-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
          if (n < 0 || t + n > e.data.length)
            throw new V.b("view-textproxy-wrong-length: Given length value is incorrect.", this);
          this.data = e.data.substring(t, t + n), this.offsetInText = t;
        }
        get offsetSize() {
          return this.data.length;
        }
        get isPartial() {
          return this.data.length !== this.textNode.data.length;
        }
        get parent() {
          return this.textNode.parent;
        }
        get root() {
          return this.textNode.root;
        }
        get document() {
          return this.textNode.document;
        }
        is(e) {
          return e == "textProxy" || e == "view:textProxy";
        }
        getAncestors(e = { includeSelf: !1, parentFirst: !1 }) {
          const t = [];
          let n = e.includeSelf ? this.textNode : this.parent;
          for (; n !== null; )
            t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return t;
        }
      }
      function Jl(o) {
        const e = /* @__PURE__ */ new Map();
        for (const t in o)
          e.set(t, o[t]);
        return e;
      }
      function Hn(o) {
        return !(!o || !o[Symbol.iterator]);
      }
      class Wn {
        constructor(...e) {
          this._patterns = [], this.add(...e);
        }
        add(...e) {
          for (let t of e)
            (typeof t == "string" || t instanceof RegExp) && (t = { name: t }), t.classes && (typeof t.classes == "string" || t.classes instanceof RegExp) && (t.classes = [t.classes]), this._patterns.push(t);
        }
        match(...e) {
          for (const t of e)
            for (const n of this._patterns) {
              const i = ec(t, n);
              if (i)
                return { element: t, pattern: n, match: i };
            }
          return null;
        }
        matchAll(...e) {
          const t = [];
          for (const n of e)
            for (const i of this._patterns) {
              const s = ec(n, i);
              s && t.push({ element: n, pattern: i, match: s });
            }
          return t.length > 0 ? t : null;
        }
        getElementName() {
          if (this._patterns.length !== 1)
            return null;
          const e = this._patterns[0], t = e.name;
          return typeof e == "function" || !t || t instanceof RegExp ? null : t;
        }
      }
      function ec(o, e) {
        if (typeof e == "function")
          return e(o);
        const t = {};
        return e.name && (t.name = function(n, i) {
          return n instanceof RegExp ? n.test(i) : n === i;
        }(e.name, o.name), !t.name) || e.attributes && (t.attributes = function(n, i) {
          const s = [];
          for (const l in n) {
            const d = n[l];
            if (!i.hasAttribute(l))
              return null;
            {
              const f = i.getAttribute(l);
              if (d === !0)
                s.push(l);
              else if (d instanceof RegExp) {
                if (!d.test(f))
                  return null;
                s.push(l);
              } else {
                if (f !== d)
                  return null;
                s.push(l);
              }
            }
          }
          return s;
        }(e.attributes, o), !t.attributes) ? null : !(e.classes && (t.classes = function(n, i) {
          const s = [];
          for (const l of n)
            if (l instanceof RegExp) {
              const d = i.getClassNames();
              for (const f of d)
                l.test(f) && s.push(f);
              if (s.length === 0)
                return null;
            } else {
              if (!i.hasClass(l))
                return null;
              s.push(l);
            }
          return s;
        }(e.classes, o), !t.classes)) && !(e.styles && (t.styles = function(n, i) {
          const s = [];
          for (const l in n) {
            const d = n[l];
            if (!i.hasStyle(l))
              return null;
            {
              const f = i.getStyle(l);
              if (d instanceof RegExp) {
                if (!d.test(f))
                  return null;
                s.push(l);
              } else {
                if (f !== d)
                  return null;
                s.push(l);
              }
            }
          }
          return s;
        }(e.styles, o), !t.styles)) && t;
      }
      class tn extends ri {
        constructor(e, t, n) {
          if (super(), this.name = e, this._attrs = function(i) {
            i = _(i) ? Jl(i) : new Map(i);
            for (const [s, l] of i)
              l === null ? i.delete(s) : typeof l != "string" && i.set(s, String(l));
            return i;
          }(t), this._children = [], n && this._insertChild(0, n), this._classes = /* @__PURE__ */ new Set(), this._attrs.has("class")) {
            const i = this._attrs.get("class");
            nc(this._classes, i), this._attrs.delete("class");
          }
          this._styles = /* @__PURE__ */ new Map(), this._attrs.has("style") && (tc(this._styles, this._attrs.get("style")), this._attrs.delete("style")), this._customProperties = /* @__PURE__ */ new Map();
        }
        get childCount() {
          return this._children.length;
        }
        get isEmpty() {
          return this._children.length === 0;
        }
        is(e, t = null) {
          const n = e.replace(/^view:/, "");
          return t ? n == "element" && t == this.name : n == "element" || n == this.name || super.is(e);
        }
        getChild(e) {
          return this._children[e];
        }
        getChildIndex(e) {
          return this._children.indexOf(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        *getAttributeKeys() {
          this._classes.size > 0 && (yield "class"), this._styles.size > 0 && (yield "style"), yield* this._attrs.keys();
        }
        *getAttributes() {
          yield* this._attrs.entries(), this._classes.size > 0 && (yield ["class", this.getAttribute("class")]), this._styles.size > 0 && (yield ["style", this.getAttribute("style")]);
        }
        getAttribute(e) {
          if (e == "class")
            return this._classes.size > 0 ? [...this._classes].join(" ") : void 0;
          if (e != "style")
            return this._attrs.get(e);
          if (this._styles.size > 0) {
            let t = "";
            for (const [n, i] of this._styles)
              t += `${n}:${i};`;
            return t;
          }
        }
        hasAttribute(e) {
          return e == "class" ? this._classes.size > 0 : e == "style" ? this._styles.size > 0 : this._attrs.has(e);
        }
        isSimilar(e) {
          if (!(e instanceof tn))
            return !1;
          if (this === e)
            return !0;
          if (this.name != e.name || this._attrs.size !== e._attrs.size || this._classes.size !== e._classes.size || this._styles.size !== e._styles.size)
            return !1;
          for (const [t, n] of this._attrs)
            if (!e._attrs.has(t) || e._attrs.get(t) !== n)
              return !1;
          for (const t of this._classes)
            if (!e._classes.has(t))
              return !1;
          for (const [t, n] of this._styles)
            if (!e._styles.has(t) || e._styles.get(t) !== n)
              return !1;
          return !0;
        }
        hasClass(...e) {
          for (const t of e)
            if (!this._classes.has(t))
              return !1;
          return !0;
        }
        getClassNames() {
          return this._classes.keys();
        }
        getStyle(e) {
          return this._styles.get(e);
        }
        getStyleNames() {
          return this._styles.keys();
        }
        hasStyle(...e) {
          for (const t of e)
            if (!this._styles.has(t))
              return !1;
          return !0;
        }
        findAncestor(...e) {
          const t = new Wn(...e);
          let n = this.parent;
          for (; n; ) {
            if (t.match(n))
              return n;
            n = n.parent;
          }
          return null;
        }
        getCustomProperty(e) {
          return this._customProperties.get(e);
        }
        *getCustomProperties() {
          yield* this._customProperties.entries();
        }
        getIdentity() {
          const e = Array.from(this._classes).sort().join(","), t = Array.from(this._styles).map((i) => `${i[0]}:${i[1]}`).sort().join(";"), n = Array.from(this._attrs).map((i) => `${i[0]}="${i[1]}"`).sort().join(" ");
          return this.name + (e == "" ? "" : ` class="${e}"`) + (t == "" ? "" : ` style="${t}"`) + (n == "" ? "" : ` ${n}`);
        }
        _clone(e = !1) {
          const t = [];
          if (e)
            for (const i of this.getChildren())
              t.push(i._clone(e));
          const n = new this.constructor(this.name, this._attrs, t);
          return n._classes = new Set(this._classes), n._styles = new Map(this._styles), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n;
        }
        _appendChild(e) {
          return this._insertChild(this.childCount, e);
        }
        _insertChild(e, t) {
          this._fireChange("children", this);
          let n = 0;
          const i = function(s) {
            return typeof s == "string" ? [new rt(s)] : (Hn(s) || (s = [s]), Array.from(s).map((l) => typeof l == "string" ? new rt(l) : l instanceof Un ? new rt(l.data) : l));
          }(t);
          for (const s of i)
            s.parent !== null && s._remove(), s.parent = this, this._children.splice(e, 0, s), e++, n++;
          return n;
        }
        _removeChildren(e, t = 1) {
          this._fireChange("children", this);
          for (let n = e; n < e + t; n++)
            this._children[n].parent = null;
          return this._children.splice(e, t);
        }
        _setAttribute(e, t) {
          t = String(t), this._fireChange("attributes", this), e == "class" ? nc(this._classes, t) : e == "style" ? tc(this._styles, t) : this._attrs.set(e, t);
        }
        _removeAttribute(e) {
          return this._fireChange("attributes", this), e == "class" ? this._classes.size > 0 && (this._classes.clear(), !0) : e == "style" ? this._styles.size > 0 && (this._styles.clear(), !0) : this._attrs.delete(e);
        }
        _addClass(e) {
          this._fireChange("attributes", this), (e = Array.isArray(e) ? e : [e]).forEach((t) => this._classes.add(t));
        }
        _removeClass(e) {
          this._fireChange("attributes", this), (e = Array.isArray(e) ? e : [e]).forEach((t) => this._classes.delete(t));
        }
        _setStyle(e, t) {
          if (this._fireChange("attributes", this), _(e)) {
            const n = Object.keys(e);
            for (const i of n)
              this._styles.set(i, e[i]);
          } else
            this._styles.set(e, t);
        }
        _removeStyle(e) {
          this._fireChange("attributes", this), (e = Array.isArray(e) ? e : [e]).forEach((t) => this._styles.delete(t));
        }
        _setCustomProperty(e, t) {
          this._customProperties.set(e, t);
        }
        _removeCustomProperty(e) {
          return this._customProperties.delete(e);
        }
      }
      function tc(o, e) {
        let t = null, n = 0, i = 0, s = null;
        if (o.clear(), e !== "") {
          e.charAt(e.length - 1) != ";" && (e += ";");
          for (let l = 0; l < e.length; l++) {
            const d = e.charAt(l);
            if (t === null)
              switch (d) {
                case ":":
                  s || (s = e.substr(n, l - n), i = l + 1);
                  break;
                case '"':
                case "'":
                  t = d;
                  break;
                case ";": {
                  const f = e.substr(i, l - i);
                  s && o.set(s.trim(), f.trim()), s = null, n = l + 1;
                  break;
                }
              }
            else
              d === t && (t = null);
          }
        }
      }
      function nc(o, e) {
        const t = e.split(/\s+/);
        o.clear(), t.forEach((n) => o.add(n));
      }
      class Gr extends tn {
        constructor(e, t, n) {
          super(e, t, n), this.getFillerOffset = ic;
        }
        is(e, t = null) {
          const n = e && e.replace(/^view:/, "");
          return t ? n == "containerElement" && t == this.name || super.is(e, t) : n == "containerElement" || super.is(e);
        }
      }
      function ic() {
        const o = [...this.getChildren()], e = o[this.childCount - 1];
        if (e && e.is("element", "br"))
          return this.childCount;
        for (const t of o)
          if (!t.is("uiElement"))
            return null;
        return this.childCount;
      }
      var rc = function(o) {
        return o;
      }, gg = function(o, e, t) {
        switch (t.length) {
          case 0:
            return o.call(e);
          case 1:
            return o.call(e, t[0]);
          case 2:
            return o.call(e, t[0], t[1]);
          case 3:
            return o.call(e, t[0], t[1], t[2]);
        }
        return o.apply(e, t);
      }, oc = Math.max, vg = function(o, e, t) {
        return e = oc(e === void 0 ? o.length - 1 : e, 0), function() {
          for (var n = arguments, i = -1, s = oc(n.length - e, 0), l = Array(s); ++i < s; )
            l[i] = n[e + i];
          i = -1;
          for (var d = Array(e + 1); ++i < e; )
            d[i] = n[i];
          return d[e] = t(l), gg(o, this, d);
        };
      }, bg = function(o) {
        return function() {
          return o;
        };
      }, _g = Ue ? function(o, e) {
        return Ue(o, "toString", { configurable: !0, enumerable: !1, value: bg(e), writable: !0 });
      } : rc, wg = 800, yg = 16, kg = Date.now, xg = function(o) {
        var e = 0, t = 0;
        return function() {
          var n = kg(), i = yg - (n - t);
          if (t = n, i > 0) {
            if (++e >= wg)
              return arguments[0];
          } else
            e = 0;
          return o.apply(void 0, arguments);
        };
      }(_g), Sg = function(o, e) {
        return xg(vg(o, e, rc), o + "");
      }, Cg = function(o, e, t) {
        if (!te(t))
          return !1;
        var n = typeof e;
        return !!(n == "number" ? hs(t) && El(e, t.length) : n == "string" && e in t) && B(t[e], o);
      }, Ri = function(o) {
        return Sg(function(e, t) {
          var n = -1, i = t.length, s = i > 1 ? t[i - 1] : void 0, l = i > 2 ? t[2] : void 0;
          for (s = o.length > 3 && typeof s == "function" ? (i--, s) : void 0, l && Cg(t[0], t[1], l) && (s = i < 3 ? void 0 : s, i = 1), e = Object(e); ++n < i; ) {
            var d = t[n];
            d && o(e, d, n, s);
          }
          return e;
        });
      }(function(o, e) {
        zt(e, ps(e), o);
      });
      const Zr = Symbol("observableProperties"), Kr = Symbol("boundObservables"), Xr = Symbol("boundProperties"), sc = { set(o, e) {
        if (te(o))
          return void Object.keys(o).forEach((n) => {
            this.set(n, o[n]);
          }, this);
        ac(this);
        const t = this[Zr];
        if (o in this && !t.has(o))
          throw new V.b("observable-set-cannot-override: Cannot override an existing property.", this);
        Object.defineProperty(this, o, { enumerable: !0, configurable: !0, get: () => t.get(o), set(n) {
          const i = t.get(o);
          let s = this.fire("set:" + o, o, n, i);
          s === void 0 && (s = n), i === s && t.has(o) || (t.set(o, s), this.fire("change:" + o, o, s, i));
        } }), this[o] = e;
      }, bind(...o) {
        if (!o.length || !lc(o))
          throw new V.b("observable-bind-wrong-properties: All properties must be strings.", this);
        if (new Set(o).size !== o.length)
          throw new V.b("observable-bind-duplicate-properties: Properties must be unique.", this);
        ac(this);
        const e = this[Xr];
        o.forEach((n) => {
          if (e.has(n))
            throw new V.b("observable-bind-rebind: Cannot bind the same property more that once.", this);
        });
        const t = /* @__PURE__ */ new Map();
        return o.forEach((n) => {
          const i = { property: n, to: [] };
          e.set(n, i), t.set(n, i);
        }), { to: Ag, toMany: Tg, _observable: this, _bindProperties: o, _to: [], _bindings: t };
      }, unbind(...o) {
        if (!(Zr in this))
          return;
        const e = this[Xr], t = this[Kr];
        if (o.length) {
          if (!lc(o))
            throw new V.b("observable-unbind-wrong-properties: Properties must be strings.", this);
          o.forEach((n) => {
            const i = e.get(n);
            if (!i)
              return;
            let s, l, d, f;
            i.to.forEach((m) => {
              s = m[0], l = m[1], d = t.get(s), (f = d[l]).delete(i), f.size || delete d[l], Object.keys(d).length || (t.delete(s), this.stopListening(s, "change"));
            }), e.delete(n);
          });
        } else
          t.forEach((n, i) => {
            this.stopListening(i, "change");
          }), t.clear(), e.clear();
      }, decorate(o) {
        const e = this[o];
        if (!e)
          throw new V.b("observablemixin-cannot-decorate-undefined: Cannot decorate an undefined method.", this, { object: this, methodName: o });
        this.on(o, (t, n) => {
          t.return = e.apply(this, n);
        }), this[o] = function(...t) {
          return this.fire(o, t);
        };
      } };
      Ri(sc, dt);
      var xt = sc;
      function ac(o) {
        Zr in o || (Object.defineProperty(o, Zr, { value: /* @__PURE__ */ new Map() }), Object.defineProperty(o, Kr, { value: /* @__PURE__ */ new Map() }), Object.defineProperty(o, Xr, { value: /* @__PURE__ */ new Map() }));
      }
      function Ag(...o) {
        const e = function(...i) {
          if (!i.length)
            throw new V.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
          const s = { to: [] };
          let l;
          return typeof i[i.length - 1] == "function" && (s.callback = i.pop()), i.forEach((d) => {
            if (typeof d == "string")
              l.properties.push(d);
            else {
              if (typeof d != "object")
                throw new V.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
              l = { observable: d, properties: [] }, s.to.push(l);
            }
          }), s;
        }(...o), t = Array.from(this._bindings.keys()), n = t.length;
        if (!e.callback && e.to.length > 1)
          throw new V.b("observable-bind-to-no-callback: Binding multiple observables only possible with callback.", this);
        if (n > 1 && e.callback)
          throw new V.b("observable-bind-to-extra-callback: Cannot bind multiple properties and use a callback in one binding.", this);
        e.to.forEach((i) => {
          if (i.properties.length && i.properties.length !== n)
            throw new V.b("observable-bind-to-properties-length: The number of properties must match.", this);
          i.properties.length || (i.properties = this._bindProperties);
        }), this._to = e.to, e.callback && (this._bindings.get(t[0]).callback = e.callback), function(i, s) {
          s.forEach((l) => {
            const d = i[Kr];
            let f;
            d.get(l.observable) || i.listenTo(l.observable, "change", (m, g) => {
              (f = d.get(l.observable)[g]) && f.forEach((b) => {
                cc(i, b.property);
              });
            });
          });
        }(this._observable, this._to), function(i) {
          let s;
          i._bindings.forEach((l, d) => {
            i._to.forEach((f) => {
              s = f.properties[l.callback ? 0 : i._bindProperties.indexOf(d)], l.to.push([f.observable, s]), function(m, g, b, y) {
                const C = m[Kr], O = C.get(b), D = O || {};
                D[y] || (D[y] = /* @__PURE__ */ new Set()), D[y].add(g), O || C.set(b, D);
              }(i._observable, l, f.observable, s);
            });
          });
        }(this), this._bindProperties.forEach((i) => {
          cc(this._observable, i);
        });
      }
      function Tg(o, e, t) {
        if (this._bindings.size > 1)
          throw new V.b("observable-bind-to-many-not-one-binding: Cannot bind multiple properties with toMany().", this);
        this.to(...function(n, i) {
          const s = n.map((l) => [l, i]);
          return Array.prototype.concat.apply([], s);
        }(o, e), t);
      }
      function lc(o) {
        return o.every((e) => typeof e == "string");
      }
      function cc(o, e) {
        const t = o[Xr].get(e);
        let n;
        n = t.callback ? t.callback.apply(o, t.to.map((i) => i[0][i[1]])) : (n = t.to[0])[0][n[1]], o.hasOwnProperty(e) ? o[e] = n : o.set(e, n);
      }
      const Is = Symbol("document");
      class Qr extends Gr {
        constructor(e, t, n) {
          super(e, t, n), this.set("isReadOnly", !1), this.set("isFocused", !1);
        }
        is(e, t = null) {
          const n = e && e.replace(/^view:/, "");
          return t ? n == "editableElement" && t == this.name || super.is(e, t) : n == "editableElement" || super.is(e);
        }
        destroy() {
          this.stopListening();
        }
        get document() {
          return this.getCustomProperty(Is);
        }
        set _document(e) {
          if (this.getCustomProperty(Is))
            throw new V.b("view-editableelement-document-already-set: View document is already set.", this);
          this._setCustomProperty(Is, e), this.bind("isReadOnly").to(e), this.bind("isFocused").to(e, "isFocused", (t) => t && e.selection.editableElement == this), this.listenTo(e.selection, "change", () => {
            this.isFocused = e.isFocused && e.selection.editableElement == this;
          });
        }
      }
      $e(Qr, xt);
      const uc = Symbol("rootName");
      class Ig extends Qr {
        constructor(e) {
          super(e), this.rootName = "main";
        }
        is(e, t = null) {
          const n = e.replace(/^view:/, "");
          return t ? n == "rootElement" && t == this.name || super.is(e, t) : n == "rootElement" || super.is(e);
        }
        get rootName() {
          return this.getCustomProperty(uc);
        }
        set rootName(e) {
          this._setCustomProperty(uc, e);
        }
        set _name(e) {
          this.name = e;
        }
      }
      class wi {
        constructor(e = {}) {
          if (!e.boundaries && !e.startPosition)
            throw new V.b("view-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
          if (e.direction && e.direction != "forward" && e.direction != "backward")
            throw new V.b("view-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", e.startPosition, { direction: e.direction });
          this.boundaries = e.boundaries || null, e.startPosition ? this.position = be._createAt(e.startPosition) : this.position = be._createAt(e.boundaries[e.direction == "backward" ? "end" : "start"]), this.direction = e.direction || "forward", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
        }
        [Symbol.iterator]() {
          return this;
        }
        skip(e) {
          let t, n, i;
          do
            i = this.position, { done: t, value: n } = this.next();
          while (!t && e(n));
          t || (this.position = i);
        }
        next() {
          return this.direction == "forward" ? this._next() : this._previous();
        }
        _next() {
          let e = this.position.clone();
          const t = this.position, n = e.parent;
          if (n.parent === null && e.offset === n.childCount)
            return { done: !0 };
          if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset)
            return { done: !0 };
          let i;
          if (n instanceof rt) {
            if (e.isAtEnd)
              return this.position = be._createAfter(n), this._next();
            i = n.data[e.offset];
          } else
            i = n.getChild(e.offset);
          if (i instanceof tn)
            return this.shallow ? e.offset++ : e = new be(i, 0), this.position = e, this._formatReturnValue("elementStart", i, t, e, 1);
          if (i instanceof rt) {
            if (this.singleCharacters)
              return e = new be(i, 0), this.position = e, this._next();
            {
              let s, l = i.data.length;
              return i == this._boundaryEndParent ? (l = this.boundaries.end.offset, s = new Un(i, 0, l), e = be._createAfter(s)) : (s = new Un(i, 0, i.data.length), e.offset++), this.position = e, this._formatReturnValue("text", s, t, e, l);
            }
          }
          if (typeof i == "string") {
            let s;
            this.singleCharacters ? s = 1 : s = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - e.offset;
            const l = new Un(n, e.offset, s);
            return e.offset += s, this.position = e, this._formatReturnValue("text", l, t, e, s);
          }
          return e = be._createAfter(n), this.position = e, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, t, e);
        }
        _previous() {
          let e = this.position.clone();
          const t = this.position, n = e.parent;
          if (n.parent === null && e.offset === 0)
            return { done: !0 };
          if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset)
            return { done: !0 };
          let i;
          if (n instanceof rt) {
            if (e.isAtStart)
              return this.position = be._createBefore(n), this._previous();
            i = n.data[e.offset - 1];
          } else
            i = n.getChild(e.offset - 1);
          if (i instanceof tn)
            return this.shallow ? (e.offset--, this.position = e, this._formatReturnValue("elementStart", i, t, e, 1)) : (e = new be(i, i.childCount), this.position = e, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", i, t, e));
          if (i instanceof rt) {
            if (this.singleCharacters)
              return e = new be(i, i.data.length), this.position = e, this._previous();
            {
              let s, l = i.data.length;
              if (i == this._boundaryStartParent) {
                const d = this.boundaries.start.offset;
                l = (s = new Un(i, d, i.data.length - d)).data.length, e = be._createBefore(s);
              } else
                s = new Un(i, 0, i.data.length), e.offset--;
              return this.position = e, this._formatReturnValue("text", s, t, e, l);
            }
          }
          if (typeof i == "string") {
            let s;
            if (this.singleCharacters)
              s = 1;
            else {
              const d = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
              s = e.offset - d;
            }
            e.offset -= s;
            const l = new Un(n, e.offset, s);
            return this.position = e, this._formatReturnValue("text", l, t, e, s);
          }
          return e = be._createBefore(n), this.position = e, this._formatReturnValue("elementStart", n, t, e, 1);
        }
        _formatReturnValue(e, t, n, i, s) {
          return t instanceof Un && (t.offsetInText + t.data.length == t.textNode.data.length && (this.direction != "forward" || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = be._createAfter(t.textNode) : (i = be._createAfter(t.textNode), this.position = i)), t.offsetInText === 0 && (this.direction != "backward" || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = be._createBefore(t.textNode) : (i = be._createBefore(t.textNode), this.position = i))), { done: !1, value: { type: e, item: t, previousPosition: n, nextPosition: i, length: s } };
        }
      }
      class be {
        constructor(e, t) {
          this.parent = e, this.offset = t;
        }
        get nodeAfter() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset) || null;
        }
        get nodeBefore() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset - 1) || null;
        }
        get isAtStart() {
          return this.offset === 0;
        }
        get isAtEnd() {
          const e = this.parent.is("text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === e;
        }
        get root() {
          return this.parent.root;
        }
        get editableElement() {
          let e = this.parent;
          for (; !(e instanceof Qr); ) {
            if (!e.parent)
              return null;
            e = e.parent;
          }
          return e;
        }
        getShiftedBy(e) {
          const t = be._createAt(this), n = t.offset + e;
          return t.offset = n < 0 ? 0 : n, t;
        }
        getLastMatchingPosition(e, t = {}) {
          t.startPosition = this;
          const n = new wi(t);
          return n.skip(e), n.position;
        }
        getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({ includeSelf: !0 });
        }
        getCommonAncestor(e) {
          const t = this.getAncestors(), n = e.getAncestors();
          let i = 0;
          for (; t[i] == n[i] && t[i]; )
            i++;
          return i === 0 ? null : t[i - 1];
        }
        is(e) {
          return e == "position" || e == "view:position";
        }
        isEqual(e) {
          return this.parent == e.parent && this.offset == e.offset;
        }
        isBefore(e) {
          return this.compareWith(e) == "before";
        }
        isAfter(e) {
          return this.compareWith(e) == "after";
        }
        compareWith(e) {
          if (this.root !== e.root)
            return "different";
          if (this.isEqual(e))
            return "same";
          const t = this.parent.is("node") ? this.parent.getPath() : [], n = e.parent.is("node") ? e.parent.getPath() : [];
          t.push(this.offset), n.push(e.offset);
          const i = Kt(t, n);
          switch (i) {
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return t[i] < n[i] ? "before" : "after";
          }
        }
        getWalker(e = {}) {
          return e.startPosition = this, new wi(e);
        }
        clone() {
          return new be(this.parent, this.offset);
        }
        static _createAt(e, t) {
          if (e instanceof be)
            return new this(e.parent, e.offset);
          {
            const n = e;
            if (t == "end")
              t = n.is("text") ? n.data.length : n.childCount;
            else {
              if (t == "before")
                return this._createBefore(n);
              if (t == "after")
                return this._createAfter(n);
              if (t !== 0 && !t)
                throw new V.b("view-createPositionAt-offset-required: View#createPositionAt() requires the offset when the first parameter is a view item.", n);
            }
            return new be(n, t);
          }
        }
        static _createAfter(e) {
          if (e.is("textProxy"))
            return new be(e.textNode, e.offsetInText + e.data.length);
          if (!e.parent)
            throw new V.b("view-position-after-root: You can not make position after root.", e, { root: e });
          return new be(e.parent, e.index + 1);
        }
        static _createBefore(e) {
          if (e.is("textProxy"))
            return new be(e.textNode, e.offsetInText);
          if (!e.parent)
            throw new V.b("view-position-before-root: You can not make position before root.", e, { root: e });
          return new be(e.parent, e.index);
        }
      }
      class ze {
        constructor(e, t = null) {
          this.start = e.clone(), this.end = t ? t.clone() : e.clone();
        }
        *[Symbol.iterator]() {
          yield* new wi({ boundaries: this, ignoreElementEnd: !0 });
        }
        get isCollapsed() {
          return this.start.isEqual(this.end);
        }
        get isFlat() {
          return this.start.parent === this.end.parent;
        }
        get root() {
          return this.start.root;
        }
        getEnlarged() {
          let e = this.start.getLastMatchingPosition(Jr, { direction: "backward" }), t = this.end.getLastMatchingPosition(Jr);
          return e.parent.is("text") && e.isAtStart && (e = be._createBefore(e.parent)), t.parent.is("text") && t.isAtEnd && (t = be._createAfter(t.parent)), new ze(e, t);
        }
        getTrimmed() {
          let e = this.start.getLastMatchingPosition(Jr);
          if (e.isAfter(this.end) || e.isEqual(this.end))
            return new ze(e, e);
          let t = this.end.getLastMatchingPosition(Jr, { direction: "backward" });
          const n = e.nodeAfter, i = t.nodeBefore;
          return n && n.is("text") && (e = new be(n, 0)), i && i.is("text") && (t = new be(i, i.data.length)), new ze(e, t);
        }
        isEqual(e) {
          return this == e || this.start.isEqual(e.start) && this.end.isEqual(e.end);
        }
        containsPosition(e) {
          return e.isAfter(this.start) && e.isBefore(this.end);
        }
        containsRange(e, t = !1) {
          e.isCollapsed && (t = !1);
          const n = this.containsPosition(e.start) || t && this.start.isEqual(e.start), i = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
          return n && i;
        }
        getDifference(e) {
          const t = [];
          return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new ze(this.start, e.start)), this.containsPosition(e.end) && t.push(new ze(e.end, this.end))) : t.push(this.clone()), t;
        }
        getIntersection(e) {
          if (this.isIntersecting(e)) {
            let t = this.start, n = this.end;
            return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new ze(t, n);
          }
          return null;
        }
        getWalker(e = {}) {
          return e.boundaries = this, new wi(e);
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
        clone() {
          return new ze(this.start, this.end);
        }
        *getItems(e = {}) {
          e.boundaries = this, e.ignoreElementEnd = !0;
          const t = new wi(e);
          for (const n of t)
            yield n.item;
        }
        *getPositions(e = {}) {
          e.boundaries = this;
          const t = new wi(e);
          yield t.position;
          for (const n of t)
            yield n.nextPosition;
        }
        is(e) {
          return e == "range" || e == "view:range";
        }
        isIntersecting(e) {
          return this.start.isBefore(e.end) && this.end.isAfter(e.start);
        }
        static _createFromParentsAndOffsets(e, t, n, i) {
          return new this(new be(e, t), new be(n, i));
        }
        static _createFromPositionAndShift(e, t) {
          const n = e, i = e.getShiftedBy(t);
          return t > 0 ? new this(n, i) : new this(i, n);
        }
        static _createIn(e) {
          return this._createFromParentsAndOffsets(e, 0, e, e.childCount);
        }
        static _createOn(e) {
          const t = e.is("textProxy") ? e.offsetSize : 1;
          return this._createFromPositionAndShift(be._createBefore(e), t);
        }
      }
      function Jr(o) {
        return !(!o.item.is("attributeElement") && !o.item.is("uiElement"));
      }
      function Es(o) {
        let e = 0;
        for (const t of o)
          e++;
        return e;
      }
      class bn {
        constructor(e = null, t, n) {
          this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(e, t, n);
        }
        get isFake() {
          return this._isFake;
        }
        get fakeSelectionLabel() {
          return this._fakeSelectionLabel;
        }
        get anchor() {
          if (!this._ranges.length)
            return null;
          const e = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? e.end : e.start).clone();
        }
        get focus() {
          if (!this._ranges.length)
            return null;
          const e = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? e.start : e.end).clone();
        }
        get isCollapsed() {
          return this.rangeCount === 1 && this._ranges[0].isCollapsed;
        }
        get rangeCount() {
          return this._ranges.length;
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
        get editableElement() {
          return this.anchor ? this.anchor.editableElement : null;
        }
        *getRanges() {
          for (const e of this._ranges)
            yield e.clone();
        }
        getFirstRange() {
          let e = null;
          for (const t of this._ranges)
            e && !t.start.isBefore(e.start) || (e = t);
          return e ? e.clone() : null;
        }
        getLastRange() {
          let e = null;
          for (const t of this._ranges)
            e && !t.end.isAfter(e.end) || (e = t);
          return e ? e.clone() : null;
        }
        getFirstPosition() {
          const e = this.getFirstRange();
          return e ? e.start.clone() : null;
        }
        getLastPosition() {
          const e = this.getLastRange();
          return e ? e.end.clone() : null;
        }
        isEqual(e) {
          if (this.isFake != e.isFake || this.isFake && this.fakeSelectionLabel != e.fakeSelectionLabel || this.rangeCount != e.rangeCount)
            return !1;
          if (this.rangeCount === 0)
            return !0;
          if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus))
            return !1;
          for (const t of this._ranges) {
            let n = !1;
            for (const i of e._ranges)
              if (t.isEqual(i)) {
                n = !0;
                break;
              }
            if (!n)
              return !1;
          }
          return !0;
        }
        isSimilar(e) {
          if (this.isBackward != e.isBackward)
            return !1;
          const t = Es(this.getRanges());
          if (t != Es(e.getRanges()))
            return !1;
          if (t == 0)
            return !0;
          for (let n of this.getRanges()) {
            n = n.getTrimmed();
            let i = !1;
            for (let s of e.getRanges())
              if (s = s.getTrimmed(), n.start.isEqual(s.start) && n.end.isEqual(s.end)) {
                i = !0;
                break;
              }
            if (!i)
              return !1;
          }
          return !0;
        }
        getSelectedElement() {
          if (this.rangeCount !== 1)
            return null;
          const e = this.getFirstRange();
          let t = e.start.nodeAfter, n = e.end.nodeBefore;
          return e.start.parent.is("text") && e.start.isAtEnd && e.start.parent.nextSibling && (t = e.start.parent.nextSibling), e.end.parent.is("text") && e.end.isAtStart && e.end.parent.previousSibling && (n = e.end.parent.previousSibling), t instanceof tn && t == n ? t : null;
        }
        setTo(e, t, n) {
          if (e === null)
            this._setRanges([]), this._setFakeOptions(t);
          else if (e instanceof bn || e instanceof Ps)
            this._setRanges(e.getRanges(), e.isBackward), this._setFakeOptions({ fake: e.isFake, label: e.fakeSelectionLabel });
          else if (e instanceof ze)
            this._setRanges([e], t && t.backward), this._setFakeOptions(t);
          else if (e instanceof be)
            this._setRanges([new ze(e)]), this._setFakeOptions(t);
          else if (e instanceof ri) {
            const i = !!n && !!n.backward;
            let s;
            if (t === void 0)
              throw new V.b("view-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", this);
            s = t == "in" ? ze._createIn(e) : t == "on" ? ze._createOn(e) : new ze(be._createAt(e, t)), this._setRanges([s], i), this._setFakeOptions(n);
          } else {
            if (!Hn(e))
              throw new V.b("view-selection-setTo-not-selectable: Cannot set selection to given place.", this);
            this._setRanges(e, t && t.backward), this._setFakeOptions(t);
          }
          this.fire("change");
        }
        setFocus(e, t) {
          if (this.anchor === null)
            throw new V.b("view-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", this);
          const n = be._createAt(e, t);
          if (n.compareWith(this.focus) == "same")
            return;
          const i = this.anchor;
          this._ranges.pop(), n.compareWith(i) == "before" ? this._addRange(new ze(n, i), !0) : this._addRange(new ze(i, n)), this.fire("change");
        }
        is(e) {
          return e == "selection" || e == "view:selection";
        }
        _setRanges(e, t = !1) {
          e = Array.from(e), this._ranges = [];
          for (const n of e)
            this._addRange(n);
          this._lastRangeBackward = !!t;
        }
        _setFakeOptions(e = {}) {
          this._isFake = !!e.fake, this._fakeSelectionLabel = e.fake && e.label || "";
        }
        _addRange(e, t = !1) {
          if (!(e instanceof ze))
            throw new V.b("view-selection-add-range-not-range: Selection range set to an object that is not an instance of view.Range", this);
          this._pushRange(e), this._lastRangeBackward = !!t;
        }
        _pushRange(e) {
          for (const t of this._ranges)
            if (e.isIntersecting(t))
              throw new V.b("view-selection-range-intersects: Trying to add a range that intersects with another range from selection.", this, { addedRange: e, intersectingRange: t });
          this._ranges.push(new ze(e.start, e.end));
        }
      }
      $e(bn, dt);
      class Ps {
        constructor(e = null, t, n) {
          this._selection = new bn(), this._selection.delegate("change").to(this), this._selection.setTo(e, t, n);
        }
        get isFake() {
          return this._selection.isFake;
        }
        get fakeSelectionLabel() {
          return this._selection.fakeSelectionLabel;
        }
        get anchor() {
          return this._selection.anchor;
        }
        get focus() {
          return this._selection.focus;
        }
        get isCollapsed() {
          return this._selection.isCollapsed;
        }
        get rangeCount() {
          return this._selection.rangeCount;
        }
        get isBackward() {
          return this._selection.isBackward;
        }
        get editableElement() {
          return this._selection.editableElement;
        }
        get _ranges() {
          return this._selection._ranges;
        }
        *getRanges() {
          yield* this._selection.getRanges();
        }
        getFirstRange() {
          return this._selection.getFirstRange();
        }
        getLastRange() {
          return this._selection.getLastRange();
        }
        getFirstPosition() {
          return this._selection.getFirstPosition();
        }
        getLastPosition() {
          return this._selection.getLastPosition();
        }
        getSelectedElement() {
          return this._selection.getSelectedElement();
        }
        isEqual(e) {
          return this._selection.isEqual(e);
        }
        isSimilar(e) {
          return this._selection.isSimilar(e);
        }
        is(e) {
          return e == "selection" || e == "documentSelection" || e == "view:selection" || e == "view:documentSelection";
        }
        _setTo(e, t, n) {
          this._selection.setTo(e, t, n);
        }
        _setFocus(e, t) {
          this._selection.setFocus(e, t);
        }
      }
      $e(Ps, dt);
      class _n {
        constructor(e = {}) {
          this._items = [], this._itemMap = /* @__PURE__ */ new Map(), this._idProperty = e.idProperty || "id", this._bindToExternalToInternalMap = /* @__PURE__ */ new WeakMap(), this._bindToInternalToExternalMap = /* @__PURE__ */ new WeakMap(), this._skippedIndexesFromExternal = [];
        }
        get length() {
          return this._items.length;
        }
        get first() {
          return this._items[0] || null;
        }
        get last() {
          return this._items[this.length - 1] || null;
        }
        add(e, t) {
          let n;
          const i = this._idProperty;
          if (i in e) {
            if (typeof (n = e[i]) != "string")
              throw new V.b("collection-add-invalid-id", this);
            if (this.get(n))
              throw new V.b("collection-add-item-already-exists", this);
          } else
            e[i] = n = Vn();
          if (t === void 0)
            t = this._items.length;
          else if (t > this._items.length || t < 0)
            throw new V.b("collection-add-item-invalid-index", this);
          return this._items.splice(t, 0, e), this._itemMap.set(n, e), this.fire("add", e, t), this;
        }
        get(e) {
          let t;
          if (typeof e == "string")
            t = this._itemMap.get(e);
          else {
            if (typeof e != "number")
              throw new V.b("collection-get-invalid-arg: Index or id must be given.", this);
            t = this._items[e];
          }
          return t || null;
        }
        has(e) {
          if (typeof e == "string")
            return this._itemMap.has(e);
          {
            const t = e[this._idProperty];
            return this._itemMap.has(t);
          }
        }
        getIndex(e) {
          let t;
          return t = typeof e == "string" ? this._itemMap.get(e) : e, this._items.indexOf(t);
        }
        remove(e) {
          let t, n, i, s = !1;
          const l = this._idProperty;
          if (typeof e == "string" ? (n = e, s = !(i = this._itemMap.get(n)), i && (t = this._items.indexOf(i))) : typeof e == "number" ? (t = e, s = !(i = this._items[t]), i && (n = i[l])) : (n = (i = e)[l], s = (t = this._items.indexOf(i)) == -1 || !this._itemMap.get(n)), s)
            throw new V.b("collection-remove-404: Item not found.", this);
          this._items.splice(t, 1), this._itemMap.delete(n);
          const d = this._bindToInternalToExternalMap.get(i);
          return this._bindToInternalToExternalMap.delete(i), this._bindToExternalToInternalMap.delete(d), this.fire("remove", i, t), i;
        }
        map(e, t) {
          return this._items.map(e, t);
        }
        find(e, t) {
          return this._items.find(e, t);
        }
        filter(e, t) {
          return this._items.filter(e, t);
        }
        clear() {
          for (this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null); this.length; )
            this.remove(0);
        }
        bindTo(e) {
          if (this._bindToCollection)
            throw new V.b("collection-bind-to-rebind: The collection cannot be bound more than once.", this);
          return this._bindToCollection = e, { as: (t) => {
            this._setUpBindToBinding((n) => new t(n));
          }, using: (t) => {
            typeof t == "function" ? this._setUpBindToBinding((n) => t(n)) : this._setUpBindToBinding((n) => n[t]);
          } };
        }
        _setUpBindToBinding(e) {
          const t = this._bindToCollection, n = (i, s, l) => {
            const d = t._bindToCollection == this, f = t._bindToInternalToExternalMap.get(s);
            if (d && f)
              this._bindToExternalToInternalMap.set(s, f), this._bindToInternalToExternalMap.set(f, s);
            else {
              const m = e(s);
              if (!m)
                return void this._skippedIndexesFromExternal.push(l);
              let g = l;
              for (const b of this._skippedIndexesFromExternal)
                l > b && g--;
              for (const b of t._skippedIndexesFromExternal)
                g >= b && g++;
              this._bindToExternalToInternalMap.set(s, m), this._bindToInternalToExternalMap.set(m, s), this.add(m, g);
              for (let b = 0; b < t._skippedIndexesFromExternal.length; b++)
                g <= t._skippedIndexesFromExternal[b] && t._skippedIndexesFromExternal[b]++;
            }
          };
          for (const i of t)
            n(0, i, t.getIndex(i));
          this.listenTo(t, "add", n), this.listenTo(t, "remove", (i, s, l) => {
            const d = this._bindToExternalToInternalMap.get(s);
            d && this.remove(d), this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((f, m) => (l < m && f.push(m - 1), l > m && f.push(m), f), []);
          });
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]();
        }
      }
      $e(_n, dt);
      class Ms {
        constructor() {
          this.selection = new Ps(), this.roots = new _n({ idProperty: "rootName" }), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isComposing", !1), this._postFixers = /* @__PURE__ */ new Set();
        }
        getRoot(e = "main") {
          return this.roots.get(e);
        }
        registerPostFixer(e) {
          this._postFixers.add(e);
        }
        destroy() {
          this.roots.map((e) => e.destroy()), this.stopListening();
        }
        _callPostFixers(e) {
          let t = !1;
          do
            for (const n of this._postFixers)
              if (t = n(e))
                break;
          while (t);
        }
      }
      $e(Ms, xt);
      const dc = 10;
      class yi extends tn {
        constructor(e, t, n) {
          super(e, t, n), this.getFillerOffset = Eg, this._priority = dc, this._id = null, this._clonesGroup = null;
        }
        get priority() {
          return this._priority;
        }
        get id() {
          return this._id;
        }
        getElementsWithSameId() {
          if (this.id === null)
            throw new V.b("attribute-element-get-elements-with-same-id-no-id: Cannot get elements with the same id for an attribute element without id.", this);
          return new Set(this._clonesGroup);
        }
        is(e, t = null) {
          const n = e && e.replace(/^view:/, "");
          return t ? n == "attributeElement" && t == this.name || super.is(e, t) : n == "attributeElement" || super.is(e);
        }
        isSimilar(e) {
          return this.id !== null || e.id !== null ? this.id === e.id : super.isSimilar(e) && this.priority == e.priority;
        }
        _clone(e) {
          const t = super._clone(e);
          return t._priority = this._priority, t._id = this._id, t;
        }
      }
      function Eg() {
        if (Os(this))
          return null;
        let o = this.parent;
        for (; o && o.is("attributeElement"); ) {
          if (Os(o) > 1)
            return null;
          o = o.parent;
        }
        return !o || Os(o) > 1 ? null : this.childCount;
      }
      function Os(o) {
        return Array.from(o.getChildren()).filter((e) => !e.is("uiElement")).length;
      }
      yi.DEFAULT_PRIORITY = dc;
      class hc extends tn {
        constructor(e, t, n) {
          super(e, t, n), this.getFillerOffset = Pg;
        }
        is(e, t = null) {
          const n = e.replace(/^view:/, "");
          return t ? n == "emptyElement" && t == this.name || super.is(e, t) : n == "emptyElement" || super.is(e);
        }
        _insertChild(e, t) {
          if (t && (t instanceof ri || Array.from(t).length > 0))
            throw new V.b("view-emptyelement-cannot-add: Cannot add child nodes to EmptyElement instance.", [this, t]);
        }
      }
      function Pg() {
        return null;
      }
      const ar = navigator.userAgent.toLowerCase();
      var un = { isMac: function(o) {
        return o.indexOf("macintosh") > -1;
      }(ar), isEdge: function(o) {
        return !!o.match(/edge\/(\d+.?\d*)/);
      }(ar), isGecko: function(o) {
        return !!o.match(/gecko\/\d+/);
      }(ar), isSafari: function(o) {
        return o.indexOf(" applewebkit/") > -1 && o.indexOf("chrome") === -1;
      }(ar), isAndroid: function(o) {
        return o.indexOf("android") > -1;
      }(ar), features: { isRegExpUnicodePropertySupported: function() {
        let o = !1;
        try {
          o = "\u0107".search(new RegExp("[\\p{L}]", "u")) === 0;
        } catch {
        }
        return o;
      }() } };
      const Mg = { "\u2318": "ctrl", "\u21E7": "shift", "\u2325": "alt" }, Og = { ctrl: "\u2318", shift: "\u21E7", alt: "\u2325" }, tt = function() {
        const o = { arrowleft: 37, arrowup: 38, arrowright: 39, arrowdown: 40, backspace: 8, delete: 46, enter: 13, space: 32, esc: 27, tab: 9, ctrl: 1114112, cmd: 1114112, shift: 2228224, alt: 4456448 };
        for (let e = 65; e <= 90; e++) {
          const t = String.fromCharCode(e);
          o[t.toLowerCase()] = e;
        }
        for (let e = 48; e <= 57; e++)
          o[e - 48] = e;
        for (let e = 112; e <= 123; e++)
          o["f" + (e - 111)] = e;
        return o;
      }();
      function Yn(o) {
        let e;
        if (typeof o == "string") {
          if (!(e = tt[o.toLowerCase()]))
            throw new V.b("keyboard-unknown-key: Unknown key name.", null, { key: o });
        } else
          e = o.keyCode + (o.altKey ? tt.alt : 0) + (o.ctrlKey ? tt.ctrl : 0) + (o.shiftKey ? tt.shift : 0);
        return e;
      }
      function fc(o) {
        return typeof o == "string" && (o = pc(o)), o.map((e) => typeof e == "string" ? Yn(e) : e).reduce((e, t) => t + e, 0);
      }
      function pc(o) {
        return o.split(/\s*\+\s*/);
      }
      class mc extends tn {
        constructor(e, t, n) {
          super(e, t, n), this.getFillerOffset = Ng;
        }
        is(e, t = null) {
          const n = e.replace(/^view:/, "");
          return t ? n == "uiElement" && t == this.name || super.is(e, t) : n == "uiElement" || super.is(e);
        }
        _insertChild(e, t) {
          if (t && (t instanceof ri || Array.from(t).length > 0))
            throw new V.b("view-uielement-cannot-add: Cannot add child nodes to UIElement instance.", this);
        }
        render(e) {
          return this.toDomElement(e);
        }
        toDomElement(e) {
          const t = e.createElement(this.name);
          for (const n of this.getAttributeKeys())
            t.setAttribute(n, this.getAttribute(n));
          return t;
        }
      }
      function Dg(o) {
        o.document.on("keydown", (e, t) => function(n, i, s) {
          if (i.keyCode == tt.arrowright) {
            const l = i.domTarget.ownerDocument.defaultView.getSelection(), d = l.rangeCount == 1 && l.getRangeAt(0).collapsed;
            if (d || i.shiftKey) {
              const f = l.focusNode, m = l.focusOffset, g = s.domPositionToView(f, m);
              if (g === null)
                return;
              let b = !1;
              const y = g.getLastMatchingPosition((C) => (C.item.is("uiElement") && (b = !0), !(!C.item.is("uiElement") && !C.item.is("attributeElement"))));
              if (b) {
                const C = s.viewPositionToDom(y);
                d ? l.collapse(C.parent, C.offset) : l.extend(C.parent, C.offset);
              }
            }
          }
        }(0, t, o.domConverter));
      }
      function Ng() {
        return null;
      }
      class Li {
        constructor(e) {
          this._children = [], e && this._insertChild(0, e);
        }
        [Symbol.iterator]() {
          return this._children[Symbol.iterator]();
        }
        get childCount() {
          return this._children.length;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        get root() {
          return this;
        }
        get parent() {
          return null;
        }
        is(e) {
          return e == "documentFragment" || e == "view:documentFragment";
        }
        _appendChild(e) {
          return this._insertChild(this.childCount, e);
        }
        getChild(e) {
          return this._children[e];
        }
        getChildIndex(e) {
          return this._children.indexOf(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        _insertChild(e, t) {
          this._fireChange("children", this);
          let n = 0;
          const i = function(s) {
            return typeof s == "string" ? [new rt(s)] : (Hn(s) || (s = [s]), Array.from(s).map((l) => typeof l == "string" ? new rt(l) : l instanceof Un ? new rt(l.data) : l));
          }(t);
          for (const s of i)
            s.parent !== null && s._remove(), s.parent = this, this._children.splice(e, 0, s), e++, n++;
          return n;
        }
        _removeChildren(e, t = 1) {
          this._fireChange("children", this);
          for (let n = e; n < e + t; n++)
            this._children[n].parent = null;
          return this._children.splice(e, t);
        }
        _fireChange(e, t) {
          this.fire("change:" + e, t);
        }
      }
      $e(Li, dt);
      class gc {
        constructor(e) {
          this.document = e, this._cloneGroups = /* @__PURE__ */ new Map();
        }
        setSelection(e, t, n) {
          this.document.selection._setTo(e, t, n);
        }
        setSelectionFocus(e, t) {
          this.document.selection._setFocus(e, t);
        }
        createText(e) {
          return new rt(e);
        }
        createAttributeElement(e, t, n = {}) {
          const i = new yi(e, t);
          return n.priority && (i._priority = n.priority), n.id && (i._id = n.id), i;
        }
        createContainerElement(e, t) {
          return new Gr(e, t);
        }
        createEditableElement(e, t) {
          const n = new Qr(e, t);
          return n._document = this.document, n;
        }
        createEmptyElement(e, t) {
          return new hc(e, t);
        }
        createUIElement(e, t, n) {
          const i = new mc(e, t);
          return n && (i.render = n), i;
        }
        setAttribute(e, t, n) {
          n._setAttribute(e, t);
        }
        removeAttribute(e, t) {
          t._removeAttribute(e);
        }
        addClass(e, t) {
          t._addClass(e);
        }
        removeClass(e, t) {
          t._removeClass(e);
        }
        setStyle(e, t, n) {
          _(e) && n === void 0 && (n = t), n._setStyle(e, t);
        }
        removeStyle(e, t) {
          t._removeStyle(e);
        }
        setCustomProperty(e, t, n) {
          n._setCustomProperty(e, t);
        }
        removeCustomProperty(e, t) {
          return t._removeCustomProperty(e);
        }
        breakAttributes(e) {
          return e instanceof be ? this._breakAttributes(e) : this._breakAttributesRange(e);
        }
        breakContainer(e) {
          const t = e.parent;
          if (!t.is("containerElement"))
            throw new V.b("view-writer-break-non-container-element: Trying to break an element which is not a container element.", this.document);
          if (!t.parent)
            throw new V.b("view-writer-break-root: Trying to break root element.", this.document);
          if (e.isAtStart)
            return be._createBefore(t);
          if (!e.isAtEnd) {
            const n = t._clone(!1);
            this.insert(be._createAfter(t), n);
            const i = new ze(e, be._createAt(t, "end")), s = new be(n, 0);
            this.move(i, s);
          }
          return be._createAfter(t);
        }
        mergeAttributes(e) {
          const t = e.offset, n = e.parent;
          if (n.is("text"))
            return e;
          if (n.is("attributeElement") && n.childCount === 0) {
            const l = n.parent, d = n.index;
            return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new be(l, d));
          }
          const i = n.getChild(t - 1), s = n.getChild(t);
          if (!i || !s)
            return e;
          if (i.is("text") && s.is("text"))
            return _c(i, s);
          if (i.is("attributeElement") && s.is("attributeElement") && i.isSimilar(s)) {
            const l = i.childCount;
            return i._appendChild(s.getChildren()), s._remove(), this._removeFromClonedElementsGroup(s), this.mergeAttributes(new be(i, l));
          }
          return e;
        }
        mergeContainers(e) {
          const t = e.nodeBefore, n = e.nodeAfter;
          if (!(t && n && t.is("containerElement") && n.is("containerElement")))
            throw new V.b("view-writer-merge-containers-invalid-position: Element before and after given position cannot be merged.", this.document);
          const i = t.getChild(t.childCount - 1), s = i instanceof rt ? be._createAt(i, "end") : be._createAt(t, "end");
          return this.move(ze._createIn(n), be._createAt(t, "end")), this.remove(ze._createOn(n)), s;
        }
        insert(e, t) {
          (function f(m, g) {
            for (const b of m) {
              if (!Lg.some((y) => b instanceof y))
                throw new V.b("view-writer-insert-invalid-node", g);
              b.is("text") || f(b.getChildren(), g);
            }
          })(t = Hn(t) ? [...t] : [t], this.document);
          const n = Ds(e);
          if (!n)
            throw new V.b("view-writer-invalid-position-container", this.document);
          const i = this._breakAttributes(e, !0), s = n._insertChild(i.offset, t);
          for (const f of t)
            this._addToClonedElementsGroup(f);
          const l = i.getShiftedBy(s), d = this.mergeAttributes(i);
          if (s === 0)
            return new ze(d, d);
          {
            d.isEqual(i) || l.offset--;
            const f = this.mergeAttributes(l);
            return new ze(d, f);
          }
        }
        remove(e) {
          const t = e instanceof ze ? e : ze._createOn(e);
          if (lr(t, this.document), t.isCollapsed)
            return new Li();
          const { start: n, end: i } = this._breakAttributesRange(t, !0), s = n.parent, l = i.offset - n.offset, d = s._removeChildren(n.offset, l);
          for (const m of d)
            this._removeFromClonedElementsGroup(m);
          const f = this.mergeAttributes(n);
          return t.start = f, t.end = f.clone(), new Li(d);
        }
        clear(e, t) {
          lr(e, this.document);
          const n = e.getWalker({ direction: "backward", ignoreElementEnd: !0 });
          for (const i of n) {
            const s = i.item;
            let l;
            if (s.is("element") && t.isSimilar(s))
              l = ze._createOn(s);
            else if (!i.nextPosition.isAfter(e.start) && s.is("textProxy")) {
              const d = s.getAncestors().find((f) => f.is("element") && t.isSimilar(f));
              d && (l = ze._createIn(d));
            }
            l && (l.end.isAfter(e.end) && (l.end = e.end), l.start.isBefore(e.start) && (l.start = e.start), this.remove(l));
          }
        }
        move(e, t) {
          let n;
          if (t.isAfter(e.end)) {
            const i = (t = this._breakAttributes(t, !0)).parent, s = i.childCount;
            e = this._breakAttributesRange(e, !0), n = this.remove(e), t.offset += i.childCount - s;
          } else
            n = this.remove(e);
          return this.insert(t, n);
        }
        wrap(e, t) {
          if (!(t instanceof yi))
            throw new V.b("view-writer-wrap-invalid-attribute", this.document);
          if (lr(e, this.document), e.isCollapsed) {
            let n = e.start;
            n.parent.is("element") && !function(s) {
              return Array.from(s.getChildren()).some((l) => !l.is("uiElement"));
            }(n.parent) && (n = n.getLastMatchingPosition((s) => s.item.is("uiElement"))), n = this._wrapPosition(n, t);
            const i = this.document.selection;
            return i.isCollapsed && i.getFirstPosition().isEqual(e.start) && this.setSelection(n), new ze(n);
          }
          return this._wrapRange(e, t);
        }
        unwrap(e, t) {
          if (!(t instanceof yi))
            throw new V.b("view-writer-unwrap-invalid-attribute", this.document);
          if (lr(e, this.document), e.isCollapsed)
            return e;
          const { start: n, end: i } = this._breakAttributesRange(e, !0), s = n.parent, l = this._unwrapChildren(s, n.offset, i.offset, t), d = this.mergeAttributes(l.start);
          d.isEqual(l.start) || l.end.offset--;
          const f = this.mergeAttributes(l.end);
          return new ze(d, f);
        }
        rename(e, t) {
          const n = new Gr(e, t.getAttributes());
          return this.insert(be._createAfter(t), n), this.move(ze._createIn(t), be._createAt(n, 0)), this.remove(ze._createOn(t)), n;
        }
        clearClonedElementsGroup(e) {
          this._cloneGroups.delete(e);
        }
        createPositionAt(e, t) {
          return be._createAt(e, t);
        }
        createPositionAfter(e) {
          return be._createAfter(e);
        }
        createPositionBefore(e) {
          return be._createBefore(e);
        }
        createRange(e, t) {
          return new ze(e, t);
        }
        createRangeOn(e) {
          return ze._createOn(e);
        }
        createRangeIn(e) {
          return ze._createIn(e);
        }
        createSelection(e, t, n) {
          return new bn(e, t, n);
        }
        _wrapChildren(e, t, n, i) {
          let s = t;
          const l = [];
          for (; s < n; ) {
            const f = e.getChild(s), m = f.is("text"), g = f.is("attributeElement"), b = f.is("emptyElement"), y = f.is("uiElement");
            if (g && this._wrapAttributeElement(i, f))
              l.push(new be(e, s));
            else if (m || b || y || g && Rg(i, f)) {
              const C = i._clone();
              f._remove(), C._appendChild(f), e._insertChild(s, C), this._addToClonedElementsGroup(C), l.push(new be(e, s));
            } else
              g && this._wrapChildren(f, 0, f.childCount, i);
            s++;
          }
          let d = 0;
          for (const f of l)
            f.offset -= d, f.offset != t && (this.mergeAttributes(f).isEqual(f) || (d++, n--));
          return ze._createFromParentsAndOffsets(e, t, e, n);
        }
        _unwrapChildren(e, t, n, i) {
          let s = t;
          const l = [];
          for (; s < n; ) {
            const f = e.getChild(s);
            if (f.is("attributeElement"))
              if (f.isSimilar(i)) {
                const m = f.getChildren(), g = f.childCount;
                f._remove(), e._insertChild(s, m), this._removeFromClonedElementsGroup(f), l.push(new be(e, s), new be(e, s + g)), s += g, n += g - 1;
              } else
                this._unwrapAttributeElement(i, f) ? (l.push(new be(e, s), new be(e, s + 1)), s++) : (this._unwrapChildren(f, 0, f.childCount, i), s++);
            else
              s++;
          }
          let d = 0;
          for (const f of l)
            f.offset -= d, !(f.offset == t || f.offset == n) && (this.mergeAttributes(f).isEqual(f) || (d++, n--));
          return ze._createFromParentsAndOffsets(e, t, e, n);
        }
        _wrapRange(e, t) {
          const { start: n, end: i } = this._breakAttributesRange(e, !0), s = n.parent, l = this._wrapChildren(s, n.offset, i.offset, t), d = this.mergeAttributes(l.start);
          d.isEqual(l.start) || l.end.offset--;
          const f = this.mergeAttributes(l.end);
          return new ze(d, f);
        }
        _wrapPosition(e, t) {
          if (t.isSimilar(e.parent))
            return vc(e.clone());
          e.parent.is("text") && (e = bc(e));
          const n = this.createAttributeElement();
          n._priority = Number.POSITIVE_INFINITY, n.isSimilar = () => !1, e.parent._insertChild(e.offset, n);
          const i = new ze(e, e.getShiftedBy(1));
          this.wrap(i, t);
          const s = new be(n.parent, n.index);
          n._remove();
          const l = s.nodeBefore, d = s.nodeAfter;
          return l instanceof rt && d instanceof rt ? _c(l, d) : vc(s);
        }
        _wrapAttributeElement(e, t) {
          if (!wc(e, t) || e.name !== t.name || e.priority !== t.priority)
            return !1;
          for (const n of e.getAttributeKeys())
            if (n !== "class" && n !== "style" && t.hasAttribute(n) && t.getAttribute(n) !== e.getAttribute(n))
              return !1;
          for (const n of e.getStyleNames())
            if (t.hasStyle(n) && t.getStyle(n) !== e.getStyle(n))
              return !1;
          for (const n of e.getAttributeKeys())
            n !== "class" && n !== "style" && (t.hasAttribute(n) || this.setAttribute(n, e.getAttribute(n), t));
          for (const n of e.getStyleNames())
            t.hasStyle(n) || this.setStyle(n, e.getStyle(n), t);
          for (const n of e.getClassNames())
            t.hasClass(n) || this.addClass(n, t);
          return !0;
        }
        _unwrapAttributeElement(e, t) {
          if (!wc(e, t) || e.name !== t.name || e.priority !== t.priority)
            return !1;
          for (const n of e.getAttributeKeys())
            if (n !== "class" && n !== "style" && (!t.hasAttribute(n) || t.getAttribute(n) !== e.getAttribute(n)))
              return !1;
          if (!t.hasClass(...e.getClassNames()))
            return !1;
          for (const n of e.getStyleNames())
            if (!t.hasStyle(n) || t.getStyle(n) !== e.getStyle(n))
              return !1;
          for (const n of e.getAttributeKeys())
            n !== "class" && n !== "style" && this.removeAttribute(n, t);
          return this.removeClass(Array.from(e.getClassNames()), t), this.removeStyle(Array.from(e.getStyleNames()), t), !0;
        }
        _breakAttributesRange(e, t = !1) {
          const n = e.start, i = e.end;
          if (lr(e, this.document), e.isCollapsed) {
            const f = this._breakAttributes(e.start, t);
            return new ze(f, f);
          }
          const s = this._breakAttributes(i, t), l = s.parent.childCount, d = this._breakAttributes(n, t);
          return s.offset += s.parent.childCount - l, new ze(d, s);
        }
        _breakAttributes(e, t = !1) {
          const n = e.offset, i = e.parent;
          if (e.parent.is("emptyElement"))
            throw new V.b("view-writer-cannot-break-empty-element", this.document);
          if (e.parent.is("uiElement"))
            throw new V.b("view-writer-cannot-break-ui-element", this.document);
          if (!t && i.is("text") && Ns(i.parent) || Ns(i))
            return e.clone();
          if (i.is("text"))
            return this._breakAttributes(bc(e), t);
          if (n == i.childCount) {
            const s = new be(i.parent, i.index + 1);
            return this._breakAttributes(s, t);
          }
          if (n === 0) {
            const s = new be(i.parent, i.index);
            return this._breakAttributes(s, t);
          }
          {
            const s = i.index + 1, l = i._clone();
            i.parent._insertChild(s, l), this._addToClonedElementsGroup(l);
            const d = i.childCount - n, f = i._removeChildren(n, d);
            l._appendChild(f);
            const m = new be(i.parent, s);
            return this._breakAttributes(m, t);
          }
        }
        _addToClonedElementsGroup(e) {
          if (!e.root.is("rootElement"))
            return;
          if (e.is("element"))
            for (const i of e.getChildren())
              this._addToClonedElementsGroup(i);
          const t = e.id;
          if (!t)
            return;
          let n = this._cloneGroups.get(t);
          n || (n = /* @__PURE__ */ new Set(), this._cloneGroups.set(t, n)), n.add(e), e._clonesGroup = n;
        }
        _removeFromClonedElementsGroup(e) {
          if (e.is("element"))
            for (const i of e.getChildren())
              this._removeFromClonedElementsGroup(i);
          const t = e.id;
          if (!t)
            return;
          const n = this._cloneGroups.get(t);
          n && n.delete(e);
        }
      }
      function Ds(o) {
        let e = o.parent;
        for (; !Ns(e); ) {
          if (!e)
            return;
          e = e.parent;
        }
        return e;
      }
      function Rg(o, e) {
        return o.priority < e.priority || !(o.priority > e.priority) && o.getIdentity() < e.getIdentity();
      }
      function vc(o) {
        const e = o.nodeBefore;
        if (e && e.is("text"))
          return new be(e, e.data.length);
        const t = o.nodeAfter;
        return t && t.is("text") ? new be(t, 0) : o;
      }
      function bc(o) {
        if (o.offset == o.parent.data.length)
          return new be(o.parent.parent, o.parent.index + 1);
        if (o.offset === 0)
          return new be(o.parent.parent, o.parent.index);
        const e = o.parent.data.slice(o.offset);
        return o.parent._data = o.parent.data.slice(0, o.offset), o.parent.parent._insertChild(o.parent.index + 1, new rt(e)), new be(o.parent.parent, o.parent.index + 1);
      }
      function _c(o, e) {
        const t = o.data.length;
        return o._data += e.data, e._remove(), new be(o, t);
      }
      const Lg = [rt, yi, Gr, hc, mc];
      function Ns(o) {
        return o && (o.is("containerElement") || o.is("documentFragment"));
      }
      function lr(o, e) {
        const t = Ds(o.start), n = Ds(o.end);
        if (!t || !n || t !== n)
          throw new V.b("view-writer-invalid-range-container", e);
      }
      function wc(o, e) {
        return o.id === null && e.id === null;
      }
      function $t(o) {
        return Object.prototype.toString.call(o) == "[object Text]";
      }
      const Fg = (o) => {
        const e = o.createElement("br");
        return e.dataset.ckeFiller = !0, e;
      }, yc = (o) => o.createTextNode("\xA0"), Pn = 7;
      let cr = "";
      for (let o = 0; o < Pn; o++)
        cr += "\u200B";
      function nn(o) {
        return $t(o) && o.data.substr(0, Pn) === cr;
      }
      function eo(o) {
        return o.data.length == Pn && nn(o);
      }
      function Rs(o) {
        return nn(o) ? o.data.slice(Pn) : o.data;
      }
      const kc = /* @__PURE__ */ new WeakMap();
      function to(o, e) {
        let t = kc.get(e);
        return t || (t = e(window.document), kc.set(e, t)), o.isEqualNode(t);
      }
      function zg(o, e) {
        if (e.keyCode == tt.arrowleft) {
          const t = e.domTarget.ownerDocument.defaultView.getSelection();
          if (t.rangeCount == 1 && t.getRangeAt(0).collapsed) {
            const n = t.getRangeAt(0).startContainer, i = t.getRangeAt(0).startOffset;
            nn(n) && i <= Pn && t.collapse(n, 0);
          }
        }
      }
      function xc(o, e, t, n = !1) {
        t = t || function(s, l) {
          return s === l;
        }, Array.isArray(o) || (o = Array.from(o)), Array.isArray(e) || (e = Array.from(e));
        const i = function(s, l, d) {
          const f = Sc(s, l, d);
          if (f === -1)
            return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
          const m = Cc(s, f), g = Cc(l, f), b = Sc(m, g, d), y = s.length - b, C = l.length - b;
          return { firstIndex: f, lastIndexOld: y, lastIndexNew: C };
        }(o, e, t);
        return n ? function(s, l) {
          const { firstIndex: d, lastIndexOld: f, lastIndexNew: m } = s;
          if (d === -1)
            return Array(l).fill("equal");
          let g = [];
          return d > 0 && (g = g.concat(Array(d).fill("equal"))), m - d > 0 && (g = g.concat(Array(m - d).fill("insert"))), f - d > 0 && (g = g.concat(Array(f - d).fill("delete"))), m < l && (g = g.concat(Array(l - m).fill("equal"))), g;
        }(i, e.length) : function(s, l) {
          const d = [], { firstIndex: f, lastIndexOld: m, lastIndexNew: g } = l;
          return g - f > 0 && d.push({ index: f, type: "insert", values: s.slice(f, g) }), m - f > 0 && d.push({ index: f + (g - f), type: "delete", howMany: m - f }), d;
        }(e, i);
      }
      function Sc(o, e, t) {
        for (let n = 0; n < Math.max(o.length, e.length); n++)
          if (o[n] === void 0 || e[n] === void 0 || !t(o[n], e[n]))
            return n;
        return -1;
      }
      function Cc(o, e) {
        return o.slice(e).reverse();
      }
      function oi(o, e, t) {
        t = t || function(D, oe) {
          return D === oe;
        };
        const n = o.length, i = e.length;
        if (n > 200 || i > 200 || n + i > 300)
          return oi.fastDiff(o, e, t, !0);
        let s, l;
        if (i < n) {
          const D = o;
          o = e, e = D, s = "delete", l = "insert";
        } else
          s = "insert", l = "delete";
        const d = o.length, f = e.length, m = f - d, g = {}, b = {};
        function y(D) {
          const oe = (b[D - 1] !== void 0 ? b[D - 1] : -1) + 1, ce = b[D + 1] !== void 0 ? b[D + 1] : -1, _e = oe > ce ? -1 : 1;
          g[D + _e] && (g[D] = g[D + _e].slice(0)), g[D] || (g[D] = []), g[D].push(oe > ce ? s : l);
          let De = Math.max(oe, ce), mt = De - D;
          for (; mt < d && De < f && t(o[mt], e[De]); )
            mt++, De++, g[D].push("equal");
          return De;
        }
        let C, O = 0;
        do {
          for (C = -O; C < m; C++)
            b[C] = y(C);
          for (C = m + O; C > m; C--)
            b[C] = y(C);
          b[m] = y(m), O++;
        } while (b[m] !== f);
        return g[m].slice(1);
      }
      function Ac(o, e, t) {
        o.insertBefore(t, o.childNodes[e] || null);
      }
      function Tc(o) {
        const e = o.parentNode;
        e && e.removeChild(o);
      }
      function Fi(o) {
        if (o) {
          if (o.defaultView)
            return o instanceof o.defaultView.Document;
          if (o.ownerDocument && o.ownerDocument.defaultView)
            return o instanceof o.ownerDocument.defaultView.Node;
        }
        return !1;
      }
      oi.fastDiff = xc;
      class Ic {
        constructor(e, t) {
          this.domDocuments = /* @__PURE__ */ new Set(), this.domConverter = e, this.markedAttributes = /* @__PURE__ */ new Set(), this.markedChildren = /* @__PURE__ */ new Set(), this.markedTexts = /* @__PURE__ */ new Set(), this.selection = t, this.isFocused = !1, this._inlineFiller = null, this._fakeSelectionContainer = null;
        }
        markToSync(e, t) {
          if (e === "text")
            this.domConverter.mapViewToDom(t.parent) && this.markedTexts.add(t);
          else {
            if (!this.domConverter.mapViewToDom(t))
              return;
            if (e === "attributes")
              this.markedAttributes.add(t);
            else {
              if (e !== "children")
                throw new V.b("view-renderer-unknown-type: Unknown type passed to Renderer.markToSync.", this);
              this.markedChildren.add(t);
            }
          }
        }
        render() {
          let e;
          for (const t of this.markedChildren)
            this._updateChildrenMappings(t);
          this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? e = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (e = this.selection.getFirstPosition(), this.markedChildren.add(e.parent));
          for (const t of this.markedAttributes)
            this._updateAttrs(t);
          for (const t of this.markedChildren)
            this._updateChildren(t, { inlineFillerPosition: e });
          for (const t of this.markedTexts)
            !this.markedChildren.has(t.parent) && this.domConverter.mapViewToDom(t.parent) && this._updateText(t, { inlineFillerPosition: e });
          if (e) {
            const t = this.domConverter.viewPositionToDom(e), n = t.parent.ownerDocument;
            nn(t.parent) ? this._inlineFiller = t.parent : this._inlineFiller = Ec(n, t.parent, t.offset);
          } else
            this._inlineFiller = null;
          this._updateSelection(), this._updateFocus(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
        }
        _updateChildrenMappings(e) {
          const t = this.domConverter.mapViewToDom(e);
          if (!t)
            return;
          const n = this.domConverter.mapViewToDom(e).childNodes, i = Array.from(this.domConverter.viewChildrenToDom(e, t.ownerDocument, { withChildren: !1 })), s = this._diffNodeLists(n, i), l = this._findReplaceActions(s, n, i);
          if (l.indexOf("replace") !== -1) {
            const d = { equal: 0, insert: 0, delete: 0 };
            for (const f of l)
              if (f === "replace") {
                const m = d.equal + d.insert, g = d.equal + d.delete, b = e.getChild(m);
                b && !b.is("uiElement") && this._updateElementMappings(b, n[g]), Tc(i[m]), d.equal++;
              } else
                d[f]++;
          }
        }
        _updateElementMappings(e, t) {
          this.domConverter.unbindDomElement(t), this.domConverter.bindElements(t, e), this.markedChildren.add(e), this.markedAttributes.add(e);
        }
        _getInlineFillerPosition() {
          const e = this.selection.getFirstPosition();
          return e.parent.is("text") ? be._createBefore(this.selection.getFirstPosition().parent) : e;
        }
        _isSelectionInInlineFiller() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed)
            return !1;
          const e = this.selection.getFirstPosition(), t = this.domConverter.viewPositionToDom(e);
          return !!(t && $t(t.parent) && nn(t.parent));
        }
        _removeInlineFiller() {
          const e = this._inlineFiller;
          if (!nn(e))
            throw new V.b("view-renderer-filler-was-lost: The inline filler node was lost.", this);
          eo(e) ? e.parentNode.removeChild(e) : e.data = e.data.substr(Pn), this._inlineFiller = null;
        }
        _needsInlineFillerAtSelection() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed)
            return !1;
          const e = this.selection.getFirstPosition(), t = e.parent, n = e.offset;
          if (!this.domConverter.mapViewToDom(t.root) || !t.is("element") || !function(l) {
            if (l.getAttribute("contenteditable") == "false")
              return !1;
            const d = l.findAncestor((f) => f.hasAttribute("contenteditable"));
            return !d || d.getAttribute("contenteditable") == "true";
          }(t) || n === t.getFillerOffset())
            return !1;
          const i = e.nodeBefore, s = e.nodeAfter;
          return !(i instanceof rt || s instanceof rt);
        }
        _updateText(e, t) {
          const n = this.domConverter.findCorrespondingDomText(e), i = this.domConverter.viewToDom(e, n.ownerDocument), s = n.data;
          let l = i.data;
          const d = t.inlineFillerPosition;
          if (d && d.parent == e.parent && d.offset == e.index && (l = cr + l), s != l) {
            const f = xc(s, l);
            for (const m of f)
              m.type === "insert" ? n.insertData(m.index, m.values.join("")) : n.deleteData(m.index, m.howMany);
          }
        }
        _updateAttrs(e) {
          const t = this.domConverter.mapViewToDom(e);
          if (!t)
            return;
          const n = Array.from(t.attributes).map((s) => s.name), i = e.getAttributeKeys();
          for (const s of i)
            t.setAttribute(s, e.getAttribute(s));
          for (const s of n)
            e.hasAttribute(s) || t.removeAttribute(s);
        }
        _updateChildren(e, t) {
          const n = this.domConverter.mapViewToDom(e);
          if (!n)
            return;
          const i = t.inlineFillerPosition, s = this.domConverter.mapViewToDom(e).childNodes, l = Array.from(this.domConverter.viewChildrenToDom(e, n.ownerDocument, { bind: !0, inlineFillerPosition: i }));
          i && i.parent === e && Ec(n.ownerDocument, l, i.offset);
          const d = this._diffNodeLists(s, l);
          let f = 0;
          const m = /* @__PURE__ */ new Set();
          for (const g of d)
            g === "insert" ? (Ac(n, f, l[f]), f++) : g === "delete" ? (m.add(s[f]), Tc(s[f])) : (this._markDescendantTextToSync(this.domConverter.domToView(l[f])), f++);
          for (const g of m)
            g.parentNode || this.domConverter.unbindDomElement(g);
        }
        _diffNodeLists(e, t) {
          return oi(e = function(n, i) {
            const s = Array.from(n);
            return s.length == 0 || !i || s[s.length - 1] == i && s.pop(), s;
          }(e, this._fakeSelectionContainer), t, function(n, i, s) {
            return i === s ? !0 : $t(i) && $t(s) ? i.data === s.data : !!(to(i, n) && to(s, n));
          }.bind(null, this.domConverter.blockFiller));
        }
        _findReplaceActions(e, t, n) {
          if (e.indexOf("insert") === -1 || e.indexOf("delete") === -1)
            return e;
          let i = [], s = [], l = [];
          const d = { equal: 0, insert: 0, delete: 0 };
          for (const f of e)
            f === "insert" ? l.push(n[d.equal + d.insert]) : f === "delete" ? s.push(t[d.equal + d.delete]) : ((i = i.concat(oi(s, l, Pc).map((m) => m === "equal" ? "replace" : m))).push("equal"), s = [], l = []), d[f]++;
          return i.concat(oi(s, l, Pc).map((f) => f === "equal" ? "replace" : f));
        }
        _markDescendantTextToSync(e) {
          if (e) {
            if (e.is("text"))
              this.markedTexts.add(e);
            else if (e.is("element"))
              for (const t of e.getChildren())
                this._markDescendantTextToSync(t);
          }
        }
        _updateSelection() {
          if (this.selection.rangeCount === 0)
            return this._removeDomSelection(), void this._removeFakeSelection();
          const e = this.domConverter.mapViewToDom(this.selection.editableElement);
          this.isFocused && e && (this.selection.isFake ? this._updateFakeSelection(e) : (this._removeFakeSelection(), this._updateDomSelection(e)));
        }
        _updateFakeSelection(e) {
          const t = e.ownerDocument;
          let n = this._fakeSelectionContainer;
          n || (this._fakeSelectionContainer = n = t.createElement("div"), Object.assign(n.style, { position: "fixed", top: 0, left: "-9999px", width: "42px" }), n.textContent = "\xA0"), n.parentElement && n.parentElement == e || e.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || "\xA0";
          const i = t.getSelection(), s = t.createRange();
          i.removeAllRanges(), s.selectNodeContents(n), i.addRange(s), this.domConverter.bindFakeSelection(n, this.selection);
        }
        _updateDomSelection(e) {
          const t = e.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(t))
            return;
          const n = this.domConverter.viewPositionToDom(this.selection.anchor), i = this.domConverter.viewPositionToDom(this.selection.focus);
          e.focus(), t.collapse(n.parent, n.offset), t.extend(i.parent, i.offset), un.isGecko && function(s, l) {
            const d = s.parent;
            if (d.nodeType != Node.ELEMENT_NODE || s.offset != d.childNodes.length - 1)
              return;
            const f = d.childNodes[s.offset];
            f && f.tagName == "BR" && l.addRange(l.getRangeAt(0));
          }(i, t);
        }
        _domSelectionNeedsUpdate(e) {
          if (!this.domConverter.isDomSelectionCorrect(e))
            return !0;
          const t = e && this.domConverter.domSelectionToView(e);
          return (!t || !this.selection.isEqual(t)) && !(!this.selection.isCollapsed && this.selection.isSimilar(t));
        }
        _removeDomSelection() {
          for (const e of this.domDocuments)
            if (e.getSelection().rangeCount) {
              const t = e.activeElement, n = this.domConverter.mapDomToView(t);
              t && n && e.getSelection().removeAllRanges();
            }
        }
        _removeFakeSelection() {
          const e = this._fakeSelectionContainer;
          e && e.remove();
        }
        _updateFocus() {
          if (this.isFocused) {
            const e = this.selection.editableElement;
            e && this.domConverter.focus(e);
          }
        }
      }
      function Ec(o, e, t) {
        const n = e instanceof Array ? e : e.childNodes, i = n[t];
        if ($t(i))
          return i.data = cr + i.data, i;
        {
          const s = o.createTextNode(cr);
          return Array.isArray(e) ? n.splice(t, 0, s) : Ac(e, t, s), s;
        }
      }
      function Pc(o, e) {
        return Fi(o) && Fi(e) && !$t(o) && !$t(e) && o.tagName.toLowerCase() === e.tagName.toLowerCase();
      }
      $e(Ic, xt);
      var jt = { window, document };
      function Ls(o) {
        let e = 0;
        for (; o.previousSibling; )
          o = o.previousSibling, e++;
        return e;
      }
      function ur(o) {
        const e = [];
        for (; o && o.nodeType != Node.DOCUMENT_NODE; )
          e.unshift(o), o = o.parentNode;
        return e;
      }
      class no {
        constructor(e = {}) {
          this.blockFiller = e.blockFiller || Fg, this.preElements = ["pre"], this.blockElements = ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"], this._domToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToDomMapping = /* @__PURE__ */ new WeakMap(), this._fakeSelectionMapping = /* @__PURE__ */ new WeakMap();
        }
        bindFakeSelection(e, t) {
          this._fakeSelectionMapping.set(e, new bn(t));
        }
        fakeSelectionToView(e) {
          return this._fakeSelectionMapping.get(e);
        }
        bindElements(e, t) {
          this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
        }
        unbindDomElement(e) {
          const t = this._domToViewMapping.get(e);
          if (t) {
            this._domToViewMapping.delete(e), this._viewToDomMapping.delete(t);
            for (const n of Array.from(e.childNodes))
              this.unbindDomElement(n);
          }
        }
        bindDocumentFragments(e, t) {
          this._domToViewMapping.set(e, t), this._viewToDomMapping.set(t, e);
        }
        viewToDom(e, t, n = {}) {
          if (e.is("text")) {
            const i = this._processDataFromViewText(e);
            return t.createTextNode(i);
          }
          {
            if (this.mapViewToDom(e))
              return this.mapViewToDom(e);
            let i;
            if (e.is("documentFragment"))
              i = t.createDocumentFragment(), n.bind && this.bindDocumentFragments(i, e);
            else {
              if (e.is("uiElement"))
                return i = e.render(t), n.bind && this.bindElements(i, e), i;
              i = t.createElement(e.name), n.bind && this.bindElements(i, e);
              for (const s of e.getAttributeKeys())
                i.setAttribute(s, e.getAttribute(s));
            }
            if (n.withChildren || n.withChildren === void 0)
              for (const s of this.viewChildrenToDom(e, t, n))
                i.appendChild(s);
            return i;
          }
        }
        *viewChildrenToDom(e, t, n = {}) {
          const i = e.getFillerOffset && e.getFillerOffset();
          let s = 0;
          for (const l of e.getChildren())
            i === s && (yield this.blockFiller(t)), yield this.viewToDom(l, t, n), s++;
          i === s && (yield this.blockFiller(t));
        }
        viewRangeToDom(e) {
          const t = this.viewPositionToDom(e.start), n = this.viewPositionToDom(e.end), i = document.createRange();
          return i.setStart(t.parent, t.offset), i.setEnd(n.parent, n.offset), i;
        }
        viewPositionToDom(e) {
          const t = e.parent;
          if (t.is("text")) {
            const n = this.findCorrespondingDomText(t);
            if (!n)
              return null;
            let i = e.offset;
            return nn(n) && (i += Pn), { parent: n, offset: i };
          }
          {
            let n, i, s;
            if (e.offset === 0) {
              if (!(n = this.mapViewToDom(t)))
                return null;
              s = n.childNodes[0];
            } else {
              const l = e.nodeBefore;
              if (!(i = l.is("text") ? this.findCorrespondingDomText(l) : this.mapViewToDom(e.nodeBefore)))
                return null;
              n = i.parentNode, s = i.nextSibling;
            }
            return $t(s) && nn(s) ? { parent: s, offset: Pn } : { parent: n, offset: i ? Ls(i) + 1 : 0 };
          }
        }
        domToView(e, t = {}) {
          if (to(e, this.blockFiller))
            return null;
          const n = this.getParentUIElement(e, this._domToViewMapping);
          if (n)
            return n;
          if ($t(e)) {
            if (eo(e))
              return null;
            {
              const i = this._processDataFromDomText(e);
              return i === "" ? null : new rt(i);
            }
          }
          if (this.isComment(e))
            return null;
          {
            if (this.mapDomToView(e))
              return this.mapDomToView(e);
            let i;
            if (this.isDocumentFragment(e))
              i = new Li(), t.bind && this.bindDocumentFragments(e, i);
            else {
              const s = t.keepOriginalCase ? e.tagName : e.tagName.toLowerCase();
              i = new tn(s), t.bind && this.bindElements(e, i);
              const l = e.attributes;
              for (let d = l.length - 1; d >= 0; d--)
                i._setAttribute(l[d].name, l[d].value);
            }
            if (t.withChildren || t.withChildren === void 0)
              for (const s of this.domChildrenToView(e, t))
                i._appendChild(s);
            return i;
          }
        }
        *domChildrenToView(e, t = {}) {
          for (let n = 0; n < e.childNodes.length; n++) {
            const i = e.childNodes[n], s = this.domToView(i, t);
            s !== null && (yield s);
          }
        }
        domSelectionToView(e) {
          if (e.rangeCount === 1) {
            let i = e.getRangeAt(0).startContainer;
            $t(i) && (i = i.parentNode);
            const s = this.fakeSelectionToView(i);
            if (s)
              return s;
          }
          const t = this.isDomSelectionBackward(e), n = [];
          for (let i = 0; i < e.rangeCount; i++) {
            const s = e.getRangeAt(i), l = this.domRangeToView(s);
            l && n.push(l);
          }
          return new bn(n, { backward: t });
        }
        domRangeToView(e) {
          const t = this.domPositionToView(e.startContainer, e.startOffset), n = this.domPositionToView(e.endContainer, e.endOffset);
          return t && n ? new ze(t, n) : null;
        }
        domPositionToView(e, t) {
          if (to(e, this.blockFiller))
            return this.domPositionToView(e.parentNode, Ls(e));
          const n = this.mapDomToView(e);
          if (n && n.is("uiElement"))
            return be._createBefore(n);
          if ($t(e)) {
            if (eo(e))
              return this.domPositionToView(e.parentNode, Ls(e));
            const i = this.findCorrespondingViewText(e);
            let s = t;
            return i ? (nn(e) && (s = (s -= Pn) < 0 ? 0 : s), new be(i, s)) : null;
          }
          if (t === 0) {
            const i = this.mapDomToView(e);
            if (i)
              return new be(i, 0);
          } else {
            const i = e.childNodes[t - 1], s = $t(i) ? this.findCorrespondingViewText(i) : this.mapDomToView(i);
            if (s && s.parent)
              return new be(s.parent, s.index + 1);
          }
          return null;
        }
        mapDomToView(e) {
          return this.getParentUIElement(e) || this._domToViewMapping.get(e);
        }
        findCorrespondingViewText(e) {
          if (eo(e))
            return null;
          const t = this.getParentUIElement(e);
          if (t)
            return t;
          const n = e.previousSibling;
          if (n) {
            if (!this.isElement(n))
              return null;
            const i = this.mapDomToView(n);
            if (i)
              return i.nextSibling instanceof rt ? i.nextSibling : null;
          } else {
            const i = this.mapDomToView(e.parentNode);
            if (i) {
              const s = i.getChild(0);
              return s instanceof rt ? s : null;
            }
          }
          return null;
        }
        mapViewToDom(e) {
          return this._viewToDomMapping.get(e);
        }
        findCorrespondingDomText(e) {
          const t = e.previousSibling;
          return t && this.mapViewToDom(t) ? this.mapViewToDom(t).nextSibling : !t && e.parent && this.mapViewToDom(e.parent) ? this.mapViewToDom(e.parent).childNodes[0] : null;
        }
        focus(e) {
          const t = this.mapViewToDom(e);
          if (t && t.ownerDocument.activeElement !== t) {
            const { scrollX: n, scrollY: i } = jt.window, s = [];
            Mc(t, (l) => {
              const { scrollLeft: d, scrollTop: f } = l;
              s.push([d, f]);
            }), t.focus(), Mc(t, (l) => {
              const [d, f] = s.shift();
              l.scrollLeft = d, l.scrollTop = f;
            }), jt.window.scrollTo(n, i);
          }
        }
        isElement(e) {
          return e && e.nodeType == Node.ELEMENT_NODE;
        }
        isDocumentFragment(e) {
          return e && e.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
        isComment(e) {
          return e && e.nodeType == Node.COMMENT_NODE;
        }
        isDomSelectionBackward(e) {
          if (e.isCollapsed)
            return !1;
          const t = document.createRange();
          t.setStart(e.anchorNode, e.anchorOffset), t.setEnd(e.focusNode, e.focusOffset);
          const n = t.collapsed;
          return t.detach(), n;
        }
        getParentUIElement(e) {
          const t = ur(e);
          for (t.pop(); t.length; ) {
            const n = t.pop(), i = this._domToViewMapping.get(n);
            if (i && i.is("uiElement"))
              return i;
          }
          return null;
        }
        isDomSelectionCorrect(e) {
          return this._isDomSelectionPositionCorrect(e.anchorNode, e.anchorOffset) && this._isDomSelectionPositionCorrect(e.focusNode, e.focusOffset);
        }
        _isDomSelectionPositionCorrect(e, t) {
          if ($t(e) && nn(e) && t < Pn || this.isElement(e) && nn(e.childNodes[t]))
            return !1;
          const n = this.mapDomToView(e);
          return !n || !n.is("uiElement");
        }
        _processDataFromViewText(e) {
          let t = e.data;
          if (e.getAncestors().some((n) => this.preElements.includes(n.name)))
            return t;
          if (t.charAt(0) == " ") {
            const n = this._getTouchingViewTextNode(e, !1);
            !(n && this._nodeEndsWithSpace(n)) && n || (t = "\xA0" + t.substr(1));
          }
          if (t.charAt(t.length - 1) == " ") {
            const n = this._getTouchingViewTextNode(e, !0);
            t.charAt(t.length - 2) != " " && n && n.data.charAt(0) != " " || (t = t.substr(0, t.length - 1) + "\xA0");
          }
          return t.replace(/ {2}/g, " \xA0");
        }
        _nodeEndsWithSpace(e) {
          if (e.getAncestors().some((n) => this.preElements.includes(n.name)))
            return !1;
          const t = this._processDataFromViewText(e);
          return t.charAt(t.length - 1) == " ";
        }
        _processDataFromDomText(e) {
          let t = e.data;
          if (Fs(e, this.preElements))
            return Rs(e);
          t = t.replace(/[ \n\t\r]{1,}/g, " ");
          const n = this._getTouchingInlineDomNode(e, !1), i = this._getTouchingInlineDomNode(e, !0), s = this._checkShouldLeftTrimDomText(n), l = this._checkShouldRightTrimDomText(e, i);
          return s && (t = t.replace(/^ /, "")), l && (t = t.replace(/ $/, "")), t = (t = Rs(new Text(t))).replace(/ \u00A0/g, "  "), (/( |\u00A0)\u00A0$/.test(t) || !i || i.data && i.data.charAt(0) == " ") && (t = t.replace(/\u00A0$/, " ")), s && (t = t.replace(/^\u00A0/, " ")), t;
        }
        _checkShouldLeftTrimDomText(e) {
          return !e || !!Bn(e) || /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1));
        }
        _checkShouldRightTrimDomText(e, t) {
          return !t && !nn(e);
        }
        _getTouchingViewTextNode(e, t) {
          const n = new wi({ startPosition: t ? be._createAfter(e) : be._createBefore(e), direction: t ? "forward" : "backward" });
          for (const i of n) {
            if (i.item.is("containerElement") || i.item.is("br"))
              return null;
            if (i.item.is("textProxy"))
              return i.item;
          }
          return null;
        }
        _getTouchingInlineDomNode(e, t) {
          if (!e.parentNode)
            return null;
          const n = t ? "nextNode" : "previousNode", i = e.ownerDocument, s = ur(e)[0], l = i.createTreeWalker(s, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, { acceptNode: (f) => $t(f) || f.tagName == "BR" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP });
          l.currentNode = e;
          const d = l[n]();
          if (d !== null) {
            const f = function(m, g) {
              const b = ur(m), y = ur(g);
              let C = 0;
              for (; b[C] == y[C] && b[C]; )
                C++;
              return C === 0 ? null : b[C - 1];
            }(e, d);
            if (f && !Fs(e, this.blockElements, f) && !Fs(d, this.blockElements, f))
              return d;
          }
          return null;
        }
      }
      function Fs(o, e, t) {
        let n = ur(o);
        return t && (n = n.slice(n.indexOf(t) + 1)), n.some((i) => i.tagName && e.includes(i.tagName.toLowerCase()));
      }
      function Mc(o, e) {
        for (; o && o != jt.document; )
          e(o), o = o.parentNode;
      }
      function io(o) {
        const e = Object.prototype.toString.apply(o);
        return e == "[object Window]" || e == "[object global]";
      }
      var ro = Ri({}, dt, { listenTo(o, ...e) {
        if (Fi(o) || io(o)) {
          const t = this._getProxyEmitter(o) || new zs(o);
          t.attach(...e), o = t;
        }
        dt.listenTo.call(this, o, ...e);
      }, stopListening(o, e, t) {
        if (Fi(o) || io(o)) {
          const n = this._getProxyEmitter(o);
          if (!n)
            return;
          o = n;
        }
        dt.stopListening.call(this, o, e, t), o instanceof zs && o.detach(e);
      }, _getProxyEmitter(o) {
        return function(e, t) {
          return e[ii] && e[ii][t] ? e[ii][t].emitter : null;
        }(this, Oc(o));
      } });
      class zs {
        constructor(e) {
          Zl(this, Oc(e)), this._domNode = e;
        }
      }
      function Oc(o) {
        return o["data-ck-expando"] || (o["data-ck-expando"] = Vn());
      }
      Ri(zs.prototype, dt, { attach(o, e, t = {}) {
        if (this._domListeners && this._domListeners[o])
          return;
        const n = this._createDomListener(o, !!t.useCapture);
        this._domNode.addEventListener(o, n, !!t.useCapture), this._domListeners || (this._domListeners = {}), this._domListeners[o] = n;
      }, detach(o) {
        let e;
        !this._domListeners[o] || (e = this._events[o]) && e.callbacks.length || this._domListeners[o].removeListener();
      }, _createDomListener(o, e) {
        const t = (n) => {
          this.fire(o, n);
        };
        return t.removeListener = () => {
          this._domNode.removeEventListener(o, t, e), delete this._domListeners[o];
        }, t;
      } });
      class si {
        constructor(e) {
          this.view = e, this.document = e.document, this.isEnabled = !1;
        }
        enable() {
          this.isEnabled = !0;
        }
        disable() {
          this.isEnabled = !1;
        }
        destroy() {
          this.disable(), this.stopListening();
        }
      }
      $e(si, ro);
      var $g = "__lodash_hash_undefined__", jg = function(o) {
        return this.__data__.set(o, $g), this;
      }, Bg = function(o) {
        return this.__data__.has(o);
      };
      function oo(o) {
        var e = -1, t = o == null ? 0 : o.length;
        for (this.__data__ = new Se(); ++e < t; )
          this.add(o[e]);
      }
      oo.prototype.add = oo.prototype.push = jg, oo.prototype.has = Bg;
      var Vg = oo, Ug = function(o, e) {
        for (var t = -1, n = o == null ? 0 : o.length; ++t < n; )
          if (e(o[t], t, o))
            return !0;
        return !1;
      }, Hg = function(o, e) {
        return o.has(e);
      }, Wg = 1, Yg = 2, Dc = function(o, e, t, n, i, s) {
        var l = t & Wg, d = o.length, f = e.length;
        if (d != f && !(l && f > d))
          return !1;
        var m = s.get(o);
        if (m && s.get(e))
          return m == e;
        var g = -1, b = !0, y = t & Yg ? new Vg() : void 0;
        for (s.set(o, e), s.set(e, o); ++g < d; ) {
          var C = o[g], O = e[g];
          if (n)
            var D = l ? n(O, C, g, e, o, s) : n(C, O, g, o, e, s);
          if (D !== void 0) {
            if (D)
              continue;
            b = !1;
            break;
          }
          if (y) {
            if (!Ug(e, function(oe, ce) {
              if (!Hg(y, ce) && (C === oe || i(C, oe, t, n, s)))
                return y.push(ce);
            })) {
              b = !1;
              break;
            }
          } else if (C !== O && !i(C, O, t, n, s)) {
            b = !1;
            break;
          }
        }
        return s.delete(o), s.delete(e), b;
      }, qg = function(o) {
        var e = -1, t = Array(o.size);
        return o.forEach(function(n, i) {
          t[++e] = [i, n];
        }), t;
      }, Gg = function(o) {
        var e = -1, t = Array(o.size);
        return o.forEach(function(n) {
          t[++e] = n;
        }), t;
      }, Zg = 1, Kg = 2, Xg = "[object Boolean]", Qg = "[object Date]", Jg = "[object Error]", ev = "[object Map]", tv = "[object Number]", nv = "[object RegExp]", iv = "[object Set]", rv = "[object String]", ov = "[object Symbol]", sv = "[object ArrayBuffer]", av = "[object DataView]", Nc = v ? v.prototype : void 0, $s = Nc ? Nc.valueOf : void 0, lv = function(o, e, t, n, i, s, l) {
        switch (t) {
          case av:
            if (o.byteLength != e.byteLength || o.byteOffset != e.byteOffset)
              return !1;
            o = o.buffer, e = e.buffer;
          case sv:
            return !(o.byteLength != e.byteLength || !s(new Yr(o), new Yr(e)));
          case Xg:
          case Qg:
          case tv:
            return B(+o, +e);
          case Jg:
            return o.name == e.name && o.message == e.message;
          case nv:
          case rv:
            return o == e + "";
          case ev:
            var d = qg;
          case iv:
            var f = n & Zg;
            if (d || (d = Gg), o.size != e.size && !f)
              return !1;
            var m = l.get(o);
            if (m)
              return m == e;
            n |= Kg, l.set(o, e);
            var g = Dc(d(o), d(e), n, i, s, l);
            return l.delete(o), g;
          case ov:
            if ($s)
              return $s.call(o) == $s.call(e);
        }
        return !1;
      }, cv = 1, uv = Object.prototype.hasOwnProperty, dv = function(o, e, t, n, i, s) {
        var l = t & cv, d = gs(o), f = d.length;
        if (f != gs(e).length && !l)
          return !1;
        for (var m = f; m--; ) {
          var g = d[m];
          if (!(l ? g in e : uv.call(e, g)))
            return !1;
        }
        var b = s.get(o);
        if (b && s.get(e))
          return b == e;
        var y = !0;
        s.set(o, e), s.set(e, o);
        for (var C = l; ++m < f; ) {
          var O = o[g = d[m]], D = e[g];
          if (n)
            var oe = l ? n(D, O, g, e, o, s) : n(O, D, g, o, e, s);
          if (!(oe === void 0 ? O === D || i(O, D, t, n, s) : oe)) {
            y = !1;
            break;
          }
          C || (C = g == "constructor");
        }
        if (y && !C) {
          var ce = o.constructor, _e = e.constructor;
          ce != _e && "constructor" in o && "constructor" in e && !(typeof ce == "function" && ce instanceof ce && typeof _e == "function" && _e instanceof _e) && (y = !1);
        }
        return s.delete(o), s.delete(e), y;
      }, hv = 1, Rc = "[object Arguments]", Lc = "[object Array]", so = "[object Object]", Fc = Object.prototype.hasOwnProperty, fv = function(o, e, t, n, i, s) {
        var l = En(o), d = En(e), f = l ? Lc : sr(o), m = d ? Lc : sr(e), g = (f = f == Rc ? so : f) == so, b = (m = m == Rc ? so : m) == so, y = f == m;
        if (y && Object(Wr.a)(o)) {
          if (!Object(Wr.a)(e))
            return !1;
          l = !0, g = !1;
        }
        if (y && !g)
          return s || (s = new Ot()), l || Ol(o) ? Dc(o, e, t, n, i, s) : lv(o, e, f, t, n, i, s);
        if (!(t & hv)) {
          var C = g && Fc.call(o, "__wrapped__"), O = b && Fc.call(e, "__wrapped__");
          if (C || O) {
            var D = C ? o.value() : o, oe = O ? e.value() : e;
            return s || (s = new Ot()), i(D, oe, t, n, s);
          }
        }
        return !!y && (s || (s = new Ot()), dv(o, e, t, n, i, s));
      }, zc = function o(e, t, n, i, s) {
        return e === t || (e == null || t == null || !se(e) && !se(t) ? e != e && t != t : fv(e, t, n, i, o, s));
      }, pv = function(o, e, t) {
        var n = (t = typeof t == "function" ? t : void 0) ? t(o, e) : void 0;
        return n === void 0 ? zc(o, e, void 0, t) : !!n;
      };
      class $c extends si {
        constructor(e) {
          super(e), this._config = { childList: !0, characterData: !0, characterDataOldValue: !0, subtree: !0 }, this.domConverter = e.domConverter, this.renderer = e._renderer, this._domElements = [], this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
        }
        flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
        observe(e) {
          this._domElements.push(e), this.isEnabled && this._mutationObserver.observe(e, this._config);
        }
        enable() {
          super.enable();
          for (const e of this._domElements)
            this._mutationObserver.observe(e, this._config);
        }
        disable() {
          super.disable(), this._mutationObserver.disconnect();
        }
        destroy() {
          super.destroy(), this._mutationObserver.disconnect();
        }
        _onMutations(e) {
          if (e.length === 0)
            return;
          const t = this.domConverter, n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set();
          for (const m of e)
            if (m.type === "childList") {
              const g = t.mapDomToView(m.target);
              if (g && g.is("uiElement"))
                continue;
              g && !this._isBogusBrMutation(m) && i.add(g);
            }
          for (const m of e) {
            const g = t.mapDomToView(m.target);
            if ((!g || !g.is("uiElement")) && m.type === "characterData") {
              const b = t.findCorrespondingViewText(m.target);
              b && !i.has(b.parent) ? n.set(b, { type: "text", oldText: b.data, newText: Rs(m.target), node: b }) : !b && nn(m.target) && i.add(t.mapDomToView(m.target.parentNode));
            }
          }
          const s = [];
          for (const m of n.values())
            this.renderer.markToSync("text", m.node), s.push(m);
          for (const m of i) {
            const g = t.mapViewToDom(m), b = Array.from(m.getChildren()), y = Array.from(t.domChildrenToView(g, { withChildren: !1 }));
            pv(b, y, f) || (this.renderer.markToSync("children", m), s.push({ type: "children", oldChildren: b, newChildren: y, node: m }));
          }
          const l = e[0].target.ownerDocument.getSelection();
          let d = null;
          if (l && l.anchorNode) {
            const m = t.domPositionToView(l.anchorNode, l.anchorOffset), g = t.domPositionToView(l.focusNode, l.focusOffset);
            m && g && (d = new bn(m)).setFocus(g);
          }
          function f(m, g) {
            if (!Array.isArray(m))
              return m === g || !(!m.is("text") || !g.is("text")) && m.data === g.data;
          }
          this.document.fire("mutations", s, d), this.view.forceRender();
        }
        _isBogusBrMutation(e) {
          let t = null;
          return e.nextSibling === null && e.removedNodes.length === 0 && e.addedNodes.length == 1 && (t = this.domConverter.domToView(e.addedNodes[0], { withChildren: !1 })), t && t.is("element", "br");
        }
      }
      class js {
        constructor(e, t, n) {
          this.view = e, this.document = e.document, this.domEvent = t, this.domTarget = t.target, Ri(this, n);
        }
        get target() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
        preventDefault() {
          this.domEvent.preventDefault();
        }
        stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }
      class ki extends si {
        constructor(e) {
          super(e), this.useCapture = !1;
        }
        observe(e) {
          (typeof this.domEventType == "string" ? [this.domEventType] : this.domEventType).forEach((t) => {
            this.listenTo(e, t, (n, i) => {
              this.isEnabled && this.onDomEvent(i);
            }, { useCapture: this.useCapture });
          });
        }
        fire(e, t, n) {
          this.isEnabled && this.document.fire(e, new js(this.view, t, n));
        }
      }
      class mv extends ki {
        constructor(e) {
          super(e), this.domEventType = ["keydown", "keyup"];
        }
        onDomEvent(e) {
          this.fire(e.type, e, { keyCode: e.keyCode, altKey: e.altKey, ctrlKey: e.ctrlKey || e.metaKey, shiftKey: e.shiftKey, get keystroke() {
            return Yn(this);
          } });
        }
      }
      var Bs = function() {
        return h.a.Date.now();
      }, gv = "[object Symbol]", jc = function(o) {
        return typeof o == "symbol" || se(o) && Z(o) == gv;
      }, Bc = NaN, vv = /^\s+|\s+$/g, bv = /^[-+]0x[0-9a-f]+$/i, _v = /^0b[01]+$/i, wv = /^0o[0-7]+$/i, yv = parseInt, Vc = function(o) {
        if (typeof o == "number")
          return o;
        if (jc(o))
          return Bc;
        if (te(o)) {
          var e = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = te(e) ? e + "" : e;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = o.replace(vv, "");
        var t = _v.test(o);
        return t || wv.test(o) ? yv(o.slice(2), t ? 2 : 8) : bv.test(o) ? Bc : +o;
      }, kv = "Expected a function", xv = Math.max, Sv = Math.min, Uc = function(o, e, t) {
        var n, i, s, l, d, f, m = 0, g = !1, b = !1, y = !0;
        if (typeof o != "function")
          throw new TypeError(kv);
        function C(_e) {
          var De = n, mt = i;
          return n = i = void 0, m = _e, l = o.apply(mt, De);
        }
        function O(_e) {
          var De = _e - f;
          return f === void 0 || De >= e || De < 0 || b && _e - m >= s;
        }
        function D() {
          var _e = Bs();
          if (O(_e))
            return oe(_e);
          d = setTimeout(D, function(De) {
            var mt = e - (De - f);
            return b ? Sv(mt, s - (De - m)) : mt;
          }(_e));
        }
        function oe(_e) {
          return d = void 0, y && n ? C(_e) : (n = i = void 0, l);
        }
        function ce() {
          var _e = Bs(), De = O(_e);
          if (n = arguments, i = this, f = _e, De) {
            if (d === void 0)
              return function(mt) {
                return m = mt, d = setTimeout(D, e), g ? C(mt) : l;
              }(f);
            if (b)
              return clearTimeout(d), d = setTimeout(D, e), C(f);
          }
          return d === void 0 && (d = setTimeout(D, e)), l;
        }
        return e = Vc(e) || 0, te(t) && (g = !!t.leading, s = (b = "maxWait" in t) ? xv(Vc(t.maxWait) || 0, e) : s, y = "trailing" in t ? !!t.trailing : y), ce.cancel = function() {
          d !== void 0 && clearTimeout(d), m = 0, n = f = i = d = void 0;
        }, ce.flush = function() {
          return d === void 0 ? l : oe(Bs());
        }, ce;
      };
      class Cv extends si {
        constructor(e) {
          super(e), this._fireSelectionChangeDoneDebounced = Uc((t) => this.document.fire("selectionChangeDone", t), 200);
        }
        observe() {
          const e = this.document;
          e.on("keydown", (t, n) => {
            e.selection.isFake && function(i) {
              return i == tt.arrowright || i == tt.arrowleft || i == tt.arrowup || i == tt.arrowdown;
            }(n.keyCode) && this.isEnabled && (n.preventDefault(), this._handleSelectionMove(n.keyCode));
          }, { priority: "lowest" });
        }
        destroy() {
          super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
        }
        _handleSelectionMove(e) {
          const t = this.document.selection, n = new bn(t.getRanges(), { backward: t.isBackward, fake: !1 });
          e != tt.arrowleft && e != tt.arrowup || n.setTo(n.getFirstPosition()), e != tt.arrowright && e != tt.arrowdown || n.setTo(n.getLastPosition());
          const i = { oldSelection: t, newSelection: n, domSelection: null };
          this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
        }
      }
      class Av extends si {
        constructor(e) {
          super(e), this.mutationObserver = e.getObserver($c), this.selection = this.document.selection, this.domConverter = e.domConverter, this._documents = /* @__PURE__ */ new WeakSet(), this._fireSelectionChangeDoneDebounced = Uc((t) => this.document.fire("selectionChangeDone", t), 200), this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3), this._loopbackCounter = 0;
        }
        observe(e) {
          const t = e.ownerDocument;
          this._documents.has(t) || (this.listenTo(t, "selectionchange", () => {
            this._handleSelectionChange(t);
          }), this._documents.add(t));
        }
        destroy() {
          super.destroy(), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel();
        }
        _handleSelectionChange(e) {
          if (!this.isEnabled || !this.document.isFocused && !this.document.isReadOnly)
            return;
          this.mutationObserver.flush();
          const t = e.defaultView.getSelection(), n = this.domConverter.domSelectionToView(t);
          if (!(this.selection.isEqual(n) && this.domConverter.isDomSelectionCorrect(t) || ++this._loopbackCounter > 60))
            if (this.selection.isSimilar(n))
              this.view.forceRender();
            else {
              const i = { oldSelection: this.selection, newSelection: n, domSelection: t };
              this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
            }
        }
        _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }
      class Tv extends ki {
        constructor(e) {
          super(e), this.domEventType = ["focus", "blur"], this.useCapture = !0;
          const t = this.document;
          t.on("focus", () => {
            t.isFocused = !0, this._renderTimeoutId = setTimeout(() => e.forceRender(), 50);
          }), t.on("blur", (n, i) => {
            const s = t.selection.editableElement;
            s !== null && s !== i.target || (t.isFocused = !1, e.forceRender());
          });
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
        destroy() {
          this._renderTimeoutId && clearTimeout(this._renderTimeoutId), super.destroy();
        }
      }
      class Iv extends ki {
        constructor(e) {
          super(e), this.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
          const t = this.document;
          t.on("compositionstart", () => {
            t.isComposing = !0;
          }), t.on("compositionend", () => {
            t.isComposing = !1;
          });
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      class Ev extends ki {
        constructor(e) {
          super(e), this.domEventType = ["beforeinput"];
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      function ao(o) {
        return Object.prototype.toString.apply(o) == "[object Range]";
      }
      function Hc(o) {
        const e = o.ownerDocument.defaultView.getComputedStyle(o);
        return { top: parseInt(e.borderTopWidth, 10), right: parseInt(e.borderRightWidth, 10), bottom: parseInt(e.borderBottomWidth, 10), left: parseInt(e.borderLeftWidth, 10) };
      }
      const Wc = ["top", "right", "bottom", "left", "width", "height"];
      class Dt {
        constructor(e) {
          const t = ao(e);
          if (Object.defineProperty(this, "_source", { value: e._source || e, writable: !0, enumerable: !1 }), Bn(e) || t)
            Vs(this, t ? Dt.getDomRangeRects(e)[0] : e.getBoundingClientRect());
          else if (io(e)) {
            const { innerWidth: n, innerHeight: i } = e;
            Vs(this, { top: 0, right: n, bottom: i, left: 0, width: n, height: i });
          } else
            Vs(this, e);
        }
        clone() {
          return new Dt(this);
        }
        moveTo(e, t) {
          return this.top = t, this.right = e + this.width, this.bottom = t + this.height, this.left = e, this;
        }
        moveBy(e, t) {
          return this.top += t, this.right += e, this.left += e, this.bottom += t, this;
        }
        getIntersection(e) {
          const t = { top: Math.max(this.top, e.top), right: Math.min(this.right, e.right), bottom: Math.min(this.bottom, e.bottom), left: Math.max(this.left, e.left) };
          return t.width = t.right - t.left, t.height = t.bottom - t.top, t.width < 0 || t.height < 0 ? null : new Dt(t);
        }
        getIntersectionArea(e) {
          const t = this.getIntersection(e);
          return t ? t.getArea() : 0;
        }
        getArea() {
          return this.width * this.height;
        }
        getVisible() {
          const e = this._source;
          let t = this.clone();
          if (!Yc(e)) {
            let n = e.parentNode || e.commonAncestorContainer;
            for (; n && !Yc(n); ) {
              const i = new Dt(n), s = t.getIntersection(i);
              if (!s)
                return null;
              s.getArea() < t.getArea() && (t = s), n = n.parentNode;
            }
          }
          return t;
        }
        isEqual(e) {
          for (const t of Wc)
            if (this[t] !== e[t])
              return !1;
          return !0;
        }
        contains(e) {
          const t = this.getIntersection(e);
          return !(!t || !t.isEqual(e));
        }
        excludeScrollbarsAndBorders() {
          const e = this._source;
          let t, n;
          if (io(e))
            t = e.innerWidth - e.document.documentElement.clientWidth, n = e.innerHeight - e.document.documentElement.clientHeight;
          else {
            const i = Hc(this._source);
            t = e.offsetWidth - e.clientWidth, n = e.offsetHeight - e.clientHeight, this.moveBy(i.left, i.top);
          }
          return this.width -= t, this.right -= t, this.height -= n, this.bottom -= n, this;
        }
        static getDomRangeRects(e) {
          const t = [], n = Array.from(e.getClientRects());
          if (n.length)
            for (const i of n)
              t.push(new Dt(i));
          else {
            let i = e.startContainer;
            $t(i) && (i = i.parentNode);
            const s = new Dt(i.getBoundingClientRect());
            s.right = s.left, s.width = 0, t.push(s);
          }
          return t;
        }
      }
      function Vs(o, e) {
        for (const t of Wc)
          o[t] = e[t];
      }
      function Yc(o) {
        return !!Bn(o) && o === o.ownerDocument.body;
      }
      function qc({ target: o, viewportOffset: e = 0 }) {
        const t = Us(o);
        let n = t, i = null;
        for (; n; ) {
          Gc(Jc(n == t ? o : i), () => eu(o, n));
          const s = eu(o, n);
          if (Pv(n, s, e), n.parent != n) {
            if (i = n.frameElement, n = n.parent, !i)
              return;
          } else
            n = null;
        }
      }
      function Pv(o, e, t) {
        const n = e.clone().moveBy(0, t), i = e.clone().moveBy(0, -t), s = new Dt(o).excludeScrollbarsAndBorders();
        if (![i, n].every((l) => s.contains(l))) {
          let { scrollX: l, scrollY: d } = o;
          Kc(i, s) ? d -= s.top - e.top + t : Zc(n, s) && (d += e.bottom - s.bottom + t), Xc(e, s) ? l -= s.left - e.left + t : Qc(e, s) && (l += e.right - s.right + t), o.scrollTo(l, d);
        }
      }
      function Gc(o, e) {
        const t = Us(o);
        let n, i;
        for (; o != t.document.body; )
          i = e(), (n = new Dt(o).excludeScrollbarsAndBorders()).contains(i) || (Kc(i, n) ? o.scrollTop -= n.top - i.top : Zc(i, n) && (o.scrollTop += i.bottom - n.bottom), Xc(i, n) ? o.scrollLeft -= n.left - i.left : Qc(i, n) && (o.scrollLeft += i.right - n.right)), o = o.parentNode;
      }
      function Zc(o, e) {
        return o.bottom > e.bottom;
      }
      function Kc(o, e) {
        return o.top < e.top;
      }
      function Xc(o, e) {
        return o.left < e.left;
      }
      function Qc(o, e) {
        return o.right > e.right;
      }
      function Us(o) {
        return ao(o) ? o.startContainer.ownerDocument.defaultView : o.ownerDocument.defaultView;
      }
      function Jc(o) {
        if (ao(o)) {
          let e = o.commonAncestorContainer;
          return $t(e) && (e = e.parentNode), e;
        }
        return o.parentNode;
      }
      function eu(o, e) {
        const t = Us(o), n = new Dt(o);
        if (t === e)
          return n;
        {
          let i = t;
          for (; i != e; ) {
            const s = i.frameElement, l = new Dt(s).excludeScrollbarsAndBorders();
            n.moveBy(l.left, l.top), i = i.parent;
          }
        }
        return n;
      }
      Object.assign({}, { scrollViewportToShowTarget: qc, scrollAncestorsToShowTarget: function(o) {
        Gc(Jc(o), () => new Dt(o));
      } });
      class tu {
        constructor() {
          this.document = new Ms(), this.domConverter = new no(), this.domRoots = /* @__PURE__ */ new Map(), this.set("isRenderingInProgress", !1), this._renderer = new Ic(this.domConverter, this.document.selection), this._renderer.bind("isFocused").to(this.document), this._initialDomRootAttributes = /* @__PURE__ */ new WeakMap(), this._observers = /* @__PURE__ */ new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new gc(this.document), this.addObserver($c), this.addObserver(Av), this.addObserver(Tv), this.addObserver(mv), this.addObserver(Cv), this.addObserver(Iv), un.isAndroid && this.addObserver(Ev), function(e) {
            e.document.on("keydown", zg);
          }(this), Dg(this), this.on("render", () => {
            this._render(), this.document.fire("layoutChanged"), this._hasChangedSinceTheLastRendering = !1;
          }), this.listenTo(this.document.selection, "change", () => {
            this._hasChangedSinceTheLastRendering = !0;
          });
        }
        attachDomRoot(e, t = "main") {
          const n = this.document.getRoot(t);
          n._name = e.tagName.toLowerCase();
          const i = {};
          for (const { name: l, value: d } of Array.from(e.attributes))
            i[l] = d, l === "class" ? this._writer.addClass(d.split(" "), n) : this._writer.setAttribute(l, d, n);
          this._initialDomRootAttributes.set(e, i);
          const s = () => {
            this._writer.setAttribute("contenteditable", !n.isReadOnly, n), n.isReadOnly ? this._writer.addClass("ck-read-only", n) : this._writer.removeClass("ck-read-only", n);
          };
          s(), this.domRoots.set(t, e), this.domConverter.bindElements(e, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(e.ownerDocument), n.on("change:children", (l, d) => this._renderer.markToSync("children", d)), n.on("change:attributes", (l, d) => this._renderer.markToSync("attributes", d)), n.on("change:text", (l, d) => this._renderer.markToSync("text", d)), n.on("change:isReadOnly", () => this.change(s)), n.on("change", () => {
            this._hasChangedSinceTheLastRendering = !0;
          });
          for (const l of this._observers.values())
            l.observe(e, t);
        }
        detachDomRoot(e) {
          const t = this.domRoots.get(e);
          Array.from(t.attributes).forEach(({ name: i }) => t.removeAttribute(i));
          const n = this._initialDomRootAttributes.get(t);
          for (const i in n)
            t.setAttribute(i, n[i]);
          this.domRoots.delete(e), this.domConverter.unbindDomElement(t);
        }
        getDomRoot(e = "main") {
          return this.domRoots.get(e);
        }
        addObserver(e) {
          let t = this._observers.get(e);
          if (t)
            return t;
          t = new e(this), this._observers.set(e, t);
          for (const [n, i] of this.domRoots)
            t.observe(i, n);
          return t.enable(), t;
        }
        getObserver(e) {
          return this._observers.get(e);
        }
        disableObservers() {
          for (const e of this._observers.values())
            e.disable();
        }
        enableObservers() {
          for (const e of this._observers.values())
            e.enable();
        }
        scrollToTheSelection() {
          const e = this.document.selection.getFirstRange();
          e && qc({ target: this.domConverter.viewRangeToDom(e), viewportOffset: 20 });
        }
        focus() {
          if (!this.document.isFocused) {
            const e = this.document.selection.editableElement;
            e && (this.domConverter.focus(e), this.forceRender());
          }
        }
        change(e) {
          if (this.isRenderingInProgress || this._postFixersInProgress)
            throw new V.b("cannot-change-view-tree: Attempting to make changes to the view when it is in an incorrect state: rendering or post-fixers are in progress. This may cause some unexpected behavior and inconsistency between the DOM and the view.", this);
          if (this._ongoingChange)
            return e(this._writer);
          this._ongoingChange = !0;
          const t = e(this._writer);
          return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), t;
        }
        forceRender() {
          this._hasChangedSinceTheLastRendering = !0, this.change(() => {
          });
        }
        destroy() {
          for (const e of this._observers.values())
            e.destroy();
          this.document.destroy(), this.stopListening();
        }
        createPositionAt(e, t) {
          return be._createAt(e, t);
        }
        createPositionAfter(e) {
          return be._createAfter(e);
        }
        createPositionBefore(e) {
          return be._createBefore(e);
        }
        createRange(e, t) {
          return new ze(e, t);
        }
        createRangeOn(e) {
          return ze._createOn(e);
        }
        createRangeIn(e) {
          return ze._createIn(e);
        }
        createSelection(e, t, n) {
          return new bn(e, t, n);
        }
        _disableRendering(e) {
          this._renderingDisabled = e, e == 0 && this.change(() => {
          });
        }
        _render() {
          this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
        }
      }
      function xi(o) {
        return _(o) ? Jl(o) : new Map(o);
      }
      $e(tu, xt);
      class Si {
        constructor(e) {
          this.parent = null, this._attrs = xi(e);
        }
        get index() {
          let e;
          if (!this.parent)
            return null;
          if ((e = this.parent.getChildIndex(this)) === null)
            throw new V.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return e;
        }
        get startOffset() {
          let e;
          if (!this.parent)
            return null;
          if ((e = this.parent.getChildStartOffset(this)) === null)
            throw new V.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return e;
        }
        get offsetSize() {
          return 1;
        }
        get endOffset() {
          return this.parent ? this.startOffset + this.offsetSize : null;
        }
        get nextSibling() {
          const e = this.index;
          return e !== null && this.parent.getChild(e + 1) || null;
        }
        get previousSibling() {
          const e = this.index;
          return e !== null && this.parent.getChild(e - 1) || null;
        }
        get root() {
          let e = this;
          for (; e.parent; )
            e = e.parent;
          return e;
        }
        get document() {
          return this.root == this ? null : this.root.document || null;
        }
        getPath() {
          const e = [];
          let t = this;
          for (; t.parent; )
            e.unshift(t.startOffset), t = t.parent;
          return e;
        }
        getAncestors(e = { includeSelf: !1, parentFirst: !1 }) {
          const t = [];
          let n = e.includeSelf ? this : this.parent;
          for (; n; )
            t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return t;
        }
        getCommonAncestor(e, t = {}) {
          const n = this.getAncestors(t), i = e.getAncestors(t);
          let s = 0;
          for (; n[s] == i[s] && n[s]; )
            s++;
          return s === 0 ? null : n[s - 1];
        }
        isBefore(e) {
          if (this == e || this.root !== e.root)
            return !1;
          const t = this.getPath(), n = e.getPath(), i = Kt(t, n);
          switch (i) {
            case "prefix":
              return !0;
            case "extension":
              return !1;
            default:
              return t[i] < n[i];
          }
        }
        isAfter(e) {
          return this != e && this.root === e.root && !this.isBefore(e);
        }
        hasAttribute(e) {
          return this._attrs.has(e);
        }
        getAttribute(e) {
          return this._attrs.get(e);
        }
        getAttributes() {
          return this._attrs.entries();
        }
        getAttributeKeys() {
          return this._attrs.keys();
        }
        toJSON() {
          const e = {};
          return this._attrs.size && (e.attributes = Array.from(this._attrs).reduce((t, n) => (t[n[0]] = n[1], t), {})), e;
        }
        is(e) {
          return e == "node" || e == "model:node";
        }
        _clone() {
          return new Si(this._attrs);
        }
        _remove() {
          this.parent._removeChildren(this.index);
        }
        _setAttribute(e, t) {
          this._attrs.set(e, t);
        }
        _setAttributesTo(e) {
          this._attrs = xi(e);
        }
        _removeAttribute(e) {
          return this._attrs.delete(e);
        }
        _clearAttributes() {
          this._attrs.clear();
        }
      }
      class nt extends Si {
        constructor(e, t) {
          super(t), this._data = e || "";
        }
        get offsetSize() {
          return this.data.length;
        }
        get data() {
          return this._data;
        }
        is(e) {
          return e == "text" || e == "model:text" || super.is(e);
        }
        toJSON() {
          const e = super.toJSON();
          return e.data = this.data, e;
        }
        _clone() {
          return new nt(this.data, this.getAttributes());
        }
        static fromJSON(e) {
          return new nt(e.data, e.attributes);
        }
      }
      class Mn {
        constructor(e, t, n) {
          if (this.textNode = e, t < 0 || t > e.offsetSize)
            throw new V.b("model-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
          if (n < 0 || t + n > e.offsetSize)
            throw new V.b("model-textproxy-wrong-length: Given length value is incorrect.", this);
          this.data = e.data.substring(t, t + n), this.offsetInText = t;
        }
        get startOffset() {
          return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null;
        }
        get offsetSize() {
          return this.data.length;
        }
        get endOffset() {
          return this.startOffset !== null ? this.startOffset + this.offsetSize : null;
        }
        get isPartial() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
        get parent() {
          return this.textNode.parent;
        }
        get root() {
          return this.textNode.root;
        }
        get document() {
          return this.textNode.document;
        }
        is(e) {
          return e == "textProxy" || e == "model:textProxy";
        }
        getPath() {
          const e = this.textNode.getPath();
          return e.length > 0 && (e[e.length - 1] += this.offsetInText), e;
        }
        getAncestors(e = { includeSelf: !1, parentFirst: !1 }) {
          const t = [];
          let n = e.includeSelf ? this : this.parent;
          for (; n; )
            t[e.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return t;
        }
        hasAttribute(e) {
          return this.textNode.hasAttribute(e);
        }
        getAttribute(e) {
          return this.textNode.getAttribute(e);
        }
        getAttributes() {
          return this.textNode.getAttributes();
        }
        getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }
      class zi {
        constructor(e) {
          this._nodes = [], e && this._insertNodes(0, e);
        }
        [Symbol.iterator]() {
          return this._nodes[Symbol.iterator]();
        }
        get length() {
          return this._nodes.length;
        }
        get maxOffset() {
          return this._nodes.reduce((e, t) => e + t.offsetSize, 0);
        }
        getNode(e) {
          return this._nodes[e] || null;
        }
        getNodeIndex(e) {
          const t = this._nodes.indexOf(e);
          return t == -1 ? null : t;
        }
        getNodeStartOffset(e) {
          const t = this.getNodeIndex(e);
          return t === null ? null : this._nodes.slice(0, t).reduce((n, i) => n + i.offsetSize, 0);
        }
        indexToOffset(e) {
          if (e == this._nodes.length)
            return this.maxOffset;
          const t = this._nodes[e];
          if (!t)
            throw new V.b("model-nodelist-index-out-of-bounds: Given index cannot be found in the node list.", this);
          return this.getNodeStartOffset(t);
        }
        offsetToIndex(e) {
          let t = 0;
          for (const n of this._nodes) {
            if (e >= t && e < t + n.offsetSize)
              return this.getNodeIndex(n);
            t += n.offsetSize;
          }
          if (t != e)
            throw new V.b("model-nodelist-offset-out-of-bounds: Given offset cannot be found in the node list.", this, { offset: e, nodeList: this });
          return this.length;
        }
        _insertNodes(e, t) {
          for (const n of t)
            if (!(n instanceof Si))
              throw new V.b("model-nodelist-insertNodes-not-node: Trying to insert an object which is not a Node instance.", this);
          this._nodes.splice(e, 0, ...t);
        }
        _removeNodes(e, t = 1) {
          return this._nodes.splice(e, t);
        }
        toJSON() {
          return this._nodes.map((e) => e.toJSON());
        }
      }
      class it extends Si {
        constructor(e, t, n) {
          super(t), this.name = e, this._children = new zi(), n && this._insertChild(0, n);
        }
        get childCount() {
          return this._children.length;
        }
        get maxOffset() {
          return this._children.maxOffset;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        is(e, t = null) {
          const n = e.replace(/^model:/, "");
          return t ? n == "element" && t == this.name : n == "element" || n == this.name || super.is(e);
        }
        getChild(e) {
          return this._children.getNode(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        getChildIndex(e) {
          return this._children.getNodeIndex(e);
        }
        getChildStartOffset(e) {
          return this._children.getNodeStartOffset(e);
        }
        offsetToIndex(e) {
          return this._children.offsetToIndex(e);
        }
        getNodeByPath(e) {
          let t = this;
          for (const n of e)
            t = t.getChild(t.offsetToIndex(n));
          return t;
        }
        toJSON() {
          const e = super.toJSON();
          if (e.name = this.name, this._children.length > 0) {
            e.children = [];
            for (const t of this._children)
              e.children.push(t.toJSON());
          }
          return e;
        }
        _clone(e = !1) {
          const t = e ? Array.from(this._children).map((n) => n._clone(!0)) : null;
          return new it(this.name, this.getAttributes(), t);
        }
        _appendChild(e) {
          this._insertChild(this.childCount, e);
        }
        _insertChild(e, t) {
          const n = function(i) {
            return typeof i == "string" ? [new nt(i)] : (Hn(i) || (i = [i]), Array.from(i).map((s) => typeof s == "string" ? new nt(s) : s instanceof Mn ? new nt(s.data, s.getAttributes()) : s));
          }(t);
          for (const i of n)
            i.parent !== null && i._remove(), i.parent = this;
          this._children._insertNodes(e, n);
        }
        _removeChildren(e, t = 1) {
          const n = this._children._removeNodes(e, t);
          for (const i of n)
            i.parent = null;
          return n;
        }
        static fromJSON(e) {
          let t = null;
          if (e.children) {
            t = [];
            for (const n of e.children)
              n.name ? t.push(it.fromJSON(n)) : t.push(nt.fromJSON(n));
          }
          return new it(e.name, e.attributes, t);
        }
      }
      class qn {
        constructor(e = {}) {
          if (!e.boundaries && !e.startPosition)
            throw new V.b("model-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
          const t = e.direction || "forward";
          if (t != "forward" && t != "backward")
            throw new V.b("model-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", e, { direction: t });
          this.direction = t, this.boundaries = e.boundaries || null, e.startPosition ? this.position = e.startPosition.clone() : this.position = le._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!e.singleCharacters, this.shallow = !!e.shallow, this.ignoreElementEnd = !!e.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
        }
        [Symbol.iterator]() {
          return this;
        }
        skip(e) {
          let t, n, i, s;
          do
            i = this.position, s = this._visitedParent, { done: t, value: n } = this.next();
          while (!t && e(n));
          t || (this.position = i, this._visitedParent = s);
        }
        next() {
          return this.direction == "forward" ? this._next() : this._previous();
        }
        _next() {
          const e = this.position, t = this.position.clone(), n = this._visitedParent;
          if (n.parent === null && t.offset === n.maxOffset)
            return { done: !0 };
          if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset)
            return { done: !0 };
          const i = t.textNode ? t.textNode : t.nodeAfter;
          if (i instanceof it)
            return this.shallow ? t.offset++ : (t.path.push(0), this._visitedParent = i), this.position = t, Ci("elementStart", i, e, t, 1);
          if (i instanceof nt) {
            let s;
            if (this.singleCharacters)
              s = 1;
            else {
              let f = i.endOffset;
              this._boundaryEndParent == n && this.boundaries.end.offset < f && (f = this.boundaries.end.offset), s = f - t.offset;
            }
            const l = t.offset - i.startOffset, d = new Mn(i, l, s);
            return t.offset += s, this.position = t, Ci("text", d, e, t, s);
          }
          return t.path.pop(), t.offset++, this.position = t, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : Ci("elementEnd", n, e, t);
        }
        _previous() {
          const e = this.position, t = this.position.clone(), n = this._visitedParent;
          if (n.parent === null && t.offset === 0)
            return { done: !0 };
          if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset)
            return { done: !0 };
          const i = t.textNode ? t.textNode : t.nodeBefore;
          if (i instanceof it)
            return t.offset--, this.shallow ? (this.position = t, Ci("elementStart", i, e, t, 1)) : (t.path.push(i.maxOffset), this.position = t, this._visitedParent = i, this.ignoreElementEnd ? this._previous() : Ci("elementEnd", i, e, t));
          if (i instanceof nt) {
            let s;
            if (this.singleCharacters)
              s = 1;
            else {
              let f = i.startOffset;
              this._boundaryStartParent == n && this.boundaries.start.offset > f && (f = this.boundaries.start.offset), s = t.offset - f;
            }
            const l = t.offset - i.startOffset, d = new Mn(i, l - s, s);
            return t.offset -= s, this.position = t, Ci("text", d, e, t, s);
          }
          return t.path.pop(), this.position = t, this._visitedParent = n.parent, Ci("elementStart", n, e, t, 1);
        }
      }
      function Ci(o, e, t, n, i) {
        return { done: !1, value: { type: o, item: e, previousPosition: t, nextPosition: n, length: i } };
      }
      var Mv = function(o) {
        var e = o == null ? 0 : o.length;
        return e ? o[e - 1] : void 0;
      };
      class le {
        constructor(e, t, n = "toNone") {
          if (!e.is("element") && !e.is("documentFragment"))
            throw new V.b("model-position-root-invalid: Position root invalid.", e);
          if (!(t instanceof Array) || t.length === 0)
            throw new V.b("model-position-path-incorrect-format: Position path must be an array with at least one item.", e, { path: t });
          t = e.getPath().concat(t), e = e.root, this.root = e, this.path = t, this.stickiness = n;
        }
        get offset() {
          return Mv(this.path);
        }
        set offset(e) {
          this.path[this.path.length - 1] = e;
        }
        get parent() {
          let e = this.root;
          for (let t = 0; t < this.path.length - 1; t++)
            if (!(e = e.getChild(e.offsetToIndex(this.path[t]))))
              throw new V.b("model-position-path-incorrect: The position's path is incorrect.", this, { position: this });
          if (e.is("text"))
            throw new V.b("model-position-path-incorrect: The position's path is incorrect.", this, { position: this });
          return e;
        }
        get index() {
          return this.parent.offsetToIndex(this.offset);
        }
        get textNode() {
          const e = this.parent.getChild(this.index);
          return e instanceof nt && e.startOffset < this.offset ? e : null;
        }
        get nodeAfter() {
          return this.textNode === null ? this.parent.getChild(this.index) : null;
        }
        get nodeBefore() {
          return this.textNode === null ? this.parent.getChild(this.index - 1) : null;
        }
        get isAtStart() {
          return this.offset === 0;
        }
        get isAtEnd() {
          return this.offset == this.parent.maxOffset;
        }
        compareWith(e) {
          if (this.root != e.root)
            return "different";
          const t = Kt(this.path, e.path);
          switch (t) {
            case "same":
              return "same";
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return this.path[t] < e.path[t] ? "before" : "after";
          }
        }
        getLastMatchingPosition(e, t = {}) {
          t.startPosition = this;
          const n = new qn(t);
          return n.skip(e), n.position;
        }
        getParentPath() {
          return this.path.slice(0, -1);
        }
        getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({ includeSelf: !0 });
        }
        getCommonPath(e) {
          if (this.root != e.root)
            return [];
          const t = Kt(this.path, e.path), n = typeof t == "string" ? Math.min(this.path.length, e.path.length) : t;
          return this.path.slice(0, n);
        }
        getCommonAncestor(e) {
          const t = this.getAncestors(), n = e.getAncestors();
          let i = 0;
          for (; t[i] == n[i] && t[i]; )
            i++;
          return i === 0 ? null : t[i - 1];
        }
        getShiftedBy(e) {
          const t = this.clone(), n = t.offset + e;
          return t.offset = n < 0 ? 0 : n, t;
        }
        isAfter(e) {
          return this.compareWith(e) == "after";
        }
        isBefore(e) {
          return this.compareWith(e) == "before";
        }
        isEqual(e) {
          return this.compareWith(e) == "same";
        }
        isTouching(e) {
          let t = null, n = null;
          switch (this.compareWith(e)) {
            case "same":
              return !0;
            case "before":
              t = le._createAt(this), n = le._createAt(e);
              break;
            case "after":
              t = le._createAt(e), n = le._createAt(this);
              break;
            default:
              return !1;
          }
          let i = t.parent;
          for (; t.path.length + n.path.length; ) {
            if (t.isEqual(n))
              return !0;
            if (t.path.length > n.path.length) {
              if (t.offset !== i.maxOffset)
                return !1;
              t.path = t.path.slice(0, -1), i = i.parent, t.offset++;
            } else {
              if (n.offset !== 0)
                return !1;
              n.path = n.path.slice(0, -1);
            }
          }
        }
        is(e) {
          return e == "position" || e == "model:position";
        }
        hasSameParentAs(e) {
          return this.root !== e.root ? !1 : Kt(this.getParentPath(), e.getParentPath()) == "same";
        }
        getTransformedByOperation(e) {
          let t;
          switch (e.type) {
            case "insert":
              t = this._getTransformedByInsertOperation(e);
              break;
            case "move":
            case "remove":
            case "reinsert":
              t = this._getTransformedByMoveOperation(e);
              break;
            case "split":
              t = this._getTransformedBySplitOperation(e);
              break;
            case "merge":
              t = this._getTransformedByMergeOperation(e);
              break;
            default:
              t = le._createAt(this);
          }
          return t;
        }
        _getTransformedByInsertOperation(e) {
          return this._getTransformedByInsertion(e.position, e.howMany);
        }
        _getTransformedByMoveOperation(e) {
          return this._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
        }
        _getTransformedBySplitOperation(e) {
          const t = e.movedRange;
          return t.containsPosition(this) || t.start.isEqual(this) && this.stickiness == "toNext" ? this._getCombined(e.splitPosition, e.moveTargetPosition) : e.graveyardPosition ? this._getTransformedByMove(e.graveyardPosition, e.insertionPosition, 1) : this._getTransformedByInsertion(e.insertionPosition, 1);
        }
        _getTransformedByMergeOperation(e) {
          const t = e.movedRange;
          let n;
          return t.containsPosition(this) || t.start.isEqual(this) ? (n = this._getCombined(e.sourcePosition, e.targetPosition), e.sourcePosition.isBefore(e.targetPosition) && (n = n._getTransformedByDeletion(e.deletionPosition, 1))) : n = this.isEqual(e.deletionPosition) ? le._createAt(e.deletionPosition) : this._getTransformedByMove(e.deletionPosition, e.graveyardPosition, 1), n;
        }
        _getTransformedByDeletion(e, t) {
          const n = le._createAt(this);
          if (this.root != e.root)
            return n;
          if (Kt(e.getParentPath(), this.getParentPath()) == "same") {
            if (e.offset < this.offset) {
              if (e.offset + t > this.offset)
                return null;
              n.offset -= t;
            }
          } else if (Kt(e.getParentPath(), this.getParentPath()) == "prefix") {
            const i = e.path.length - 1;
            if (e.offset <= this.path[i]) {
              if (e.offset + t > this.path[i])
                return null;
              n.path[i] -= t;
            }
          }
          return n;
        }
        _getTransformedByInsertion(e, t) {
          const n = le._createAt(this);
          if (this.root != e.root)
            return n;
          if (Kt(e.getParentPath(), this.getParentPath()) == "same")
            (e.offset < this.offset || e.offset == this.offset && this.stickiness != "toPrevious") && (n.offset += t);
          else if (Kt(e.getParentPath(), this.getParentPath()) == "prefix") {
            const i = e.path.length - 1;
            e.offset <= this.path[i] && (n.path[i] += t);
          }
          return n;
        }
        _getTransformedByMove(e, t, n) {
          if (t = t._getTransformedByDeletion(e, n), e.isEqual(t))
            return le._createAt(this);
          const i = this._getTransformedByDeletion(e, n);
          return i === null || e.isEqual(this) && this.stickiness == "toNext" || e.getShiftedBy(n).isEqual(this) && this.stickiness == "toPrevious" ? this._getCombined(e, t) : i._getTransformedByInsertion(t, n);
        }
        _getCombined(e, t) {
          const n = e.path.length - 1, i = le._createAt(t);
          return i.stickiness = this.stickiness, i.offset = i.offset + this.path[n] - e.offset, i.path = i.path.concat(this.path.slice(n + 1)), i;
        }
        toJSON() {
          return { root: this.root.toJSON(), path: Array.from(this.path), stickiness: this.stickiness };
        }
        clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
        static _createAt(e, t, n = "toNone") {
          if (e instanceof le)
            return new le(e.root, e.path, e.stickiness);
          {
            const i = e;
            if (t == "end")
              t = i.maxOffset;
            else {
              if (t == "before")
                return this._createBefore(i, n);
              if (t == "after")
                return this._createAfter(i, n);
              if (t !== 0 && !t)
                throw new V.b("model-createPositionAt-offset-required: Model#createPositionAt() requires the offset when the first parameter is a model item.", [this, e]);
            }
            if (!i.is("element") && !i.is("documentFragment"))
              throw new V.b("model-position-parent-incorrect: Position parent have to be a element or document fragment.", [this, e]);
            const s = i.getPath();
            return s.push(t), new this(i.root, s, n);
          }
        }
        static _createAfter(e, t) {
          if (!e.parent)
            throw new V.b("model-position-after-root: You cannot make a position after root.", [this, e], { root: e });
          return this._createAt(e.parent, e.endOffset, t);
        }
        static _createBefore(e, t) {
          if (!e.parent)
            throw new V.b("model-position-before-root: You cannot make a position before root.", e, { root: e });
          return this._createAt(e.parent, e.startOffset, t);
        }
        static fromJSON(e, t) {
          if (e.root === "$graveyard") {
            const n = new le(t.graveyard, e.path);
            return n.stickiness = e.stickiness, n;
          }
          if (!t.getRoot(e.root))
            throw new V.b("model-position-fromjson-no-root: Cannot create position for document. Root with specified name does not exist.", t, { rootName: e.root });
          return new le(t.getRoot(e.root), e.path, e.stickiness);
        }
      }
      class ie {
        constructor(e, t = null) {
          this.start = le._createAt(e), this.end = t ? le._createAt(t) : le._createAt(e), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
        }
        *[Symbol.iterator]() {
          yield* new qn({ boundaries: this, ignoreElementEnd: !0 });
        }
        get isCollapsed() {
          return this.start.isEqual(this.end);
        }
        get isFlat() {
          return Kt(this.start.getParentPath(), this.end.getParentPath()) == "same";
        }
        get root() {
          return this.start.root;
        }
        containsPosition(e) {
          return e.isAfter(this.start) && e.isBefore(this.end);
        }
        containsRange(e, t = !1) {
          e.isCollapsed && (t = !1);
          const n = this.containsPosition(e.start) || t && this.start.isEqual(e.start), i = this.containsPosition(e.end) || t && this.end.isEqual(e.end);
          return n && i;
        }
        containsItem(e) {
          const t = le._createBefore(e);
          return this.containsPosition(t) || this.start.isEqual(t);
        }
        is(e) {
          return e == "range" || e == "model:range";
        }
        isEqual(e) {
          return this.start.isEqual(e.start) && this.end.isEqual(e.end);
        }
        isIntersecting(e) {
          return this.start.isBefore(e.end) && this.end.isAfter(e.start);
        }
        getDifference(e) {
          const t = [];
          return this.isIntersecting(e) ? (this.containsPosition(e.start) && t.push(new ie(this.start, e.start)), this.containsPosition(e.end) && t.push(new ie(e.end, this.end))) : t.push(new ie(this.start, this.end)), t;
        }
        getIntersection(e) {
          if (this.isIntersecting(e)) {
            let t = this.start, n = this.end;
            return this.containsPosition(e.start) && (t = e.start), this.containsPosition(e.end) && (n = e.end), new ie(t, n);
          }
          return null;
        }
        getMinimalFlatRanges() {
          const e = [], t = this.start.getCommonPath(this.end).length, n = le._createAt(this.start);
          let i = n.parent;
          for (; n.path.length > t + 1; ) {
            const s = i.maxOffset - n.offset;
            s !== 0 && e.push(new ie(n, n.getShiftedBy(s))), n.path = n.path.slice(0, -1), n.offset++, i = i.parent;
          }
          for (; n.path.length <= this.end.path.length; ) {
            const s = this.end.path[n.path.length - 1], l = s - n.offset;
            l !== 0 && e.push(new ie(n, n.getShiftedBy(l))), n.offset = s, n.path.push(0);
          }
          return e;
        }
        getWalker(e = {}) {
          return e.boundaries = this, new qn(e);
        }
        *getItems(e = {}) {
          e.boundaries = this, e.ignoreElementEnd = !0;
          const t = new qn(e);
          for (const n of t)
            yield n.item;
        }
        *getPositions(e = {}) {
          e.boundaries = this;
          const t = new qn(e);
          yield t.position;
          for (const n of t)
            yield n.nextPosition;
        }
        getTransformedByOperation(e) {
          switch (e.type) {
            case "insert":
              return this._getTransformedByInsertOperation(e);
            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(e);
            case "split":
              return [this._getTransformedBySplitOperation(e)];
            case "merge":
              return [this._getTransformedByMergeOperation(e)];
          }
          return [new ie(this.start, this.end)];
        }
        getTransformedByOperations(e) {
          const t = [new ie(this.start, this.end)];
          for (const n of e)
            for (let i = 0; i < t.length; i++) {
              const s = t[i].getTransformedByOperation(n);
              t.splice(i, 1, ...s), i += s.length - 1;
            }
          for (let n = 0; n < t.length; n++) {
            const i = t[n];
            for (let s = n + 1; s < t.length; s++) {
              const l = t[s];
              (i.containsRange(l) || l.containsRange(i) || i.isEqual(l)) && t.splice(s, 1);
            }
          }
          return t;
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
        toJSON() {
          return { start: this.start.toJSON(), end: this.end.toJSON() };
        }
        clone() {
          return new this.constructor(this.start, this.end);
        }
        _getTransformedByInsertOperation(e, t = !1) {
          return this._getTransformedByInsertion(e.position, e.howMany, t);
        }
        _getTransformedByMoveOperation(e, t = !1) {
          const n = e.sourcePosition, i = e.howMany, s = e.targetPosition;
          return this._getTransformedByMove(n, s, i, t);
        }
        _getTransformedBySplitOperation(e) {
          const t = this.start._getTransformedBySplitOperation(e);
          let n = this.end._getTransformedBySplitOperation(e);
          return this.end.isEqual(e.insertionPosition) && (n = this.end.getShiftedBy(1)), t.root != n.root && (n = this.end.getShiftedBy(-1)), new ie(t, n);
        }
        _getTransformedByMergeOperation(e) {
          if (this.start.isEqual(e.targetPosition) && this.end.isEqual(e.deletionPosition))
            return new ie(this.start);
          let t = this.start._getTransformedByMergeOperation(e), n = this.end._getTransformedByMergeOperation(e);
          return t.root != n.root && (n = this.end.getShiftedBy(-1)), t.isAfter(n) ? (e.sourcePosition.isBefore(e.targetPosition) ? (t = le._createAt(n)).offset = 0 : (e.deletionPosition.isEqual(t) || (n = e.deletionPosition), t = e.targetPosition), new ie(t, n)) : new ie(t, n);
        }
        _getTransformedByInsertion(e, t, n = !1) {
          if (n && this.containsPosition(e))
            return [new ie(this.start, e), new ie(e.getShiftedBy(t), this.end._getTransformedByInsertion(e, t))];
          {
            const i = new ie(this.start, this.end);
            return i.start = i.start._getTransformedByInsertion(e, t), i.end = i.end._getTransformedByInsertion(e, t), [i];
          }
        }
        _getTransformedByMove(e, t, n, i = !1) {
          if (this.isCollapsed) {
            const b = this.start._getTransformedByMove(e, t, n);
            return [new ie(b)];
          }
          const s = ie._createFromPositionAndShift(e, n), l = t._getTransformedByDeletion(e, n);
          if (this.containsPosition(t) && !i && (s.containsPosition(this.start) || s.containsPosition(this.end))) {
            const b = this.start._getTransformedByMove(e, t, n), y = this.end._getTransformedByMove(e, t, n);
            return [new ie(b, y)];
          }
          let d;
          const f = this.getDifference(s);
          let m = null;
          const g = this.getIntersection(s);
          if (f.length == 1 ? m = new ie(f[0].start._getTransformedByDeletion(e, n), f[0].end._getTransformedByDeletion(e, n)) : f.length == 2 && (m = new ie(this.start, this.end._getTransformedByDeletion(e, n))), d = m ? m._getTransformedByInsertion(l, n, g !== null || i) : [], g) {
            const b = new ie(g.start._getCombined(s.start, l), g.end._getCombined(s.start, l));
            d.length == 2 ? d.splice(1, 0, b) : d.push(b);
          }
          return d;
        }
        _getTransformedByDeletion(e, t) {
          let n = this.start._getTransformedByDeletion(e, t), i = this.end._getTransformedByDeletion(e, t);
          return n == null && i == null ? null : (n == null && (n = e), i == null && (i = e), new ie(n, i));
        }
        static _createFromPositionAndShift(e, t) {
          const n = e, i = e.getShiftedBy(t);
          return t > 0 ? new this(n, i) : new this(i, n);
        }
        static _createIn(e) {
          return new this(le._createAt(e, 0), le._createAt(e, e.maxOffset));
        }
        static _createOn(e) {
          return this._createFromPositionAndShift(le._createBefore(e), e.offsetSize);
        }
        static _createFromRanges(e) {
          if (e.length === 0)
            throw new V.b("range-create-from-ranges-empty-array: At least one range has to be passed.", null);
          if (e.length == 1)
            return e[0].clone();
          const t = e[0];
          e.sort((s, l) => s.start.isAfter(l.start) ? 1 : -1);
          const n = e.indexOf(t), i = new this(t.start, t.end);
          if (n > 0)
            for (let s = n - 1; e[s].end.isEqual(i.start); s++)
              i.start = le._createAt(e[s].start);
          for (let s = n + 1; s < e.length && e[s].start.isEqual(i.end); s++)
            i.end = le._createAt(e[s].end);
          return i;
        }
        static fromJSON(e, t) {
          return new this(le.fromJSON(e.start, t), le.fromJSON(e.end, t));
        }
      }
      class Hs {
        constructor() {
          this._modelToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelLengthCallbacks = /* @__PURE__ */ new Map(), this._markerNameToElements = /* @__PURE__ */ new Map(), this._elementToMarkerNames = /* @__PURE__ */ new Map(), this._unboundMarkerNames = /* @__PURE__ */ new Set(), this.on("modelToViewPosition", (e, t) => {
            if (t.viewPosition)
              return;
            const n = this._modelToViewMapping.get(t.modelPosition.parent);
            t.viewPosition = this._findPositionIn(n, t.modelPosition.offset);
          }, { priority: "low" }), this.on("viewToModelPosition", (e, t) => {
            if (t.modelPosition)
              return;
            const n = this.findMappedViewAncestor(t.viewPosition), i = this._viewToModelMapping.get(n), s = this._toModelOffset(t.viewPosition.parent, t.viewPosition.offset, n);
            t.modelPosition = le._createAt(i, s);
          }, { priority: "low" });
        }
        bindElements(e, t) {
          this._modelToViewMapping.set(e, t), this._viewToModelMapping.set(t, e);
        }
        unbindViewElement(e) {
          const t = this.toModelElement(e);
          if (this._viewToModelMapping.delete(e), this._elementToMarkerNames.has(e))
            for (const n of this._elementToMarkerNames.get(e))
              this._unboundMarkerNames.add(n);
          this._modelToViewMapping.get(t) == e && this._modelToViewMapping.delete(t);
        }
        unbindModelElement(e) {
          const t = this.toViewElement(e);
          this._modelToViewMapping.delete(e), this._viewToModelMapping.get(t) == e && this._viewToModelMapping.delete(t);
        }
        bindElementToMarker(e, t) {
          const n = this._markerNameToElements.get(t) || /* @__PURE__ */ new Set();
          n.add(e);
          const i = this._elementToMarkerNames.get(e) || /* @__PURE__ */ new Set();
          i.add(t), this._markerNameToElements.set(t, n), this._elementToMarkerNames.set(e, i);
        }
        unbindElementFromMarkerName(e, t) {
          const n = this._markerNameToElements.get(t);
          n && (n.delete(e), n.size == 0 && this._markerNameToElements.delete(t));
          const i = this._elementToMarkerNames.get(e);
          i && (i.delete(t), i.size == 0 && this._elementToMarkerNames.delete(e));
        }
        flushUnboundMarkerNames() {
          const e = Array.from(this._unboundMarkerNames);
          return this._unboundMarkerNames.clear(), e;
        }
        clearBindings() {
          this._modelToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelMapping = /* @__PURE__ */ new WeakMap(), this._markerNameToElements = /* @__PURE__ */ new Map(), this._elementToMarkerNames = /* @__PURE__ */ new Map(), this._unboundMarkerNames = /* @__PURE__ */ new Set();
        }
        toModelElement(e) {
          return this._viewToModelMapping.get(e);
        }
        toViewElement(e) {
          return this._modelToViewMapping.get(e);
        }
        toModelRange(e) {
          return new ie(this.toModelPosition(e.start), this.toModelPosition(e.end));
        }
        toViewRange(e) {
          return new ze(this.toViewPosition(e.start), this.toViewPosition(e.end));
        }
        toModelPosition(e) {
          const t = { viewPosition: e, mapper: this };
          return this.fire("viewToModelPosition", t), t.modelPosition;
        }
        toViewPosition(e, t = { isPhantom: !1 }) {
          const n = { modelPosition: e, mapper: this, isPhantom: t.isPhantom };
          return this.fire("modelToViewPosition", n), n.viewPosition;
        }
        markerNameToElements(e) {
          const t = this._markerNameToElements.get(e);
          if (!t)
            return null;
          const n = /* @__PURE__ */ new Set();
          for (const i of t)
            if (i.is("attributeElement"))
              for (const s of i.getElementsWithSameId())
                n.add(s);
            else
              n.add(i);
          return n;
        }
        registerViewToModelLength(e, t) {
          this._viewToModelLengthCallbacks.set(e, t);
        }
        findMappedViewAncestor(e) {
          let t = e.parent;
          for (; !this._viewToModelMapping.has(t); )
            t = t.parent;
          return t;
        }
        _toModelOffset(e, t, n) {
          if (n != e)
            return this._toModelOffset(e.parent, e.index, n) + this._toModelOffset(e, t, e);
          if (e.is("text"))
            return t;
          let i = 0;
          for (let s = 0; s < t; s++)
            i += this.getModelLength(e.getChild(s));
          return i;
        }
        getModelLength(e) {
          if (this._viewToModelLengthCallbacks.get(e.name))
            return this._viewToModelLengthCallbacks.get(e.name)(e);
          if (this._viewToModelMapping.has(e))
            return 1;
          if (e.is("text"))
            return e.data.length;
          if (e.is("uiElement"))
            return 0;
          {
            let t = 0;
            for (const n of e.getChildren())
              t += this.getModelLength(n);
            return t;
          }
        }
        _findPositionIn(e, t) {
          let n, i = 0, s = 0, l = 0;
          if (e.is("text"))
            return new be(e, t);
          for (; s < t; )
            n = e.getChild(l), s += i = this.getModelLength(n), l++;
          return s == t ? this._moveViewPositionToTextNode(new be(e, l)) : this._findPositionIn(n, t - (s - i));
        }
        _moveViewPositionToTextNode(e) {
          const t = e.nodeBefore, n = e.nodeAfter;
          return t instanceof rt ? new be(t, t.data.length) : n instanceof rt ? new be(n, 0) : e;
        }
      }
      $e(Hs, dt);
      class lo {
        constructor() {
          this._consumable = /* @__PURE__ */ new Map(), this._textProxyRegistry = /* @__PURE__ */ new Map();
        }
        add(e, t) {
          t = co(t), e instanceof Mn && (e = this._getSymbolForTextProxy(e)), this._consumable.has(e) || this._consumable.set(e, /* @__PURE__ */ new Map()), this._consumable.get(e).set(t, !0);
        }
        consume(e, t) {
          return t = co(t), e instanceof Mn && (e = this._getSymbolForTextProxy(e)), !!this.test(e, t) && (this._consumable.get(e).set(t, !1), !0);
        }
        test(e, t) {
          t = co(t), e instanceof Mn && (e = this._getSymbolForTextProxy(e));
          const n = this._consumable.get(e);
          if (n === void 0)
            return null;
          const i = n.get(t);
          return i === void 0 ? null : i;
        }
        revert(e, t) {
          t = co(t), e instanceof Mn && (e = this._getSymbolForTextProxy(e));
          const n = this.test(e, t);
          return n === !1 ? (this._consumable.get(e).set(t, !0), !0) : n !== !0 && null;
        }
        _getSymbolForTextProxy(e) {
          let t = null;
          const n = this._textProxyRegistry.get(e.startOffset);
          if (n) {
            const i = n.get(e.endOffset);
            i && (t = i.get(e.parent));
          }
          return t || (t = this._addSymbolForTextProxy(e.startOffset, e.endOffset, e.parent)), t;
        }
        _addSymbolForTextProxy(e, t, n) {
          const i = Symbol("textProxySymbol");
          let s, l;
          return (s = this._textProxyRegistry.get(e)) || (s = /* @__PURE__ */ new Map(), this._textProxyRegistry.set(e, s)), (l = s.get(t)) || (l = /* @__PURE__ */ new Map(), s.set(t, l)), l.set(n, i), i;
        }
      }
      function co(o) {
        const e = o.split(":");
        return e.length > 1 ? e[0] + ":" + e[1] : e[0];
      }
      class Ws {
        constructor(e) {
          this.conversionApi = Ri({ dispatcher: this }, e);
        }
        convertChanges(e, t, n) {
          for (const i of e.getMarkersToRemove())
            this.convertMarkerRemove(i.name, i.range, n);
          for (const i of e.getChanges())
            i.type == "insert" ? this.convertInsert(ie._createFromPositionAndShift(i.position, i.length), n) : i.type == "remove" ? this.convertRemove(i.position, i.length, i.name, n) : this.convertAttribute(i.range, i.attributeKey, i.attributeOldValue, i.attributeNewValue, n);
          for (const i of this.conversionApi.mapper.flushUnboundMarkerNames()) {
            const s = t.get(i).getRange();
            this.convertMarkerRemove(i, s, n), this.convertMarkerAdd(i, s, n);
          }
          for (const i of e.getMarkersToAdd())
            this.convertMarkerAdd(i.name, i.range, n);
        }
        convertInsert(e, t) {
          this.conversionApi.writer = t, this.conversionApi.consumable = this._createInsertConsumable(e);
          for (const n of e) {
            const i = n.item, s = { item: i, range: ie._createFromPositionAndShift(n.previousPosition, n.length) };
            this._testAndFire("insert", s);
            for (const l of i.getAttributeKeys())
              s.attributeKey = l, s.attributeOldValue = null, s.attributeNewValue = i.getAttribute(l), this._testAndFire(`attribute:${l}`, s);
          }
          this._clearConversionApi();
        }
        convertRemove(e, t, n, i) {
          this.conversionApi.writer = i, this.fire("remove:" + n, { position: e, length: t }, this.conversionApi), this._clearConversionApi();
        }
        convertAttribute(e, t, n, i, s) {
          this.conversionApi.writer = s, this.conversionApi.consumable = this._createConsumableForRange(e, `attribute:${t}`);
          for (const l of e) {
            const d = { item: l.item, range: ie._createFromPositionAndShift(l.previousPosition, l.length), attributeKey: t, attributeOldValue: n, attributeNewValue: i };
            this._testAndFire(`attribute:${t}`, d);
          }
          this._clearConversionApi();
        }
        convertSelection(e, t, n) {
          const i = Array.from(t.getMarkersAtPosition(e.getFirstPosition()));
          if (this.conversionApi.writer = n, this.conversionApi.consumable = this._createSelectionConsumable(e, i), this.fire("selection", { selection: e }, this.conversionApi), e.isCollapsed) {
            for (const s of i) {
              const l = s.getRange();
              if (!Ov(e.getFirstPosition(), s, this.conversionApi.mapper))
                continue;
              const d = { item: e, markerName: s.name, markerRange: l };
              this.conversionApi.consumable.test(e, "addMarker:" + s.name) && this.fire("addMarker:" + s.name, d, this.conversionApi);
            }
            for (const s of e.getAttributeKeys()) {
              const l = { item: e, range: e.getFirstRange(), attributeKey: s, attributeOldValue: null, attributeNewValue: e.getAttribute(s) };
              this.conversionApi.consumable.test(e, "attribute:" + l.attributeKey) && this.fire("attribute:" + l.attributeKey + ":$text", l, this.conversionApi);
            }
            this._clearConversionApi();
          }
        }
        convertMarkerAdd(e, t, n) {
          if (!t.root.document || t.root.rootName == "$graveyard")
            return;
          this.conversionApi.writer = n;
          const i = "addMarker:" + e, s = new lo();
          if (s.add(t, i), this.conversionApi.consumable = s, this.fire(i, { markerName: e, markerRange: t }, this.conversionApi), s.test(t, i)) {
            this.conversionApi.consumable = this._createConsumableForRange(t, i);
            for (const l of t.getItems()) {
              if (!this.conversionApi.consumable.test(l, i))
                continue;
              const d = { item: l, range: ie._createOn(l), markerName: e, markerRange: t };
              this.fire(i, d, this.conversionApi);
            }
            this._clearConversionApi();
          }
        }
        convertMarkerRemove(e, t, n) {
          t.root.document && t.root.rootName != "$graveyard" && (this.conversionApi.writer = n, this.fire("removeMarker:" + e, { markerName: e, markerRange: t }, this.conversionApi), this._clearConversionApi());
        }
        _createInsertConsumable(e) {
          const t = new lo();
          for (const n of e) {
            const i = n.item;
            t.add(i, "insert");
            for (const s of i.getAttributeKeys())
              t.add(i, "attribute:" + s);
          }
          return t;
        }
        _createConsumableForRange(e, t) {
          const n = new lo();
          for (const i of e.getItems())
            n.add(i, t);
          return n;
        }
        _createSelectionConsumable(e, t) {
          const n = new lo();
          n.add(e, "selection");
          for (const i of t)
            n.add(e, "addMarker:" + i.name);
          for (const i of e.getAttributeKeys())
            n.add(e, "attribute:" + i);
          return n;
        }
        _testAndFire(e, t) {
          if (!this.conversionApi.consumable.test(t.item, e))
            return;
          const n = t.item.name || "$text";
          this.fire(e + ":" + n, t, this.conversionApi);
        }
        _clearConversionApi() {
          delete this.conversionApi.writer, delete this.conversionApi.consumable;
        }
      }
      function Ov(o, e, t) {
        const n = e.getRange(), i = Array.from(o.getAncestors());
        return i.shift(), i.reverse(), !i.some((s) => {
          if (n.containsItem(s))
            return !!t.toViewElement(s).getCustomProperty("addHighlight");
        });
      }
      $e(Ws, dt);
      class On {
        constructor(e, t, n) {
          this._lastRangeBackward = !1, this._ranges = [], this._attrs = /* @__PURE__ */ new Map(), e && this.setTo(e, t, n);
        }
        get anchor() {
          if (this._ranges.length > 0) {
            const e = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? e.end : e.start;
          }
          return null;
        }
        get focus() {
          if (this._ranges.length > 0) {
            const e = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? e.start : e.end;
          }
          return null;
        }
        get isCollapsed() {
          return this._ranges.length === 1 && this._ranges[0].isCollapsed;
        }
        get rangeCount() {
          return this._ranges.length;
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
        isEqual(e) {
          if (this.rangeCount != e.rangeCount)
            return !1;
          if (this.rangeCount === 0)
            return !0;
          if (!this.anchor.isEqual(e.anchor) || !this.focus.isEqual(e.focus))
            return !1;
          for (const t of this._ranges) {
            let n = !1;
            for (const i of e._ranges)
              if (t.isEqual(i)) {
                n = !0;
                break;
              }
            if (!n)
              return !1;
          }
          return !0;
        }
        *getRanges() {
          for (const e of this._ranges)
            yield new ie(e.start, e.end);
        }
        getFirstRange() {
          let e = null;
          for (const t of this._ranges)
            e && !t.start.isBefore(e.start) || (e = t);
          return e ? new ie(e.start, e.end) : null;
        }
        getLastRange() {
          let e = null;
          for (const t of this._ranges)
            e && !t.end.isAfter(e.end) || (e = t);
          return e ? new ie(e.start, e.end) : null;
        }
        getFirstPosition() {
          const e = this.getFirstRange();
          return e ? e.start.clone() : null;
        }
        getLastPosition() {
          const e = this.getLastRange();
          return e ? e.end.clone() : null;
        }
        setTo(e, t, n) {
          if (e === null)
            this._setRanges([]);
          else if (e instanceof On)
            this._setRanges(e.getRanges(), e.isBackward);
          else if (e && typeof e.getRanges == "function")
            this._setRanges(e.getRanges(), e.isBackward);
          else if (e instanceof ie)
            this._setRanges([e], !!t && !!t.backward);
          else if (e instanceof le)
            this._setRanges([new ie(e)]);
          else if (e instanceof Si) {
            const i = !!n && !!n.backward;
            let s;
            if (t == "in")
              s = ie._createIn(e);
            else if (t == "on")
              s = ie._createOn(e);
            else {
              if (t === void 0)
                throw new V.b("model-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", [this, e]);
              s = new ie(le._createAt(e, t));
            }
            this._setRanges([s], i);
          } else {
            if (!Hn(e))
              throw new V.b("model-selection-setTo-not-selectable: Cannot set the selection to the given place.", [this, e]);
            this._setRanges(e, t && !!t.backward);
          }
        }
        _setRanges(e, t = !1) {
          const n = (e = Array.from(e)).some((i) => {
            if (!(i instanceof ie))
              throw new V.b("model-selection-set-ranges-not-range: Selection range set to an object that is not an instance of model.Range.", [this, e]);
            return this._ranges.every((s) => !s.isEqual(i));
          });
          if (e.length !== this._ranges.length || n) {
            this._removeAllRanges();
            for (const i of e)
              this._pushRange(i);
            this._lastRangeBackward = !!t, this.fire("change:range", { directChange: !0 });
          }
        }
        setFocus(e, t) {
          if (this.anchor === null)
            throw new V.b("model-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", [this, e]);
          const n = le._createAt(e, t);
          if (n.compareWith(this.focus) == "same")
            return;
          const i = this.anchor;
          this._ranges.length && this._popRange(), n.compareWith(i) == "before" ? (this._pushRange(new ie(n, i)), this._lastRangeBackward = !0) : (this._pushRange(new ie(i, n)), this._lastRangeBackward = !1), this.fire("change:range", { directChange: !0 });
        }
        getAttribute(e) {
          return this._attrs.get(e);
        }
        getAttributes() {
          return this._attrs.entries();
        }
        getAttributeKeys() {
          return this._attrs.keys();
        }
        hasAttribute(e) {
          return this._attrs.has(e);
        }
        removeAttribute(e) {
          this.hasAttribute(e) && (this._attrs.delete(e), this.fire("change:attribute", { attributeKeys: [e], directChange: !0 }));
        }
        setAttribute(e, t) {
          this.getAttribute(e) !== t && (this._attrs.set(e, t), this.fire("change:attribute", { attributeKeys: [e], directChange: !0 }));
        }
        getSelectedElement() {
          if (this.rangeCount !== 1)
            return null;
          const e = this.getFirstRange(), t = e.start.nodeAfter, n = e.end.nodeBefore;
          return t instanceof it && t == n ? t : null;
        }
        is(e) {
          return e == "selection" || e == "model:selection";
        }
        *getSelectedBlocks() {
          const e = /* @__PURE__ */ new WeakSet();
          for (const t of this.getRanges()) {
            const n = iu(t.start, e);
            n && (yield n);
            for (const s of t.getWalker())
              s.type == "elementEnd" && nu(s.item, e) && (yield s.item);
            const i = iu(t.end, e);
            i && !t.end.isTouching(le._createAt(i, 0)) && (yield i);
          }
        }
        *getTopMostBlocks() {
          const e = Array.from(this.getSelectedBlocks());
          for (const t of e) {
            const n = Dv(t);
            n && e.includes(n) || (yield t);
          }
        }
        containsEntireContent(e = this.anchor.root) {
          const t = le._createAt(e, 0), n = le._createAt(e, "end");
          return t.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
        }
        _pushRange(e) {
          this._checkRange(e), this._ranges.push(new ie(e.start, e.end));
        }
        _checkRange(e) {
          for (let t = 0; t < this._ranges.length; t++)
            if (e.isIntersecting(this._ranges[t]))
              throw new V.b("model-selection-range-intersects: Trying to add a range that intersects with another range in the selection.", [this, e], { addedRange: e, intersectingRange: this._ranges[t] });
        }
        _removeAllRanges() {
          for (; this._ranges.length > 0; )
            this._popRange();
        }
        _popRange() {
          this._ranges.pop();
        }
      }
      function nu(o, e) {
        return !e.has(o) && (e.add(o), o.document.model.schema.isBlock(o) && o.parent);
      }
      function iu(o, e) {
        const t = o.parent.document.model.schema, n = o.parent.getAncestors({ parentFirst: !0, includeSelf: !0 });
        let i = !1;
        const s = n.find((l) => !i && !(i = t.isLimit(l)) && nu(l, e));
        return n.forEach((l) => e.add(l)), s;
      }
      function Dv(o) {
        const e = o.document.model.schema;
        let t = o.parent;
        for (; t; ) {
          if (e.isBlock(t))
            return t;
          t = t.parent;
        }
      }
      $e(On, dt);
      class ai extends ie {
        constructor(e, t) {
          super(e, t), function() {
            this.listenTo(this.root.document.model, "applyOperation", (n, i) => {
              const s = i[0];
              s.isDocumentOperation && function(l) {
                const d = this.getTransformedByOperation(l), f = ie._createFromRanges(d), m = !f.isEqual(this), g = function(y, C) {
                  switch (C.type) {
                    case "insert":
                      return y.containsPosition(C.position);
                    case "move":
                    case "remove":
                    case "reinsert":
                    case "merge":
                      return y.containsPosition(C.sourcePosition) || y.start.isEqual(C.sourcePosition) || y.containsPosition(C.targetPosition);
                    case "split":
                      return y.containsPosition(C.splitPosition) || y.containsPosition(C.insertionPosition);
                  }
                  return !1;
                }(this, l);
                let b = null;
                if (m) {
                  f.root.rootName == "$graveyard" && (b = l.type == "remove" ? l.sourcePosition : l.deletionPosition);
                  const y = this.toRange();
                  this.start = f.start, this.end = f.end, this.fire("change:range", y, { deletionPosition: b });
                } else
                  g && this.fire("change:content", this.toRange(), { deletionPosition: b });
              }.call(this, s);
            }, { priority: "low" });
          }.call(this);
        }
        detach() {
          this.stopListening();
        }
        is(e) {
          return e == "liveRange" || e == "model:liveRange" || super.is(e);
        }
        toRange() {
          return new ie(this.start, this.end);
        }
        static fromRange(e) {
          return new ai(e.start, e.end);
        }
      }
      $e(ai, dt);
      const dr = "selection:";
      class wn {
        constructor(e) {
          this._selection = new Nv(e), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this);
        }
        get isCollapsed() {
          return this._selection.isCollapsed;
        }
        get anchor() {
          return this._selection.anchor;
        }
        get focus() {
          return this._selection.focus;
        }
        get rangeCount() {
          return this._selection.rangeCount;
        }
        get hasOwnRange() {
          return this._selection.hasOwnRange;
        }
        get isBackward() {
          return this._selection.isBackward;
        }
        get isGravityOverridden() {
          return this._selection.isGravityOverridden;
        }
        get markers() {
          return this._selection.markers;
        }
        get _ranges() {
          return this._selection._ranges;
        }
        getRanges() {
          return this._selection.getRanges();
        }
        getFirstPosition() {
          return this._selection.getFirstPosition();
        }
        getLastPosition() {
          return this._selection.getLastPosition();
        }
        getFirstRange() {
          return this._selection.getFirstRange();
        }
        getLastRange() {
          return this._selection.getLastRange();
        }
        getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
        getTopMostBlocks() {
          return this._selection.getTopMostBlocks();
        }
        getSelectedElement() {
          return this._selection.getSelectedElement();
        }
        containsEntireContent(e) {
          return this._selection.containsEntireContent(e);
        }
        destroy() {
          this._selection.destroy();
        }
        getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
        getAttributes() {
          return this._selection.getAttributes();
        }
        getAttribute(e) {
          return this._selection.getAttribute(e);
        }
        hasAttribute(e) {
          return this._selection.hasAttribute(e);
        }
        refresh() {
          this._selection._updateMarkers(), this._selection._updateAttributes(!1);
        }
        is(e) {
          return e == "selection" || e == "model:selection" || e == "documentSelection" || e == "model:documentSelection";
        }
        _setFocus(e, t) {
          this._selection.setFocus(e, t);
        }
        _setTo(e, t, n) {
          this._selection.setTo(e, t, n);
        }
        _setAttribute(e, t) {
          this._selection.setAttribute(e, t);
        }
        _removeAttribute(e) {
          this._selection.removeAttribute(e);
        }
        _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
        _overrideGravity() {
          return this._selection.overrideGravity();
        }
        _restoreGravity(e) {
          this._selection.restoreGravity(e);
        }
        static _getStoreAttributeKey(e) {
          return dr + e;
        }
        static _isStoreAttributeKey(e) {
          return e.startsWith(dr);
        }
      }
      $e(wn, dt);
      class Nv extends On {
        constructor(e) {
          super(), this.markers = new _n({ idProperty: "name" }), this._model = e.model, this._document = e, this._attributePriority = /* @__PURE__ */ new Map(), this._fixGraveyardRangesData = [], this._hasChangedRange = !1, this._overriddenGravityRegister = /* @__PURE__ */ new Set(), this.listenTo(this._model, "applyOperation", (t, n) => {
            const i = n[0];
            if (i.isDocumentOperation && i.type != "marker" && i.type != "rename" && i.type != "noop") {
              for (; this._fixGraveyardRangesData.length; ) {
                const { liveRange: s, sourcePosition: l } = this._fixGraveyardRangesData.shift();
                this._fixGraveyardSelection(s, l);
              }
              this._hasChangedRange && (this._hasChangedRange = !1, this.fire("change:range", { directChange: !1 }));
            }
          }, { priority: "lowest" }), this.on("change:range", () => {
            for (const t of this.getRanges())
              if (!this._document._validateSelectionRange(t))
                throw new V.b("document-selection-wrong-position: Range from document selection starts or ends at incorrect position.", this, { range: t });
          }), this.listenTo(this._model.markers, "update", () => this._updateMarkers()), this.listenTo(this._document, "change", (t, n) => {
            (function(i, s) {
              const l = i.document.differ;
              for (const d of l.getChanges()) {
                if (d.type != "insert")
                  continue;
                const f = d.position.parent;
                d.length === f.maxOffset && i.enqueueChange(s, (g) => {
                  const b = Array.from(f.getAttributeKeys()).filter((y) => y.startsWith(dr));
                  for (const y of b)
                    g.removeAttribute(y, f);
                });
              }
            })(this._model, n);
          });
        }
        get isCollapsed() {
          return this._ranges.length === 0 ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
        }
        get anchor() {
          return super.anchor || this._document._getDefaultRange().start;
        }
        get focus() {
          return super.focus || this._document._getDefaultRange().end;
        }
        get rangeCount() {
          return this._ranges.length ? this._ranges.length : 1;
        }
        get hasOwnRange() {
          return this._ranges.length > 0;
        }
        get isGravityOverridden() {
          return !!this._overriddenGravityRegister.size;
        }
        destroy() {
          for (let e = 0; e < this._ranges.length; e++)
            this._ranges[e].detach();
          this.stopListening();
        }
        *getRanges() {
          this._ranges.length ? yield* super.getRanges() : yield this._document._getDefaultRange();
        }
        getFirstRange() {
          return super.getFirstRange() || this._document._getDefaultRange();
        }
        getLastRange() {
          return super.getLastRange() || this._document._getDefaultRange();
        }
        setTo(e, t, n) {
          super.setTo(e, t, n), this._updateAttributes(!0);
        }
        setFocus(e, t) {
          super.setFocus(e, t), this._updateAttributes(!0);
        }
        setAttribute(e, t) {
          if (this._setAttribute(e, t)) {
            const n = [e];
            this.fire("change:attribute", { attributeKeys: n, directChange: !0 });
          }
        }
        removeAttribute(e) {
          if (this._removeAttribute(e)) {
            const t = [e];
            this.fire("change:attribute", { attributeKeys: t, directChange: !0 });
          }
        }
        overrideGravity() {
          const e = Vn();
          return this._overriddenGravityRegister.add(e), this._overriddenGravityRegister.size === 1 && this._updateAttributes(!0), e;
        }
        restoreGravity(e) {
          if (!this._overriddenGravityRegister.has(e))
            throw new V.b("document-selection-gravity-wrong-restore: Attempting to restore the selection gravity for an unknown UID.", this, { uid: e });
          this._overriddenGravityRegister.delete(e), this.isGravityOverridden || this._updateAttributes(!0);
        }
        _popRange() {
          this._ranges.pop().detach();
        }
        _pushRange(e) {
          const t = this._prepareRange(e);
          t && this._ranges.push(t);
        }
        _prepareRange(e) {
          if (this._checkRange(e), e.root == this._document.graveyard)
            return;
          const t = ai.fromRange(e);
          return t.on("change:range", (n, i, s) => {
            this._hasChangedRange = !0, t.root == this._document.graveyard && this._fixGraveyardRangesData.push({ liveRange: t, sourcePosition: s.deletionPosition });
          }), t;
        }
        _updateMarkers() {
          const e = [];
          for (const t of this._model.markers) {
            const n = t.getRange();
            for (const i of this.getRanges())
              n.containsRange(i, !i.isCollapsed) && e.push(t);
          }
          for (const t of e)
            this.markers.has(t) || this.markers.add(t);
          for (const t of Array.from(this.markers))
            e.includes(t) || this.markers.remove(t);
        }
        _updateAttributes(e) {
          const t = xi(this._getSurroundingAttributes()), n = xi(this.getAttributes());
          if (e)
            this._attributePriority = /* @__PURE__ */ new Map(), this._attrs = /* @__PURE__ */ new Map();
          else
            for (const [s, l] of this._attributePriority)
              l == "low" && (this._attrs.delete(s), this._attributePriority.delete(s));
          this._setAttributesTo(t);
          const i = [];
          for (const [s, l] of this.getAttributes())
            n.has(s) && n.get(s) === l || i.push(s);
          for (const [s] of n)
            this.hasAttribute(s) || i.push(s);
          i.length > 0 && this.fire("change:attribute", { attributeKeys: i, directChange: !1 });
        }
        _setAttribute(e, t, n = !0) {
          const i = n ? "normal" : "low";
          return (i != "low" || this._attributePriority.get(e) != "normal") && super.getAttribute(e) !== t && (this._attrs.set(e, t), this._attributePriority.set(e, i), !0);
        }
        _removeAttribute(e, t = !0) {
          const n = t ? "normal" : "low";
          return (n != "low" || this._attributePriority.get(e) != "normal") && (this._attributePriority.set(e, n), !!super.hasAttribute(e) && (this._attrs.delete(e), !0));
        }
        _setAttributesTo(e) {
          const t = /* @__PURE__ */ new Set();
          for (const [n, i] of this.getAttributes())
            e.get(n) !== i && this._removeAttribute(n, !1);
          for (const [n, i] of e)
            this._setAttribute(n, i, !1) && t.add(n);
          return t;
        }
        *_getStoredAttributes() {
          const e = this.getFirstPosition().parent;
          if (this.isCollapsed && e.isEmpty)
            for (const t of e.getAttributeKeys())
              t.startsWith(dr) && (yield [t.substr(dr.length), e.getAttribute(t)]);
        }
        _getSurroundingAttributes() {
          const e = this.getFirstPosition(), t = this._model.schema;
          let n = null;
          if (this.isCollapsed) {
            const i = e.textNode ? e.textNode : e.nodeBefore, s = e.textNode ? e.textNode : e.nodeAfter;
            if (this.isGravityOverridden || (n = uo(i)), n || (n = uo(s)), !this.isGravityOverridden && !n) {
              let l = i;
              for (; l && !n; )
                n = uo(l = l.previousSibling);
            }
            if (!n) {
              let l = s;
              for (; l && !n; )
                n = uo(l = l.nextSibling);
            }
            n || (n = this._getStoredAttributes());
          } else {
            const i = this.getFirstRange();
            for (const s of i) {
              if (s.item.is("element") && t.isObject(s.item))
                break;
              if (s.type == "text") {
                n = s.item.getAttributes();
                break;
              }
            }
          }
          return n;
        }
        _fixGraveyardSelection(e, t) {
          const n = t.clone(), i = this._model.schema.getNearestSelectionRange(n), s = this._ranges.indexOf(e);
          if (this._ranges.splice(s, 1), e.detach(), i) {
            const l = this._prepareRange(i);
            this._ranges.splice(s, 0, l);
          }
        }
      }
      function uo(o) {
        return o instanceof Mn || o instanceof nt ? o.getAttributes() : null;
      }
      class ru {
        constructor(e) {
          this._dispatchers = e;
        }
        add(e) {
          for (const t of this._dispatchers)
            e(t);
          return this;
        }
      }
      var Rv = 1, Lv = 4, li = function(o) {
        return ks(o, Rv | Lv);
      };
      class Fv extends ru {
        elementToElement(e) {
          return this.add(function(t) {
            return (t = li(t)).view = ho(t.view, "container"), (n) => {
              n.on("insert:" + t.model, function(i) {
                return (s, l, d) => {
                  const f = i(l.item, d.writer);
                  if (!f || !d.consumable.consume(l.item, "insert"))
                    return;
                  const m = d.mapper.toViewPosition(l.range.start);
                  d.mapper.bindElements(l.item, f), d.writer.insert(m, f);
                };
              }(t.view), { priority: t.converterPriority || "normal" });
            };
          }(e));
        }
        attributeToElement(e) {
          return this.add(function(t) {
            let n = "attribute:" + ((t = li(t)).model.key ? t.model.key : t.model);
            if (t.model.name && (n += ":" + t.model.name), t.model.values)
              for (const s of t.model.values)
                t.view[s] = ho(t.view[s], "attribute");
            else
              t.view = ho(t.view, "attribute");
            const i = su(t);
            return (s) => {
              s.on(n, function(l) {
                return (d, f, m) => {
                  const g = l(f.attributeOldValue, m.writer), b = l(f.attributeNewValue, m.writer);
                  if (!g && !b || !m.consumable.consume(f.item, d.name))
                    return;
                  const y = m.writer, C = y.document.selection;
                  if (f.item instanceof On || f.item instanceof wn)
                    y.wrap(C.getFirstRange(), b);
                  else {
                    let O = m.mapper.toViewRange(f.range);
                    f.attributeOldValue !== null && g && (O = y.unwrap(O, g)), f.attributeNewValue !== null && b && y.wrap(O, b);
                  }
                };
              }(i), { priority: t.converterPriority || "normal" });
            };
          }(e));
        }
        attributeToAttribute(e) {
          return this.add(function(t) {
            let n = "attribute:" + ((t = li(t)).model.key ? t.model.key : t.model);
            if (t.model.name && (n += ":" + t.model.name), t.model.values)
              for (const s of t.model.values)
                t.view[s] = au(t.view[s]);
            else
              t.view = au(t.view);
            const i = su(t);
            return (s) => {
              s.on(n, function(l) {
                return (d, f, m) => {
                  const g = l(f.attributeOldValue, f), b = l(f.attributeNewValue, f);
                  if (!g && !b || !m.consumable.consume(f.item, d.name))
                    return;
                  const y = m.mapper.toViewElement(f.item), C = m.writer;
                  if (!y)
                    throw new V.b("conversion-attribute-to-attribute-on-text: Trying to convert text node's attribute with attribute-to-attribute converter.", [f, m]);
                  if (f.attributeOldValue !== null && g)
                    if (g.key == "class") {
                      const O = Array.isArray(g.value) ? g.value : [g.value];
                      for (const D of O)
                        C.removeClass(D, y);
                    } else if (g.key == "style") {
                      const O = Object.keys(g.value);
                      for (const D of O)
                        C.removeStyle(D, y);
                    } else
                      C.removeAttribute(g.key, y);
                  if (f.attributeNewValue !== null && b)
                    if (b.key == "class") {
                      const O = Array.isArray(b.value) ? b.value : [b.value];
                      for (const D of O)
                        C.addClass(D, y);
                    } else if (b.key == "style") {
                      const O = Object.keys(b.value);
                      for (const D of O)
                        C.setStyle(D, b.value[D], y);
                    } else
                      C.setAttribute(b.key, b.value, y);
                };
              }(i), { priority: t.converterPriority || "normal" });
            };
          }(e));
        }
        markerToElement(e) {
          return this.add(function(t) {
            return (t = li(t)).view = ho(t.view, "ui"), (n) => {
              n.on("addMarker:" + t.model, function(i) {
                return (s, l, d) => {
                  l.isOpening = !0;
                  const f = i(l, d.writer);
                  l.isOpening = !1;
                  const m = i(l, d.writer);
                  if (!f || !m)
                    return;
                  const g = l.markerRange;
                  if (g.isCollapsed && !d.consumable.consume(g, s.name))
                    return;
                  for (const C of g)
                    if (!d.consumable.consume(C.item, s.name))
                      return;
                  const b = d.mapper, y = d.writer;
                  y.insert(b.toViewPosition(g.start), f), d.mapper.bindElementToMarker(f, l.markerName), g.isCollapsed || (y.insert(b.toViewPosition(g.end), m), d.mapper.bindElementToMarker(m, l.markerName)), s.stop();
                };
              }(t.view), { priority: t.converterPriority || "normal" }), n.on("removeMarker:" + t.model, (t.view, (i, s, l) => {
                const d = l.mapper.markerNameToElements(s.markerName);
                if (d) {
                  for (const f of d)
                    l.mapper.unbindElementFromMarkerName(f, s.markerName), l.writer.clear(l.writer.createRangeOn(f), f);
                  l.writer.clearClonedElementsGroup(s.markerName), i.stop();
                }
              }), { priority: t.converterPriority || "normal" });
            };
          }(e));
        }
        markerToHighlight(e) {
          return this.add(function(t) {
            return (n) => {
              n.on("addMarker:" + t.model, function(i) {
                return (s, l, d) => {
                  if (!l.item || !(l.item instanceof On || l.item instanceof wn || l.item.is("textProxy")))
                    return;
                  const f = Ys(i, l, d);
                  if (!f || !d.consumable.consume(l.item, s.name))
                    return;
                  const m = ou(f), g = d.writer, b = g.document.selection;
                  if (l.item instanceof On || l.item instanceof wn)
                    g.wrap(b.getFirstRange(), m, b);
                  else {
                    const y = d.mapper.toViewRange(l.range), C = g.wrap(y, m);
                    for (const O of C.getItems())
                      if (O.is("attributeElement") && O.isSimilar(m)) {
                        d.mapper.bindElementToMarker(O, l.markerName);
                        break;
                      }
                  }
                };
              }(t.view), { priority: t.converterPriority || "normal" }), n.on("addMarker:" + t.model, function(i) {
                return (s, l, d) => {
                  if (!l.item || !(l.item instanceof it))
                    return;
                  const f = Ys(i, l, d);
                  if (!f || !d.consumable.test(l.item, s.name))
                    return;
                  const m = d.mapper.toViewElement(l.item);
                  if (m && m.getCustomProperty("addHighlight")) {
                    d.consumable.consume(l.item, s.name);
                    for (const g of ie._createIn(l.item))
                      d.consumable.consume(g.item, s.name);
                    m.getCustomProperty("addHighlight")(m, f, d.writer), d.mapper.bindElementToMarker(m, l.markerName);
                  }
                };
              }(t.view), { priority: t.converterPriority || "normal" }), n.on("removeMarker:" + t.model, function(i) {
                return (s, l, d) => {
                  if (l.markerRange.isCollapsed)
                    return;
                  const f = Ys(i, l, d);
                  if (!f)
                    return;
                  const m = ou(f), g = d.mapper.markerNameToElements(l.markerName);
                  if (g) {
                    for (const b of g)
                      d.mapper.unbindElementFromMarkerName(b, l.markerName), b.is("attributeElement") ? d.writer.unwrap(d.writer.createRangeOn(b), m) : b.getCustomProperty("removeHighlight")(b, f.id, d.writer);
                    d.writer.clearClonedElementsGroup(l.markerName), s.stop();
                  }
                };
              }(t.view), { priority: t.converterPriority || "normal" });
            };
          }(e));
        }
      }
      function ou(o) {
        const e = new yi("span", o.attributes);
        return o.classes && e._addClass(o.classes), o.priority && (e._priority = o.priority), e._id = o.id, e;
      }
      function ho(o, e) {
        return typeof o == "function" ? o : (t, n) => function(i, s, l) {
          typeof i == "string" && (i = { name: i });
          let d;
          const f = Object.assign({}, i.attributes);
          if (l == "container")
            d = s.createContainerElement(i.name, f);
          else if (l == "attribute") {
            const m = { priority: i.priority || yi.DEFAULT_PRIORITY };
            d = s.createAttributeElement(i.name, f, m);
          } else
            d = s.createUIElement(i.name, f);
          if (i.styles) {
            const m = Object.keys(i.styles);
            for (const g of m)
              s.setStyle(g, i.styles[g], d);
          }
          if (i.classes) {
            const m = i.classes;
            if (typeof m == "string")
              s.addClass(m, d);
            else
              for (const g of m)
                s.addClass(g, d);
          }
          return d;
        }(o, n, e);
      }
      function su(o) {
        return o.model.values ? (e, t) => {
          const n = o.view[e];
          return n ? n(e, t) : null;
        } : o.view;
      }
      function au(o) {
        return typeof o == "string" ? (e) => ({ key: o, value: e }) : typeof o == "object" ? o.value ? () => o : (e) => ({ key: o.key, value: e }) : o;
      }
      function Ys(o, e, t) {
        const n = typeof o == "function" ? o(e, t) : o;
        return n ? (n.priority || (n.priority = 10), n.id || (n.id = e.markerName), n) : null;
      }
      class zv extends ru {
        elementToElement(e) {
          return this.add(lu(e));
        }
        elementToAttribute(e) {
          return this.add(function(t) {
            cu(t = li(t));
            const n = uu(t, !1), i = qs(t), s = i ? "element:" + i : "element";
            return (l) => {
              l.on(s, n, { priority: t.converterPriority || "low" });
            };
          }(e));
        }
        attributeToAttribute(e) {
          return this.add(function(t) {
            let n = null;
            (typeof (t = li(t)).view == "string" || t.view.key) && (n = function(s) {
              typeof s.view == "string" && (s.view = { key: s.view });
              const l = s.view.key;
              let d;
              if (l == "class" || l == "style")
                d = { [l == "class" ? "classes" : "styles"]: s.view.value };
              else {
                const f = s.view.value === void 0 ? /[\s\S]*/ : s.view.value;
                d = { attributes: { [l]: f } };
              }
              return s.view.name && (d.name = s.view.name), s.view = d, l;
            }(t)), cu(t, n);
            const i = uu(t, !0);
            return (s) => {
              s.on("element", i, { priority: t.converterPriority || "low" });
            };
          }(e));
        }
        elementToMarker(e) {
          return this.add(function(t) {
            return function(n) {
              const i = n.model;
              n.model = (s, l) => {
                const d = typeof i == "string" ? i : i(s);
                return l.createElement("$marker", { "data-name": d });
              };
            }(t = li(t)), lu(t);
          }(e));
        }
      }
      function lu(o) {
        const e = function(i) {
          const s = i.view ? new Wn(i.view) : null;
          return (l, d, f) => {
            let m = {};
            if (s) {
              const C = s.match(d.viewItem);
              if (!C)
                return;
              m = C.match;
            }
            m.name = !0;
            const g = function(C, O, D) {
              return C instanceof Function ? C(O, D) : D.createElement(C);
            }(i.model, d.viewItem, f.writer);
            if (!g || !f.consumable.test(d.viewItem, m))
              return;
            const b = f.splitToAllowedParent(g, d.modelCursor);
            if (!b)
              return;
            f.writer.insert(g, b.position), f.convertChildren(d.viewItem, f.writer.createPositionAt(g, 0)), f.consumable.consume(d.viewItem, m);
            const y = f.getSplitParts(g);
            d.modelRange = new ie(f.writer.createPositionBefore(g), f.writer.createPositionAfter(y[y.length - 1])), b.cursorParent ? d.modelCursor = f.writer.createPositionAt(b.cursorParent, 0) : d.modelCursor = d.modelRange.end;
          };
        }(o = li(o)), t = qs(o), n = t ? "element:" + t : "element";
        return (i) => {
          i.on(n, e, { priority: o.converterPriority || "normal" });
        };
      }
      function qs(o) {
        return typeof o.view == "string" ? o.view : typeof o.view == "object" && typeof o.view.name == "string" ? o.view.name : null;
      }
      function cu(o, e = null) {
        const t = e === null || ((s) => s.getAttribute(e)), n = typeof o.model != "object" ? o.model : o.model.key, i = typeof o.model != "object" || o.model.value === void 0 ? t : o.model.value;
        o.model = { key: n, value: i };
      }
      function uu(o, e) {
        const t = new Wn(o.view);
        return (n, i, s) => {
          const l = t.match(i.viewItem);
          if (!l)
            return;
          const d = o.model.key, f = typeof o.model.value == "function" ? o.model.value(i.viewItem) : o.model.value;
          f !== null && (function(m) {
            return typeof m.view == "object" && !qs(m) ? !1 : !m.view.classes && !m.view.attributes && !m.view.styles;
          }(o) ? l.match.name = !0 : delete l.match.name, s.consumable.test(i.viewItem, l.match) && (i.modelRange || (i = Object.assign(i, s.convertChildren(i.viewItem, i.modelCursor))), function(m, g, b, y) {
            let C = !1;
            for (const O of Array.from(m.getItems({ shallow: b })))
              y.schema.checkAttribute(O, g.key) && (y.writer.setAttribute(g.key, g.value, O), C = !0);
            return C;
          }(i.modelRange, { key: d, value: f }, e, s) && s.consumable.consume(i.viewItem, l.match)));
        };
      }
      class du {
        constructor(e) {
          this.model = e, this.view = new tu(), this.mapper = new Hs(), this.downcastDispatcher = new Ws({ mapper: this.mapper });
          const t = this.model.document, n = t.selection, i = this.model.markers;
          this.listenTo(this.model, "_beforeChanges", () => {
            this.view._disableRendering(!0);
          }, { priority: "highest" }), this.listenTo(this.model, "_afterChanges", () => {
            this.view._disableRendering(!1);
          }, { priority: "lowest" }), this.listenTo(t, "change", () => {
            this.view.change((s) => {
              this.downcastDispatcher.convertChanges(t.differ, i, s), this.downcastDispatcher.convertSelection(n, i, s);
            });
          }, { priority: "low" }), this.listenTo(this.view.document, "selectionChange", function(s, l) {
            return (d, f) => {
              const m = f.newSelection, g = new On(), b = [];
              for (const y of m.getRanges())
                b.push(l.toModelRange(y));
              g.setTo(b, { backward: m.isBackward }), g.isEqual(s.document.selection) || s.change((y) => {
                y.setSelection(g);
              });
            };
          }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", (s, l, d) => {
            if (!d.consumable.consume(l.item, "insert"))
              return;
            const f = d.writer, m = d.mapper.toViewPosition(l.range.start), g = f.createText(l.item.data);
            f.insert(m, g);
          }, { priority: "lowest" }), this.downcastDispatcher.on("remove", (s, l, d) => {
            const f = d.mapper.toViewPosition(l.position), m = l.position.getShiftedBy(l.length), g = d.mapper.toViewPosition(m, { isPhantom: !0 }), b = d.writer.createRange(f, g), y = d.writer.remove(b.getTrimmed());
            for (const C of d.writer.createRangeIn(y).getItems())
              d.mapper.unbindViewElement(C);
          }, { priority: "low" }), this.downcastDispatcher.on("selection", (s, l, d) => {
            const f = d.writer, m = f.document.selection;
            for (const g of m.getRanges())
              g.isCollapsed && g.end.parent.document && d.writer.mergeAttributes(g.start);
            f.setSelection(null);
          }, { priority: "low" }), this.downcastDispatcher.on("selection", (s, l, d) => {
            const f = l.selection;
            if (f.isCollapsed || !d.consumable.consume(f, "selection"))
              return;
            const m = [];
            for (const g of f.getRanges()) {
              const b = d.mapper.toViewRange(g);
              m.push(b);
            }
            d.writer.setSelection(m, { backward: f.isBackward });
          }, { priority: "low" }), this.downcastDispatcher.on("selection", (s, l, d) => {
            const f = l.selection;
            if (!f.isCollapsed || !d.consumable.consume(f, "selection"))
              return;
            const m = d.writer, g = f.getFirstPosition(), b = d.mapper.toViewPosition(g), y = m.breakAttributes(b);
            m.setSelection(y);
          }, { priority: "low" }), this.view.document.roots.bindTo(this.model.document.roots).using((s) => {
            if (s.rootName == "$graveyard")
              return null;
            const l = new Ig(s.name);
            return l.rootName = s.rootName, l._document = this.view.document, this.mapper.bindElements(s, l), l;
          });
        }
        destroy() {
          this.view.destroy(), this.stopListening();
        }
      }
      $e(du, xt);
      class hu {
        constructor(e, t = []) {
          this._editor = e, this._availablePlugins = /* @__PURE__ */ new Map(), this._plugins = /* @__PURE__ */ new Map();
          for (const n of t)
            this._availablePlugins.set(n, n), n.pluginName && this._availablePlugins.set(n.pluginName, n);
        }
        *[Symbol.iterator]() {
          for (const e of this._plugins)
            typeof e[0] == "function" && (yield e);
        }
        get(e) {
          const t = this._plugins.get(e);
          if (!t) {
            const n = "plugincollection-plugin-not-loaded: The requested plugin is not loaded.";
            let i = e;
            throw typeof e == "function" && (i = e.pluginName || e.name), new V.b(n, this._editor, { plugin: i });
          }
          return t;
        }
        has(e) {
          return this._plugins.has(e);
        }
        init(e, t = []) {
          const n = this, i = this._editor, s = /* @__PURE__ */ new Set(), l = [], d = C(e), f = C(t), m = function(O) {
            const D = [];
            for (const oe of O)
              y(oe) || D.push(oe);
            return D.length ? D : null;
          }(e);
          if (m) {
            const O = "plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.";
            return console.error(Object(V.a)(O), { plugins: m }), Promise.reject(new V.b(O, this._editor, { plugins: m }));
          }
          return Promise.all(d.map(g)).then(() => b(l, "init")).then(() => b(l, "afterInit")).then(() => l);
          function g(O) {
            if (!f.includes(O) && !n._plugins.has(O) && !s.has(O))
              return function(D) {
                return new Promise((oe) => {
                  s.add(D), D.requires && D.requires.forEach((_e) => {
                    const De = y(_e);
                    if (t.includes(De))
                      throw new V.b("plugincollection-required: Cannot load a plugin because one of its dependencies is listed inthe `removePlugins` option.", i, { plugin: De, requiredBy: D });
                    g(De);
                  });
                  const ce = new D(i);
                  n._add(D, ce), l.push(ce), oe();
                });
              }(O).catch((D) => {
                throw console.error(Object(V.a)("plugincollection-load: It was not possible to load the plugin."), { plugin: O }), D;
              });
          }
          function b(O, D) {
            return O.reduce((oe, ce) => ce[D] ? oe.then(ce[D].bind(ce)) : oe, Promise.resolve());
          }
          function y(O) {
            return typeof O == "function" ? O : n._availablePlugins.get(O);
          }
          function C(O) {
            return O.map((D) => y(D)).filter((D) => !!D);
          }
        }
        destroy() {
          const e = Array.from(this).map(([, t]) => t).filter((t) => typeof t.destroy == "function").map((t) => t.destroy());
          return Promise.all(e);
        }
        _add(e, t) {
          this._plugins.set(e, t);
          const n = e.pluginName;
          if (n) {
            if (this._plugins.has(n))
              throw new V.b("plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.", null, { pluginName: n, plugin1: this._plugins.get(n).constructor, plugin2: e });
            this._plugins.set(n, t);
          }
        }
      }
      $e(hu, dt);
      class $v {
        constructor() {
          this._commands = /* @__PURE__ */ new Map();
        }
        add(e, t) {
          this._commands.set(e, t);
        }
        get(e) {
          return this._commands.get(e);
        }
        execute(e, ...t) {
          const n = this.get(e);
          if (!n)
            throw new V.b("commandcollection-command-not-found: Command does not exist.", this, { commandName: e });
          n.execute(...t);
        }
        *names() {
          yield* this._commands.keys();
        }
        *commands() {
          yield* this._commands.values();
        }
        [Symbol.iterator]() {
          return this._commands[Symbol.iterator]();
        }
        destroy() {
          for (const e of this.commands())
            e.destroy();
        }
      }
      function jv(o, e) {
        const t = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
        return t === 1 && (o = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]), t !== 0 && function(n, i) {
          return n in window.CKEDITOR_TRANSLATIONS && i in window.CKEDITOR_TRANSLATIONS[n];
        }(o, e) ? window.CKEDITOR_TRANSLATIONS[o][e].replace(/ \[context: [^\]]+\]$/, "") : e.replace(/ \[context: [^\]]+\]$/, "");
      }
      window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
      const Bv = ["ar", "fa", "he", "ku", "ug"];
      class Vv {
        constructor(e = {}) {
          this.uiLanguage = e.uiLanguage || "en", this.contentLanguage = e.contentLanguage || this.uiLanguage, this.uiLanguageDirection = fu(this.uiLanguage), this.contentLanguageDirection = fu(this.contentLanguage), this.t = (...t) => this._t(...t);
        }
        get language() {
          return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
        }
        _t(e, t) {
          let n = jv(this.uiLanguage, e);
          return t && (n = n.replace(/%(\d+)/g, (i, s) => s < t.length ? t[s] : i)), n;
        }
      }
      function fu(o) {
        return Bv.includes(o) ? "rtl" : "ltr";
      }
      class hr {
        constructor() {
          this._consumables = /* @__PURE__ */ new Map();
        }
        add(e, t) {
          let n;
          e.is("text") || e.is("documentFragment") ? this._consumables.set(e, !0) : (this._consumables.has(e) ? n = this._consumables.get(e) : (n = new Uv(), this._consumables.set(e, n)), n.add(t));
        }
        test(e, t) {
          const n = this._consumables.get(e);
          return n === void 0 ? null : e.is("text") || e.is("documentFragment") ? n : n.test(t);
        }
        consume(e, t) {
          return !!this.test(e, t) && (e.is("text") || e.is("documentFragment") ? this._consumables.set(e, !1) : this._consumables.get(e).consume(t), !0);
        }
        revert(e, t) {
          const n = this._consumables.get(e);
          n !== void 0 && (e.is("text") || e.is("documentFragment") ? this._consumables.set(e, !0) : n.revert(t));
        }
        static consumablesFromElement(e) {
          const t = { name: !0, attributes: [], classes: [], styles: [] }, n = e.getAttributeKeys();
          for (const l of n)
            l != "style" && l != "class" && t.attributes.push(l);
          const i = e.getClassNames();
          for (const l of i)
            t.classes.push(l);
          const s = e.getStyleNames();
          for (const l of s)
            t.styles.push(l);
          return t;
        }
        static createFrom(e, t) {
          if (t || (t = new hr()), e.is("text"))
            return t.add(e), t;
          e.is("element") && t.add(e, hr.consumablesFromElement(e)), e.is("documentFragment") && t.add(e);
          for (const n of e.getChildren())
            t = hr.createFrom(n, t);
          return t;
        }
      }
      class Uv {
        constructor() {
          this._canConsumeName = null, this._consumables = { attributes: /* @__PURE__ */ new Map(), styles: /* @__PURE__ */ new Map(), classes: /* @__PURE__ */ new Map() };
        }
        add(e) {
          e.name && (this._canConsumeName = !0);
          for (const t in this._consumables)
            t in e && this._add(t, e[t]);
        }
        test(e) {
          if (e.name && !this._canConsumeName)
            return this._canConsumeName;
          for (const t in this._consumables)
            if (t in e) {
              const n = this._test(t, e[t]);
              if (n !== !0)
                return n;
            }
          return !0;
        }
        consume(e) {
          e.name && (this._canConsumeName = !1);
          for (const t in this._consumables)
            t in e && this._consume(t, e[t]);
        }
        revert(e) {
          e.name && (this._canConsumeName = !0);
          for (const t in this._consumables)
            t in e && this._revert(t, e[t]);
        }
        _add(e, t) {
          const n = En(t) ? t : [t], i = this._consumables[e];
          for (const s of n) {
            if (e === "attributes" && (s === "class" || s === "style"))
              throw new V.b("viewconsumable-invalid-attribute: Classes and styles should be handled separately.", this);
            i.set(s, !0);
          }
        }
        _test(e, t) {
          const n = En(t) ? t : [t], i = this._consumables[e];
          for (const s of n)
            if (e !== "attributes" || s !== "class" && s !== "style") {
              const l = i.get(s);
              if (l === void 0)
                return null;
              if (!l)
                return !1;
            } else {
              const l = s == "class" ? "classes" : "styles", d = this._test(l, [...this._consumables[l].keys()]);
              if (d !== !0)
                return d;
            }
          return !0;
        }
        _consume(e, t) {
          const n = En(t) ? t : [t], i = this._consumables[e];
          for (const s of n)
            if (e !== "attributes" || s !== "class" && s !== "style")
              i.set(s, !1);
            else {
              const l = s == "class" ? "classes" : "styles";
              this._consume(l, [...this._consumables[l].keys()]);
            }
        }
        _revert(e, t) {
          const n = En(t) ? t : [t], i = this._consumables[e];
          for (const s of n)
            if (e !== "attributes" || s !== "class" && s !== "style")
              i.get(s) === !1 && i.set(s, !0);
            else {
              const l = s == "class" ? "classes" : "styles";
              this._revert(l, [...this._consumables[l].keys()]);
            }
        }
      }
      class pu {
        constructor() {
          this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", (e, t) => {
            t[0] = new Ai(t[0]);
          }, { priority: "highest" }), this.on("checkChild", (e, t) => {
            t[0] = new Ai(t[0]), t[1] = this.getDefinition(t[1]);
          }, { priority: "highest" });
        }
        register(e, t) {
          if (this._sourceDefinitions[e])
            throw new V.b("schema-cannot-register-item-twice: A single item cannot be registered twice in the schema.", this, { itemName: e });
          this._sourceDefinitions[e] = [Object.assign({}, t)], this._clearCache();
        }
        extend(e, t) {
          if (!this._sourceDefinitions[e])
            throw new V.b("schema-cannot-extend-missing-item: Cannot extend an item which was not registered yet.", this, { itemName: e });
          this._sourceDefinitions[e].push(Object.assign({}, t)), this._clearCache();
        }
        getDefinitions() {
          return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
        }
        getDefinition(e) {
          let t;
          return t = typeof e == "string" ? e : e.is && (e.is("text") || e.is("textProxy")) ? "$text" : e.name, this.getDefinitions()[t];
        }
        isRegistered(e) {
          return !!this.getDefinition(e);
        }
        isBlock(e) {
          const t = this.getDefinition(e);
          return !(!t || !t.isBlock);
        }
        isLimit(e) {
          const t = this.getDefinition(e);
          return !!t && !(!t.isLimit && !t.isObject);
        }
        isObject(e) {
          const t = this.getDefinition(e);
          return !(!t || !t.isObject);
        }
        isInline(e) {
          const t = this.getDefinition(e);
          return !(!t || !t.isInline);
        }
        checkChild(e, t) {
          return !!t && this._checkContextMatch(t, e);
        }
        checkAttribute(e, t) {
          const n = this.getDefinition(e.last);
          return !!n && n.allowAttributes.includes(t);
        }
        checkMerge(e, t = null) {
          if (e instanceof le) {
            const n = e.nodeBefore, i = e.nodeAfter;
            if (!(n instanceof it))
              throw new V.b("schema-check-merge-no-element-before: The node before the merge position must be an element.", this);
            if (!(i instanceof it))
              throw new V.b("schema-check-merge-no-element-after: The node after the merge position must be an element.", this);
            return this.checkMerge(n, i);
          }
          for (const n of t.getChildren())
            if (!this.checkChild(e, n))
              return !1;
          return !0;
        }
        addChildCheck(e) {
          this.on("checkChild", (t, [n, i]) => {
            if (!i)
              return;
            const s = e(n, i);
            typeof s == "boolean" && (t.stop(), t.return = s);
          }, { priority: "high" });
        }
        addAttributeCheck(e) {
          this.on("checkAttribute", (t, [n, i]) => {
            const s = e(n, i);
            typeof s == "boolean" && (t.stop(), t.return = s);
          }, { priority: "high" });
        }
        setAttributeProperties(e, t) {
          this._attributeProperties[e] = Object.assign(this.getAttributeProperties(e), t);
        }
        getAttributeProperties(e) {
          return this._attributeProperties[e] || {};
        }
        getLimitElement(e) {
          let t;
          for (e instanceof le ? t = e.parent : t = (e instanceof ie ? [e] : Array.from(e.getRanges())).reduce((n, i) => {
            const s = i.getCommonAncestor();
            return n ? n.getCommonAncestor(s, { includeSelf: !0 }) : s;
          }, null); !this.isLimit(t) && t.parent; )
            t = t.parent;
          return t;
        }
        checkAttributeInSelection(e, t) {
          if (e.isCollapsed) {
            const n = [...e.getFirstPosition().getAncestors(), new nt("", e.getAttributes())];
            return this.checkAttribute(n, t);
          }
          {
            const n = e.getRanges();
            for (const i of n)
              for (const s of i)
                if (this.checkAttribute(s.item, t))
                  return !0;
          }
          return !1;
        }
        *getValidRanges(e, t) {
          e = function* (n) {
            for (const i of n)
              yield* i.getMinimalFlatRanges();
          }(e);
          for (const n of e)
            yield* this._getValidRangesForRange(n, t);
        }
        getNearestSelectionRange(e, t = "both") {
          if (this.checkChild(e, "$text"))
            return new ie(e);
          let n, i;
          t != "both" && t != "backward" || (n = new qn({ startPosition: e, direction: "backward" })), t != "both" && t != "forward" || (i = new qn({ startPosition: e }));
          for (const s of function* (l, d) {
            let f = !1;
            for (; !f; ) {
              if (f = !0, l) {
                const m = l.next();
                m.done || (f = !1, yield { walker: l, value: m.value });
              }
              if (d) {
                const m = d.next();
                m.done || (f = !1, yield { walker: d, value: m.value });
              }
            }
          }(n, i)) {
            const l = s.walker == n ? "elementEnd" : "elementStart", d = s.value;
            if (d.type == l && this.isObject(d.item))
              return ie._createOn(d.item);
            if (this.checkChild(d.nextPosition, "$text"))
              return new ie(d.nextPosition);
          }
          return null;
        }
        findAllowedParent(e, t) {
          let n = e.parent;
          for (; n; ) {
            if (this.checkChild(n, t))
              return n;
            if (this.isLimit(n))
              return null;
            n = n.parent;
          }
          return null;
        }
        removeDisallowedAttributes(e, t) {
          for (const n of e) {
            for (const i of n.getAttributeKeys())
              this.checkAttribute(n, i) || t.removeAttribute(i, n);
            n.is("element") && this.removeDisallowedAttributes(n.getChildren(), t);
          }
        }
        createContext(e) {
          return new Ai(e);
        }
        _clearCache() {
          this._compiledDefinitions = null;
        }
        _compile() {
          const e = {}, t = this._sourceDefinitions, n = Object.keys(t);
          for (const i of n)
            e[i] = Hv(t[i], i);
          for (const i of n)
            Wv(e, i);
          for (const i of n)
            Yv(e, i);
          for (const i of n)
            qv(e, i), Gv(e, i);
          for (const i of n)
            Zv(e, i), Kv(e, i);
          this._compiledDefinitions = e;
        }
        _checkContextMatch(e, t, n = t.length - 1) {
          const i = t.getItem(n);
          if (e.allowIn.includes(i.name)) {
            if (n == 0)
              return !0;
            {
              const s = this.getDefinition(i);
              return this._checkContextMatch(s, t, n - 1);
            }
          }
          return !1;
        }
        *_getValidRangesForRange(e, t) {
          let n = e.start, i = e.start;
          for (const s of e.getItems({ shallow: !0 }))
            s.is("element") && (yield* this._getValidRangesForRange(ie._createIn(s), t)), this.checkAttribute(s, t) || (n.isEqual(i) || (yield new ie(n, i)), n = le._createAfter(s)), i = le._createAfter(s);
          n.isEqual(i) || (yield new ie(n, i));
        }
      }
      $e(pu, xt);
      class Ai {
        constructor(e) {
          if (e instanceof Ai)
            return e;
          typeof e == "string" ? e = [e] : Array.isArray(e) || (e = e.getAncestors({ includeSelf: !0 })), e[0] && typeof e[0] != "string" && e[0].is("documentFragment") && e.shift(), this._items = e.map(Qv);
        }
        get length() {
          return this._items.length;
        }
        get last() {
          return this._items[this._items.length - 1];
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]();
        }
        push(e) {
          const t = new Ai([e]);
          return t._items = [...this._items, ...t._items], t;
        }
        getItem(e) {
          return this._items[e];
        }
        *getNames() {
          yield* this._items.map((e) => e.name);
        }
        endsWith(e) {
          return Array.from(this.getNames()).join(" ").endsWith(e);
        }
      }
      function Hv(o, e) {
        const t = { name: e, allowIn: [], allowContentOf: [], allowWhere: [], allowAttributes: [], allowAttributesOf: [], inheritTypesFrom: [] };
        return function(n, i) {
          for (const s of n) {
            const l = Object.keys(s).filter((d) => d.startsWith("is"));
            for (const d of l)
              i[d] = s[d];
          }
        }(o, t), $i(o, t, "allowIn"), $i(o, t, "allowContentOf"), $i(o, t, "allowWhere"), $i(o, t, "allowAttributes"), $i(o, t, "allowAttributesOf"), $i(o, t, "inheritTypesFrom"), function(n, i) {
          for (const s of n) {
            const l = s.inheritAllFrom;
            l && (i.allowContentOf.push(l), i.allowWhere.push(l), i.allowAttributesOf.push(l), i.inheritTypesFrom.push(l));
          }
        }(o, t), t;
      }
      function Wv(o, e) {
        for (const t of o[e].allowContentOf)
          o[t] && Xv(o, t).forEach((n) => {
            n.allowIn.push(e);
          });
        delete o[e].allowContentOf;
      }
      function Yv(o, e) {
        for (const t of o[e].allowWhere) {
          const n = o[t];
          if (n) {
            const i = n.allowIn;
            o[e].allowIn.push(...i);
          }
        }
        delete o[e].allowWhere;
      }
      function qv(o, e) {
        for (const t of o[e].allowAttributesOf) {
          const n = o[t];
          if (n) {
            const i = n.allowAttributes;
            o[e].allowAttributes.push(...i);
          }
        }
        delete o[e].allowAttributesOf;
      }
      function Gv(o, e) {
        const t = o[e];
        for (const n of t.inheritTypesFrom) {
          const i = o[n];
          if (i) {
            const s = Object.keys(i).filter((l) => l.startsWith("is"));
            for (const l of s)
              l in t || (t[l] = i[l]);
          }
        }
        delete t.inheritTypesFrom;
      }
      function Zv(o, e) {
        const t = o[e], n = t.allowIn.filter((i) => o[i]);
        t.allowIn = Array.from(new Set(n));
      }
      function Kv(o, e) {
        const t = o[e];
        t.allowAttributes = Array.from(new Set(t.allowAttributes));
      }
      function $i(o, e, t) {
        for (const n of o)
          typeof n[t] == "string" ? e[t].push(n[t]) : Array.isArray(n[t]) && e[t].push(...n[t]);
      }
      function Xv(o, e) {
        const t = o[e];
        return function(n) {
          return Object.keys(n).map((i) => n[i]);
        }(o).filter((n) => n.allowIn.includes(t.name));
      }
      function Qv(o) {
        return typeof o == "string" ? { name: o, *getAttributeKeys() {
        }, getAttribute() {
        } } : { name: o.is("element") ? o.name : "$text", *getAttributeKeys() {
          yield* o.getAttributeKeys();
        }, getAttribute: (e) => o.getAttribute(e) };
      }
      class mu {
        constructor(e = {}) {
          this._splitParts = /* @__PURE__ */ new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, e), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
        }
        convert(e, t, n = ["$root"]) {
          this.fire("viewCleanup", e), this._modelCursor = function(l, d) {
            let f;
            for (const m of new Ai(l)) {
              const g = {};
              for (const y of m.getAttributeKeys())
                g[y] = m.getAttribute(y);
              const b = d.createElement(m.name, g);
              f && d.append(b, f), f = le._createAt(b, 0);
            }
            return f;
          }(n, t), this.conversionApi.writer = t, this.conversionApi.consumable = hr.createFrom(e), this.conversionApi.store = {};
          const { modelRange: i } = this._convertItem(e, this._modelCursor), s = t.createDocumentFragment();
          if (i) {
            this._removeEmptyElements();
            for (const l of Array.from(this._modelCursor.parent.getChildren()))
              t.append(l, s);
            s.markers = function(l, d) {
              const f = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Map(), g = ie._createIn(l).getItems();
              for (const b of g)
                b.name == "$marker" && f.add(b);
              for (const b of f) {
                const y = b.getAttribute("data-name"), C = d.createPositionBefore(b);
                m.has(y) ? m.get(y).end = C.clone() : m.set(y, new ie(C.clone())), d.remove(b);
              }
              return m;
            }(s, t);
          }
          return this._modelCursor = null, this._splitParts.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, s;
        }
        _convertItem(e, t) {
          const n = Object.assign({ viewItem: e, modelCursor: t, modelRange: null });
          if (e.is("element") ? this.fire("element:" + e.name, n, this.conversionApi) : e.is("text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof ie))
            throw new V.b("view-conversion-dispatcher-incorrect-result: Incorrect conversion result was dropped.", this);
          return { modelRange: n.modelRange, modelCursor: n.modelCursor };
        }
        _convertChildren(e, t) {
          const n = new ie(t);
          let i = t;
          for (const s of Array.from(e.getChildren())) {
            const l = this._convertItem(s, i);
            l.modelRange instanceof ie && (n.end = l.modelRange.end, i = l.modelCursor);
          }
          return { modelRange: n, modelCursor: i };
        }
        _splitToAllowedParent(e, t) {
          const n = this.conversionApi.schema.findAllowedParent(t, e);
          if (!n)
            return null;
          if (n === t.parent)
            return { position: t };
          if (this._modelCursor.parent.getAncestors().includes(n))
            return null;
          const i = this.conversionApi.writer.split(t, n), s = [];
          for (const l of i.range.getWalker())
            if (l.type == "elementEnd")
              s.push(l.item);
            else {
              const d = s.pop(), f = l.item;
              this._registerSplitPair(d, f);
            }
          return { position: i.position, cursorParent: i.range.end.parent };
        }
        _registerSplitPair(e, t) {
          this._splitParts.has(e) || this._splitParts.set(e, [e]);
          const n = this._splitParts.get(e);
          this._splitParts.set(t, n), n.push(t);
        }
        _getSplitParts(e) {
          return this._splitParts.has(e) ? this._splitParts.get(e) : [e];
        }
        _removeEmptyElements() {
          let e = !1;
          for (const t of this._splitParts.keys())
            t.isEmpty && (this.conversionApi.writer.remove(t), this._splitParts.delete(t), e = !0);
          e && this._removeEmptyElements();
        }
      }
      $e(mu, dt);
      class gu {
        constructor(e, t) {
          this.model = e, this.processor = t, this.mapper = new Hs(), this.downcastDispatcher = new Ws({ mapper: this.mapper }), this.downcastDispatcher.on("insert:$text", (n, i, s) => {
            if (!s.consumable.consume(i.item, "insert"))
              return;
            const l = s.writer, d = s.mapper.toViewPosition(i.range.start), f = l.createText(i.item.data);
            l.insert(d, f);
          }, { priority: "lowest" }), this.upcastDispatcher = new mu({ schema: e.schema }), this.upcastDispatcher.on("text", (n, i, s) => {
            if (s.schema.checkChild(i.modelCursor, "$text") && s.consumable.consume(i.viewItem)) {
              const l = s.writer.createText(i.viewItem.data);
              s.writer.insert(l, i.modelCursor), i.modelRange = ie._createFromPositionAndShift(i.modelCursor, l.offsetSize), i.modelCursor = i.modelRange.end;
            }
          }, { priority: "lowest" }), this.upcastDispatcher.on("element", (n, i, s) => {
            if (!i.modelRange && s.consumable.consume(i.viewItem, { name: !0 })) {
              const { modelRange: l, modelCursor: d } = s.convertChildren(i.viewItem, i.modelCursor);
              i.modelRange = l, i.modelCursor = d;
            }
          }, { priority: "lowest" }), this.upcastDispatcher.on("documentFragment", (n, i, s) => {
            if (!i.modelRange && s.consumable.consume(i.viewItem, { name: !0 })) {
              const { modelRange: l, modelCursor: d } = s.convertChildren(i.viewItem, i.modelCursor);
              i.modelRange = l, i.modelCursor = d;
            }
          }, { priority: "lowest" }), this.decorate("init"), this.on("init", () => {
            this.fire("ready");
          }, { priority: "lowest" });
        }
        get(e) {
          const { rootName: t = "main", trim: n = "empty" } = e || {};
          if (!this._checkIfRootsExists([t]))
            throw new V.b("datacontroller-get-non-existent-root: Attempting to get data from a non-existing root.", this);
          const i = this.model.document.getRoot(t);
          return n !== "empty" || this.model.hasContent(i, { ignoreWhitespaces: !0 }) ? this.stringify(i) : "";
        }
        stringify(e) {
          const t = this.toView(e);
          return this.processor.toData(t);
        }
        toView(e) {
          this.mapper.clearBindings();
          const t = ie._createIn(e), n = new Li(), i = new gc(new Ms());
          if (this.mapper.bindElements(e, n), this.downcastDispatcher.convertInsert(t, i), !e.is("documentFragment")) {
            const s = function(l) {
              const d = [], f = l.root.document;
              if (!f)
                return [];
              const m = ie._createIn(l);
              for (const g of f.model.markers) {
                const b = m.getIntersection(g.getRange());
                b && d.push([g.name, b]);
              }
              return d;
            }(e);
            for (const [l, d] of s)
              this.downcastDispatcher.convertMarkerAdd(l, d, i);
          }
          return n;
        }
        init(e) {
          if (this.model.document.version)
            throw new V.b("datacontroller-init-document-not-empty: Trying to set initial data to not empty document.", this);
          let t = {};
          if (typeof e == "string" ? t.main = e : t = e, !this._checkIfRootsExists(Object.keys(t)))
            throw new V.b("datacontroller-init-non-existent-root: Attempting to init data on a non-existing root.", this);
          return this.model.enqueueChange("transparent", (n) => {
            for (const i of Object.keys(t)) {
              const s = this.model.document.getRoot(i);
              n.insert(this.parse(t[i], s), s, 0);
            }
          }), Promise.resolve();
        }
        set(e) {
          let t = {};
          if (typeof e == "string" ? t.main = e : t = e, !this._checkIfRootsExists(Object.keys(t)))
            throw new V.b("datacontroller-set-non-existent-root: Attempting to set data on a non-existing root.", this);
          this.model.enqueueChange("transparent", (n) => {
            n.setSelection(null), n.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
            for (const i of Object.keys(t)) {
              const s = this.model.document.getRoot(i);
              n.remove(n.createRangeIn(s)), n.insert(this.parse(t[i], s), s, 0);
            }
          });
        }
        parse(e, t = "$root") {
          const n = this.processor.toView(e);
          return this.toModel(n, t);
        }
        toModel(e, t = "$root") {
          return this.model.change((n) => this.upcastDispatcher.convert(e, n, t));
        }
        destroy() {
          this.stopListening();
        }
        _checkIfRootsExists(e) {
          for (const t of e)
            if (!this.model.document.getRootNames().includes(t))
              return !1;
          return !0;
        }
      }
      $e(gu, xt);
      class Jv {
        constructor(e, t) {
          this._helpers = /* @__PURE__ */ new Map(), this._downcast = Array.isArray(e) ? e : [e], this._createConversionHelpers({ name: "downcast", dispatchers: this._downcast, isDowncast: !0 }), this._upcast = Array.isArray(t) ? t : [t], this._createConversionHelpers({ name: "upcast", dispatchers: this._upcast, isDowncast: !1 });
        }
        addAlias(e, t) {
          const n = this._downcast.includes(t);
          if (!this._upcast.includes(t) && !n)
            throw new V.b("conversion-add-alias-dispatcher-not-registered: Trying to register and alias for a dispatcher that nas not been registered.", this);
          this._createConversionHelpers({ name: e, dispatchers: [t], isDowncast: n });
        }
        for(e) {
          if (!this._helpers.has(e))
            throw new V.b("conversion-for-unknown-group: Trying to add a converter to an unknown dispatchers group.", this);
          return this._helpers.get(e);
        }
        elementToElement(e) {
          this.for("downcast").elementToElement(e);
          for (const { model: t, view: n } of Gs(e))
            this.for("upcast").elementToElement({ model: t, view: n, converterPriority: e.converterPriority });
        }
        attributeToElement(e) {
          this.for("downcast").attributeToElement(e);
          for (const { model: t, view: n } of Gs(e))
            this.for("upcast").elementToAttribute({ view: n, model: t, converterPriority: e.converterPriority });
        }
        attributeToAttribute(e) {
          this.for("downcast").attributeToAttribute(e);
          for (const { model: t, view: n } of Gs(e))
            this.for("upcast").attributeToAttribute({ view: n, model: t });
        }
        _createConversionHelpers({ name: e, dispatchers: t, isDowncast: n }) {
          if (this._helpers.has(e))
            throw new V.b("conversion-group-exists: Trying to register a group name that has already been registered.", this);
          const i = n ? new Fv(t) : new zv(t);
          this._helpers.set(e, i);
        }
      }
      function* Gs(o) {
        if (o.model.values)
          for (const e of o.model.values)
            yield* vu({ key: o.model.key, value: e }, o.view[e], o.upcastAlso ? o.upcastAlso[e] : void 0);
        else
          yield* vu(o.model, o.view, o.upcastAlso);
      }
      function* vu(o, e, t) {
        if (yield { model: o, view: e }, t) {
          t = Array.isArray(t) ? t : [t];
          for (const n of t)
            yield { model: o, view: n };
        }
      }
      class fo {
        constructor(e = "default") {
          this.operations = [], this.type = e;
        }
        get baseVersion() {
          for (const e of this.operations)
            if (e.baseVersion !== null)
              return e.baseVersion;
          return null;
        }
        addOperation(e) {
          return e.batch = this, this.operations.push(e), e;
        }
      }
      class Dn {
        constructor(e) {
          this.baseVersion = e, this.isDocumentOperation = this.baseVersion !== null, this.batch = null;
        }
        _validate() {
        }
        toJSON() {
          const e = Object.assign({}, this);
          return e.__className = this.constructor.className, delete e.batch, delete e.isDocumentOperation, e;
        }
        static get className() {
          return "Operation";
        }
        static fromJSON(e) {
          return new this(e.baseVersion);
        }
      }
      class Gn {
        constructor(e) {
          this.markers = /* @__PURE__ */ new Map(), this._children = new zi(), e && this._insertChild(0, e);
        }
        [Symbol.iterator]() {
          return this.getChildren();
        }
        get childCount() {
          return this._children.length;
        }
        get maxOffset() {
          return this._children.maxOffset;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        get root() {
          return this;
        }
        get parent() {
          return null;
        }
        is(e) {
          return e == "documentFragment" || e == "model:documentFragment";
        }
        getChild(e) {
          return this._children.getNode(e);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        getChildIndex(e) {
          return this._children.getNodeIndex(e);
        }
        getChildStartOffset(e) {
          return this._children.getNodeStartOffset(e);
        }
        getPath() {
          return [];
        }
        getNodeByPath(e) {
          let t = this;
          for (const n of e)
            t = t.getChild(t.offsetToIndex(n));
          return t;
        }
        offsetToIndex(e) {
          return this._children.offsetToIndex(e);
        }
        toJSON() {
          const e = [];
          for (const t of this._children)
            e.push(t.toJSON());
          return e;
        }
        static fromJSON(e) {
          const t = [];
          for (const n of e)
            n.name ? t.push(it.fromJSON(n)) : t.push(nt.fromJSON(n));
          return new Gn(t);
        }
        _appendChild(e) {
          this._insertChild(this.childCount, e);
        }
        _insertChild(e, t) {
          const n = function(i) {
            return typeof i == "string" ? [new nt(i)] : (Hn(i) || (i = [i]), Array.from(i).map((s) => typeof s == "string" ? new nt(s) : s instanceof Mn ? new nt(s.data, s.getAttributes()) : s));
          }(t);
          for (const i of n)
            i.parent !== null && i._remove(), i.parent = this;
          this._children._insertNodes(e, n);
        }
        _removeChildren(e, t = 1) {
          const n = this._children._removeNodes(e, t);
          for (const i of n)
            i.parent = null;
          return n;
        }
      }
      function Zs(o, e) {
        const t = (e = _u(e)).reduce((s, l) => s + l.offsetSize, 0), n = o.parent;
        mr(o);
        const i = o.index;
        return n._insertChild(i, e), pr(n, i + e.length), pr(n, i), new ie(o, o.getShiftedBy(t));
      }
      function bu(o) {
        if (!o.isFlat)
          throw new V.b("operation-utils-remove-range-not-flat: Trying to remove a range which starts and ends in different element.", this);
        const e = o.start.parent;
        mr(o.start), mr(o.end);
        const t = e._removeChildren(o.start.index, o.end.index - o.start.index);
        return pr(e, o.start.index), t;
      }
      function fr(o, e) {
        if (!o.isFlat)
          throw new V.b("operation-utils-move-range-not-flat: Trying to move a range which starts and ends in different element.", this);
        const t = bu(o);
        return Zs(e = e._getTransformedByDeletion(o.start, o.end.offset - o.start.offset), t);
      }
      function _u(o) {
        const e = [];
        o instanceof Array || (o = [o]);
        for (let t = 0; t < o.length; t++)
          if (typeof o[t] == "string")
            e.push(new nt(o[t]));
          else if (o[t] instanceof Mn)
            e.push(new nt(o[t].data, o[t].getAttributes()));
          else if (o[t] instanceof Gn || o[t] instanceof zi)
            for (const n of o[t])
              e.push(n);
          else
            o[t] instanceof Si && e.push(o[t]);
        for (let t = 1; t < e.length; t++) {
          const n = e[t], i = e[t - 1];
          n instanceof nt && i instanceof nt && wu(n, i) && (e.splice(t - 1, 2, new nt(i.data + n.data, i.getAttributes())), t--);
        }
        return e;
      }
      function pr(o, e) {
        const t = o.getChild(e - 1), n = o.getChild(e);
        if (t && n && t.is("text") && n.is("text") && wu(t, n)) {
          const i = new nt(t.data + n.data, t.getAttributes());
          o._removeChildren(e - 1, 2), o._insertChild(e - 1, i);
        }
      }
      function mr(o) {
        const e = o.textNode, t = o.parent;
        if (e) {
          const n = o.offset - e.startOffset, i = e.index;
          t._removeChildren(i, 1);
          const s = new nt(e.data.substr(0, n), e.getAttributes()), l = new nt(e.data.substr(n), e.getAttributes());
          t._insertChild(i, [s, l]);
        }
      }
      function wu(o, e) {
        const t = o.getAttributes(), n = e.getAttributes();
        for (const i of t) {
          if (i[1] !== e.getAttribute(i[0]))
            return !1;
          n.next();
        }
        return n.next().done;
      }
      var yu = function(o, e) {
        return zc(o, e);
      };
      class Pt extends Dn {
        constructor(e, t, n, i, s) {
          super(s), this.range = e.clone(), this.key = t, this.oldValue = n === void 0 ? null : n, this.newValue = i === void 0 ? null : i;
        }
        get type() {
          return this.oldValue === null ? "addAttribute" : this.newValue === null ? "removeAttribute" : "changeAttribute";
        }
        clone() {
          return new Pt(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
        getReversed() {
          return new Pt(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
        toJSON() {
          const e = super.toJSON();
          return e.range = this.range.toJSON(), e;
        }
        _validate() {
          if (!this.range.isFlat)
            throw new V.b("attribute-operation-range-not-flat: The range to change is not flat.", this);
          for (const e of this.range.getItems({ shallow: !0 })) {
            if (this.oldValue !== null && !yu(e.getAttribute(this.key), this.oldValue))
              throw new V.b("attribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, { item: e, key: this.key, value: this.oldValue });
            if (this.oldValue === null && this.newValue !== null && e.hasAttribute(this.key))
              throw new V.b("attribute-operation-attribute-exists: The attribute with given key already exists.", this, { node: e, key: this.key });
          }
        }
        _execute() {
          yu(this.oldValue, this.newValue) || function(e, t, n) {
            mr(e.start), mr(e.end);
            for (const i of e.getItems({ shallow: !0 })) {
              const s = i.is("textProxy") ? i.textNode : i;
              n !== null ? s._setAttribute(t, n) : s._removeAttribute(t), pr(s.parent, s.index);
            }
            pr(e.end.parent, e.end.index);
          }(this.range, this.key, this.newValue);
        }
        static get className() {
          return "AttributeOperation";
        }
        static fromJSON(e, t) {
          return new Pt(ie.fromJSON(e.range, t), e.key, e.oldValue, e.newValue, e.baseVersion);
        }
      }
      class eb extends Dn {
        constructor(e, t) {
          super(null), this.sourcePosition = e.clone(), this.howMany = t;
        }
        get type() {
          return "detach";
        }
        toJSON() {
          const e = super.toJSON();
          return e.sourcePosition = this.sourcePosition.toJSON(), e;
        }
        _validate() {
          if (this.sourcePosition.root.document)
            throw new V.b("detach-operation-on-document-node: Cannot detach document node.", this);
        }
        _execute() {
          bu(ie._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
        static get className() {
          return "DetachOperation";
        }
      }
      class ot extends Dn {
        constructor(e, t, n, i) {
          super(i), this.sourcePosition = e.clone(), this.sourcePosition.stickiness = "toNext", this.howMany = t, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNone";
        }
        get type() {
          return this.targetPosition.root.rootName == "$graveyard" ? "remove" : this.sourcePosition.root.rootName == "$graveyard" ? "reinsert" : "move";
        }
        clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
        getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
        getReversed() {
          const e = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
          return new this.constructor(this.getMovedRangeStart(), this.howMany, e, this.baseVersion + 1);
        }
        _validate() {
          const e = this.sourcePosition.parent, t = this.targetPosition.parent, n = this.sourcePosition.offset, i = this.targetPosition.offset;
          if (n + this.howMany > e.maxOffset)
            throw new V.b("move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.", this);
          if (e === t && n < i && i < n + this.howMany)
            throw new V.b("move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.", this);
          if (this.sourcePosition.root == this.targetPosition.root && Kt(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
            const s = this.sourcePosition.path.length - 1;
            if (this.targetPosition.path[s] >= n && this.targetPosition.path[s] < n + this.howMany)
              throw new V.b("move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.", this);
          }
        }
        _execute() {
          fr(ie._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
        toJSON() {
          const e = super.toJSON();
          return e.sourcePosition = this.sourcePosition.toJSON(), e.targetPosition = this.targetPosition.toJSON(), e;
        }
        static get className() {
          return "MoveOperation";
        }
        static fromJSON(e, t) {
          const n = le.fromJSON(e.sourcePosition, t), i = le.fromJSON(e.targetPosition, t);
          return new this(n, e.howMany, i, e.baseVersion);
        }
      }
      class Bt extends Dn {
        constructor(e, t, n) {
          super(n), this.position = e.clone(), this.position.stickiness = "toNone", this.nodes = new zi(_u(t)), this.shouldReceiveAttributes = !1;
        }
        get type() {
          return "insert";
        }
        get howMany() {
          return this.nodes.maxOffset;
        }
        clone() {
          const e = new zi([...this.nodes].map((n) => n._clone(!0))), t = new Bt(this.position, e, this.baseVersion);
          return t.shouldReceiveAttributes = this.shouldReceiveAttributes, t;
        }
        getReversed() {
          const e = this.position.root.document.graveyard, t = new le(e, [0]);
          return new ot(this.position, this.nodes.maxOffset, t, this.baseVersion + 1);
        }
        _validate() {
          const e = this.position.parent;
          if (!e || e.maxOffset < this.position.offset)
            throw new V.b("insert-operation-position-invalid: Insertion position is invalid.", this);
        }
        _execute() {
          const e = this.nodes;
          this.nodes = new zi([...e].map((t) => t._clone(!0))), Zs(this.position, e);
        }
        toJSON() {
          const e = super.toJSON();
          return e.position = this.position.toJSON(), e.nodes = this.nodes.toJSON(), e;
        }
        static get className() {
          return "InsertOperation";
        }
        static fromJSON(e, t) {
          const n = [];
          for (const s of e.nodes)
            s.name ? n.push(it.fromJSON(s)) : n.push(nt.fromJSON(s));
          const i = new Bt(le.fromJSON(e.position, t), n, e.baseVersion);
          return i.shouldReceiveAttributes = e.shouldReceiveAttributes, i;
        }
      }
      class dn extends Dn {
        constructor(e, t, n, i, s, l) {
          super(l), this.name = e, this.oldRange = t ? t.clone() : null, this.newRange = n ? n.clone() : null, this.affectsData = s, this._markers = i;
        }
        get type() {
          return "marker";
        }
        clone() {
          return new dn(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
        getReversed() {
          return new dn(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
        _execute() {
          const e = this.newRange ? "_set" : "_remove";
          this._markers[e](this.name, this.newRange, !0, this.affectsData);
        }
        toJSON() {
          const e = super.toJSON();
          return this.oldRange && (e.oldRange = this.oldRange.toJSON()), this.newRange && (e.newRange = this.newRange.toJSON()), delete e._markers, e;
        }
        static get className() {
          return "MarkerOperation";
        }
        static fromJSON(e, t) {
          return new dn(e.name, e.oldRange ? ie.fromJSON(e.oldRange, t) : null, e.newRange ? ie.fromJSON(e.newRange, t) : null, t.model.markers, e.affectsData, e.baseVersion);
        }
      }
      class hn extends Dn {
        constructor(e, t, n, i) {
          super(i), this.position = e, this.position.stickiness = "toNext", this.oldName = t, this.newName = n;
        }
        get type() {
          return "rename";
        }
        clone() {
          return new hn(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
        getReversed() {
          return new hn(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
        _validate() {
          const e = this.position.nodeAfter;
          if (!(e instanceof it))
            throw new V.b("rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.", this);
          if (e.name !== this.oldName)
            throw new V.b("rename-operation-wrong-name: Element to change has different name than operation's old name.", this);
        }
        _execute() {
          this.position.nodeAfter.name = this.newName;
        }
        toJSON() {
          const e = super.toJSON();
          return e.position = this.position.toJSON(), e;
        }
        static get className() {
          return "RenameOperation";
        }
        static fromJSON(e, t) {
          return new hn(le.fromJSON(e.position, t), e.oldName, e.newName, e.baseVersion);
        }
      }
      class Ti extends Dn {
        constructor(e, t, n, i, s) {
          super(s), this.root = e, this.key = t, this.oldValue = n, this.newValue = i;
        }
        get type() {
          return this.oldValue === null ? "addRootAttribute" : this.newValue === null ? "removeRootAttribute" : "changeRootAttribute";
        }
        clone() {
          return new Ti(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
        getReversed() {
          return new Ti(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
        _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment"))
            throw new V.b("rootattribute-operation-not-a-root: The element to change is not a root element.", this, { root: this.root, key: this.key });
          if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue)
            throw new V.b("rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, { root: this.root, key: this.key });
          if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key))
            throw new V.b("rootattribute-operation-attribute-exists: The attribute with given key already exists.", this, { root: this.root, key: this.key });
        }
        _execute() {
          this.newValue !== null ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
        }
        toJSON() {
          const e = super.toJSON();
          return e.root = this.root.toJSON(), e;
        }
        static get className() {
          return "RootAttributeOperation";
        }
        static fromJSON(e, t) {
          if (!t.getRoot(e.root))
            throw new V.b("rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.", this, { rootName: e.root });
          return new Ti(t.getRoot(e.root), e.key, e.oldValue, e.newValue, e.baseVersion);
        }
      }
      class Nt extends Dn {
        constructor(e, t, n, i, s) {
          super(s), this.sourcePosition = e.clone(), this.sourcePosition.stickiness = "toPrevious", this.howMany = t, this.targetPosition = n.clone(), this.targetPosition.stickiness = "toNext", this.graveyardPosition = i.clone();
        }
        get type() {
          return "merge";
        }
        get deletionPosition() {
          return new le(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
        get movedRange() {
          const e = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ie(this.sourcePosition, e);
        }
        clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
        getReversed() {
          const e = this.targetPosition._getTransformedByMergeOperation(this), t = this.sourcePosition.path.slice(0, -1), n = new le(this.sourcePosition.root, t)._getTransformedByMergeOperation(this), i = new at(e, this.howMany, this.graveyardPosition, this.baseVersion + 1);
          return i.insertionPosition = n, i;
        }
        _validate() {
          const e = this.sourcePosition.parent, t = this.targetPosition.parent;
          if (!e.parent)
            throw new V.b("merge-operation-source-position-invalid: Merge source position is invalid.", this);
          if (!t.parent)
            throw new V.b("merge-operation-target-position-invalid: Merge target position is invalid.", this);
          if (this.howMany != e.maxOffset)
            throw new V.b("merge-operation-how-many-invalid: Merge operation specifies wrong number of nodes to move.", this);
        }
        _execute() {
          const e = this.sourcePosition.parent;
          fr(ie._createIn(e), this.targetPosition), fr(ie._createOn(e), this.graveyardPosition);
        }
        toJSON() {
          const e = super.toJSON();
          return e.sourcePosition = e.sourcePosition.toJSON(), e.targetPosition = e.targetPosition.toJSON(), e.graveyardPosition = e.graveyardPosition.toJSON(), e;
        }
        static get className() {
          return "MergeOperation";
        }
        static fromJSON(e, t) {
          const n = le.fromJSON(e.sourcePosition, t), i = le.fromJSON(e.targetPosition, t), s = le.fromJSON(e.graveyardPosition, t);
          return new this(n, e.howMany, i, s, e.baseVersion);
        }
      }
      class at extends Dn {
        constructor(e, t, n, i) {
          super(i), this.splitPosition = e.clone(), this.splitPosition.stickiness = "toNext", this.howMany = t, this.insertionPosition = at.getInsertionPosition(e), this.insertionPosition.stickiness = "toNone", this.graveyardPosition = n ? n.clone() : null, this.graveyardPosition && (this.graveyardPosition.stickiness = "toNext");
        }
        get type() {
          return "split";
        }
        get moveTargetPosition() {
          const e = this.insertionPosition.path.slice();
          return e.push(0), new le(this.insertionPosition.root, e);
        }
        get movedRange() {
          const e = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ie(this.splitPosition, e);
        }
        clone() {
          const e = new this.constructor(this.splitPosition, this.howMany, this.graveyardPosition, this.baseVersion);
          return e.insertionPosition = this.insertionPosition, e;
        }
        getReversed() {
          const e = this.splitPosition.root.document.graveyard, t = new le(e, [0]);
          return new Nt(this.moveTargetPosition, this.howMany, this.splitPosition, t, this.baseVersion + 1);
        }
        _validate() {
          const e = this.splitPosition.parent, t = this.splitPosition.offset;
          if (!e || e.maxOffset < t)
            throw new V.b("split-operation-position-invalid: Split position is invalid.", this);
          if (!e.parent)
            throw new V.b("split-operation-split-in-root: Cannot split root element.", this);
          if (this.howMany != e.maxOffset - this.splitPosition.offset)
            throw new V.b("split-operation-how-many-invalid: Split operation specifies wrong number of nodes to move.", this);
          if (this.graveyardPosition && !this.graveyardPosition.nodeAfter)
            throw new V.b("split-operation-graveyard-position-invalid: Graveyard position invalid.", this);
        }
        _execute() {
          const e = this.splitPosition.parent;
          if (this.graveyardPosition)
            fr(ie._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
          else {
            const t = e._clone();
            Zs(this.insertionPosition, t);
          }
          fr(new ie(le._createAt(e, this.splitPosition.offset), le._createAt(e, e.maxOffset)), this.moveTargetPosition);
        }
        toJSON() {
          const e = super.toJSON();
          return e.splitPosition = this.splitPosition.toJSON(), e.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (e.graveyardPosition = this.graveyardPosition.toJSON()), e;
        }
        static get className() {
          return "SplitOperation";
        }
        static getInsertionPosition(e) {
          const t = e.path.slice(0, -1);
          return t[t.length - 1]++, new le(e.root, t);
        }
        static fromJSON(e, t) {
          const n = le.fromJSON(e.splitPosition, t), i = le.fromJSON(e.insertionPosition, t), s = e.graveyardPosition ? le.fromJSON(e.graveyardPosition, t) : null, l = new this(n, e.howMany, s, e.baseVersion);
          return l.insertionPosition = i, l;
        }
      }
      class Ks extends it {
        constructor(e, t, n = "main") {
          super(t), this._doc = e, this.rootName = n;
        }
        get document() {
          return this._doc;
        }
        is(e, t) {
          const n = e.replace("model:", "");
          return t ? n == "rootElement" && t == this.name || super.is(e, t) : n == "rootElement" || super.is(e);
        }
        toJSON() {
          return this.rootName;
        }
      }
      class tb {
        constructor(e, t) {
          this.model = e, this.batch = t;
        }
        createText(e, t) {
          return new nt(e, t);
        }
        createElement(e, t) {
          return new it(e, t);
        }
        createDocumentFragment() {
          return new Gn();
        }
        insert(e, t, n = 0) {
          if (this._assertWriterUsedCorrectly(), e instanceof nt && e.data == "")
            return;
          const i = le._createAt(t, n);
          if (e.parent) {
            if (Su(e.root, i.root))
              return void this.move(ie._createOn(e), i);
            if (e.root.document)
              throw new V.b("model-writer-insert-forbidden-move: Cannot move a node from a document to a different tree. It is forbidden to move a node that was already in a document outside of it.", this);
            this.remove(e);
          }
          const s = i.root.document ? i.root.document.version : null, l = new Bt(i, e, s);
          if (e instanceof nt && (l.shouldReceiveAttributes = !0), this.batch.addOperation(l), this.model.applyOperation(l), e instanceof Gn)
            for (const [d, f] of e.markers) {
              const m = le._createAt(f.root, 0), g = { range: new ie(f.start._getCombined(m, i), f.end._getCombined(m, i)), usingOperation: !0, affectsData: !0 };
              this.model.markers.has(d) ? this.updateMarker(d, g) : this.addMarker(d, g);
            }
        }
        insertText(e, t, n, i) {
          t instanceof Gn || t instanceof it || t instanceof le ? this.insert(this.createText(e), t, n) : this.insert(this.createText(e, t), n, i);
        }
        insertElement(e, t, n, i) {
          t instanceof Gn || t instanceof it || t instanceof le ? this.insert(this.createElement(e), t, n) : this.insert(this.createElement(e, t), n, i);
        }
        append(e, t) {
          this.insert(e, t, "end");
        }
        appendText(e, t, n) {
          t instanceof Gn || t instanceof it ? this.insert(this.createText(e), t, "end") : this.insert(this.createText(e, t), n, "end");
        }
        appendElement(e, t, n) {
          t instanceof Gn || t instanceof it ? this.insert(this.createElement(e), t, "end") : this.insert(this.createElement(e, t), n, "end");
        }
        setAttribute(e, t, n) {
          if (this._assertWriterUsedCorrectly(), n instanceof ie) {
            const i = n.getMinimalFlatRanges();
            for (const s of i)
              ku(this, e, t, s);
          } else
            xu(this, e, t, n);
        }
        setAttributes(e, t) {
          for (const [n, i] of xi(e))
            this.setAttribute(n, i, t);
        }
        removeAttribute(e, t) {
          if (this._assertWriterUsedCorrectly(), t instanceof ie) {
            const n = t.getMinimalFlatRanges();
            for (const i of n)
              ku(this, e, null, i);
          } else
            xu(this, e, null, t);
        }
        clearAttributes(e) {
          this._assertWriterUsedCorrectly();
          const t = (n) => {
            for (const i of n.getAttributeKeys())
              this.removeAttribute(i, n);
          };
          if (e instanceof ie)
            for (const n of e.getItems())
              t(n);
          else
            t(e);
        }
        move(e, t, n) {
          if (this._assertWriterUsedCorrectly(), !(e instanceof ie))
            throw new V.b("writer-move-invalid-range: Invalid range to move.", this);
          if (!e.isFlat)
            throw new V.b("writer-move-range-not-flat: Range to move is not flat.", this);
          const i = le._createAt(t, n);
          if (i.isEqual(e.start))
            return;
          if (this._addOperationForAffectedMarkers("move", e), !Su(e.root, i.root))
            throw new V.b("writer-move-different-document: Range is going to be moved between different documents.", this);
          const s = e.root.document ? e.root.document.version : null, l = new ot(e.start, e.end.offset - e.start.offset, i, s);
          this.batch.addOperation(l), this.model.applyOperation(l);
        }
        remove(e) {
          this._assertWriterUsedCorrectly();
          const t = (e instanceof ie ? e : ie._createOn(e)).getMinimalFlatRanges().reverse();
          for (const n of t)
            this._addOperationForAffectedMarkers("move", n), nb(n.start, n.end.offset - n.start.offset, this.batch, this.model);
        }
        merge(e) {
          this._assertWriterUsedCorrectly();
          const t = e.nodeBefore, n = e.nodeAfter;
          if (this._addOperationForAffectedMarkers("merge", e), !(t instanceof it))
            throw new V.b("writer-merge-no-element-before: Node before merge position must be an element.", this);
          if (!(n instanceof it))
            throw new V.b("writer-merge-no-element-after: Node after merge position must be an element.", this);
          e.root.document ? this._merge(e) : this._mergeDetached(e);
        }
        createPositionFromPath(e, t, n) {
          return this.model.createPositionFromPath(e, t, n);
        }
        createPositionAt(e, t) {
          return this.model.createPositionAt(e, t);
        }
        createPositionAfter(e) {
          return this.model.createPositionAfter(e);
        }
        createPositionBefore(e) {
          return this.model.createPositionBefore(e);
        }
        createRange(e, t) {
          return this.model.createRange(e, t);
        }
        createRangeIn(e) {
          return this.model.createRangeIn(e);
        }
        createRangeOn(e) {
          return this.model.createRangeOn(e);
        }
        createSelection(e, t, n) {
          return this.model.createSelection(e, t, n);
        }
        _mergeDetached(e) {
          const t = e.nodeBefore, n = e.nodeAfter;
          this.move(ie._createIn(n), le._createAt(t, "end")), this.remove(n);
        }
        _merge(e) {
          const t = le._createAt(e.nodeBefore, "end"), n = le._createAt(e.nodeAfter, 0), i = e.root.document.graveyard, s = new le(i, [0]), l = e.root.document.version, d = new Nt(n, e.nodeAfter.maxOffset, t, s, l);
          this.batch.addOperation(d), this.model.applyOperation(d);
        }
        rename(e, t) {
          if (this._assertWriterUsedCorrectly(), !(e instanceof it))
            throw new V.b("writer-rename-not-element-instance: Trying to rename an object which is not an instance of Element.", this);
          const n = e.root.document ? e.root.document.version : null, i = new hn(le._createBefore(e), e.name, t, n);
          this.batch.addOperation(i), this.model.applyOperation(i);
        }
        split(e, t) {
          this._assertWriterUsedCorrectly();
          let n, i, s = e.parent;
          if (!s.parent)
            throw new V.b("writer-split-element-no-parent: Element with no parent can not be split.", this);
          if (t || (t = s.parent), !e.parent.getAncestors({ includeSelf: !0 }).includes(t))
            throw new V.b("writer-split-invalid-limit-element: Limit element is not a position ancestor.", this);
          do {
            const l = s.root.document ? s.root.document.version : null, d = s.maxOffset - e.offset, f = new at(e, d, null, l);
            this.batch.addOperation(f), this.model.applyOperation(f), n || i || (n = s, i = e.parent.nextSibling), s = (e = this.createPositionAfter(e.parent)).parent;
          } while (s !== t);
          return { position: e, range: new ie(le._createAt(n, "end"), le._createAt(i, 0)) };
        }
        wrap(e, t) {
          if (this._assertWriterUsedCorrectly(), !e.isFlat)
            throw new V.b("writer-wrap-range-not-flat: Range to wrap is not flat.", this);
          const n = t instanceof it ? t : new it(t);
          if (n.childCount > 0)
            throw new V.b("writer-wrap-element-not-empty: Element to wrap with is not empty.", this);
          if (n.parent !== null)
            throw new V.b("writer-wrap-element-attached: Element to wrap with is already attached to tree model.", this);
          this.insert(n, e.start);
          const i = new ie(e.start.getShiftedBy(1), e.end.getShiftedBy(1));
          this.move(i, le._createAt(n, 0));
        }
        unwrap(e) {
          if (this._assertWriterUsedCorrectly(), e.parent === null)
            throw new V.b("writer-unwrap-element-no-parent: Trying to unwrap an element which has no parent.", this);
          this.move(ie._createIn(e), this.createPositionAfter(e)), this.remove(e);
        }
        addMarker(e, t) {
          if (this._assertWriterUsedCorrectly(), !t || typeof t.usingOperation != "boolean")
            throw new V.b("writer-addMarker-no-usingOperation: The options.usingOperation parameter is required when adding a new marker.", this);
          const n = t.usingOperation, i = t.range, s = t.affectsData !== void 0 && t.affectsData;
          if (this.model.markers.has(e))
            throw new V.b("writer-addMarker-marker-exists: Marker with provided name already exists.", this);
          if (!i)
            throw new V.b("writer-addMarker-no-range: Range parameter is required when adding a new marker.", this);
          return n ? (gr(this, e, null, i, s), this.model.markers.get(e)) : this.model.markers._set(e, i, n, s);
        }
        updateMarker(e, t) {
          this._assertWriterUsedCorrectly();
          const n = typeof e == "string" ? e : e.name, i = this.model.markers.get(n);
          if (!i)
            throw new V.b("writer-updateMarker-marker-not-exists: Marker with provided name does not exists.", this);
          if (!t)
            return void this.model.markers._refresh(i);
          const s = typeof t.usingOperation == "boolean", l = typeof t.affectsData == "boolean", d = l ? t.affectsData : i.affectsData;
          if (!s && !t.range && !l)
            throw new V.b("writer-updateMarker-wrong-options: One of the options is required - provide range, usingOperations or affectsData.", this);
          const f = i.getRange(), m = t.range ? t.range : f;
          s && t.usingOperation !== i.managedUsingOperations ? t.usingOperation ? gr(this, n, null, m, d) : (gr(this, n, f, null, d), this.model.markers._set(n, m, void 0, d)) : i.managedUsingOperations ? gr(this, n, f, m, d) : this.model.markers._set(n, m, void 0, d);
        }
        removeMarker(e) {
          this._assertWriterUsedCorrectly();
          const t = typeof e == "string" ? e : e.name;
          if (!this.model.markers.has(t))
            throw new V.b("writer-removeMarker-no-marker: Trying to remove marker which does not exist.", this);
          const n = this.model.markers.get(t);
          n.managedUsingOperations ? gr(this, t, n.getRange(), null, n.affectsData) : this.model.markers._remove(t);
        }
        setSelection(e, t, n) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(e, t, n);
        }
        setSelectionFocus(e, t) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(e, t);
        }
        setSelectionAttribute(e, t) {
          if (this._assertWriterUsedCorrectly(), typeof e == "string")
            this._setSelectionAttribute(e, t);
          else
            for (const [n, i] of xi(e))
              this._setSelectionAttribute(n, i);
        }
        removeSelectionAttribute(e) {
          if (this._assertWriterUsedCorrectly(), typeof e == "string")
            this._removeSelectionAttribute(e);
          else
            for (const t of e)
              this._removeSelectionAttribute(t);
        }
        overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
        restoreSelectionGravity(e) {
          this.model.document.selection._restoreGravity(e);
        }
        _setSelectionAttribute(e, t) {
          const n = this.model.document.selection;
          if (n.isCollapsed && n.anchor.parent.isEmpty) {
            const i = wn._getStoreAttributeKey(e);
            this.setAttribute(i, t, n.anchor.parent);
          }
          n._setAttribute(e, t);
        }
        _removeSelectionAttribute(e) {
          const t = this.model.document.selection;
          if (t.isCollapsed && t.anchor.parent.isEmpty) {
            const n = wn._getStoreAttributeKey(e);
            this.removeAttribute(n, t.anchor.parent);
          }
          t._removeAttribute(e);
        }
        _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this)
            throw new V.b("writer-incorrect-use: Trying to use a writer outside the change() block.", this);
        }
        _addOperationForAffectedMarkers(e, t) {
          for (const n of this.model.markers) {
            if (!n.managedUsingOperations)
              continue;
            const i = n.getRange();
            let s = !1;
            if (e == "move")
              s = t.containsPosition(i.start) || t.start.isEqual(i.start) || t.containsPosition(i.end) || t.end.isEqual(i.end);
            else {
              const l = t.nodeBefore, d = t.nodeAfter, f = i.start.parent == l && i.start.isAtEnd, m = i.end.parent == d && i.end.offset == 0, g = i.end.nodeAfter == d, b = i.start.nodeAfter == d;
              s = f || m || g || b;
            }
            s && this.updateMarker(n.name, { range: i });
          }
        }
      }
      function ku(o, e, t, n) {
        const i = o.model, s = i.document;
        let l, d, f, m = n.start;
        for (const b of n.getWalker({ shallow: !0 }))
          f = b.item.getAttribute(e), l && d != f && (d != t && g(), m = l), l = b.nextPosition, d = f;
        function g() {
          const b = new ie(m, l), y = b.root.document ? s.version : null, C = new Pt(b, e, d, t, y);
          o.batch.addOperation(C), i.applyOperation(C);
        }
        l instanceof le && l != m && d != t && g();
      }
      function xu(o, e, t, n) {
        const i = o.model, s = i.document, l = n.getAttribute(e);
        let d, f;
        if (l != t) {
          if (n.root === n) {
            const m = n.document ? s.version : null;
            f = new Ti(n, e, l, t, m);
          } else {
            const m = (d = new ie(le._createBefore(n), o.createPositionAfter(n))).root.document ? s.version : null;
            f = new Pt(d, e, l, t, m);
          }
          o.batch.addOperation(f), i.applyOperation(f);
        }
      }
      function gr(o, e, t, n, i) {
        const s = o.model, l = s.document, d = new dn(e, t, n, s.markers, i, l.version);
        o.batch.addOperation(d), s.applyOperation(d);
      }
      function nb(o, e, t, n) {
        let i;
        if (o.root.document) {
          const s = n.document, l = new le(s.graveyard, [0]);
          i = new ot(o, e, l, s.version);
        } else
          i = new eb(o, e);
        t.addOperation(i), n.applyOperation(i);
      }
      function Su(o, e) {
        return o === e || o instanceof Ks && e instanceof Ks;
      }
      class ib {
        constructor(e) {
          this._markerCollection = e, this._changesInElement = /* @__PURE__ */ new Map(), this._elementSnapshots = /* @__PURE__ */ new Map(), this._changedMarkers = /* @__PURE__ */ new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null;
        }
        get isEmpty() {
          return this._changesInElement.size == 0 && this._changedMarkers.size == 0;
        }
        refreshItem(e) {
          if (this._isInInsertedElement(e.parent))
            return;
          this._markRemove(e.parent, e.startOffset, e.offsetSize), this._markInsert(e.parent, e.startOffset, e.offsetSize);
          const t = ie._createOn(e);
          for (const n of this._markerCollection.getMarkersIntersectingRange(t)) {
            const i = n.getRange();
            this.bufferMarkerChange(n.name, i, i, n.affectsData);
          }
          this._cachedChanges = null;
        }
        bufferOperation(e) {
          switch (e.type) {
            case "insert":
              if (this._isInInsertedElement(e.position.parent))
                return;
              this._markInsert(e.position.parent, e.position.offset, e.nodes.maxOffset);
              break;
            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              for (const t of e.range.getItems({ shallow: !0 }))
                this._isInInsertedElement(t.parent) || this._markAttribute(t);
              break;
            case "remove":
            case "move":
            case "reinsert": {
              if (e.sourcePosition.isEqual(e.targetPosition) || e.sourcePosition.getShiftedBy(e.howMany).isEqual(e.targetPosition))
                return;
              const t = this._isInInsertedElement(e.sourcePosition.parent), n = this._isInInsertedElement(e.targetPosition.parent);
              t || this._markRemove(e.sourcePosition.parent, e.sourcePosition.offset, e.howMany), n || this._markInsert(e.targetPosition.parent, e.getMovedRangeStart().offset, e.howMany);
              break;
            }
            case "rename": {
              if (this._isInInsertedElement(e.position.parent))
                return;
              this._markRemove(e.position.parent, e.position.offset, 1), this._markInsert(e.position.parent, e.position.offset, 1);
              const t = ie._createFromPositionAndShift(e.position, 1);
              for (const n of this._markerCollection.getMarkersIntersectingRange(t)) {
                const i = n.getRange();
                this.bufferMarkerChange(n.name, i, i, n.affectsData);
              }
              break;
            }
            case "split": {
              const t = e.splitPosition.parent;
              this._isInInsertedElement(t) || this._markRemove(t, e.splitPosition.offset, e.howMany), this._isInInsertedElement(e.insertionPosition.parent) || this._markInsert(e.insertionPosition.parent, e.insertionPosition.offset, 1), e.graveyardPosition && this._markRemove(e.graveyardPosition.parent, e.graveyardPosition.offset, 1);
              break;
            }
            case "merge": {
              const t = e.sourcePosition.parent;
              this._isInInsertedElement(t.parent) || this._markRemove(t.parent, t.startOffset, 1);
              const n = e.graveyardPosition.parent;
              this._markInsert(n, e.graveyardPosition.offset, 1);
              const i = e.targetPosition.parent;
              this._isInInsertedElement(i) || this._markInsert(i, e.targetPosition.offset, t.maxOffset);
              break;
            }
          }
          this._cachedChanges = null;
        }
        bufferMarkerChange(e, t, n, i) {
          const s = this._changedMarkers.get(e);
          s ? (s.newRange = n, s.affectsData = i, s.oldRange == null && s.newRange == null && this._changedMarkers.delete(e)) : this._changedMarkers.set(e, { oldRange: t, newRange: n, affectsData: i });
        }
        getMarkersToRemove() {
          const e = [];
          for (const [t, n] of this._changedMarkers)
            n.oldRange != null && e.push({ name: t, range: n.oldRange });
          return e;
        }
        getMarkersToAdd() {
          const e = [];
          for (const [t, n] of this._changedMarkers)
            n.newRange != null && e.push({ name: t, range: n.newRange });
          return e;
        }
        getChangedMarkers() {
          return Array.from(this._changedMarkers).map((e) => ({ name: e[0], data: { oldRange: e[1].oldRange, newRange: e[1].newRange } }));
        }
        hasDataChanges() {
          for (const [, e] of this._changedMarkers)
            if (e.affectsData)
              return !0;
          return this._changesInElement.size > 0;
        }
        getChanges(e = { includeChangesInGraveyard: !1 }) {
          if (this._cachedChanges)
            return e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          const t = [];
          for (const n of this._changesInElement.keys()) {
            const i = this._changesInElement.get(n).sort((g, b) => g.offset === b.offset ? g.type != b.type ? g.type == "remove" ? -1 : 1 : 0 : g.offset < b.offset ? -1 : 1), s = this._elementSnapshots.get(n), l = Cu(n.getChildren()), d = rb(s.length, i);
            let f = 0, m = 0;
            for (const g of d)
              if (g === "i")
                t.push(this._getInsertDiff(n, f, l[f].name)), f++;
              else if (g === "r")
                t.push(this._getRemoveDiff(n, f, s[m].name)), m++;
              else if (g === "a") {
                const b = l[f].attributes, y = s[m].attributes;
                let C;
                if (l[f].name == "$text")
                  C = new ie(le._createAt(n, f), le._createAt(n, f + 1));
                else {
                  const O = n.offsetToIndex(f);
                  C = new ie(le._createAt(n, f), le._createAt(n.getChild(O), 0));
                }
                t.push(...this._getAttributesDiff(C, y, b)), f++, m++;
              } else
                f++, m++;
          }
          t.sort((n, i) => n.position.root != i.position.root ? n.position.root.rootName < i.position.root.rootName ? -1 : 1 : n.position.isEqual(i.position) ? n.changeCount - i.changeCount : n.position.isBefore(i.position) ? -1 : 1);
          for (let n = 1; n < t.length; n++) {
            const i = t[n - 1], s = t[n], l = i.type == "remove" && s.type == "remove" && i.name == "$text" && s.name == "$text" && i.position.isEqual(s.position), d = i.type == "insert" && s.type == "insert" && i.name == "$text" && s.name == "$text" && i.position.parent == s.position.parent && i.position.offset + i.length == s.position.offset, f = i.type == "attribute" && s.type == "attribute" && i.position.parent == s.position.parent && i.range.isFlat && s.range.isFlat && i.position.offset + i.length == s.position.offset && i.attributeKey == s.attributeKey && i.attributeOldValue == s.attributeOldValue && i.attributeNewValue == s.attributeNewValue;
            (l || d || f) && (t[n - 1].length++, f && (t[n - 1].range.end = t[n - 1].range.end.getShiftedBy(1)), t.splice(n, 1), n--);
          }
          for (const n of t)
            delete n.changeCount, n.type == "attribute" && (delete n.position, delete n.length);
          return this._changeCount = 0, this._cachedChangesWithGraveyard = t.slice(), this._cachedChanges = t.slice().filter(ob), e.includeChangesInGraveyard ? this._cachedChangesWithGraveyard : this._cachedChanges;
        }
        reset() {
          this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._cachedChanges = null;
        }
        _markInsert(e, t, n) {
          const i = { type: "insert", offset: t, howMany: n, count: this._changeCount++ };
          this._markChange(e, i);
        }
        _markRemove(e, t, n) {
          const i = { type: "remove", offset: t, howMany: n, count: this._changeCount++ };
          this._markChange(e, i), this._removeAllNestedChanges(e, t, n);
        }
        _markAttribute(e) {
          const t = { type: "attribute", offset: e.startOffset, howMany: e.offsetSize, count: this._changeCount++ };
          this._markChange(e.parent, t);
        }
        _markChange(e, t) {
          this._makeSnapshot(e);
          const n = this._getChangesForElement(e);
          this._handleChange(t, n), n.push(t);
          for (let i = 0; i < n.length; i++)
            n[i].howMany < 1 && (n.splice(i, 1), i--);
        }
        _getChangesForElement(e) {
          let t;
          return this._changesInElement.has(e) ? t = this._changesInElement.get(e) : (t = [], this._changesInElement.set(e, t)), t;
        }
        _makeSnapshot(e) {
          this._elementSnapshots.has(e) || this._elementSnapshots.set(e, Cu(e.getChildren()));
        }
        _handleChange(e, t) {
          e.nodesToHandle = e.howMany;
          for (const n of t) {
            const i = e.offset + e.howMany, s = n.offset + n.howMany;
            if (e.type == "insert" && (n.type == "insert" && (e.offset <= n.offset ? n.offset += e.howMany : e.offset < s && (n.howMany += e.nodesToHandle, e.nodesToHandle = 0)), n.type == "remove" && e.offset < n.offset && (n.offset += e.howMany), n.type == "attribute")) {
              if (e.offset <= n.offset)
                n.offset += e.howMany;
              else if (e.offset < s) {
                const l = n.howMany;
                n.howMany = e.offset - n.offset, t.unshift({ type: "attribute", offset: i, howMany: l - n.howMany, count: this._changeCount++ });
              }
            }
            if (e.type == "remove") {
              if (n.type == "insert") {
                if (i <= n.offset)
                  n.offset -= e.howMany;
                else if (i <= s)
                  if (e.offset < n.offset) {
                    const l = i - n.offset;
                    n.offset = e.offset, n.howMany -= l, e.nodesToHandle -= l;
                  } else
                    n.howMany -= e.nodesToHandle, e.nodesToHandle = 0;
                else if (e.offset <= n.offset)
                  e.nodesToHandle -= n.howMany, n.howMany = 0;
                else if (e.offset < s) {
                  const l = s - e.offset;
                  n.howMany -= l, e.nodesToHandle -= l;
                }
              }
              if (n.type == "remove" && (i <= n.offset ? n.offset -= e.howMany : e.offset < n.offset && (e.nodesToHandle += n.howMany, n.howMany = 0)), n.type == "attribute") {
                if (i <= n.offset)
                  n.offset -= e.howMany;
                else if (e.offset < n.offset) {
                  const l = i - n.offset;
                  n.offset = e.offset, n.howMany -= l;
                } else if (e.offset < s)
                  if (i <= s) {
                    const l = n.howMany;
                    n.howMany = e.offset - n.offset;
                    const d = l - n.howMany - e.nodesToHandle;
                    t.unshift({ type: "attribute", offset: e.offset, howMany: d, count: this._changeCount++ });
                  } else
                    n.howMany -= s - e.offset;
              }
            }
            if (e.type == "attribute") {
              if (n.type == "insert")
                if (e.offset < n.offset && i > n.offset) {
                  if (i > s) {
                    const l = { type: "attribute", offset: s, howMany: i - s, count: this._changeCount++ };
                    this._handleChange(l, t), t.push(l);
                  }
                  e.nodesToHandle = n.offset - e.offset, e.howMany = e.nodesToHandle;
                } else
                  e.offset >= n.offset && e.offset < s && (i > s ? (e.nodesToHandle = i - s, e.offset = s) : e.nodesToHandle = 0);
              if (n.type == "remove" && e.offset < n.offset && i > n.offset) {
                const l = { type: "attribute", offset: n.offset, howMany: i - n.offset, count: this._changeCount++ };
                this._handleChange(l, t), t.push(l), e.nodesToHandle = n.offset - e.offset, e.howMany = e.nodesToHandle;
              }
              n.type == "attribute" && (e.offset >= n.offset && i <= s ? (e.nodesToHandle = 0, e.howMany = 0, e.offset = 0) : e.offset <= n.offset && i >= s && (n.howMany = 0));
            }
          }
          e.howMany = e.nodesToHandle, delete e.nodesToHandle;
        }
        _getInsertDiff(e, t, n) {
          return { type: "insert", position: le._createAt(e, t), name: n, length: 1, changeCount: this._changeCount++ };
        }
        _getRemoveDiff(e, t, n) {
          return { type: "remove", position: le._createAt(e, t), name: n, length: 1, changeCount: this._changeCount++ };
        }
        _getAttributesDiff(e, t, n) {
          const i = [];
          n = new Map(n);
          for (const [s, l] of t) {
            const d = n.has(s) ? n.get(s) : null;
            d !== l && i.push({ type: "attribute", position: e.start, range: e.clone(), length: 1, attributeKey: s, attributeOldValue: l, attributeNewValue: d, changeCount: this._changeCount++ }), n.delete(s);
          }
          for (const [s, l] of n)
            i.push({ type: "attribute", position: e.start, range: e.clone(), length: 1, attributeKey: s, attributeOldValue: null, attributeNewValue: l, changeCount: this._changeCount++ });
          return i;
        }
        _isInInsertedElement(e) {
          const t = e.parent;
          if (!t)
            return !1;
          const n = this._changesInElement.get(t), i = e.startOffset;
          if (n) {
            for (const s of n)
              if (s.type == "insert" && i >= s.offset && i < s.offset + s.howMany)
                return !0;
          }
          return this._isInInsertedElement(t);
        }
        _removeAllNestedChanges(e, t, n) {
          const i = new ie(le._createAt(e, t), le._createAt(e, t + n));
          for (const s of i.getItems({ shallow: !0 }))
            s.is("element") && (this._elementSnapshots.delete(s), this._changesInElement.delete(s), this._removeAllNestedChanges(s, 0, s.maxOffset));
        }
      }
      function Cu(o) {
        const e = [];
        for (const t of o)
          if (t.is("text"))
            for (let n = 0; n < t.data.length; n++)
              e.push({ name: "$text", attributes: new Map(t.getAttributes()) });
          else
            e.push({ name: t.name, attributes: new Map(t.getAttributes()) });
        return e;
      }
      function rb(o, e) {
        const t = [];
        let n = 0, i = 0;
        for (const s of e) {
          if (s.offset > n) {
            for (let l = 0; l < s.offset - n; l++)
              t.push("e");
            i += s.offset - n;
          }
          if (s.type == "insert") {
            for (let l = 0; l < s.howMany; l++)
              t.push("i");
            n = s.offset + s.howMany;
          } else if (s.type == "remove") {
            for (let l = 0; l < s.howMany; l++)
              t.push("r");
            n = s.offset, i += s.howMany;
          } else
            t.push(..."a".repeat(s.howMany).split("")), n = s.offset + s.howMany, i += s.howMany;
        }
        if (i < o)
          for (let s = 0; s < o - i - n; s++)
            t.push("e");
        return t;
      }
      function ob(o) {
        const e = o.position && o.position.root.rootName == "$graveyard", t = o.range && o.range.root.rootName == "$graveyard";
        return !e && !t;
      }
      class sb {
        constructor() {
          this._operations = [], this._undoPairs = /* @__PURE__ */ new Map(), this._undoneOperations = /* @__PURE__ */ new Set();
        }
        addOperation(e) {
          this._operations.includes(e) || this._operations.push(e);
        }
        getOperations(e = 0, t = Number.POSITIVE_INFINITY) {
          return e < 0 ? [] : this._operations.slice(e, t);
        }
        getOperation(e) {
          return this._operations[e];
        }
        setOperationAsUndone(e, t) {
          this._undoPairs.set(t, e), this._undoneOperations.add(e);
        }
        isUndoingOperation(e) {
          return this._undoPairs.has(e);
        }
        isUndoneOperation(e) {
          return this._undoneOperations.has(e);
        }
        getUndoneOperation(e) {
          return this._undoPairs.get(e);
        }
      }
      function Au(o, e) {
        return function(t) {
          return !!t && t.length == 1 && /[\ud800-\udbff]/.test(t);
        }(o.charAt(e - 1)) && function(t) {
          return !!t && t.length == 1 && /[\udc00-\udfff]/.test(t);
        }(o.charAt(e));
      }
      function Tu(o, e) {
        return function(t) {
          return !!t && t.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(t);
        }(o.charAt(e));
      }
      const Xs = "$graveyard";
      class Iu {
        constructor(e) {
          this.model = e, this.version = 0, this.history = new sb(this), this.selection = new wn(this), this.roots = new _n({ idProperty: "rootName" }), this.differ = new ib(e.markers), this._postFixers = /* @__PURE__ */ new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", Xs), this.listenTo(e, "applyOperation", (t, n) => {
            const i = n[0];
            if (i.isDocumentOperation && i.baseVersion !== this.version)
              throw new V.b("model-document-applyOperation-wrong-version: Only operations with matching versions can be applied.", this, { operation: i });
          }, { priority: "highest" }), this.listenTo(e, "applyOperation", (t, n) => {
            const i = n[0];
            i.isDocumentOperation && this.differ.bufferOperation(i);
          }, { priority: "high" }), this.listenTo(e, "applyOperation", (t, n) => {
            const i = n[0];
            i.isDocumentOperation && (this.version++, this.history.addOperation(i));
          }, { priority: "low" }), this.listenTo(this.selection, "change", () => {
            this._hasSelectionChangedFromTheLastChangeBlock = !0;
          }), this.listenTo(e.markers, "update", (t, n, i, s) => {
            this.differ.bufferMarkerChange(n.name, i, s, n.affectsData), i === null && n.on("change", (l, d) => {
              this.differ.bufferMarkerChange(n.name, d, n.getRange(), n.affectsData);
            });
          });
        }
        get graveyard() {
          return this.getRoot(Xs);
        }
        createRoot(e = "$root", t = "main") {
          if (this.roots.get(t))
            throw new V.b("model-document-createRoot-name-exists: Root with specified name already exists.", this, { name: t });
          const n = new Ks(this, e, t);
          return this.roots.add(n), n;
        }
        destroy() {
          this.selection.destroy(), this.stopListening();
        }
        getRoot(e = "main") {
          return this.roots.get(e);
        }
        getRootNames() {
          return Array.from(this.roots, (e) => e.rootName).filter((e) => e != Xs);
        }
        registerPostFixer(e) {
          this._postFixers.add(e);
        }
        toJSON() {
          const e = Ql(this);
          return e.selection = "[engine.model.DocumentSelection]", e.model = "[engine.model.Model]", e;
        }
        _handleChangeBlock(e) {
          this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(e), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", e.batch) : this.fire("change", e.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
        }
        _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
        _getDefaultRoot() {
          for (const e of this.roots)
            if (e !== this.graveyard)
              return e;
          return this.graveyard;
        }
        _getDefaultRange() {
          const e = this._getDefaultRoot(), t = this.model, n = t.schema, i = t.createPositionFromPath(e, [0]);
          return n.getNearestSelectionRange(i) || t.createRange(i);
        }
        _validateSelectionRange(e) {
          return Eu(e.start) && Eu(e.end);
        }
        _callPostFixers(e) {
          let t = !1;
          do
            for (const n of this._postFixers)
              if (this.selection.refresh(), t = n(e))
                break;
          while (t);
        }
      }
      function Eu(o) {
        const e = o.textNode;
        if (e) {
          const t = e.data, n = o.offset - e.startOffset;
          return !Au(t, n) && !Tu(t, n);
        }
        return !0;
      }
      $e(Iu, dt);
      class Pu {
        constructor() {
          this._markers = /* @__PURE__ */ new Map();
        }
        [Symbol.iterator]() {
          return this._markers.values();
        }
        has(e) {
          return this._markers.has(e);
        }
        get(e) {
          return this._markers.get(e) || null;
        }
        _set(e, t, n = !1, i = !1) {
          const s = e instanceof vr ? e.name : e, l = this._markers.get(s);
          if (l) {
            const m = l.getRange();
            let g = !1;
            return m.isEqual(t) || (l._attachLiveRange(ai.fromRange(t)), g = !0), n != l.managedUsingOperations && (l._managedUsingOperations = n, g = !0), typeof i == "boolean" && i != l.affectsData && (l._affectsData = i, g = !0), g && this.fire("update:" + s, l, m, t), l;
          }
          const d = ai.fromRange(t), f = new vr(s, d, n, i);
          return this._markers.set(s, f), this.fire("update:" + s, f, null, t), f;
        }
        _remove(e) {
          const t = e instanceof vr ? e.name : e, n = this._markers.get(t);
          return !!n && (this._markers.delete(t), this.fire("update:" + t, n, n.getRange(), null), this._destroyMarker(n), !0);
        }
        _refresh(e) {
          const t = e instanceof vr ? e.name : e, n = this._markers.get(t);
          if (!n)
            throw new V.b("markercollection-refresh-marker-not-exists: Marker with provided name does not exists.", this);
          const i = n.getRange();
          this.fire("update:" + t, n, i, i, n.managedUsingOperations, n.affectsData);
        }
        *getMarkersAtPosition(e) {
          for (const t of this)
            t.getRange().containsPosition(e) && (yield t);
        }
        *getMarkersIntersectingRange(e) {
          for (const t of this)
            t.getRange().getIntersection(e) !== null && (yield t);
        }
        destroy() {
          for (const e of this._markers.values())
            this._destroyMarker(e);
          this._markers = null, this.stopListening();
        }
        *getMarkersGroup(e) {
          for (const t of this._markers.values())
            t.name.startsWith(e + ":") && (yield t);
        }
        _destroyMarker(e) {
          e.stopListening(), e._detachLiveRange();
        }
      }
      $e(Pu, dt);
      class vr {
        constructor(e, t, n, i) {
          this.name = e, this._liveRange = this._attachLiveRange(t), this._managedUsingOperations = n, this._affectsData = i;
        }
        get managedUsingOperations() {
          if (!this._liveRange)
            throw new V.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._managedUsingOperations;
        }
        get affectsData() {
          if (!this._liveRange)
            throw new V.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._affectsData;
        }
        getStart() {
          if (!this._liveRange)
            throw new V.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.start.clone();
        }
        getEnd() {
          if (!this._liveRange)
            throw new V.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.end.clone();
        }
        getRange() {
          if (!this._liveRange)
            throw new V.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.toRange();
        }
        is(e) {
          return e == "marker" || e == "model:marker";
        }
        _attachLiveRange(e) {
          return this._liveRange && this._detachLiveRange(), e.delegate("change:range").to(this), e.delegate("change:content").to(this), this._liveRange = e, e;
        }
        _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
        }
      }
      $e(vr, dt);
      class Vt extends le {
        constructor(e, t, n = "toNone") {
          if (super(e, t, n), !this.root.is("rootElement"))
            throw new V.b("model-liveposition-root-not-rootelement: LivePosition's root has to be an instance of RootElement.", e);
          (function() {
            this.listenTo(this.root.document.model, "applyOperation", (i, s) => {
              const l = s[0];
              l.isDocumentOperation && function(d) {
                const f = this.getTransformedByOperation(d);
                if (!this.isEqual(f)) {
                  const m = this.toPosition();
                  this.path = f.path, this.root = f.root, this.fire("change", m);
                }
              }.call(this, l);
            }, { priority: "low" });
          }).call(this);
        }
        detach() {
          this.stopListening();
        }
        is(e) {
          return e == "livePosition" || e == "model:livePosition" || super.is(e);
        }
        toPosition() {
          return new le(this.root, this.path.slice(), this.stickiness);
        }
        static fromPosition(e, t) {
          return new this(e.root, e.path.slice(), t || e.stickiness);
        }
      }
      $e(Vt, dt);
      class ab {
        constructor(e, t, n) {
          this.model = e, this.writer = t, this.position = n, this.canMergeWith = /* @__PURE__ */ new Set([this.position.parent]), this.schema = e.schema, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
        }
        handleNodes(e, t) {
          e = Array.from(e);
          for (let n = 0; n < e.length; n++) {
            const i = e[n];
            this._handleNode(i, { isFirst: n === 0 && t.isFirst, isLast: n === e.length - 1 && t.isLast });
          }
          this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
        }
        getSelectionRange() {
          return this.nodeToSelect ? ie._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
        }
        getAffectedRange() {
          return this._affectedStart ? new ie(this._affectedStart, this._affectedEnd) : null;
        }
        destroy() {
          this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
        }
        _handleNode(e, t) {
          if (this.schema.isObject(e))
            return void this._handleObject(e, t);
          this._checkAndSplitToAllowedPosition(e, t) ? (this._insert(e), this._mergeSiblingsOf(e, t)) : this._handleDisallowedNode(e, t);
        }
        _handleObject(e, t) {
          this._checkAndSplitToAllowedPosition(e) ? this._insert(e) : this._tryAutoparagraphing(e, t);
        }
        _handleDisallowedNode(e, t) {
          e.is("element") ? this.handleNodes(e.getChildren(), t) : this._tryAutoparagraphing(e, t);
        }
        _insert(e) {
          if (!this.schema.checkChild(this.position, e))
            throw new V.b("insertcontent-wrong-position: Given node cannot be inserted on the given position.", this, { node: e, position: this.position });
          const t = Vt.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position), this.writer.insert(e, this.position), this.position = t.toPosition(), t.detach(), this.schema.isObject(e) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = e : this.nodeToSelect = null, this._filterAttributesOf.push(e);
        }
        _setAffectedBoundaries(e) {
          this._affectedStart || (this._affectedStart = Vt.fromPosition(e, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(e) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = Vt.fromPosition(e, "toNext"));
        }
        _mergeSiblingsOf(e, t) {
          if (!(e instanceof it))
            return;
          const n = this._canMergeLeft(e, t), i = this._canMergeRight(e, t), s = Vt._createBefore(e);
          s.stickiness = "toNext";
          const l = Vt._createAfter(e);
          if (l.stickiness = "toNext", n) {
            const d = Vt.fromPosition(this.position);
            d.stickiness = "toNext", this._affectedStart.isEqual(s) && (this._affectedStart.detach(), this._affectedStart = Vt._createAt(s.nodeBefore, "end", "toPrevious")), this.writer.merge(s), s.isEqual(this._affectedEnd) && t.isLast && (this._affectedEnd.detach(), this._affectedEnd = Vt._createAt(s.nodeBefore, "end", "toNext")), this.position = d.toPosition(), d.detach();
          }
          if (i) {
            if (!this.position.isEqual(l))
              throw new V.b("insertcontent-invalid-insertion-position", this);
            this.position = le._createAt(l.nodeBefore, "end");
            const d = Vt.fromPosition(this.position, "toPrevious");
            this._affectedEnd.isEqual(l) && (this._affectedEnd.detach(), this._affectedEnd = Vt._createAt(l.nodeBefore, "end", "toNext")), this.writer.merge(l), l.getShiftedBy(-1).isEqual(this._affectedStart) && t.isFirst && (this._affectedStart.detach(), this._affectedStart = Vt._createAt(l.nodeBefore, 0, "toPrevious")), this.position = d.toPosition(), d.detach();
          }
          (n || i) && this._filterAttributesOf.push(this.position.parent), s.detach(), l.detach();
        }
        _canMergeLeft(e, t) {
          const n = e.previousSibling;
          return t.isFirst && n instanceof it && this.canMergeWith.has(n) && this.model.schema.checkMerge(n, e);
        }
        _canMergeRight(e, t) {
          const n = e.nextSibling;
          return t.isLast && n instanceof it && this.canMergeWith.has(n) && this.model.schema.checkMerge(e, n);
        }
        _tryAutoparagraphing(e, t) {
          const n = this.writer.createElement("paragraph");
          this._getAllowedIn(n, this.position.parent) && this.schema.checkChild(n, e) && (n._appendChild(e), this._handleNode(n, t));
        }
        _checkAndSplitToAllowedPosition(e) {
          const t = this._getAllowedIn(e, this.position.parent);
          if (!t)
            return !1;
          for (; t != this.position.parent; ) {
            if (this.schema.isLimit(this.position.parent))
              return !1;
            if (this.position.isAtStart) {
              const n = this.position.parent;
              this.position = this.writer.createPositionBefore(n), n.isEmpty && n.parent === t && this.writer.remove(n);
            } else if (this.position.isAtEnd)
              this.position = this.writer.createPositionAfter(this.position.parent);
            else {
              const n = this.writer.createPositionAfter(this.position.parent);
              this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = n, this.canMergeWith.add(this.position.nodeAfter);
            }
          }
          return !0;
        }
        _getAllowedIn(e, t) {
          return this.schema.checkChild(t, e) ? t : t.parent ? this._getAllowedIn(e, t.parent) : null;
        }
      }
      function lb(o, e, t = {}) {
        if (e.isCollapsed)
          return;
        const n = e.getFirstRange();
        if (n.root.rootName == "$graveyard")
          return;
        const i = o.schema;
        o.change((s) => {
          if (!t.doNotResetEntireContent && function(f, m) {
            const g = f.getLimitElement(m);
            if (!m.containsEntireContent(g))
              return !1;
            const b = m.getFirstRange();
            return b.start.parent == b.end.parent ? !1 : f.checkChild(g, "paragraph");
          }(i, e))
            return void function(f, m) {
              const g = f.model.schema.getLimitElement(m);
              f.remove(f.createRangeIn(g)), Mu(f, f.createPositionAt(g, 0), m);
            }(s, e);
          const l = n.start, d = Vt.fromPosition(n.end, "toNext");
          if (n.start.isTouching(n.end) || s.remove(n), t.leaveUnmerged || (function f(m, g, b) {
            const y = g.parent, C = b.parent;
            if (y != C && !(m.model.schema.isLimit(y) || m.model.schema.isLimit(C)) && !!function(O, D, oe) {
              const ce = new ie(O, D);
              for (const _e of ce.getWalker())
                if (oe.isLimit(_e.item))
                  return !1;
              return !0;
            }(g, b, m.model.schema)) {
              for (g = m.createPositionAfter(y), b = m.createPositionBefore(C), b.isEqual(g) || m.insert(C, g), m.merge(g); b.parent.isEmpty; ) {
                const O = b.parent;
                b = m.createPositionBefore(O), m.remove(O);
              }
              f(m, g, b);
            }
          }(s, l, d), i.removeDisallowedAttributes(l.parent.getChildren(), s)), Qs(s, e, l), function(f, m) {
            const g = f.checkChild(m, "$text"), b = f.checkChild(m, "paragraph");
            return !g && b;
          }(i, l)) {
            const f = i.getNearestSelectionRange(l);
            t.doNotAutoparagraph && f ? Qs(s, e, f) : Mu(s, l, e);
          }
          d.detach();
        });
      }
      function Mu(o, e, t) {
        const n = o.createElement("paragraph");
        o.insert(n, e), Qs(o, t, o.createPositionAt(n, 0));
      }
      function Qs(o, e, t) {
        e instanceof wn ? o.setSelection(t) : e.setTo(t);
      }
      const Ou = ' ,.?!:;"-()';
      function cb(o, e, t = {}) {
        const n = o.schema, i = t.direction != "backward", s = t.unit ? t.unit : "character", l = e.focus, d = new qn({ boundaries: function(g, b) {
          const y = g.root, C = le._createAt(y, b ? "end" : 0);
          return b ? new ie(g, C) : new ie(C, g);
        }(l, i), singleCharacters: !0, direction: i ? "forward" : "backward" }), f = { walker: d, schema: n, isForward: i, unit: s };
        let m;
        for (; m = d.next(); ) {
          if (m.done)
            return;
          const g = ub(f, m.value);
          if (g)
            return void (e instanceof wn ? o.change((b) => {
              b.setSelectionFocus(g);
            }) : e.setFocus(g));
        }
      }
      function ub(o, e) {
        if (e.type == "text")
          return o.unit === "word" ? function(t, n) {
            let i = t.position.textNode;
            if (i) {
              let s = t.position.offset - i.startOffset;
              for (; !db(i.data, s, n) && !hb(i, s, n); ) {
                t.next();
                const l = n ? t.position.nodeAfter : t.position.nodeBefore;
                if (l && l.is("text")) {
                  const d = l.data.charAt(n ? 0 : l.data.length - 1);
                  Ou.includes(d) || (t.next(), i = t.position.textNode);
                }
                s = t.position.offset - i.startOffset;
              }
            }
            return t.position;
          }(o.walker, o.isForward) : function(t, n) {
            const i = t.position.textNode;
            if (i) {
              const s = i.data;
              let l = t.position.offset - i.startOffset;
              for (; Au(s, l) || n == "character" && Tu(s, l); )
                t.next(), l = t.position.offset - i.startOffset;
            }
            return t.position;
          }(o.walker, o.unit, o.isForward);
        if (e.type == (o.isForward ? "elementStart" : "elementEnd")) {
          if (o.schema.isObject(e.item))
            return le._createAt(e.item, o.isForward ? "after" : "before");
          if (o.schema.checkChild(e.nextPosition, "$text"))
            return e.nextPosition;
        } else {
          if (o.schema.isLimit(e.item))
            return void o.walker.skip(() => !0);
          if (o.schema.checkChild(e.nextPosition, "$text"))
            return e.nextPosition;
        }
      }
      function db(o, e, t) {
        const n = e + (t ? 0 : -1);
        return Ou.includes(o.charAt(n));
      }
      function hb(o, e, t) {
        return e === (t ? o.endOffset : 0);
      }
      function Du(o, e) {
        const t = [];
        Array.from(o.getItems({ direction: "backward" })).map((n) => e.createRangeOn(n)).filter((n) => (n.start.isAfter(o.start) || n.start.isEqual(o.start)) && (n.end.isBefore(o.end) || n.end.isEqual(o.end))).forEach((n) => {
          t.push(n.start.parent), e.remove(n);
        }), t.forEach((n) => {
          let i = n;
          for (; i.parent && i.isEmpty; ) {
            const s = e.createRangeOn(i);
            i = i.parent, e.remove(s);
          }
        });
      }
      function fb(o) {
        o.document.registerPostFixer((e) => function(t, n) {
          const i = n.document.selection, s = n.schema, l = [];
          let d = !1;
          for (const f of i.getRanges()) {
            const m = pb(f, s);
            m ? (l.push(m), d = !0) : l.push(f);
          }
          if (d) {
            let f = l;
            if (l.length > 1) {
              const m = l[0].start, g = l[l.length - 1].end;
              f = [new ie(m, g)];
            }
            t.setSelection(f, { backward: i.isBackward });
          }
        }(e, o));
      }
      function pb(o, e) {
        return o.isCollapsed ? function(t, n) {
          const i = t.start, s = n.getNearestSelectionRange(i);
          if (!s)
            return null;
          const l = s.start;
          return i.isEqual(l) ? null : l.nodeAfter && n.isLimit(l.nodeAfter) ? new ie(l, le._createAfter(l.nodeAfter)) : new ie(l);
        }(o, e) : function(t, n) {
          const i = t.start, s = t.end, l = n.checkChild(i, "$text"), d = n.checkChild(s, "$text"), f = n.getLimitElement(i), m = n.getLimitElement(s);
          if (f === m) {
            if (l && d)
              return null;
            if (function(y, C, O) {
              const D = y.nodeAfter && !O.isLimit(y.nodeAfter) || O.checkChild(y, "$text"), oe = C.nodeBefore && !O.isLimit(C.nodeBefore) || O.checkChild(C, "$text");
              return D || oe;
            }(i, s, n)) {
              const y = i.nodeAfter && n.isObject(i.nodeAfter), C = y ? null : n.getNearestSelectionRange(i, "forward"), O = s.nodeBefore && n.isObject(s.nodeBefore), D = O ? null : n.getNearestSelectionRange(s, "backward"), oe = C ? C.start : i, ce = D ? D.start : s;
              return new ie(oe, ce);
            }
          }
          const g = f && !f.is("rootElement"), b = m && !m.is("rootElement");
          if (g || b) {
            const y = i.nodeAfter && s.nodeBefore && i.nodeAfter.parent === s.nodeBefore.parent, C = g && (!y || !Ru(i.nodeAfter, n)), O = b && (!y || !Ru(s.nodeBefore, n));
            let D = i, oe = s;
            return C && (D = le._createBefore(Nu(f, n))), O && (oe = le._createAfter(Nu(m, n))), new ie(D, oe);
          }
          return null;
        }(o, e);
      }
      function Nu(o, e) {
        let t = o, n = t;
        for (; e.isLimit(n) && n.parent; )
          t = n, n = n.parent;
        return t;
      }
      function Ru(o, e) {
        return o && e.isObject(o);
      }
      class Lu {
        constructor() {
          this.markers = new Pu(), this.document = new Iu(this), this.schema = new pu(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach((e) => this.decorate(e)), this.on("applyOperation", (e, t) => {
            t[0]._validate();
          }, { priority: "highest" }), this.schema.register("$root", { isLimit: !0 }), this.schema.register("$block", { allowIn: "$root", isBlock: !0 }), this.schema.register("$text", { allowIn: "$block", isInline: !0 }), this.schema.register("$clipboardHolder", { allowContentOf: "$root", isLimit: !0 }), this.schema.extend("$text", { allowIn: "$clipboardHolder" }), this.schema.register("$marker"), this.schema.addChildCheck((e, t) => {
            if (t.name === "$marker")
              return !0;
          }), fb(this);
        }
        change(e) {
          return this._pendingChanges.length === 0 ? (this._pendingChanges.push({ batch: new fo(), callback: e }), this._runPendingChanges()[0]) : e(this._currentWriter);
        }
        enqueueChange(e, t) {
          typeof e == "string" ? e = new fo(e) : typeof e == "function" && (t = e, e = new fo()), this._pendingChanges.push({ batch: e, callback: t }), this._pendingChanges.length == 1 && this._runPendingChanges();
        }
        applyOperation(e) {
          e._execute();
        }
        insertContent(e, t, n) {
          return function(i, s, l, d) {
            return i.change((f) => {
              let m;
              const g = (m = l ? l instanceof On || l instanceof wn ? l : f.createSelection(l, d) : i.document.selection).getFirstPosition();
              m.isCollapsed || i.deleteContent(m, { doNotAutoparagraph: !0 });
              const b = new ab(i, f, g);
              let y;
              y = s.is("documentFragment") ? s.getChildren() : [s], b.handleNodes(y, { isFirst: !0, isLast: !0 });
              const C = b.getSelectionRange();
              C && (m instanceof wn ? f.setSelection(C) : m.setTo(C));
              const O = b.getAffectedRange() || i.createRange(g);
              return b.destroy(), O;
            });
          }(this, e, t, n);
        }
        deleteContent(e, t) {
          lb(this, e, t);
        }
        modifySelection(e, t) {
          cb(this, e, t);
        }
        getSelectedContent(e) {
          return function(t, n) {
            return t.change((i) => {
              const s = i.createDocumentFragment(), l = n.getFirstRange();
              if (!l || l.isCollapsed)
                return s;
              const d = l.start.root, f = l.start.getCommonPath(l.end), m = d.getNodeByPath(f);
              let g;
              const b = (g = l.start.parent == l.end.parent ? l : i.createRange(i.createPositionAt(m, l.start.path[f.length]), i.createPositionAt(m, l.end.path[f.length] + 1))).end.offset - g.start.offset;
              for (const y of g.getItems({ shallow: !0 }))
                y.is("textProxy") ? i.appendText(y.data, y.getAttributes(), s) : i.append(y._clone(!0), s);
              if (g != l) {
                const y = l._getTransformedByMove(g.start, i.createPositionAt(s, 0), b)[0], C = i.createRange(i.createPositionAt(s, 0), y.start);
                Du(i.createRange(y.end, i.createPositionAt(s, "end")), i), Du(C, i);
              }
              return s;
            });
          }(this, e);
        }
        hasContent(e, t) {
          const n = e instanceof it ? ie._createIn(e) : e;
          if (n.isCollapsed)
            return !1;
          for (const s of this.markers.getMarkersIntersectingRange(n))
            if (s.affectsData)
              return !0;
          const { ignoreWhitespaces: i = !1 } = t || {};
          for (const s of n.getItems())
            if (s.is("textProxy")) {
              if (!i || s.data.search(/\S/) !== -1)
                return !0;
            } else if (this.schema.isObject(s))
              return !0;
          return !1;
        }
        createPositionFromPath(e, t, n) {
          return new le(e, t, n);
        }
        createPositionAt(e, t) {
          return le._createAt(e, t);
        }
        createPositionAfter(e) {
          return le._createAfter(e);
        }
        createPositionBefore(e) {
          return le._createBefore(e);
        }
        createRange(e, t) {
          return new ie(e, t);
        }
        createRangeIn(e) {
          return ie._createIn(e);
        }
        createRangeOn(e) {
          return ie._createOn(e);
        }
        createSelection(e, t, n) {
          return new On(e, t, n);
        }
        createBatch(e) {
          return new fo(e);
        }
        destroy() {
          this.document.destroy(), this.stopListening();
        }
        _runPendingChanges() {
          const e = [];
          for (this.fire("_beforeChanges"); this._pendingChanges.length; ) {
            const t = this._pendingChanges[0].batch;
            this._currentWriter = new tb(this, t);
            const n = this._pendingChanges[0].callback(this._currentWriter);
            e.push(n), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }
          return this.fire("_afterChanges"), e;
        }
      }
      $e(Lu, xt);
      class ci {
        constructor() {
          this._listener = Object.create(ro);
        }
        listenTo(e) {
          this._listener.listenTo(e, "keydown", (t, n) => {
            this._listener.fire("_keydown:" + Yn(n), n);
          });
        }
        set(e, t, n = {}) {
          const i = fc(e), s = n.priority;
          this._listener.listenTo(this._listener, "_keydown:" + i, (l, d) => {
            t(d, () => {
              d.preventDefault(), d.stopPropagation(), l.stop();
            }), l.return = !0;
          }, { priority: s });
        }
        press(e) {
          return !!this._listener.fire("_keydown:" + Yn(e), e);
        }
        destroy() {
          this._listener.stopListening();
        }
      }
      class mb extends ci {
        constructor(e) {
          super(), this.editor = e;
        }
        set(e, t, n = {}) {
          if (typeof t == "string") {
            const i = t;
            t = (s, l) => {
              this.editor.execute(i), l();
            };
          }
          super.set(e, t, n);
        }
      }
      class Fu {
        constructor(e) {
          const t = this.constructor.builtinPlugins;
          this.config = new fg(e, this.constructor.defaultConfig), this.config.define("plugins", t), this.plugins = new hu(this, t), this.commands = new $v();
          const n = this.config.get("language") || {};
          this.locale = new Vv({ uiLanguage: typeof n == "string" ? n : n.ui, contentLanguage: this.config.get("language.content") }), this.t = this.locale.t, this.set("state", "initializing"), this.once("ready", () => this.state = "ready", { priority: "high" }), this.once("destroy", () => this.state = "destroyed", { priority: "high" }), this.set("isReadOnly", !1), this.model = new Lu(), this.data = new gu(this.model), this.editing = new du(this.model), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new Jv([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new mb(this), this.keystrokes.listenTo(this.editing.view.document);
        }
        initPlugins() {
          const e = this.config, t = e.get("plugins") || [], n = e.get("removePlugins") || [], i = e.get("extraPlugins") || [];
          return this.plugins.init(t.concat(i), n);
        }
        destroy() {
          let e = Promise.resolve();
          return this.state == "initializing" && (e = new Promise((t) => this.once("ready", t))), e.then(() => {
            this.fire("destroy"), this.stopListening(), this.commands.destroy();
          }).then(() => this.plugins.destroy()).then(() => {
            this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
          });
        }
        execute(...e) {
          this.commands.execute(...e);
        }
      }
      $e(Fu, xt);
      var gb = { setData(o) {
        this.data.set(o);
      }, getData(o) {
        return this.data.get(o);
      } }, vb = { updateSourceElement() {
        if (!this.sourceElement)
          throw new V.b("editor-missing-sourceelement: Cannot update the source element of a detached editor.", this);
        (function(o, e) {
          o instanceof HTMLTextAreaElement && (o.value = e), o.innerHTML = e;
        })(this.sourceElement, this.data.get());
      } };
      class bb {
        getHtml(e) {
          const t = document.implementation.createHTMLDocument("").createElement("div");
          return t.appendChild(e), t.innerHTML;
        }
      }
      class zu {
        constructor() {
          this._domParser = new DOMParser(), this._domConverter = new no({ blockFiller: yc }), this._htmlWriter = new bb();
        }
        toData(e) {
          const t = this._domConverter.viewToDom(e, document);
          return this._htmlWriter.getHtml(t);
        }
        toView(e) {
          const t = this._toDom(e);
          return this._domConverter.domToView(t);
        }
        _toDom(e) {
          const t = this._domParser.parseFromString(e, "text/html"), n = t.createDocumentFragment(), i = t.body.childNodes;
          for (; i.length > 0; )
            n.appendChild(i[0]);
          return n;
        }
      }
      class _b {
        constructor(e) {
          this.editor = e, this._components = /* @__PURE__ */ new Map();
        }
        *names() {
          for (const e of this._components.values())
            yield e.originalName;
        }
        add(e, t) {
          if (this.has(e))
            throw new V.b("componentfactory-item-exists: The item already exists in the component factory.", this, { name: e });
          this._components.set(Js(e), { callback: t, originalName: e });
        }
        create(e) {
          if (!this.has(e))
            throw new V.b("componentfactory-item-missing: The required component is not registered in the factory.", this, { name: e });
          return this._components.get(Js(e)).callback(this.editor.locale);
        }
        has(e) {
          return this._components.has(Js(e));
        }
      }
      function Js(o) {
        return String(o).toLowerCase();
      }
      class yn {
        constructor() {
          this.set("isFocused", !1), this.set("focusedElement", null), this._elements = /* @__PURE__ */ new Set(), this._nextEventLoopTimeout = null;
        }
        add(e) {
          if (this._elements.has(e))
            throw new V.b("focusTracker-add-element-already-exist", this);
          this.listenTo(e, "focus", () => this._focus(e), { useCapture: !0 }), this.listenTo(e, "blur", () => this._blur(), { useCapture: !0 }), this._elements.add(e);
        }
        remove(e) {
          e === this.focusedElement && this._blur(e), this._elements.has(e) && (this.stopListening(e), this._elements.delete(e));
        }
        destroy() {
          this.stopListening();
        }
        _focus(e) {
          clearTimeout(this._nextEventLoopTimeout), this.focusedElement = e, this.isFocused = !0;
        }
        _blur() {
          clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(() => {
            this.focusedElement = null, this.isFocused = !1;
          }, 0);
        }
      }
      $e(yn, ro), $e(yn, xt);
      class $u {
        constructor(e) {
          this.editor = e, this.componentFactory = new _b(e), this.focusTracker = new yn(), this._editableElementsMap = /* @__PURE__ */ new Map(), this.listenTo(e.editing.view.document, "layoutChanged", () => this.update());
        }
        get element() {
          return null;
        }
        update() {
          this.fire("update");
        }
        destroy() {
          this.stopListening(), this.focusTracker.destroy();
          for (const e of this._editableElementsMap.values())
            e.ckeditorInstance = null;
          this._editableElementsMap = /* @__PURE__ */ new Map();
        }
        setEditableElement(e, t) {
          this._editableElementsMap.set(e, t), t.ckeditorInstance || (t.ckeditorInstance = this.editor);
        }
        getEditableElement(e = "main") {
          return this._editableElementsMap.get(e);
        }
        getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
        get _editableElements() {
          return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", { editorUI: this }), this._editableElementsMap;
        }
      }
      $e($u, dt), p(14);
      const po = /* @__PURE__ */ new WeakMap();
      function ju(o) {
        const { view: e, element: t, text: n, isDirectHost: i = !0 } = o, s = e.document;
        po.has(s) || (po.set(s, /* @__PURE__ */ new Map()), s.registerPostFixer((l) => Bu(s, l))), po.get(s).set(t, { text: n, isDirectHost: i }), e.change((l) => Bu(s, l));
      }
      function wb(o, e) {
        return !!e.hasClass("ck-placeholder") && (o.removeClass("ck-placeholder", e), !0);
      }
      function Bu(o, e) {
        const t = po.get(o);
        let n = !1;
        for (const [i, s] of t)
          yb(e, i, s) && (n = !0);
        return n;
      }
      function yb(o, e, t) {
        const { text: n, isDirectHost: i } = t, s = i ? e : function(d) {
          if (d.childCount === 1) {
            const f = d.getChild(0);
            if (f.is("element") && !f.is("uiElement"))
              return f;
          }
          return null;
        }(e);
        let l = !1;
        return !!s && (t.hostElement = s, s.getAttribute("data-placeholder") !== n && (o.setAttribute("data-placeholder", n, s), l = !0), function(d) {
          const f = d.document;
          if (!f)
            return !1;
          const m = !Array.from(d.getChildren()).some((b) => !b.is("uiElement"));
          if (!f.isFocused && m)
            return !0;
          const g = f.selection.anchor;
          return !(!m || !g || g.parent === d);
        }(s) ? function(d, f) {
          return !f.hasClass("ck-placeholder") && (d.addClass("ck-placeholder", f), !0);
        }(o, s) && (l = !0) : wb(o, s) && (l = !0), l);
      }
      class kb {
        constructor() {
          this._replacedElements = [];
        }
        replace(e, t) {
          this._replacedElements.push({ element: e, newElement: t }), e.style.display = "none", t && e.parentNode.insertBefore(t, e.nextSibling);
        }
        restore() {
          this._replacedElements.forEach(({ element: e, newElement: t }) => {
            e.style.display = "", t && t.remove();
          }), this._replacedElements = [];
        }
      }
      class xb extends $u {
        constructor(e, t) {
          super(e), this.view = t, this._toolbarConfig = function(n) {
            return Array.isArray(n) ? { items: n } : n ? Object.assign({ items: [] }, n) : { items: [] };
          }(e.config.get("toolbar")), this._elementReplacer = new kb();
        }
        get element() {
          return this.view.element;
        }
        init(e) {
          const t = this.editor, n = this.view, i = t.editing.view, s = n.editable, l = i.document.getRoot();
          s.name = l.rootName, n.render();
          const d = s.element;
          this.setEditableElement(s.name, d), this.focusTracker.add(d), n.editable.bind("isFocused").to(this.focusTracker), i.attachDomRoot(d), e && this._elementReplacer.replace(e, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
        destroy() {
          const e = this.view, t = this.editor.editing.view;
          this._elementReplacer.restore(), t.detachDomRoot(e.editable.name), e.destroy(), super.destroy();
        }
        _initToolbar() {
          const e = this.editor, t = this.view, n = e.editing.view;
          t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, this._toolbarConfig.viewportTopOffset && (t.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset), t.toolbar.fillFromConfig(this._toolbarConfig.items, this.componentFactory), function({ origin: i, originKeystrokeHandler: s, originFocusTracker: l, toolbar: d, beforeFocus: f, afterBlur: m }) {
            l.add(d.element), s.set("Alt+F10", (g, b) => {
              l.isFocused && !d.focusTracker.isFocused && (f && f(), d.focus(), b());
            }), d.keystrokes.set("Esc", (g, b) => {
              d.focusTracker.isFocused && (i.focus(), m && m(), b());
            });
          }({ origin: n, originFocusTracker: this.focusTracker, originKeystrokeHandler: e.keystrokes, toolbar: t.toolbar });
        }
        _initPlaceholder() {
          const e = this.editor, t = e.editing.view, n = t.document.getRoot(), i = e.sourceElement, s = e.config.get("placeholder") || i && i.tagName.toLowerCase() === "textarea" && i.getAttribute("placeholder");
          s && ju({ view: t, element: n, text: s, isDirectHost: !1 });
        }
      }
      class ji extends _n {
        constructor(e) {
          super({ idProperty: "viewUid" }), this.on("add", (t, n, i) => {
            n.isRendered || n.render(), n.element && this._parentElement && this._parentElement.insertBefore(n.element, this._parentElement.children[i]);
          }), this.on("remove", (t, n) => {
            n.element && this._parentElement && n.element.remove();
          }), this.locale = e, this._parentElement = null;
        }
        destroy() {
          this.map((e) => e.destroy());
        }
        setParent(e) {
          this._parentElement = e;
        }
        delegate(...e) {
          if (!e.length || !function(t) {
            return t.every((n) => typeof n == "string");
          }(e))
            throw new V.b("ui-viewcollection-delegate-wrong-events: All event names must be strings.", this);
          return { to: (t) => {
            for (const n of this)
              for (const i of e)
                n.delegate(i).to(t);
            this.on("add", (n, i) => {
              for (const s of e)
                i.delegate(s).to(t);
            }), this.on("remove", (n, i) => {
              for (const s of e)
                i.stopDelegating(s, t);
            });
          } };
        }
      }
      const Sb = "http://www.w3.org/1999/xhtml";
      class Nn {
        constructor(e) {
          Object.assign(this, Wu(Hu(e))), this._isRendered = !1, this._revertData = null;
        }
        render() {
          const e = this._renderNode({ intoFragment: !0 });
          return this._isRendered = !0, e;
        }
        apply(e) {
          return this._revertData = { children: [], bindings: [], attributes: {} }, this._renderNode({ node: e, isApplying: !0, revertData: this._revertData }), e;
        }
        revert(e) {
          if (!this._revertData)
            throw new V.b("ui-template-revert-not-applied: Attempting to revert a template which has not been applied yet.", [this, e]);
          this._revertTemplateFromNode(e, this._revertData);
        }
        *getViews() {
          yield* function* e(t) {
            if (t.children)
              for (const n of t.children)
                go(n) ? yield n : ea(n) && (yield* e(n));
          }(this);
        }
        static bind(e, t) {
          return { to: (n, i) => new Cb({ eventNameOrFunction: n, attribute: n, observable: e, emitter: t, callback: i }), if: (n, i, s) => new Vu({ observable: e, emitter: t, attribute: n, valueIfTrue: i, callback: s }) };
        }
        static extend(e, t) {
          if (e._isRendered)
            throw new V.b("template-extend-render: Attempting to extend a template which has already been rendered.", [this, e]);
          (function n(i, s) {
            if (s.attributes && (i.attributes || (i.attributes = {}), Gu(i.attributes, s.attributes)), s.eventListeners && (i.eventListeners || (i.eventListeners = {}), Gu(i.eventListeners, s.eventListeners)), s.text && i.text.push(...s.text), s.children && s.children.length) {
              if (i.children.length != s.children.length)
                throw new V.b("ui-template-extend-children-mismatch: The number of children in extended definition does not match.", i);
              let l = 0;
              for (const d of s.children)
                n(i.children[l++], d);
            }
          })(e, Wu(Hu(t)));
        }
        _renderNode(e) {
          if (e.node ? this.tag && this.text : this.tag ? this.text : !this.text)
            throw new V.b('ui-template-wrong-syntax: Node definition must have either "tag" or "text" when rendering a new Node.', this);
          return this.text ? this._renderText(e) : this._renderElement(e);
        }
        _renderElement(e) {
          let t = e.node;
          return t || (t = e.node = document.createElementNS(this.ns || Sb, this.tag)), this._renderAttributes(e), this._renderElementChildren(e), this._setUpListeners(e), t;
        }
        _renderText(e) {
          let t = e.node;
          return t ? e.revertData.text = t.textContent : t = e.node = document.createTextNode(""), mo(this.text) ? this._bindToObservable({ schema: this.text, updater: function(n) {
            return { set(i) {
              n.textContent = i;
            }, remove() {
              n.textContent = "";
            } };
          }(t), data: e }) : t.textContent = this.text.join(""), t;
        }
        _renderAttributes(e) {
          let t, n, i, s;
          if (!this.attributes)
            return;
          const l = e.node, d = e.revertData;
          for (t in this.attributes)
            if (i = l.getAttribute(t), n = this.attributes[t], d && (d.attributes[t] = i), s = te(n[0]) && n[0].ns ? n[0].ns : null, mo(n)) {
              const f = s ? n[0].value : n;
              d && Zu(t) && f.unshift(i), this._bindToObservable({ schema: f, updater: Ab(l, t, s), data: e });
            } else
              t == "style" && typeof n[0] != "string" ? this._renderStyleAttribute(n[0], e) : (d && i && Zu(t) && n.unshift(i), Bi(n = n.map((f) => f && f.value || f).reduce((f, m) => f.concat(m), []).reduce(qu, "")) || l.setAttributeNS(s, t, n));
        }
        _renderStyleAttribute(e, t) {
          const n = t.node;
          for (const i in e) {
            const s = e[i];
            mo(s) ? this._bindToObservable({ schema: [s], updater: Tb(n, i), data: t }) : n.style[i] = s;
          }
        }
        _renderElementChildren(e) {
          const t = e.node, n = e.intoFragment ? document.createDocumentFragment() : t, i = e.isApplying;
          let s = 0;
          for (const l of this.children)
            if (ta(l)) {
              if (!i) {
                l.setParent(t);
                for (const d of l)
                  n.appendChild(d.element);
              }
            } else if (go(l))
              i || (l.isRendered || l.render(), n.appendChild(l.element));
            else if (Fi(l))
              n.appendChild(l);
            else if (i) {
              const d = { children: [], bindings: [], attributes: {} };
              e.revertData.children.push(d), l._renderNode({ node: n.childNodes[s++], isApplying: !0, revertData: d });
            } else
              n.appendChild(l.render());
          e.intoFragment && t.appendChild(n);
        }
        _setUpListeners(e) {
          if (this.eventListeners)
            for (const t in this.eventListeners) {
              const n = this.eventListeners[t].map((i) => {
                const [s, l] = t.split("@");
                return i.activateDomEventListener(s, l, e);
              });
              e.revertData && e.revertData.bindings.push(n);
            }
        }
        _bindToObservable({ schema: e, updater: t, data: n }) {
          const i = n.revertData;
          Uu(e, t, n);
          const s = e.filter((l) => !Bi(l)).filter((l) => l.observable).map((l) => l.activateAttributeListener(e, t, n));
          i && i.bindings.push(s);
        }
        _revertTemplateFromNode(e, t) {
          for (const n of t.bindings)
            for (const i of n)
              i();
          if (t.text)
            e.textContent = t.text;
          else {
            for (const n in t.attributes) {
              const i = t.attributes[n];
              i === null ? e.removeAttribute(n) : e.setAttribute(n, i);
            }
            for (let n = 0; n < t.children.length; ++n)
              this._revertTemplateFromNode(e.childNodes[n], t.children[n]);
          }
        }
      }
      $e(Nn, dt);
      class br {
        constructor(e) {
          Object.assign(this, e);
        }
        getValue(e) {
          const t = this.observable[this.attribute];
          return this.callback ? this.callback(t, e) : t;
        }
        activateAttributeListener(e, t, n) {
          const i = () => Uu(e, t, n);
          return this.emitter.listenTo(this.observable, "change:" + this.attribute, i), () => {
            this.emitter.stopListening(this.observable, "change:" + this.attribute, i);
          };
        }
      }
      class Cb extends br {
        activateDomEventListener(e, t, n) {
          const i = (s, l) => {
            t && !l.target.matches(t) || (typeof this.eventNameOrFunction == "function" ? this.eventNameOrFunction(l) : this.observable.fire(this.eventNameOrFunction, l));
          };
          return this.emitter.listenTo(n.node, e, i), () => {
            this.emitter.stopListening(n.node, e, i);
          };
        }
      }
      class Vu extends br {
        getValue(e) {
          return !Bi(super.getValue(e)) && (this.valueIfTrue || !0);
        }
      }
      function mo(o) {
        return !!o && (o.value && (o = o.value), Array.isArray(o) ? o.some(mo) : o instanceof br);
      }
      function Uu(o, e, { node: t }) {
        let n = function(i, s) {
          return i.map((l) => l instanceof br ? l.getValue(s) : l);
        }(o, t);
        Bi(n = o.length == 1 && o[0] instanceof Vu ? n[0] : n.reduce(qu, "")) ? e.remove() : e.set(n);
      }
      function Ab(o, e, t) {
        return { set(n) {
          o.setAttributeNS(t, e, n);
        }, remove() {
          o.removeAttributeNS(t, e);
        } };
      }
      function Tb(o, e) {
        return { set(t) {
          o.style[e] = t;
        }, remove() {
          o.style[e] = null;
        } };
      }
      function Hu(o) {
        return ql(o, (e) => {
          if (e && (e instanceof br || ea(e) || go(e) || ta(e)))
            return e;
        });
      }
      function Wu(o) {
        if (typeof o == "string" ? o = function(e) {
          return { text: [e] };
        }(o) : o.text && function(e) {
          Array.isArray(e.text) || (e.text = [e.text]);
        }(o), o.on && (o.eventListeners = function(e) {
          for (const t in e)
            Yu(e, t);
          return e;
        }(o.on), delete o.on), !o.text) {
          o.attributes && function(t) {
            for (const n in t)
              t[n].value && (t[n].value = [].concat(t[n].value)), Yu(t, n);
          }(o.attributes);
          const e = [];
          if (o.children)
            if (ta(o.children))
              e.push(o.children);
            else
              for (const t of o.children)
                ea(t) || go(t) || Fi(t) ? e.push(t) : e.push(new Nn(t));
          o.children = e;
        }
        return o;
      }
      function Yu(o, e) {
        Array.isArray(o[e]) || (o[e] = [o[e]]);
      }
      function qu(o, e) {
        return Bi(e) ? o : Bi(o) ? e : `${o} ${e}`;
      }
      function Gu(o, e) {
        for (const t in e)
          o[t] ? o[t].push(...e[t]) : o[t] = e[t];
      }
      function Bi(o) {
        return !o && o !== 0;
      }
      function go(o) {
        return o instanceof Ge;
      }
      function ea(o) {
        return o instanceof Nn;
      }
      function ta(o) {
        return o instanceof ji;
      }
      function Zu(o) {
        return o == "class" || o == "style";
      }
      p(16);
      class Ge {
        constructor(e) {
          this.element = null, this.isRendered = !1, this.locale = e, this.t = e && e.t, this._viewCollections = new _n(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", (t, n) => {
            n.locale = e;
          }), this.decorate("render");
        }
        get bindTemplate() {
          return this._bindTemplate ? this._bindTemplate : this._bindTemplate = Nn.bind(this, this);
        }
        createCollection() {
          const e = new ji();
          return this._viewCollections.add(e), e;
        }
        registerChild(e) {
          Hn(e) || (e = [e]);
          for (const t of e)
            this._unboundChildren.add(t);
        }
        deregisterChild(e) {
          Hn(e) || (e = [e]);
          for (const t of e)
            this._unboundChildren.remove(t);
        }
        setTemplate(e) {
          this.template = new Nn(e);
        }
        extendTemplate(e) {
          Nn.extend(this.template, e);
        }
        render() {
          if (this.isRendered)
            throw new V.b("ui-view-render-already-rendered: This View has already been rendered.", this);
          this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
        }
        destroy() {
          this.stopListening(), this._viewCollections.map((e) => e.destroy()), this.template && this.template._revertData && this.template.revert(this.element);
        }
      }
      $e(Ge, ro), $e(Ge, xt), p(18);
      class Ib extends Ge {
        constructor(e) {
          super(e), this.body = this.createCollection();
        }
        render() {
          super.render(), this._renderBodyCollection();
        }
        destroy() {
          return this._bodyCollectionContainer.remove(), super.destroy();
        }
        _renderBodyCollection() {
          const e = this.locale, t = this._bodyCollectionContainer = new Nn({ tag: "div", attributes: { class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"], dir: e.uiLanguageDirection }, children: this.body }).render();
          document.body.appendChild(t);
        }
      }
      p(20);
      class Ku extends Ge {
        constructor(e) {
          super(e), this.set("text"), this.set("for");
          const t = this.bindTemplate;
          this.setTemplate({ tag: "label", attributes: { class: ["ck", "ck-label"], for: t.to("for") }, children: [{ text: t.to("text") }] });
        }
      }
      class Eb extends Ib {
        constructor(e) {
          super(e);
          const t = Vn();
          this.top = this.createCollection(), this.main = this.createCollection(), this._voiceLabelView = this._createVoiceLabel(t), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"], role: "application", dir: e.uiLanguageDirection, lang: e.uiLanguage, "aria-labelledby": `ck-editor__aria-label_${t}` }, children: [this._voiceLabelView, { tag: "div", attributes: { class: ["ck", "ck-editor__top", "ck-reset_all"], role: "presentation" }, children: this.top }, { tag: "div", attributes: { class: ["ck", "ck-editor__main"], role: "presentation" }, children: this.main }] });
        }
        _createVoiceLabel(e) {
          const t = this.t, n = new Ku();
          return n.text = t("bm"), n.extendTemplate({ attributes: { id: `ck-editor__aria-label_${e}`, class: "ck-voice-label" } }), n;
        }
      }
      class Pb extends Ge {
        constructor(e, t, n) {
          super(e), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"], lang: e.contentLanguage, dir: e.contentLanguageDirection } }), this.name = null, this.set("isFocused", !1), this._editableElement = n, this._hasExternalElement = !!this._editableElement, this._editingView = t;
        }
        render() {
          super.render(), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", () => this._updateIsFocusedClasses()), this._updateIsFocusedClasses();
        }
        destroy() {
          this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
        }
        _updateIsFocusedClasses() {
          const e = this._editingView;
          function t(n) {
            e.change((i) => {
              const s = e.document.getRoot(n.name);
              i.addClass(n.isFocused ? "ck-focused" : "ck-blurred", s), i.removeClass(n.isFocused ? "ck-blurred" : "ck-focused", s);
            });
          }
          e.isRenderingInProgress ? function n(i) {
            e.once("change:isRenderingInProgress", (s, l, d) => {
              d ? n(i) : t(i);
            });
          }(this) : t(this);
        }
      }
      class Mb extends Pb {
        constructor(e, t, n) {
          super(e, t, n), this.extendTemplate({ attributes: { role: "textbox", class: "ck-editor__editable_inline" } });
        }
        render() {
          super.render();
          const e = this._editingView, t = this.t;
          e.change((n) => {
            const i = e.document.getRoot(this.name);
            n.setAttribute("aria-label", t("bn", [this.name]), i);
          });
        }
      }
      function na(o) {
        return (e) => e + o;
      }
      p(22);
      const _r = na("px");
      class Ob extends Ge {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set("isActive", !1), this.set("isSticky", !1), this.set("limiterElement", null), this.set("limiterBottomOffset", 50), this.set("viewportTopOffset", 0), this.set("_marginLeft", null), this.set("_isStickyToTheLimiter", !1), this.set("_hasViewportTopOffset", !1), this.content = this.createCollection(), this._contentPanelPlaceholder = new Nn({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__placeholder"], style: { display: t.to("isSticky", (n) => n ? "block" : "none"), height: t.to("isSticky", (n) => n ? _r(this._panelRect.height) : null) } } }).render(), this._contentPanel = new Nn({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__content", t.if("isSticky", "ck-sticky-panel__content_sticky"), t.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")], style: { width: t.to("isSticky", (n) => n ? _r(this._contentPanelPlaceholder.getBoundingClientRect().width) : null), top: t.to("_hasViewportTopOffset", (n) => n ? _r(this.viewportTopOffset) : null), bottom: t.to("_isStickyToTheLimiter", (n) => n ? _r(this.limiterBottomOffset) : null), marginLeft: t.to("_marginLeft") } }, children: this.content }).render(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel"] }, children: [this._contentPanelPlaceholder, this._contentPanel] });
        }
        render() {
          super.render(), this._checkIfShouldBeSticky(), this.listenTo(jt.window, "scroll", () => {
            this._checkIfShouldBeSticky();
          }), this.listenTo(this, "change:isActive", () => {
            this._checkIfShouldBeSticky();
          });
        }
        _checkIfShouldBeSticky() {
          const e = this._panelRect = this._contentPanel.getBoundingClientRect();
          let t;
          this.limiterElement ? (t = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && t.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < t.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = t.bottom < e.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : _r(-jt.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
        }
      }
      class Vi {
        constructor(e) {
          if (Object.assign(this, e), e.actions && e.keystrokeHandler)
            for (const t in e.actions) {
              let n = e.actions[t];
              typeof n == "string" && (n = [n]);
              for (const i of n)
                e.keystrokeHandler.set(i, (s, l) => {
                  this[t](), l();
                });
            }
        }
        get first() {
          return this.focusables.find(ia) || null;
        }
        get last() {
          return this.focusables.filter(ia).slice(-1)[0] || null;
        }
        get next() {
          return this._getFocusableItem(1);
        }
        get previous() {
          return this._getFocusableItem(-1);
        }
        get current() {
          let e = null;
          return this.focusTracker.focusedElement === null ? null : (this.focusables.find((t, n) => {
            const i = t.element === this.focusTracker.focusedElement;
            return i && (e = n), i;
          }), e);
        }
        focusFirst() {
          this._focus(this.first);
        }
        focusLast() {
          this._focus(this.last);
        }
        focusNext() {
          this._focus(this.next);
        }
        focusPrevious() {
          this._focus(this.previous);
        }
        _focus(e) {
          e && e.focus();
        }
        _getFocusableItem(e) {
          const t = this.current, n = this.focusables.length;
          if (!n)
            return null;
          if (t === null)
            return this[e === 1 ? "first" : "last"];
          let i = (t + n + e) % n;
          do {
            const s = this.focusables.get(i);
            if (ia(s))
              return s;
            i = (i + n + e) % n;
          } while (i !== t);
          return null;
        }
      }
      function ia(o) {
        return !(!o.focus || jt.window.getComputedStyle(o.element).display == "none");
      }
      class Db extends Ge {
        constructor(e) {
          super(e), this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-toolbar__separator"] } });
        }
      }
      p(24);
      class ra extends Ge {
        constructor(e) {
          super(e);
          const t = this.bindTemplate, n = this.t;
          this.set("ariaLabel", n("bl")), this.items = this.createCollection(), this.focusTracker = new yn(), this.keystrokes = new ci(), this.set("isVertical", !1), this.set("class"), this._focusCycler = new Vi({ focusables: this.items, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: ["arrowleft", "arrowup"], focusNext: ["arrowright", "arrowdown"] } }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-toolbar", t.if("isVertical", "ck-toolbar_vertical"), t.to("class")], role: "toolbar", "aria-label": t.to("ariaLabel") }, children: this.items, on: { mousedown: function(i) {
            return i.bindTemplate.to((s) => {
              s.target === i.element && s.preventDefault();
            });
          }(this) } });
        }
        render() {
          super.render();
          for (const e of this.items)
            this.focusTracker.add(e.element);
          this.items.on("add", (e, t) => {
            this.focusTracker.add(t.element);
          }), this.items.on("remove", (e, t) => {
            this.focusTracker.remove(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        focusLast() {
          this._focusCycler.focusLast();
        }
        fillFromConfig(e, t) {
          e.map((n) => {
            n == "|" ? this.items.add(new Db()) : t.has(n) ? this.items.add(t.create(n)) : console.warn(Object(V.a)("toolbarview-item-unavailable: The requested toolbar item is unavailable."), { name: n });
          });
        }
      }
      p(26);
      class Nb extends Eb {
        constructor(e, t) {
          super(e), this.stickyPanel = new Ob(e), this.toolbar = new ra(e), this.editable = new Mb(e, t);
        }
        render() {
          super.render(), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }
      class oa extends Fu {
        constructor(e, t) {
          super(t), Bn(e) && (this.sourceElement = e), this.data.processor = new zu(), this.model.document.createRoot(), this.ui = new xb(this, new Nb(this.locale, this.editing.view)), function(n) {
            if (!fe(n.updateSourceElement))
              throw new V.b("attachtoform-missing-elementapi-interface: Editor passed to attachToForm() must implement ElementApi.", n);
            const i = n.sourceElement;
            if (i && i.tagName.toLowerCase() === "textarea" && i.form) {
              let s;
              const l = i.form, d = () => n.updateSourceElement();
              fe(l.submit) && (s = l.submit, l.submit = () => {
                d(), s.apply(l);
              }), l.addEventListener("submit", d), n.on("destroy", () => {
                l.removeEventListener("submit", d), s && (l.submit = s);
              });
            }
          }(this);
        }
        destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
        }
        static create(e, t = {}) {
          return new Promise((n) => {
            const i = new this(e, t);
            n(i.initPlugins().then(() => i.ui.init(Bn(e) ? e : null)).then(() => {
              if (!Bn(e) && t.initialData)
                throw new V.b("editor-create-initial-data: The config.initialData option cannot be used together with initial data passed in Editor.create().", null);
              const s = t.initialData || function(l) {
                return Bn(l) ? function(d) {
                  return d instanceof HTMLTextAreaElement ? d.value : d.innerHTML;
                }(l) : l;
              }(e);
              return i.data.init(s);
            }).then(() => i.fire("ready")).then(() => i));
          });
        }
      }
      $e(oa, gb), $e(oa, vb);
      class Ae {
        constructor(e) {
          this.editor = e;
        }
        destroy() {
          this.stopListening();
        }
      }
      $e(Ae, xt);
      class Xe {
        constructor(e) {
          this.editor = e, this.set("value", void 0), this.set("isEnabled", !1), this._disableStack = /* @__PURE__ */ new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", () => {
            this.refresh();
          }), this.on("execute", (t) => {
            this.isEnabled || t.stop();
          }, { priority: "high" }), this.listenTo(e, "change:isReadOnly", (t, n, i) => {
            i ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
          });
        }
        refresh() {
          this.isEnabled = !0;
        }
        forceDisabled(e) {
          this._disableStack.add(e), this._disableStack.size == 1 && (this.on("set:isEnabled", Xu, { priority: "highest" }), this.isEnabled = !1);
        }
        clearForceDisabled(e) {
          this._disableStack.delete(e), this._disableStack.size == 0 && (this.off("set:isEnabled", Xu), this.refresh());
        }
        execute() {
        }
        destroy() {
          this.stopListening();
        }
      }
      function Xu(o) {
        o.return = !1, o.stop();
      }
      function Rn(o) {
        const e = o.next();
        return e.done ? null : e.value;
      }
      $e(Xe, xt);
      const Qu = ["left", "right", "center", "justify"];
      function Ju(o) {
        return Qu.includes(o);
      }
      function ed(o, e) {
        return e.contentLanguageDirection == "rtl" ? o === "right" : o === "left";
      }
      const sa = "alignment";
      class Rb extends Xe {
        refresh() {
          const e = this.editor.locale, t = Rn(this.editor.model.document.selection.getSelectedBlocks());
          this.isEnabled = !!t && this._canBeAligned(t), this.isEnabled && t.hasAttribute("alignment") ? this.value = t.getAttribute("alignment") : this.value = e.contentLanguageDirection === "rtl" ? "right" : "left";
        }
        execute(e = {}) {
          const t = this.editor, n = t.locale, i = t.model, s = i.document, l = e.value;
          i.change((d) => {
            const f = Array.from(s.selection.getSelectedBlocks()).filter((g) => this._canBeAligned(g)), m = f[0].getAttribute("alignment");
            ed(l, n) || m === l || !l ? function(g, b) {
              for (const y of g)
                b.removeAttribute(sa, y);
            }(f, d) : function(g, b, y) {
              for (const C of g)
                b.setAttribute(sa, y, C);
            }(f, d, l);
          });
        }
        _canBeAligned(e) {
          return this.editor.model.schema.checkAttribute(e, sa);
        }
      }
      class Lb extends Ae {
        constructor(e) {
          super(e), e.config.define("alignment", { options: [...Qu] });
        }
        init() {
          const e = this.editor, t = e.locale, n = e.model.schema, i = e.config.get("alignment.options").filter(Ju);
          n.extend("$block", { allowAttributes: "alignment" }), e.model.schema.setAttributeProperties("alignment", { isFormatting: !0 });
          const s = function(l) {
            const d = { model: { key: "alignment", values: l.slice() }, view: {} };
            for (const f of l)
              d.view[f] = { key: "style", value: { "text-align": f } };
            return d;
          }(i.filter((l) => !ed(l, t)));
          e.conversion.attributeToAttribute(s), e.commands.add("alignment", new Rb(e));
        }
      }
      p(28);
      class vo extends Ge {
        constructor() {
          super();
          const e = this.bindTemplate;
          this.set("content", ""), this.set("viewBox", "0 0 20 20"), this.set("fillColor", ""), this.setTemplate({ tag: "svg", ns: "http://www.w3.org/2000/svg", attributes: { class: ["ck", "ck-icon"], viewBox: e.to("viewBox") } });
        }
        render() {
          super.render(), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", () => {
            this._updateXMLContent(), this._colorFillPaths();
          }), this.on("change:fillColor", () => {
            this._colorFillPaths();
          });
        }
        _updateXMLContent() {
          if (this.content) {
            const e = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"), t = e.getAttribute("viewBox");
            for (t && (this.viewBox = t), this.element.innerHTML = ""; e.childNodes.length > 0; )
              this.element.appendChild(e.childNodes[0]);
          }
        }
        _colorFillPaths() {
          this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach((e) => {
            e.style.fill = this.fillColor;
          });
        }
      }
      p(30);
      class td extends Ge {
        constructor(e) {
          super(e), this.set("text", ""), this.set("position", "s");
          const t = this.bindTemplate;
          this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-tooltip", t.to("position", (n) => "ck-tooltip_" + n), t.if("text", "ck-hidden", (n) => !n.trim())] }, children: [{ tag: "span", attributes: { class: ["ck", "ck-tooltip__text"] }, children: [{ text: t.to("text") }] }] });
        }
      }
      p(32);
      class kt extends Ge {
        constructor(e) {
          super(e);
          const t = this.bindTemplate, n = Vn();
          this.set("class"), this.set("labelStyle"), this.set("icon"), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isVisible", !0), this.set("isToggleable", !1), this.set("keystroke"), this.set("label"), this.set("tabindex", -1), this.set("tooltip"), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.children = this.createCollection(), this.tooltipView = this._createTooltipView(), this.labelView = this._createLabelView(n), this.iconView = new vo(), this.iconView.extendTemplate({ attributes: { class: "ck-button__icon" } }), this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this)), this.setTemplate({ tag: "button", attributes: { class: ["ck", "ck-button", t.to("class"), t.if("isEnabled", "ck-disabled", (i) => !i), t.if("isVisible", "ck-hidden", (i) => !i), t.to("isOn", (i) => i ? "ck-on" : "ck-off"), t.if("withText", "ck-button_with-text")], type: t.to("type", (i) => i || "button"), tabindex: t.to("tabindex"), "aria-labelledby": `ck-editor__aria-label_${n}`, "aria-disabled": t.if("isEnabled", !0, (i) => !i), "aria-pressed": t.to("isOn", (i) => !!this.isToggleable && String(i)) }, children: this.children, on: { mousedown: t.to((i) => {
            i.preventDefault();
          }), click: t.to((i) => {
            this.isEnabled ? this.fire("execute") : i.preventDefault();
          }) } });
        }
        render() {
          super.render(), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView);
        }
        focus() {
          this.element.focus();
        }
        _createTooltipView() {
          const e = new td();
          return e.bind("text").to(this, "_tooltipString"), e.bind("position").to(this, "tooltipPosition"), e;
        }
        _createLabelView(e) {
          const t = new Ge(), n = this.bindTemplate;
          return t.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__label"], style: n.to("labelStyle"), id: `ck-editor__aria-label_${e}` }, children: [{ text: this.bindTemplate.to("label") }] }), t;
        }
        _getTooltipString(e, t, n) {
          return e ? typeof e == "string" ? e : (n && (n = function(i) {
            return un.isMac ? pc(i).map((s) => Og[s.toLowerCase()] || s).reduce((s, l) => s.slice(-1) in Mg ? s + l : s + "+" + l) : i;
          }(n)), e instanceof Function ? e(t, n) : `${t}${n ? ` (${n})` : ""}`) : "";
        }
      }
      class Fb extends Ge {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-dropdown__panel", t.to("position", (n) => `ck-dropdown__panel_${n}`), t.if("isVisible", "ck-dropdown__panel-visible")] }, children: this.children, on: { selectstart: t.to((n) => n.preventDefault()) } });
        }
        focus() {
          this.children.length && this.children.first.focus();
        }
        focusLast() {
          if (this.children.length) {
            const e = this.children.last;
            typeof e.focusLast == "function" ? e.focusLast() : e.focus();
          }
        }
      }
      p(34);
      function nd({ element: o, target: e, positions: t, limiter: n, fitInViewport: i }) {
        fe(e) && (e = e()), fe(n) && (n = n());
        const s = function(y) {
          for (; y && y.tagName.toLowerCase() != "html"; ) {
            if (jt.window.getComputedStyle(y).position != "static")
              return y;
            y = y.parentElement;
          }
          return null;
        }(o.parentElement), l = new Dt(o), d = new Dt(e);
        let f, m;
        if (n || i) {
          const y = n && new Dt(n).getVisible(), C = i && new Dt(jt.window);
          [m, f] = function(O, D, oe, ce, _e) {
            let De, mt, di = 0, pn = 0;
            const Fo = oe.getArea();
            return O.some((hi) => {
              const [qa, zo] = aa(hi, D, oe);
              let Ii, xr;
              if (ce)
                if (_e) {
                  const yf = ce.getIntersection(_e);
                  Ii = yf ? yf.getIntersectionArea(zo) : 0;
                } else
                  Ii = ce.getIntersectionArea(zo);
              function $o() {
                pn = xr, di = Ii, De = zo, mt = qa;
              }
              return _e && (xr = _e.getIntersectionArea(zo)), _e && !ce ? xr > pn && $o() : !_e && ce ? Ii > di && $o() : (xr > pn && Ii >= di || xr >= pn && Ii > di) && $o(), Ii === Fo;
            }), De ? [mt, De] : null;
          }(t, d, l, y, C) || aa(t[0], d, l);
        } else
          [m, f] = aa(t[0], d, l);
        let { left: g, top: b } = id(f);
        if (s) {
          const y = id(new Dt(s)), C = Hc(s);
          g -= y.left, b -= y.top, g += s.scrollLeft, b += s.scrollTop, g -= C.left, b -= C.top;
        }
        return { left: g, top: b, name: m };
      }
      function aa(o, e, t) {
        const { left: n, top: i, name: s } = o(e, t);
        return [s, t.clone().moveTo(n, i)];
      }
      function id({ left: o, top: e }) {
        const { scrollX: t, scrollY: n } = jt.window;
        return { left: o + t, top: e + n };
      }
      class Ui extends Ge {
        constructor(e, t, n) {
          super(e);
          const i = this.bindTemplate;
          this.buttonView = t, this.panelView = n, this.set("isOpen", !1), this.set("isEnabled", !0), this.set("class"), this.set("panelPosition", "auto"), this.focusTracker = new yn(), this.keystrokes = new ci(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-dropdown", i.to("class"), i.if("isEnabled", "ck-disabled", (s) => !s)] }, children: [t, n] }), t.extendTemplate({ attributes: { class: ["ck-dropdown__button"] } });
        }
        render() {
          super.render(), this.listenTo(this.buttonView, "open", () => {
            this.isOpen = !this.isOpen;
          }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", () => {
            this.isOpen && (this.panelPosition === "auto" ? this.panelView.position = Ui._getOptimalPosition({ element: this.panelView.element, target: this.buttonView.element, fitInViewport: !0, positions: this._panelPositions }).name : this.panelView.position = this.panelPosition);
          }), this.keystrokes.listenTo(this.element), this.focusTracker.add(this.element);
          const e = (t, n) => {
            this.isOpen && (this.buttonView.focus(), this.isOpen = !1, n());
          };
          this.keystrokes.set("arrowdown", (t, n) => {
            this.buttonView.isEnabled && !this.isOpen && (this.isOpen = !0, n());
          }), this.keystrokes.set("arrowright", (t, n) => {
            this.isOpen && n();
          }), this.keystrokes.set("arrowleft", e), this.keystrokes.set("esc", e);
        }
        focus() {
          this.buttonView.focus();
        }
        get _panelPositions() {
          const { southEast: e, southWest: t, northEast: n, northWest: i } = Ui.defaultPanelPositions;
          return this.locale.uiLanguageDirection === "ltr" ? [e, t, n, i] : [t, e, i, n];
        }
      }
      Ui.defaultPanelPositions = { southEast: (o) => ({ top: o.bottom, left: o.left, name: "se" }), southWest: (o, e) => ({ top: o.bottom, left: o.left - e.width + o.width, name: "sw" }), northEast: (o, e) => ({ top: o.top - e.height, left: o.left, name: "ne" }), northWest: (o, e) => ({ top: o.bottom - e.height, left: o.left - e.width + o.width, name: "nw" }) }, Ui._getOptimalPosition = nd;
      var zb = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
      class rd extends kt {
        constructor(e) {
          super(e), this.arrowView = this._createArrowView(), this.extendTemplate({ attributes: { "aria-haspopup": !0 } }), this.delegate("execute").to(this, "open");
        }
        render() {
          super.render(), this.children.add(this.arrowView);
        }
        _createArrowView() {
          const e = new vo();
          return e.content = zb, e.extendTemplate({ attributes: { class: "ck-dropdown__arrow" } }), e;
        }
      }
      p(36);
      class $b extends Ge {
        constructor() {
          super(), this.items = this.createCollection(), this.focusTracker = new yn(), this.keystrokes = new ci(), this._focusCycler = new Vi({ focusables: this.items, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "arrowup", focusNext: "arrowdown" } }), this.setTemplate({ tag: "ul", attributes: { class: ["ck", "ck-reset", "ck-list"] }, children: this.items });
        }
        render() {
          super.render();
          for (const e of this.items)
            this.focusTracker.add(e.element);
          this.items.on("add", (e, t) => {
            this.focusTracker.add(t.element);
          }), this.items.on("remove", (e, t) => {
            this.focusTracker.remove(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        focusLast() {
          this._focusCycler.focusLast();
        }
      }
      class jb extends Ge {
        constructor(e) {
          super(e), this.children = this.createCollection(), this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__item"] }, children: this.children });
        }
        focus() {
          this.children.first.focus();
        }
      }
      class Bb extends Ge {
        constructor(e) {
          super(e), this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__separator"] } });
        }
      }
      p(38);
      class la extends kt {
        constructor(e) {
          super(e), this.isToggleable = !0, this.toggleSwitchView = this._createToggleView(), this.extendTemplate({ attributes: { class: "ck-switchbutton" } });
        }
        render() {
          super.render(), this.children.add(this.toggleSwitchView);
        }
        _createToggleView() {
          const e = new Ge();
          return e.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__toggle"] }, children: [{ tag: "span", attributes: { class: ["ck", "ck-button__toggle__inner"] } }] }), e;
        }
      }
      function ca({ emitter: o, activator: e, callback: t, contextElements: n }) {
        o.listenTo(document, "mousedown", (i, { target: s }) => {
          if (e()) {
            for (const l of n)
              if (l.contains(s))
                return;
            t();
          }
        });
      }
      p(40), p(42);
      function wr(o, e = rd) {
        const t = new e(o), n = new Fb(o), i = new Ui(o, t, n);
        return t.bind("isEnabled").to(i), t instanceof rd ? t.bind("isOn").to(i, "isOpen") : t.arrowView.bind("isOn").to(i, "isOpen"), function(s) {
          (function(l) {
            l.on("render", () => {
              ca({ emitter: l, activator: () => l.isOpen, callback: () => {
                l.isOpen = !1;
              }, contextElements: [l.element] });
            });
          })(s), function(l) {
            l.on("execute", (d) => {
              d.source instanceof la || (l.isOpen = !1);
            });
          }(s), function(l) {
            l.keystrokes.set("arrowdown", (d, f) => {
              l.isOpen && (l.panelView.focus(), f());
            }), l.keystrokes.set("arrowup", (d, f) => {
              l.isOpen && (l.panelView.focusLast(), f());
            });
          }(s);
        }(i), i;
      }
      function od(o, e) {
        const t = o.locale, n = o.listView = new $b(t);
        n.items.bindTo(e).using(({ type: i, model: s }) => {
          if (i === "separator")
            return new Bb(t);
          if (i === "button" || i === "switchbutton") {
            const l = new jb(t);
            let d;
            return (d = i === "button" ? new kt(t) : new la(t)).bind(...Object.keys(s)).to(s), d.delegate("execute").to(l), l.children.add(d), l;
          }
        }), o.panelView.children.add(n), n.items.delegate("execute").to(o);
      }
      var sd = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>', ad = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>';
      const Vb = /* @__PURE__ */ new Map([["left", sd], ["right", ad], ["center", '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>'], ["justify", '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>']]);
      class Ub extends Ae {
        get localizedOptionTitles() {
          const e = this.editor.t;
          return { left: e("d"), right: e("e"), center: e("f"), justify: e("g") };
        }
        static get pluginName() {
          return "AlignmentUI";
        }
        init() {
          const e = this.editor, t = e.ui.componentFactory, n = e.t, i = e.config.get("alignment.options");
          i.filter(Ju).forEach((s) => this._addButton(s)), t.add("alignment", (s) => {
            const l = wr(s), d = i.map((m) => t.create(`alignment:${m}`));
            (function(m, g) {
              const b = m.locale, y = b.t, C = m.toolbarView = new ra(b);
              C.set("ariaLabel", y("bo")), m.extendTemplate({ attributes: { class: ["ck-toolbar-dropdown"] } }), g.map((O) => C.items.add(O)), m.panelView.children.add(C), C.items.delegate("execute").to(m);
            })(l, d), l.buttonView.set({ label: n("h"), tooltip: !0 }), l.toolbarView.isVertical = !0, l.toolbarView.ariaLabel = n("i"), l.extendTemplate({ attributes: { class: "ck-alignment-dropdown" } });
            const f = s.contentLanguageDirection === "rtl" ? ad : sd;
            return l.buttonView.bind("icon").toMany(d, "isOn", (...m) => {
              const g = m.findIndex((b) => b);
              return g < 0 ? f : d[g].icon;
            }), l.bind("isEnabled").toMany(d, "isEnabled", (...m) => m.some((g) => g)), l;
          });
        }
        _addButton(e) {
          const t = this.editor;
          t.ui.componentFactory.add(`alignment:${e}`, (n) => {
            const i = t.commands.get("alignment"), s = new kt(n);
            return s.set({ label: this.localizedOptionTitles[e], icon: Vb.get(e), tooltip: !0, isToggleable: !0 }), s.bind("isEnabled").to(i), s.bind("isOn").to(i, "value", (l) => l === e), this.listenTo(s, "execute", () => {
              t.execute("alignment", { value: e }), t.editing.view.focus();
            }), s;
          });
        }
      }
      class Hb {
        constructor(e) {
          this.files = function(t) {
            const n = t.files ? Array.from(t.files) : [], i = t.items ? Array.from(t.items) : [];
            return n.length ? n : i.filter((s) => s.kind === "file").map((s) => s.getAsFile());
          }(e), this._native = e;
        }
        get types() {
          return this._native.types;
        }
        getData(e) {
          return this._native.getData(e);
        }
        setData(e, t) {
          this._native.setData(e, t);
        }
      }
      class Wb extends ki {
        constructor(e) {
          super(e);
          const t = this.document;
          function n(i, s) {
            s.preventDefault();
            const l = s.dropRange ? [s.dropRange] : Array.from(t.selection.getRanges()), d = new qr(t, "clipboardInput");
            t.fire(d, { dataTransfer: s.dataTransfer, targetRanges: l }), d.stop.called && s.stopPropagation();
          }
          this.domEventType = ["paste", "copy", "cut", "drop", "dragover"], this.listenTo(t, "paste", n, { priority: "low" }), this.listenTo(t, "drop", n, { priority: "low" });
        }
        onDomEvent(e) {
          const t = { dataTransfer: new Hb(e.clipboardData ? e.clipboardData : e.dataTransfer) };
          e.type == "drop" && (t.dropRange = function(n, i) {
            const s = i.target.ownerDocument, l = i.clientX, d = i.clientY;
            let f;
            return s.caretRangeFromPoint && s.caretRangeFromPoint(l, d) ? f = s.caretRangeFromPoint(l, d) : i.rangeParent && ((f = s.createRange()).setStart(i.rangeParent, i.rangeOffset), f.collapse(!0)), f ? n.domConverter.domRangeToView(f) : n.document.selection.getFirstRange();
          }(this.view, e)), this.fire(e.type, e, t);
        }
      }
      const ld = ["figcaption", "li"];
      class bo extends Ae {
        static get pluginName() {
          return "Clipboard";
        }
        init() {
          const e = this.editor, t = e.model.document, n = e.editing.view, i = n.document;
          function s(l, d) {
            const f = d.dataTransfer;
            d.preventDefault();
            const m = e.data.toView(e.model.getSelectedContent(t.selection));
            i.fire("clipboardOutput", { dataTransfer: f, content: m, method: l.name });
          }
          this._htmlDataProcessor = new zu(), n.addObserver(Wb), this.listenTo(i, "clipboardInput", (l) => {
            e.isReadOnly && l.stop();
          }, { priority: "highest" }), this.listenTo(i, "clipboardInput", (l, d) => {
            const f = d.dataTransfer;
            let m = "";
            f.getData("text/html") ? m = function(g) {
              return g.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (b, y) => y.length == 1 ? " " : y);
            }(f.getData("text/html")) : f.getData("text/plain") && (m = function(g) {
              return (g = g.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "</p><p>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).indexOf("</p><p>") > -1 && (g = `<p>${g}</p>`), g;
            }(f.getData("text/plain"))), m = this._htmlDataProcessor.toView(m), this.fire("inputTransformation", { content: m, dataTransfer: f }), n.scrollToTheSelection();
          }, { priority: "low" }), this.listenTo(this, "inputTransformation", (l, d) => {
            if (!d.content.isEmpty) {
              const f = this.editor.data, m = this.editor.model, g = f.toModel(d.content, "$clipboardHolder");
              if (g.childCount == 0)
                return;
              m.insertContent(g);
            }
          }, { priority: "low" }), this.listenTo(i, "copy", s, { priority: "low" }), this.listenTo(i, "cut", (l, d) => {
            e.isReadOnly ? d.preventDefault() : s(l, d);
          }, { priority: "low" }), this.listenTo(i, "clipboardOutput", (l, d) => {
            d.content.isEmpty || (d.dataTransfer.setData("text/html", this._htmlDataProcessor.toData(d.content)), d.dataTransfer.setData("text/plain", function f(m) {
              let g = "";
              if (m.is("text") || m.is("textProxy"))
                g = m.data;
              else if (m.is("img") && m.hasAttribute("alt"))
                g = m.getAttribute("alt");
              else {
                let b = null;
                for (const y of m.getChildren()) {
                  const C = f(y);
                  b && (b.is("containerElement") || y.is("containerElement")) && (ld.includes(b.name) || ld.includes(y.name) ? g += `
` : g += `

`), g += C, b = y;
                }
              }
              return g;
            }(d.content))), d.method == "cut" && e.model.deleteContent(t.selection);
          }, { priority: "low" });
        }
      }
      function* cd(o, e) {
        for (const t of e)
          t && o.getAttributeProperties(t[0]).copyOnEnter && (yield t);
      }
      class Yb extends Xe {
        execute() {
          const e = this.editor.model, t = e.document;
          e.change((n) => {
            (function(i, s, l, d) {
              const f = l.isCollapsed, m = l.getFirstRange(), g = m.start.parent, b = m.end.parent;
              if (d.isLimit(g) || d.isLimit(b))
                return void (f || g != b || i.deleteContent(l));
              if (f) {
                const y = cd(s.model.schema, l.getAttributes());
                ud(s, m.start), s.setSelectionAttribute(y);
              } else {
                const y = !(m.start.isAtStart && m.end.isAtEnd), C = g == b;
                i.deleteContent(l, { leaveUnmerged: y }), y && (C ? ud(s, l.focus) : s.setSelection(b, 0));
              }
            })(this.editor.model, n, t.selection, e.schema), this.fire("afterExecute", { writer: n });
          });
        }
      }
      function ud(o, e) {
        o.split(e), o.setSelection(e.parent.nextSibling, 0);
      }
      class dd extends si {
        constructor(e) {
          super(e);
          const t = this.document;
          t.on("keydown", (n, i) => {
            if (this.isEnabled && i.keyCode == tt.enter) {
              let s;
              t.once("enter", (l) => s = l, { priority: "highest" }), t.fire("enter", new js(t, i.domEvent, { isSoft: i.shiftKey })), s && s.stop.called && n.stop();
            }
          });
        }
        observe() {
        }
      }
      class qb extends Ae {
        static get pluginName() {
          return "Enter";
        }
        init() {
          const e = this.editor, t = e.editing.view, n = t.document;
          t.addObserver(dd), e.commands.add("enter", new Yb(e)), this.listenTo(n, "enter", (i, s) => {
            s.preventDefault(), s.isSoft || (e.execute("enter"), t.scrollToTheSelection());
          }, { priority: "low" });
        }
      }
      class Gb extends Xe {
        execute() {
          const e = this.editor.model, t = e.document;
          e.change((n) => {
            (function(i, s, l) {
              const d = l.isCollapsed, f = l.getFirstRange(), m = f.start.parent, g = f.end.parent, b = m == g;
              if (d) {
                const y = cd(i.schema, l.getAttributes());
                hd(s, f.end), s.removeSelectionAttribute(l.getAttributeKeys()), s.setSelectionAttribute(y);
              } else {
                const y = !(f.start.isAtStart && f.end.isAtEnd);
                i.deleteContent(l, { leaveUnmerged: y }), b ? hd(s, l.focus) : y && s.setSelection(g, 0);
              }
            })(e, n, t.selection), this.fire("afterExecute", { writer: n });
          });
        }
        refresh() {
          const e = this.editor.model, t = e.document;
          this.isEnabled = function(n, i) {
            if (i.rangeCount > 1)
              return !1;
            const s = i.anchor;
            if (!s || !n.checkChild(s, "softBreak"))
              return !1;
            const l = i.getFirstRange(), d = l.start.parent, f = l.end.parent;
            return !((ua(d, n) || ua(f, n)) && d !== f);
          }(e.schema, t.selection);
        }
      }
      function hd(o, e) {
        const t = o.createElement("softBreak");
        o.insert(t, e), o.setSelection(t, "after");
      }
      function ua(o, e) {
        return !o.is("rootElement") && (e.isLimit(o) || ua(o.parent, e));
      }
      class Zb extends Ae {
        static get pluginName() {
          return "ShiftEnter";
        }
        init() {
          const e = this.editor, t = e.model.schema, n = e.conversion, i = e.editing.view, s = i.document;
          t.register("softBreak", { allowWhere: "$text", isInline: !0 }), n.for("upcast").elementToElement({ model: "softBreak", view: "br" }), n.for("downcast").elementToElement({ model: "softBreak", view: (l, d) => d.createEmptyElement("br") }), i.addObserver(dd), e.commands.add("shiftEnter", new Gb(e)), this.listenTo(s, "enter", (l, d) => {
            d.preventDefault(), d.isSoft && (e.execute("shiftEnter"), i.scrollToTheSelection());
          }, { priority: "low" });
        }
      }
      class fd {
        constructor(e, t = 20) {
          this.model = e, this.size = 0, this.limit = t, this.isLocked = !1, this._changeCallback = (n, i) => {
            i.type != "transparent" && i !== this._batch && this._reset(!0);
          }, this._selectionChangeCallback = () => {
            this._reset();
          }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
        }
        get batch() {
          return this._batch || (this._batch = this.model.createBatch()), this._batch;
        }
        input(e) {
          this.size += e, this.size >= this.limit && this._reset(!0);
        }
        lock() {
          this.isLocked = !0;
        }
        unlock() {
          this.isLocked = !1;
        }
        destroy() {
          this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
        _reset(e) {
          this.isLocked && !e || (this._batch = null, this.size = 0);
        }
      }
      class Kb extends Xe {
        constructor(e, t) {
          super(e), this._buffer = new fd(e.model, t), this._batches = /* @__PURE__ */ new WeakSet();
        }
        get buffer() {
          return this._buffer;
        }
        destroy() {
          super.destroy(), this._buffer.destroy();
        }
        execute(e = {}) {
          const t = this.editor.model, n = t.document, i = e.text || "", s = i.length, l = e.range || n.selection.getFirstRange(), d = e.resultRange;
          t.enqueueChange(this._buffer.batch, (f) => {
            const m = l.isCollapsed;
            this._buffer.lock(), t.deleteContent(t.createSelection(l)), i && t.insertContent(f.createText(i, n.selection.getAttributes()), l.start), d ? f.setSelection(d) : m && f.setSelection(l.start.getShiftedBy(s)), this._buffer.unlock(), this._buffer.input(s), this._batches.add(this._buffer.batch);
          });
        }
      }
      function Xb(o) {
        let e = null;
        const t = o.model, n = o.editing.view, i = o.commands.get("input");
        function s(d) {
          const f = t.document, m = n.document.isComposing, g = e && e.isEqual(f.selection);
          e = null, i.isEnabled && (function(b) {
            return b.ctrlKey ? !0 : pd.includes(b.keyCode);
          }(d) || f.selection.isCollapsed || m && d.keyCode === 229 || !m && d.keyCode === 229 && g || l());
        }
        function l() {
          const d = i.buffer;
          d.lock(), t.enqueueChange(d.batch, () => {
            t.deleteContent(t.document.selection);
          }), d.unlock();
        }
        un.isAndroid ? n.document.on("beforeinput", (d, f) => s(f), { priority: "lowest" }) : n.document.on("keydown", (d, f) => s(f), { priority: "lowest" }), n.document.on("compositionstart", function() {
          const d = t.document, f = d.selection.rangeCount !== 1 || d.selection.getFirstRange().isFlat;
          d.selection.isCollapsed || f || l();
        }, { priority: "lowest" }), n.document.on("compositionend", () => {
          e = t.createSelection(t.document.selection);
        }, { priority: "lowest" });
      }
      const pd = [Yn("arrowUp"), Yn("arrowRight"), Yn("arrowDown"), Yn("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];
      for (let o = 112; o <= 135; o++)
        pd.push(o);
      function md(o) {
        if (o.newChildren.length - o.oldChildren.length != 1)
          return;
        const e = function(n, i) {
          const s = [];
          let l, d = 0;
          return n.forEach((g) => {
            g == "equal" ? (f(), d++) : g == "insert" ? (m("insert") ? l.values.push(i[d]) : (f(), l = { type: "insert", index: d, values: [i[d]] }), d++) : m("delete") ? l.howMany++ : (f(), l = { type: "delete", index: d, howMany: 1 });
          }), f(), s;
          function f() {
            l && (s.push(l), l = null);
          }
          function m(g) {
            return l && l.type == g;
          }
        }(oi(o.oldChildren, o.newChildren, Qb), o.newChildren);
        if (e.length > 1)
          return;
        const t = e[0];
        return t.values[0] && t.values[0].is("text") ? t : void 0;
      }
      function Qb(o, e) {
        return o && o.is("text") && e && e.is("text") ? o.data === e.data : o === e;
      }
      class Jb {
        constructor(e) {
          this.editor = e, this.editing = this.editor.editing;
        }
        handle(e, t) {
          if (function(n) {
            if (n.length == 0)
              return !1;
            for (const i of n)
              if (i.type === "children" && !md(i))
                return !0;
            return !1;
          }(e))
            this._handleContainerChildrenMutations(e, t);
          else
            for (const n of e)
              this._handleTextMutation(n, t), this._handleTextNodeInsertion(n);
        }
        _handleContainerChildrenMutations(e, t) {
          const n = function(pn) {
            const Fo = pn.map((hi) => hi.node).reduce((hi, qa) => hi.getCommonAncestor(qa, { includeSelf: !0 }));
            if (!!Fo)
              return Fo.getAncestors({ includeSelf: !0, parentFirst: !0 }).find((hi) => hi.is("containerElement") || hi.is("rootElement"));
          }(e);
          if (!n)
            return;
          const i = this.editor.editing.view.domConverter.mapViewToDom(n), s = new no(), l = this.editor.data.toModel(s.domToView(i)).getChild(0), d = this.editor.editing.mapper.toModelElement(n);
          if (!d)
            return;
          const f = Array.from(l.getChildren()), m = Array.from(d.getChildren()), g = f[f.length - 1], b = m[m.length - 1];
          g && g.is("softBreak") && b && !b.is("softBreak") && f.pop();
          const y = this.editor.model.schema;
          if (!gd(f, y) || !gd(m, y))
            return;
          const C = f.map((pn) => pn.is("text") ? pn.data : "@").join("").replace(/\u00A0/g, " "), O = m.map((pn) => pn.is("text") ? pn.data : "@").join("").replace(/\u00A0/g, " ");
          if (O === C)
            return;
          const D = oi(O, C), { firstChangeAt: oe, insertions: ce, deletions: _e } = vd(D);
          let De = null;
          t && (De = this.editing.mapper.toModelRange(t.getFirstRange()));
          const mt = C.substr(oe, ce), di = this.editor.model.createRange(this.editor.model.createPositionAt(d, oe), this.editor.model.createPositionAt(d, oe + _e));
          this.editor.execute("input", { text: mt, range: di, resultRange: De });
        }
        _handleTextMutation(e, t) {
          if (e.type != "text")
            return;
          const n = e.newText.replace(/\u00A0/g, " "), i = e.oldText.replace(/\u00A0/g, " ");
          if (i === n)
            return;
          const s = oi(i, n), { firstChangeAt: l, insertions: d, deletions: f } = vd(s);
          let m = null;
          t && (m = this.editing.mapper.toModelRange(t.getFirstRange()));
          const g = this.editing.view.createPositionAt(e.node, l), b = this.editing.mapper.toModelPosition(g), y = this.editor.model.createRange(b, b.getShiftedBy(f)), C = n.substr(l, d);
          this.editor.execute("input", { text: C, range: y, resultRange: m });
        }
        _handleTextNodeInsertion(e) {
          if (e.type != "children")
            return;
          const t = md(e), n = this.editing.view.createPositionAt(e.node, t.index), i = this.editing.mapper.toModelPosition(n), s = t.values[0].data;
          this.editor.execute("input", { text: s.replace(/\u00A0/g, " "), range: this.editor.model.createRange(i) });
        }
      }
      function gd(o, e) {
        return o.every((t) => e.isInline(t));
      }
      function vd(o) {
        let e = null, t = null;
        for (let s = 0; s < o.length; s++)
          o[s] != "equal" && (e = e === null ? s : e, t = s);
        let n = 0, i = 0;
        for (let s = e; s <= t; s++)
          o[s] != "insert" && n++, o[s] != "delete" && i++;
        return { insertions: i, deletions: n, firstChangeAt: e };
      }
      class e_ extends Ae {
        static get pluginName() {
          return "Input";
        }
        init() {
          const e = this.editor, t = new Kb(e, e.config.get("typing.undoStep") || 20);
          e.commands.add("input", t), Xb(e), function(n) {
            n.editing.view.document.on("mutations", (i, s, l) => {
              new Jb(n).handle(s, l);
            });
          }(e);
        }
        isInput(e) {
          return this.editor.commands.get("input")._batches.has(e);
        }
      }
      class bd extends Xe {
        constructor(e, t) {
          super(e), this.direction = t, this._buffer = new fd(e.model, e.config.get("typing.undoStep"));
        }
        get buffer() {
          return this._buffer;
        }
        execute(e = {}) {
          const t = this.editor.model, n = t.document;
          t.enqueueChange(this._buffer.batch, (i) => {
            this._buffer.lock();
            const s = i.createSelection(e.selection || n.selection), l = s.isCollapsed;
            if (s.isCollapsed && t.modifySelection(s, { direction: this.direction, unit: e.unit }), this._shouldEntireContentBeReplacedWithParagraph(e.sequence || 1))
              return void this._replaceEntireContentWithParagraph(i);
            if (s.isCollapsed)
              return;
            let d = 0;
            s.getFirstRange().getMinimalFlatRanges().forEach((f) => {
              d += Es(f.getWalker({ singleCharacters: !0, ignoreElementEnd: !0, shallow: !0 }));
            }), t.deleteContent(s, { doNotResetEntireContent: l }), this._buffer.input(d), i.setSelection(s), this._buffer.unlock();
          });
        }
        _shouldEntireContentBeReplacedWithParagraph(e) {
          if (e > 1)
            return !1;
          const t = this.editor.model, n = t.document.selection, i = t.schema.getLimitElement(n);
          if (!(n.isCollapsed && n.containsEntireContent(i)) || !t.schema.checkChild(i, "paragraph"))
            return !1;
          const s = i.getChild(0);
          return !s || s.name !== "paragraph";
        }
        _replaceEntireContentWithParagraph(e) {
          const t = this.editor.model, n = t.document.selection, i = t.schema.getLimitElement(n), s = e.createElement("paragraph");
          e.remove(e.createRangeIn(i)), e.insert(s, i), e.setSelection(s, 0);
        }
      }
      class t_ extends si {
        constructor(e) {
          super(e);
          const t = e.document;
          let n = 0;
          function i(s, l, d) {
            let f;
            t.once("delete", (m) => f = m, { priority: Number.POSITIVE_INFINITY }), t.fire("delete", new js(t, l, d)), f && f.stop.called && s.stop();
          }
          t.on("keyup", (s, l) => {
            l.keyCode != tt.delete && l.keyCode != tt.backspace || (n = 0);
          }), t.on("keydown", (s, l) => {
            const d = {};
            if (l.keyCode == tt.delete)
              d.direction = "forward", d.unit = "character";
            else {
              if (l.keyCode != tt.backspace)
                return;
              d.direction = "backward", d.unit = "codePoint";
            }
            const f = un.isMac ? l.altKey : l.ctrlKey;
            d.unit = f ? "word" : d.unit, d.sequence = ++n, i(s, l.domEvent, d);
          }), un.isAndroid && t.on("beforeinput", (s, l) => {
            if (l.domEvent.inputType != "deleteContentBackward")
              return;
            const d = { unit: "codepoint", direction: "backward", sequence: 1 }, f = l.domTarget.ownerDocument.defaultView.getSelection();
            f.anchorNode == f.focusNode && f.anchorOffset + 1 != f.focusOffset && (d.selectionToRemove = e.domConverter.domSelectionToView(f)), i(s, l.domEvent, d);
          });
        }
        observe() {
        }
      }
      class n_ extends Ae {
        static get pluginName() {
          return "Delete";
        }
        init() {
          const e = this.editor, t = e.editing.view, n = t.document;
          if (t.addObserver(t_), e.commands.add("forwardDelete", new bd(e, "forward")), e.commands.add("delete", new bd(e, "backward")), this.listenTo(n, "delete", (i, s) => {
            const l = { unit: s.unit, sequence: s.sequence };
            if (s.selectionToRemove) {
              const d = e.model.createSelection(), f = [];
              for (const m of s.selectionToRemove.getRanges())
                f.push(e.editing.mapper.toModelRange(m));
              d.setTo(f), l.selection = d;
            }
            e.execute(s.direction == "forward" ? "forwardDelete" : "delete", l), s.preventDefault(), t.scrollToTheSelection();
          }), un.isAndroid) {
            let i = null;
            this.listenTo(n, "delete", (s, l) => {
              const d = l.domTarget.ownerDocument.defaultView.getSelection();
              i = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset };
            }, { priority: "lowest" }), this.listenTo(n, "keyup", (s, l) => {
              if (i) {
                const d = l.domTarget.ownerDocument.defaultView.getSelection();
                d.collapse(i.anchorNode, i.anchorOffset), d.extend(i.focusNode, i.focusOffset), i = null;
              }
            });
          }
        }
      }
      class i_ extends Ae {
        static get requires() {
          return [e_, n_];
        }
        static get pluginName() {
          return "Typing";
        }
      }
      class Ut extends Dn {
        get type() {
          return "noop";
        }
        clone() {
          return new Ut(this.baseVersion);
        }
        getReversed() {
          return new Ut(this.baseVersion + 1);
        }
        _execute() {
        }
        static get className() {
          return "NoOperation";
        }
      }
      const da = /* @__PURE__ */ new Map();
      function Ze(o, e, t) {
        let n = da.get(o);
        n || (n = /* @__PURE__ */ new Map(), da.set(o, n)), n.set(e, t);
      }
      function r_(o) {
        return [o];
      }
      function _d(o, e, t = {}) {
        const n = function(i, s) {
          const l = da.get(i);
          return l && l.has(s) ? l.get(s) : r_;
        }(o.constructor, e.constructor);
        try {
          return n(o = o.clone(), e, t);
        } catch (i) {
          throw i;
        }
      }
      function o_(o, e, t) {
        o = o.slice(), e = e.slice();
        const n = new s_(t.document, t.useRelations, t.forceWeakRemove);
        n.setOriginalOperations(o), n.setOriginalOperations(e);
        const i = n.originalOperations;
        if (o.length == 0 || e.length == 0)
          return { operationsA: o, operationsB: e, originalOperations: i };
        const s = /* @__PURE__ */ new WeakMap();
        for (const f of o)
          s.set(f, 0);
        const l = { nextBaseVersionA: o[o.length - 1].baseVersion + 1, nextBaseVersionB: e[e.length - 1].baseVersion + 1, originalOperationsACount: o.length, originalOperationsBCount: e.length };
        let d = 0;
        for (; d < o.length; ) {
          const f = o[d], m = s.get(f);
          if (m == e.length) {
            d++;
            continue;
          }
          const g = e[m], b = _d(f, g, n.getContext(f, g, !0)), y = _d(g, f, n.getContext(g, f, !1));
          n.updateRelation(f, g), n.setOriginalOperations(b, f), n.setOriginalOperations(y, g);
          for (const C of b)
            s.set(C, m + y.length);
          o.splice(d, 1, ...b), e.splice(m, 1, ...y);
        }
        if (t.padWithNoOps) {
          const f = o.length - l.originalOperationsACount, m = e.length - l.originalOperationsBCount;
          yd(o, m - f), yd(e, f - m);
        }
        return wd(o, l.nextBaseVersionB), wd(e, l.nextBaseVersionA), { operationsA: o, operationsB: e, originalOperations: i };
      }
      class s_ {
        constructor(e, t, n = !1) {
          this.originalOperations = /* @__PURE__ */ new Map(), this._history = e.history, this._useRelations = t, this._forceWeakRemove = !!n, this._relations = /* @__PURE__ */ new Map();
        }
        setOriginalOperations(e, t = null) {
          const n = t ? this.originalOperations.get(t) : null;
          for (const i of e)
            this.originalOperations.set(i, n || i);
        }
        updateRelation(e, t) {
          switch (e.constructor) {
            case ot:
              switch (t.constructor) {
                case Nt:
                  e.targetPosition.isEqual(t.sourcePosition) || t.movedRange.containsPosition(e.targetPosition) ? this._setRelation(e, t, "insertAtSource") : e.targetPosition.isEqual(t.deletionPosition) ? this._setRelation(e, t, "insertBetween") : e.targetPosition.isAfter(t.sourcePosition) && this._setRelation(e, t, "moveTargetAfter");
                  break;
                case ot:
                  e.targetPosition.isEqual(t.sourcePosition) || e.targetPosition.isBefore(t.sourcePosition) ? this._setRelation(e, t, "insertBefore") : this._setRelation(e, t, "insertAfter");
              }
              break;
            case at:
              switch (t.constructor) {
                case Nt:
                  e.splitPosition.isBefore(t.sourcePosition) && this._setRelation(e, t, "splitBefore");
                  break;
                case ot:
                  (e.splitPosition.isEqual(t.sourcePosition) || e.splitPosition.isBefore(t.sourcePosition)) && this._setRelation(e, t, "splitBefore");
              }
              break;
            case Nt:
              switch (t.constructor) {
                case Nt:
                  e.targetPosition.isEqual(t.sourcePosition) || this._setRelation(e, t, "mergeTargetNotMoved"), e.sourcePosition.isEqual(t.targetPosition) && this._setRelation(e, t, "mergeSourceNotMoved"), e.sourcePosition.isEqual(t.sourcePosition) && this._setRelation(e, t, "mergeSameElement");
                  break;
                case at:
                  e.sourcePosition.isEqual(t.splitPosition) && this._setRelation(e, t, "splitAtSource");
              }
              break;
            case dn: {
              const n = e.newRange;
              if (!n)
                return;
              switch (t.constructor) {
                case ot: {
                  const i = ie._createFromPositionAndShift(t.sourcePosition, t.howMany), s = i.containsPosition(n.start) || i.start.isEqual(n.start), l = i.containsPosition(n.end) || i.end.isEqual(n.end);
                  !s && !l || i.containsRange(n) || this._setRelation(e, t, { side: s ? "left" : "right", path: s ? n.start.path.slice() : n.end.path.slice() });
                  break;
                }
                case Nt: {
                  const i = n.start.isEqual(t.targetPosition), s = n.start.isEqual(t.deletionPosition), l = n.end.isEqual(t.deletionPosition), d = n.end.isEqual(t.sourcePosition);
                  (i || s || l || d) && this._setRelation(e, t, { wasInLeftElement: i, wasStartBeforeMergedElement: s, wasEndBeforeMergedElement: l, wasInRightElement: d });
                  break;
                }
              }
              break;
            }
          }
        }
        getContext(e, t, n) {
          return { aIsStrong: n, aWasUndone: this._wasUndone(e), bWasUndone: this._wasUndone(t), abRelation: this._useRelations ? this._getRelation(e, t) : null, baRelation: this._useRelations ? this._getRelation(t, e) : null, forceWeakRemove: this._forceWeakRemove };
        }
        _wasUndone(e) {
          const t = this.originalOperations.get(e);
          return t.wasUndone || this._history.isUndoneOperation(t);
        }
        _getRelation(e, t) {
          const n = this.originalOperations.get(t), i = this._history.getUndoneOperation(n);
          if (!i)
            return null;
          const s = this.originalOperations.get(e), l = this._relations.get(s);
          return l && l.get(i) || null;
        }
        _setRelation(e, t, n) {
          const i = this.originalOperations.get(e), s = this.originalOperations.get(t);
          let l = this._relations.get(i);
          l || (l = /* @__PURE__ */ new Map(), this._relations.set(i, l)), l.set(s, n);
        }
      }
      function wd(o, e) {
        for (const t of o)
          t.baseVersion = e++;
      }
      function yd(o, e) {
        for (let t = 0; t < e; t++)
          o.push(new Ut(0));
      }
      function kd(o, e, t) {
        const n = o.nodes.getNode(0).getAttribute(e);
        if (n == t)
          return null;
        const i = new ie(o.position, o.position.getShiftedBy(o.howMany));
        return new Pt(i, e, n, t, 0);
      }
      function xd(o, e) {
        return o.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) === null;
      }
      function Hi(o, e) {
        const t = [];
        for (let n = 0; n < o.length; n++) {
          const i = o[n], s = new ot(i.start, i.end.offset - i.start.offset, e, 0);
          t.push(s);
          for (let l = n + 1; l < o.length; l++)
            o[l] = o[l]._getTransformedByMove(s.sourcePosition, s.targetPosition, s.howMany)[0];
          e = e._getTransformedByMove(s.sourcePosition, s.targetPosition, s.howMany);
        }
        return t;
      }
      Ze(Pt, Pt, (o, e, t) => {
        if (o.key === e.key) {
          const n = o.range.getDifference(e.range).map((s) => new Pt(s, o.key, o.oldValue, o.newValue, 0)), i = o.range.getIntersection(e.range);
          return i && t.aIsStrong && n.push(new Pt(i, e.key, e.newValue, o.newValue, 0)), n.length == 0 ? [new Ut(0)] : n;
        }
        return [o];
      }), Ze(Pt, Bt, (o, e) => {
        if (o.range.start.hasSameParentAs(e.position) && o.range.containsPosition(e.position)) {
          const t = o.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map((n) => new Pt(n, o.key, o.oldValue, o.newValue, o.baseVersion));
          if (e.shouldReceiveAttributes) {
            const n = kd(e, o.key, o.oldValue);
            n && t.unshift(n);
          }
          return t;
        }
        return o.range = o.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [o];
      }), Ze(Pt, Nt, (o, e) => {
        const t = [];
        o.range.start.hasSameParentAs(e.deletionPosition) && (o.range.containsPosition(e.deletionPosition) || o.range.start.isEqual(e.deletionPosition)) && t.push(ie._createFromPositionAndShift(e.graveyardPosition, 1));
        const n = o.range._getTransformedByMergeOperation(e);
        return n.isCollapsed || t.push(n), t.map((i) => new Pt(i, o.key, o.oldValue, o.newValue, o.baseVersion));
      }), Ze(Pt, ot, (o, e) => function(t, n) {
        const i = ie._createFromPositionAndShift(n.sourcePosition, n.howMany);
        let s = null, l = [];
        i.containsRange(t, !0) ? s = t : t.start.hasSameParentAs(i.start) ? (l = t.getDifference(i), s = t.getIntersection(i)) : l = [t];
        const d = [];
        for (let f of l) {
          f = f._getTransformedByDeletion(n.sourcePosition, n.howMany);
          const m = n.getMovedRangeStart(), g = f.start.hasSameParentAs(m);
          f = f._getTransformedByInsertion(m, n.howMany, g), d.push(...f);
        }
        return s && d.push(s._getTransformedByMove(n.sourcePosition, n.targetPosition, n.howMany, !1)[0]), d;
      }(o.range, e).map((t) => new Pt(t, o.key, o.oldValue, o.newValue, o.baseVersion))), Ze(Pt, at, (o, e) => {
        if (o.range.end.isEqual(e.insertionPosition))
          return e.graveyardPosition || o.range.end.offset++, [o];
        if (o.range.start.hasSameParentAs(e.splitPosition) && o.range.containsPosition(e.splitPosition)) {
          const t = o.clone();
          return t.range = new ie(e.moveTargetPosition.clone(), o.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), o.range.end = e.splitPosition.clone(), o.range.end.stickiness = "toPrevious", [o, t];
        }
        return o.range = o.range._getTransformedBySplitOperation(e), [o];
      }), Ze(Bt, Pt, (o, e) => {
        const t = [o];
        if (o.shouldReceiveAttributes && o.position.hasSameParentAs(e.range.start) && e.range.containsPosition(o.position)) {
          const n = kd(o, e.key, e.newValue);
          n && t.push(n);
        }
        return t;
      }), Ze(Bt, Bt, (o, e, t) => o.position.isEqual(e.position) && t.aIsStrong ? [o] : (o.position = o.position._getTransformedByInsertOperation(e), [o])), Ze(Bt, ot, (o, e) => (o.position = o.position._getTransformedByMoveOperation(e), [o])), Ze(Bt, at, (o, e) => (o.position = o.position._getTransformedBySplitOperation(e), [o])), Ze(Bt, Nt, (o, e) => (o.position = o.position._getTransformedByMergeOperation(e), [o])), Ze(dn, Bt, (o, e) => (o.oldRange && (o.oldRange = o.oldRange._getTransformedByInsertOperation(e)[0]), o.newRange && (o.newRange = o.newRange._getTransformedByInsertOperation(e)[0]), [o])), Ze(dn, dn, (o, e, t) => {
        if (o.name == e.name) {
          if (!t.aIsStrong)
            return [new Ut(0)];
          o.oldRange = e.newRange ? e.newRange.clone() : null;
        }
        return [o];
      }), Ze(dn, Nt, (o, e) => (o.oldRange && (o.oldRange = o.oldRange._getTransformedByMergeOperation(e)), o.newRange && (o.newRange = o.newRange._getTransformedByMergeOperation(e)), [o])), Ze(dn, ot, (o, e, t) => {
        if (o.oldRange && (o.oldRange = ie._createFromRanges(o.oldRange._getTransformedByMoveOperation(e))), o.newRange) {
          if (t.abRelation) {
            const n = ie._createFromRanges(o.newRange._getTransformedByMoveOperation(e));
            if (t.abRelation.side == "left" && e.targetPosition.isEqual(o.newRange.start))
              return o.newRange.start.path = t.abRelation.path, o.newRange.end = n.end, [o];
            if (t.abRelation.side == "right" && e.targetPosition.isEqual(o.newRange.end))
              return o.newRange.start = n.start, o.newRange.end.path = t.abRelation.path, [o];
          }
          o.newRange = ie._createFromRanges(o.newRange._getTransformedByMoveOperation(e));
        }
        return [o];
      }), Ze(dn, at, (o, e, t) => {
        if (o.oldRange && (o.oldRange = o.oldRange._getTransformedBySplitOperation(e)), o.newRange) {
          if (t.abRelation) {
            const n = o.newRange._getTransformedBySplitOperation(e);
            return o.newRange.start.isEqual(e.splitPosition) && t.abRelation.wasStartBeforeMergedElement ? o.newRange.start = le._createAt(e.insertionPosition) : o.newRange.start.isEqual(e.splitPosition) && !t.abRelation.wasInLeftElement && (o.newRange.start = le._createAt(e.moveTargetPosition)), o.newRange.end.isEqual(e.splitPosition) && t.abRelation.wasInRightElement ? o.newRange.end = le._createAt(e.moveTargetPosition) : o.newRange.end.isEqual(e.splitPosition) && t.abRelation.wasEndBeforeMergedElement ? o.newRange.end = le._createAt(e.insertionPosition) : o.newRange.end = n.end, [o];
          }
          o.newRange = o.newRange._getTransformedBySplitOperation(e);
        }
        return [o];
      }), Ze(Nt, Bt, (o, e) => (o.sourcePosition.hasSameParentAs(e.position) && (o.howMany += e.howMany), o.sourcePosition = o.sourcePosition._getTransformedByInsertOperation(e), o.targetPosition = o.targetPosition._getTransformedByInsertOperation(e), [o])), Ze(Nt, Nt, (o, e, t) => {
        if (o.sourcePosition.isEqual(e.sourcePosition) && o.targetPosition.isEqual(e.targetPosition)) {
          if (t.bWasUndone) {
            const n = e.graveyardPosition.path.slice();
            return n.push(0), o.sourcePosition = new le(e.graveyardPosition.root, n), o.howMany = 0, [o];
          }
          return [new Ut(0)];
        }
        if (o.sourcePosition.isEqual(e.sourcePosition) && !o.targetPosition.isEqual(e.targetPosition) && !t.bWasUndone && t.abRelation != "splitAtSource") {
          const n = o.targetPosition.root.rootName == "$graveyard", i = e.targetPosition.root.rootName == "$graveyard";
          if (i && !n || !(n && !i) && t.aIsStrong) {
            const s = e.targetPosition._getTransformedByMergeOperation(e), l = o.targetPosition._getTransformedByMergeOperation(e);
            return [new ot(s, o.howMany, l, 0)];
          }
          return [new Ut(0)];
        }
        return o.sourcePosition.hasSameParentAs(e.targetPosition) && (o.howMany += e.howMany), o.sourcePosition = o.sourcePosition._getTransformedByMergeOperation(e), o.targetPosition = o.targetPosition._getTransformedByMergeOperation(e), o.graveyardPosition.isEqual(e.graveyardPosition) && t.aIsStrong || (o.graveyardPosition = o.graveyardPosition._getTransformedByMergeOperation(e)), [o];
      }), Ze(Nt, ot, (o, e, t) => {
        const n = ie._createFromPositionAndShift(e.sourcePosition, e.howMany);
        return e.type == "remove" && !t.bWasUndone && !t.forceWeakRemove && o.deletionPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(o.sourcePosition) ? [new Ut(0)] : (o.sourcePosition.hasSameParentAs(e.targetPosition) && (o.howMany += e.howMany), o.sourcePosition.hasSameParentAs(e.sourcePosition) && (o.howMany -= e.howMany), o.sourcePosition = o.sourcePosition._getTransformedByMoveOperation(e), o.targetPosition = o.targetPosition._getTransformedByMoveOperation(e), o.graveyardPosition.isEqual(e.targetPosition) || (o.graveyardPosition = o.graveyardPosition._getTransformedByMoveOperation(e)), [o]);
      }), Ze(Nt, at, (o, e, t) => {
        if (e.graveyardPosition && (o.graveyardPosition = o.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), o.deletionPosition.isEqual(e.graveyardPosition) && (o.howMany = e.howMany)), o.targetPosition.isEqual(e.splitPosition)) {
          const n = e.howMany != 0, i = e.graveyardPosition && o.deletionPosition.isEqual(e.graveyardPosition);
          if (n || i || t.abRelation == "mergeTargetNotMoved")
            return o.sourcePosition = o.sourcePosition._getTransformedBySplitOperation(e), [o];
        }
        if (o.sourcePosition.isEqual(e.splitPosition)) {
          if (t.abRelation == "mergeSourceNotMoved")
            return o.howMany = 0, o.targetPosition = o.targetPosition._getTransformedBySplitOperation(e), [o];
          if (t.abRelation == "mergeSameElement" || o.sourcePosition.offset > 0)
            return o.sourcePosition = e.moveTargetPosition.clone(), o.targetPosition = o.targetPosition._getTransformedBySplitOperation(e), [o];
        }
        return o.sourcePosition.hasSameParentAs(e.splitPosition) && (o.howMany = e.splitPosition.offset), o.sourcePosition = o.sourcePosition._getTransformedBySplitOperation(e), o.targetPosition = o.targetPosition._getTransformedBySplitOperation(e), [o];
      }), Ze(ot, Bt, (o, e) => {
        const t = ie._createFromPositionAndShift(o.sourcePosition, o.howMany)._getTransformedByInsertOperation(e, !1)[0];
        return o.sourcePosition = t.start, o.howMany = t.end.offset - t.start.offset, o.targetPosition.isEqual(e.position) || (o.targetPosition = o.targetPosition._getTransformedByInsertOperation(e)), [o];
      }), Ze(ot, ot, (o, e, t) => {
        const n = ie._createFromPositionAndShift(o.sourcePosition, o.howMany), i = ie._createFromPositionAndShift(e.sourcePosition, e.howMany);
        let s, l = t.aIsStrong, d = !t.aIsStrong;
        if (t.abRelation == "insertBefore" || t.baRelation == "insertAfter" ? d = !0 : t.abRelation != "insertAfter" && t.baRelation != "insertBefore" || (d = !1), s = o.targetPosition.isEqual(e.targetPosition) && d ? o.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : o.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), xd(o, e) && xd(e, o))
          return [e.getReversed()];
        if (n.containsPosition(e.targetPosition) && n.containsRange(i, !0))
          return n.start = n.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), n.end = n.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Hi([n], s);
        if (i.containsPosition(o.targetPosition) && i.containsRange(n, !0))
          return n.start = n.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), n.end = n.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), Hi([n], s);
        const f = Kt(o.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
        if (f == "prefix" || f == "extension")
          return n.start = n.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), n.end = n.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Hi([n], s);
        o.type != "remove" || e.type == "remove" || t.aWasUndone || t.forceWeakRemove ? o.type == "remove" || e.type != "remove" || t.bWasUndone || t.forceWeakRemove || (l = !1) : l = !0;
        const m = [], g = n.getDifference(i);
        for (const y of g) {
          y.start = y.start._getTransformedByDeletion(e.sourcePosition, e.howMany), y.end = y.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
          const C = Kt(y.start.getParentPath(), e.getMovedRangeStart().getParentPath()) == "same", O = y._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, C);
          m.push(...O);
        }
        const b = n.getIntersection(i);
        return b !== null && l && (b.start = b.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), b.end = b.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), m.length === 0 ? m.push(b) : m.length == 1 ? i.start.isBefore(n.start) || i.start.isEqual(n.start) ? m.unshift(b) : m.push(b) : m.splice(1, 0, b)), m.length === 0 ? [new Ut(o.baseVersion)] : Hi(m, s);
      }), Ze(ot, at, (o, e, t) => {
        let n = o.targetPosition.clone();
        o.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && t.abRelation != "moveTargetAfter" || (n = o.targetPosition._getTransformedBySplitOperation(e));
        const i = ie._createFromPositionAndShift(o.sourcePosition, o.howMany);
        if (i.end.isEqual(e.insertionPosition))
          return e.graveyardPosition || o.howMany++, o.targetPosition = n, [o];
        if (i.start.hasSameParentAs(e.splitPosition) && i.containsPosition(e.splitPosition)) {
          let l = new ie(e.splitPosition, i.end);
          return l = l._getTransformedBySplitOperation(e), Hi([new ie(i.start, e.splitPosition), l], n);
        }
        o.targetPosition.isEqual(e.splitPosition) && t.abRelation == "insertAtSource" && (n = e.moveTargetPosition), o.targetPosition.isEqual(e.insertionPosition) && t.abRelation == "insertBetween" && (n = o.targetPosition);
        const s = [i._getTransformedBySplitOperation(e)];
        if (e.graveyardPosition) {
          const l = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
          o.howMany > 1 && l && !t.aWasUndone && s.push(ie._createFromPositionAndShift(e.insertionPosition, 1));
        }
        return Hi(s, n);
      }), Ze(ot, Nt, (o, e, t) => {
        const n = ie._createFromPositionAndShift(o.sourcePosition, o.howMany);
        if (e.deletionPosition.hasSameParentAs(o.sourcePosition) && n.containsPosition(e.sourcePosition)) {
          if (o.type != "remove" || t.forceWeakRemove) {
            if (o.howMany == 1)
              return t.bWasUndone ? (o.sourcePosition = e.graveyardPosition.clone(), o.targetPosition = o.targetPosition._getTransformedByMergeOperation(e), [o]) : [new Ut(0)];
          } else if (!t.aWasUndone) {
            const s = [];
            let l = e.graveyardPosition.clone(), d = e.targetPosition._getTransformedByMergeOperation(e);
            o.howMany > 1 && (s.push(new ot(o.sourcePosition, o.howMany - 1, o.targetPosition, 0)), l = l._getTransformedByMove(o.sourcePosition, o.targetPosition, o.howMany - 1), d = d._getTransformedByMove(o.sourcePosition, o.targetPosition, o.howMany - 1));
            const f = e.deletionPosition._getCombined(o.sourcePosition, o.targetPosition), m = new ot(l, 1, f, 0), g = m.getMovedRangeStart().path.slice();
            g.push(0);
            const b = new le(m.targetPosition.root, g);
            d = d._getTransformedByMove(l, f, 1);
            const y = new ot(d, e.howMany, b, 0);
            return s.push(m), s.push(y), s;
          }
        }
        const i = ie._createFromPositionAndShift(o.sourcePosition, o.howMany)._getTransformedByMergeOperation(e);
        return o.sourcePosition = i.start, o.howMany = i.end.offset - i.start.offset, o.targetPosition = o.targetPosition._getTransformedByMergeOperation(e), [o];
      }), Ze(hn, Bt, (o, e) => (o.position = o.position._getTransformedByInsertOperation(e), [o])), Ze(hn, Nt, (o, e) => o.position.isEqual(e.deletionPosition) ? (o.position = e.graveyardPosition.clone(), o.position.stickiness = "toNext", [o]) : (o.position = o.position._getTransformedByMergeOperation(e), [o])), Ze(hn, ot, (o, e) => (o.position = o.position._getTransformedByMoveOperation(e), [o])), Ze(hn, hn, (o, e, t) => {
        if (o.position.isEqual(e.position)) {
          if (!t.aIsStrong)
            return [new Ut(0)];
          o.oldName = e.newName;
        }
        return [o];
      }), Ze(hn, at, (o, e) => Kt(o.position.path, e.splitPosition.getParentPath()) == "same" && !e.graveyardPosition ? [o, new hn(o.position.getShiftedBy(1), o.oldName, o.newName, 0)] : (o.position = o.position._getTransformedBySplitOperation(e), [o])), Ze(Ti, Ti, (o, e, t) => {
        if (o.root === e.root && o.key === e.key) {
          if (!t.aIsStrong || o.newValue === e.newValue)
            return [new Ut(0)];
          o.oldValue = e.newValue;
        }
        return [o];
      }), Ze(at, Bt, (o, e) => (o.splitPosition.hasSameParentAs(e.position) && o.splitPosition.offset < e.position.offset && (o.howMany += e.howMany), o.splitPosition = o.splitPosition._getTransformedByInsertOperation(e), o.insertionPosition = at.getInsertionPosition(o.splitPosition), [o])), Ze(at, Nt, (o, e, t) => {
        if (!o.graveyardPosition && !t.bWasUndone && o.splitPosition.hasSameParentAs(e.sourcePosition)) {
          const n = e.graveyardPosition.path.slice();
          n.push(0);
          const i = new le(e.graveyardPosition.root, n), s = at.getInsertionPosition(new le(e.graveyardPosition.root, n)), l = new at(i, 0, null, 0);
          return l.insertionPosition = s, o.splitPosition = o.splitPosition._getTransformedByMergeOperation(e), o.insertionPosition = at.getInsertionPosition(o.splitPosition), o.graveyardPosition = l.insertionPosition.clone(), o.graveyardPosition.stickiness = "toNext", [l, o];
        }
        return o.splitPosition.hasSameParentAs(e.deletionPosition) && !o.splitPosition.isAfter(e.deletionPosition) && o.howMany--, o.splitPosition.hasSameParentAs(e.targetPosition) && (o.howMany += e.howMany), o.splitPosition = o.splitPosition._getTransformedByMergeOperation(e), o.insertionPosition = at.getInsertionPosition(o.splitPosition), o.graveyardPosition && (o.graveyardPosition = o.graveyardPosition._getTransformedByMergeOperation(e)), [o];
      }), Ze(at, ot, (o, e, t) => {
        const n = ie._createFromPositionAndShift(e.sourcePosition, e.howMany);
        if (o.graveyardPosition) {
          const i = n.start.isEqual(o.graveyardPosition) || n.containsPosition(o.graveyardPosition);
          if (!t.bWasUndone && i) {
            const s = o.splitPosition._getTransformedByMoveOperation(e), l = o.graveyardPosition._getTransformedByMoveOperation(e), d = l.path.slice();
            d.push(0);
            const f = new le(l.root, d);
            return [new ot(s, o.howMany, f, 0)];
          }
          o.graveyardPosition = o.graveyardPosition._getTransformedByMoveOperation(e);
        }
        if (o.splitPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(o.splitPosition)) {
          const i = e.howMany - (o.splitPosition.offset - e.sourcePosition.offset);
          return o.howMany -= i, o.splitPosition.hasSameParentAs(e.targetPosition) && o.splitPosition.offset < e.targetPosition.offset && (o.howMany += e.howMany), o.splitPosition = e.sourcePosition.clone(), o.insertionPosition = at.getInsertionPosition(o.splitPosition), [o];
        }
        return !o.splitPosition.isEqual(e.targetPosition) || t.baRelation != "insertAtSource" && t.abRelation != "splitBefore" ? (e.sourcePosition.isEqual(e.targetPosition) || (o.splitPosition.hasSameParentAs(e.sourcePosition) && o.splitPosition.offset <= e.sourcePosition.offset && (o.howMany -= e.howMany), o.splitPosition.hasSameParentAs(e.targetPosition) && o.splitPosition.offset < e.targetPosition.offset && (o.howMany += e.howMany)), o.splitPosition.stickiness = "toNone", o.splitPosition = o.splitPosition._getTransformedByMoveOperation(e), o.splitPosition.stickiness = "toNext", o.graveyardPosition ? o.insertionPosition = o.insertionPosition._getTransformedByMoveOperation(e) : o.insertionPosition = at.getInsertionPosition(o.splitPosition), [o]) : (o.howMany += e.howMany, o.splitPosition = o.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), o.insertionPosition = at.getInsertionPosition(o.splitPosition), [o]);
      }), Ze(at, at, (o, e, t) => {
        if (o.splitPosition.isEqual(e.splitPosition)) {
          if (!o.graveyardPosition && !e.graveyardPosition)
            return [new Ut(0)];
          if (o.graveyardPosition && e.graveyardPosition && o.graveyardPosition.isEqual(e.graveyardPosition))
            return [new Ut(0)];
          if (t.abRelation == "splitBefore")
            return o.howMany = 0, o.graveyardPosition = o.graveyardPosition._getTransformedBySplitOperation(e), [o];
        }
        if (o.graveyardPosition && e.graveyardPosition && o.graveyardPosition.isEqual(e.graveyardPosition)) {
          const n = o.splitPosition.root.rootName == "$graveyard", i = e.splitPosition.root.rootName == "$graveyard";
          if (i && !n || !(n && !i) && t.aIsStrong) {
            const s = [];
            return e.howMany && s.push(new ot(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), o.howMany && s.push(new ot(o.splitPosition, o.howMany, o.moveTargetPosition, 0)), s;
          }
          return [new Ut(0)];
        }
        if (o.graveyardPosition && (o.graveyardPosition = o.graveyardPosition._getTransformedBySplitOperation(e)), o.splitPosition.isEqual(e.insertionPosition) && t.abRelation == "splitBefore")
          return o.howMany++, [o];
        if (e.splitPosition.isEqual(o.insertionPosition) && t.baRelation == "splitBefore") {
          const n = e.insertionPosition.path.slice();
          n.push(0);
          const i = new le(e.insertionPosition.root, n);
          return [o, new ot(o.insertionPosition, 1, i, 0)];
        }
        return o.splitPosition.hasSameParentAs(e.splitPosition) && o.splitPosition.offset < e.splitPosition.offset && (o.howMany -= e.howMany), o.splitPosition = o.splitPosition._getTransformedBySplitOperation(e), o.insertionPosition = at.getInsertionPosition(o.splitPosition), [o];
      });
      class Sd extends Xe {
        constructor(e) {
          super(e), this._stack = [], this._createdBatches = /* @__PURE__ */ new WeakSet(), this.refresh();
        }
        refresh() {
          this.isEnabled = this._stack.length > 0;
        }
        addBatch(e) {
          const t = this.editor.model.document.selection, n = { ranges: t.hasOwnRange ? Array.from(t.getRanges()) : [], isBackward: t.isBackward };
          this._stack.push({ batch: e, selection: n }), this.refresh();
        }
        clearStack() {
          this._stack = [], this.refresh();
        }
        _restoreSelection(e, t, n) {
          const i = this.editor.model, s = i.document, l = [];
          for (const d of e) {
            const f = a_(d, n).find((m) => m.start.root != s.graveyard);
            f && l.push(f);
          }
          l.length && i.change((d) => {
            d.setSelection(l, { backward: t });
          });
        }
        _undo(e, t) {
          const n = this.editor.model, i = n.document;
          this._createdBatches.add(t);
          const s = e.operations.slice().filter((l) => l.isDocumentOperation);
          s.reverse();
          for (const l of s) {
            const d = l.baseVersion + 1, f = Array.from(i.history.getOperations(d)), m = o_([l.getReversed()], f, { useRelations: !0, document: this.editor.model.document, padWithNoOps: !1, forceWeakRemove: !0 }).operationsA;
            for (const g of m)
              t.addOperation(g), n.applyOperation(g), i.history.setOperationAsUndone(l, g);
          }
        }
      }
      function a_(o, e) {
        const t = o.getTransformedByOperations(e);
        t.sort((n, i) => n.start.isBefore(i.start) ? -1 : 1);
        for (let n = 1; n < t.length; n++) {
          const i = t[n - 1], s = t[n];
          i.end.isTouching(s.start) && (i.end = s.end, t.splice(n, 1), n--);
        }
        return t;
      }
      class l_ extends Sd {
        execute(e = null) {
          const t = e ? this._stack.findIndex((s) => s.batch == e) : this._stack.length - 1, n = this._stack.splice(t, 1)[0], i = this.editor.model.createBatch("transparent");
          this.editor.model.enqueueChange(i, () => {
            this._undo(n.batch, i);
            const s = this.editor.model.document.history.getOperations(n.batch.baseVersion);
            this._restoreSelection(n.selection.ranges, n.selection.isBackward, s), this.fire("revert", n.batch, i);
          }), this.refresh();
        }
      }
      class c_ extends Sd {
        execute() {
          const e = this._stack.pop(), t = this.editor.model.createBatch("transparent");
          this.editor.model.enqueueChange(t, () => {
            const n = e.batch.operations[e.batch.operations.length - 1].baseVersion + 1, i = this.editor.model.document.history.getOperations(n);
            this._restoreSelection(e.selection.ranges, e.selection.isBackward, i), this._undo(e.batch, t);
          }), this.refresh();
        }
      }
      class u_ extends Ae {
        constructor(e) {
          super(e), this._batchRegistry = /* @__PURE__ */ new WeakSet();
        }
        init() {
          const e = this.editor;
          this._undoCommand = new l_(e), this._redoCommand = new c_(e), e.commands.add("undo", this._undoCommand), e.commands.add("redo", this._redoCommand), this.listenTo(e.model, "applyOperation", (t, n) => {
            const i = n[0];
            if (!i.isDocumentOperation)
              return;
            const s = i.batch, l = this._redoCommand._createdBatches.has(s), d = this._undoCommand._createdBatches.has(s);
            this._batchRegistry.has(s) || s.type == "transparent" && !l && !d || (l ? this._undoCommand.addBatch(s) : d || (this._undoCommand.addBatch(s), this._redoCommand.clearStack()), this._batchRegistry.add(s));
          }, { priority: "highest" }), this.listenTo(this._undoCommand, "revert", (t, n, i) => {
            this._redoCommand.addBatch(i);
          }), e.keystrokes.set("CTRL+Z", "undo"), e.keystrokes.set("CTRL+Y", "redo"), e.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }
      var Cd = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>', Ad = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
      class d_ extends Ae {
        init() {
          const e = this.editor, t = e.locale, n = e.t, i = t.uiLanguageDirection == "ltr" ? Cd : Ad, s = t.uiLanguageDirection == "ltr" ? Ad : Cd;
          this._addButton("undo", n("bt"), "CTRL+Z", i), this._addButton("redo", n("bu"), "CTRL+Y", s);
        }
        _addButton(e, t, n, i) {
          const s = this.editor;
          s.ui.componentFactory.add(e, (l) => {
            const d = s.commands.get(e), f = new kt(l);
            return f.set({ label: t, icon: i, keystroke: n, tooltip: !0 }), f.bind("isEnabled").to(d, "isEnabled"), this.listenTo(f, "execute", () => s.execute(e)), f;
          });
        }
      }
      class Td extends Ae {
        static get requires() {
          return [u_, d_];
        }
        static get pluginName() {
          return "Undo";
        }
      }
      class Id extends Ae {
        static get pluginName() {
          return "PendingActions";
        }
        init() {
          this.set("hasAny", !1), this._actions = new _n({ idProperty: "_id" }), this._actions.delegate("add", "remove").to(this);
        }
        add(e) {
          if (typeof e != "string")
            throw new V.b("pendingactions-add-invalid-message: The message must be a string.", this);
          const t = Object.create(xt);
          return t.set("message", e), this._actions.add(t), this.hasAny = !0, t;
        }
        remove(e) {
          this._actions.remove(e), this.hasAny = !!this._actions.length;
        }
        get first() {
          return this._actions.get(0);
        }
        [Symbol.iterator]() {
          return this._actions[Symbol.iterator]();
        }
      }
      class Ed {
        constructor() {
          const e = new window.FileReader();
          this._reader = e, this._data = void 0, this.set("loaded", 0), e.onprogress = (t) => {
            this.loaded = t.loaded;
          };
        }
        get error() {
          return this._reader.error;
        }
        get data() {
          return this._data;
        }
        read(e) {
          const t = this._reader;
          return this.total = e.size, new Promise((n, i) => {
            t.onload = () => {
              const s = t.result;
              this._data = s, n(s);
            }, t.onerror = () => {
              i("error");
            }, t.onabort = () => {
              i("aborted");
            }, this._reader.readAsDataURL(e);
          });
        }
        abort() {
          this._reader.abort();
        }
      }
      $e(Ed, xt);
      class Ln extends Ae {
        static get pluginName() {
          return "FileRepository";
        }
        static get requires() {
          return [Id];
        }
        init() {
          this.loaders = new _n(), this.loaders.on("add", () => this._updatePendingAction()), this.loaders.on("remove", () => this._updatePendingAction()), this._loadersMap = /* @__PURE__ */ new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (e, t) => t ? e / t * 100 : 0);
        }
        getLoader(e) {
          return this._loadersMap.get(e) || null;
        }
        createLoader(e) {
          if (!this.createUploadAdapter)
            return console.warn(Object(V.a)("filerepository-no-upload-adapter: Upload adapter is not defined.")), null;
          const t = new ha(Promise.resolve(e), this.createUploadAdapter);
          return this.loaders.add(t), this._loadersMap.set(e, t), e instanceof Promise && t.file.then((n) => {
            this._loadersMap.set(n, t);
          }), t.file.catch(() => {
          }), t.on("change:uploaded", () => {
            let n = 0;
            for (const i of this.loaders)
              n += i.uploaded;
            this.uploaded = n;
          }), t.on("change:uploadTotal", () => {
            let n = 0;
            for (const i of this.loaders)
              i.uploadTotal && (n += i.uploadTotal);
            this.uploadTotal = n;
          }), t;
        }
        destroyLoader(e) {
          const t = e instanceof ha ? e : this.getLoader(e);
          t._destroy(), this.loaders.remove(t), this._loadersMap.forEach((n, i) => {
            n === t && this._loadersMap.delete(i);
          });
        }
        _updatePendingAction() {
          const e = this.editor.plugins.get(Id);
          if (this.loaders.length) {
            if (!this._pendingAction) {
              const t = this.editor.t, n = (i) => `${t("ay")} ${parseInt(i)}%.`;
              this._pendingAction = e.add(n(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", n);
            }
          } else
            e.remove(this._pendingAction), this._pendingAction = null;
        }
      }
      $e(Ln, xt);
      class ha {
        constructor(e, t) {
          this.id = Vn(), this._filePromiseWrapper = this._createFilePromiseWrapper(e), this._adapter = t(this), this._reader = new Ed(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (n, i) => i ? n / i * 100 : 0), this.set("uploadResponse", null);
        }
        get file() {
          return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then((e) => this._filePromiseWrapper ? e : null) : Promise.resolve(null);
        }
        get data() {
          return this._reader.data;
        }
        read() {
          if (this.status != "idle")
            throw new V.b("filerepository-read-wrong-status: You cannot call read if the status is different than idle.", this);
          return this.status = "reading", this._filePromiseWrapper.promise.then((e) => this._reader.read(e)).then((e) => (this.status = "idle", e)).catch((e) => {
            throw e === "aborted" ? (this.status = "aborted", "aborted") : (this.status = "error", this._reader.error ? this._reader.error : e);
          });
        }
        upload() {
          if (this.status != "idle")
            throw new V.b("filerepository-upload-wrong-status: You cannot call upload if the status is different than idle.", this);
          return this.status = "uploading", this._filePromiseWrapper.promise.then(() => this._adapter.upload()).then((e) => (this.uploadResponse = e, this.status = "idle", e)).catch((e) => {
            throw this.status === "aborted" ? "aborted" : (this.status = "error", e);
          });
        }
        abort() {
          const e = this.status;
          this.status = "aborted", this._filePromiseWrapper.isFulfilled ? e == "reading" ? this._reader.abort() : e == "uploading" && this._adapter.abort && this._adapter.abort() : this._filePromiseWrapper.rejecter("aborted"), this._destroy();
        }
        _destroy() {
          this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
        }
        _createFilePromiseWrapper(e) {
          const t = {};
          return t.promise = new Promise((n, i) => {
            t.resolver = n, t.rejecter = i, t.isFulfilled = !1, e.then((s) => {
              t.isFulfilled = !0, n(s);
            }).catch((s) => {
              t.isFulfilled = !0, i(s);
            });
          }), t;
        }
      }
      $e(ha, xt);
      const Pd = "ckCsrfToken", Md = 40, Od = "abcdefghijklmnopqrstuvwxyz0123456789";
      function h_() {
        let o = function(e) {
          e = e.toLowerCase();
          const t = document.cookie.split(";");
          for (const n of t) {
            const i = n.split("=");
            if (decodeURIComponent(i[0].trim().toLowerCase()) === e)
              return decodeURIComponent(i[1]);
          }
          return null;
        }(Pd);
        return o && o.length == Md || (o = function(e) {
          let t = "";
          const n = new Uint8Array(e);
          window.crypto.getRandomValues(n);
          for (let i = 0; i < n.length; i++) {
            const s = Od.charAt(n[i] % Od.length);
            t += Math.random() > 0.5 ? s.toUpperCase() : s;
          }
          return t;
        }(Md), function(e, t) {
          document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + ";path=/";
        }(Pd, o)), o;
      }
      class Dd extends Ae {
        static get requires() {
          return [Ln];
        }
        static get pluginName() {
          return "CKFinderUploadAdapter";
        }
        init() {
          const e = this.editor.config.get("ckfinder.uploadUrl");
          e && (this.editor.plugins.get(Ln).createUploadAdapter = (t) => new f_(t, e, this.editor.t));
        }
      }
      class f_ {
        constructor(e, t, n) {
          this.loader = e, this.url = t, this.t = n;
        }
        upload() {
          return this.loader.file.then((e) => new Promise((t, n) => {
            this._initRequest(), this._initListeners(t, n, e), this._sendRequest(e);
          }));
        }
        abort() {
          this.xhr && this.xhr.abort();
        }
        _initRequest() {
          const e = this.xhr = new XMLHttpRequest();
          e.open("POST", this.url, !0), e.responseType = "json";
        }
        _initListeners(e, t, n) {
          const i = this.xhr, s = this.loader, l = (0, this.t)("a") + ` ${n.name}.`;
          i.addEventListener("error", () => t(l)), i.addEventListener("abort", () => t()), i.addEventListener("load", () => {
            const d = i.response;
            if (!d || !d.uploaded)
              return t(d && d.error && d.error.message ? d.error.message : l);
            e({ default: d.url });
          }), i.upload && i.upload.addEventListener("progress", (d) => {
            d.lengthComputable && (s.uploadTotal = d.total, s.uploaded = d.loaded);
          });
        }
        _sendRequest(e) {
          const t = new FormData();
          t.append("upload", e), t.append("ckCsrfToken", h_()), this.xhr.send(t);
        }
      }
      class _o {
        constructor(e, t, n) {
          let i, s = null;
          typeof n == "function" ? i = n : (s = e.commands.get(n), i = () => {
            e.execute(n);
          }), e.model.document.on("change", (l, d) => {
            if (s && !s.isEnabled || d.type == "transparent")
              return;
            const f = Array.from(e.model.document.differ.getChanges()), m = f[0];
            if (f.length != 1 || m.type !== "insert" || m.name != "$text" || m.length != 1)
              return;
            const g = m.position.textNode || m.position.nodeAfter;
            if (!g.parent.is("paragraph"))
              return;
            const b = t.exec(g.data);
            b && e.model.enqueueChange((y) => {
              const C = y.createPositionAt(g.parent, 0), O = y.createPositionAt(g.parent, b[0].length), D = new ai(C, O);
              i({ match: b }) !== !1 && y.remove(D), D.detach();
            });
          });
        }
      }
      class yr {
        constructor(e, t, n) {
          let i, s, l, d;
          t instanceof RegExp ? i = t : l = t, typeof n == "string" ? s = n : d = n, l = l || ((f) => {
            let m;
            const g = [], b = [];
            for (; (m = i.exec(f)) !== null && !(m && m.length < 4); ) {
              let { index: y, 1: C, 2: O, 3: D } = m;
              const oe = C + O + D, ce = [y += m[0].length - oe.length, y + C.length], _e = [y + C.length + O.length, y + C.length + O.length + D.length];
              g.push(ce), g.push(_e), b.push([y + C.length, y + C.length + O.length]);
            }
            return { remove: g, format: b };
          }), d = d || ((f, m) => {
            const g = e.model.schema.getValidRanges(m, s);
            for (const b of g)
              f.setAttribute(s, !0, b);
            f.removeSelectionAttribute(s);
          }), e.model.document.on("change", (f, m) => {
            if (m.type == "transparent")
              return;
            const g = e.model.document.selection;
            if (!g.isCollapsed)
              return;
            const b = Array.from(e.model.document.differ.getChanges()), y = b[0];
            if (b.length != 1 || y.type !== "insert" || y.name != "$text" || y.length != 1)
              return;
            const C = g.focus.parent, O = function(_e) {
              return Array.from(_e.getChildren()).reduce((De, mt) => De + mt.data, "");
            }(C).slice(0, g.focus.offset), D = l(O), oe = Nd(C, D.format, e.model), ce = Nd(C, D.remove, e.model);
            oe.length && ce.length && e.model.enqueueChange((_e) => {
              if (d(_e, oe) !== !1)
                for (const De of ce.reverse())
                  _e.remove(De);
            });
          });
        }
      }
      function Nd(o, e, t) {
        return e.filter((n) => n[0] !== void 0 && n[1] !== void 0).map((n) => t.createRange(t.createPositionAt(o, n[0]), t.createPositionAt(o, n[1])));
      }
      function fa(o, e) {
        return (t, n) => {
          if (!o.commands.get(e).isEnabled)
            return !1;
          const i = o.model.schema.getValidRanges(n, e);
          for (const s of i)
            t.setAttribute(e, !0, s);
          t.removeSelectionAttribute(e);
        };
      }
      class Rd extends Xe {
        constructor(e, t) {
          super(e), this.attributeKey = t;
        }
        refresh() {
          const e = this.editor.model, t = e.document;
          this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = e.schema.checkAttributeInSelection(t.selection, this.attributeKey);
        }
        execute(e = {}) {
          const t = this.editor.model, n = t.document.selection, i = e.forceValue === void 0 ? !this.value : e.forceValue;
          t.change((s) => {
            if (n.isCollapsed)
              i ? s.setSelectionAttribute(this.attributeKey, !0) : s.removeSelectionAttribute(this.attributeKey);
            else {
              const l = t.schema.getValidRanges(n.getRanges(), this.attributeKey);
              for (const d of l)
                i ? s.setAttribute(this.attributeKey, i, d) : s.removeAttribute(this.attributeKey, d);
            }
          });
        }
        _getValueFromFirstAllowedNode() {
          const e = this.editor.model, t = e.schema, n = e.document.selection;
          if (n.isCollapsed)
            return n.hasAttribute(this.attributeKey);
          for (const i of n.getRanges())
            for (const s of i.getItems())
              if (t.checkAttribute(s, this.attributeKey))
                return s.hasAttribute(this.attributeKey);
          return !1;
        }
      }
      const Wi = "bold";
      class p_ extends Ae {
        init() {
          const e = this.editor;
          e.model.schema.extend("$text", { allowAttributes: Wi }), e.model.schema.setAttributeProperties(Wi, { isFormatting: !0, copyOnEnter: !0 }), e.conversion.attributeToElement({ model: Wi, view: "strong", upcastAlso: ["b", { styles: { "font-weight": "bold" } }] }), e.commands.add(Wi, new Rd(e, Wi)), e.keystrokes.set("CTRL+B", Wi);
        }
      }
      var m_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
      const pa = "bold";
      class g_ extends Ae {
        init() {
          const e = this.editor, t = e.t;
          e.ui.componentFactory.add(pa, (n) => {
            const i = e.commands.get(pa), s = new kt(n);
            return s.set({ label: t("k"), icon: m_, keystroke: "CTRL+B", tooltip: !0, isToggleable: !0 }), s.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), this.listenTo(s, "execute", () => e.execute(pa)), s;
          });
        }
      }
      const Yi = "italic";
      class v_ extends Ae {
        init() {
          const e = this.editor;
          e.model.schema.extend("$text", { allowAttributes: Yi }), e.model.schema.setAttributeProperties(Yi, { isFormatting: !0, copyOnEnter: !0 }), e.conversion.attributeToElement({ model: Yi, view: "i", upcastAlso: ["em", { styles: { "font-style": "italic" } }] }), e.commands.add(Yi, new Rd(e, Yi)), e.keystrokes.set("CTRL+I", Yi);
        }
      }
      var b_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
      const ma = "italic";
      class __ extends Ae {
        init() {
          const e = this.editor, t = e.t;
          e.ui.componentFactory.add(ma, (n) => {
            const i = e.commands.get(ma), s = new kt(n);
            return s.set({ label: t("j"), icon: b_, keystroke: "CTRL+I", tooltip: !0, isToggleable: !0 }), s.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), this.listenTo(s, "execute", () => e.execute(ma)), s;
          });
        }
      }
      class w_ extends Xe {
        refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
        execute(e = {}) {
          const t = this.editor.model, n = t.schema, i = t.document.selection, s = Array.from(i.getTopMostBlocks()), l = e.forceValue === void 0 ? !this.value : e.forceValue;
          t.change((d) => {
            if (l) {
              const f = s.filter((m) => wo(m) || Fd(n, m));
              this._applyQuote(d, f);
            } else
              this._removeQuote(d, s.filter(wo));
          });
        }
        _getValue() {
          const e = Rn(this.editor.model.document.selection.getTopMostBlocks());
          return !(!e || !wo(e));
        }
        _checkEnabled() {
          if (this.value)
            return !0;
          const e = this.editor.model.document.selection, t = this.editor.model.schema, n = Rn(e.getSelectedBlocks());
          return !!n && Fd(t, n);
        }
        _removeQuote(e, t) {
          Ld(e, t).reverse().forEach((n) => {
            if (n.start.isAtStart && n.end.isAtEnd)
              return void e.unwrap(n.start.parent);
            if (n.start.isAtStart) {
              const s = e.createPositionBefore(n.start.parent);
              return void e.move(n, s);
            }
            n.end.isAtEnd || e.split(n.end);
            const i = e.createPositionAfter(n.end.parent);
            e.move(n, i);
          });
        }
        _applyQuote(e, t) {
          const n = [];
          Ld(e, t).reverse().forEach((i) => {
            let s = wo(i.start);
            s || (s = e.createElement("blockQuote"), e.wrap(i, s)), n.push(s);
          }), n.reverse().reduce((i, s) => i.nextSibling == s ? (e.merge(e.createPositionAfter(i)), i) : s);
        }
      }
      function wo(o) {
        return o.parent.name == "blockQuote" ? o.parent : null;
      }
      function Ld(o, e) {
        let t, n = 0;
        const i = [];
        for (; n < e.length; ) {
          const s = e[n], l = e[n + 1];
          t || (t = o.createPositionBefore(s)), l && s.nextSibling == l || (i.push(o.createRange(t, o.createPositionAfter(s))), t = null), n++;
        }
        return i;
      }
      function Fd(o, e) {
        const t = o.checkChild(e.parent, "blockQuote"), n = o.checkChild(["$root", "blockQuote"], e);
        return t && n;
      }
      class y_ extends Ae {
        init() {
          const e = this.editor, t = e.model.schema;
          e.commands.add("blockQuote", new w_(e)), t.register("blockQuote", { allowWhere: "$block", allowContentOf: "$root" }), t.addChildCheck((n, i) => {
            if (n.endsWith("blockQuote") && i.name == "blockQuote")
              return !1;
          }), e.conversion.elementToElement({ model: "blockQuote", view: "blockquote" }), e.model.document.registerPostFixer((n) => {
            const i = e.model.document.differ.getChanges();
            for (const s of i)
              if (s.type == "insert") {
                const l = s.position.nodeAfter;
                if (!l)
                  continue;
                if (l.is("blockQuote") && l.isEmpty)
                  return n.remove(l), !0;
                if (l.is("blockQuote") && !t.checkChild(s.position, l))
                  return n.unwrap(l), !0;
                if (l.is("element")) {
                  const d = n.createRangeIn(l);
                  for (const f of d.getItems())
                    if (f.is("blockQuote") && !t.checkChild(n.createPositionBefore(f), f))
                      return n.unwrap(f), !0;
                }
              } else if (s.type == "remove") {
                const l = s.position.parent;
                if (l.is("blockQuote") && l.isEmpty)
                  return n.remove(l), !0;
              }
            return !1;
          });
        }
        afterInit() {
          const e = this.editor.commands.get("blockQuote");
          this.listenTo(this.editor.editing.view.document, "enter", (t, n) => {
            const i = this.editor.model.document, s = i.selection.getLastPosition().parent;
            i.selection.isCollapsed && s.isEmpty && e.value && (this.editor.execute("blockQuote"), this.editor.editing.view.scrollToTheSelection(), n.preventDefault(), t.stop());
          });
        }
      }
      var k_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
      p(44);
      class x_ extends Ae {
        init() {
          const e = this.editor, t = e.t;
          e.ui.componentFactory.add("blockQuote", (n) => {
            const i = e.commands.get("blockQuote"), s = new kt(n);
            return s.set({ label: t("l"), icon: k_, tooltip: !0, isToggleable: !0 }), s.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), this.listenTo(s, "execute", () => e.execute("blockQuote")), s;
          });
        }
      }
      var S_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>';
      class C_ extends Ae {
        static get pluginName() {
          return "CKFinderUI";
        }
        init() {
          const e = this.editor, t = e.ui.componentFactory, n = e.t;
          t.add("ckfinder", (i) => {
            const s = e.commands.get("ckfinder"), l = new kt(i);
            return l.set({ label: n("m"), icon: S_, tooltip: !0 }), l.bind("isEnabled").to(s), l.on("execute", () => {
              e.execute("ckfinder"), e.editing.view.focus();
            }), l;
          });
        }
      }
      class ga extends Ae {
        static get pluginName() {
          return "Notification";
        }
        init() {
          this.on("show:warning", (e, t) => {
            window.alert(t.message);
          }, { priority: "lowest" });
        }
        showSuccess(e, t = {}) {
          this._showNotification({ message: e, type: "success", namespace: t.namespace, title: t.title });
        }
        showInfo(e, t = {}) {
          this._showNotification({ message: e, type: "info", namespace: t.namespace, title: t.title });
        }
        showWarning(e, t = {}) {
          this._showNotification({ message: e, type: "warning", namespace: t.namespace, title: t.title });
        }
        _showNotification(e) {
          const t = `show:${e.type}` + (e.namespace ? `:${e.namespace}` : "");
          this.fire(t, { message: e.message, type: e.type, title: e.title || "" });
        }
      }
      class A_ extends Xe {
        constructor(e) {
          super(e), this.stopListening(this.editor.model.document, "change"), this.listenTo(this.editor.model.document, "change", () => this.refresh(), { priority: "low" });
        }
        refresh() {
          const e = this.editor.commands.get("imageUpload"), t = this.editor.commands.get("link");
          this.isEnabled = e && t && (e.isEnabled || t.isEnabled);
        }
        execute() {
          const e = this.editor, t = this.editor.config.get("ckfinder.openerMethod") || "modal";
          if (t != "popup" && t != "modal")
            throw new V.b('ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".', e);
          const n = this.editor.config.get("ckfinder.options") || {};
          n.chooseFiles = !0;
          const i = n.onInit;
          n.language || (n.language = e.locale.uiLanguage), n.onInit = (s) => {
            i && i(s), s.on("files:choose", (l) => {
              const d = l.data.files.toArray(), f = d.filter((b) => !b.isImage()), m = d.filter((b) => b.isImage());
              for (const b of f)
                e.execute("link", b.getUrl());
              const g = [];
              for (const b of m) {
                const y = b.getUrl();
                g.push(y || s.request("file:getProxyUrl", { file: b }));
              }
              g.length && zd(e, g);
            }), s.on("file:choose:resizedImage", (l) => {
              const d = l.data.resizedUrl;
              if (d)
                zd(e, [d]);
              else {
                const f = e.plugins.get("Notification"), m = e.locale.t;
                f.showWarning(m("az"), { title: m("ba"), namespace: "ckfinder" });
              }
            });
          }, window.CKFinder[t](n);
        }
      }
      function zd(o, e) {
        if (o.commands.get("imageUpload").isEnabled)
          o.execute("imageInsert", { source: e });
        else {
          const t = o.plugins.get("Notification"), n = o.locale.t;
          t.showWarning(n("bb"), { title: n("bc"), namespace: "ckfinder" });
        }
      }
      class T_ extends Ae {
        static get pluginName() {
          return "CKFinderEditing";
        }
        static get requires() {
          return [ga];
        }
        init() {
          const e = this.editor;
          e.commands.add("ckfinder", new A_(e));
        }
      }
      const va = /^data:(\S*?);base64,/;
      class $d {
        constructor(e, t, n) {
          if (!e)
            throw new V.b("fileuploader-missing-file: File must be provided as the first argument", null);
          if (!t)
            throw new V.b("fileuploader-missing-token: Token must be provided as the second argument.", null);
          if (!n)
            throw new V.b("fileuploader-missing-api-address: Api address must be provided as the third argument.", null);
          this.file = function(i) {
            if (typeof i != "string")
              return !1;
            const s = i.match(va);
            return !(!s || !s.length);
          }(e) ? function(i, s = 512) {
            try {
              const l = i.match(va)[1], d = atob(i.replace(va, "")), f = [];
              for (let m = 0; m < d.length; m += s) {
                const g = d.slice(m, m + s), b = new Array(g.length);
                for (let y = 0; y < g.length; y++)
                  b[y] = g.charCodeAt(y);
                f.push(new Uint8Array(b));
              }
              return new Blob(f, { type: l });
            } catch {
              throw new V.b("fileuploader-decoding-image-data-error: Problem with decoding Base64 image data.", null);
            }
          }(e) : e, this._token = t, this._apiAddress = n;
        }
        onProgress(e) {
          return this.on("progress", (t, n) => e(n)), this;
        }
        onError(e) {
          return this.once("error", (t, n) => e(n)), this;
        }
        abort() {
          this.xhr.abort();
        }
        send() {
          return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
        }
        _prepareRequest() {
          const e = new XMLHttpRequest();
          e.open("POST", this._apiAddress), e.setRequestHeader("Authorization", this._token.value), e.responseType = "json", this.xhr = e;
        }
        _attachXHRListeners() {
          const e = this, t = this.xhr;
          function n(i) {
            return () => e.fire("error", i);
          }
          t.addEventListener("error", n("Network Error")), t.addEventListener("abort", n("Abort")), t.upload && t.upload.addEventListener("progress", (i) => {
            i.lengthComputable && this.fire("progress", { total: i.total, uploaded: i.loaded });
          }), t.addEventListener("load", () => {
            const i = t.status, s = t.response;
            if (i < 200 || i > 299)
              return this.fire("error", s.message || s.error);
          });
        }
        _sendRequest() {
          const e = new FormData(), t = this.xhr;
          return e.append("file", this.file), new Promise((n, i) => {
            t.addEventListener("load", () => {
              const s = t.status, l = t.response;
              return s < 200 || s > 299 ? l.message ? i(new V.b("fileuploader-uploading-data-failed: Uploading file failed.", this, { message: l.message })) : i(l.error) : n(l);
            }), t.addEventListener("error", () => i(new Error("Network Error"))), t.addEventListener("abort", () => i(new Error("Abort"))), t.send(e);
          });
        }
      }
      $e($d, dt);
      const ba = { refreshInterval: 36e5, autoRefresh: !0 };
      class yo {
        constructor(e, t = ba) {
          if (!e)
            throw new V.b("token-missing-token-url: A `tokenUrl` must be provided as the first constructor argument.", this);
          this.set("value", t.initValue), this._refresh = typeof e == "function" ? e : () => function(n) {
            return new Promise((i, s) => {
              const l = new XMLHttpRequest();
              l.open("GET", n), l.addEventListener("load", () => {
                const d = l.status, f = l.response;
                return d < 200 || d > 299 ? s(new V.b("token-cannot-download-new-token: Cannot download new token from the provided url.", null)) : i(f);
              }), l.addEventListener("error", () => s(new Error("Network Error"))), l.addEventListener("abort", () => s(new Error("Abort"))), l.send();
            });
          }(e), this._options = Object.assign({}, ba, t);
        }
        init() {
          return new Promise((e, t) => {
            this._options.autoRefresh && this._startRefreshing(), this.value ? e(this) : this._refreshToken().then(e).catch(t);
          });
        }
        _refreshToken() {
          return this._refresh().then((e) => this.set("value", e)).then(() => this);
        }
        destroy() {
          this._stopRefreshing();
        }
        _startRefreshing() {
          this._refreshInterval = setInterval(() => this._refreshToken(), this._options.refreshInterval);
        }
        _stopRefreshing() {
          clearInterval(this._refreshInterval);
        }
        static create(e, t = ba) {
          return new yo(e, t).init();
        }
      }
      $e(yo, xt);
      var I_ = yo;
      class kr extends Ae {
        static get pluginName() {
          return "CloudServices";
        }
        init() {
          const e = this.editor.config.get("cloudServices") || {};
          for (const t in e)
            this[t] = e[t];
          if (this.tokenUrl)
            return this.token = new kr.Token(this.tokenUrl), this.token.init();
          this.token = null;
        }
      }
      kr.Token = I_;
      class ko extends Ae {
        static get requires() {
          return [Ln, kr];
        }
        init() {
          const e = this.editor, t = e.plugins.get(kr), n = t.token, i = t.uploadUrl;
          n && (this._uploadGateway = new ko._UploadGateway(n, i), e.plugins.get(Ln).createUploadAdapter = (s) => new E_(this._uploadGateway, s));
        }
      }
      class E_ {
        constructor(e, t) {
          this.uploadGateway = e, this.loader = t;
        }
        upload() {
          return this.loader.file.then((e) => (this.fileUploader = this.uploadGateway.upload(e), this.fileUploader.on("progress", (t, n) => {
            this.loader.uploadTotal = n.total, this.loader.uploaded = n.uploaded;
          }), this.fileUploader.send()));
        }
        abort() {
          this.fileUploader.abort();
        }
      }
      ko._UploadGateway = class {
        constructor(o, e) {
          if (!o)
            throw new V.b("uploadgateway-missing-token: Token must be provided.", null);
          if (!e)
            throw new V.b("uploadgateway-missing-api-address: Api address must be provided.", null);
          this._token = o, this._apiAddress = e;
        }
        upload(o) {
          return new $d(o, this._token, this._apiAddress);
        }
      };
      class P_ extends si {
        constructor(e) {
          super(e), this._observedElements = /* @__PURE__ */ new Set();
        }
        observe(e, t) {
          this.document.getRoot(t).on("change:children", (n, i) => {
            this.view.once("render", () => this._updateObservedElements(e, i));
          });
        }
        _updateObservedElements(e, t) {
          if (!t.is("element") || t.is("attributeElement"))
            return;
          const n = this.view.domConverter.mapViewToDom(t);
          if (n) {
            for (const i of n.querySelectorAll("img"))
              this._observedElements.has(i) || (this.listenTo(i, "load", (s, l) => this._fireEvents(l)), this._observedElements.add(i));
            for (const i of this._observedElements)
              e.contains(i) || (this.stopListening(i), this._observedElements.delete(i));
          }
        }
        _fireEvents(e) {
          this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", e));
        }
        destroy() {
          this._observedElements.clear(), super.destroy();
        }
      }
      function jd(o) {
        return (t) => {
          t.on(`attribute:${o}:image`, e);
        };
        function e(t, n, i) {
          if (!i.consumable.consume(n.item, t.name))
            return;
          const s = i.writer, l = i.mapper.toViewElement(n.item).getChild(0);
          n.attributeNewValue !== null ? s.setAttribute(n.attributeKey, n.attributeNewValue, l) : s.removeAttribute(n.attributeKey, l);
        }
      }
      class Bd {
        constructor() {
          this._stack = [];
        }
        add(e, t) {
          const n = this._stack, i = n[0];
          this._insertDescriptor(e);
          const s = n[0];
          i === s || _a(i, s) || this.fire("change:top", { oldDescriptor: i, newDescriptor: s, writer: t });
        }
        remove(e, t) {
          const n = this._stack, i = n[0];
          this._removeDescriptor(e);
          const s = n[0];
          i === s || _a(i, s) || this.fire("change:top", { oldDescriptor: i, newDescriptor: s, writer: t });
        }
        _insertDescriptor(e) {
          const t = this._stack, n = t.findIndex((s) => s.id === e.id);
          if (_a(e, t[n]))
            return;
          n > -1 && t.splice(n, 1);
          let i = 0;
          for (; t[i] && M_(t[i], e); )
            i++;
          t.splice(i, 0, e);
        }
        _removeDescriptor(e) {
          const t = this._stack, n = t.findIndex((i) => i.id === e);
          n > -1 && t.splice(n, 1);
        }
      }
      function _a(o, e) {
        return o && e && o.priority == e.priority && xo(o.classes) == xo(e.classes);
      }
      function M_(o, e) {
        return o.priority > e.priority || !(o.priority < e.priority) && xo(o.classes) > xo(e.classes);
      }
      function xo(o) {
        return Array.isArray(o) ? o.sort().join(",") : o;
      }
      $e(Bd, dt);
      var O_ = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
      const D_ = "ck-widget", Vd = "ck-widget_selected";
      function ui(o) {
        return !!o.is("element") && !!o.getCustomProperty("widget");
      }
      function wa(o, e, t = {}) {
        return un.isEdge || e.setAttribute("contenteditable", "false", o), e.addClass(D_, o), e.setCustomProperty("widget", !0, o), o.getFillerOffset = R_, t.label && function(i, s, l) {
          l.setCustomProperty("widgetLabel", s, i);
        }(o, t.label, e), t.hasSelectionHandler && function(i, s) {
          const l = s.createUIElement("div", { class: "ck ck-widget__selection-handler" }, function(d) {
            const f = this.toDomElement(d), m = new vo();
            return m.set("content", O_), m.render(), f.appendChild(m.element), f;
          });
          s.insert(s.createPositionAt(i, 0), l), s.addClass(["ck-widget_with-selection-handler"], i);
        }(o, e), function(i, s, l, d) {
          const f = new Bd();
          f.on("change:top", (m, g) => {
            g.oldDescriptor && d(i, g.oldDescriptor, g.writer), g.newDescriptor && l(i, g.newDescriptor, g.writer);
          }), s.setCustomProperty("addHighlight", (m, g, b) => f.add(g, b), i), s.setCustomProperty("removeHighlight", (m, g, b) => f.remove(g, b), i);
        }(o, e, (i, s, l) => l.addClass(n(s.classes), i), (i, s, l) => l.removeClass(n(s.classes), i)), o;
        function n(i) {
          return Array.isArray(i) ? i : [i];
        }
      }
      function N_(o) {
        const e = o.getCustomProperty("widgetLabel");
        return e ? typeof e == "function" ? e() : e : "";
      }
      function ya(o, e) {
        return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], o), un.isEdge || (e.setAttribute("contenteditable", o.isReadOnly ? "false" : "true", o), o.on("change:isReadOnly", (t, n, i) => {
          e.setAttribute("contenteditable", i ? "false" : "true", o);
        })), o.on("change:isFocused", (t, n, i) => {
          i ? e.addClass("ck-editor__nested-editable_focused", o) : e.removeClass("ck-editor__nested-editable_focused", o);
        }), o;
      }
      function So(o, e) {
        const t = o.getSelectedElement();
        if (t && e.schema.isBlock(t))
          return e.createPositionAfter(t);
        const n = o.getSelectedBlocks().next().value;
        if (n) {
          if (n.isEmpty)
            return e.createPositionAt(n, 0);
          const i = e.createPositionAfter(n);
          return o.focus.isTouching(i) ? i : e.createPositionBefore(n);
        }
        return o.focus;
      }
      function R_() {
        return null;
      }
      function ka(o) {
        const e = o.getSelectedElement();
        return e && function(t) {
          return !!t.getCustomProperty("image") && ui(t);
        }(e) ? e : null;
      }
      function Co(o) {
        return !!o && o.is("image");
      }
      function Ud(o, e, t = {}) {
        const n = o.createElement("image", t), i = So(e.document.selection, e);
        e.insertContent(n, i), n.parent && o.setSelection(n, "on");
      }
      function Hd(o) {
        const e = o.schema, t = o.document.selection;
        return function(n, i, s) {
          const l = function(d, f) {
            const m = So(d, f).parent;
            return m.isEmpty && !m.is("$root") ? m.parent : m;
          }(n, s);
          return i.checkChild(l, "image");
        }(t, e, o) && !function(n, i) {
          const s = n.getSelectedElement();
          return s && i.isObject(s);
        }(t, e) && function(n) {
          return [...n.focus.getAncestors()].every((i) => !i.is("image"));
        }(t);
      }
      class L_ extends Xe {
        refresh() {
          this.isEnabled = Hd(this.editor.model);
        }
        execute(e) {
          const t = this.editor.model;
          t.change((n) => {
            const i = Array.isArray(e.source) ? e.source : [e.source];
            for (const s of i)
              Ud(n, t, { src: s });
          });
        }
      }
      class F_ extends Ae {
        init() {
          const e = this.editor, t = e.model.schema, n = e.t, i = e.conversion;
          e.editing.view.addObserver(P_), t.register("image", { isObject: !0, isBlock: !0, allowWhere: "$block", allowAttributes: ["alt", "src", "srcset"] }), i.for("dataDowncast").elementToElement({ model: "image", view: (s, l) => Wd(l) }), i.for("editingDowncast").elementToElement({ model: "image", view: (s, l) => function(d, f, m) {
            return f.setCustomProperty("image", !0, d), wa(d, f, { label: function() {
              const g = d.getChild(0).getAttribute("alt");
              return g ? `${g} ${m}` : m;
            } });
          }(Wd(l), l, n("p")) }), i.for("downcast").add(jd("src")).add(jd("alt")).add(function() {
            return (l) => {
              l.on("attribute:srcset:image", s);
            };
            function s(l, d, f) {
              if (!f.consumable.consume(d.item, l.name))
                return;
              const m = f.writer, g = f.mapper.toViewElement(d.item).getChild(0);
              if (d.attributeNewValue === null) {
                const b = d.attributeOldValue;
                b.data && (m.removeAttribute("srcset", g), m.removeAttribute("sizes", g), b.width && m.removeAttribute("width", g));
              } else {
                const b = d.attributeNewValue;
                b.data && (m.setAttribute("srcset", b.data, g), m.setAttribute("sizes", "100vw", g), b.width && m.setAttribute("width", b.width, g));
              }
            }
          }()), i.for("upcast").elementToElement({ view: { name: "img", attributes: { src: !0 } }, model: (s, l) => l.createElement("image", { src: s.getAttribute("src") }) }).attributeToAttribute({ view: { name: "img", key: "alt" }, model: "alt" }).attributeToAttribute({ view: { name: "img", key: "srcset" }, model: { key: "srcset", value: (s) => {
            const l = { data: s.getAttribute("srcset") };
            return s.hasAttribute("width") && (l.width = s.getAttribute("width")), l;
          } } }).add(function() {
            return (l) => {
              l.on("element:figure", s);
            };
            function s(l, d, f) {
              if (!f.consumable.test(d.viewItem, { name: !0, classes: "image" }))
                return;
              const m = Array.from(d.viewItem.getChildren()).find((y) => y.is("img"));
              if (!m || !m.hasAttribute("src") || !f.consumable.test(m, { name: !0 }))
                return;
              const g = f.convertItem(m, d.modelCursor), b = Rn(g.modelRange.getItems());
              b && (f.convertChildren(d.viewItem, f.writer.createPositionAt(b, 0)), d.modelRange = g.modelRange, d.modelCursor = g.modelCursor);
            }
          }()), e.commands.add("imageInsert", new L_(e));
        }
      }
      function Wd(o) {
        const e = o.createEmptyElement("img"), t = o.createContainerElement("figure", { class: "image" });
        return o.insert(o.createPositionAt(t, 0), e), t;
      }
      class z_ extends ki {
        constructor(e) {
          super(e), this.domEventType = "mousedown";
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      p(46);
      const $_ = fc("Ctrl+A");
      class xa extends Ae {
        static get pluginName() {
          return "Widget";
        }
        init() {
          const e = this.editor.editing.view, t = e.document;
          this._previouslySelected = /* @__PURE__ */ new Set(), this.editor.editing.downcastDispatcher.on("selection", (n, i, s) => {
            this._clearPreviouslySelectedWidgets(s.writer);
            const l = s.writer, d = l.document.selection, f = d.getSelectedElement();
            let m = null;
            for (const g of d.getRanges())
              for (const b of g) {
                const y = b.item;
                ui(y) && !j_(y, m) && (l.addClass(Vd, y), this._previouslySelected.add(y), m = y, y == f && l.setSelection(d.getRanges(), { fake: !0, label: N_(f) }));
              }
          }, { priority: "low" }), e.addObserver(z_), this.listenTo(t, "mousedown", (...n) => this._onMousedown(...n)), this.listenTo(t, "keydown", (...n) => this._onKeydown(...n), { priority: "high" }), this.listenTo(t, "delete", (n, i) => {
            this._handleDelete(i.direction == "forward") && (i.preventDefault(), n.stop());
          }, { priority: "high" });
        }
        _onMousedown(e, t) {
          const n = this.editor, i = n.editing.view, s = i.document;
          let l = t.target;
          if (function(f) {
            for (; f; ) {
              if (f.is("editableElement") && !f.is("rootElement"))
                return !0;
              if (ui(f))
                return !1;
              f = f.parent;
            }
            return !1;
          }(l)) {
            if (un.isSafari && t.domEvent.detail >= 3) {
              const f = n.editing.mapper.toModelElement(l);
              this.editor.model.change((m) => {
                t.preventDefault(), m.setSelection(f, "in");
              });
            }
            return;
          }
          if (!ui(l) && !(l = l.findAncestor(ui)))
            return;
          t.preventDefault(), s.isFocused || i.focus();
          const d = n.editing.mapper.toModelElement(l);
          this._setSelectionOverElement(d);
        }
        _onKeydown(e, t) {
          const n = t.keyCode, i = n == tt.arrowdown || n == tt.arrowright;
          let s = !1;
          (function(l) {
            return l == tt.arrowright || l == tt.arrowleft || l == tt.arrowup || l == tt.arrowdown;
          })(n) ? s = this._handleArrowKeys(i) : function(l) {
            return Yn(l) == $_;
          }(t) ? s = this._selectAllNestedEditableContent() || this._selectAllContent() : n === tt.enter && (s = this._handleEnterKey(t.shiftKey)), s && (t.preventDefault(), e.stop());
        }
        _handleDelete(e) {
          if (this.editor.isReadOnly)
            return;
          const t = this.editor.model.document.selection;
          if (!t.isCollapsed)
            return;
          const n = this._getObjectElementNextToSelection(e);
          return n ? (this.editor.model.change((i) => {
            let s = t.anchor.parent;
            for (; s.isEmpty; ) {
              const l = s;
              s = l.parent, i.remove(l);
            }
            this._setSelectionOverElement(n);
          }), !0) : void 0;
        }
        _handleArrowKeys(e) {
          const t = this.editor.model, n = t.schema, i = t.document.selection, s = i.getSelectedElement();
          if (s && n.isObject(s)) {
            const d = e ? i.getLastPosition() : i.getFirstPosition(), f = n.getNearestSelectionRange(d, e ? "forward" : "backward");
            return f && t.change((m) => {
              m.setSelection(f);
            }), !0;
          }
          if (!i.isCollapsed)
            return;
          const l = this._getObjectElementNextToSelection(e);
          return l && n.isObject(l) ? (this._setSelectionOverElement(l), !0) : void 0;
        }
        _handleEnterKey(e) {
          const t = this.editor.model, n = t.document.selection.getSelectedElement();
          if (function(i, s) {
            return i && s.isObject(i) && !s.isInline(i);
          }(n, t.schema))
            return t.change((i) => {
              let s = i.createPositionAt(n, e ? "before" : "after");
              const l = i.createElement("paragraph");
              if (t.schema.isBlock(n.parent)) {
                const d = t.schema.findAllowedParent(s, l);
                s = i.split(s, d).position;
              }
              i.insert(l, s), i.setSelection(l, "in");
            }), !0;
        }
        _selectAllNestedEditableContent() {
          const e = this.editor.model, t = e.document.selection, n = e.schema.getLimitElement(t);
          return t.getFirstRange().root != n && (e.change((i) => {
            i.setSelection(i.createRangeIn(n));
          }), !0);
        }
        _selectAllContent() {
          const e = this.editor.model, t = this.editor.editing, n = t.view.document.selection.getSelectedElement();
          if (n && ui(n)) {
            const i = t.mapper.toModelElement(n.parent);
            return e.change((s) => {
              s.setSelection(s.createRangeIn(i));
            }), !0;
          }
          return !1;
        }
        _setSelectionOverElement(e) {
          this.editor.model.change((t) => {
            t.setSelection(t.createRangeOn(e));
          });
        }
        _getObjectElementNextToSelection(e) {
          const t = this.editor.model, n = t.schema, i = t.document.selection, s = t.createSelection(i);
          t.modifySelection(s, { direction: e ? "forward" : "backward" });
          const l = e ? s.focus.nodeBefore : s.focus.nodeAfter;
          return l && n.isObject(l) ? l : null;
        }
        _clearPreviouslySelectedWidgets(e) {
          for (const t of this._previouslySelected)
            e.removeClass(Vd, t);
          this._previouslySelected.clear();
        }
      }
      function j_(o, e) {
        return !!e && Array.from(o.getAncestors()).includes(e);
      }
      class B_ extends Xe {
        refresh() {
          const e = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = Co(e), Co(e) && e.hasAttribute("alt") ? this.value = e.getAttribute("alt") : this.value = !1;
        }
        execute(e) {
          const t = this.editor.model, n = t.document.selection.getSelectedElement();
          t.change((i) => {
            i.setAttribute("alt", e.newValue, n);
          });
        }
      }
      class V_ extends Ae {
        init() {
          this.editor.commands.add("imageTextAlternative", new B_(this.editor));
        }
      }
      p(48);
      class Sa extends Ge {
        constructor(e, t) {
          super(e);
          const n = `ck-input-${Vn()}`, i = `ck-status-${Vn()}`;
          this.set("label"), this.set("value"), this.set("isReadOnly", !1), this.set("errorText", null), this.set("infoText", null), this.labelView = this._createLabelView(n), this.inputView = this._createInputView(t, n, i), this.statusView = this._createStatusView(i), this.bind("_statusText").to(this, "errorText", this, "infoText", (l, d) => l || d);
          const s = this.bindTemplate;
          this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-input", s.if("isReadOnly", "ck-disabled")] }, children: [this.labelView, this.inputView, this.statusView] });
        }
        _createLabelView(e) {
          const t = new Ku(this.locale);
          return t.for = e, t.bind("text").to(this, "label"), t;
        }
        _createInputView(e, t, n) {
          const i = new e(this.locale, n);
          return i.id = t, i.ariaDescribedById = n, i.bind("value").to(this), i.bind("isReadOnly").to(this), i.bind("hasError").to(this, "errorText", (s) => !!s), i.on("input", () => {
            this.errorText = null;
          }), i;
        }
        _createStatusView(e) {
          const t = new Ge(this.locale), n = this.bindTemplate;
          return t.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-input__status", n.if("errorText", "ck-labeled-input__status_error"), n.if("_statusText", "ck-hidden", (i) => !i)], id: e, role: n.if("errorText", "alert") }, children: [{ text: n.to("_statusText") }] }), t;
        }
        select() {
          this.inputView.select();
        }
        focus() {
          this.inputView.focus();
        }
      }
      p(50);
      class Ca extends Ge {
        constructor(e) {
          super(e), this.set("value"), this.set("id"), this.set("placeholder"), this.set("isReadOnly", !1), this.set("hasError", !1), this.set("ariaDescribedById");
          const t = this.bindTemplate;
          this.setTemplate({ tag: "input", attributes: { type: "text", class: ["ck", "ck-input", "ck-input-text", t.if("hasError", "ck-error")], id: t.to("id"), placeholder: t.to("placeholder"), readonly: t.to("isReadOnly"), "aria-invalid": t.if("hasError", !0), "aria-describedby": t.to("ariaDescribedById") }, on: { input: t.to("input") } });
        }
        render() {
          super.render();
          const e = (t) => {
            this.element.value = t || t === 0 ? t : "";
          };
          e(this.value), this.on("change:value", (t, n, i) => {
            e(i);
          });
        }
        select() {
          this.element.select();
        }
        focus() {
          this.element.focus();
        }
      }
      function Aa({ view: o }) {
        o.listenTo(o.element, "submit", (e, t) => {
          t.preventDefault(), o.fire("submit");
        }, { useCapture: !0 });
      }
      var Ta = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>', Ia = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
      p(52);
      class U_ extends Ge {
        constructor(e) {
          super(e);
          const t = this.locale.t;
          this.focusTracker = new yn(), this.keystrokes = new ci(), this.labeledInput = this._createLabeledInputView(), this.saveButtonView = this._createButton(t("ca"), Ta, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(t("cb"), Ia, "ck-button-cancel", "cancel"), this._focusables = new ji(), this._focusCycler = new Vi({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-text-alternative-form"], tabindex: "-1" }, children: [this.labeledInput, this.saveButtonView, this.cancelButtonView] });
        }
        render() {
          super.render(), this.keystrokes.listenTo(this.element), Aa({ view: this }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach((e) => {
            this._focusables.add(e), this.focusTracker.add(e.element);
          });
        }
        _createButton(e, t, n, i) {
          const s = new kt(this.locale);
          return s.set({ label: e, icon: t, tooltip: !0 }), s.extendTemplate({ attributes: { class: n } }), i && s.delegate("execute").to(this, i), s;
        }
        _createLabeledInputView() {
          const e = this.locale.t, t = new Sa(this.locale, Ca);
          return t.label = e("cc"), t.inputView.placeholder = e("cc"), t;
        }
      }
      p(54);
      const Yd = na("px"), qd = jt.document.body;
      class ft extends Ge {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set("top", 0), this.set("left", 0), this.set("position", "arrow_nw"), this.set("isVisible", !1), this.set("withArrow", !0), this.set("class"), this.content = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-panel", t.to("position", (n) => `ck-balloon-panel_${n}`), t.if("isVisible", "ck-balloon-panel_visible"), t.if("withArrow", "ck-balloon-panel_with-arrow"), t.to("class")], style: { top: t.to("top", Yd), left: t.to("left", Yd) } }, children: this.content });
        }
        show() {
          this.isVisible = !0;
        }
        hide() {
          this.isVisible = !1;
        }
        attachTo(e) {
          this.show();
          const t = ft.defaultPositions, n = Object.assign({}, { element: this.element, positions: [t.southArrowNorth, t.southArrowNorthWest, t.southArrowNorthEast, t.northArrowSouth, t.northArrowSouthWest, t.northArrowSouthEast], limiter: qd, fitInViewport: !0 }, e), i = ft._getOptimalPosition(n), s = parseInt(i.left), l = parseInt(i.top), d = i.name;
          Object.assign(this, { top: l, left: s, position: d });
        }
        pin(e) {
          this.unpin(), this._pinWhenIsVisibleCallback = () => {
            this.isVisible ? this._startPinning(e) : this._stopPinning();
          }, this._startPinning(e), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
        unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
        _startPinning(e) {
          this.attachTo(e);
          const t = Ea(e.target), n = e.limiter ? Ea(e.limiter) : qd;
          this.listenTo(jt.document, "scroll", (i, s) => {
            const l = s.target, d = t && l.contains(t), f = n && l.contains(n);
            !d && !f && t && n || this.attachTo(e);
          }, { useCapture: !0 }), this.listenTo(jt.window, "resize", () => {
            this.attachTo(e);
          });
        }
        _stopPinning() {
          this.stopListening(jt.document, "scroll"), this.stopListening(jt.window, "resize");
        }
      }
      function Ea(o) {
        return Bn(o) ? o : ao(o) ? o.commonAncestorContainer : typeof o == "function" ? Ea(o()) : null;
      }
      function Zn(o, e) {
        return o.top - e.height - ft.arrowVerticalOffset;
      }
      function Kn(o) {
        return o.bottom + ft.arrowVerticalOffset;
      }
      ft.arrowHorizontalOffset = 25, ft.arrowVerticalOffset = 10, ft._getOptimalPosition = nd, ft.defaultPositions = { northArrowSouth: (o, e) => ({ top: Zn(o, e), left: o.left + o.width / 2 - e.width / 2, name: "arrow_s" }), northArrowSouthEast: (o, e) => ({ top: Zn(o, e), left: o.left + o.width / 2 - e.width + ft.arrowHorizontalOffset, name: "arrow_se" }), northArrowSouthWest: (o, e) => ({ top: Zn(o, e), left: o.left + o.width / 2 - ft.arrowHorizontalOffset, name: "arrow_sw" }), northWestArrowSouth: (o, e) => ({ top: Zn(o, e), left: o.left - e.width / 2, name: "arrow_s" }), northWestArrowSouthWest: (o, e) => ({ top: Zn(o, e), left: o.left - ft.arrowHorizontalOffset, name: "arrow_sw" }), northWestArrowSouthEast: (o, e) => ({ top: Zn(o, e), left: o.left - e.width + ft.arrowHorizontalOffset, name: "arrow_se" }), northEastArrowSouth: (o, e) => ({ top: Zn(o, e), left: o.right - e.width / 2, name: "arrow_s" }), northEastArrowSouthEast: (o, e) => ({ top: Zn(o, e), left: o.right - e.width + ft.arrowHorizontalOffset, name: "arrow_se" }), northEastArrowSouthWest: (o, e) => ({ top: Zn(o, e), left: o.right - ft.arrowHorizontalOffset, name: "arrow_sw" }), southArrowNorth: (o, e) => ({ top: Kn(o), left: o.left + o.width / 2 - e.width / 2, name: "arrow_n" }), southArrowNorthEast: (o, e) => ({ top: Kn(o), left: o.left + o.width / 2 - e.width + ft.arrowHorizontalOffset, name: "arrow_ne" }), southArrowNorthWest: (o, e) => ({ top: Kn(o), left: o.left + o.width / 2 - ft.arrowHorizontalOffset, name: "arrow_nw" }), southWestArrowNorth: (o, e) => ({ top: Kn(o), left: o.left - e.width / 2, name: "arrow_n" }), southWestArrowNorthWest: (o, e) => ({ top: Kn(o), left: o.left - ft.arrowHorizontalOffset, name: "arrow_nw" }), southWestArrowNorthEast: (o, e) => ({ top: Kn(o), left: o.left - e.width + ft.arrowHorizontalOffset, name: "arrow_ne" }), southEastArrowNorth: (o, e) => ({ top: Kn(o), left: o.right - e.width / 2, name: "arrow_n" }), southEastArrowNorthEast: (o, e) => ({ top: Kn(o), left: o.right - e.width + ft.arrowHorizontalOffset, name: "arrow_ne" }), southEastArrowNorthWest: (o, e) => ({ top: Kn(o), left: o.right - ft.arrowHorizontalOffset, name: "arrow_nw" }) };
      var H_ = `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z" /></svg>
`, W_ = `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>
`;
      p(56), p(58);
      const Ao = na("px");
      class To extends Ae {
        static get pluginName() {
          return "ContextualBalloon";
        }
        constructor(e) {
          super(e), this.positionLimiter = () => {
            const t = this.editor.editing.view, n = t.document.selection.editableElement;
            return n ? t.domConverter.mapViewToDom(n.root) : null;
          }, this.set("visibleView", null), this.view = new ft(e.locale), e.ui.view.body.add(this.view), e.ui.focusTracker.add(this.view.element), this._viewToStack = /* @__PURE__ */ new Map(), this._idToStack = /* @__PURE__ */ new Map(), this.set("_numberOfStacks", 0), this.set("_singleViewMode", !1), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
        }
        hasView(e) {
          return Array.from(this._viewToStack.keys()).includes(e);
        }
        add(e) {
          if (this.hasView(e.view))
            throw new V.b("contextualballoon-add-view-exist: Cannot add configuration of the same view twice.", [this, e]);
          const t = e.stackId || "main";
          if (!this._idToStack.has(t))
            return this._idToStack.set(t, /* @__PURE__ */ new Map([[e.view, e]])), this._viewToStack.set(e.view, this._idToStack.get(t)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !e.singleViewMode || this.showStack(t));
          const n = this._idToStack.get(t);
          e.singleViewMode && this.showStack(t), n.set(e.view, e), this._viewToStack.set(e.view, n), n === this._visibleStack && this._showView(e);
        }
        remove(e) {
          if (!this.hasView(e))
            throw new V.b("contextualballoon-remove-view-not-exist: Cannot remove the configuration of a non-existent view.", [this, e]);
          const t = this._viewToStack.get(e);
          this._singleViewMode && this.visibleView === e && (this._singleViewMode = !1), this.visibleView === e && (t.size === 1 ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(t.values())[t.size - 2])), t.size === 1 ? (this._idToStack.delete(this._getStackId(t)), this._numberOfStacks = this._idToStack.size) : t.delete(e), this._viewToStack.delete(e);
        }
        updatePosition(e) {
          e && (this._visibleStack.get(this.visibleView).position = e), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
        }
        showStack(e) {
          this.visibleStack = e;
          const t = this._idToStack.get(e);
          if (!t)
            throw new V.b("contextualballoon-showstack-stack-not-exist: Cannot show a stack that does not exist.", this);
          this._visibleStack !== t && this._showView(Array.from(t.values()).pop());
        }
        get _visibleStack() {
          return this._viewToStack.get(this.visibleView);
        }
        _getStackId(e) {
          return Array.from(this._idToStack.entries()).find((t) => t[1] === e)[0];
        }
        _showNextStack() {
          const e = Array.from(this._idToStack.values());
          let t = e.indexOf(this._visibleStack) + 1;
          e[t] || (t = 0), this.showStack(this._getStackId(e[t]));
        }
        _showPrevStack() {
          const e = Array.from(this._idToStack.values());
          let t = e.indexOf(this._visibleStack) - 1;
          e[t] || (t = e.length - 1), this.showStack(this._getStackId(e[t]));
        }
        _createRotatorView() {
          const e = new Y_(this.editor.locale), t = this.editor.locale.t;
          return this.view.content.add(e), e.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (n, i) => !i && n > 1), e.on("change:isNavigationVisible", () => this.updatePosition(), { priority: "low" }), e.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (n, i) => {
            if (i < 2)
              return "";
            const s = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
            return t("bv", [s, i]);
          }), e.buttonNextView.on("execute", () => {
            e.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
          }), e.buttonPrevView.on("execute", () => {
            e.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
          }), e;
        }
        _createFakePanelsView() {
          const e = new q_(this.editor.locale, this.view);
          return e.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (t, n) => !n && t >= 2 ? Math.min(t - 1, 2) : 0), e.listenTo(this.view, "change:top", () => e.updatePosition()), e.listenTo(this.view, "change:left", () => e.updatePosition()), this.editor.ui.view.body.add(e), e;
        }
        _showView({ view: e, balloonClassName: t = "", withArrow: n = !0, singleViewMode: i = !1 }) {
          this.view.class = t, this.view.withArrow = n, this._rotatorView.showView(e), this.visibleView = e, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), i && (this._singleViewMode = !0);
        }
        _getBalloonPosition() {
          let e = Array.from(this._visibleStack.values()).pop().position;
          return e && !e.limiter && (e = Object.assign({}, e, { limiter: this.positionLimiter })), e;
        }
      }
      class Y_ extends Ge {
        constructor(e) {
          super(e);
          const t = e.t, n = this.bindTemplate;
          this.set("isNavigationVisible", !0), this.focusTracker = new yn(), this.buttonPrevView = this._createButtonView(t("bw"), H_), this.buttonNextView = this._createButtonView(t("bx"), W_), this.content = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-rotator"], "z-index": "-1" }, children: [{ tag: "div", attributes: { class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", (i) => i ? "" : "ck-hidden")] }, children: [this.buttonPrevView, { tag: "span", attributes: { class: ["ck-balloon-rotator__counter"] }, children: [{ text: n.to("counter") }] }, this.buttonNextView] }, { tag: "div", attributes: { class: "ck-balloon-rotator__content" }, children: this.content }] });
        }
        render() {
          super.render(), this.focusTracker.add(this.element);
        }
        showView(e) {
          this.hideView(), this.content.add(e);
        }
        hideView() {
          this.content.clear();
        }
        _createButtonView(e, t) {
          const n = new kt(this.locale);
          return n.set({ label: e, icon: t, tooltip: !0 }), n;
        }
      }
      class q_ extends Ge {
        constructor(e, t) {
          super(e);
          const n = this.bindTemplate;
          this.set("top", 0), this.set("left", 0), this.set("height", 0), this.set("width", 0), this.set("numberOfPanels", 0), this.content = this.createCollection(), this._balloonPanelView = t, this.setTemplate({ tag: "div", attributes: { class: ["ck-fake-panel", n.to("numberOfPanels", (i) => i ? "" : "ck-hidden")], style: { top: n.to("top", Ao), left: n.to("left", Ao), width: n.to("width", Ao), height: n.to("height", Ao) } }, children: this.content }), this.on("change:numberOfPanels", (i, s, l, d) => {
            l > d ? this._addPanels(l - d) : this._removePanels(d - l), this.updatePosition();
          });
        }
        _addPanels(e) {
          for (; e--; ) {
            const t = new Ge();
            t.setTemplate({ tag: "div" }), this.content.add(t), this.registerChild(t);
          }
        }
        _removePanels(e) {
          for (; e--; ) {
            const t = this.content.last;
            this.content.remove(t), this.deregisterChild(t), t.destroy();
          }
        }
        updatePosition() {
          if (this.numberOfPanels) {
            const { top: e, left: t } = this._balloonPanelView, { width: n, height: i } = new Dt(this._balloonPanelView.element);
            Object.assign(this, { top: e, left: t, width: n, height: i });
          }
        }
      }
      var G_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';
      function Gd(o) {
        const e = o.editing.view, t = ft.defaultPositions;
        return { target: e.domConverter.viewToDom(e.document.selection.getSelectedElement()), positions: [t.northArrowSouth, t.northArrowSouthWest, t.northArrowSouthEast, t.southArrowNorth, t.southArrowNorthWest, t.southArrowNorthEast] };
      }
      class Z_ extends Ae {
        static get requires() {
          return [To];
        }
        static get pluginName() {
          return "ImageTextAlternativeUI";
        }
        init() {
          this._createButton(), this._createForm();
        }
        destroy() {
          super.destroy(), this._form.destroy();
        }
        _createButton() {
          const e = this.editor, t = e.t;
          e.ui.componentFactory.add("imageTextAlternative", (n) => {
            const i = e.commands.get("imageTextAlternative"), s = new kt(n);
            return s.set({ label: t("bk"), icon: G_, tooltip: !0 }), s.bind("isEnabled").to(i, "isEnabled"), this.listenTo(s, "execute", () => this._showForm()), s;
          });
        }
        _createForm() {
          const e = this.editor, t = e.editing.view.document;
          this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new U_(e.locale), this._form.render(), this.listenTo(this._form, "submit", () => {
            e.execute("imageTextAlternative", { newValue: this._form.labeledInput.inputView.element.value }), this._hideForm(!0);
          }), this.listenTo(this._form, "cancel", () => {
            this._hideForm(!0);
          }), this._form.keystrokes.set("Esc", (n, i) => {
            this._hideForm(!0), i();
          }), this.listenTo(e.ui, "update", () => {
            ka(t.selection) ? this._isVisible && function(n) {
              const i = n.plugins.get("ContextualBalloon");
              if (ka(n.editing.view.document.selection)) {
                const s = Gd(n);
                i.updatePosition(s);
              }
            }(e) : this._hideForm(!0);
          }), ca({ emitter: this._form, activator: () => this._isVisible, contextElements: [this._balloon.view.element], callback: () => this._hideForm() });
        }
        _showForm() {
          if (this._isVisible)
            return;
          const e = this.editor, t = e.commands.get("imageTextAlternative"), n = this._form.labeledInput;
          this._isInBalloon || this._balloon.add({ view: this._form, position: Gd(e) }), n.value = n.inputView.element.value = t.value || "", this._form.labeledInput.select();
        }
        _hideForm(e) {
          this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), e && this.editor.editing.view.focus());
        }
        get _isVisible() {
          return this._balloon.visibleView === this._form;
        }
        get _isInBalloon() {
          return this._balloon.hasView(this._form);
        }
      }
      class K_ extends Ae {
        static get requires() {
          return [V_, Z_];
        }
        static get pluginName() {
          return "ImageTextAlternative";
        }
      }
      p(60);
      class Zd extends Ae {
        static get requires() {
          return [F_, xa, K_];
        }
        static get pluginName() {
          return "Image";
        }
      }
      class X_ extends Ge {
        constructor(e) {
          super(e), this.buttonView = new kt(e), this._fileInputView = new Q_(e), this._fileInputView.bind("acceptedType").to(this), this._fileInputView.bind("allowMultipleFiles").to(this), this._fileInputView.delegate("done").to(this), this.setTemplate({ tag: "span", attributes: { class: "ck-file-dialog-button" }, children: [this.buttonView, this._fileInputView] }), this.buttonView.on("execute", () => {
            this._fileInputView.open();
          });
        }
        focus() {
          this.buttonView.focus();
        }
      }
      class Q_ extends Ge {
        constructor(e) {
          super(e), this.set("acceptedType"), this.set("allowMultipleFiles", !1);
          const t = this.bindTemplate;
          this.setTemplate({ tag: "input", attributes: { class: ["ck-hidden"], type: "file", tabindex: "-1", accept: t.to("acceptedType"), multiple: t.to("allowMultipleFiles") }, on: { change: t.to(() => {
            this.element && this.element.files && this.element.files.length && this.fire("done", this.element.files), this.element.value = "";
          }) } });
        }
        open() {
          this.element.click();
        }
      }
      var J_ = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';
      function Kd(o) {
        return /^image\/(jpeg|png|gif|bmp)$/.test(o.type);
      }
      function ew(o) {
        return new Promise((e, t) => {
          const n = o.getAttribute("src");
          fetch(n).then((i) => i.blob()).then((i) => {
            const s = function(d, f) {
              return d.type ? d.type : f.match(/data:(image\/\w+);base64/) ? f.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
            }(i, n), l = function(d, f, m) {
              try {
                return new File([d], f, { type: m });
              } catch {
                return null;
              }
            }(i, `image.${s.replace("image/", "")}`, s);
            l ? e(l) : t();
          }).catch(t);
        });
      }
      class tw extends Ae {
        init() {
          const e = this.editor, t = e.t;
          e.ui.componentFactory.add("imageUpload", (n) => {
            const i = new X_(n), s = e.commands.get("imageUpload");
            return i.set({ acceptedType: "image/*", allowMultipleFiles: !0 }), i.buttonView.set({ label: t("v"), icon: J_, tooltip: !0 }), i.buttonView.bind("isEnabled").to(s), i.on("done", (l, d) => {
              const f = Array.from(d).filter(Kd);
              f.length && e.execute("imageUpload", { file: f });
            }), i;
          });
        }
      }
      var nw = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>';
      p(62), p(64), p(66);
      class iw extends Ae {
        constructor(e) {
          super(e), this.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent(nw);
        }
        init() {
          this.editor.editing.downcastDispatcher.on("attribute:uploadStatus:image", (...e) => this.uploadStatusChange(...e));
        }
        uploadStatusChange(e, t, n) {
          const i = this.editor, s = t.item, l = s.getAttribute("uploadId");
          if (!n.consumable.consume(t.item, e.name))
            return;
          const d = i.plugins.get(Ln), f = l ? t.attributeNewValue : null, m = this.placeholder, g = i.editing.mapper.toViewElement(s), b = n.writer;
          if (f == "reading")
            return Xd(g, b), void Qd(m, g, b);
          if (f == "uploading") {
            const y = d.loaders.get(l);
            return Xd(g, b), void (y ? (Jd(g, b), function(C, O, D, oe) {
              const ce = function(_e) {
                const De = _e.createUIElement("div", { class: "ck-progress-bar" });
                return _e.setCustomProperty("progressBar", !0, De), De;
              }(O);
              O.insert(O.createPositionAt(C, "end"), ce), D.on("change:uploadedPercent", (_e, De, mt) => {
                oe.change((di) => {
                  di.setStyle("width", mt + "%", ce);
                });
              });
            }(g, b, y, i.editing.view), function(C, O, D) {
              if (D.data) {
                const oe = C.getChild(0);
                O.setAttribute("src", D.data, oe);
              }
            }(g, b, y)) : Qd(m, g, b));
          }
          f == "complete" && d.loaders.get(l) && !un.isEdge && function(y, C, O) {
            const D = C.createUIElement("div", { class: "ck-image-upload-complete-icon" });
            C.insert(C.createPositionAt(y, "end"), D), setTimeout(() => {
              O.change((oe) => oe.remove(oe.createRangeOn(D)));
            }, 3e3);
          }(g, b, i.editing.view), function(y, C) {
            th(y, C, "progressBar");
          }(g, b), Jd(g, b), function(y, C) {
            C.removeClass("ck-appear", y);
          }(g, b);
        }
      }
      function Xd(o, e) {
        o.hasClass("ck-appear") || e.addClass("ck-appear", o);
      }
      function Qd(o, e, t) {
        e.hasClass("ck-image-upload-placeholder") || t.addClass("ck-image-upload-placeholder", e);
        const n = e.getChild(0);
        n.getAttribute("src") !== o && t.setAttribute("src", o, n), eh(e, "placeholder") || t.insert(t.createPositionAfter(n), function(i) {
          const s = i.createUIElement("div", { class: "ck-upload-placeholder-loader" });
          return i.setCustomProperty("placeholder", !0, s), s;
        }(t));
      }
      function Jd(o, e) {
        o.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", o), th(o, e, "placeholder");
      }
      function eh(o, e) {
        for (const t of o.getChildren())
          if (t.getCustomProperty(e))
            return t;
      }
      function th(o, e, t) {
        const n = eh(o, t);
        n && e.remove(e.createRangeOn(n));
      }
      class Io {
        createDocumentFragment(e) {
          return new Li(e);
        }
        createElement(e, t, n) {
          return new tn(e, t, n);
        }
        createText(e) {
          return new rt(e);
        }
        clone(e, t = !1) {
          return e._clone(t);
        }
        appendChild(e, t) {
          return t._appendChild(e);
        }
        insertChild(e, t, n) {
          return n._insertChild(e, t);
        }
        removeChildren(e, t, n) {
          return n._removeChildren(e, t);
        }
        remove(e) {
          const t = e.parent;
          return t ? this.removeChildren(t.getChildIndex(e), 1, t) : [];
        }
        replace(e, t) {
          const n = e.parent;
          if (n) {
            const i = n.getChildIndex(e);
            return this.removeChildren(i, 1, n), this.insertChild(i, t, n), !0;
          }
          return !1;
        }
        unwrapElement(e) {
          const t = e.parent;
          if (t) {
            const n = t.getChildIndex(e);
            this.remove(e), this.insertChild(n, e.getChildren(), t);
          }
        }
        rename(e, t) {
          const n = new tn(e, t.getAttributes(), t.getChildren());
          return this.replace(t, n) ? n : null;
        }
        setAttribute(e, t, n) {
          n._setAttribute(e, t);
        }
        removeAttribute(e, t) {
          t._removeAttribute(e);
        }
        addClass(e, t) {
          t._addClass(e);
        }
        removeClass(e, t) {
          t._removeClass(e);
        }
        setStyle(e, t, n) {
          _(e) && n === void 0 && (n = t), n._setStyle(e, t);
        }
        removeStyle(e, t) {
          t._removeStyle(e);
        }
        setCustomProperty(e, t, n) {
          n._setCustomProperty(e, t);
        }
        removeCustomProperty(e, t) {
          return t._removeCustomProperty(e);
        }
        createPositionAt(e, t) {
          return be._createAt(e, t);
        }
        createPositionAfter(e) {
          return be._createAfter(e);
        }
        createPositionBefore(e) {
          return be._createBefore(e);
        }
        createRange(e, t) {
          return new ze(e, t);
        }
        createRangeOn(e) {
          return ze._createOn(e);
        }
        createRangeIn(e) {
          return ze._createIn(e);
        }
        createSelection(e, t, n) {
          return new bn(e, t, n);
        }
      }
      class rw extends Xe {
        refresh() {
          this.isEnabled = Hd(this.editor.model);
        }
        execute(e) {
          const t = this.editor, n = t.model, i = t.plugins.get(Ln);
          n.change((s) => {
            const l = Array.isArray(e.file) ? e.file : [e.file];
            for (const d of l)
              ow(s, n, i, d);
          });
        }
      }
      function ow(o, e, t, n) {
        const i = t.createLoader(n);
        i && Ud(o, e, { uploadId: i.id });
      }
      class sw extends Ae {
        static get requires() {
          return [Ln, ga];
        }
        init() {
          const e = this.editor, t = e.model.document, n = e.model.schema, i = e.conversion, s = e.plugins.get(Ln);
          n.extend("image", { allowAttributes: ["uploadId", "uploadStatus"] }), e.commands.add("imageUpload", new rw(e)), i.for("upcast").attributeToAttribute({ view: { name: "img", key: "uploadId" }, model: "uploadId" }), this.listenTo(e.editing.view.document, "clipboardInput", (l, d) => {
            if (function(g) {
              return Array.from(g.types).includes("text/html") && g.getData("text/html") !== "";
            }(d.dataTransfer))
              return;
            const f = Array.from(d.dataTransfer.files).filter((g) => !!g && Kd(g)), m = d.targetRanges.map((g) => e.editing.mapper.toModelRange(g));
            e.model.change((g) => {
              g.setSelection(m), f.length && (l.stop(), e.model.enqueueChange("default", () => {
                e.execute("imageUpload", { file: f });
              }));
            });
          }), e.plugins.has("Clipboard") && this.listenTo(e.plugins.get("Clipboard"), "inputTransformation", (l, d) => {
            const f = Array.from(e.editing.view.createRangeIn(d.content)).filter((g) => function(b) {
              return !(!b.is("element", "img") || !b.getAttribute("src")) && (b.getAttribute("src").match(/^data:image\/\w+;base64,/g) || b.getAttribute("src").match(/^blob:/g));
            }(g.item) && !g.item.getAttribute("uploadProcessed")).map((g) => ({ promise: ew(g.item), imageElement: g.item }));
            if (!f.length)
              return;
            const m = new Io();
            for (const g of f) {
              m.setAttribute("uploadProcessed", !0, g.imageElement);
              const b = s.createLoader(g.promise);
              b && (m.setAttribute("src", "", g.imageElement), m.setAttribute("uploadId", b.id, g.imageElement));
            }
          }), e.editing.view.document.on("dragover", (l, d) => {
            d.preventDefault();
          }), t.on("change", () => {
            const l = t.differ.getChanges({ includeChangesInGraveyard: !0 });
            for (const d of l)
              if (d.type == "insert" && d.name != "$text") {
                const f = d.position.nodeAfter, m = d.position.root.rootName == "$graveyard";
                for (const g of aw(e, f)) {
                  const b = g.getAttribute("uploadId");
                  if (!b)
                    continue;
                  const y = s.loaders.get(b);
                  y && (m ? y.abort() : y.status == "idle" && this._readAndUpload(y, g));
                }
              }
          });
        }
        _readAndUpload(e, t) {
          const n = this.editor, i = n.model, s = n.locale.t, l = n.plugins.get(Ln), d = n.plugins.get(ga);
          return i.enqueueChange("transparent", (m) => {
            m.setAttribute("uploadStatus", "reading", t);
          }), e.read().then(() => {
            const m = e.upload();
            if (un.isSafari) {
              const g = n.editing.mapper.toViewElement(t).getChild(0);
              n.editing.view.once("render", () => {
                if (!g.parent)
                  return;
                const b = n.editing.view.domConverter.mapViewToDom(g.parent);
                if (!b)
                  return;
                const y = b.style.display;
                b.style.display = "none", b._ckHack = b.offsetHeight, b.style.display = y;
              });
            }
            return i.enqueueChange("transparent", (g) => {
              g.setAttribute("uploadStatus", "uploading", t);
            }), m;
          }).then((m) => {
            i.enqueueChange("transparent", (g) => {
              g.setAttributes({ uploadStatus: "complete", src: m.default }, t), this._parseAndSetSrcsetAttributeOnImage(m, t, g);
            }), f();
          }).catch((m) => {
            if (e.status !== "error" && e.status !== "aborted")
              throw m;
            e.status == "error" && m && d.showWarning(m, { title: s("ar"), namespace: "upload" }), f(), i.enqueueChange("transparent", (g) => {
              g.remove(t);
            });
          });
          function f() {
            i.enqueueChange("transparent", (m) => {
              m.removeAttribute("uploadId", t), m.removeAttribute("uploadStatus", t);
            }), l.destroyLoader(e);
          }
        }
        _parseAndSetSrcsetAttributeOnImage(e, t, n) {
          let i = 0;
          const s = Object.keys(e).filter((l) => {
            const d = parseInt(l, 10);
            if (!isNaN(d))
              return i = Math.max(i, d), !0;
          }).map((l) => `${e[l]} ${l}w`).join(", ");
          s != "" && n.setAttribute("srcset", { data: s, width: i }, t);
        }
      }
      function aw(o, e) {
        return Array.from(o.model.createRangeOn(e)).filter((t) => t.item.is("image")).map((t) => t.item);
      }
      class nh extends Ae {
        static get pluginName() {
          return "ImageUpload";
        }
        static get requires() {
          return [sw, tw, iw];
        }
      }
      class lw extends Xe {
        refresh() {
          const e = this.editor.model, t = Rn(e.document.selection.getSelectedBlocks());
          this.value = !!t && t.is("paragraph"), this.isEnabled = !!t && ih(t, e.schema);
        }
        execute(e = {}) {
          const t = this.editor.model, n = t.document;
          t.change((i) => {
            const s = (e.selection || n.selection).getSelectedBlocks();
            for (const l of s)
              !l.is("paragraph") && ih(l, t.schema) && i.rename(l, "paragraph");
          });
        }
      }
      function ih(o, e) {
        return e.checkChild(o.parent, "paragraph") && !e.isObject(o);
      }
      class qi extends Ae {
        static get pluginName() {
          return "Paragraph";
        }
        init() {
          const e = this.editor, t = e.model, n = e.data;
          e.commands.add("paragraph", new lw(e)), t.schema.register("paragraph", { inheritAllFrom: "$block" }), e.conversion.elementToElement({ model: "paragraph", view: "p" }), e.conversion.for("upcast").elementToElement({ model: (i, s) => qi.paragraphLikeElements.has(i.name) ? i.isEmpty ? null : s.createElement("paragraph") : null, converterPriority: "low" }), n.upcastDispatcher.on("element", (i, s, l) => {
            l.consumable.test(s.viewItem, { name: s.viewItem.name }) && oh(s.viewItem, s.modelCursor, l.schema) && Object.assign(s, rh(s.viewItem, s.modelCursor, l));
          }, { priority: "low" }), n.upcastDispatcher.on("text", (i, s, l) => {
            s.modelRange || oh(s.viewItem, s.modelCursor, l.schema) && Object.assign(s, rh(s.viewItem, s.modelCursor, l));
          }, { priority: "lowest" }), t.document.registerPostFixer((i) => this._autoparagraphEmptyRoots(i)), e.data.on("ready", () => {
            t.enqueueChange("transparent", (i) => this._autoparagraphEmptyRoots(i));
          }, { priority: "lowest" });
        }
        _autoparagraphEmptyRoots(e) {
          const t = this.editor.model;
          for (const n of t.document.getRootNames()) {
            const i = t.document.getRoot(n);
            if (i.isEmpty && i.rootName != "$graveyard" && t.schema.checkChild(i, "paragraph"))
              return e.insertElement("paragraph", i), !0;
          }
        }
      }
      function rh(o, e, t) {
        const n = t.writer.createElement("paragraph");
        return t.writer.insert(n, e), t.convertItem(o, t.writer.createPositionAt(n, 0));
      }
      function oh(o, e, t) {
        const n = t.createContext(e);
        return !!t.checkChild(n, "paragraph") && !!t.checkChild(n.push("paragraph"), o);
      }
      qi.paragraphLikeElements = /* @__PURE__ */ new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td"]);
      class cw extends Xe {
        constructor(e, t) {
          super(e), this.modelElements = t;
        }
        refresh() {
          const e = Rn(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!e && this.modelElements.includes(e.name) && e.name, this.isEnabled = !!e && this.modelElements.some((t) => sh(e, t, this.editor.model.schema));
        }
        execute(e) {
          const t = this.editor.model, n = t.document, i = e.value;
          t.change((s) => {
            const l = Array.from(n.selection.getSelectedBlocks()).filter((d) => sh(d, i, t.schema));
            for (const d of l)
              d.is(i) || s.rename(d, i);
          });
        }
      }
      function sh(o, e, t) {
        return t.checkChild(o.parent, e) && !t.isObject(o);
      }
      const Pa = "paragraph";
      class uw extends Ae {
        constructor(e) {
          super(e), e.config.define("heading", { options: [{ model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" }, { model: "heading1", view: "h2", title: "Heading 1", class: "ck-heading_heading1" }, { model: "heading2", view: "h3", title: "Heading 2", class: "ck-heading_heading2" }, { model: "heading3", view: "h4", title: "Heading 3", class: "ck-heading_heading3" }] });
        }
        static get requires() {
          return [qi];
        }
        init() {
          const e = this.editor, t = e.config.get("heading.options"), n = [];
          for (const i of t)
            i.model !== Pa && (e.model.schema.register(i.model, { inheritAllFrom: "$block" }), e.conversion.elementToElement(i), n.push(i.model));
          this._addDefaultH1Conversion(e), e.commands.add("heading", new cw(e, n));
        }
        afterInit() {
          const e = this.editor, t = e.commands.get("enter"), n = e.config.get("heading.options");
          t && this.listenTo(t, "afterExecute", (i, s) => {
            const l = e.model.document.selection.getFirstPosition().parent;
            n.some((d) => l.is(d.model)) && !l.is(Pa) && l.childCount === 0 && s.writer.rename(l, Pa);
          });
        }
        _addDefaultH1Conversion(e) {
          e.conversion.for("upcast").elementToElement({ model: "heading1", view: "h1", converterPriority: xs.get("low") + 1 });
        }
      }
      class Ma {
        constructor(e, t) {
          t && Ri(this, t), e && this.set(e);
        }
      }
      $e(Ma, xt), p(10);
      class dw extends Ae {
        init() {
          const e = this.editor, t = e.t, n = function(l) {
            const d = l.t, f = { Paragraph: d("bd"), "Heading 1": d("be"), "Heading 2": d("bf"), "Heading 3": d("bg"), "Heading 4": d("bh"), "Heading 5": d("bi"), "Heading 6": d("bj") };
            return l.config.get("heading.options").map((m) => {
              const g = f[m.title];
              return g && g != m.title && (m.title = g), m;
            });
          }(e), i = t("n"), s = t("o");
          e.ui.componentFactory.add("heading", (l) => {
            const d = {}, f = new _n(), m = e.commands.get("heading"), g = e.commands.get("paragraph"), b = [m];
            for (const C of n) {
              const O = { type: "button", model: new Ma({ label: C.title, class: C.class, withText: !0 }) };
              C.model === "paragraph" ? (O.model.bind("isOn").to(g, "value"), O.model.set("commandName", "paragraph"), b.push(g)) : (O.model.bind("isOn").to(m, "value", (D) => D === C.model), O.model.set({ commandName: "heading", commandValue: C.model })), f.add(O), d[C.model] = C.title;
            }
            const y = wr(l);
            return od(y, f), y.buttonView.set({ isOn: !1, withText: !0, tooltip: s }), y.extendTemplate({ attributes: { class: ["ck-heading-dropdown"] } }), y.bind("isEnabled").toMany(b, "isEnabled", (...C) => C.some((O) => O)), y.buttonView.bind("label").to(m, "value", g, "value", (C, O) => {
              const D = C || O && "paragraph";
              return d[D] ? d[D] : i;
            }), this.listenTo(y, "execute", (C) => {
              e.execute(C.source.commandName, C.source.commandValue ? { value: C.source.commandValue } : void 0), e.editing.view.focus();
            }), y;
          });
        }
      }
      function Oa(o) {
        for (const e of o.getChildren())
          if (e && e.is("caption"))
            return e;
        return null;
      }
      function hw(o) {
        const e = o.parent;
        return o.name == "figcaption" && e && e.name == "figure" && e.hasClass("image") ? { name: !0 } : null;
      }
      class fw extends Ae {
        init() {
          const e = this.editor, t = e.editing.view, n = e.model.schema, i = e.data, s = e.editing, l = e.t;
          n.register("caption", { allowIn: "image", allowContentOf: "$block", isLimit: !0 }), e.model.document.registerPostFixer((f) => this._insertMissingModelCaptionElement(f)), e.conversion.for("upcast").elementToElement({ view: hw, model: "caption" }), i.downcastDispatcher.on("insert:caption", ah((f) => f.createContainerElement("figcaption"), !1));
          const d = function(f, m) {
            return (g) => {
              const b = g.createEditableElement("figcaption");
              return g.setCustomProperty("imageCaption", !0, b), ju({ view: f, element: b, text: m }), ya(b, g);
            };
          }(t, l("aq"));
          s.downcastDispatcher.on("insert:caption", ah(d)), s.downcastDispatcher.on("insert", this._fixCaptionVisibility((f) => f.item), { priority: "high" }), s.downcastDispatcher.on("remove", this._fixCaptionVisibility((f) => f.position.parent), { priority: "high" }), t.document.registerPostFixer((f) => this._updateCaptionVisibility(f));
        }
        _updateCaptionVisibility(e) {
          const t = this.editor.editing.mapper, n = this._lastSelectedCaption;
          let i;
          const s = this.editor.model.document.selection, l = s.getSelectedElement();
          if (l && l.is("image")) {
            const f = Oa(l);
            i = t.toViewElement(f);
          }
          const d = lh(s.getFirstPosition().parent);
          if (d && (i = t.toViewElement(d)), i)
            return n ? (n === i || (ch(n, e), this._lastSelectedCaption = i), Da(i, e)) : (this._lastSelectedCaption = i, Da(i, e));
          if (n) {
            const f = ch(n, e);
            return this._lastSelectedCaption = null, f;
          }
          return !1;
        }
        _fixCaptionVisibility(e) {
          return (t, n, i) => {
            const s = lh(e(n)), l = this.editor.editing.mapper, d = i.writer;
            if (s) {
              const f = l.toViewElement(s);
              f && (s.childCount ? d.removeClass("ck-hidden", f) : d.addClass("ck-hidden", f));
            }
          };
        }
        _insertMissingModelCaptionElement(e) {
          const t = this.editor.model, n = t.document.differ.getChanges(), i = [];
          for (const s of n)
            if (s.type == "insert" && s.name != "$text") {
              const l = s.position.nodeAfter;
              if (l.is("image") && !Oa(l) && i.push(l), !l.is("image") && l.childCount)
                for (const d of t.createRangeIn(l).getItems())
                  d.is("image") && !Oa(d) && i.push(d);
            }
          for (const s of i)
            e.appendElement("caption", s);
          return !!i.length;
        }
      }
      function ah(o, e = !0) {
        return (t, n, i) => {
          const s = n.item;
          if ((s.childCount || e) && Co(s.parent)) {
            if (!i.consumable.consume(n.item, "insert"))
              return;
            const l = i.mapper.toViewElement(n.range.start.parent), d = o(i.writer), f = i.writer;
            s.childCount || f.addClass("ck-hidden", d), function(m, g, b, y) {
              const C = y.writer.createPositionAt(b, "end");
              y.writer.insert(C, m), y.mapper.bindElements(g, m);
            }(d, n.item, l, i);
          }
        };
      }
      function lh(o) {
        const e = o.getAncestors({ includeSelf: !0 }).find((t) => t.name == "caption");
        return e && e.parent && e.parent.name == "image" ? e : null;
      }
      function ch(o, e) {
        return !o.childCount && !o.hasClass("ck-hidden") && (e.addClass("ck-hidden", o), !0);
      }
      function Da(o, e) {
        return !!o.hasClass("ck-hidden") && (e.removeClass("ck-hidden", o), !0);
      }
      p(69);
      class pw extends Xe {
        constructor(e, t) {
          super(e), this.defaultStyle = !1, this.styles = t.reduce((n, i) => (n[i.name] = i, i.isDefault && (this.defaultStyle = i.name), n), {});
        }
        refresh() {
          const e = this.editor.model.document.selection.getSelectedElement();
          if (this.isEnabled = Co(e), e)
            if (e.hasAttribute("imageStyle")) {
              const t = e.getAttribute("imageStyle");
              this.value = !!this.styles[t] && t;
            } else
              this.value = this.defaultStyle;
          else
            this.value = !1;
        }
        execute(e) {
          const t = e.value, n = this.editor.model, i = n.document.selection.getSelectedElement();
          n.change((s) => {
            this.styles[t].isDefault ? s.removeAttribute("imageStyle", i) : s.setAttribute("imageStyle", t, i);
          });
        }
      }
      function uh(o, e) {
        for (const t of e)
          if (t.name === o)
            return t;
      }
      var dh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>', hh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>', fh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>', Na = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
      const Eo = { full: { name: "full", title: "Full size image", icon: dh, isDefault: !0 }, side: { name: "side", title: "Side image", icon: Na, className: "image-style-side" }, alignLeft: { name: "alignLeft", title: "Left aligned image", icon: hh, className: "image-style-align-left" }, alignCenter: { name: "alignCenter", title: "Centered image", icon: fh, className: "image-style-align-center" }, alignRight: { name: "alignRight", title: "Right aligned image", icon: Na, className: "image-style-align-right" } }, ph = { full: dh, left: hh, right: Na, center: fh };
      function mh(o = []) {
        return o.map(mw);
      }
      function mw(o) {
        if (typeof o == "string") {
          const e = o;
          Eo[e] ? o = Object.assign({}, Eo[e]) : (console.warn(Object(V.a)("image-style-not-found: There is no such image style of given name."), { name: e }), o = { name: e });
        } else if (Eo[o.name]) {
          const e = Eo[o.name], t = Object.assign({}, o);
          for (const n in e)
            o.hasOwnProperty(n) || (t[n] = e[n]);
          o = t;
        }
        return typeof o.icon == "string" && ph[o.icon] && (o.icon = ph[o.icon]), o;
      }
      class gw extends Ae {
        static get pluginName() {
          return "ImageStyleEditing";
        }
        init() {
          const e = this.editor, t = e.model.schema, n = e.data, i = e.editing;
          e.config.define("image.styles", ["full", "side"]);
          const s = mh(e.config.get("image.styles"));
          t.extend("image", { allowAttributes: "imageStyle" });
          const l = function(d) {
            return (f, m, g) => {
              if (!g.consumable.consume(m.item, f.name))
                return;
              const b = uh(m.attributeNewValue, d), y = uh(m.attributeOldValue, d), C = g.mapper.toViewElement(m.item), O = g.writer;
              y && O.removeClass(y.className, C), b && O.addClass(b.className, C);
            };
          }(s);
          i.downcastDispatcher.on("attribute:imageStyle:image", l), n.downcastDispatcher.on("attribute:imageStyle:image", l), n.upcastDispatcher.on("element:figure", function(d) {
            const f = d.filter((m) => !m.isDefault);
            return (m, g, b) => {
              if (!g.modelRange)
                return;
              const y = g.viewItem, C = Rn(g.modelRange.getItems());
              if (b.schema.checkAttribute(C, "imageStyle"))
                for (const O of f)
                  b.consumable.consume(y, { classes: O.className }) && b.writer.setAttribute("imageStyle", O.name, C);
            };
          }(s), { priority: "low" }), e.commands.add("imageStyle", new pw(e, s));
        }
      }
      p(71);
      class vw extends Ae {
        static get pluginName() {
          return "ImageStyleUI";
        }
        get localizedDefaultStylesTitles() {
          const e = this.editor.t;
          return { "Full size image": e("q"), "Side image": e("r"), "Left aligned image": e("s"), "Centered image": e("t"), "Right aligned image": e("u") };
        }
        init() {
          const e = function(t, n) {
            for (const i of t)
              n[i.title] && (i.title = n[i.title]);
            return t;
          }(mh(this.editor.config.get("image.styles")), this.localizedDefaultStylesTitles);
          for (const t of e)
            this._createButton(t);
        }
        _createButton(e) {
          const t = this.editor, n = `imageStyle:${e.name}`;
          t.ui.componentFactory.add(n, (i) => {
            const s = t.commands.get("imageStyle"), l = new kt(i);
            return l.set({ label: e.title, icon: e.icon, tooltip: !0, isToggleable: !0 }), l.bind("isEnabled").to(s, "isEnabled"), l.bind("isOn").to(s, "value", (d) => d === e.name), this.listenTo(l, "execute", () => t.execute("imageStyle", { value: e.name })), l;
          });
        }
      }
      class Po extends Ae {
        static get requires() {
          return [To];
        }
        static get pluginName() {
          return "WidgetToolbarRepository";
        }
        init() {
          const e = this.editor;
          if (e.plugins.has("BalloonToolbar")) {
            const t = e.plugins.get("BalloonToolbar");
            this.listenTo(t, "show", (n) => {
              (function(i) {
                const s = i.getSelectedElement();
                return !(!s || !ui(s));
              })(e.editing.view.document.selection) && n.stop();
            }, { priority: "high" });
          }
          this._toolbarDefinitions = /* @__PURE__ */ new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.listenTo(e.ui, "update", () => {
            this._updateToolbarsVisibility();
          }), this.listenTo(e.ui.focusTracker, "change:isFocused", () => {
            this._updateToolbarsVisibility();
          }, { priority: "low" });
        }
        destroy() {
          super.destroy();
          for (const e of this._toolbarDefinitions.values())
            e.view.destroy();
        }
        register(e, { ariaLabel: t, items: n, getRelatedElement: i, balloonClassName: s = "ck-toolbar-container" }) {
          const l = this.editor, d = l.t, f = new ra(l.locale);
          if (f.ariaLabel = t || d("ax"), this._toolbarDefinitions.has(e))
            throw new V.b("widget-toolbar-duplicated: Toolbar with the given id was already added.", this, { toolbarId: e });
          f.fillFromConfig(n, l.ui.componentFactory), this._toolbarDefinitions.set(e, { view: f, getRelatedElement: i, balloonClassName: s });
        }
        _updateToolbarsVisibility() {
          let e = 0, t = null, n = null;
          for (const i of this._toolbarDefinitions.values()) {
            const s = i.getRelatedElement(this.editor.editing.view.document.selection);
            if (this.editor.ui.focusTracker.isFocused)
              if (s) {
                const l = s.getAncestors().length;
                l > e && (e = l, t = s, n = i);
              } else
                this._isToolbarInBalloon(i) && this._hideToolbar(i);
            else
              this._isToolbarVisible(i) && this._hideToolbar(i);
          }
          n && this._showToolbar(n, t);
        }
        _hideToolbar(e) {
          this._balloon.remove(e.view), this.stopListening(this._balloon, "change:visibleView");
        }
        _showToolbar(e, t) {
          this._isToolbarVisible(e) ? gh(this.editor, t) : this._isToolbarInBalloon(e) || (this._balloon.add({ view: e.view, position: vh(this.editor, t), balloonClassName: e.balloonClassName }), this.listenTo(this._balloon, "change:visibleView", () => {
            for (const n of this._toolbarDefinitions.values())
              if (this._isToolbarVisible(n)) {
                const i = n.getRelatedElement(this.editor.editing.view.document.selection);
                gh(this.editor, i);
              }
          }));
        }
        _isToolbarVisible(e) {
          return this._balloon.visibleView === e.view;
        }
        _isToolbarInBalloon(e) {
          return this._balloon.hasView(e.view);
        }
      }
      function gh(o, e) {
        const t = o.plugins.get("ContextualBalloon"), n = vh(o, e);
        t.updatePosition(n);
      }
      function vh(o, e) {
        const t = o.editing.view, n = ft.defaultPositions;
        return { target: t.domConverter.mapViewToDom(e), positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast] };
      }
      function Ra(o, e, t) {
        return t.createRange(bh(o, e, !0, t), bh(o, e, !1, t));
      }
      function bh(o, e, t, n) {
        let i = o.textNode || (t ? o.nodeBefore : o.nodeAfter), s = null;
        for (; i && i.getAttribute("linkHref") == e; )
          s = i, i = t ? i.previousSibling : i.nextSibling;
        return s ? n.createPositionAt(s, t ? "before" : "after") : o;
      }
      class bw extends Xe {
        constructor(e) {
          super(e), this.manualDecorators = new _n();
        }
        restoreManualDecoratorStates() {
          for (const e of this.manualDecorators)
            e.value = this._getDecoratorStateFromModel(e.id);
        }
        refresh() {
          const e = this.editor.model, t = e.document;
          this.value = t.selection.getAttribute("linkHref");
          for (const n of this.manualDecorators)
            n.value = this._getDecoratorStateFromModel(n.id);
          this.isEnabled = e.schema.checkAttributeInSelection(t.selection, "linkHref");
        }
        execute(e, t = {}) {
          const n = this.editor.model, i = n.document.selection, s = [], l = [];
          for (const d in t)
            t[d] ? s.push(d) : l.push(d);
          n.change((d) => {
            if (i.isCollapsed) {
              const f = i.getFirstPosition();
              if (i.hasAttribute("linkHref")) {
                const m = Ra(f, i.getAttribute("linkHref"), n);
                d.setAttribute("linkHref", e, m), s.forEach((g) => {
                  d.setAttribute(g, !0, m);
                }), l.forEach((g) => {
                  d.removeAttribute(g, m);
                }), d.setSelection(m);
              } else if (e !== "") {
                const m = xi(i.getAttributes());
                m.set("linkHref", e), s.forEach((b) => {
                  m.set(b, !0);
                });
                const g = d.createText(e, m);
                n.insertContent(g, f), d.setSelection(d.createRangeOn(g));
              }
            } else {
              const f = n.schema.getValidRanges(i.getRanges(), "linkHref");
              for (const m of f)
                d.setAttribute("linkHref", e, m), s.forEach((g) => {
                  d.setAttribute(g, !0, m);
                }), l.forEach((g) => {
                  d.removeAttribute(g, m);
                });
            }
          });
        }
        _getDecoratorStateFromModel(e) {
          return this.editor.model.document.selection.getAttribute(e) || !1;
        }
      }
      class _w extends Xe {
        refresh() {
          this.isEnabled = this.editor.model.document.selection.hasAttribute("linkHref");
        }
        execute() {
          const e = this.editor, t = this.editor.model, n = t.document.selection, i = e.commands.get("link");
          t.change((s) => {
            const l = n.isCollapsed ? [Ra(n.getFirstPosition(), n.getAttribute("linkHref"), t)] : n.getRanges();
            for (const d of l)
              if (s.removeAttribute("linkHref", d), i)
                for (const f of i.manualDecorators)
                  s.removeAttribute(f.id, d);
          });
        }
      }
      var ww = function(o, e, t) {
        var n = -1, i = o.length;
        e < 0 && (e = -e > i ? 0 : i + e), (t = t > i ? i : t) < 0 && (t += i), i = e > t ? 0 : t - e >>> 0, e >>>= 0;
        for (var s = Array(i); ++n < i; )
          s[n] = o[n + e];
        return s;
      }, yw = function(o, e, t) {
        var n = o.length;
        return t = t === void 0 ? n : t, !e && t >= n ? o : ww(o, e, t);
      }, kw = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"), _h = function(o) {
        return kw.test(o);
      }, xw = function(o) {
        return o.split("");
      }, Sw = "[\\ud800-\\udfff]", La = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", Fa = "\\ud83c[\\udffb-\\udfff]", wh = "[^\\ud800-\\udfff]", yh = "(?:\\ud83c[\\udde6-\\uddff]){2}", kh = "[\\ud800-\\udbff][\\udc00-\\udfff]", xh = "(?:" + La + "|" + Fa + ")?", Cw = "[\\ufe0e\\ufe0f]?" + xh + ("(?:\\u200d(?:" + [wh, yh, kh].join("|") + ")[\\ufe0e\\ufe0f]?" + xh + ")*"), Aw = "(?:" + [wh + La + "?", La, yh, kh, Sw].join("|") + ")", Tw = RegExp(Fa + "(?=" + Fa + ")|" + Aw + Cw, "g"), Iw = function(o) {
        return o.match(Tw) || [];
      }, Ew = function(o) {
        return _h(o) ? Iw(o) : xw(o);
      }, Pw = function(o, e) {
        for (var t = -1, n = o == null ? 0 : o.length, i = Array(n); ++t < n; )
          i[t] = e(o[t], t, o);
        return i;
      }, Mw = 1 / 0, Sh = v ? v.prototype : void 0, Ch = Sh ? Sh.toString : void 0, Ow = function o(e) {
        if (typeof e == "string")
          return e;
        if (En(e))
          return Pw(e, o) + "";
        if (jc(e))
          return Ch ? Ch.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -Mw ? "-0" : t;
      }, Dw = function(o) {
        return o == null ? "" : Ow(o);
      }, Nw = function(o) {
        return function(e) {
          e = Dw(e);
          var t = _h(e) ? Ew(e) : void 0, n = t ? t[0] : e.charAt(0), i = t ? yw(t, 1).join("") : e.slice(1);
          return n[o]() + i;
        };
      }("toUpperCase");
      const Rw = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, Lw = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;
      function Ah(o, e) {
        const t = e.createAttributeElement("a", { href: o }, { priority: 5 });
        return e.setCustomProperty("link", !0, t), t;
      }
      function Th(o) {
        return function(e) {
          return e.replace(Rw, "").match(Lw);
        }(o = String(o)) ? o : "#";
      }
      class Fw {
        constructor() {
          this._definitions = /* @__PURE__ */ new Set();
        }
        get length() {
          return this._definitions.size;
        }
        add(e) {
          Array.isArray(e) ? e.forEach((t) => this._definitions.add(t)) : this._definitions.add(e);
        }
        getDispatcher() {
          return (e) => {
            e.on("attribute:linkHref", (t, n, i) => {
              if (!i.consumable.test(n.item, "attribute:linkHref"))
                return;
              const s = i.writer, l = s.document.selection;
              for (const d of this._definitions) {
                const f = s.createAttributeElement("a", d.attributes, { priority: 5 });
                s.setCustomProperty("link", !0, f), d.callback(n.attributeNewValue) ? n.item.is("selection") ? s.wrap(l.getFirstRange(), f) : s.wrap(i.mapper.toViewRange(n.range), f) : s.unwrap(i.mapper.toViewRange(n.range), f);
              }
            }, { priority: "high" });
          };
        }
      }
      class Ih {
        constructor({ id: e, label: t, attributes: n }) {
          this.id = e, this.set("value"), this.label = t, this.attributes = n;
        }
      }
      $e(Ih, xt);
      class zw {
        constructor(e, t, n) {
          this.model = e, this.attribute = n, this._modelSelection = e.document.selection, this._overrideUid = null, this._isNextGravityRestorationSkipped = !1, t.listenTo(this._modelSelection, "change:range", (i, s) => {
            this._isNextGravityRestorationSkipped ? this._isNextGravityRestorationSkipped = !1 : this._isGravityOverridden && (!s.directChange && Eh(this._modelSelection.getFirstPosition(), n) || this._restoreGravity());
          });
        }
        handleForwardMovement(e, t) {
          const n = this.attribute;
          if (!(this._isGravityOverridden || e.isAtStart && this._hasSelectionAttribute))
            return $a(e, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(t), this._removeSelectionAttribute(), !0) : Ph(e, n) ? (this._preventCaretMovement(t), this._overrideGravity(), !0) : za(e, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(t), this._overrideGravity(), !0) : void 0;
        }
        handleBackwardMovement(e, t) {
          const n = this.attribute;
          return this._isGravityOverridden ? $a(e, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(t), this._restoreGravity(), this._removeSelectionAttribute(), !0) : (this._preventCaretMovement(t), this._restoreGravity(), e.isAtStart && this._removeSelectionAttribute(), !0) : $a(e, n) && !this._hasSelectionAttribute ? (this._preventCaretMovement(t), this._setSelectionAttributeFromTheNodeBefore(e), !0) : e.isAtEnd && za(e, n) ? this._hasSelectionAttribute ? void (Mh(e, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity())) : (this._preventCaretMovement(t), this._setSelectionAttributeFromTheNodeBefore(e), !0) : e.isAtStart ? this._hasSelectionAttribute ? (this._removeSelectionAttribute(), this._preventCaretMovement(t), !0) : void 0 : void (Mh(e, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity()));
        }
        get _isGravityOverridden() {
          return !!this._overrideUid;
        }
        get _hasSelectionAttribute() {
          return this._modelSelection.hasAttribute(this.attribute);
        }
        _overrideGravity() {
          this._overrideUid = this.model.change((e) => e.overrideSelectionGravity());
        }
        _restoreGravity() {
          this.model.change((e) => {
            e.restoreSelectionGravity(this._overrideUid), this._overrideUid = null;
          });
        }
        _preventCaretMovement(e) {
          e.preventDefault();
        }
        _removeSelectionAttribute() {
          this.model.change((e) => {
            e.removeSelectionAttribute(this.attribute);
          });
        }
        _setSelectionAttributeFromTheNodeBefore(e) {
          const t = this.attribute;
          this.model.change((n) => {
            n.setSelectionAttribute(this.attribute, e.nodeBefore.getAttribute(t));
          });
        }
        _skipNextAutomaticGravityRestoration() {
          this._isNextGravityRestorationSkipped = !0;
        }
      }
      function Eh(o, e) {
        return Ph(o, e) || za(o, e);
      }
      function Ph(o, e) {
        const { nodeBefore: t, nodeAfter: n } = o, i = !!t && t.hasAttribute(e);
        return !!n && n.hasAttribute(e) && (!i || t.getAttribute(e) !== n.getAttribute(e));
      }
      function za(o, e) {
        const { nodeBefore: t, nodeAfter: n } = o, i = !!t && t.hasAttribute(e), s = !!n && n.hasAttribute(e);
        return i && (!s || t.getAttribute(e) !== n.getAttribute(e));
      }
      function $a(o, e) {
        const { nodeBefore: t, nodeAfter: n } = o, i = !!t && t.hasAttribute(e);
        if (!!n && n.hasAttribute(e) && i)
          return n.getAttribute(e) !== t.getAttribute(e);
      }
      function Mh(o, e) {
        return Eh(o.getShiftedBy(-1), e);
      }
      p(73);
      const ja = "ck-link_selected", Oh = "automatic", $w = "manual", jw = /^(https?:)?\/\//;
      class Bw extends Ae {
        constructor(e) {
          super(e), e.config.define("link", { addTargetToExternalLinks: !1 });
        }
        init() {
          const e = this.editor, t = e.locale;
          e.model.schema.extend("$text", { allowAttributes: "linkHref" }), e.conversion.for("dataDowncast").attributeToElement({ model: "linkHref", view: Ah }), e.conversion.for("editingDowncast").attributeToElement({ model: "linkHref", view: (i, s) => Ah(Th(i), s) }), e.conversion.for("upcast").elementToAttribute({ view: { name: "a", attributes: { href: !0 } }, model: { key: "linkHref", value: (i) => i.getAttribute("href") } }), e.commands.add("link", new bw(e)), e.commands.add("unlink", new _w(e));
          const n = function(i, s) {
            const l = { "Open in a new tab": i("by"), Downloadable: i("bz") };
            return s.forEach((d) => (d.label && l[d.label] && (d.label = l[d.label]), d)), s;
          }(e.t, function(i) {
            const s = [];
            if (i)
              for (const [l, d] of Object.entries(i)) {
                const f = Object.assign({}, d, { id: `link${Nw(l)}` });
                s.push(f);
              }
            return s;
          }(e.config.get("link.decorators")));
          this._enableAutomaticDecorators(n.filter((i) => i.mode === Oh)), this._enableManualDecorators(n.filter((i) => i.mode === $w)), function({ view: i, model: s, emitter: l, attribute: d, locale: f }) {
            const m = new zw(s, l, d), g = s.document.selection;
            l.listenTo(i.document, "keydown", (b, y) => {
              if (!g.isCollapsed || y.shiftKey || y.altKey || y.ctrlKey)
                return;
              const C = y.keyCode == tt.arrowright, O = y.keyCode == tt.arrowleft;
              if (!C && !O)
                return;
              const D = g.getFirstPosition(), oe = f.contentLanguageDirection;
              (oe === "ltr" && C || oe === "rtl" && O ? m.handleForwardMovement(D, y) : m.handleBackwardMovement(D, y)) && b.stop();
            }, { priority: xs.get("high") + 1 });
          }({ view: e.editing.view, model: e.model, emitter: this, attribute: "linkHref", locale: t }), this._setupLinkHighlight();
        }
        _enableAutomaticDecorators(e) {
          const t = this.editor, n = new Fw();
          t.config.get("link.addTargetToExternalLinks") && n.add({ id: "linkIsExternal", mode: Oh, callback: (i) => jw.test(i), attributes: { target: "_blank", rel: "noopener noreferrer" } }), n.add(e), n.length && t.conversion.for("downcast").add(n.getDispatcher());
        }
        _enableManualDecorators(e) {
          if (!e.length)
            return;
          const t = this.editor, n = t.commands.get("link").manualDecorators;
          e.forEach((i) => {
            t.model.schema.extend("$text", { allowAttributes: i.id }), n.add(new Ih(i)), t.conversion.for("downcast").attributeToElement({ model: i.id, view: (s, l) => {
              if (s) {
                const d = n.get(i.id).attributes, f = l.createAttributeElement("a", d, { priority: 5 });
                return l.setCustomProperty("link", !0, f), f;
              }
            } }), t.conversion.for("upcast").elementToAttribute({ view: { name: "a", attributes: n.get(i.id).attributes }, model: { key: i.id } });
          });
        }
        _setupLinkHighlight() {
          const e = this.editor, t = e.editing.view, n = /* @__PURE__ */ new Set();
          t.document.registerPostFixer((i) => {
            const s = e.model.document.selection;
            let l = !1;
            if (s.hasAttribute("linkHref")) {
              const d = Ra(s.getFirstPosition(), s.getAttribute("linkHref"), e.model), f = e.editing.mapper.toViewRange(d);
              for (const m of f.getItems())
                m.is("a") && !m.hasClass(ja) && (i.addClass(ja, m), n.add(m), l = !0);
            }
            return l;
          }), e.conversion.for("editingDowncast").add((i) => {
            function s() {
              t.change((l) => {
                for (const d of n.values())
                  l.removeClass(ja, d), n.delete(d);
              });
            }
            i.on("insert", s, { priority: "highest" }), i.on("remove", s, { priority: "highest" }), i.on("attribute", s, { priority: "highest" }), i.on("selection", s, { priority: "highest" });
          });
        }
      }
      class Vw extends ki {
        constructor(e) {
          super(e), this.domEventType = "click";
        }
        onDomEvent(e) {
          this.fire(e.type, e);
        }
      }
      p(75);
      class Uw extends Ge {
        constructor(e, t = []) {
          super(e);
          const n = e.t;
          this.focusTracker = new yn(), this.keystrokes = new ci(), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(n("ca"), Ta, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(n("cb"), Ia, "ck-button-cancel", "cancel"), this._manualDecoratorSwitches = this._createManualDecoratorSwitches(t), this.children = this._createFormChildren(t), this._focusables = new ji(), this._focusCycler = new Vi({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } });
          const i = ["ck", "ck-link-form"];
          t.length && i.push("ck-link-form_layout-vertical"), this.setTemplate({ tag: "form", attributes: { class: i, tabindex: "-1" }, children: this.children });
        }
        getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce((e, t) => (e[t.name] = t.isOn, e), {});
        }
        render() {
          super.render(), Aa({ view: this }), [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView].forEach((e) => {
            this._focusables.add(e), this.focusTracker.add(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        _createUrlInput() {
          const e = this.locale.t, t = new Sa(this.locale, Ca);
          return t.label = e("cd"), t.inputView.placeholder = "https://example.com", t;
        }
        _createButton(e, t, n, i) {
          const s = new kt(this.locale);
          return s.set({ label: e, icon: t, tooltip: !0 }), s.extendTemplate({ attributes: { class: n } }), i && s.delegate("execute").to(this, i), s;
        }
        _createManualDecoratorSwitches(e) {
          const t = this.createCollection();
          for (const n of e) {
            const i = new la(this.locale);
            i.set({ name: n.id, label: n.label, withText: !0 }), i.bind("isOn").to(n, "value"), i.on("execute", () => {
              n.set("value", !i.isOn);
            }), t.add(i);
          }
          return t;
        }
        _createFormChildren(e) {
          const t = this.createCollection();
          if (t.add(this.urlInputView), e.length) {
            const n = new Ge();
            n.setTemplate({ tag: "ul", children: this._manualDecoratorSwitches.map((i) => ({ tag: "li", children: [i], attributes: { class: ["ck", "ck-list__item"] } })), attributes: { class: ["ck", "ck-reset", "ck-list"] } }), t.add(n);
          }
          return t.add(this.saveButtonView), t.add(this.cancelButtonView), t;
        }
      }
      var Hw = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', Ww = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>';
      p(77);
      class Yw extends Ge {
        constructor(e) {
          super(e);
          const t = e.t;
          this.focusTracker = new yn(), this.keystrokes = new ci(), this.previewButtonView = this._createPreviewButton(), this.unlinkButtonView = this._createButton(t("bp"), Hw, "unlink"), this.editButtonView = this._createButton(t("bq"), Ww, "edit"), this.set("href"), this._focusables = new ji(), this._focusCycler = new Vi({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-link-actions"], tabindex: "-1" }, children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView] });
        }
        render() {
          super.render(), [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach((e) => {
            this._focusables.add(e), this.focusTracker.add(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        _createButton(e, t, n) {
          const i = new kt(this.locale);
          return i.set({ label: e, icon: t, tooltip: !0 }), i.delegate("execute").to(this, n), i;
        }
        _createPreviewButton() {
          const e = new kt(this.locale), t = this.bindTemplate, n = this.t;
          return e.set({ withText: !0, tooltip: n("br") }), e.extendTemplate({ attributes: { class: ["ck", "ck-link-actions__preview"], href: t.to("href", (i) => i && Th(i)), target: "_blank" } }), e.bind("label").to(this, "href", (i) => i || n("bs")), e.bind("isEnabled").to(this, "href", (i) => !!i), e.template.tag = "a", e.template.eventListeners = {}, e;
        }
      }
      var qw = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
      const Ba = "Ctrl+K";
      class Gw extends Ae {
        static get requires() {
          return [To];
        }
        static get pluginName() {
          return "LinkUI";
        }
        init() {
          const e = this.editor;
          e.editing.view.addObserver(Vw), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = e.plugins.get(To), this._createToolbarLinkButton(), this._enableUserBalloonInteractions();
        }
        destroy() {
          super.destroy(), this.formView.destroy();
        }
        _createActionsView() {
          const e = this.editor, t = new Yw(e.locale), n = e.commands.get("link"), i = e.commands.get("unlink");
          return t.bind("href").to(n, "value"), t.editButtonView.bind("isEnabled").to(n), t.unlinkButtonView.bind("isEnabled").to(i), this.listenTo(t, "edit", () => {
            this._addFormView();
          }), this.listenTo(t, "unlink", () => {
            e.execute("unlink"), this._hideUI();
          }), t.keystrokes.set("Esc", (s, l) => {
            this._hideUI(), l();
          }), t.keystrokes.set(Ba, (s, l) => {
            this._addFormView(), l();
          }), t;
        }
        _createFormView() {
          const e = this.editor, t = e.commands.get("link"), n = new Uw(e.locale, t.manualDecorators);
          return n.urlInputView.bind("value").to(t, "value"), n.urlInputView.bind("isReadOnly").to(t, "isEnabled", (i) => !i), n.saveButtonView.bind("isEnabled").to(t), this.listenTo(n, "submit", () => {
            e.execute("link", n.urlInputView.inputView.element.value, n.getDecoratorSwitchesState()), this._closeFormView();
          }), this.listenTo(n, "cancel", () => {
            this._closeFormView();
          }), n.keystrokes.set("Esc", (i, s) => {
            this._closeFormView(), s();
          }), n;
        }
        _createToolbarLinkButton() {
          const e = this.editor, t = e.commands.get("link"), n = e.t;
          e.keystrokes.set(Ba, (i, s) => {
            s(), t.isEnabled && this._showUI(!0);
          }), e.ui.componentFactory.add("link", (i) => {
            const s = new kt(i);
            return s.isEnabled = !0, s.label = n("aw"), s.icon = qw, s.keystroke = Ba, s.tooltip = !0, s.isToggleable = !0, s.bind("isEnabled").to(t, "isEnabled"), s.bind("isOn").to(t, "value", (l) => !!l), this.listenTo(s, "execute", () => this._showUI(!0)), s;
          });
        }
        _enableUserBalloonInteractions() {
          const e = this.editor.editing.view.document;
          this.listenTo(e, "click", () => {
            this._getSelectedLinkElement() && this._showUI();
          }), this.editor.keystrokes.set("Tab", (t, n) => {
            this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), n());
          }, { priority: "high" }), this.editor.keystrokes.set("Esc", (t, n) => {
            this._isUIVisible && (this._hideUI(), n());
          }), ca({ emitter: this.formView, activator: () => this._isUIInPanel, contextElements: [this._balloon.view.element], callback: () => this._hideUI() });
        }
        _addActionsView() {
          this._areActionsInPanel || this._balloon.add({ view: this.actionsView, position: this._getBalloonPositionData() });
        }
        _addFormView() {
          if (this._isFormInPanel)
            return;
          const e = this.editor.commands.get("link");
          this._balloon.add({ view: this.formView, position: this._getBalloonPositionData() }), this._balloon.visibleView === this.formView && this.formView.urlInputView.select(), this.formView.urlInputView.inputView.element.value = e.value || "";
        }
        _closeFormView() {
          const e = this.editor.commands.get("link");
          e.restoreManualDecoratorStates(), e.value !== void 0 ? this._removeFormView() : this._hideUI();
        }
        _removeFormView() {
          this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus());
        }
        _showUI(e = !1) {
          this.editor.commands.get("link").isEnabled && (this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), e && this._balloon.showStack("main")) : (this._addActionsView(), e && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI());
        }
        _hideUI() {
          if (!this._isUIInPanel)
            return;
          const e = this.editor;
          this.stopListening(e.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), e.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView);
        }
        _startUpdatingUI() {
          const e = this.editor, t = e.editing.view.document;
          let n = this._getSelectedLinkElement(), i = l();
          const s = () => {
            const d = this._getSelectedLinkElement(), f = l();
            n && !d || !n && f !== i ? this._hideUI() : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()), n = d, i = f;
          };
          function l() {
            return t.selection.focus.getAncestors().reverse().find((d) => d.is("element"));
          }
          this.listenTo(e.ui, "update", s), this.listenTo(this._balloon, "change:visibleView", s);
        }
        get _isFormInPanel() {
          return this._balloon.hasView(this.formView);
        }
        get _areActionsInPanel() {
          return this._balloon.hasView(this.actionsView);
        }
        get _areActionsVisible() {
          return this._balloon.visibleView === this.actionsView;
        }
        get _isUIInPanel() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
        get _isUIVisible() {
          return this._balloon.visibleView == this.formView || this._areActionsVisible;
        }
        _getBalloonPositionData() {
          const e = this.editor.editing.view, t = e.document, n = this._getSelectedLinkElement();
          return { target: n ? e.domConverter.mapViewToDom(n) : e.domConverter.viewRangeToDom(t.selection.getFirstRange()) };
        }
        _getSelectedLinkElement() {
          const e = this.editor.editing.view, t = e.document.selection;
          if (t.isCollapsed)
            return Va(t.getFirstPosition());
          {
            const n = t.getFirstRange().getTrimmed(), i = Va(n.start), s = Va(n.end);
            return i && i == s && e.createRangeIn(i).getTrimmed().isEqual(n) ? i : null;
          }
        }
      }
      function Va(o) {
        return o.getAncestors().find((e) => function(t) {
          return t.is("attributeElement") && !!t.getCustomProperty("link");
        }(e));
      }
      class Dh extends Xe {
        constructor(e, t) {
          super(e), this.type = t;
        }
        refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
        execute() {
          const e = this.editor.model, t = e.document, n = Array.from(t.selection.getSelectedBlocks()).filter((s) => Rh(s, e.schema)), i = this.value === !0;
          e.change((s) => {
            if (i) {
              let l = n[n.length - 1].nextSibling, d = Number.POSITIVE_INFINITY, f = [];
              for (; l && l.name == "listItem" && l.getAttribute("listIndent") !== 0; ) {
                const m = l.getAttribute("listIndent");
                m < d && (d = m);
                const g = m - d;
                f.push({ element: l, listIndent: g }), l = l.nextSibling;
              }
              f = f.reverse();
              for (const m of f)
                s.setAttribute("listIndent", m.listIndent, m.element);
            }
            if (!i) {
              let l = Number.POSITIVE_INFINITY;
              for (const d of n)
                d.is("listItem") && d.getAttribute("listIndent") < l && (l = d.getAttribute("listIndent"));
              Nh(n, !0, l = l === 0 ? 1 : l), Nh(n, !1, l);
            }
            for (const l of n.reverse())
              i && l.name == "listItem" ? s.rename(l, "paragraph") : i || l.name == "listItem" ? i || l.name != "listItem" || l.getAttribute("listType") == this.type || s.setAttribute("listType", this.type, l) : (s.setAttributes({ listType: this.type, listIndent: 0 }, l), s.rename(l, "listItem"));
          });
        }
        _getValue() {
          const e = Rn(this.editor.model.document.selection.getSelectedBlocks());
          return !!e && e.is("listItem") && e.getAttribute("listType") == this.type;
        }
        _checkEnabled() {
          if (this.value)
            return !0;
          const e = this.editor.model.document.selection, t = this.editor.model.schema, n = Rn(e.getSelectedBlocks());
          return !!n && Rh(n, t);
        }
      }
      function Nh(o, e, t) {
        const n = e ? o[0] : o[o.length - 1];
        if (n.is("listItem")) {
          let i = n[e ? "previousSibling" : "nextSibling"], s = n.getAttribute("listIndent");
          for (; i && i.is("listItem") && i.getAttribute("listIndent") >= t; )
            s > i.getAttribute("listIndent") && (s = i.getAttribute("listIndent")), i.getAttribute("listIndent") == s && o[e ? "unshift" : "push"](i), i = i[e ? "previousSibling" : "nextSibling"];
        }
      }
      function Rh(o, e) {
        return e.checkChild(o.parent, "listItem") && !e.isObject(o);
      }
      class Lh extends Xe {
        constructor(e, t) {
          super(e), this._indentBy = t == "forward" ? 1 : -1;
        }
        refresh() {
          this.isEnabled = this._checkEnabled();
        }
        execute() {
          const e = this.editor.model, t = e.document;
          let n = Array.from(t.selection.getSelectedBlocks());
          e.change((i) => {
            const s = n[n.length - 1];
            let l = s.nextSibling;
            for (; l && l.name == "listItem" && l.getAttribute("listIndent") > s.getAttribute("listIndent"); )
              n.push(l), l = l.nextSibling;
            this._indentBy < 0 && (n = n.reverse());
            for (const d of n) {
              const f = d.getAttribute("listIndent") + this._indentBy;
              f < 0 ? i.rename(d, "paragraph") : i.setAttribute("listIndent", f, d);
            }
          });
        }
        _checkEnabled() {
          const e = Rn(this.editor.model.document.selection.getSelectedBlocks());
          if (!e || !e.is("listItem"))
            return !1;
          if (this._indentBy > 0) {
            const t = e.getAttribute("listIndent"), n = e.getAttribute("listType");
            let i = e.previousSibling;
            for (; i && i.is("listItem") && i.getAttribute("listIndent") >= t; ) {
              if (i.getAttribute("listIndent") == t)
                return i.getAttribute("listType") == n;
              i = i.previousSibling;
            }
            return !1;
          }
          return !0;
        }
      }
      function Zw(o, e) {
        const t = e.mapper, n = e.writer, i = o.getAttribute("listType") == "numbered" ? "ol" : "ul", s = function(d) {
          const f = d.createContainerElement("li");
          return f.getFillerOffset = Kw, f;
        }(n), l = n.createContainerElement(i, null);
        return n.insert(n.createPositionAt(l, 0), s), t.bindElements(o, s), s;
      }
      function Fh(o, e, t, n) {
        const i = e.parent, s = t.mapper, l = t.writer;
        let d = s.toViewPosition(n.createPositionBefore(o));
        const f = $h(o.previousSibling, { sameIndent: !0, smallerIndent: !0, listIndent: o.getAttribute("listIndent") }), m = o.previousSibling;
        if (f && f.getAttribute("listIndent") == o.getAttribute("listIndent")) {
          const g = s.toViewElement(f);
          d = l.breakContainer(l.createPositionAfter(g));
        } else
          d = m && m.name == "listItem" ? s.toViewPosition(n.createPositionAt(m, "end")) : s.toViewPosition(n.createPositionBefore(o));
        if (d = zh(d), l.insert(d, i), m && m.name == "listItem") {
          const g = s.toViewElement(m), b = l.createRange(l.createPositionAt(g, 0), d).getWalker({ ignoreElementEnd: !0 });
          for (const y of b)
            if (y.item.is("li")) {
              const C = l.breakContainer(l.createPositionBefore(y.item)), O = y.item.parent, D = l.createPositionAt(e, "end");
              fn(l, D.nodeBefore, D.nodeAfter), l.move(l.createRangeOn(O), D), b.position = C;
            }
        } else {
          const g = i.nextSibling;
          if (g && (g.is("ul") || g.is("ol"))) {
            let b = null;
            for (const y of g.getChildren()) {
              const C = s.toModelElement(y);
              if (!(C && C.getAttribute("listIndent") > o.getAttribute("listIndent")))
                break;
              b = y;
            }
            b && (l.breakContainer(l.createPositionAfter(b)), l.move(l.createRangeOn(b.parent), l.createPositionAt(e, "end")));
          }
        }
        fn(l, i, i.nextSibling), fn(l, i.previousSibling, i);
      }
      function fn(o, e, t) {
        return !e || !t || e.name != "ul" && e.name != "ol" || e.name != t.name || e.getAttribute("class") !== t.getAttribute("class") ? null : o.mergeContainers(o.createPositionAfter(e));
      }
      function zh(o) {
        return o.getLastMatchingPosition((e) => e.item.is("uiElement"));
      }
      function $h(o, e) {
        const t = !!e.sameIndent, n = !!e.smallerIndent, i = e.listIndent;
        let s = o;
        for (; s && s.name == "listItem"; ) {
          const l = s.getAttribute("listIndent");
          if (t && i == l || n && i > l)
            return s;
          s = s.previousSibling;
        }
        return null;
      }
      function jh(o, e, t, n) {
        o.ui.componentFactory.add(e, (i) => {
          const s = o.commands.get(e), l = new kt(i);
          return l.set({ label: t, icon: n, tooltip: !0, isToggleable: !0 }), l.bind("isOn", "isEnabled").to(s, "value", "isEnabled"), l.on("execute", () => o.execute(e)), l;
        });
      }
      function Kw() {
        const o = !this.isEmpty && (this.getChild(0).name == "ul" || this.getChild(0).name == "ol");
        return this.isEmpty || o ? 0 : ic.call(this);
      }
      function Bh(o) {
        return (e, t, n) => {
          const i = n.consumable;
          if (!i.test(t.item, "insert") || !i.test(t.item, "attribute:listType") || !i.test(t.item, "attribute:listIndent"))
            return;
          i.consume(t.item, "insert"), i.consume(t.item, "attribute:listType"), i.consume(t.item, "attribute:listIndent");
          const s = t.item;
          Fh(s, Zw(s, n), n, o);
        };
      }
      function Xw(o, e, t) {
        if (!t.consumable.consume(e.item, "attribute:listType"))
          return;
        const n = t.mapper.toViewElement(e.item), i = t.writer;
        i.breakContainer(i.createPositionBefore(n)), i.breakContainer(i.createPositionAfter(n));
        const s = n.parent, l = e.attributeNewValue == "numbered" ? "ol" : "ul";
        i.rename(l, s);
      }
      function Qw(o, e, t) {
        const n = t.mapper.toViewElement(e.item).parent, i = t.writer;
        fn(i, n, n.nextSibling), fn(i, n.previousSibling, n);
        for (const s of e.item.getChildren())
          t.consumable.consume(s, "insert");
      }
      function Vh(o, e, t) {
        if (e.item.name != "listItem") {
          let n = t.mapper.toViewPosition(e.range.start);
          const i = t.writer, s = [];
          for (; (n.parent.name == "ul" || n.parent.name == "ol") && (n = i.breakContainer(n)).parent.name == "li"; ) {
            const l = n, d = i.createPositionAt(n.parent, "end");
            if (!l.isEqual(d)) {
              const f = i.remove(i.createRange(l, d));
              s.push(f);
            }
            n = i.createPositionAfter(n.parent);
          }
          if (s.length > 0) {
            for (let l = 0; l < s.length; l++) {
              const d = n.nodeBefore;
              if (n = i.insert(n, s[l]).end, l > 0) {
                const f = fn(i, d, d.nextSibling);
                f && f.parent == d && n.offset--;
              }
            }
            fn(i, n.nodeBefore, n.nodeAfter);
          }
        }
      }
      function Jw(o, e, t) {
        const n = t.mapper.toViewPosition(e.position), i = n.nodeBefore, s = n.nodeAfter;
        fn(t.writer, i, s);
      }
      function ey(o, e, t) {
        if (t.consumable.consume(e.viewItem, { name: !0 })) {
          const n = t.writer, i = this.conversionApi.store, s = n.createElement("listItem");
          i.indent = i.indent || 0, n.setAttribute("listIndent", i.indent, s);
          const l = e.viewItem.parent && e.viewItem.parent.name == "ol" ? "numbered" : "bulleted";
          n.setAttribute("listType", l, s), i.indent++;
          const d = t.splitToAllowedParent(s, e.modelCursor);
          if (!d)
            return;
          n.insert(s, d.position);
          const f = function(m, g, b) {
            const { writer: y, schema: C } = b;
            let O = y.createPositionAfter(m);
            for (const D of g)
              if (D.name == "ul" || D.name == "ol")
                O = b.convertItem(D, O).modelCursor;
              else {
                const oe = b.convertItem(D, y.createPositionAt(m, "end")), ce = oe.modelRange.start.nodeAfter;
                ce && ce.is("element") && !C.checkChild(m, ce.name) && (m = oe.modelCursor.parent.is("listItem") ? oe.modelCursor.parent : iy(oe.modelCursor), O = y.createPositionAfter(m));
              }
            return O;
          }(s, e.viewItem.getChildren(), t);
          i.indent--, e.modelRange = n.createRange(e.modelCursor, f), d.cursorParent ? e.modelCursor = n.createPositionAt(d.cursorParent, 0) : e.modelCursor = e.modelRange.end;
        }
      }
      function Uh(o, e, t) {
        if (t.consumable.test(e.viewItem, { name: !0 })) {
          const n = Array.from(e.viewItem.getChildren());
          for (const i of n)
            i.is("li") || i._remove();
        }
      }
      function ty(o, e, t) {
        if (t.consumable.test(e.viewItem, { name: !0 })) {
          if (e.viewItem.childCount === 0)
            return;
          const n = [...e.viewItem.getChildren()];
          let i = !1, s = !0;
          for (const l of n)
            !i || l.is("ul") || l.is("ol") || l._remove(), l.is("text") ? (s && (l._data = l.data.replace(/^\s+/, "")), (!l.nextSibling || l.nextSibling.is("ul") || l.nextSibling.is("ol")) && (l._data = l.data.replace(/\s+$/, ""))) : (l.is("ul") || l.is("ol")) && (i = !0), s = !1;
        }
      }
      function Hh(o) {
        return (e, t) => {
          if (t.isPhantom)
            return;
          const n = t.modelPosition.nodeBefore;
          if (n && n.is("listItem")) {
            const i = t.mapper.toViewElement(n), s = i.getAncestors().find((d) => d.is("ul") || d.is("ol")), l = o.createPositionAt(i, 0).getWalker();
            for (const d of l) {
              if (d.type == "elementStart" && d.item.is("li")) {
                t.viewPosition = d.previousPosition;
                break;
              }
              if (d.type == "elementEnd" && d.item == s) {
                t.viewPosition = d.nextPosition;
                break;
              }
            }
          }
        };
      }
      function ny(o, [e, t]) {
        let n, i = e.is("documentFragment") ? e.getChild(0) : e;
        if (n = t ? this.createSelection(t) : this.document.selection, i && i.is("listItem")) {
          const s = n.getFirstPosition();
          let l = null;
          if (s.parent.is("listItem") ? l = s.parent : s.nodeBefore && s.nodeBefore.is("listItem") && (l = s.nodeBefore), l) {
            const d = l.getAttribute("listIndent");
            if (d > 0)
              for (; i && i.is("listItem"); )
                i._setAttribute("listIndent", i.getAttribute("listIndent") + d), i = i.nextSibling;
          }
        }
      }
      function iy(o) {
        const e = new qn({ startPosition: o });
        let t;
        do
          t = e.next();
        while (!t.value.item.is("listItem"));
        return t.value.item;
      }
      function Wh(o, e, t, n, i, s) {
        const l = $h(e.nodeBefore, { sameIndent: !0, smallerIndent: !0, listIndent: o, foo: "b" }), d = i.mapper, f = i.writer, m = l ? l.getAttribute("listIndent") : null;
        let g;
        if (l)
          if (m == o) {
            const b = d.toViewElement(l).parent;
            g = f.createPositionAfter(b);
          } else {
            const b = s.createPositionAt(l, "end");
            g = d.toViewPosition(b);
          }
        else
          g = t;
        g = zh(g);
        for (const b of [...n.getChildren()])
          (b.is("ul") || b.is("ol")) && (g = f.move(f.createRangeOn(b), g).end, fn(f, b, b.nextSibling), fn(f, b.previousSibling, b));
      }
      class ry extends Ae {
        static get requires() {
          return [qi];
        }
        init() {
          const e = this.editor;
          e.model.schema.register("listItem", { inheritAllFrom: "$block", allowAttributes: ["listType", "listIndent"] });
          const t = e.data, n = e.editing;
          e.model.document.registerPostFixer((l) => function(d, f) {
            const m = d.document.differ.getChanges(), g = /* @__PURE__ */ new Map();
            let b = !1;
            for (const D of m)
              if (D.type == "insert" && D.name == "listItem")
                y(D.position);
              else if (D.type == "insert" && D.name != "listItem") {
                if (D.name != "$text") {
                  const oe = D.position.nodeAfter;
                  oe.hasAttribute("listIndent") && (f.removeAttribute("listIndent", oe), b = !0), oe.hasAttribute("listType") && (f.removeAttribute("listType", oe), b = !0);
                }
                y(D.position.getShiftedBy(D.length));
              } else
                D.type == "remove" && D.name == "listItem" ? y(D.position) : (D.type == "attribute" && D.attributeKey == "listIndent" || D.type == "attribute" && D.attributeKey == "listType") && y(D.range.start);
            for (const D of g.values())
              C(D), O(D);
            return b;
            function y(D) {
              const oe = D.nodeBefore;
              if (oe && oe.is("listItem")) {
                let ce = oe;
                if (g.has(ce))
                  return;
                for (; ce.previousSibling && ce.previousSibling.is("listItem"); )
                  if (ce = ce.previousSibling, g.has(ce))
                    return;
                g.set(D.nodeBefore, ce);
              } else {
                const ce = D.nodeAfter;
                ce && ce.is("listItem") && g.set(ce, ce);
              }
            }
            function C(D) {
              let oe = 0, ce = null;
              for (; D && D.is("listItem"); ) {
                const _e = D.getAttribute("listIndent");
                if (_e > oe) {
                  let De;
                  ce === null ? (ce = _e - oe, De = oe) : (ce > _e && (ce = _e), De = _e - ce), f.setAttribute("listIndent", De, D), b = !0;
                } else
                  ce = null, oe = D.getAttribute("listIndent") + 1;
                D = D.nextSibling;
              }
            }
            function O(D) {
              let oe = [], ce = null;
              for (; D && D.is("listItem"); ) {
                const _e = D.getAttribute("listIndent");
                if (ce && ce.getAttribute("listIndent") > _e && (oe = oe.slice(0, _e + 1)), _e != 0)
                  if (oe[_e]) {
                    const De = oe[_e];
                    D.getAttribute("listType") != De && (f.setAttribute("listType", De, D), b = !0);
                  } else
                    oe[_e] = D.getAttribute("listType");
                ce = D, D = D.nextSibling;
              }
            }
          }(e.model, l)), n.mapper.registerViewToModelLength("li", Ua), t.mapper.registerViewToModelLength("li", Ua), n.mapper.on("modelToViewPosition", Hh(n.view)), n.mapper.on("viewToModelPosition", function(l) {
            return (d, f) => {
              const m = f.viewPosition, g = m.parent, b = f.mapper;
              if (g.name == "ul" || g.name == "ol") {
                if (m.isAtEnd) {
                  const y = b.toModelElement(m.nodeBefore), C = b.getModelLength(m.nodeBefore);
                  f.modelPosition = l.createPositionBefore(y).getShiftedBy(C);
                } else {
                  const y = b.toModelElement(m.nodeAfter);
                  f.modelPosition = l.createPositionBefore(y);
                }
                d.stop();
              } else if (g.name == "li" && m.nodeBefore && (m.nodeBefore.name == "ul" || m.nodeBefore.name == "ol")) {
                const y = b.toModelElement(g);
                let C = 1, O = m.nodeBefore;
                for (; O && (O.is("ul") || O.is("ol")); )
                  C += b.getModelLength(O), O = O.previousSibling;
                f.modelPosition = l.createPositionBefore(y).getShiftedBy(C), d.stop();
              }
            };
          }(e.model)), t.mapper.on("modelToViewPosition", Hh(n.view)), n.downcastDispatcher.on("insert", Vh, { priority: "high" }), n.downcastDispatcher.on("insert:listItem", Bh(e.model)), t.downcastDispatcher.on("insert", Vh, { priority: "high" }), t.downcastDispatcher.on("insert:listItem", Bh(e.model)), n.downcastDispatcher.on("attribute:listType:listItem", Xw, { priority: "high" }), n.downcastDispatcher.on("attribute:listType:listItem", Qw, { priority: "low" }), n.downcastDispatcher.on("attribute:listIndent:listItem", function(l) {
            return (d, f, m) => {
              if (!m.consumable.consume(f.item, "attribute:listIndent"))
                return;
              const g = m.mapper.toViewElement(f.item), b = m.writer;
              b.breakContainer(b.createPositionBefore(g)), b.breakContainer(b.createPositionAfter(g));
              const y = g.parent, C = y.previousSibling, O = b.createRangeOn(y);
              b.remove(O), C && C.nextSibling && fn(b, C, C.nextSibling), Wh(f.attributeOldValue + 1, f.range.start, O.start, g, m, l), Fh(f.item, g, m, l);
              for (const D of f.item.getChildren())
                m.consumable.consume(D, "insert");
            };
          }(e.model)), n.downcastDispatcher.on("remove:listItem", function(l) {
            return (d, f, m) => {
              const g = m.mapper.toViewPosition(f.position).getLastMatchingPosition((oe) => !oe.item.is("li")).nodeAfter, b = m.writer;
              b.breakContainer(b.createPositionBefore(g)), b.breakContainer(b.createPositionAfter(g));
              const y = g.parent, C = y.previousSibling, O = b.createRangeOn(y), D = b.remove(O);
              C && C.nextSibling && fn(b, C, C.nextSibling), Wh(m.mapper.toModelElement(g).getAttribute("listIndent") + 1, f.position, O.start, g, m, l);
              for (const oe of b.createRangeIn(D).getItems())
                m.mapper.unbindViewElement(oe);
              d.stop();
            };
          }(e.model)), n.downcastDispatcher.on("remove", Jw, { priority: "low" }), t.upcastDispatcher.on("element:ul", Uh, { priority: "high" }), t.upcastDispatcher.on("element:ol", Uh, { priority: "high" }), t.upcastDispatcher.on("element:li", ty, { priority: "high" }), t.upcastDispatcher.on("element:li", ey), e.model.on("insertContent", ny, { priority: "high" }), e.commands.add("numberedList", new Dh(e, "numbered")), e.commands.add("bulletedList", new Dh(e, "bulleted")), e.commands.add("indentList", new Lh(e, "forward")), e.commands.add("outdentList", new Lh(e, "backward"));
          const i = n.view.document;
          this.listenTo(i, "enter", (l, d) => {
            const f = this.editor.model.document, m = f.selection.getLastPosition().parent;
            f.selection.isCollapsed && m.name == "listItem" && m.isEmpty && (this.editor.execute("outdentList"), d.preventDefault(), l.stop());
          }), this.listenTo(i, "delete", (l, d) => {
            if (d.direction !== "backward")
              return;
            const f = this.editor.model.document.selection;
            if (!f.isCollapsed)
              return;
            const m = f.getFirstPosition();
            if (!m.isAtStart)
              return;
            const g = m.parent;
            g.name === "listItem" && (g.previousSibling && g.previousSibling.name === "listItem" || (this.editor.execute("outdentList"), d.preventDefault(), l.stop()));
          }, { priority: "high" });
          const s = (l) => (d, f) => {
            this.editor.commands.get(l).isEnabled && (this.editor.execute(l), f());
          };
          e.keystrokes.set("Tab", s("indentList")), e.keystrokes.set("Shift+Tab", s("outdentList"));
        }
        afterInit() {
          const e = this.editor.commands, t = e.get("indent"), n = e.get("outdent");
          t && t.registerChildCommand(e.get("indentList")), n && n.registerChildCommand(e.get("outdentList"));
        }
      }
      function Ua(o) {
        let e = 1;
        for (const t of o.getChildren())
          if (t.name == "ul" || t.name == "ol")
            for (const n of t.getChildren())
              e += Ua(n);
        return e;
      }
      var oy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>', sy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';
      class ay extends Ae {
        init() {
          const e = this.editor.t;
          jh(this.editor, "numberedList", e("w"), oy), jh(this.editor, "bulletedList", e("x"), sy);
        }
      }
      function Yh(o, e) {
        return (n) => {
          n.on("attribute:url:media", t);
        };
        function t(n, i, s) {
          if (!s.consumable.consume(i.item, n.name))
            return;
          const l = i.attributeNewValue, d = s.writer, f = s.mapper.toViewElement(i.item);
          d.remove(d.createRangeIn(f));
          const m = o.getMediaViewElement(d, l, e);
          d.insert(d.createPositionAt(f, 0), m);
        }
      }
      function qh(o, e, t, n) {
        const i = o.createContainerElement("figure", { class: "media" });
        return i.getFillerOffset = ly, o.insert(o.createPositionAt(i, 0), e.getMediaViewElement(o, t, n)), i;
      }
      function Gh(o) {
        const e = o.getSelectedElement();
        return e && e.is("media") ? e : null;
      }
      function Zh(o, e, t) {
        o.change((n) => {
          const i = n.createElement("media", { url: e });
          o.insertContent(i, t), n.setSelection(i, "on");
        });
      }
      function ly() {
        return null;
      }
      class cy extends Xe {
        refresh() {
          const e = this.editor.model, t = e.document.selection, n = e.schema, i = t.getFirstPosition(), s = Gh(t);
          let l = i.parent;
          l != l.root && (l = l.parent), this.value = s ? s.getAttribute("url") : null, this.isEnabled = n.checkChild(l, "media");
        }
        execute(e) {
          const t = this.editor.model, n = t.document.selection, i = Gh(n);
          if (i)
            t.change((s) => {
              s.setAttribute("url", e, i);
            });
          else {
            const s = So(n, t);
            Zh(t, e, s);
          }
        }
      }
      var uy = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>';
      const dy = "0 0 64 42";
      class hy {
        constructor(e, t) {
          const n = t.providers, i = t.extraProviders || [], s = new Set(t.removeProviders), l = n.concat(i).filter((d) => {
            const f = d.name;
            return f ? !s.has(f) : (console.warn(Object(V.a)("media-embed-no-provider-name: The configured media provider has no name and cannot be used."), { provider: d }), !1);
          });
          this.locale = e, this.providerDefinitions = l;
        }
        hasMedia(e) {
          return !!this._getMedia(e);
        }
        getMediaViewElement(e, t, n) {
          return this._getMedia(t).getViewElement(e, n);
        }
        _getMedia(e) {
          if (!e)
            return new Kh(this.locale);
          e = e.trim();
          for (const t of this.providerDefinitions) {
            const n = t.html;
            let i = t.url;
            Array.isArray(i) || (i = [i]);
            for (const s of i) {
              const l = this._getUrlMatches(e, s);
              if (l)
                return new Kh(this.locale, e, l, n);
            }
          }
          return null;
        }
        _getUrlMatches(e, t) {
          let n = e.match(t);
          if (n)
            return n;
          let i = e.replace(/^https?:\/\//, "");
          return (n = i.match(t)) ? n : (n = (i = i.replace(/^www\./, "")).match(t)) || null;
        }
      }
      class Kh {
        constructor(e, t, n, i) {
          this.url = this._getValidUrl(t), this._t = e.t, this._match = n, this._previewRenderer = i;
        }
        getViewElement(e, t) {
          const n = {};
          if (t.renderForEditingView || t.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (n["data-oembed-url"] = this.url), t.renderForEditingView && (n.class = "ck-media__wrapper");
            const i = this._getPreviewHtml(t);
            return e.createUIElement("div", n, function(s) {
              const l = this.toDomElement(s);
              return l.innerHTML = i, l;
            });
          }
          return this.url && (n.url = this.url), e.createEmptyElement("oembed", n);
        }
        _getPreviewHtml(e) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && e.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
        _getPlaceholderHtml() {
          const e = new td(), t = new vo();
          return e.text = this._t("Open media in new tab"), t.content = uy, t.viewBox = dy, new Nn({ tag: "div", attributes: { class: "ck ck-reset_all ck-media__placeholder" }, children: [{ tag: "div", attributes: { class: "ck-media__placeholder__icon" }, children: [t] }, { tag: "a", attributes: { class: "ck-media__placeholder__url", target: "_blank", rel: "noopener noreferrer", href: this.url }, children: [{ tag: "span", attributes: { class: "ck-media__placeholder__url__text" }, children: [this.url] }, e] }] }).render().outerHTML;
        }
        _getValidUrl(e) {
          return e ? e.match(/^https?/) ? e : "https://" + e : null;
        }
      }
      p(79);
      class Mo extends Ae {
        static get pluginName() {
          return "MediaEmbedEditing";
        }
        constructor(e) {
          super(e), e.config.define("mediaEmbed", { providers: [{ name: "dailymotion", url: /^dailymotion\.com\/video\/(\w+)/, html: (t) => `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>` }, { name: "spotify", url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/], html: (t) => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>` }, { name: "youtube", url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/], html: (t) => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>` }, { name: "vimeo", url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/], html: (t) => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${t[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>` }, { name: "instagram", url: /^instagram\.com\/p\/(\w+)/ }, { name: "twitter", url: /^twitter\.com/ }, { name: "googleMaps", url: /^google\.com\/maps/ }, { name: "flickr", url: /^flickr\.com/ }, { name: "facebook", url: /^facebook\.com/ }] }), this.registry = new hy(e.locale, e.config.get("mediaEmbed"));
        }
        init() {
          const e = this.editor, t = e.model.schema, n = e.t, i = e.conversion, s = e.config.get("mediaEmbed.previewsInData"), l = this.registry;
          e.commands.add("mediaEmbed", new cy(e)), t.register("media", { isObject: !0, isBlock: !0, allowWhere: "$block", allowAttributes: ["url"] }), i.for("dataDowncast").elementToElement({ model: "media", view: (d, f) => {
            const m = d.getAttribute("url");
            return qh(f, l, m, { renderMediaPreview: m && s });
          } }), i.for("dataDowncast").add(Yh(l, { renderMediaPreview: s })), i.for("editingDowncast").elementToElement({ model: "media", view: (d, f) => {
            const m = d.getAttribute("url");
            return function(g, b, y) {
              return b.setCustomProperty("media", !0, g), wa(g, b, { label: y });
            }(qh(f, l, m, { renderForEditingView: !0 }), f, n("as"));
          } }), i.for("editingDowncast").add(Yh(l, { renderForEditingView: !0 })), i.for("upcast").elementToElement({ view: { name: "oembed", attributes: { url: !0 } }, model: (d, f) => {
            const m = d.getAttribute("url");
            if (l.hasMedia(m))
              return f.createElement("media", { url: m });
          } }).elementToElement({ view: { name: "div", attributes: { "data-oembed-url": !0 } }, model: (d, f) => {
            const m = d.getAttribute("data-oembed-url");
            if (l.hasMedia(m))
              return f.createElement("media", { url: m });
          } });
        }
      }
      const fy = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;
      class py extends Ae {
        static get requires() {
          return [bo, Td];
        }
        static get pluginName() {
          return "AutoMediaEmbed";
        }
        constructor(e) {
          super(e), this._timeoutId = null, this._positionToInsert = null;
        }
        init() {
          const e = this.editor, t = e.model.document;
          this.listenTo(e.plugins.get(bo), "inputTransformation", () => {
            const n = t.selection.getFirstRange(), i = Vt.fromPosition(n.start);
            i.stickiness = "toPrevious";
            const s = Vt.fromPosition(n.end);
            s.stickiness = "toNext", t.once("change:data", () => {
              this._embedMediaBetweenPositions(i, s), i.detach(), s.detach();
            }, { priority: "high" });
          }), e.commands.get("undo").on("execute", () => {
            this._timeoutId && (jt.window.clearTimeout(this._timeoutId), this._positionToInsert.detach(), this._timeoutId = null, this._positionToInsert = null);
          }, { priority: "high" });
        }
        _embedMediaBetweenPositions(e, t) {
          const n = this.editor, i = n.plugins.get(Mo).registry, s = new ai(e, t), l = s.getWalker({ ignoreElementEnd: !0 });
          let d = "";
          for (const f of l)
            f.item.is("textProxy") && (d += f.item.data);
          !(d = d.trim()).match(fy) || !i.hasMedia(d) || n.commands.get("mediaEmbed").isEnabled && (this._positionToInsert = Vt.fromPosition(e), this._timeoutId = jt.window.setTimeout(() => {
            n.model.change((f) => {
              let m;
              this._timeoutId = null, f.remove(s), this._positionToInsert.root.rootName !== "$graveyard" && (m = this._positionToInsert), Zh(n.model, d, m), this._positionToInsert.detach(), this._positionToInsert = null;
            });
          }, 100));
        }
      }
      p(81);
      class my extends Ge {
        constructor(e, t) {
          super(t);
          const n = t.t;
          this.focusTracker = new yn(), this.keystrokes = new ci(), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(n("ca"), Ta, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(n("cb"), Ia, "ck-button-cancel", "cancel"), this._focusables = new ji(), this._focusCycler = new Vi({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this._validators = e, this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-media-form"], tabindex: "-1" }, children: [this.urlInputView, this.saveButtonView, this.cancelButtonView] });
        }
        render() {
          super.render(), Aa({ view: this }), [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach((t) => {
            this._focusables.add(t), this.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
          const e = (t) => t.stopPropagation();
          this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e), this.listenTo(this.urlInputView.element, "selectstart", (t, n) => {
            n.stopPropagation();
          }, { priority: "high" });
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        get url() {
          return this.urlInputView.inputView.element.value.trim();
        }
        set url(e) {
          this.urlInputView.inputView.element.value = e.trim();
        }
        isValid() {
          this.resetFormStatus();
          for (const e of this._validators) {
            const t = e(this);
            if (t)
              return this.urlInputView.errorText = t, !1;
          }
          return !0;
        }
        resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
        _createUrlInput() {
          const e = this.locale.t, t = new Sa(this.locale, Ca), n = t.inputView;
          return this._urlInputViewInfoDefault = e("ce"), this._urlInputViewInfoTip = e("cf"), t.label = e("cg"), t.infoText = this._urlInputViewInfoDefault, n.placeholder = "https://example.com", n.on("input", () => {
            t.infoText = n.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault;
          }), t;
        }
        _createButton(e, t, n, i) {
          const s = new kt(this.locale);
          return s.set({ label: e, icon: t, tooltip: !0 }), s.extendTemplate({ attributes: { class: n } }), i && s.delegate("execute").to(this, i), s;
        }
      }
      var gy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18.68 2.53c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.08c0-.58-.01-.55.6-.55h17.38zM15.77 14.5v-10H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 6.677a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V6.676z"/></svg>';
      class vy extends Ae {
        static get requires() {
          return [Mo];
        }
        static get pluginName() {
          return "MediaEmbedUI";
        }
        init() {
          const e = this.editor, t = e.commands.get("mediaEmbed"), n = e.plugins.get(Mo).registry;
          this.form = new my(function(i, s) {
            return [(l) => {
              if (!l.url.length)
                return i("au");
            }, (l) => {
              if (!s.hasMedia(l.url))
                return i("av");
            }];
          }(e.t, n), e.locale), e.ui.componentFactory.add("mediaEmbed", (i) => {
            const s = wr(i);
            return this._setUpDropdown(s, this.form, t, e), this._setUpForm(this.form, s, t), s;
          });
        }
        _setUpDropdown(e, t, n) {
          const i = this.editor, s = i.t, l = e.buttonView;
          function d() {
            i.editing.view.focus(), e.isOpen = !1;
          }
          e.bind("isEnabled").to(n), e.panelView.children.add(t), l.set({ label: s("at"), icon: gy, tooltip: !0 }), l.on("open", () => {
            t.url = n.value || "", t.urlInputView.select(), t.focus();
          }, { priority: "low" }), e.on("submit", () => {
            t.isValid() && (i.execute("mediaEmbed", t.url), d());
          }), e.on("change:isOpen", () => t.resetFormStatus()), e.on("cancel", () => d());
        }
        _setUpForm(e, t, n) {
          e.delegate("submit", "cancel").to(t), e.urlInputView.bind("value").to(n, "value"), e.urlInputView.bind("isReadOnly").to(n, "isEnabled", (i) => !i), e.saveButtonView.bind("isEnabled").to(n);
        }
      }
      p(83);
      function by(o, e) {
        if (!o.childCount)
          return;
        const t = new Io(), n = function(s, l) {
          const d = l.createRangeIn(s), f = new Wn({ name: /^p|h\d+$/, styles: { "mso-list": /.*/ } }), m = [];
          for (const g of d)
            if (g.type === "elementStart" && f.match(g.item)) {
              const b = _y(g.item);
              m.push({ element: g.item, id: b.id, order: b.order, indent: b.indent });
            }
          return m;
        }(o, t);
        if (!n.length)
          return;
        let i = null;
        n.forEach((s, l) => {
          if (!i || function(f, m) {
            if (f.id !== m.id)
              return !0;
            const g = m.element.previousSibling;
            return g ? !Oo(g) : !0;
          }(n[l - 1], s)) {
            const f = function(m, g) {
              const b = /mso-level-number-format:([^;]*);/gi, y = new RegExp(`@list l${m.id}:level${m.indent}\\s*({[^}]*)`, "gi").exec(g);
              let C = "decimal";
              if (y && y[1]) {
                const O = b.exec(y[1]);
                O && O[1] && (C = O[1].trim());
              }
              return { type: C !== "bullet" && C !== "image" ? "ol" : "ul", style: C };
            }(s, e);
            i = function(m, g, b) {
              const y = new tn(m.type), C = g.parent.getChildIndex(g);
              return b.insertChild(C, y, g.parent), y;
            }(f, s.element, t);
          }
          const d = function(f, m) {
            return function(g, b) {
              const y = new Wn({ name: "span", styles: { "mso-list": "Ignore" } }), C = b.createRangeIn(g);
              for (const O of C)
                O.type === "elementStart" && y.match(O.item) && b.remove(O.item);
            }(f, m), m.rename("li", f);
          }(s.element, t);
          t.appendChild(d, i);
        });
      }
      function _y(o) {
        const e = {}, t = o.getStyle("mso-list");
        return t && (e.id = parseInt(t.match(/(^|\s+)l(\d+)/i)[2]), e.order = parseInt(t.match(/\s*lfo(\d+)/i)[1]), e.indent = parseInt(t.match(/\s*level(\d+)/i)[1])), e;
      }
      function Oo(o) {
        return o.is("ol") || o.is("ul");
      }
      const wy = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
      class yy {
        isActive(e) {
          return wy.test(e);
        }
        execute(e) {
          const t = new Io();
          (function(n, i) {
            for (const s of n.getChildren())
              if (s.is("b") && s.getStyle("font-weight") === "normal") {
                const l = n.getChildIndex(s);
                i.remove(s), i.insertChild(l, s.getChildren(), n);
              }
          })(e.content, t), function(n, i) {
            for (const s of i.createRangeIn(n)) {
              const l = s.item;
              if (l.is("li")) {
                const d = l.nextSibling;
                d && Oo(d) && (i.remove(d), i.insertChild(l.childCount, d, l));
              }
              if (Oo(l)) {
                let d = l.getChild(0);
                for (; Oo(d); )
                  i.unwrapElement(d), d = l.getChild(0);
              }
            }
          }(e.content, t), function(n, i) {
            for (const s of i.createRangeIn(n)) {
              const l = s.item;
              if (l.is("li")) {
                const d = l.getChild(0);
                d.is("p") && i.unwrapElement(d);
              }
            }
          }(e.content, t);
        }
      }
      function Xh(o) {
        return o.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (e, t) => t.length === 1 ? " " : Array(t.length + 1).join("\xA0 ").substr(0, t.length));
      }
      function ky(o) {
        const e = new DOMParser(), t = function(d) {
          return Xh(Xh(d)).replace(/(<span style=['"]mso-spacerun:yes['"]>[\s]*?)[\r\n]+(\s*<\/span>)/g, "$1$2").replace(/<span style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, "\xA0</").replace(/ <o:p><\/o:p>/g, "\xA0<o:p></o:p>").replace(/>(\s*[\r\n]\s*)</g, "><");
        }(function(d) {
          const f = d.match(/<\/body>(.*?)(<\/html>|$)/);
          return f && f[1] && (d = d.slice(0, f.index) + d.slice(f.index).replace(f[1], "")), d;
        }(o = o.replace(/<!--\[if gte vml 1]>/g, ""))), n = e.parseFromString(t, "text/html");
        (function(d) {
          d.querySelectorAll("span[style*=spacerun]").forEach((f) => {
            const m = f.childNodes[0].data.length;
            f.innerHTML = Array(m + 1).join("\xA0 ").substr(0, m);
          });
        })(n);
        const i = n.body.innerHTML, s = function(d) {
          const f = new no({ blockFiller: yc }), m = d.createDocumentFragment(), g = d.body.childNodes;
          for (; g.length > 0; )
            m.appendChild(g[0]);
          return f.domToView(m);
        }(n), l = function(d) {
          const f = [], m = [], g = Array.from(d.getElementsByTagName("style"));
          for (const b of g)
            b.sheet && b.sheet.cssRules && b.sheet.cssRules.length && (f.push(b.sheet), m.push(b.innerHTML));
          return { styles: f, stylesString: m.join(" ") };
        }(n);
        return { body: s, bodyString: i, styles: l.styles, stylesString: l.stylesString };
      }
      function xy(o, e) {
        if (!o.childCount)
          return;
        const t = new Io();
        (function(i, s, l) {
          const d = l.createRangeIn(s), f = new Wn({ name: "img" }), m = [];
          for (const g of d)
            if (f.match(g.item)) {
              const b = g.item, y = b.getAttribute("v:shapes") ? b.getAttribute("v:shapes").split(" ") : [];
              y.length && y.every((C) => i.indexOf(C) > -1) ? m.push(b) : b.getAttribute("src") || m.push(b);
            }
          for (const g of m)
            l.remove(g);
        })(function(i, s) {
          const l = s.createRangeIn(i), d = new Wn({ name: /v:(.+)/ }), f = [];
          for (const m of l) {
            const g = m.item, b = g.previousSibling && g.previousSibling.name || null;
            d.match(g) && g.getAttribute("o:gfxdata") && b !== "v:shapetype" && f.push(m.item.getAttribute("id"));
          }
          return f;
        }(o, t), o, t), function(i, s) {
          const l = s.createRangeIn(i), d = new Wn({ name: /v:(.+)/ }), f = [];
          for (const m of l)
            d.match(m.item) && f.push(m.item);
          for (const m of f)
            s.remove(m);
        }(o, t);
        const n = function(i, s) {
          const l = s.createRangeIn(i), d = new Wn({ name: "img" }), f = [];
          for (const m of l)
            d.match(m.item) && m.item.getAttribute("src").startsWith("file://") && f.push(m.item);
          return f;
        }(o, t);
        n.length && function(i, s, l) {
          if (i.length === s.length)
            for (let d = 0; d < i.length; d++) {
              const f = `data:${s[d].type};base64,${Sy(s[d].hex)}`;
              l.setAttribute("src", f, i[d]);
            }
        }(n, function(i) {
          if (!i)
            return [];
          const s = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/, l = new RegExp("(?:(" + s.source + "))([\\da-fA-F\\s]+)\\}", "g"), d = i.match(l), f = [];
          if (d)
            for (const m of d) {
              let g = !1;
              m.includes("\\pngblip") ? g = "image/png" : m.includes("\\jpegblip") && (g = "image/jpeg"), g && f.push({ hex: m.replace(s, "").replace(/[^\da-fA-F]/g, ""), type: g });
            }
          return f;
        }(e), t);
      }
      function Sy(o) {
        return btoa(o.match(/\w{2}/g).map((e) => String.fromCharCode(parseInt(e, 16))).join(""));
      }
      const Cy = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i, Ay = /xmlns:o="urn:schemas-microsoft-com/i;
      class Ty {
        isActive(e) {
          return Cy.test(e) || Ay.test(e);
        }
        execute(e) {
          const { body: t, stylesString: n } = ky(e.dataTransfer.getData("text/html"));
          by(t, n), xy(t, e.dataTransfer.getData("text/rtf")), e.content = t;
        }
      }
      function St(o, e) {
        let t = e.parent;
        for (; t; ) {
          if (t.name === o)
            return t;
          t = t.parent;
        }
      }
      function rn(o, e, t, n, i = 1) {
        e > i ? n.setAttribute(o, e, t) : n.removeAttribute(o, t);
      }
      function Do(o, e, t = {}) {
        const n = o.createElement("tableCell", t);
        o.insertElement("paragraph", n), o.insert(n, e);
      }
      function Iy() {
        return (o) => {
          o.on("element:table", (e, t, n) => {
            const i = t.viewItem;
            if (!n.consumable.test(i, { name: !0 }))
              return;
            const { rows: s, headingRows: l, headingColumns: d } = function(b) {
              const y = { headingRows: 0, headingColumns: 0 }, C = [], O = [];
              let D;
              for (const oe of Array.from(b.getChildren()))
                if (oe.name === "tbody" || oe.name === "thead" || oe.name === "tfoot") {
                  oe.name !== "thead" || D || (D = oe);
                  const ce = Array.from(oe.getChildren()).filter((_e) => _e.is("element", "tr"));
                  for (const _e of ce)
                    if (_e.parent.name === "thead" && _e.parent === D)
                      y.headingRows++, C.push(_e);
                    else {
                      O.push(_e);
                      const De = Ey(_e);
                      De > y.headingColumns && (y.headingColumns = De);
                    }
                }
              return y.rows = [...C, ...O], y;
            }(i), f = {};
            d && (f.headingColumns = d), l && (f.headingRows = l);
            const m = n.writer.createElement("table", f), g = n.splitToAllowedParent(m, t.modelCursor);
            if (g) {
              if (n.writer.insert(m, g.position), n.consumable.consume(i, { name: !0 }), s.length)
                s.forEach((b) => n.convertItem(b, n.writer.createPositionAt(m, "end")));
              else {
                const b = n.writer.createElement("tableRow");
                n.writer.insert(b, n.writer.createPositionAt(m, "end")), Do(n.writer, n.writer.createPositionAt(b, "end"));
              }
              t.modelRange = n.writer.createRange(n.writer.createPositionBefore(m), n.writer.createPositionAfter(m)), g.cursorParent ? t.modelCursor = n.writer.createPositionAt(g.cursorParent, 0) : t.modelCursor = t.modelRange.end;
            }
          });
        };
      }
      function Qh(o) {
        return (e) => {
          e.on(`element:${o}`, (t, n, i) => {
            const s = n.viewItem;
            if (!i.consumable.test(s, { name: !0 }))
              return;
            const l = i.writer.createElement("tableCell"), d = i.splitToAllowedParent(l, n.modelCursor);
            if (!d)
              return;
            i.writer.insert(l, d.position), i.consumable.consume(s, { name: !0 });
            const f = i.writer.createPositionAt(l, 0);
            i.convertChildren(s, f), l.childCount || i.writer.insertElement("paragraph", f), n.modelRange = i.writer.createRange(i.writer.createPositionBefore(l), i.writer.createPositionAfter(l)), n.modelCursor = n.modelRange.end;
          });
        };
      }
      function Ey(o) {
        let e = 0, t = 0;
        const n = Array.from(o.getChildren()).filter((i) => i.name === "th" || i.name === "td");
        for (; t < n.length && n[t].name === "th"; ) {
          const i = n[t];
          e += parseInt(i.getAttribute("colspan") || 1), t++;
        }
        return e;
      }
      class Ct {
        constructor(e, t = {}) {
          this.table = e, this.startRow = t.startRow || 0, this.endRow = typeof t.endRow == "number" ? t.endRow : void 0, this.includeSpanned = !!t.includeSpanned, this.column = typeof t.column == "number" ? t.column : void 0, this._skipRows = /* @__PURE__ */ new Set(), this._row = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = /* @__PURE__ */ new Map(), this._nextCellAtColumn = -1;
        }
        [Symbol.iterator]() {
          return this;
        }
        next() {
          const e = this.table.getChild(this._row);
          if (!e || this._isOverEndRow())
            return { done: !0 };
          let t, n, i;
          if (this._isSpanned(this._row, this._column))
            t = this._getSpanned(this._row, this._column), n = !this.includeSpanned || this._shouldSkipRow() || this._shouldSkipColumn(), i = this._formatOutValue(t, this._column, !0);
          else {
            if (!(t = e.getChild(this._cellIndex)))
              return this._row++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
            const s = parseInt(t.getAttribute("colspan") || 1), l = parseInt(t.getAttribute("rowspan") || 1);
            (s > 1 || l > 1) && this._recordSpans(this._row, this._column, l, s, t), this._nextCellAtColumn = this._column + s, n = this._shouldSkipRow() || this._shouldSkipColumn(), i = this._formatOutValue(t, this._column, !1, l, s);
          }
          return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, n ? this.next() : i;
        }
        skipRow(e) {
          this._skipRows.add(e);
        }
        _isOverEndRow() {
          return this.endRow !== void 0 && this._row > this.endRow;
        }
        _formatOutValue(e, t, n, i = 1, s = 1) {
          return { done: !1, value: { cell: e, row: this._row, column: t, isSpanned: n, rowspan: i, colspan: s, cellIndex: this._cellIndex } };
        }
        _shouldSkipRow() {
          const e = this._row < this.startRow, t = this._skipRows.has(this._row);
          return e || t;
        }
        _shouldSkipColumn() {
          return this.column !== void 0 && this.column != this._column;
        }
        _isSpanned(e, t) {
          return this._spannedCells.has(e) ? this._spannedCells.get(e).has(t) : !1;
        }
        _getSpanned(e, t) {
          return this._spannedCells.get(e).get(t);
        }
        _recordSpans(e, t, n, i, s) {
          for (let l = t + 1; l <= t + i - 1; l++)
            this._markSpannedCell(e, l, s);
          for (let l = e + 1; l < e + n; l++)
            for (let d = t; d <= t + i - 1; d++)
              this._markSpannedCell(l, d, s);
        }
        _markSpannedCell(e, t, n) {
          this._spannedCells.has(e) || this._spannedCells.set(e, /* @__PURE__ */ new Map()), this._spannedCells.get(e).set(t, n);
        }
      }
      function Jh(o) {
        return !!o.getCustomProperty("table") && ui(o);
      }
      function Py(o) {
        const e = o.getSelectedElement();
        return e && Jh(e) ? e : null;
      }
      function My(o) {
        const e = St("table", o.getFirstPosition());
        return e && Jh(e.parent) ? e.parent : null;
      }
      function ef(o = {}) {
        return (e) => e.on("insert:table", (t, n, i) => {
          const s = n.item;
          if (!i.consumable.consume(s, "insert"))
            return;
          i.consumable.consume(s, "attribute:headingRows:table"), i.consumable.consume(s, "attribute:headingColumns:table");
          const l = o && o.asWidget, d = i.writer.createContainerElement("figure", { class: "table" }), f = i.writer.createContainerElement("table");
          let m;
          i.writer.insert(i.writer.createPositionAt(d, 0), f), l && (m = function(O, D) {
            return D.setCustomProperty("table", !0, O), wa(O, D, { hasSelectionHandler: !0 });
          }(d, i.writer));
          const g = new Ct(s), b = { headingRows: s.getAttribute("headingRows") || 0, headingColumns: s.getAttribute("headingColumns") || 0 }, y = /* @__PURE__ */ new Map();
          for (const O of g) {
            const { row: D, cell: oe } = O, ce = No(uf(D, b), f, i), _e = s.getChild(D), De = y.get(D) || lf(_e, D, ce, i);
            y.set(D, De), i.consumable.consume(oe, "insert"), Ha(O, b, i.writer.createPositionAt(De, "end"), i, o);
          }
          const C = i.mapper.toViewPosition(n.range.start);
          i.mapper.bindElements(s, l ? m : d), i.writer.insert(C, l ? m : d);
        });
      }
      function tf(o = {}) {
        return (e) => e.on("insert:tableRow", (t, n, i) => {
          const s = n.item;
          if (!i.consumable.consume(s, "insert"))
            return;
          const l = s.parent, d = pf(i.mapper.toViewElement(l)), f = l.getChildIndex(s), m = new Ct(l, { startRow: f, endRow: f }), g = { headingRows: l.getAttribute("headingRows") || 0, headingColumns: l.getAttribute("headingColumns") || 0 }, b = /* @__PURE__ */ new Map();
          for (const y of m) {
            const C = No(uf(f, g), d, i), O = b.get(f) || lf(s, f, C, i);
            b.set(f, O), i.consumable.consume(y.cell, "insert"), Ha(y, g, i.writer.createPositionAt(O, "end"), i, o);
          }
        });
      }
      function nf(o = {}) {
        return (e) => e.on("insert:tableCell", (t, n, i) => {
          const s = n.item;
          if (!i.consumable.consume(s, "insert"))
            return;
          const l = s.parent, d = l.parent, f = d.getChildIndex(l), m = new Ct(d, { startRow: f, endRow: f }), g = { headingRows: d.getAttribute("headingRows") || 0, headingColumns: d.getAttribute("headingColumns") || 0 };
          for (const b of m)
            if (b.cell === s) {
              const y = i.mapper.toViewElement(l);
              return void Ha(b, g, i.writer.createPositionAt(y, l.getChildIndex(s)), i, o);
            }
        });
      }
      function rf(o = {}) {
        const e = !!o.asWidget;
        return (t) => t.on("attribute:headingRows:table", (n, i, s) => {
          const l = i.item;
          if (!s.consumable.consume(i.item, n.name))
            return;
          const d = pf(s.mapper.toViewElement(l)), f = i.attributeOldValue, m = i.attributeNewValue;
          if (m > f) {
            const b = Array.from(l.getChildren()).filter(({ index: y }) => g(y, f - 1, m));
            ff(b, No("thead", d, s), s, "end");
            for (const y of b)
              for (const C of y.getChildren())
                sf(C, "th", s, e);
            hf("tbody", d, s);
          } else {
            ff(Array.from(l.getChildren()).filter(({ index: C }) => g(C, m - 1, f)).reverse(), No("tbody", d, s), s, 0);
            const b = new Ct(l, { startRow: m && m - 1, endRow: f - 1 }), y = { headingRows: l.getAttribute("headingRows") || 0, headingColumns: l.getAttribute("headingColumns") || 0 };
            for (const C of b)
              af(C, y, s, e);
            hf("thead", d, s);
          }
          function g(b, y, C) {
            return b > y && b < C;
          }
        });
      }
      function of(o = {}) {
        const e = !!o.asWidget;
        return (t) => t.on("attribute:headingColumns:table", (n, i, s) => {
          const l = i.item;
          if (!s.consumable.consume(i.item, n.name))
            return;
          const d = { headingRows: l.getAttribute("headingRows") || 0, headingColumns: l.getAttribute("headingColumns") || 0 }, f = i.attributeOldValue, m = i.attributeNewValue, g = (f > m ? f : m) - 1;
          for (const b of new Ct(l))
            b.column > g || af(b, d, s, e);
        });
      }
      function sf(o, e, t, n) {
        const i = t.writer, s = t.mapper.toViewElement(o);
        if (!s)
          return;
        let l;
        n ? (l = ya(i.createEditableElement(e, s.getAttributes()), i), i.insert(i.createPositionAfter(s), l), i.move(i.createRangeIn(s), i.createPositionAt(l, 0)), i.remove(i.createRangeOn(s))) : l = i.rename(e, s), t.mapper.unbindViewElement(s), t.mapper.bindElements(o, l);
      }
      function af(o, e, t, n) {
        const { cell: i } = o, s = cf(o, e), l = t.mapper.toViewElement(i);
        l && l.name !== s && sf(i, s, t, n);
      }
      function Ha(o, e, t, n, i) {
        const s = i && i.asWidget, l = cf(o, e), d = s ? ya(n.writer.createEditableElement(l), n.writer) : n.writer.createContainerElement(l), f = o.cell, m = f.getChild(0), g = f.childCount === 1 && m.name === "paragraph";
        if (n.writer.insert(t, d), g && !function(b) {
          return !![...b.getAttributeKeys()].length;
        }(m)) {
          const b = f.getChild(0), y = n.writer.createPositionAt(d, "end");
          if (n.consumable.consume(b, "insert"), i.asWidget) {
            const C = n.writer.createContainerElement("span");
            n.mapper.bindElements(b, C), n.writer.insert(y, C), n.mapper.bindElements(f, d);
          } else
            n.mapper.bindElements(f, d), n.mapper.bindElements(b, d);
        } else
          n.mapper.bindElements(f, d);
      }
      function lf(o, e, t, n) {
        n.consumable.consume(o, "insert");
        const i = n.writer.createContainerElement("tr");
        n.mapper.bindElements(o, i);
        const s = o.parent.getAttribute("headingRows") || 0, l = s > 0 && e >= s ? e - s : e, d = n.writer.createPositionAt(t, l);
        return n.writer.insert(d, i), i;
      }
      function cf(o, e) {
        const { row: t, column: n } = o, { headingColumns: i, headingRows: s } = e;
        return s && s > t || i && i > n ? "th" : "td";
      }
      function uf(o, e) {
        return o < e.headingRows ? "thead" : "tbody";
      }
      function No(o, e, t) {
        return df(o, e) || function(i, s, l) {
          const d = l.writer.createContainerElement(i), f = l.writer.createPositionAt(s, i == "tbody" ? "end" : 0);
          return l.writer.insert(f, d), d;
        }(o, e, t);
      }
      function df(o, e) {
        for (const t of e.getChildren())
          if (t.name == o)
            return t;
      }
      function hf(o, e, t) {
        const n = df(o, e);
        n && n.childCount === 0 && t.writer.remove(t.writer.createRangeOn(n));
      }
      function ff(o, e, t, n) {
        for (const i of o) {
          const s = t.mapper.toViewElement(i);
          s && t.writer.move(t.writer.createRangeOn(s), t.writer.createPositionAt(e, n));
        }
      }
      function pf(o) {
        for (const e of o.getChildren())
          if (e.name === "table")
            return e;
      }
      class Oy extends Xe {
        refresh() {
          const e = this.editor.model, t = e.document.selection, n = e.schema, i = function(s) {
            const l = s.parent;
            return l === l.root ? l : l.parent;
          }(t.getFirstPosition());
          this.isEnabled = n.checkChild(i, "table");
        }
        execute(e = {}) {
          const t = this.editor.model, n = t.document.selection, i = this.editor.plugins.get("TableUtils"), s = parseInt(e.rows) || 2, l = parseInt(e.columns) || 2, d = So(n, t);
          t.change((f) => {
            const m = i.createTable(f, s, l);
            t.insertContent(m, d), f.setSelection(f.createPositionAt(m.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }
      class mf extends Xe {
        constructor(e, t = {}) {
          super(e), this.order = t.order || "below";
        }
        refresh() {
          const e = St("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!e;
        }
        execute() {
          const e = this.editor, t = e.model.document.selection, n = e.plugins.get("TableUtils"), i = St("tableCell", t.getFirstPosition()).parent, s = i.parent, l = s.getChildIndex(i), d = this.order === "below" ? l + 1 : l;
          n.insertRows(s, { rows: 1, at: d });
        }
      }
      class gf extends Xe {
        constructor(e, t = {}) {
          super(e), this.order = t.order || "right";
        }
        refresh() {
          const e = St("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!e;
        }
        execute() {
          const e = this.editor, t = e.model.document.selection, n = e.plugins.get("TableUtils"), i = St("tableCell", t.getFirstPosition()), s = i.parent.parent, { column: l } = n.getCellLocation(i), d = this.order === "right" ? l + 1 : l;
          n.insertColumns(s, { columns: 1, at: d });
        }
      }
      class vf extends Xe {
        constructor(e, t = {}) {
          super(e), this.direction = t.direction || "horizontally";
        }
        refresh() {
          const e = St("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!e;
        }
        execute() {
          const e = St("tableCell", this.editor.model.document.selection.getFirstPosition()), t = this.direction === "horizontally", n = this.editor.plugins.get("TableUtils");
          t ? n.splitCellHorizontally(e, 2) : n.splitCellVertically(e, 2);
        }
      }
      class Ro extends Xe {
        constructor(e, t) {
          super(e), this.direction = t.direction, this.isHorizontal = this.direction == "right" || this.direction == "left";
        }
        refresh() {
          const e = this._getMergeableCell();
          this.isEnabled = !!e, this.value = e;
        }
        execute() {
          const e = this.editor.model, t = St("tableCell", e.document.selection.getFirstPosition()), n = this.value, i = this.direction;
          e.change((s) => {
            const l = i == "right" || i == "down", d = l ? t : n, f = l ? n : t, m = f.parent;
            (function(C, O, D) {
              bf(C) || (bf(O) && D.remove(D.createRangeIn(O)), D.move(D.createRangeIn(C), D.createPositionAt(O, "end"))), D.remove(C);
            })(f, d, s);
            const g = this.isHorizontal ? "colspan" : "rowspan", b = parseInt(t.getAttribute(g) || 1), y = parseInt(n.getAttribute(g) || 1);
            s.setAttribute(g, b + y, d), s.setSelection(s.createRangeIn(d)), m.childCount || function(C, O) {
              const D = C.parent, oe = D.getChildIndex(C);
              for (const { cell: ce, row: _e, rowspan: De } of new Ct(D, { endRow: oe }))
                _e + De - 1 >= oe && rn("rowspan", De - 1, ce, O);
              O.remove(C);
            }(m, s);
          });
        }
        _getMergeableCell() {
          const e = St("tableCell", this.editor.model.document.selection.getFirstPosition());
          if (!e)
            return;
          const t = this.editor.plugins.get("TableUtils"), n = this.isHorizontal ? function(l, d, f) {
            const m = d == "right" ? l.nextSibling : l.previousSibling;
            if (!m)
              return;
            const g = d == "right" ? l : m, b = d == "right" ? m : l, { column: y } = f.getCellLocation(g), { column: C } = f.getCellLocation(b), O = parseInt(g.getAttribute("colspan") || 1);
            return y + O === C ? m : void 0;
          }(e, this.direction, t) : function(l, d) {
            const f = l.parent, m = f.parent, g = m.getChildIndex(f);
            if (d == "down" && g === m.childCount - 1 || d == "up" && g === 0)
              return;
            const b = parseInt(l.getAttribute("rowspan") || 1), y = m.getAttribute("headingRows") || 0;
            if (y && (d == "down" && g + b === y || d == "up" && g === y))
              return;
            const C = parseInt(l.getAttribute("rowspan") || 1), O = d == "down" ? g + C : g, D = [...new Ct(m, { endRow: O })], oe = D.find((_e) => _e.cell === l).column, ce = D.find(({ row: _e, rowspan: De, column: mt }) => mt === oe && (d == "down" ? _e === O : O === _e + De));
            return ce && ce.cell;
          }(e, this.direction);
          if (!n)
            return;
          const i = this.isHorizontal ? "rowspan" : "colspan", s = parseInt(e.getAttribute(i) || 1);
          return parseInt(n.getAttribute(i) || 1) === s ? n : void 0;
        }
      }
      function bf(o) {
        return o.childCount == 1 && o.getChild(0).is("paragraph") && o.getChild(0).isEmpty;
      }
      class Dy extends Xe {
        refresh() {
          const e = St("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!e && e.parent.parent.childCount > 1;
        }
        execute() {
          const e = this.editor.model, t = St("tableCell", e.document.selection.getFirstPosition()).parent, n = t.parent, i = n.getChildIndex(t), s = n.getAttribute("headingRows") || 0;
          e.change((l) => {
            s && i <= s && rn("headingRows", s - 1, n, l, 0);
            const d = [...new Ct(n, { endRow: i })], f = /* @__PURE__ */ new Map();
            d.filter(({ row: y, rowspan: C }) => y === i && C > 1).forEach(({ column: y, cell: C, rowspan: O }) => f.set(y, { cell: C, rowspanToSet: O - 1 })), d.filter(({ row: y, rowspan: C }) => y <= i - 1 && y + C > i).forEach(({ cell: y, rowspan: C }) => rn("rowspan", C - 1, y, l));
            const m = i + 1, g = new Ct(n, { includeSpanned: !0, startRow: m, endRow: m });
            let b;
            for (const { row: y, column: C, cell: O } of [...g])
              if (f.has(C)) {
                const { cell: D, rowspanToSet: oe } = f.get(C), ce = b ? l.createPositionAfter(b) : l.createPositionAt(n.getChild(y), 0);
                l.move(l.createRangeOn(D), ce), rn("rowspan", oe, D, l), b = D;
              } else
                b = O;
            l.remove(t);
          });
        }
      }
      class Ny extends Xe {
        refresh() {
          const e = this.editor, t = e.model.document.selection, n = e.plugins.get("TableUtils"), i = St("tableCell", t.getFirstPosition());
          this.isEnabled = !!i && n.getColumns(i.parent.parent) > 1;
        }
        execute() {
          const e = this.editor.model, t = St("tableCell", e.document.selection.getFirstPosition()), n = t.parent, i = n.parent, s = i.getAttribute("headingColumns") || 0, l = i.getChildIndex(n), d = [...new Ct(i)], f = d.find((m) => m.cell === t).column;
          e.change((m) => {
            s && l <= s && m.setAttribute("headingColumns", s - 1, i);
            for (const { cell: g, column: b, colspan: y } of d)
              b <= f && y > 1 && b + y > f ? rn("colspan", y - 1, g, m) : b === f && m.remove(g);
          });
        }
      }
      class Ry extends Xe {
        refresh() {
          const e = St("tableCell", this.editor.model.document.selection.getFirstPosition()), t = !!e;
          this.isEnabled = t, this.value = t && this._isInHeading(e, e.parent.parent);
        }
        execute(e = {}) {
          const t = this.editor.model, n = St("tableCell", t.document.selection.getFirstPosition()).parent, i = n.parent, s = i.getAttribute("headingRows") || 0, l = n.index;
          if (e.forceValue === this.value)
            return;
          const d = this.value ? l : l + 1;
          t.change((f) => {
            if (d) {
              const m = function(g, b, y) {
                const C = [], O = new Ct(g, { startRow: b > y ? y : 0, endRow: b - 1 });
                for (const { row: D, rowspan: oe, cell: ce } of O)
                  oe > 1 && D + oe > b && C.push(ce);
                return C;
              }(i, d, s);
              for (const g of m)
                Ly(g, d, f);
            }
            rn("headingRows", d, i, f, 0);
          });
        }
        _isInHeading(e, t) {
          const n = parseInt(t.getAttribute("headingRows") || 0);
          return !!n && e.parent.index < n;
        }
      }
      function Ly(o, e, t) {
        const n = o.parent, i = n.parent, s = e - n.index, l = {}, d = parseInt(o.getAttribute("rowspan")) - s;
        d > 1 && (l.rowspan = d);
        const f = parseInt(o.getAttribute("colspan") || 1);
        f > 1 && (l.colspan = f);
        const m = i.getChildIndex(n), g = m + s, b = [...new Ct(i, { startRow: m, endRow: g, includeSpanned: !0 })];
        let y;
        for (const { row: C, column: O, cell: D, cellIndex: oe } of b)
          if (D === o && y === void 0 && (y = O), y !== void 0 && y === O && C === g) {
            const ce = i.getChild(C);
            Do(t, t.createPositionAt(ce, oe), l);
          }
        rn("rowspan", s, o, t);
      }
      class Fy extends Xe {
        refresh() {
          const e = St("tableCell", this.editor.model.document.selection.getFirstPosition()), t = !!e;
          this.isEnabled = t, this.value = t && this._isInHeading(e, e.parent.parent);
        }
        execute(e = {}) {
          const t = this.editor.model, n = t.document.selection, i = this.editor.plugins.get("TableUtils"), s = St("tableCell", n.getFirstPosition()), l = s.parent.parent, { column: d } = i.getCellLocation(s);
          if (e.forceValue === this.value)
            return;
          const f = this.value ? d : d + 1;
          t.change((m) => {
            rn("headingColumns", f, l, m, 0);
          });
        }
        _isInHeading(e, t) {
          const n = parseInt(t.getAttribute("headingColumns") || 0), i = this.editor.plugins.get("TableUtils"), { column: s } = i.getCellLocation(e);
          return !!n && s < n;
        }
      }
      class zy extends Ae {
        static get pluginName() {
          return "TableUtils";
        }
        getCellLocation(e) {
          const t = e.parent, n = t.parent, i = n.getChildIndex(t), s = new Ct(n, { startRow: i, endRow: i });
          for (const { cell: l, row: d, column: f } of s)
            if (l === e)
              return { row: d, column: f };
        }
        createTable(e, t, n) {
          const i = e.createElement("table");
          return Lo(e, i, 0, t, n), i;
        }
        insertRows(e, t = {}) {
          const n = this.editor.model, i = t.at || 0, s = t.rows || 1;
          n.change((l) => {
            const d = e.getAttribute("headingRows") || 0;
            if (d > i && l.setAttribute("headingRows", d + s, e), i === 0 || i === e.childCount)
              return void Lo(l, e, i, s, this.getColumns(e));
            const f = new Ct(e, { endRow: i });
            let m = 0;
            for (const { row: g, rowspan: b, colspan: y, cell: C } of f)
              g < i && g + b > i && l.setAttribute("rowspan", b + s, C), g === i && (m += y);
            Lo(l, e, i, s, m);
          });
        }
        insertColumns(e, t = {}) {
          const n = this.editor.model, i = t.at || 0, s = t.columns || 1;
          n.change((l) => {
            const d = e.getAttribute("headingColumns");
            i < d && l.setAttribute("headingColumns", d + s, e);
            const f = this.getColumns(e);
            if (i === 0 || f === i) {
              for (const g of e.getChildren())
                Gi(s, l, l.createPositionAt(g, i ? "end" : 0));
              return;
            }
            const m = new Ct(e, { column: i, includeSpanned: !0 });
            for (const { row: g, cell: b, cellIndex: y } of m) {
              const C = parseInt(b.getAttribute("rowspan") || 1), O = parseInt(b.getAttribute("colspan") || 1);
              if (b.index !== i && O > 1) {
                if (l.setAttribute("colspan", O + s, b), m.skipRow(g), C > 1)
                  for (let D = g + 1; D < g + C; D++)
                    m.skipRow(D);
              } else {
                const D = l.createPositionAt(e.getChild(g), y);
                Gi(s, l, D);
              }
            }
          });
        }
        splitCellVertically(e, t = 2) {
          const n = this.editor.model, i = e.parent.parent, s = parseInt(e.getAttribute("rowspan") || 1), l = parseInt(e.getAttribute("colspan") || 1);
          n.change((d) => {
            if (l > 1) {
              const { newCellsSpan: f, updatedSpan: m } = _f(l, t);
              rn("colspan", m, e, d);
              const g = {};
              f > 1 && (g.colspan = f), s > 1 && (g.rowspan = s), Gi(l > t ? t - 1 : l - 1, d, d.createPositionAfter(e), g);
            }
            if (l < t) {
              const f = t - l, m = [...new Ct(i)], { column: g } = m.find(({ cell: O }) => O === e), b = m.filter(({ cell: O, colspan: D, column: oe }) => O !== e && oe === g || oe < g && oe + D > g);
              for (const { cell: O, colspan: D } of b)
                d.setAttribute("colspan", D + f, O);
              const y = {};
              s > 1 && (y.rowspan = s), Gi(f, d, d.createPositionAfter(e), y);
              const C = i.getAttribute("headingColumns") || 0;
              C > g && rn("headingColumns", C + f, i, d);
            }
          });
        }
        splitCellHorizontally(e, t = 2) {
          const n = this.editor.model, i = e.parent, s = i.parent, l = s.getChildIndex(i), d = parseInt(e.getAttribute("rowspan") || 1), f = parseInt(e.getAttribute("colspan") || 1);
          n.change((m) => {
            if (d > 1) {
              const g = [...new Ct(s, { startRow: l, endRow: l + d - 1, includeSpanned: !0 })], { newCellsSpan: b, updatedSpan: y } = _f(d, t);
              rn("rowspan", y, e, m);
              const { column: C } = g.find(({ cell: D }) => D === e), O = {};
              b > 1 && (O.rowspan = b), f > 1 && (O.colspan = f);
              for (const { column: D, row: oe, cellIndex: ce } of g)
                oe >= l + y && D === C && (oe + l + y) % b == 0 && Gi(1, m, m.createPositionAt(s.getChild(oe), ce), O);
            }
            if (d < t) {
              const g = t - d, b = [...new Ct(s, { startRow: 0, endRow: l })];
              for (const { cell: O, rowspan: D, row: oe } of b)
                if (O !== e && oe + D > l) {
                  const ce = D + g;
                  m.setAttribute("rowspan", ce, O);
                }
              const y = {};
              f > 1 && (y.colspan = f), Lo(m, s, l + 1, g, 1, y);
              const C = s.getAttribute("headingRows") || 0;
              C > l && rn("headingRows", C + g, s, m);
            }
          });
        }
        getColumns(e) {
          return [...e.getChild(0).getChildren()].reduce((t, n) => t + parseInt(n.getAttribute("colspan") || 1), 0);
        }
      }
      function Lo(o, e, t, n, i, s = {}) {
        for (let l = 0; l < n; l++) {
          const d = o.createElement("tableRow");
          o.insert(d, e, t), Gi(i, o, o.createPositionAt(d, "end"), s);
        }
      }
      function Gi(o, e, t, n = {}) {
        for (let i = 0; i < o; i++)
          Do(e, t, n);
      }
      function _f(o, e) {
        if (o < e)
          return { newCellsSpan: 1, updatedSpan: 1 };
        const t = Math.floor(o / e);
        return { newCellsSpan: t, updatedSpan: o - t * e + t };
      }
      function $y(o) {
        o.document.registerPostFixer((e) => function(t, n) {
          const i = n.document.differ.getChanges();
          let s = !1;
          const l = /* @__PURE__ */ new Set();
          for (const d of i) {
            let f;
            d.name == "table" && d.type == "insert" && (f = d.position.nodeAfter), d.name != "tableRow" && d.name != "tableCell" || (f = St("table", d.position)), Vy(d) && (f = St("table", d.range.start)), f && !l.has(f) && (s = jy(f, t) || s, s = By(f, t) || s, l.add(f));
          }
          return s;
        }(e, o));
      }
      function jy(o, e) {
        let t = !1;
        const n = function(i) {
          const s = parseInt(i.getAttribute("headingRows") || 0), l = i.childCount, d = [];
          for (const { row: f, rowspan: m, cell: g } of new Ct(i)) {
            if (m < 2)
              continue;
            const b = f < s, y = b ? s : l;
            if (f + m > y) {
              const C = y - f;
              d.push({ cell: g, rowspan: C });
            }
          }
          return d;
        }(o);
        if (n.length) {
          t = !0;
          for (const i of n)
            rn("rowspan", i.rowspan, i.cell, e, 1);
        }
        return t;
      }
      function By(o, e) {
        let t = !1;
        const n = function(s) {
          const l = {};
          for (const { row: d } of new Ct(s, { includeSpanned: !0 }))
            l[d] || (l[d] = 0), l[d] += 1;
          return l;
        }(o), i = n[0];
        if (!Object.values(n).every((s) => s === i)) {
          const s = Object.values(n).reduce((l, d) => d > l ? d : l, 0);
          for (const [l, d] of Object.entries(n)) {
            const f = s - d;
            if (f) {
              for (let m = 0; m < f; m++)
                Do(e, e.createPositionAt(o.getChild(l), "end"));
              t = !0;
            }
          }
        }
        return t;
      }
      function Vy(o) {
        const e = o.type === "attribute", t = o.attributeKey;
        return e && (t === "headingRows" || t === "colspan" || t === "rowspan");
      }
      function Uy(o) {
        o.document.registerPostFixer((e) => function(t, n) {
          const i = n.document.differ.getChanges();
          let s = !1;
          for (const l of i)
            l.type == "insert" && l.name == "table" && (s = Hy(l.position.nodeAfter, t) || s), l.type == "insert" && l.name == "tableRow" && (s = wf(l.position.nodeAfter, t) || s), l.type == "insert" && l.name == "tableCell" && (s = Wa(l.position.nodeAfter, t) || s), Wy(l) && (s = Wa(l.position.parent, t) || s);
          return s;
        }(e, o));
      }
      function Hy(o, e) {
        let t = !1;
        for (const n of o.getChildren())
          t = wf(n, e) || t;
        return t;
      }
      function wf(o, e) {
        let t = !1;
        for (const n of o.getChildren())
          t = Wa(n, e) || t;
        return t;
      }
      function Wa(o, e) {
        if (o.childCount == 0)
          return e.insertElement("paragraph", o), !0;
        const t = Array.from(o.getChildren()).filter((n) => n.is("text"));
        for (const n of t)
          e.wrap(e.createRangeOn(n), "paragraph");
        return !!t.length;
      }
      function Wy(o) {
        return !(!o.position || !o.position.parent.is("tableCell")) && (o.type == "insert" && o.name == "$text" || o.type == "remove");
      }
      function Yy(o) {
        o.document.registerPostFixer(() => function(e) {
          const t = e.document.differ, n = /* @__PURE__ */ new Set();
          for (const i of t.getChanges()) {
            const s = i.type == "insert" || i.type == "remove" ? i.position.parent : i.range.start.parent;
            s.is("tableCell") && qy(s, i.type) && n.add(s);
          }
          if (n.size) {
            for (const i of n.values())
              t.refreshItem(i);
            return !0;
          }
          return !1;
        }(o));
      }
      function qy(o, e) {
        if (!Array.from(o.getChildren()).some((t) => t.is("paragraph")))
          return !1;
        if (e == "attribute") {
          const t = Array.from(o.getChild(0).getAttributeKeys()).length;
          return o.childCount === 1 && t < 2;
        }
        return o.childCount <= (e == "insert" ? 2 : 1);
      }
      p(85);
      class Gy extends Ae {
        init() {
          const e = this.editor, t = e.model, n = t.schema, i = e.conversion;
          n.register("table", { allowWhere: "$block", allowAttributes: ["headingRows", "headingColumns"], isLimit: !0, isObject: !0, isBlock: !0 }), n.register("tableRow", { allowIn: "table", isLimit: !0 }), n.register("tableCell", { allowIn: "tableRow", allowAttributes: ["colspan", "rowspan"], isLimit: !0 }), n.extend("$block", { allowIn: "tableCell" }), n.addChildCheck((s, l) => {
            if (l.name == "table" && Array.from(s.getNames()).includes("table"))
              return !1;
          }), i.for("upcast").add(Iy()), i.for("editingDowncast").add(ef({ asWidget: !0 })), i.for("dataDowncast").add(ef()), i.for("upcast").elementToElement({ model: "tableRow", view: "tr" }), i.for("editingDowncast").add(tf({ asWidget: !0 })), i.for("dataDowncast").add(tf()), i.for("downcast").add((s) => s.on("remove:tableRow", (l, d, f) => {
            l.stop();
            const m = f.writer, g = f.mapper, b = g.toViewPosition(d.position).getLastMatchingPosition((D) => !D.item.is("tr")).nodeAfter, y = b.parent, C = m.createRangeOn(b), O = m.remove(C);
            for (const D of m.createRangeIn(O).getItems())
              g.unbindViewElement(D);
            y.childCount || m.remove(m.createRangeOn(y));
          }, { priority: "higher" })), i.for("upcast").add(Qh("td")), i.for("upcast").add(Qh("th")), i.for("editingDowncast").add(nf({ asWidget: !0 })), i.for("dataDowncast").add(nf()), i.attributeToAttribute({ model: "colspan", view: "colspan" }), i.attributeToAttribute({ model: "rowspan", view: "rowspan" }), i.for("editingDowncast").add(of({ asWidget: !0 })), i.for("dataDowncast").add(of()), i.for("editingDowncast").add(rf({ asWidget: !0 })), i.for("dataDowncast").add(rf()), e.commands.add("insertTable", new Oy(e)), e.commands.add("insertTableRowAbove", new mf(e, { order: "above" })), e.commands.add("insertTableRowBelow", new mf(e, { order: "below" })), e.commands.add("insertTableColumnLeft", new gf(e, { order: "left" })), e.commands.add("insertTableColumnRight", new gf(e, { order: "right" })), e.commands.add("removeTableRow", new Dy(e)), e.commands.add("removeTableColumn", new Ny(e)), e.commands.add("splitTableCellVertically", new vf(e, { direction: "vertically" })), e.commands.add("splitTableCellHorizontally", new vf(e, { direction: "horizontally" })), e.commands.add("mergeTableCellRight", new Ro(e, { direction: "right" })), e.commands.add("mergeTableCellLeft", new Ro(e, { direction: "left" })), e.commands.add("mergeTableCellDown", new Ro(e, { direction: "down" })), e.commands.add("mergeTableCellUp", new Ro(e, { direction: "up" })), e.commands.add("setTableColumnHeader", new Fy(e)), e.commands.add("setTableRowHeader", new Ry(e)), $y(t), Yy(t), Uy(t), this.editor.keystrokes.set("Tab", (...s) => this._handleTabOnSelectedTable(...s), { priority: "low" }), this.editor.keystrokes.set("Tab", this._getTabHandler(!0), { priority: "low" }), this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), { priority: "low" });
        }
        static get requires() {
          return [zy];
        }
        _handleTabOnSelectedTable(e, t) {
          const n = this.editor, i = n.model.document.selection;
          if (!i.isCollapsed && i.rangeCount === 1 && i.getFirstRange().isFlat) {
            const s = i.getSelectedElement();
            if (!s || !s.is("table"))
              return;
            t(), n.model.change((l) => {
              l.setSelection(l.createRangeIn(s.getChild(0).getChild(0)));
            });
          }
        }
        _getTabHandler(e) {
          const t = this.editor;
          return (n, i) => {
            const s = St("tableCell", t.model.document.selection.getFirstPosition());
            if (!s)
              return;
            i();
            const l = s.parent, d = l.parent, f = d.getChildIndex(l), m = l.getChildIndex(s), g = m === 0;
            if (!e && g && f === 0)
              return;
            const b = m === l.childCount - 1, y = f === d.childCount - 1;
            if (e && y && b && (t.execute("insertTableRowBelow"), f === d.childCount - 1))
              return;
            let C;
            if (e && b)
              C = d.getChild(f + 1).getChild(0);
            else if (!e && g) {
              const O = d.getChild(f - 1);
              C = O.getChild(O.childCount - 1);
            } else
              C = l.getChild(m + (e ? 1 : -1));
            t.model.change((O) => {
              O.setSelection(O.createRangeIn(C));
            });
          };
        }
      }
      p(87);
      class Zy extends Ge {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.items = this.createCollection(), this.set("rows", 0), this.set("columns", 0), this.bind("label").to(this, "columns", this, "rows", (n, i) => `${i} \xD7 ${n}`), this.setTemplate({ tag: "div", attributes: { class: ["ck"] }, children: [{ tag: "div", attributes: { class: ["ck-insert-table-dropdown__grid"] }, children: this.items }, { tag: "div", attributes: { class: ["ck-insert-table-dropdown__label"] }, children: [{ text: t.to("label") }] }], on: { mousedown: t.to((n) => {
            n.preventDefault();
          }), click: t.to(() => {
            this.fire("execute");
          }) } });
          for (let n = 0; n < 100; n++) {
            const i = new Ky();
            i.on("over", () => {
              const s = Math.floor(n / 10), l = n % 10;
              this.set("rows", s + 1), this.set("columns", l + 1);
            }), this.items.add(i);
          }
          this.on("change:columns", () => {
            this._highlightGridBoxes();
          }), this.on("change:rows", () => {
            this._highlightGridBoxes();
          });
        }
        focus() {
        }
        focusLast() {
        }
        _highlightGridBoxes() {
          const e = this.rows, t = this.columns;
          this.items.map((n, i) => {
            const s = Math.floor(i / 10) < e && i % 10 < t;
            n.set("isOn", s);
          });
        }
      }
      class Ky extends Ge {
        constructor(e) {
          super(e);
          const t = this.bindTemplate;
          this.set("isOn", !1), this.setTemplate({ tag: "div", attributes: { class: ["ck-insert-table-dropdown-grid-box", t.if("isOn", "ck-on")] }, on: { mouseover: t.to("over") } });
        }
      }
      var Xy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>', Qy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', Jy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', ek = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>';
      class tk extends Ae {
        init() {
          const e = this.editor, t = this.editor.t;
          e.ui.componentFactory.add("insertTable", (n) => {
            const i = e.commands.get("insertTable"), s = wr(n);
            s.bind("isEnabled").to(i), s.buttonView.set({ icon: Xy, label: t("y"), tooltip: !0 });
            const l = new Zy(n);
            return s.panelView.children.add(l), l.delegate("execute").to(s), s.buttonView.on("open", () => {
              l.rows = 0, l.columns = 0;
            }), s.on("execute", () => {
              e.execute("insertTable", { rows: l.rows, columns: l.columns }), e.editing.view.focus();
            }), s;
          }), e.ui.componentFactory.add("tableColumn", (n) => {
            const i = [{ type: "switchbutton", model: { commandName: "setTableColumnHeader", label: t("z"), bindIsOn: !0 } }, { type: "separator" }, { type: "button", model: { commandName: "insertTableColumnLeft", label: t("aa") } }, { type: "button", model: { commandName: "insertTableColumnRight", label: t("ab") } }, { type: "button", model: { commandName: "removeTableColumn", label: t("ac") } }];
            return this._prepareDropdown(t("ad"), Qy, i, n);
          }), e.ui.componentFactory.add("tableRow", (n) => {
            const i = [{ type: "switchbutton", model: { commandName: "setTableRowHeader", label: t("ae"), bindIsOn: !0 } }, { type: "separator" }, { type: "button", model: { commandName: "insertTableRowBelow", label: t("af") } }, { type: "button", model: { commandName: "insertTableRowAbove", label: t("ag") } }, { type: "button", model: { commandName: "removeTableRow", label: t("ah") } }];
            return this._prepareDropdown(t("ai"), Jy, i, n);
          }), e.ui.componentFactory.add("mergeTableCells", (n) => {
            const i = [{ type: "button", model: { commandName: "mergeTableCellUp", label: t("aj") } }, { type: "button", model: { commandName: "mergeTableCellRight", label: t("ak") } }, { type: "button", model: { commandName: "mergeTableCellDown", label: t("al") } }, { type: "button", model: { commandName: "mergeTableCellLeft", label: t("am") } }, { type: "separator" }, { type: "button", model: { commandName: "splitTableCellVertically", label: t("an") } }, { type: "button", model: { commandName: "splitTableCellHorizontally", label: t("ao") } }];
            return this._prepareDropdown(t("ap"), ek, i, n);
          });
        }
        _prepareDropdown(e, t, n, i) {
          const s = this.editor, l = wr(i), d = [], f = new _n();
          for (const m of n)
            nk(m, s, d, f);
          return od(l, f), l.buttonView.set({ label: e, icon: t, tooltip: !0 }), l.bind("isEnabled").toMany(d, "isEnabled", (...m) => m.some((g) => g)), this.listenTo(l, "execute", (m) => {
            s.execute(m.source.commandName), s.editing.view.focus();
          }), l;
        }
      }
      function nk(o, e, t, n) {
        const i = o.model = new Ma(o.model), { commandName: s, bindIsOn: l } = o.model;
        if (o.type !== "separator") {
          const d = e.commands.get(s);
          t.push(d), i.set({ commandName: s }), i.bind("isEnabled").to(d), l && i.bind("isOn").to(d, "value");
        }
        i.set({ withText: !0 }), n.add(o);
      }
      p(89);
      class ik extends Ae {
        init() {
          this.buttons = [], (this.editor.config.get("simpleButton") || []).forEach((e) => this.createToolbarButton(e)), this.editor.on("change:isReadOnly", () => {
            this.buttons.forEach((e) => {
              e._syncDisabledState && (e.isEnabled = !this.editor.isReadOnly);
            });
          });
        }
        createToolbarButton(e) {
          const t = this.editor;
          t.ui.componentFactory.add(e.name, (n) => {
            const i = this.createButton(e, n);
            return i.isEnabled = !0, i._syncDisabledState = typeof e.syncDisabledState != "boolean" || e.syncDisabledState, this.listenTo(i, "execute", () => {
              this.enableButton(i, !1), Promise.resolve(e.onClick(i, t)).then(() => this.enableButton(i, !0)).catch(() => this.enableButton(i, !0));
            }), this.buttons.push(i), i;
          });
        }
        enableButton(e, t) {
          e._syncDisabledState ? e.isEnabled = !this.editor.isReadOnly && t : e.isEnabled = t;
        }
        createButton(e, t) {
          const n = new kt(t);
          return n.set({ label: e.label, icon: e.icon, tooltip: e.tooltip, isToggleable: e.isToggleable || !1, isOn: e.isOn || !1, withText: e.withText || !1, class: e.class, _tooltipString: e._tooltipString || e.label }), n;
        }
      }
      p.d(u, "default", function() {
        return Ya;
      });
      class Ya extends oa {
      }
      Ya.builtinPlugins = [class extends Ae {
        static get requires() {
          return [Lb, Ub];
        }
        static get pluginName() {
          return "Alignment";
        }
      }, class extends Ae {
        static get requires() {
          return [bo, qb, Zb, i_, Td];
        }
        static get pluginName() {
          return "Essentials";
        }
      }, Dd, class extends Ae {
        static get pluginName() {
          return "Autoformat";
        }
        afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats();
        }
        _addListAutoformats() {
          const o = this.editor.commands;
          o.get("bulletedList") && new _o(this.editor, /^[*-]\s$/, "bulletedList"), o.get("numberedList") && new _o(this.editor, /^1[.|)]\s$/, "numberedList");
        }
        _addBasicStylesAutoformats() {
          const o = this.editor.commands;
          if (o.get("bold")) {
            const e = fa(this.editor, "bold");
            new yr(this.editor, /(\*\*)([^*]+)(\*\*)$/g, e), new yr(this.editor, /(__)([^_]+)(__)$/g, e);
          }
          if (o.get("italic")) {
            const e = fa(this.editor, "italic");
            new yr(this.editor, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, e), new yr(this.editor, /(?:^|[^_])(_)([^_]+)(_)$/g, e);
          }
          if (o.get("code")) {
            const e = fa(this.editor, "code");
            new yr(this.editor, /(`)([^`]+)(`)$/g, e);
          }
        }
        _addHeadingAutoformats() {
          const o = this.editor.commands.get("heading");
          o && o.modelElements.filter((e) => e.match(/^heading[1-6]$/)).forEach((e) => {
            const t = e[7], n = new RegExp(`^(#{${t}})\\s$`);
            new _o(this.editor, n, () => {
              if (!o.isEnabled)
                return !1;
              this.editor.execute("heading", { value: e });
            });
          });
        }
        _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && new _o(this.editor, /^>\s$/, "blockQuote");
        }
      }, class extends Ae {
        static get requires() {
          return [p_, g_];
        }
        static get pluginName() {
          return "Bold";
        }
      }, class extends Ae {
        static get requires() {
          return [v_, __];
        }
        static get pluginName() {
          return "Italic";
        }
      }, class extends Ae {
        static get requires() {
          return [y_, x_];
        }
        static get pluginName() {
          return "BlockQuote";
        }
      }, class extends Ae {
        static get pluginName() {
          return "CKFinder";
        }
        static get requires() {
          return [T_, C_, Dd];
        }
      }, class extends Ae {
        static get requires() {
          return [ko, Zd, nh];
        }
        static get pluginName() {
          return "EasyImage";
        }
      }, class extends Ae {
        static get requires() {
          return [uw, dw];
        }
        static get pluginName() {
          return "Heading";
        }
      }, Zd, class extends Ae {
        static get requires() {
          return [fw];
        }
        static get pluginName() {
          return "ImageCaption";
        }
      }, class extends Ae {
        static get requires() {
          return [gw, vw];
        }
        static get pluginName() {
          return "ImageStyle";
        }
      }, class extends Ae {
        static get requires() {
          return [Po];
        }
        static get pluginName() {
          return "ImageToolbar";
        }
        afterInit() {
          const o = this.editor, e = o.t;
          o.plugins.get(Po).register("image", { ariaLabel: e("b"), items: o.config.get("image.toolbar") || [], getRelatedElement: ka });
        }
      }, nh, class extends Ae {
        static get requires() {
          return [Bw, Gw];
        }
        static get pluginName() {
          return "Link";
        }
      }, class extends Ae {
        static get requires() {
          return [ry, ay];
        }
        static get pluginName() {
          return "List";
        }
      }, class extends Ae {
        static get requires() {
          return [Mo, vy, py, xa];
        }
        static get pluginName() {
          return "MediaEmbed";
        }
      }, qi, class extends Ae {
        static get pluginName() {
          return "PasteFromOffice";
        }
        static get requires() {
          return [bo];
        }
        init() {
          const o = this.editor, e = [];
          e.push(new Ty()), e.push(new yy()), o.plugins.get("Clipboard").on("inputTransformation", (t, n) => {
            if (n.isTransformedWithPasteFromOffice)
              return;
            const i = n.dataTransfer.getData("text/html"), s = e.find((l) => l.isActive(i));
            s && (s.execute(n), n.isTransformedWithPasteFromOffice = !0);
          }, { priority: "high" });
        }
      }, class extends Ae {
        static get requires() {
          return [ik];
        }
        static get pluginName() {
          return "simpleButton";
        }
      }, class extends Ae {
        static get requires() {
          return [Gy, tk, xa];
        }
        static get pluginName() {
          return "Table";
        }
      }, class extends Ae {
        static get requires() {
          return [Po];
        }
        static get pluginName() {
          return "TableToolbar";
        }
        afterInit() {
          const o = this.editor, e = o.t, t = o.plugins.get(Po), n = o.config.get("table.contentToolbar"), i = o.config.get("table.tableToolbar");
          n && t.register("tableContent", { ariaLabel: e("c"), items: n, getRelatedElement: My }), i && t.register("table", { ariaLabel: e("c"), items: i, getRelatedElement: Py });
        }
      }], Ya.defaultConfig = { toolbar: { items: ["heading", "|", "bold", "italic", "link", "alignment", "bulletedList", "numberedList", "imageUpload", "blockQuote", "insertTable", "mediaEmbed", "undo", "redo"] }, image: { toolbar: ["imageStyle:full", "imageStyle:side", "|", "imageTextAlternative"] }, table: { contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"] }, language: "en" };
    }]).default;
  });
})(_l, _l.exports);
const wP = /* @__PURE__ */ yl(_l.exports);
var Qp = { exports: {} };
/*!
 * @license Copyright (c) 2003-2022, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function(a, r) {
  (function(c, u) {
    a.exports = u(ue);
  })(window, function(c) {
    return function(u) {
      var p = {};
      function h(v) {
        if (p[v])
          return p[v].exports;
        var w = p[v] = { i: v, l: !1, exports: {} };
        return u[v].call(w.exports, w, w.exports, h), w.l = !0, w.exports;
      }
      return h.m = u, h.c = p, h.d = function(v, w, x) {
        h.o(v, w) || Object.defineProperty(v, w, { enumerable: !0, get: x });
      }, h.r = function(v) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(v, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(v, "__esModule", { value: !0 });
      }, h.t = function(v, w) {
        if (1 & w && (v = h(v)), 8 & w || 4 & w && typeof v == "object" && v && v.__esModule)
          return v;
        var x = /* @__PURE__ */ Object.create(null);
        if (h.r(x), Object.defineProperty(x, "default", { enumerable: !0, value: v }), 2 & w && typeof v != "string")
          for (var k in v)
            h.d(x, k, function(P) {
              return v[P];
            }.bind(null, k));
        return x;
      }, h.n = function(v) {
        var w = v && v.__esModule ? function() {
          return v.default;
        } : function() {
          return v;
        };
        return h.d(w, "a", w), w;
      }, h.o = function(v, w) {
        return Object.prototype.hasOwnProperty.call(v, w);
      }, h.p = "", h(h.s = 3);
    }([function(u, p) {
      u.exports = c;
    }, function(u, p, h) {
      (function(v) {
        var w = typeof v == "object" && v && v.Object === Object && v;
        p.a = w;
      }).call(this, h(2));
    }, function(u, p) {
      var h;
      h = function() {
        return this;
      }();
      try {
        h = h || new Function("return this")();
      } catch {
        typeof window == "object" && (h = window);
      }
      u.exports = h;
    }, function(u, p, h) {
      h.r(p);
      var v = h(0), w = h.n(v), x = function(z) {
        var te = typeof z;
        return z != null && (te == "object" || te == "function");
      }, k = h(1), P = typeof self == "object" && self && self.Object === Object && self, R = k.a || P || Function("return this")(), $ = function() {
        return R.Date.now();
      }, J = /\s/, X = function(z) {
        for (var te = z.length; te-- && J.test(z.charAt(te)); )
          ;
        return te;
      }, H = /^\s+/, W = function(z) {
        return z && z.slice(0, X(z) + 1).replace(H, "");
      }, Z = R.Symbol, ee = Object.prototype, ne = ee.hasOwnProperty, se = ee.toString, pe = Z ? Z.toStringTag : void 0, ge = function(z) {
        var te = ne.call(z, pe), me = z[pe];
        try {
          z[pe] = void 0;
          var Ie = !0;
        } catch {
        }
        var ve = se.call(z);
        return Ie && (te ? z[pe] = me : delete z[pe]), ve;
      }, Oe = Object.prototype.toString, ke = function(z) {
        return Oe.call(z);
      }, we = Z ? Z.toStringTag : void 0, F = function(z) {
        return z == null ? z === void 0 ? "[object Undefined]" : "[object Null]" : we && we in Object(z) ? ge(z) : ke(z);
      }, _ = function(z) {
        return z != null && typeof z == "object";
      }, E = function(z) {
        return typeof z == "symbol" || _(z) && F(z) == "[object Symbol]";
      }, B = /^[-+]0x[0-9a-f]+$/i, Y = /^0b[01]+$/i, N = /^0o[0-7]+$/i, re = parseInt, Te = function(z) {
        if (typeof z == "number")
          return z;
        if (E(z))
          return NaN;
        if (x(z)) {
          var te = typeof z.valueOf == "function" ? z.valueOf() : z;
          z = x(te) ? te + "" : te;
        }
        if (typeof z != "string")
          return z === 0 ? z : +z;
        z = W(z);
        var me = Y.test(z);
        return me || N.test(z) ? re(z.slice(2), me ? 2 : 8) : B.test(z) ? NaN : +z;
      }, Me = Math.max, Ee = Math.min, Ce = function(z, te, me) {
        var Ie, ve, Ne, fe, ae, ct, Gt = 0, Qe = !1, Ve = !1, Zt = !0;
        if (typeof z != "function")
          throw new TypeError("Expected a function");
        function Tn(Je) {
          var et = Ie, bt = ve;
          return Ie = ve = void 0, Gt = Je, fe = z.apply(bt, et);
        }
        function $n(Je) {
          return Gt = Je, ae = setTimeout(Ft, te), Qe ? Tn(Je) : fe;
        }
        function Et(Je) {
          var et = Je - ct;
          return ct === void 0 || et >= te || et < 0 || Ve && Je - Gt >= Ne;
        }
        function Ft() {
          var Je = $();
          if (Et(Je))
            return Mt(Je);
          ae = setTimeout(Ft, function(et) {
            var bt = te - (et - ct);
            return Ve ? Ee(bt, Ne - (et - Gt)) : bt;
          }(Je));
        }
        function Mt(Je) {
          return ae = void 0, Zt && Ie ? Tn(Je) : (Ie = ve = void 0, fe);
        }
        function Jt() {
          var Je = $(), et = Et(Je);
          if (Ie = arguments, ve = this, ct = Je, et) {
            if (ae === void 0)
              return $n(ct);
            if (Ve)
              return clearTimeout(ae), ae = setTimeout(Ft, te), Tn(ct);
          }
          return ae === void 0 && (ae = setTimeout(Ft, te)), fe;
        }
        return te = Te(te) || 0, x(me) && (Qe = !!me.leading, Ne = (Ve = "maxWait" in me) ? Me(Te(me.maxWait) || 0, te) : Ne, Zt = "trailing" in me ? !!me.trailing : Zt), Jt.cancel = function() {
          ae !== void 0 && clearTimeout(ae), Gt = 0, Ie = ct = ve = ae = void 0;
        }, Jt.flush = function() {
          return ae === void 0 ? fe : Mt($());
        }, Jt;
      }, q = { name: "ckeditor", created() {
        const { CKEDITOR_VERSION: z } = window;
        if (z) {
          const [te] = z.split(".").map(Number);
          te < 34 && console.warn("The <CKEditor> component requires using CKEditor 5 in version 34 or higher.");
        } else
          console.warn('Cannot find the "CKEDITOR_VERSION" in the "window" scope.');
      }, render(z) {
        return z(this.tagName);
      }, props: { editor: { type: Function, default: null }, value: { type: String, default: "" }, config: { type: Object, default: () => ({}) }, tagName: { type: String, default: "div" }, disabled: { type: Boolean, default: !1 } }, data: () => ({ $_instance: null, $_lastEditorData: { type: String, default: "" } }), mounted() {
        const z = Object.assign({}, this.config);
        this.value && (z.initialData = this.value), this.editor.create(this.$el, z).then((te) => {
          this.$_instance = te, this.$_setUpEditorEvents(), this.value !== z.initialData && te.setData(this.value), this.disabled && te.enableReadOnlyMode("Integration Sample"), this.$emit("ready", te);
        }).catch((te) => {
          console.error(te);
        });
      }, beforeDestroy() {
        this.$_instance && (this.$_instance.destroy(), this.$_instance = null), this.$emit("destroy", this.$_instance);
      }, watch: { value(z) {
        this.$_instance && z !== this.$_lastEditorData && this.$_instance.setData(z);
      }, disabled(z) {
        z ? this.$_instance.enableReadOnlyMode("Integration Sample") : this.$_instance.disableReadOnlyMode("Integration Sample");
      } }, methods: { $_setUpEditorEvents() {
        const z = this.$_instance, te = Ce((me) => {
          const Ie = this.$_lastEditorData = z.getData();
          this.$emit("input", Ie, me, z);
        }, 300, { leading: !0 });
        z.model.document.on("change:data", te), z.editing.view.document.on("focus", (me) => {
          this.$emit("focus", me, z);
        }), z.editing.view.document.on("blur", (me) => {
          this.$emit("blur", me, z);
        });
      } } };
      const A = w.a ? w.a.version : v.version, [M] = A.split(".").map((z) => parseInt(z, 10));
      if (M !== 2)
        throw new Error("The CKEditor plugin works only with Vue 2.x. For more information, please refer to https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs-v2.html");
      const Q = { install(z) {
        z.component("ckeditor", q);
      }, component: q };
      p.default = Q;
    }]).default;
  });
})(Qp);
const yP = /* @__PURE__ */ yl(Qp.exports), kP = (a) => new Promise((r, c) => {
  const u = new FileReader();
  u.readAsDataURL(a), u.onload = () => r(u.result), u.onerror = (p) => c(p);
});
function xP(a) {
  this.loader = a, this.upload = async () => {
    const r = await this.loader.file;
    return { default: await kP(r) };
  }, this.abort = () => {
  };
}
const SP = {
  name: "CKEditor",
  components: { "vue-ckeditor": yP.component },
  props: {
    toolbar: {
      type: Array,
      default: () => [
        "heading",
        "bold",
        "link",
        "italic",
        "bulletedList",
        "numberedList",
        "blockQuote",
        "alignment",
        "|",
        "imageUpload",
        "|",
        "undo",
        "redo",
        "|",
        "editMarkdown"
      ]
    },
    uploadAdaptor: {
      type: Function,
      default: null
    },
    defaultMarkdown: {
      type: Boolean,
      default: !1
    },
    small: {
      type: Boolean,
      default: !1
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      upload: xP,
      editor: wP,
      input: this.value,
      plainText: "",
      markdown: "",
      sourceViewOpen: !1,
      turndownService: new rs({ headingStyle: "atx" }),
      useMarkdown: this.defaultMarkdown
    };
  },
  created() {
    this.turndownService.addRule("listItem", {
      filter: "li",
      replacement: function(a, r, c) {
        a = a.replace(/^\n+/, "").replace(/\n+$/, `
`).replace(/\n/gm, `
   `);
        let u = c.bulletListMarker + " ";
        const p = r.parentNode;
        if (p.nodeName === "OL") {
          const h = p.getAttribute("start"), v = Array.prototype.indexOf.call(p.children, r);
          u = (h ? Number(h) + v : v + 1) + ". ";
        }
        return u + a + (r.nextSibling && !/\n$/.test(a) ? `
` : "");
      }
    }), this.markdown = this.turndownService.turndown(this.value || ""), this.defaultMarkdown && this.setMarkdown(!0);
  },
  methods: {
    setMarkdown(a) {
      this.$set(this.editor, "isReadOnly", a), this.useMarkdown = a, this.$emit("update-editor-type", a);
    },
    getEditorConfig() {
      return {
        simpleButton: [
          {
            name: "editSource",
            label: "Edit Source",
            tooltip: !0,
            icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20"><path d="M12.5 5.7l5.2 3.9v1.3l-5.6 4c-.1.2-.3.2-.5.2-.3-.1-.6-.7-.6-1l.3-.4 4.7-3.5L11.5 7l-.2-.2c-.1-.3-.1-.6 0-.8.2-.2.5-.4.8-.4a.8.8 0 0 1 .4.1zm-5.2 0L2 9.6v1.3l5.6 4c.1.2.3.2.5.2.3-.1.7-.7.6-1 0-.1 0-.3-.2-.4l-5-3.5L8.2 7l.2-.2c.1-.3.1-.6 0-.8-.2-.2-.5-.4-.8-.4a.8.8 0 0 0-.3.1z"></path></svg>',
            syncDisabledState: !0,
            onClick: this.editSourceClick
          },
          {
            name: "editMarkdown",
            label: "Markdown",
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 208 128"><path d="M193 128H15a15 15 0 0 1-15-15V15A15 15 0 0 1 15 0h178a15 15 0 0 1 15 15v98a15 15 0 0 1-15 15zM50 98V59l20 25 20-25v39h20V30H90L70 55 50 30H30v68zm134-34h-20V30h-20v34h-20l30 35z"/></svg>',
            isOn: this.useMarkdown,
            isToggleable: !0,
            syncDisabledState: !1,
            tooltip: !0,
            withText: !0,
            disableToolbarWhenOn: !0,
            class: "edit-markdown-button",
            _tooltipString: this.useMarkdown ? "Visual Editor" : "Edit Markdown",
            onClick: this.editMarkdownClick
          }
        ],
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph"
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1"
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2"
            },
            {
              model: "heading3",
              view: "h3",
              title: "Heading 3",
              class: "ck-heading_heading3"
            }
          ]
        },
        image: {
          toolbar: ["imageTextAlternative"]
        },
        removePlugins: ["ImageCaption", "ImageStyle"],
        link: {
          decorators: {
            isExternal: {
              mode: "manual",
              label: "Open in a new tab",
              attributes: {
                target: "_blank"
              }
            }
          }
        },
        alignment: {
          options: ["left", "right", "center"]
        },
        toolbar: this.toolbar,
        mediaEmbed: {
          removeProviders: [
            "instagram",
            "twitter",
            "googleMaps",
            "flickr",
            "facebook",
            "youtube"
          ]
        }
      };
    },
    onEditorInput(a) {
      this.$emit("input", { target: { value: a } }), this.$emit("blur", a), this.$emit("focus", a);
    },
    editMarkdownClick(a) {
      a.isOn = !a.isOn, a._tooltipString = a.isOn ? "Visual Editor" : "Edit Markdown", this.setMarkdown(a.isOn), a.isOn ? (this.markdown = this.turndownService.turndown(this.value || ""), this.$nextTick(() => {
        this.$refs.markdownTextarea.focus();
      })) : this.input = ip(this.markdown || "", {
        breaks: !0,
        headerIds: !1
      });
    },
    editSourceClick() {
      this.plainText = this.input, this.sourceViewOpen = !this.sourceViewOpen;
    },
    plainTextChange(a) {
      this.onEditorInput(a.target.value), this.input = a.target.value;
    },
    markdownChange(a) {
      this.onEditorInput(
        kI(
          ip(a.target.value || "", { breaks: !0, headerIds: !1 })
        )
      );
    }
  }
};
var CP = function() {
  var r = this, c = r._self._c;
  return c("div", { class: ["wysiwyg", { small: r.small }] }, [c("vue-ckeditor", { attrs: { editor: r.editor, config: r.getEditorConfig(), disabled: r.useMarkdown }, on: { input: r.onEditorInput }, model: { value: r.input, callback: function(u) {
    r.input = u;
  }, expression: "input" } }), r.useMarkdown ? c("textarea", { directives: [{ name: "model", rawName: "v-model", value: r.markdown, expression: "markdown" }], ref: "markdownTextarea", staticClass: "markdown", domProps: { value: r.markdown }, on: { input: [function(u) {
    u.target.composing || (r.markdown = u.target.value);
  }, r.markdownChange] } }) : r._e(), r._v(" "), r.sourceViewOpen ? c("div", { staticClass: "html-input" }, [c("div", { staticClass: "modal" }, [c("textarea", { directives: [{ name: "model", rawName: "v-model", value: r.plainText, expression: "plainText" }], domProps: { value: r.plainText }, on: { input: [function(u) {
    u.target.composing || (r.plainText = u.target.value);
  }, r.plainTextChange] } }), r._v(" "), c("button", { staticClass: "close-button", on: { click: function(u) {
    return u.preventDefault(), r.editSourceClick.apply(null, arguments);
  } } }, [r._v(" Done ")])])]) : r._e()], 1);
}, AP = [], TP = /* @__PURE__ */ he(
  SP,
  CP,
  AP,
  !1,
  null,
  "17ed514b",
  null,
  null
);
const IP = TP.exports, EP = {
  components: { CKEditor: IP, FinalField: cn.exports.FinalField },
  props: {
    name: {
      type: String,
      default: ""
    },
    toolbar: {
      type: Array,
      default: () => [
        "heading",
        "bold",
        "link",
        "italic",
        "bulletedList",
        "numberedList",
        "blockQuote",
        "alignment",
        "|",
        "imageUpload",
        "mediaEmbed",
        "|",
        "undo",
        "redo"
      ]
    },
    uploadAdaptor: {
      type: Function,
      default: null
    },
    defaultMarkdown: {
      type: Boolean,
      default: !1
    },
    validate: {
      type: Function,
      default: null
    },
    small: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    blur(a) {
      this.$emit("blur", a);
    },
    focus(a) {
      this.$emit("focus", a);
    },
    input(a) {
      this.$emit("input", a);
    }
  }
};
var PP = function() {
  var r = this, c = r._self._c;
  return c("FinalField", { attrs: { validate: r.validate, name: r.name }, scopedSlots: r._u([{ key: "default", fn: function(u) {
    return c("div", {}, [c("CKEditor", r._g({ attrs: { value: u.value, name: u.name, toolbar: r.toolbar, "upload-adaptor": r.uploadAdaptor, "default-markdown": r.defaultMarkdown, small: r.small }, on: { blur: r.blur, focus: r.focus, input: r.input, "update-editor-type": (p) => r.$emit("update-editor-type", p) } }, u.events))], 1);
  } }]) });
}, MP = [], OP = /* @__PURE__ */ he(
  EP,
  PP,
  MP,
  !1,
  null,
  null,
  null,
  null
);
const S2 = OP.exports;
export {
  NP as Accordion,
  cp as Alert,
  kl as Artwork,
  Di as Badge,
  RP as BadgeCampaign,
  LP as BadgeEpisode,
  FP as BadgeHostRead,
  zP as BadgeMarker,
  $P as BadgeUser,
  jP as Banner,
  BP as Card,
  VP as CardEpisode,
  lp as Collapse,
  UP as CollapsibleList,
  HP as CollapsibleListItem,
  WP as Crumbs,
  wx as CustomCheckbox,
  YP as DataGroup,
  mp as Dropdown,
  pp as DropdownCaron,
  J1 as EpisodeArtwork,
  qP as FinalFormAudio,
  GP as FinalFormButtonsSwitch,
  ZP as FinalFormCheckbox,
  KP as FinalFormImage,
  XP as FinalFormMultiAudio,
  QP as FinalFormRadio,
  JP as FinalFormSelect,
  e2 as FinalFormTagger,
  t2 as FinalFormText,
  n2 as FinalFormTextarea,
  i2 as FormAudio,
  WS as FormButtonsSwitch,
  r2 as FormCheckbox,
  o2 as FormEmail,
  s2 as FormFieldset,
  a2 as FormGroup,
  iI as FormImage,
  rC as FormLabel,
  l2 as FormNumber,
  c2 as FormRadio,
  Ap as FormRange,
  Bp as FormSearch,
  gI as FormSelect,
  u2 as FormTagger,
  EI as FormText,
  d2 as FormTextarea,
  h2 as FormUploadCropper,
  f2 as Hamburger,
  nr as HelperText,
  xp as ListGroup,
  kp as ListGroupItem,
  uS as LoadingCircular,
  oS as LoadingSpinner,
  p2 as LoadingText,
  m2 as MenuDropdown,
  g2 as Modal,
  yp as PodcastArtwork,
  TS as QuickMenu,
  bi as SButton,
  j1 as SCard,
  fE as SCell,
  bE as SRow,
  b2 as STable,
  y2 as STip,
  w2 as SToast,
  Rt as SType,
  v2 as Sidebar,
  _2 as Tabs,
  Vp as Tag,
  yI as TagList,
  zr as Tooltip,
  k2 as Type,
  x2 as UserArtwork,
  S2 as Wysiwyg
};
